//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.7.1.0 (NJsonSchema v11.6.1.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* eslint-disable */
// ReSharper disable InconsistentNaming

import { mergeMap as _observableMergeMap, catchError as _observableCatch } from 'rxjs/operators';
import { Observable, throwError as _observableThrow, of as _observableOf } from 'rxjs';
import { Injectable, Inject, Optional, InjectionToken } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse, HttpResponseBase } from '@angular/common/http';

export const API_BASE_URL = new InjectionToken<string>('API_BASE_URL');

export interface IAccountClient {
    refreshUserToken(): Observable<CerIdentityUserDto>;
    login(userName: string | undefined, password: string | undefined): Observable<CerIdentityUserDto>;
    loginWithThirdParty(accessToken: string | undefined, userId: string | undefined, provider: string | undefined): Observable<CerIdentityUserDto>;
    register(firstName: string | undefined, lastName: string | undefined, email: string | undefined, password: string | undefined): Observable<FileResponse>;
    registerWithThirdParty(accessToken: string | undefined, userId: string | undefined, provider: string | undefined): Observable<CerIdentityUserDto>;
    confirmEmail(confirmToken: string | undefined, email: string | undefined): Observable<FileResponse>;
    resendEMailConfirmationLink(email: string): Observable<FileResponse>;
    forgotUsernameOrPassword(email: string): Observable<FileResponse>;
    resetPassword(token: string | undefined, email: string | undefined, newPassword: string | undefined): Observable<FileResponse>;
}

@Injectable({
    providedIn: 'root'
})
export class AccountClient implements IAccountClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    refreshUserToken(): Observable<CerIdentityUserDto> {
        let url_ = this.baseUrl + "/api/Account/refresh-user-token";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRefreshUserToken(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRefreshUserToken(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CerIdentityUserDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CerIdentityUserDto>;
        }));
    }

    protected processRefreshUserToken(response: HttpResponseBase): Observable<CerIdentityUserDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CerIdentityUserDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    login(userName: string | undefined, password: string | undefined): Observable<CerIdentityUserDto> {
        let url_ = this.baseUrl + "/api/Account/login?";
        if (userName === null)
            throw new globalThis.Error("The parameter 'userName' cannot be null.");
        else if (userName !== undefined)
            url_ += "userName=" + encodeURIComponent("" + userName) + "&";
        if (password === null)
            throw new globalThis.Error("The parameter 'password' cannot be null.");
        else if (password !== undefined)
            url_ += "password=" + encodeURIComponent("" + password) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processLogin(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLogin(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CerIdentityUserDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CerIdentityUserDto>;
        }));
    }

    protected processLogin(response: HttpResponseBase): Observable<CerIdentityUserDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CerIdentityUserDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    loginWithThirdParty(accessToken: string | undefined, userId: string | undefined, provider: string | undefined): Observable<CerIdentityUserDto> {
        let url_ = this.baseUrl + "/api/Account/login-with-third-party?";
        if (accessToken === null)
            throw new globalThis.Error("The parameter 'accessToken' cannot be null.");
        else if (accessToken !== undefined)
            url_ += "accessToken=" + encodeURIComponent("" + accessToken) + "&";
        if (userId === null)
            throw new globalThis.Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        if (provider === null)
            throw new globalThis.Error("The parameter 'provider' cannot be null.");
        else if (provider !== undefined)
            url_ += "provider=" + encodeURIComponent("" + provider) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processLoginWithThirdParty(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLoginWithThirdParty(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CerIdentityUserDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CerIdentityUserDto>;
        }));
    }

    protected processLoginWithThirdParty(response: HttpResponseBase): Observable<CerIdentityUserDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CerIdentityUserDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    register(firstName: string | undefined, lastName: string | undefined, email: string | undefined, password: string | undefined): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/Account/register?";
        if (firstName === null)
            throw new globalThis.Error("The parameter 'firstName' cannot be null.");
        else if (firstName !== undefined)
            url_ += "firstName=" + encodeURIComponent("" + firstName) + "&";
        if (lastName === null)
            throw new globalThis.Error("The parameter 'lastName' cannot be null.");
        else if (lastName !== undefined)
            url_ += "lastName=" + encodeURIComponent("" + lastName) + "&";
        if (email === null)
            throw new globalThis.Error("The parameter 'email' cannot be null.");
        else if (email !== undefined)
            url_ += "email=" + encodeURIComponent("" + email) + "&";
        if (password === null)
            throw new globalThis.Error("The parameter 'password' cannot be null.");
        else if (password !== undefined)
            url_ += "password=" + encodeURIComponent("" + password) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRegister(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRegister(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processRegister(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    registerWithThirdParty(accessToken: string | undefined, userId: string | undefined, provider: string | undefined): Observable<CerIdentityUserDto> {
        let url_ = this.baseUrl + "/api/Account/register-with-third-party?";
        if (accessToken === null)
            throw new globalThis.Error("The parameter 'accessToken' cannot be null.");
        else if (accessToken !== undefined)
            url_ += "accessToken=" + encodeURIComponent("" + accessToken) + "&";
        if (userId === null)
            throw new globalThis.Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        if (provider === null)
            throw new globalThis.Error("The parameter 'provider' cannot be null.");
        else if (provider !== undefined)
            url_ += "provider=" + encodeURIComponent("" + provider) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRegisterWithThirdParty(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRegisterWithThirdParty(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CerIdentityUserDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CerIdentityUserDto>;
        }));
    }

    protected processRegisterWithThirdParty(response: HttpResponseBase): Observable<CerIdentityUserDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CerIdentityUserDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    confirmEmail(confirmToken: string | undefined, email: string | undefined): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/Account/confirm-email?";
        if (confirmToken === null)
            throw new globalThis.Error("The parameter 'confirmToken' cannot be null.");
        else if (confirmToken !== undefined)
            url_ += "confirmToken=" + encodeURIComponent("" + confirmToken) + "&";
        if (email === null)
            throw new globalThis.Error("The parameter 'email' cannot be null.");
        else if (email !== undefined)
            url_ += "email=" + encodeURIComponent("" + email) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processConfirmEmail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processConfirmEmail(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processConfirmEmail(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    resendEMailConfirmationLink(email: string): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/Account/resend-email-confirmation-link/{email}";
        if (email === undefined || email === null)
            throw new globalThis.Error("The parameter 'email' must be defined.");
        url_ = url_.replace("{email}", encodeURIComponent("" + email));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processResendEMailConfirmationLink(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processResendEMailConfirmationLink(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processResendEMailConfirmationLink(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    forgotUsernameOrPassword(email: string): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/Account/forgot-username-or-password/{email}";
        if (email === undefined || email === null)
            throw new globalThis.Error("The parameter 'email' must be defined.");
        url_ = url_.replace("{email}", encodeURIComponent("" + email));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processForgotUsernameOrPassword(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processForgotUsernameOrPassword(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processForgotUsernameOrPassword(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    resetPassword(token: string | undefined, email: string | undefined, newPassword: string | undefined): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/Account/reset-password?";
        if (token === null)
            throw new globalThis.Error("The parameter 'token' cannot be null.");
        else if (token !== undefined)
            url_ += "token=" + encodeURIComponent("" + token) + "&";
        if (email === null)
            throw new globalThis.Error("The parameter 'email' cannot be null.");
        else if (email !== undefined)
            url_ += "email=" + encodeURIComponent("" + email) + "&";
        if (newPassword === null)
            throw new globalThis.Error("The parameter 'newPassword' cannot be null.");
        else if (newPassword !== undefined)
            url_ += "newPassword=" + encodeURIComponent("" + newPassword) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processResetPassword(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processResetPassword(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processResetPassword(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IAppMetaClient {
    postUserViews(command: AppMetaUserViewCommand): Observable<boolean>;
    getUserViews(url: string | undefined): Observable<AppMetaUserViewVm>;
    getEntityMeta(entityName: string | undefined): Observable<EntityMetaVm>;
}

@Injectable({
    providedIn: 'root'
})
export class AppMetaClient implements IAppMetaClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    postUserViews(command: AppMetaUserViewCommand): Observable<boolean> {
        let url_ = this.baseUrl + "/api/AppMeta/PostUserViews";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPostUserViews(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPostUserViews(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processPostUserViews(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getUserViews(url: string | undefined): Observable<AppMetaUserViewVm> {
        let url_ = this.baseUrl + "/api/AppMeta/GetUserViews?";
        if (url === null)
            throw new globalThis.Error("The parameter 'url' cannot be null.");
        else if (url !== undefined)
            url_ += "url=" + encodeURIComponent("" + url) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUserViews(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUserViews(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AppMetaUserViewVm>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AppMetaUserViewVm>;
        }));
    }

    protected processGetUserViews(response: HttpResponseBase): Observable<AppMetaUserViewVm> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AppMetaUserViewVm.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getEntityMeta(entityName: string | undefined): Observable<EntityMetaVm> {
        let url_ = this.baseUrl + "/api/AppMeta/GetEntityMeta?";
        if (entityName === null)
            throw new globalThis.Error("The parameter 'entityName' cannot be null.");
        else if (entityName !== undefined)
            url_ += "entityName=" + encodeURIComponent("" + entityName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEntityMeta(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEntityMeta(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EntityMetaVm>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EntityMetaVm>;
        }));
    }

    protected processGetEntityMeta(response: HttpResponseBase): Observable<EntityMetaVm> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = EntityMetaVm.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IBankAccountBalanceClient {
    get(): Observable<DataResponse>;
}

@Injectable({
    providedIn: 'root'
})
export class BankAccountBalanceClient implements IBankAccountBalanceClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    get(): Observable<DataResponse> {
        let url_ = this.baseUrl + "/api/BankAccountBalance";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DataResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DataResponse>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<DataResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DataResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IBankAccountSettlementClient {
    setStatus(command: BankAccountSettlementStatusSetCommand): Observable<BankAccountTransactionDto[]>;
    suggestSettlement(command: BankTransactionSuggestSettlementCommand): Observable<BankTransactionSuggestSettlementResult>;
    voucherCombineSelected(command: BankTransactionVoucherCombineSelectedCommand): Observable<boolean>;
}

@Injectable({
    providedIn: 'root'
})
export class BankAccountSettlementClient implements IBankAccountSettlementClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    setStatus(command: BankAccountSettlementStatusSetCommand): Observable<BankAccountTransactionDto[]> {
        let url_ = this.baseUrl + "/api/BankAccountSettlement/SetStatus";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSetStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSetStatus(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BankAccountTransactionDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BankAccountTransactionDto[]>;
        }));
    }

    protected processSetStatus(response: HttpResponseBase): Observable<BankAccountTransactionDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(BankAccountTransactionDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    suggestSettlement(command: BankTransactionSuggestSettlementCommand): Observable<BankTransactionSuggestSettlementResult> {
        let url_ = this.baseUrl + "/api/BankAccountSettlement/SuggestSettlement";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSuggestSettlement(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSuggestSettlement(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BankTransactionSuggestSettlementResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BankTransactionSuggestSettlementResult>;
        }));
    }

    protected processSuggestSettlement(response: HttpResponseBase): Observable<BankTransactionSuggestSettlementResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BankTransactionSuggestSettlementResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    voucherCombineSelected(command: BankTransactionVoucherCombineSelectedCommand): Observable<boolean> {
        let url_ = this.baseUrl + "/api/BankAccountSettlement/VoucherCombineSelected";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processVoucherCombineSelected(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processVoucherCombineSelected(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processVoucherCombineSelected(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IBankAccountTransactionClient {
    setTransactionStatus(command: BankTransactionStatusSetCommand): Observable<BankAccountTransactionDto[]>;
    voucherCreate(command: BankAccountTransactionVoucherCreateCommand): Observable<number>;
}

@Injectable({
    providedIn: 'root'
})
export class BankAccountTransactionClient implements IBankAccountTransactionClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    setTransactionStatus(command: BankTransactionStatusSetCommand): Observable<BankAccountTransactionDto[]> {
        let url_ = this.baseUrl + "/api/BankAccountTransaction/SetTransactionStatus";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSetTransactionStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSetTransactionStatus(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BankAccountTransactionDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BankAccountTransactionDto[]>;
        }));
    }

    protected processSetTransactionStatus(response: HttpResponseBase): Observable<BankAccountTransactionDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(BankAccountTransactionDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    voucherCreate(command: BankAccountTransactionVoucherCreateCommand): Observable<number> {
        let url_ = this.baseUrl + "/api/BankAccountTransaction/VoucherCreate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processVoucherCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processVoucherCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processVoucherCreate(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IBankPaymentJournalClient {
    paymentFileCreate(rowIds: number[] | undefined): Observable<FileResponse>;
}

@Injectable({
    providedIn: 'root'
})
export class BankPaymentJournalClient implements IBankPaymentJournalClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    paymentFileCreate(rowIds: number[] | undefined): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/BankPaymentJournal/PaymentFileCreate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(rowIds);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPaymentFileCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPaymentFileCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processPaymentFileCreate(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IBankTransactionSourceBatchClient {
    syncBatch(command: BankAccountSourceSyncCommand): Observable<number>;
    setStatus(command: BankTransactionBatchStatusSetCommand): Observable<number>;
}

@Injectable({
    providedIn: 'root'
})
export class BankTransactionSourceBatchClient implements IBankTransactionSourceBatchClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    syncBatch(command: BankAccountSourceSyncCommand): Observable<number> {
        let url_ = this.baseUrl + "/api/BankTransactionSourceBatch";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSyncBatch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSyncBatch(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processSyncBatch(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    setStatus(command: BankTransactionBatchStatusSetCommand): Observable<number> {
        let url_ = this.baseUrl + "/api/BankTransactionSourceBatch";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSetStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSetStatus(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processSetStatus(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IChatClient {
    get(table: number | undefined, id: number | undefined): Observable<ChatDto[]>;
    post(chat: ChatDto): Observable<ChatDto[]>;
    markReadChat(chatId: number | undefined): Observable<boolean>;
    markReadThread(refTableId: number | undefined, refRowId: number | undefined): Observable<boolean>;
    markReadAll(): Observable<boolean>;
}

@Injectable({
    providedIn: 'root'
})
export class ChatClient implements IChatClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    get(table: number | undefined, id: number | undefined): Observable<ChatDto[]> {
        let url_ = this.baseUrl + "/api/Chat?";
        if (table === null)
            throw new globalThis.Error("The parameter 'table' cannot be null.");
        else if (table !== undefined)
            url_ += "table=" + encodeURIComponent("" + table) + "&";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ChatDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ChatDto[]>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<ChatDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ChatDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    post(chat: ChatDto): Observable<ChatDto[]> {
        let url_ = this.baseUrl + "/api/Chat";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(chat);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPost(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPost(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ChatDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ChatDto[]>;
        }));
    }

    protected processPost(response: HttpResponseBase): Observable<ChatDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ChatDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    markReadChat(chatId: number | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/Chat/MarkReadChat?";
        if (chatId === null)
            throw new globalThis.Error("The parameter 'chatId' cannot be null.");
        else if (chatId !== undefined)
            url_ += "chatId=" + encodeURIComponent("" + chatId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMarkReadChat(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMarkReadChat(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processMarkReadChat(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    markReadThread(refTableId: number | undefined, refRowId: number | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/Chat/MarkReadThread?";
        if (refTableId === null)
            throw new globalThis.Error("The parameter 'refTableId' cannot be null.");
        else if (refTableId !== undefined)
            url_ += "refTableId=" + encodeURIComponent("" + refTableId) + "&";
        if (refRowId === null)
            throw new globalThis.Error("The parameter 'refRowId' cannot be null.");
        else if (refRowId !== undefined)
            url_ += "refRowId=" + encodeURIComponent("" + refRowId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMarkReadThread(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMarkReadThread(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processMarkReadThread(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    markReadAll(): Observable<boolean> {
        let url_ = this.baseUrl + "/api/Chat/MarkReadAll";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMarkReadAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMarkReadAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processMarkReadAll(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface ICustInvoiceClient {
    document(command: CustInvoiceDocumentCommand): Observable<string>;
}

@Injectable({
    providedIn: 'root'
})
export class CustInvoiceClient implements ICustInvoiceClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    document(command: CustInvoiceDocumentCommand): Observable<string> {
        let url_ = this.baseUrl + "/api/CustInvoice";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDocument(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDocument(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processDocument(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IDataLinkAttachmentClient {
    folderCreate(entityName: string | undefined, rowId: number | undefined, folderName: string | undefined, folderNameCreate: string | undefined, token: string | undefined, getList: boolean | undefined): Observable<LinkedAttachmentDto[]>;
    fileCreate(entityName: string | undefined, rowId: number | undefined, folderName: string | undefined, fileNameCreate: string | undefined, token: string | undefined, getList: boolean | undefined): Observable<LinkedAttachmentDto[]>;
    formUpload(): Observable<LinkedAttachmentDto[]>;
    fileRename(entityName: string | undefined, rowId: number | undefined, folderName: string | undefined, fileName: string | undefined, fileNameNew: string | undefined, token: string | undefined, overwriteExisting: boolean | undefined, getList: boolean | undefined): Observable<LinkedAttachmentDto[]>;
    delete(entityName: string | undefined, rowId: number | undefined, folderName: string | undefined, fileName: string | undefined, token: string | undefined, getList: boolean | undefined): Observable<LinkedAttachmentDto[]>;
    listGet(): Observable<DataResponse>;
    fileGet(fileName: string | undefined, folderName: string | undefined, entityId: number | undefined, rowId: number | undefined, token: string | undefined, plain: string | undefined, asAttachment: string | null | undefined): Observable<FileResponse>;
    syncList(entityName: string | undefined, rowId: number | undefined, folderName: string | undefined, fileName: string | null | undefined, token: string | undefined, includeSubFolders: boolean | undefined, getList: boolean | undefined): Observable<boolean>;
}

@Injectable({
    providedIn: 'root'
})
export class DataLinkAttachmentClient implements IDataLinkAttachmentClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    folderCreate(entityName: string | undefined, rowId: number | undefined, folderName: string | undefined, folderNameCreate: string | undefined, token: string | undefined, getList: boolean | undefined): Observable<LinkedAttachmentDto[]> {
        let url_ = this.baseUrl + "/api/DataLinkAttachment/FolderCreate?";
        if (entityName === null)
            throw new globalThis.Error("The parameter 'entityName' cannot be null.");
        else if (entityName !== undefined)
            url_ += "entityName=" + encodeURIComponent("" + entityName) + "&";
        if (rowId === null)
            throw new globalThis.Error("The parameter 'rowId' cannot be null.");
        else if (rowId !== undefined)
            url_ += "rowId=" + encodeURIComponent("" + rowId) + "&";
        if (folderName === null)
            throw new globalThis.Error("The parameter 'folderName' cannot be null.");
        else if (folderName !== undefined)
            url_ += "folderName=" + encodeURIComponent("" + folderName) + "&";
        if (folderNameCreate === null)
            throw new globalThis.Error("The parameter 'folderNameCreate' cannot be null.");
        else if (folderNameCreate !== undefined)
            url_ += "folderNameCreate=" + encodeURIComponent("" + folderNameCreate) + "&";
        if (token === null)
            throw new globalThis.Error("The parameter 'token' cannot be null.");
        else if (token !== undefined)
            url_ += "token=" + encodeURIComponent("" + token) + "&";
        if (getList === null)
            throw new globalThis.Error("The parameter 'getList' cannot be null.");
        else if (getList !== undefined)
            url_ += "getList=" + encodeURIComponent("" + getList) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processFolderCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processFolderCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LinkedAttachmentDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LinkedAttachmentDto[]>;
        }));
    }

    protected processFolderCreate(response: HttpResponseBase): Observable<LinkedAttachmentDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(LinkedAttachmentDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    fileCreate(entityName: string | undefined, rowId: number | undefined, folderName: string | undefined, fileNameCreate: string | undefined, token: string | undefined, getList: boolean | undefined): Observable<LinkedAttachmentDto[]> {
        let url_ = this.baseUrl + "/api/DataLinkAttachment/FileCreate?";
        if (entityName === null)
            throw new globalThis.Error("The parameter 'entityName' cannot be null.");
        else if (entityName !== undefined)
            url_ += "entityName=" + encodeURIComponent("" + entityName) + "&";
        if (rowId === null)
            throw new globalThis.Error("The parameter 'rowId' cannot be null.");
        else if (rowId !== undefined)
            url_ += "rowId=" + encodeURIComponent("" + rowId) + "&";
        if (folderName === null)
            throw new globalThis.Error("The parameter 'folderName' cannot be null.");
        else if (folderName !== undefined)
            url_ += "folderName=" + encodeURIComponent("" + folderName) + "&";
        if (fileNameCreate === null)
            throw new globalThis.Error("The parameter 'fileNameCreate' cannot be null.");
        else if (fileNameCreate !== undefined)
            url_ += "fileNameCreate=" + encodeURIComponent("" + fileNameCreate) + "&";
        if (token === null)
            throw new globalThis.Error("The parameter 'token' cannot be null.");
        else if (token !== undefined)
            url_ += "token=" + encodeURIComponent("" + token) + "&";
        if (getList === null)
            throw new globalThis.Error("The parameter 'getList' cannot be null.");
        else if (getList !== undefined)
            url_ += "getList=" + encodeURIComponent("" + getList) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processFileCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processFileCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LinkedAttachmentDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LinkedAttachmentDto[]>;
        }));
    }

    protected processFileCreate(response: HttpResponseBase): Observable<LinkedAttachmentDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(LinkedAttachmentDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    formUpload(): Observable<LinkedAttachmentDto[]> {
        let url_ = this.baseUrl + "/api/DataLinkAttachment/FormUpload";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processFormUpload(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processFormUpload(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LinkedAttachmentDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LinkedAttachmentDto[]>;
        }));
    }

    protected processFormUpload(response: HttpResponseBase): Observable<LinkedAttachmentDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(LinkedAttachmentDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    fileRename(entityName: string | undefined, rowId: number | undefined, folderName: string | undefined, fileName: string | undefined, fileNameNew: string | undefined, token: string | undefined, overwriteExisting: boolean | undefined, getList: boolean | undefined): Observable<LinkedAttachmentDto[]> {
        let url_ = this.baseUrl + "/api/DataLinkAttachment/Rename?";
        if (entityName === null)
            throw new globalThis.Error("The parameter 'entityName' cannot be null.");
        else if (entityName !== undefined)
            url_ += "entityName=" + encodeURIComponent("" + entityName) + "&";
        if (rowId === null)
            throw new globalThis.Error("The parameter 'rowId' cannot be null.");
        else if (rowId !== undefined)
            url_ += "rowId=" + encodeURIComponent("" + rowId) + "&";
        if (folderName === null)
            throw new globalThis.Error("The parameter 'folderName' cannot be null.");
        else if (folderName !== undefined)
            url_ += "folderName=" + encodeURIComponent("" + folderName) + "&";
        if (fileName === null)
            throw new globalThis.Error("The parameter 'fileName' cannot be null.");
        else if (fileName !== undefined)
            url_ += "fileName=" + encodeURIComponent("" + fileName) + "&";
        if (fileNameNew === null)
            throw new globalThis.Error("The parameter 'fileNameNew' cannot be null.");
        else if (fileNameNew !== undefined)
            url_ += "fileNameNew=" + encodeURIComponent("" + fileNameNew) + "&";
        if (token === null)
            throw new globalThis.Error("The parameter 'token' cannot be null.");
        else if (token !== undefined)
            url_ += "token=" + encodeURIComponent("" + token) + "&";
        if (overwriteExisting === null)
            throw new globalThis.Error("The parameter 'overwriteExisting' cannot be null.");
        else if (overwriteExisting !== undefined)
            url_ += "overwriteExisting=" + encodeURIComponent("" + overwriteExisting) + "&";
        if (getList === null)
            throw new globalThis.Error("The parameter 'getList' cannot be null.");
        else if (getList !== undefined)
            url_ += "getList=" + encodeURIComponent("" + getList) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processFileRename(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processFileRename(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LinkedAttachmentDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LinkedAttachmentDto[]>;
        }));
    }

    protected processFileRename(response: HttpResponseBase): Observable<LinkedAttachmentDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(LinkedAttachmentDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    delete(entityName: string | undefined, rowId: number | undefined, folderName: string | undefined, fileName: string | undefined, token: string | undefined, getList: boolean | undefined): Observable<LinkedAttachmentDto[]> {
        let url_ = this.baseUrl + "/api/DataLinkAttachment?";
        if (entityName === null)
            throw new globalThis.Error("The parameter 'entityName' cannot be null.");
        else if (entityName !== undefined)
            url_ += "entityName=" + encodeURIComponent("" + entityName) + "&";
        if (rowId === null)
            throw new globalThis.Error("The parameter 'rowId' cannot be null.");
        else if (rowId !== undefined)
            url_ += "rowId=" + encodeURIComponent("" + rowId) + "&";
        if (folderName === null)
            throw new globalThis.Error("The parameter 'folderName' cannot be null.");
        else if (folderName !== undefined)
            url_ += "folderName=" + encodeURIComponent("" + folderName) + "&";
        if (fileName === null)
            throw new globalThis.Error("The parameter 'fileName' cannot be null.");
        else if (fileName !== undefined)
            url_ += "fileName=" + encodeURIComponent("" + fileName) + "&";
        if (token === null)
            throw new globalThis.Error("The parameter 'token' cannot be null.");
        else if (token !== undefined)
            url_ += "token=" + encodeURIComponent("" + token) + "&";
        if (getList === null)
            throw new globalThis.Error("The parameter 'getList' cannot be null.");
        else if (getList !== undefined)
            url_ += "getList=" + encodeURIComponent("" + getList) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LinkedAttachmentDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LinkedAttachmentDto[]>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<LinkedAttachmentDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(LinkedAttachmentDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    listGet(): Observable<DataResponse> {
        let url_ = this.baseUrl + "/api/DataLinkAttachment";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processListGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processListGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DataResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DataResponse>;
        }));
    }

    protected processListGet(response: HttpResponseBase): Observable<DataResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DataResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    fileGet(fileName: string | undefined, folderName: string | undefined, entityId: number | undefined, rowId: number | undefined, token: string | undefined, plain: string | undefined, asAttachment: string | null | undefined): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/DataLinkAttachment/File?";
        if (fileName === null)
            throw new globalThis.Error("The parameter 'fileName' cannot be null.");
        else if (fileName !== undefined)
            url_ += "fileName=" + encodeURIComponent("" + fileName) + "&";
        if (folderName === null)
            throw new globalThis.Error("The parameter 'folderName' cannot be null.");
        else if (folderName !== undefined)
            url_ += "folderName=" + encodeURIComponent("" + folderName) + "&";
        if (entityId === null)
            throw new globalThis.Error("The parameter 'entityId' cannot be null.");
        else if (entityId !== undefined)
            url_ += "entityId=" + encodeURIComponent("" + entityId) + "&";
        if (rowId === null)
            throw new globalThis.Error("The parameter 'rowId' cannot be null.");
        else if (rowId !== undefined)
            url_ += "rowId=" + encodeURIComponent("" + rowId) + "&";
        if (token === null)
            throw new globalThis.Error("The parameter 'token' cannot be null.");
        else if (token !== undefined)
            url_ += "token=" + encodeURIComponent("" + token) + "&";
        if (plain === null)
            throw new globalThis.Error("The parameter 'plain' cannot be null.");
        else if (plain !== undefined)
            url_ += "plain=" + encodeURIComponent("" + plain) + "&";
        if (asAttachment !== undefined && asAttachment !== null)
            url_ += "asAttachment=" + encodeURIComponent("" + asAttachment) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processFileGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processFileGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processFileGet(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    syncList(entityName: string | undefined, rowId: number | undefined, folderName: string | undefined, fileName: string | null | undefined, token: string | undefined, includeSubFolders: boolean | undefined, getList: boolean | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/DataLinkAttachment/SyncList?";
        if (entityName === null)
            throw new globalThis.Error("The parameter 'entityName' cannot be null.");
        else if (entityName !== undefined)
            url_ += "entityName=" + encodeURIComponent("" + entityName) + "&";
        if (rowId === null)
            throw new globalThis.Error("The parameter 'rowId' cannot be null.");
        else if (rowId !== undefined)
            url_ += "rowId=" + encodeURIComponent("" + rowId) + "&";
        if (folderName === null)
            throw new globalThis.Error("The parameter 'folderName' cannot be null.");
        else if (folderName !== undefined)
            url_ += "folderName=" + encodeURIComponent("" + folderName) + "&";
        if (fileName !== undefined && fileName !== null)
            url_ += "fileName=" + encodeURIComponent("" + fileName) + "&";
        if (token === null)
            throw new globalThis.Error("The parameter 'token' cannot be null.");
        else if (token !== undefined)
            url_ += "token=" + encodeURIComponent("" + token) + "&";
        if (includeSubFolders === null)
            throw new globalThis.Error("The parameter 'includeSubFolders' cannot be null.");
        else if (includeSubFolders !== undefined)
            url_ += "includeSubFolders=" + encodeURIComponent("" + includeSubFolders) + "&";
        if (getList === null)
            throw new globalThis.Error("The parameter 'getList' cannot be null.");
        else if (getList !== undefined)
            url_ += "getList=" + encodeURIComponent("" + getList) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSyncList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSyncList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processSyncList(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IDataLinkClient {
    dataNotificationRun(cmd: DataNotificationRunCommand): Observable<boolean>;
}

@Injectable({
    providedIn: 'root'
})
export class DataLinkClient implements IDataLinkClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    dataNotificationRun(cmd: DataNotificationRunCommand): Observable<boolean> {
        let url_ = this.baseUrl + "/api/DataLink";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(cmd);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDataNotificationRun(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDataNotificationRun(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processDataNotificationRun(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IDebtorClient {
    getEANDefault(): Observable<DebtorDto[]>;
    customerCreateFromDebtorSeqments(salesOrderNumSet: string | null | undefined, customerCreateCommand: CustomerCreateCommand): Observable<SalesOrderDto>;
}

@Injectable({
    providedIn: 'root'
})
export class DebtorClient implements IDebtorClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    getEANDefault(): Observable<DebtorDto[]> {
        let url_ = this.baseUrl + "/api/Debtor/GetEANDefault";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetEANDefault(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetEANDefault(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DebtorDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DebtorDto[]>;
        }));
    }

    protected processGetEANDefault(response: HttpResponseBase): Observable<DebtorDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DebtorDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    customerCreateFromDebtorSeqments(salesOrderNumSet: string | null | undefined, customerCreateCommand: CustomerCreateCommand): Observable<SalesOrderDto> {
        let url_ = this.baseUrl + "/api/Debtor?";
        if (salesOrderNumSet !== undefined && salesOrderNumSet !== null)
            url_ += "salesOrderNumSet=" + encodeURIComponent("" + salesOrderNumSet) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(customerCreateCommand);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCustomerCreateFromDebtorSeqments(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCustomerCreateFromDebtorSeqments(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SalesOrderDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SalesOrderDto>;
        }));
    }

    protected processCustomerCreateFromDebtorSeqments(response: HttpResponseBase): Observable<SalesOrderDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SalesOrderDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IExchangeMsgClient {
    queueRelease(isVendorContract: boolean | undefined, queueIds: number[]): Observable<boolean>;
    getLog(msgSubscriberId: number): Observable<ExchangeMsgSubscriberLogDto[]>;
    rerunSubscriber(msgSubscriberId: number): Observable<boolean>;
    getAllForSubscription(subscriptionId: number): Observable<boolean>;
    getLatestChangesFromSubscription(subscriptionId: number, previousDate: Date | null | undefined): Observable<boolean>;
    getRowsByIdsForSubscription(subscriptionId: number | undefined, rowsIds: string[]): Observable<boolean>;
    reprocessJobLog(jobLogId: number | undefined): Observable<boolean>;
}

@Injectable({
    providedIn: 'root'
})
export class ExchangeMsgClient implements IExchangeMsgClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    queueRelease(isVendorContract: boolean | undefined, queueIds: number[]): Observable<boolean> {
        let url_ = this.baseUrl + "/api/ExchangeMsg/QueueRelease?";
        if (isVendorContract === null)
            throw new globalThis.Error("The parameter 'isVendorContract' cannot be null.");
        else if (isVendorContract !== undefined)
            url_ += "isVendorContract=" + encodeURIComponent("" + isVendorContract) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(queueIds);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processQueueRelease(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processQueueRelease(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processQueueRelease(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getLog(msgSubscriberId: number): Observable<ExchangeMsgSubscriberLogDto[]> {
        let url_ = this.baseUrl + "/api/ExchangeMsg/GetSubscriberLog/{msgSubscriberId}";
        if (msgSubscriberId === undefined || msgSubscriberId === null)
            throw new globalThis.Error("The parameter 'msgSubscriberId' must be defined.");
        url_ = url_.replace("{msgSubscriberId}", encodeURIComponent("" + msgSubscriberId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLog(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLog(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ExchangeMsgSubscriberLogDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ExchangeMsgSubscriberLogDto[]>;
        }));
    }

    protected processGetLog(response: HttpResponseBase): Observable<ExchangeMsgSubscriberLogDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ExchangeMsgSubscriberLogDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    rerunSubscriber(msgSubscriberId: number): Observable<boolean> {
        let url_ = this.baseUrl + "/api/ExchangeMsg/RerunSubscriber/{msgSubscriberId}";
        if (msgSubscriberId === undefined || msgSubscriberId === null)
            throw new globalThis.Error("The parameter 'msgSubscriberId' must be defined.");
        url_ = url_.replace("{msgSubscriberId}", encodeURIComponent("" + msgSubscriberId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRerunSubscriber(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRerunSubscriber(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processRerunSubscriber(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getAllForSubscription(subscriptionId: number): Observable<boolean> {
        let url_ = this.baseUrl + "/api/ExchangeMsg/GetAllForSubscription/{subscriptionId}";
        if (subscriptionId === undefined || subscriptionId === null)
            throw new globalThis.Error("The parameter 'subscriptionId' must be defined.");
        url_ = url_.replace("{subscriptionId}", encodeURIComponent("" + subscriptionId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllForSubscription(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllForSubscription(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processGetAllForSubscription(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getLatestChangesFromSubscription(subscriptionId: number, previousDate: Date | null | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/ExchangeMsg/GetLatestChangesForSubscription/{subscriptionId}?";
        if (subscriptionId === undefined || subscriptionId === null)
            throw new globalThis.Error("The parameter 'subscriptionId' must be defined.");
        url_ = url_.replace("{subscriptionId}", encodeURIComponent("" + subscriptionId));
        if (previousDate !== undefined && previousDate !== null)
            url_ += "previousDate=" + encodeURIComponent(previousDate ? "" + previousDate.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLatestChangesFromSubscription(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLatestChangesFromSubscription(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processGetLatestChangesFromSubscription(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getRowsByIdsForSubscription(subscriptionId: number | undefined, rowsIds: string[]): Observable<boolean> {
        let url_ = this.baseUrl + "/api/ExchangeMsg/GetRowsByIdsForSubscription?";
        if (subscriptionId === null)
            throw new globalThis.Error("The parameter 'subscriptionId' cannot be null.");
        else if (subscriptionId !== undefined)
            url_ += "subscriptionId=" + encodeURIComponent("" + subscriptionId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(rowsIds);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRowsByIdsForSubscription(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRowsByIdsForSubscription(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processGetRowsByIdsForSubscription(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    reprocessJobLog(jobLogId: number | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/ExchangeMsg/ReprocessJobLog?";
        if (jobLogId === null)
            throw new globalThis.Error("The parameter 'jobLogId' cannot be null.");
        else if (jobLogId !== undefined)
            url_ += "jobLogId=" + encodeURIComponent("" + jobLogId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processReprocessJobLog(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processReprocessJobLog(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processReprocessJobLog(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IFormRecognizerDocumentClient {
    process(formRecognizerDocumentId: number | undefined, doAnalyzeDocument: boolean | undefined, doExtractDocument: boolean | undefined): Observable<number | null>;
}

@Injectable({
    providedIn: 'root'
})
export class FormRecognizerDocumentClient implements IFormRecognizerDocumentClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    process(formRecognizerDocumentId: number | undefined, doAnalyzeDocument: boolean | undefined, doExtractDocument: boolean | undefined): Observable<number | null> {
        let url_ = this.baseUrl + "/api/FormRecognizerDocument?";
        if (formRecognizerDocumentId === null)
            throw new globalThis.Error("The parameter 'formRecognizerDocumentId' cannot be null.");
        else if (formRecognizerDocumentId !== undefined)
            url_ += "formRecognizerDocumentId=" + encodeURIComponent("" + formRecognizerDocumentId) + "&";
        if (doAnalyzeDocument === null)
            throw new globalThis.Error("The parameter 'doAnalyzeDocument' cannot be null.");
        else if (doAnalyzeDocument !== undefined)
            url_ += "doAnalyzeDocument=" + encodeURIComponent("" + doAnalyzeDocument) + "&";
        if (doExtractDocument === null)
            throw new globalThis.Error("The parameter 'doExtractDocument' cannot be null.");
        else if (doExtractDocument !== undefined)
            url_ += "doExtractDocument=" + encodeURIComponent("" + doExtractDocument) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processProcess(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processProcess(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number | null>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number | null>;
        }));
    }

    protected processProcess(response: HttpResponseBase): Observable<number | null> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IHovedkontraktViewClient {
    get(): Observable<HovedkontraktViewVm>;
    post(command: UpdateHovedkontraktCommand): Observable<HovedkontraktViewDto>;
    get2(id: number): Observable<ContractViewDetailsVm>;
}

@Injectable({
    providedIn: 'root'
})
export class HovedkontraktViewClient implements IHovedkontraktViewClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    get(): Observable<HovedkontraktViewVm> {
        let url_ = this.baseUrl + "/api/HovedkontraktView";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<HovedkontraktViewVm>;
                }
            } else
                return _observableThrow(response_) as any as Observable<HovedkontraktViewVm>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<HovedkontraktViewVm> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = HovedkontraktViewVm.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    post(command: UpdateHovedkontraktCommand): Observable<HovedkontraktViewDto> {
        let url_ = this.baseUrl + "/api/HovedkontraktView";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPost(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPost(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<HovedkontraktViewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<HovedkontraktViewDto>;
        }));
    }

    protected processPost(response: HttpResponseBase): Observable<HovedkontraktViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = HovedkontraktViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    get2(id: number): Observable<ContractViewDetailsVm> {
        let url_ = this.baseUrl + "/api/HovedkontraktView/Get/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ContractViewDetailsVm>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ContractViewDetailsVm>;
        }));
    }

    protected processGet2(response: HttpResponseBase): Observable<ContractViewDetailsVm> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ContractViewDetailsVm.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface INotificationMessageClient {
    markNotifiedMessageId(notificationMessageId: number | undefined): Observable<boolean>;
    markNotifiedAll(): Observable<boolean>;
}

@Injectable({
    providedIn: 'root'
})
export class NotificationMessageClient implements INotificationMessageClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    markNotifiedMessageId(notificationMessageId: number | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/NotificationMessage/MarkNotifiedMessageId?";
        if (notificationMessageId === null)
            throw new globalThis.Error("The parameter 'notificationMessageId' cannot be null.");
        else if (notificationMessageId !== undefined)
            url_ += "notificationMessageId=" + encodeURIComponent("" + notificationMessageId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMarkNotifiedMessageId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMarkNotifiedMessageId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processMarkNotifiedMessageId(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    markNotifiedAll(): Observable<boolean> {
        let url_ = this.baseUrl + "/api/NotificationMessage/MarkNotifiedAll";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMarkNotifiedAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMarkNotifiedAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processMarkNotifiedAll(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IPartyExternalRefClient {
    get(): Observable<DataResponse>;
    search(query: PartyExternalRefSearchQuery): Observable<PartyExternalRefDto[]>;
}

@Injectable({
    providedIn: 'root'
})
export class PartyExternalRefClient implements IPartyExternalRefClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    get(): Observable<DataResponse> {
        let url_ = this.baseUrl + "/api/PartyExternalRef";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DataResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DataResponse>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<DataResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DataResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    search(query: PartyExternalRefSearchQuery): Observable<PartyExternalRefDto[]> {
        let url_ = this.baseUrl + "/api/PartyExternalRef/Search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSearch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearch(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PartyExternalRefDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PartyExternalRefDto[]>;
        }));
    }

    protected processSearch(response: HttpResponseBase): Observable<PartyExternalRefDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PartyExternalRefDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IProductClient {
    sync(cmd: ProductSyncCommand): Observable<number>;
    productRights(productNum: string | undefined): Observable<AfregningstabelDto[]>;
    financeProjectSetProfitLoss(profitLossSuggestValue: boolean | undefined, productNums: string[]): Observable<number>;
}

@Injectable({
    providedIn: 'root'
})
export class ProductClient implements IProductClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    sync(cmd: ProductSyncCommand): Observable<number> {
        let url_ = this.baseUrl + "/api/Product/Sync";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(cmd);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSync(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSync(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processSync(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    productRights(productNum: string | undefined): Observable<AfregningstabelDto[]> {
        let url_ = this.baseUrl + "/api/Product/ProductRights?";
        if (productNum === null)
            throw new globalThis.Error("The parameter 'productNum' cannot be null.");
        else if (productNum !== undefined)
            url_ += "productNum=" + encodeURIComponent("" + productNum) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processProductRights(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processProductRights(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AfregningstabelDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AfregningstabelDto[]>;
        }));
    }

    protected processProductRights(response: HttpResponseBase): Observable<AfregningstabelDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AfregningstabelDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    financeProjectSetProfitLoss(profitLossSuggestValue: boolean | undefined, productNums: string[]): Observable<number> {
        let url_ = this.baseUrl + "/api/Product/FinanceSetProfitLoss?";
        if (profitLossSuggestValue === null)
            throw new globalThis.Error("The parameter 'profitLossSuggestValue' cannot be null.");
        else if (profitLossSuggestValue !== undefined)
            url_ += "profitLossSuggestValue=" + encodeURIComponent("" + profitLossSuggestValue) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(productNums);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processFinanceProjectSetProfitLoss(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processFinanceProjectSetProfitLoss(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processFinanceProjectSetProfitLoss(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IProductPartyRoleClient {
    addParty(product: string | undefined, partyNums: string[]): Observable<number>;
}

@Injectable({
    providedIn: 'root'
})
export class ProductPartyRoleClient implements IProductPartyRoleClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    addParty(product: string | undefined, partyNums: string[]): Observable<number> {
        let url_ = this.baseUrl + "/api/ProductPartyRole?";
        if (product === null)
            throw new globalThis.Error("The parameter 'product' cannot be null.");
        else if (product !== undefined)
            url_ += "product=" + encodeURIComponent("" + product) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(partyNums);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddParty(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddParty(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processAddParty(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IProgressClient {
    get(): Observable<ProgressDto[]>;
}

@Injectable({
    providedIn: 'root'
})
export class ProgressClient implements IProgressClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    get(): Observable<ProgressDto[]> {
        let url_ = this.baseUrl + "/api/Progress";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProgressDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProgressDto[]>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<ProgressDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ProgressDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IProjectClient {
    get(): Observable<ProjectDto[]>;
    taskContactsCreate(taskId: number | undefined): Observable<number>;
    taskClose(taskId: number | undefined): Observable<number>;
}

@Injectable({
    providedIn: 'root'
})
export class ProjectClient implements IProjectClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    get(): Observable<ProjectDto[]> {
        let url_ = this.baseUrl + "/api/Project";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProjectDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProjectDto[]>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<ProjectDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ProjectDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    taskContactsCreate(taskId: number | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/Project/TaskContactsCreate?";
        if (taskId === null)
            throw new globalThis.Error("The parameter 'taskId' cannot be null.");
        else if (taskId !== undefined)
            url_ += "taskId=" + encodeURIComponent("" + taskId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTaskContactsCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTaskContactsCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processTaskContactsCreate(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    taskClose(taskId: number | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/Project/TaskClose?";
        if (taskId === null)
            throw new globalThis.Error("The parameter 'taskId' cannot be null.");
        else if (taskId !== undefined)
            url_ += "taskId=" + encodeURIComponent("" + taskId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTaskClose(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTaskClose(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processTaskClose(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IRightsApprovalClient {
    setApprovalStatus(approvalId: number, approvalStatus: RightsApprovalStatusEnum): Observable<RightsApprovalDto>;
    setCloseStatus(approvalId: number, closeStatus: RightsCloseStatusEnum): Observable<RightsApprovalDto>;
}

@Injectable({
    providedIn: 'root'
})
export class RightsApprovalClient implements IRightsApprovalClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    setApprovalStatus(approvalId: number, approvalStatus: RightsApprovalStatusEnum): Observable<RightsApprovalDto> {
        let url_ = this.baseUrl + "/api/RightsApproval/SetApprovalStatus/{approvalId}/{approvalStatus}";
        if (approvalId === undefined || approvalId === null)
            throw new globalThis.Error("The parameter 'approvalId' must be defined.");
        url_ = url_.replace("{approvalId}", encodeURIComponent("" + approvalId));
        if (approvalStatus === undefined || approvalStatus === null)
            throw new globalThis.Error("The parameter 'approvalStatus' must be defined.");
        url_ = url_.replace("{approvalStatus}", encodeURIComponent("" + approvalStatus));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSetApprovalStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSetApprovalStatus(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RightsApprovalDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RightsApprovalDto>;
        }));
    }

    protected processSetApprovalStatus(response: HttpResponseBase): Observable<RightsApprovalDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RightsApprovalDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    setCloseStatus(approvalId: number, closeStatus: RightsCloseStatusEnum): Observable<RightsApprovalDto> {
        let url_ = this.baseUrl + "/api/RightsApproval/SetCloseStatus/{approvalId}/{closeStatus}";
        if (approvalId === undefined || approvalId === null)
            throw new globalThis.Error("The parameter 'approvalId' must be defined.");
        url_ = url_.replace("{approvalId}", encodeURIComponent("" + approvalId));
        if (closeStatus === undefined || closeStatus === null)
            throw new globalThis.Error("The parameter 'closeStatus' must be defined.");
        url_ = url_.replace("{closeStatus}", encodeURIComponent("" + closeStatus));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSetCloseStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSetCloseStatus(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RightsApprovalDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RightsApprovalDto>;
        }));
    }

    protected processSetCloseStatus(response: HttpResponseBase): Observable<RightsApprovalDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RightsApprovalDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IRightsPeriodClient {
    get(): Observable<RightsPeriodDto[]>;
    syncPeriod(periodId: number | undefined): Observable<number>;
}

@Injectable({
    providedIn: 'root'
})
export class RightsPeriodClient implements IRightsPeriodClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    get(): Observable<RightsPeriodDto[]> {
        let url_ = this.baseUrl + "/api/RightsPeriod";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RightsPeriodDto[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RightsPeriodDto[]>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<RightsPeriodDto[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(RightsPeriodDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    syncPeriod(periodId: number | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/RightsPeriod?";
        if (periodId === null)
            throw new globalThis.Error("The parameter 'periodId' cannot be null.");
        else if (periodId !== undefined)
            url_ += "periodId=" + encodeURIComponent("" + periodId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSyncPeriod(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSyncPeriod(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processSyncPeriod(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IRoyaltyAfregningAktuelViewClient {
    get(): Observable<RoyaltyAfregningAktuelViewVm>;
}

@Injectable({
    providedIn: 'root'
})
export class RoyaltyAfregningAktuelViewClient implements IRoyaltyAfregningAktuelViewClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    get(): Observable<RoyaltyAfregningAktuelViewVm> {
        let url_ = this.baseUrl + "/api/RoyaltyAfregningAktuelView";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RoyaltyAfregningAktuelViewVm>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RoyaltyAfregningAktuelViewVm>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<RoyaltyAfregningAktuelViewVm> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RoyaltyAfregningAktuelViewVm.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IRoyaltyAfregningAktuelDetailViewClient {
    get(id: number | undefined): Observable<RoyaltyAfregningAktuelDetailViewVm>;
    post(command: RoyaltyStatementDocMergeCommand): Observable<string>;
    put(id: number, command: UpdateRoyaltyTransCommand): Observable<RoyaltyAfregningAktuelDetailViewVm>;
}

@Injectable({
    providedIn: 'root'
})
export class RoyaltyAfregningAktuelDetailViewClient implements IRoyaltyAfregningAktuelDetailViewClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    get(id: number | undefined): Observable<RoyaltyAfregningAktuelDetailViewVm> {
        let url_ = this.baseUrl + "/api/RoyaltyAfregningAktuelDetailView?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RoyaltyAfregningAktuelDetailViewVm>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RoyaltyAfregningAktuelDetailViewVm>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<RoyaltyAfregningAktuelDetailViewVm> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RoyaltyAfregningAktuelDetailViewVm.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    post(command: RoyaltyStatementDocMergeCommand): Observable<string> {
        let url_ = this.baseUrl + "/api/RoyaltyAfregningAktuelDetailView";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPost(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPost(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processPost(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    put(id: number, command: UpdateRoyaltyTransCommand): Observable<RoyaltyAfregningAktuelDetailViewVm> {
        let url_ = this.baseUrl + "/api/RoyaltyAfregningAktuelDetailView/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPut(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPut(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RoyaltyAfregningAktuelDetailViewVm>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RoyaltyAfregningAktuelDetailViewVm>;
        }));
    }

    protected processPut(response: HttpResponseBase): Observable<RoyaltyAfregningAktuelDetailViewVm> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RoyaltyAfregningAktuelDetailViewVm.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IRoyaltyForlagViewClient {
    get(): Observable<RoyaltyForlagViewVm>;
    post(command: RunRoyaltyCalculationCommand): Observable<number>;
}

@Injectable({
    providedIn: 'root'
})
export class RoyaltyForlagViewClient implements IRoyaltyForlagViewClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    get(): Observable<RoyaltyForlagViewVm> {
        let url_ = this.baseUrl + "/api/RoyaltyForlagView";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RoyaltyForlagViewVm>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RoyaltyForlagViewVm>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<RoyaltyForlagViewVm> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RoyaltyForlagViewVm.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    post(command: RunRoyaltyCalculationCommand): Observable<number> {
        let url_ = this.baseUrl + "/api/RoyaltyForlagView";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPost(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPost(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processPost(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface ISalesOrderClient {
    syncOrder(salesOrderNum: string): Observable<number>;
    salesOrderSet(command: SalesOrderSetCommand): Observable<SalesOrderDto>;
    salesOrdersPayment(command: SalesOrdersPaymentCommand): Observable<boolean>;
    syncOrders(): Observable<number>;
}

@Injectable({
    providedIn: 'root'
})
export class SalesOrderClient implements ISalesOrderClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    syncOrder(salesOrderNum: string): Observable<number> {
        let url_ = this.baseUrl + "/api/SalesOrder/SyncOrder/{salesOrderNum}";
        if (salesOrderNum === undefined || salesOrderNum === null)
            throw new globalThis.Error("The parameter 'salesOrderNum' must be defined.");
        url_ = url_.replace("{salesOrderNum}", encodeURIComponent("" + salesOrderNum));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSyncOrder(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSyncOrder(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processSyncOrder(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    salesOrderSet(command: SalesOrderSetCommand): Observable<SalesOrderDto> {
        let url_ = this.baseUrl + "/api/SalesOrder/SalesOrderSet";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSalesOrderSet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSalesOrderSet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SalesOrderDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SalesOrderDto>;
        }));
    }

    protected processSalesOrderSet(response: HttpResponseBase): Observable<SalesOrderDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SalesOrderDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    salesOrdersPayment(command: SalesOrdersPaymentCommand): Observable<boolean> {
        let url_ = this.baseUrl + "/api/SalesOrder/SalesOrdersPayment";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSalesOrdersPayment(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSalesOrdersPayment(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processSalesOrdersPayment(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    syncOrders(): Observable<number> {
        let url_ = this.baseUrl + "/api/SalesOrder/SyncOrders";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSyncOrders(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSyncOrders(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processSyncOrders(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IUserClient {
    getAllUsers(): Observable<UserVm>;
    linkUserIdentity(userId: number | undefined, identityId: string | undefined, confirmEmail: boolean | undefined): Observable<boolean>;
    setIdentityConfirmed(identityId: string | undefined, confirmEmailNewState: boolean | undefined): Observable<boolean>;
    getExternalIdentities(): Observable<ExternalIdentity[]>;
    createExternalIdentity(extIdentity: string | undefined, userName: string | null | undefined, eMail: string | null | undefined, password: string | null | undefined, userId: number | null | undefined): Observable<string>;
}

@Injectable({
    providedIn: 'root'
})
export class UserClient implements IUserClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    getAllUsers(): Observable<UserVm> {
        let url_ = this.baseUrl + "/api/User/GetAllUsers";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllUsers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllUsers(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserVm>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserVm>;
        }));
    }

    protected processGetAllUsers(response: HttpResponseBase): Observable<UserVm> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserVm.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    linkUserIdentity(userId: number | undefined, identityId: string | undefined, confirmEmail: boolean | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/User/LinkUserIdentity?";
        if (userId === null)
            throw new globalThis.Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        if (identityId === null)
            throw new globalThis.Error("The parameter 'identityId' cannot be null.");
        else if (identityId !== undefined)
            url_ += "identityId=" + encodeURIComponent("" + identityId) + "&";
        if (confirmEmail === null)
            throw new globalThis.Error("The parameter 'confirmEmail' cannot be null.");
        else if (confirmEmail !== undefined)
            url_ += "confirmEmail=" + encodeURIComponent("" + confirmEmail) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processLinkUserIdentity(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLinkUserIdentity(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processLinkUserIdentity(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    setIdentityConfirmed(identityId: string | undefined, confirmEmailNewState: boolean | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/User/SetIdentityConfirmed?";
        if (identityId === null)
            throw new globalThis.Error("The parameter 'identityId' cannot be null.");
        else if (identityId !== undefined)
            url_ += "identityId=" + encodeURIComponent("" + identityId) + "&";
        if (confirmEmailNewState === null)
            throw new globalThis.Error("The parameter 'confirmEmailNewState' cannot be null.");
        else if (confirmEmailNewState !== undefined)
            url_ += "confirmEmailNewState=" + encodeURIComponent("" + confirmEmailNewState) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSetIdentityConfirmed(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSetIdentityConfirmed(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processSetIdentityConfirmed(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getExternalIdentities(): Observable<ExternalIdentity[]> {
        let url_ = this.baseUrl + "/api/User/GetExternalIdentities";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetExternalIdentities(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetExternalIdentities(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ExternalIdentity[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ExternalIdentity[]>;
        }));
    }

    protected processGetExternalIdentities(response: HttpResponseBase): Observable<ExternalIdentity[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ExternalIdentity.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    createExternalIdentity(extIdentity: string | undefined, userName: string | null | undefined, eMail: string | null | undefined, password: string | null | undefined, userId: number | null | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/User/CreateExternalIdentity?";
        if (extIdentity === null)
            throw new globalThis.Error("The parameter 'extIdentity' cannot be null.");
        else if (extIdentity !== undefined)
            url_ += "extIdentity=" + encodeURIComponent("" + extIdentity) + "&";
        if (userName !== undefined && userName !== null)
            url_ += "userName=" + encodeURIComponent("" + userName) + "&";
        if (eMail !== undefined && eMail !== null)
            url_ += "eMail=" + encodeURIComponent("" + eMail) + "&";
        if (password !== undefined && password !== null)
            url_ += "password=" + encodeURIComponent("" + password) + "&";
        if (userId !== undefined && userId !== null)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateExternalIdentity(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateExternalIdentity(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processCreateExternalIdentity(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IUserRoleClient {
    get(userId: number | undefined): Observable<UserRoleVm>;
    post(userId: number | undefined, roleIds: number[]): Observable<boolean>;
}

@Injectable({
    providedIn: 'root'
})
export class UserRoleClient implements IUserRoleClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    get(userId: number | undefined): Observable<UserRoleVm> {
        let url_ = this.baseUrl + "/api/UserRole?";
        if (userId === null)
            throw new globalThis.Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "UserId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserRoleVm>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserRoleVm>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<UserRoleVm> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserRoleVm.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    post(userId: number | undefined, roleIds: number[]): Observable<boolean> {
        let url_ = this.baseUrl + "/api/UserRole?";
        if (userId === null)
            throw new globalThis.Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "UserId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(roleIds);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPost(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPost(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processPost(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IUserStatusClient {
    get(): Observable<UserStatusVm>;
}

@Injectable({
    providedIn: 'root'
})
export class UserStatusClient implements IUserStatusClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    get(): Observable<UserStatusVm> {
        let url_ = this.baseUrl + "/api/UserStatus";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserStatusVm>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserStatusVm>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<UserStatusVm> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserStatusVm.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IVoucherBaseDataClient {
    get(): Observable<VoucherBaseDataVm>;
}

@Injectable({
    providedIn: 'root'
})
export class VoucherBaseDataClient implements IVoucherBaseDataClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    get(): Observable<VoucherBaseDataVm> {
        let url_ = this.baseUrl + "/api/VoucherBaseData";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<VoucherBaseDataVm>;
                }
            } else
                return _observableThrow(response_) as any as Observable<VoucherBaseDataVm>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<VoucherBaseDataVm> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = VoucherBaseDataVm.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IVoucherMessageMailClient {
    post(command: VoucherMessageMailSyncCommand): Observable<number>;
}

@Injectable({
    providedIn: 'root'
})
export class VoucherMessageMailClient implements IVoucherMessageMailClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    post(command: VoucherMessageMailSyncCommand): Observable<number> {
        let url_ = this.baseUrl + "/api/VoucherMessageMail";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPost(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPost(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processPost(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IVoucherMessageViewClient {
    get(messageStatus: VoucherMessageStatusAllEnum | undefined, channnelType: VoucherMessageChannelTypeEnum | undefined): Observable<VoucherMessageVm>;
    getMessageCreateBaseData(): Observable<MessageVoucherCreateBaseDataVm>;
    messageCreate(command: VoucherMessageCreateCommand): Observable<number>;
    setStatus(id: number | undefined, messageStatus: VoucherMessageStatusEnum | undefined, proformaStatusChange: boolean | undefined): Observable<VoucherMessageViewDto>;
    setStatusRange(messageStatus: VoucherMessageStatusEnum | undefined, proformaStatusChange: boolean | undefined, msgIds: number[]): Observable<number>;
    attachmentsApply(cmd: VoucherMessageAttachmentsApplyCommand): Observable<boolean>;
}

@Injectable({
    providedIn: 'root'
})
export class VoucherMessageViewClient implements IVoucherMessageViewClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    get(messageStatus: VoucherMessageStatusAllEnum | undefined, channnelType: VoucherMessageChannelTypeEnum | undefined): Observable<VoucherMessageVm> {
        let url_ = this.baseUrl + "/api/VoucherMessageView/Get?";
        if (messageStatus === null)
            throw new globalThis.Error("The parameter 'messageStatus' cannot be null.");
        else if (messageStatus !== undefined)
            url_ += "messageStatus=" + encodeURIComponent("" + messageStatus) + "&";
        if (channnelType === null)
            throw new globalThis.Error("The parameter 'channnelType' cannot be null.");
        else if (channnelType !== undefined)
            url_ += "channnelType=" + encodeURIComponent("" + channnelType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<VoucherMessageVm>;
                }
            } else
                return _observableThrow(response_) as any as Observable<VoucherMessageVm>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<VoucherMessageVm> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = VoucherMessageVm.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getMessageCreateBaseData(): Observable<MessageVoucherCreateBaseDataVm> {
        let url_ = this.baseUrl + "/api/VoucherMessageView/GetMessageCreateBaseData";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMessageCreateBaseData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMessageCreateBaseData(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MessageVoucherCreateBaseDataVm>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MessageVoucherCreateBaseDataVm>;
        }));
    }

    protected processGetMessageCreateBaseData(response: HttpResponseBase): Observable<MessageVoucherCreateBaseDataVm> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MessageVoucherCreateBaseDataVm.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    messageCreate(command: VoucherMessageCreateCommand): Observable<number> {
        let url_ = this.baseUrl + "/api/VoucherMessageView/MessageCreate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMessageCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMessageCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processMessageCreate(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    setStatus(id: number | undefined, messageStatus: VoucherMessageStatusEnum | undefined, proformaStatusChange: boolean | undefined): Observable<VoucherMessageViewDto> {
        let url_ = this.baseUrl + "/api/VoucherMessageView/SetStatus?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        if (messageStatus === null)
            throw new globalThis.Error("The parameter 'messageStatus' cannot be null.");
        else if (messageStatus !== undefined)
            url_ += "messageStatus=" + encodeURIComponent("" + messageStatus) + "&";
        if (proformaStatusChange === null)
            throw new globalThis.Error("The parameter 'proformaStatusChange' cannot be null.");
        else if (proformaStatusChange !== undefined)
            url_ += "proformaStatusChange=" + encodeURIComponent("" + proformaStatusChange) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSetStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSetStatus(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<VoucherMessageViewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<VoucherMessageViewDto>;
        }));
    }

    protected processSetStatus(response: HttpResponseBase): Observable<VoucherMessageViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = VoucherMessageViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    setStatusRange(messageStatus: VoucherMessageStatusEnum | undefined, proformaStatusChange: boolean | undefined, msgIds: number[]): Observable<number> {
        let url_ = this.baseUrl + "/api/VoucherMessageView/SetStatusRange?";
        if (messageStatus === null)
            throw new globalThis.Error("The parameter 'messageStatus' cannot be null.");
        else if (messageStatus !== undefined)
            url_ += "messageStatus=" + encodeURIComponent("" + messageStatus) + "&";
        if (proformaStatusChange === null)
            throw new globalThis.Error("The parameter 'proformaStatusChange' cannot be null.");
        else if (proformaStatusChange !== undefined)
            url_ += "proformaStatusChange=" + encodeURIComponent("" + proformaStatusChange) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(msgIds);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSetStatusRange(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSetStatusRange(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processSetStatusRange(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    attachmentsApply(cmd: VoucherMessageAttachmentsApplyCommand): Observable<boolean> {
        let url_ = this.baseUrl + "/api/VoucherMessageView/AttachmentsApply";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(cmd);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAttachmentsApply(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAttachmentsApply(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processAttachmentsApply(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IVoucherMessageViewDetailsClient {
    get(id: number | undefined): Observable<VoucherMessageViewDetailsVm>;
    getByVoucherNum(voucherNum: number): Observable<VoucherMessageViewDetailsVm>;
    postVoucher(voucher: VoucherViewDto): Observable<VoucherMessageViewDetailsVm>;
    putVoucher(messageId: number, forceUpdateAmountCur: boolean | undefined, voucher: VoucherViewDto): Observable<VoucherMessageViewDetailsVm>;
    deleteVoucher(messageId: number, voucherId: number): Observable<VoucherMessageViewDetailsVm>;
    postVoucherApprover(voucherId: number | undefined, userId: number | undefined, approved: boolean | undefined): Observable<boolean>;
    postPosting(posting: VoucherPostingViewDto): Observable<VoucherPostingViewDto>;
    putPosting(posting: VoucherPostingViewDto): Observable<VoucherPostingViewDto>;
    deletePosting(messageId: number, postingId: number): Observable<VoucherPostingViewDto>;
}

@Injectable({
    providedIn: 'root'
})
export class VoucherMessageViewDetailsClient implements IVoucherMessageViewDetailsClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    get(id: number | undefined): Observable<VoucherMessageViewDetailsVm> {
        let url_ = this.baseUrl + "/api/VoucherMessageViewDetails?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<VoucherMessageViewDetailsVm>;
                }
            } else
                return _observableThrow(response_) as any as Observable<VoucherMessageViewDetailsVm>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<VoucherMessageViewDetailsVm> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = VoucherMessageViewDetailsVm.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getByVoucherNum(voucherNum: number): Observable<VoucherMessageViewDetailsVm> {
        let url_ = this.baseUrl + "/api/VoucherMessageViewDetails/GetByVocuherNum/{voucherNum}";
        if (voucherNum === undefined || voucherNum === null)
            throw new globalThis.Error("The parameter 'voucherNum' must be defined.");
        url_ = url_.replace("{voucherNum}", encodeURIComponent("" + voucherNum));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetByVoucherNum(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetByVoucherNum(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<VoucherMessageViewDetailsVm>;
                }
            } else
                return _observableThrow(response_) as any as Observable<VoucherMessageViewDetailsVm>;
        }));
    }

    protected processGetByVoucherNum(response: HttpResponseBase): Observable<VoucherMessageViewDetailsVm> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = VoucherMessageViewDetailsVm.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    postVoucher(voucher: VoucherViewDto): Observable<VoucherMessageViewDetailsVm> {
        let url_ = this.baseUrl + "/api/VoucherMessageViewDetails/PostVoucher";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(voucher);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPostVoucher(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPostVoucher(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<VoucherMessageViewDetailsVm>;
                }
            } else
                return _observableThrow(response_) as any as Observable<VoucherMessageViewDetailsVm>;
        }));
    }

    protected processPostVoucher(response: HttpResponseBase): Observable<VoucherMessageViewDetailsVm> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = VoucherMessageViewDetailsVm.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    putVoucher(messageId: number, forceUpdateAmountCur: boolean | undefined, voucher: VoucherViewDto): Observable<VoucherMessageViewDetailsVm> {
        let url_ = this.baseUrl + "/api/VoucherMessageViewDetails/PutVoucher/{messageId}?";
        if (messageId === undefined || messageId === null)
            throw new globalThis.Error("The parameter 'messageId' must be defined.");
        url_ = url_.replace("{messageId}", encodeURIComponent("" + messageId));
        if (forceUpdateAmountCur === null)
            throw new globalThis.Error("The parameter 'forceUpdateAmountCur' cannot be null.");
        else if (forceUpdateAmountCur !== undefined)
            url_ += "forceUpdateAmountCur=" + encodeURIComponent("" + forceUpdateAmountCur) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(voucher);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPutVoucher(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPutVoucher(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<VoucherMessageViewDetailsVm>;
                }
            } else
                return _observableThrow(response_) as any as Observable<VoucherMessageViewDetailsVm>;
        }));
    }

    protected processPutVoucher(response: HttpResponseBase): Observable<VoucherMessageViewDetailsVm> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = VoucherMessageViewDetailsVm.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    deleteVoucher(messageId: number, voucherId: number): Observable<VoucherMessageViewDetailsVm> {
        let url_ = this.baseUrl + "/api/VoucherMessageViewDetails/DeleteVoucher/{messageId}/{voucherId}";
        if (messageId === undefined || messageId === null)
            throw new globalThis.Error("The parameter 'messageId' must be defined.");
        url_ = url_.replace("{messageId}", encodeURIComponent("" + messageId));
        if (voucherId === undefined || voucherId === null)
            throw new globalThis.Error("The parameter 'voucherId' must be defined.");
        url_ = url_.replace("{voucherId}", encodeURIComponent("" + voucherId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteVoucher(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteVoucher(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<VoucherMessageViewDetailsVm>;
                }
            } else
                return _observableThrow(response_) as any as Observable<VoucherMessageViewDetailsVm>;
        }));
    }

    protected processDeleteVoucher(response: HttpResponseBase): Observable<VoucherMessageViewDetailsVm> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = VoucherMessageViewDetailsVm.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    postVoucherApprover(voucherId: number | undefined, userId: number | undefined, approved: boolean | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/VoucherMessageViewDetails/PostVoucherApprover?";
        if (voucherId === null)
            throw new globalThis.Error("The parameter 'voucherId' cannot be null.");
        else if (voucherId !== undefined)
            url_ += "voucherId=" + encodeURIComponent("" + voucherId) + "&";
        if (userId === null)
            throw new globalThis.Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        if (approved === null)
            throw new globalThis.Error("The parameter 'approved' cannot be null.");
        else if (approved !== undefined)
            url_ += "approved=" + encodeURIComponent("" + approved) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPostVoucherApprover(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPostVoucherApprover(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processPostVoucherApprover(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    postPosting(posting: VoucherPostingViewDto): Observable<VoucherPostingViewDto> {
        let url_ = this.baseUrl + "/api/VoucherMessageViewDetails/PostPosting";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(posting);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPostPosting(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPostPosting(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<VoucherPostingViewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<VoucherPostingViewDto>;
        }));
    }

    protected processPostPosting(response: HttpResponseBase): Observable<VoucherPostingViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = VoucherPostingViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    putPosting(posting: VoucherPostingViewDto): Observable<VoucherPostingViewDto> {
        let url_ = this.baseUrl + "/api/VoucherMessageViewDetails/PutPosting";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(posting);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPutPosting(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPutPosting(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<VoucherPostingViewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<VoucherPostingViewDto>;
        }));
    }

    protected processPutPosting(response: HttpResponseBase): Observable<VoucherPostingViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = VoucherPostingViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    deletePosting(messageId: number, postingId: number): Observable<VoucherPostingViewDto> {
        let url_ = this.baseUrl + "/api/VoucherMessageViewDetails/DeletePosting/{messageId}/{postingId}";
        if (messageId === undefined || messageId === null)
            throw new globalThis.Error("The parameter 'messageId' must be defined.");
        url_ = url_.replace("{messageId}", encodeURIComponent("" + messageId));
        if (postingId === undefined || postingId === null)
            throw new globalThis.Error("The parameter 'postingId' must be defined.");
        url_ = url_.replace("{postingId}", encodeURIComponent("" + postingId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeletePosting(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeletePosting(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<VoucherPostingViewDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<VoucherPostingViewDto>;
        }));
    }

    protected processDeletePosting(response: HttpResponseBase): Observable<VoucherPostingViewDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = VoucherPostingViewDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IVoucherUtilClient {
    adjustPostingAmountToVoucher(msgId: number | undefined): Observable<VoucherMessageViewDetailsVm>;
    isVendorDocumentNumUnique(msgIdToCheck: number | undefined, vendorAccountNumToCheck: string | undefined, documentNumToCheck: string | undefined): Observable<VoucherMessageViewDetailsVm>;
    typePublish_VoucherValidationStatusEnum(): Observable<VoucherValidationStatusEnum>;
}

@Injectable({
    providedIn: 'root'
})
export class VoucherUtilClient implements IVoucherUtilClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    adjustPostingAmountToVoucher(msgId: number | undefined): Observable<VoucherMessageViewDetailsVm> {
        let url_ = this.baseUrl + "/api/VoucherUtil?";
        if (msgId === null)
            throw new globalThis.Error("The parameter 'msgId' cannot be null.");
        else if (msgId !== undefined)
            url_ += "msgId=" + encodeURIComponent("" + msgId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAdjustPostingAmountToVoucher(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAdjustPostingAmountToVoucher(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<VoucherMessageViewDetailsVm>;
                }
            } else
                return _observableThrow(response_) as any as Observable<VoucherMessageViewDetailsVm>;
        }));
    }

    protected processAdjustPostingAmountToVoucher(response: HttpResponseBase): Observable<VoucherMessageViewDetailsVm> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = VoucherMessageViewDetailsVm.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    isVendorDocumentNumUnique(msgIdToCheck: number | undefined, vendorAccountNumToCheck: string | undefined, documentNumToCheck: string | undefined): Observable<VoucherMessageViewDetailsVm> {
        let url_ = this.baseUrl + "/api/VoucherUtil?";
        if (msgIdToCheck === null)
            throw new globalThis.Error("The parameter 'msgIdToCheck' cannot be null.");
        else if (msgIdToCheck !== undefined)
            url_ += "msgIdToCheck=" + encodeURIComponent("" + msgIdToCheck) + "&";
        if (vendorAccountNumToCheck === null)
            throw new globalThis.Error("The parameter 'vendorAccountNumToCheck' cannot be null.");
        else if (vendorAccountNumToCheck !== undefined)
            url_ += "vendorAccountNumToCheck=" + encodeURIComponent("" + vendorAccountNumToCheck) + "&";
        if (documentNumToCheck === null)
            throw new globalThis.Error("The parameter 'documentNumToCheck' cannot be null.");
        else if (documentNumToCheck !== undefined)
            url_ += "documentNumToCheck=" + encodeURIComponent("" + documentNumToCheck) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processIsVendorDocumentNumUnique(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processIsVendorDocumentNumUnique(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<VoucherMessageViewDetailsVm>;
                }
            } else
                return _observableThrow(response_) as any as Observable<VoucherMessageViewDetailsVm>;
        }));
    }

    protected processIsVendorDocumentNumUnique(response: HttpResponseBase): Observable<VoucherMessageViewDetailsVm> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = VoucherMessageViewDetailsVm.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    typePublish_VoucherValidationStatusEnum(): Observable<VoucherValidationStatusEnum> {
        let url_ = this.baseUrl + "/api/VoucherUtil/TypePublish_VoucherValidationStatusEnum";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processTypePublish_VoucherValidationStatusEnum(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processTypePublish_VoucherValidationStatusEnum(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<VoucherValidationStatusEnum>;
                }
            } else
                return _observableThrow(response_) as any as Observable<VoucherValidationStatusEnum>;
        }));
    }

    protected processTypePublish_VoucherValidationStatusEnum(response: HttpResponseBase): Observable<VoucherValidationStatusEnum> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IVoucherViewClient {
    get(channelType: VoucherMessageChannelTypeEnum | null | undefined, approvalStatus: VoucherApprovalStatusAllEnum | undefined, myApprovals: boolean | undefined): Observable<VoucherViewVm>;
    post(commerceVoucherViewDto: VoucherViewDto): Observable<VoucherViewResponse>;
    put(forceUpdateAmountCur: boolean | undefined, commerceVoucherViewDto: VoucherViewDto): Observable<VoucherViewResponse>;
    delete(commerceVoucherViewDto: VoucherViewDto): Observable<VoucherViewResponse>;
    setApprovalStatus(approvalStatus: VoucherApprovalStatusEnum | undefined, id: number[]): Observable<VoucherViewResponse>;
    getExpenseVoucherCreateBaseData(): Observable<GetExpenseVoucherCreateBaseDataVm>;
}

@Injectable({
    providedIn: 'root'
})
export class VoucherViewClient implements IVoucherViewClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    get(channelType: VoucherMessageChannelTypeEnum | null | undefined, approvalStatus: VoucherApprovalStatusAllEnum | undefined, myApprovals: boolean | undefined): Observable<VoucherViewVm> {
        let url_ = this.baseUrl + "/api/VoucherView?";
        if (channelType !== undefined && channelType !== null)
            url_ += "channelType=" + encodeURIComponent("" + channelType) + "&";
        if (approvalStatus === null)
            throw new globalThis.Error("The parameter 'approvalStatus' cannot be null.");
        else if (approvalStatus !== undefined)
            url_ += "approvalStatus=" + encodeURIComponent("" + approvalStatus) + "&";
        if (myApprovals === null)
            throw new globalThis.Error("The parameter 'myApprovals' cannot be null.");
        else if (myApprovals !== undefined)
            url_ += "myApprovals=" + encodeURIComponent("" + myApprovals) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<VoucherViewVm>;
                }
            } else
                return _observableThrow(response_) as any as Observable<VoucherViewVm>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<VoucherViewVm> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = VoucherViewVm.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    post(commerceVoucherViewDto: VoucherViewDto): Observable<VoucherViewResponse> {
        let url_ = this.baseUrl + "/api/VoucherView";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(commerceVoucherViewDto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPost(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPost(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<VoucherViewResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<VoucherViewResponse>;
        }));
    }

    protected processPost(response: HttpResponseBase): Observable<VoucherViewResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = VoucherViewResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    put(forceUpdateAmountCur: boolean | undefined, commerceVoucherViewDto: VoucherViewDto): Observable<VoucherViewResponse> {
        let url_ = this.baseUrl + "/api/VoucherView?";
        if (forceUpdateAmountCur === null)
            throw new globalThis.Error("The parameter 'forceUpdateAmountCur' cannot be null.");
        else if (forceUpdateAmountCur !== undefined)
            url_ += "forceUpdateAmountCur=" + encodeURIComponent("" + forceUpdateAmountCur) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(commerceVoucherViewDto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPut(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPut(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<VoucherViewResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<VoucherViewResponse>;
        }));
    }

    protected processPut(response: HttpResponseBase): Observable<VoucherViewResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = VoucherViewResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    delete(commerceVoucherViewDto: VoucherViewDto): Observable<VoucherViewResponse> {
        let url_ = this.baseUrl + "/api/VoucherView";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(commerceVoucherViewDto);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<VoucherViewResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<VoucherViewResponse>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<VoucherViewResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = VoucherViewResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    setApprovalStatus(approvalStatus: VoucherApprovalStatusEnum | undefined, id: number[]): Observable<VoucherViewResponse> {
        let url_ = this.baseUrl + "/api/VoucherView?";
        if (approvalStatus === null)
            throw new globalThis.Error("The parameter 'approvalStatus' cannot be null.");
        else if (approvalStatus !== undefined)
            url_ += "approvalStatus=" + encodeURIComponent("" + approvalStatus) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(id);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("patch", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSetApprovalStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSetApprovalStatus(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<VoucherViewResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<VoucherViewResponse>;
        }));
    }

    protected processSetApprovalStatus(response: HttpResponseBase): Observable<VoucherViewResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = VoucherViewResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getExpenseVoucherCreateBaseData(): Observable<GetExpenseVoucherCreateBaseDataVm> {
        let url_ = this.baseUrl + "/api/VoucherView/GetExpenseVoucherCreateBaseData";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetExpenseVoucherCreateBaseData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetExpenseVoucherCreateBaseData(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetExpenseVoucherCreateBaseDataVm>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetExpenseVoucherCreateBaseDataVm>;
        }));
    }

    protected processGetExpenseVoucherCreateBaseData(response: HttpResponseBase): Observable<GetExpenseVoucherCreateBaseDataVm> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetExpenseVoucherCreateBaseDataVm.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IWarehouseOnhandClient {
    costJournalLinesCreate(journalId: number | undefined): Observable<boolean>;
    costJournalLinesDelete(journalId: number | undefined): Observable<boolean>;
    costJournalLinesRecalc(journalId: number | undefined): Observable<boolean>;
    costJournalLinesPost(journalId: number | undefined): Observable<boolean>;
    costJournalLineGet(journalId: number | undefined, productNum: string | null | undefined, projectNum: string | null | undefined): Observable<WarehouseOnhandCostJournalLineDto>;
}

@Injectable({
    providedIn: 'root'
})
export class WarehouseOnhandClient implements IWarehouseOnhandClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    costJournalLinesCreate(journalId: number | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/WarehouseOnhand?";
        if (journalId === null)
            throw new globalThis.Error("The parameter 'journalId' cannot be null.");
        else if (journalId !== undefined)
            url_ += "journalId=" + encodeURIComponent("" + journalId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCostJournalLinesCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCostJournalLinesCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processCostJournalLinesCreate(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    costJournalLinesDelete(journalId: number | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/WarehouseOnhand?";
        if (journalId === null)
            throw new globalThis.Error("The parameter 'journalId' cannot be null.");
        else if (journalId !== undefined)
            url_ += "journalId=" + encodeURIComponent("" + journalId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCostJournalLinesDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCostJournalLinesDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processCostJournalLinesDelete(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    costJournalLinesRecalc(journalId: number | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/WarehouseOnhand?";
        if (journalId === null)
            throw new globalThis.Error("The parameter 'journalId' cannot be null.");
        else if (journalId !== undefined)
            url_ += "journalId=" + encodeURIComponent("" + journalId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("patch", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCostJournalLinesRecalc(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCostJournalLinesRecalc(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processCostJournalLinesRecalc(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    costJournalLinesPost(journalId: number | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/WarehouseOnhand?";
        if (journalId === null)
            throw new globalThis.Error("The parameter 'journalId' cannot be null.");
        else if (journalId !== undefined)
            url_ += "journalId=" + encodeURIComponent("" + journalId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCostJournalLinesPost(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCostJournalLinesPost(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processCostJournalLinesPost(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    costJournalLineGet(journalId: number | undefined, productNum: string | null | undefined, projectNum: string | null | undefined): Observable<WarehouseOnhandCostJournalLineDto> {
        let url_ = this.baseUrl + "/api/WarehouseOnhand?";
        if (journalId === null)
            throw new globalThis.Error("The parameter 'journalId' cannot be null.");
        else if (journalId !== undefined)
            url_ += "journalId=" + encodeURIComponent("" + journalId) + "&";
        if (productNum !== undefined && productNum !== null)
            url_ += "productNum=" + encodeURIComponent("" + productNum) + "&";
        if (projectNum !== undefined && projectNum !== null)
            url_ += "projectNum=" + encodeURIComponent("" + projectNum) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCostJournalLineGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCostJournalLineGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WarehouseOnhandCostJournalLineDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WarehouseOnhandCostJournalLineDto>;
        }));
    }

    protected processCostJournalLineGet(response: HttpResponseBase): Observable<WarehouseOnhandCostJournalLineDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = WarehouseOnhandCostJournalLineDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IWarehouseOutboundOrderClient {
    setStatus(outboundOrderNum: string, status: WarehouseOutboundOrderStatusEnum): Observable<boolean>;
    createOrderFromCancelledLines(outboundOrderNum: string | null | undefined): Observable<boolean>;
    syncOutboundOrders(): Observable<number>;
    syncOutboundOrder(outboundOrderNum: string): Observable<number>;
}

@Injectable({
    providedIn: 'root'
})
export class WarehouseOutboundOrderClient implements IWarehouseOutboundOrderClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    setStatus(outboundOrderNum: string, status: WarehouseOutboundOrderStatusEnum): Observable<boolean> {
        let url_ = this.baseUrl + "/api/WarehouseOutboundOrder/SetStatus/{outboundOrderNum}/{status}";
        if (outboundOrderNum === undefined || outboundOrderNum === null)
            throw new globalThis.Error("The parameter 'outboundOrderNum' must be defined.");
        url_ = url_.replace("{outboundOrderNum}", encodeURIComponent("" + outboundOrderNum));
        if (status === undefined || status === null)
            throw new globalThis.Error("The parameter 'status' must be defined.");
        url_ = url_.replace("{status}", encodeURIComponent("" + status));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSetStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSetStatus(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processSetStatus(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    createOrderFromCancelledLines(outboundOrderNum: string | null | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/WarehouseOutboundOrder/CreateOrderFromCancelledLines?";
        if (outboundOrderNum !== undefined && outboundOrderNum !== null)
            url_ += "outboundOrderNum=" + encodeURIComponent("" + outboundOrderNum) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrderFromCancelledLines(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrderFromCancelledLines(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processCreateOrderFromCancelledLines(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    syncOutboundOrders(): Observable<number> {
        let url_ = this.baseUrl + "/api/WarehouseOutboundOrder/SyncOutboundOrders";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSyncOutboundOrders(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSyncOutboundOrders(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processSyncOutboundOrders(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    syncOutboundOrder(outboundOrderNum: string): Observable<number> {
        let url_ = this.baseUrl + "/api/WarehouseOutboundOrder/SyncOutboundOrder/{outboundOrderNum}";
        if (outboundOrderNum === undefined || outboundOrderNum === null)
            throw new globalThis.Error("The parameter 'outboundOrderNum' must be defined.");
        url_ = url_.replace("{outboundOrderNum}", encodeURIComponent("" + outboundOrderNum));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSyncOutboundOrder(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSyncOutboundOrder(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processSyncOutboundOrder(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export class CerIdentityUserDto implements ICerIdentityUserDto {
    firstName?: string | undefined;
    lastName?: string | undefined;
    jwt?: string;

    constructor(data?: ICerIdentityUserDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.jwt = _data["jwt"];
        }
    }

    static fromJS(data: any): CerIdentityUserDto {
        data = typeof data === 'object' ? data : {};
        let result = new CerIdentityUserDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["jwt"] = this.jwt;
        return data;
    }
}

export interface ICerIdentityUserDto {
    firstName?: string | undefined;
    lastName?: string | undefined;
    jwt?: string;
}

export class AppMetaUserViewCommand implements IAppMetaUserViewCommand {
    routeUrl?: string;
    defaultView?: string;
    views?: AppMetaUserViewItem[];

    constructor(data?: IAppMetaUserViewCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.routeUrl = _data["routeUrl"];
            this.defaultView = _data["defaultView"];
            if (Array.isArray(_data["views"])) {
                this.views = [] as any;
                for (let item of _data["views"])
                    this.views!.push(AppMetaUserViewItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AppMetaUserViewCommand {
        data = typeof data === 'object' ? data : {};
        let result = new AppMetaUserViewCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["routeUrl"] = this.routeUrl;
        data["defaultView"] = this.defaultView;
        if (Array.isArray(this.views)) {
            data["views"] = [];
            for (let item of this.views)
                data["views"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IAppMetaUserViewCommand {
    routeUrl?: string;
    defaultView?: string;
    views?: AppMetaUserViewItem[];
}

export class AppMetaUserViewItem implements IAppMetaUserViewItem {
    name?: string;
    isPrimary?: boolean;
    isDefault?: boolean;
    formPersistenceData?: string;

    constructor(data?: IAppMetaUserViewItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.isPrimary = _data["isPrimary"];
            this.isDefault = _data["isDefault"];
            this.formPersistenceData = _data["formPersistenceData"];
        }
    }

    static fromJS(data: any): AppMetaUserViewItem {
        data = typeof data === 'object' ? data : {};
        let result = new AppMetaUserViewItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["isPrimary"] = this.isPrimary;
        data["isDefault"] = this.isDefault;
        data["formPersistenceData"] = this.formPersistenceData;
        return data;
    }
}

export interface IAppMetaUserViewItem {
    name?: string;
    isPrimary?: boolean;
    isDefault?: boolean;
    formPersistenceData?: string;
}

export class AppMetaUserViewVm implements IAppMetaUserViewVm {
    route?: AppRouteDto | undefined;
    userRoute?: AppUserRouteDto | undefined;
    userRouteViews?: AppUserRouteViewDto[] | undefined;

    constructor(data?: IAppMetaUserViewVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.route = _data["route"] ? AppRouteDto.fromJS(_data["route"]) : undefined as any;
            this.userRoute = _data["userRoute"] ? AppUserRouteDto.fromJS(_data["userRoute"]) : undefined as any;
            if (Array.isArray(_data["userRouteViews"])) {
                this.userRouteViews = [] as any;
                for (let item of _data["userRouteViews"])
                    this.userRouteViews!.push(AppUserRouteViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AppMetaUserViewVm {
        data = typeof data === 'object' ? data : {};
        let result = new AppMetaUserViewVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["route"] = this.route ? this.route.toJSON() : undefined as any;
        data["userRoute"] = this.userRoute ? this.userRoute.toJSON() : undefined as any;
        if (Array.isArray(this.userRouteViews)) {
            data["userRouteViews"] = [];
            for (let item of this.userRouteViews)
                data["userRouteViews"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IAppMetaUserViewVm {
    route?: AppRouteDto | undefined;
    userRoute?: AppUserRouteDto | undefined;
    userRouteViews?: AppUserRouteViewDto[] | undefined;
}

export class AppRouteDto implements IAppRouteDto {
    id?: number | undefined;
    name?: string | undefined;
    url?: string | undefined;
    title?: string | undefined;
    created?: Date | undefined;
    createdBy?: number | undefined;
    modified?: Date | undefined;
    modifiedBy?: number | undefined;

    constructor(data?: IAppRouteDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.url = _data["url"];
            this.title = _data["title"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : undefined as any;
            this.createdBy = _data["createdBy"];
            this.modified = _data["modified"] ? new Date(_data["modified"].toString()) : undefined as any;
            this.modifiedBy = _data["modifiedBy"];
        }
    }

    static fromJS(data: any): AppRouteDto {
        data = typeof data === 'object' ? data : {};
        let result = new AppRouteDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["url"] = this.url;
        data["title"] = this.title;
        data["created"] = this.created ? this.created.toISOString() : undefined as any;
        data["createdBy"] = this.createdBy;
        data["modified"] = this.modified ? this.modified.toISOString() : undefined as any;
        data["modifiedBy"] = this.modifiedBy;
        return data;
    }
}

export interface IAppRouteDto {
    id?: number | undefined;
    name?: string | undefined;
    url?: string | undefined;
    title?: string | undefined;
    created?: Date | undefined;
    createdBy?: number | undefined;
    modified?: Date | undefined;
    modifiedBy?: number | undefined;
}

export class AppUserRouteDto implements IAppUserRouteDto {
    id?: number | undefined;
    routeId?: number | undefined;
    userId?: number | undefined;
    defaultView?: string | undefined;
    created?: Date | undefined;
    createdBy?: number | undefined;
    modified?: Date | undefined;
    modifiedBy?: number | undefined;

    constructor(data?: IAppUserRouteDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.routeId = _data["routeId"];
            this.userId = _data["userId"];
            this.defaultView = _data["defaultView"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : undefined as any;
            this.createdBy = _data["createdBy"];
            this.modified = _data["modified"] ? new Date(_data["modified"].toString()) : undefined as any;
            this.modifiedBy = _data["modifiedBy"];
        }
    }

    static fromJS(data: any): AppUserRouteDto {
        data = typeof data === 'object' ? data : {};
        let result = new AppUserRouteDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["routeId"] = this.routeId;
        data["userId"] = this.userId;
        data["defaultView"] = this.defaultView;
        data["created"] = this.created ? this.created.toISOString() : undefined as any;
        data["createdBy"] = this.createdBy;
        data["modified"] = this.modified ? this.modified.toISOString() : undefined as any;
        data["modifiedBy"] = this.modifiedBy;
        return data;
    }
}

export interface IAppUserRouteDto {
    id?: number | undefined;
    routeId?: number | undefined;
    userId?: number | undefined;
    defaultView?: string | undefined;
    created?: Date | undefined;
    createdBy?: number | undefined;
    modified?: Date | undefined;
    modifiedBy?: number | undefined;
}

export class AppUserRouteViewDto implements IAppUserRouteViewDto {
    id?: number | undefined;
    userRouteId?: number | undefined;
    name?: string | undefined;
    isPrimary?: boolean | undefined;
    formPersistenceData?: string | undefined;
    params?: string[] | undefined;
    created?: Date | undefined;
    createdBy?: number | undefined;
    modified?: Date | undefined;
    modifiedBy?: number | undefined;
    userRoute?: AppUserRouteDto | undefined;
    isDefault?: boolean | undefined;

    constructor(data?: IAppUserRouteViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.userRouteId = _data["userRouteId"];
            this.name = _data["name"];
            this.isPrimary = _data["isPrimary"];
            this.formPersistenceData = _data["formPersistenceData"];
            if (Array.isArray(_data["params"])) {
                this.params = [] as any;
                for (let item of _data["params"])
                    this.params!.push(item);
            }
            this.created = _data["created"] ? new Date(_data["created"].toString()) : undefined as any;
            this.createdBy = _data["createdBy"];
            this.modified = _data["modified"] ? new Date(_data["modified"].toString()) : undefined as any;
            this.modifiedBy = _data["modifiedBy"];
            this.userRoute = _data["userRoute"] ? AppUserRouteDto.fromJS(_data["userRoute"]) : undefined as any;
            this.isDefault = _data["isDefault"];
        }
    }

    static fromJS(data: any): AppUserRouteViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new AppUserRouteViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["userRouteId"] = this.userRouteId;
        data["name"] = this.name;
        data["isPrimary"] = this.isPrimary;
        data["formPersistenceData"] = this.formPersistenceData;
        if (Array.isArray(this.params)) {
            data["params"] = [];
            for (let item of this.params)
                data["params"].push(item);
        }
        data["created"] = this.created ? this.created.toISOString() : undefined as any;
        data["createdBy"] = this.createdBy;
        data["modified"] = this.modified ? this.modified.toISOString() : undefined as any;
        data["modifiedBy"] = this.modifiedBy;
        data["userRoute"] = this.userRoute ? this.userRoute.toJSON() : undefined as any;
        data["isDefault"] = this.isDefault;
        return data;
    }
}

export interface IAppUserRouteViewDto {
    id?: number | undefined;
    userRouteId?: number | undefined;
    name?: string | undefined;
    isPrimary?: boolean | undefined;
    formPersistenceData?: string | undefined;
    params?: string[] | undefined;
    created?: Date | undefined;
    createdBy?: number | undefined;
    modified?: Date | undefined;
    modifiedBy?: number | undefined;
    userRoute?: AppUserRouteDto | undefined;
    isDefault?: boolean | undefined;
}

export class EntityMetaVm implements IEntityMetaVm {
    entitity?: EntityMetaDto | undefined;

    constructor(data?: IEntityMetaVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.entitity = _data["entitity"] ? EntityMetaDto.fromJS(_data["entitity"]) : undefined as any;
        }
    }

    static fromJS(data: any): EntityMetaVm {
        data = typeof data === 'object' ? data : {};
        let result = new EntityMetaVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["entitity"] = this.entitity ? this.entitity.toJSON() : undefined as any;
        return data;
    }
}

export interface IEntityMetaVm {
    entitity?: EntityMetaDto | undefined;
}

export class EntityMetaBaseDto implements IEntityMetaBaseDto {
    id?: number;
    name?: string;
    columns?: EntityColumnMetaDto[];
    url?: string | undefined;
    module?: ModuleMetaDto | undefined;
    dataLink?: EntityMetaDataLink | undefined;
    access?: EntityMetaAccessLevelEnum;
    accessAdmin?: EntityMetaAccessLevelEnum;

    constructor(data?: IEntityMetaBaseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            if (Array.isArray(_data["columns"])) {
                this.columns = [] as any;
                for (let item of _data["columns"])
                    this.columns!.push(EntityColumnMetaDto.fromJS(item));
            }
            this.url = _data["url"];
            this.module = _data["module"] ? ModuleMetaDto.fromJS(_data["module"]) : undefined as any;
            this.dataLink = _data["dataLink"] ? EntityMetaDataLink.fromJS(_data["dataLink"]) : undefined as any;
            this.access = _data["access"];
            this.accessAdmin = _data["accessAdmin"];
        }
    }

    static fromJS(data: any): EntityMetaBaseDto {
        data = typeof data === 'object' ? data : {};
        let result = new EntityMetaBaseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        if (Array.isArray(this.columns)) {
            data["columns"] = [];
            for (let item of this.columns)
                data["columns"].push(item ? item.toJSON() : undefined as any);
        }
        data["url"] = this.url;
        data["module"] = this.module ? this.module.toJSON() : undefined as any;
        data["dataLink"] = this.dataLink ? this.dataLink.toJSON() : undefined as any;
        data["access"] = this.access;
        data["accessAdmin"] = this.accessAdmin;
        return data;
    }
}

export interface IEntityMetaBaseDto {
    id?: number;
    name?: string;
    columns?: EntityColumnMetaDto[];
    url?: string | undefined;
    module?: ModuleMetaDto | undefined;
    dataLink?: EntityMetaDataLink | undefined;
    access?: EntityMetaAccessLevelEnum;
    accessAdmin?: EntityMetaAccessLevelEnum;
}

export class EntityMetaDto extends EntityMetaBaseDto implements IEntityMetaDto {

    constructor(data?: IEntityMetaDto) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): EntityMetaDto {
        data = typeof data === 'object' ? data : {};
        let result = new EntityMetaDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IEntityMetaDto extends IEntityMetaBaseDto {
}

export class EntityColumnMetaDto implements IEntityColumnMetaDto {
    name?: string;
    namePrefix?: string | undefined;
    isPrimaryKey?: boolean | undefined;
    isRequired?: boolean | undefined;
    isNullable?: boolean | undefined;
    allowEdit?: boolean | undefined;
    allowEditOnCreate?: boolean | undefined;
    visible?: boolean | undefined;
    visibleOnEdit?: boolean | undefined;
    visibleOnCreate?: boolean | undefined;
    baseType?: EntityMetaBaseDataTypeEnum | undefined;
    type?: EntityMetaDataType | undefined;
    attributes?: EntityMetaTypeAttributesDto | undefined;

    constructor(data?: IEntityColumnMetaDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.namePrefix = _data["namePrefix"];
            this.isPrimaryKey = _data["isPrimaryKey"];
            this.isRequired = _data["isRequired"];
            this.isNullable = _data["isNullable"];
            this.allowEdit = _data["allowEdit"];
            this.allowEditOnCreate = _data["allowEditOnCreate"];
            this.visible = _data["visible"];
            this.visibleOnEdit = _data["visibleOnEdit"];
            this.visibleOnCreate = _data["visibleOnCreate"];
            this.baseType = _data["baseType"];
            this.type = _data["type"] ? EntityMetaDataType.fromJS(_data["type"]) : undefined as any;
            this.attributes = _data["attributes"] ? EntityMetaTypeAttributesDto.fromJS(_data["attributes"]) : undefined as any;
        }
    }

    static fromJS(data: any): EntityColumnMetaDto {
        data = typeof data === 'object' ? data : {};
        let result = new EntityColumnMetaDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["namePrefix"] = this.namePrefix;
        data["isPrimaryKey"] = this.isPrimaryKey;
        data["isRequired"] = this.isRequired;
        data["isNullable"] = this.isNullable;
        data["allowEdit"] = this.allowEdit;
        data["allowEditOnCreate"] = this.allowEditOnCreate;
        data["visible"] = this.visible;
        data["visibleOnEdit"] = this.visibleOnEdit;
        data["visibleOnCreate"] = this.visibleOnCreate;
        data["baseType"] = this.baseType;
        data["type"] = this.type ? this.type.toJSON() : undefined as any;
        data["attributes"] = this.attributes ? this.attributes.toJSON() : undefined as any;
        return data;
    }
}

export interface IEntityColumnMetaDto {
    name?: string;
    namePrefix?: string | undefined;
    isPrimaryKey?: boolean | undefined;
    isRequired?: boolean | undefined;
    isNullable?: boolean | undefined;
    allowEdit?: boolean | undefined;
    allowEditOnCreate?: boolean | undefined;
    visible?: boolean | undefined;
    visibleOnEdit?: boolean | undefined;
    visibleOnCreate?: boolean | undefined;
    baseType?: EntityMetaBaseDataTypeEnum | undefined;
    type?: EntityMetaDataType | undefined;
    attributes?: EntityMetaTypeAttributesDto | undefined;
}

export enum EntityMetaBaseDataTypeEnum {
    String = 0,
    Number = 1,
    Amount = 2,
    Short = 3,
    Long = 4,
    DateTime = 5,
    Decimal = 6,
    DateOnly = 7,
    Boolean = 8,
    Object = 9,
    Navigation = 10,
    Details = 11,
}

export class EntityMetaDataType implements IEntityMetaDataType {
    name?: string;
    attributes?: EntityMetaDataTypeAttributes;

    constructor(data?: IEntityMetaDataType) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.attributes = _data["attributes"] ? EntityMetaDataTypeAttributes.fromJS(_data["attributes"]) : undefined as any;
        }
    }

    static fromJS(data: any): EntityMetaDataType {
        data = typeof data === 'object' ? data : {};
        let result = new EntityMetaDataType();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["attributes"] = this.attributes ? this.attributes.toJSON() : undefined as any;
        return data;
    }
}

export interface IEntityMetaDataType {
    name?: string;
    attributes?: EntityMetaDataTypeAttributes;
}

export class EntityMetaDataTypeAttributes implements IEntityMetaDataTypeAttributes {
    baseType?: EntityMetaBaseDataTypeEnum;
    isConcurrencyToken?: boolean | undefined;
    maxLength?: number | undefined;
    width?: number | undefined;
    labels?: string[];
    foreignKey?: EntityMetaForeignKey | undefined;
    isForeignKeyToSelf?: boolean | undefined;

    constructor(data?: IEntityMetaDataTypeAttributes) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.baseType = _data["baseType"];
            this.isConcurrencyToken = _data["isConcurrencyToken"];
            this.maxLength = _data["maxLength"];
            this.width = _data["width"];
            if (Array.isArray(_data["labels"])) {
                this.labels = [] as any;
                for (let item of _data["labels"])
                    this.labels!.push(item);
            }
            this.foreignKey = _data["foreignKey"] ? EntityMetaForeignKey.fromJS(_data["foreignKey"]) : undefined as any;
            this.isForeignKeyToSelf = _data["isForeignKeyToSelf"];
        }
    }

    static fromJS(data: any): EntityMetaDataTypeAttributes {
        data = typeof data === 'object' ? data : {};
        let result = new EntityMetaDataTypeAttributes();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["baseType"] = this.baseType;
        data["isConcurrencyToken"] = this.isConcurrencyToken;
        data["maxLength"] = this.maxLength;
        data["width"] = this.width;
        if (Array.isArray(this.labels)) {
            data["labels"] = [];
            for (let item of this.labels)
                data["labels"].push(item);
        }
        data["foreignKey"] = this.foreignKey ? this.foreignKey.toJSON() : undefined as any;
        data["isForeignKeyToSelf"] = this.isForeignKeyToSelf;
        return data;
    }
}

export interface IEntityMetaDataTypeAttributes {
    baseType?: EntityMetaBaseDataTypeEnum;
    isConcurrencyToken?: boolean | undefined;
    maxLength?: number | undefined;
    width?: number | undefined;
    labels?: string[];
    foreignKey?: EntityMetaForeignKey | undefined;
    isForeignKeyToSelf?: boolean | undefined;
}

export class EntityMetaForeignKey implements IEntityMetaForeignKey {
    entity?: EntityMeta;
    column?: string;
    deleteBehavior?: DeleteBehavior;
    url?: string | undefined;

    constructor(data?: IEntityMetaForeignKey) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.entity = _data["entity"] ? EntityMeta.fromJS(_data["entity"]) : undefined as any;
            this.column = _data["column"];
            this.deleteBehavior = _data["deleteBehavior"];
            this.url = _data["url"];
        }
    }

    static fromJS(data: any): EntityMetaForeignKey {
        data = typeof data === 'object' ? data : {};
        let result = new EntityMetaForeignKey();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["entity"] = this.entity ? this.entity.toJSON() : undefined as any;
        data["column"] = this.column;
        data["deleteBehavior"] = this.deleteBehavior;
        data["url"] = this.url;
        return data;
    }
}

export interface IEntityMetaForeignKey {
    entity?: EntityMeta;
    column?: string;
    deleteBehavior?: DeleteBehavior;
    url?: string | undefined;
}

export class EntityMeta implements IEntityMeta {
    id?: number;
    name?: string;
    module?: ModuleMeta;
    entityType?: string;
    entityTypeWrite?: string;
    dtoType?: string;
    queryType?: string | undefined;
    commandType?: string | undefined;
    queryOnWrite?: boolean;
    idLong?: PropertyInfo | undefined;
    idInt?: PropertyInfo | undefined;
    dataLink?: EntityMetaDataLink;
    authorization?: EntityAuthorization;

    constructor(data?: IEntityMeta) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.module = _data["module"] ? ModuleMeta.fromJS(_data["module"]) : undefined as any;
            this.entityType = _data["entityType"];
            this.entityTypeWrite = _data["entityTypeWrite"];
            this.dtoType = _data["dtoType"];
            this.queryType = _data["queryType"];
            this.commandType = _data["commandType"];
            this.queryOnWrite = _data["queryOnWrite"];
            this.idLong = _data["idLong"] ? PropertyInfo.fromJS(_data["idLong"]) : undefined as any;
            this.idInt = _data["idInt"] ? PropertyInfo.fromJS(_data["idInt"]) : undefined as any;
            this.dataLink = _data["dataLink"] ? EntityMetaDataLink.fromJS(_data["dataLink"]) : undefined as any;
            this.authorization = _data["authorization"] ? EntityAuthorization.fromJS(_data["authorization"]) : undefined as any;
        }
    }

    static fromJS(data: any): EntityMeta {
        data = typeof data === 'object' ? data : {};
        let result = new EntityMeta();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["module"] = this.module ? this.module.toJSON() : undefined as any;
        data["entityType"] = this.entityType;
        data["entityTypeWrite"] = this.entityTypeWrite;
        data["dtoType"] = this.dtoType;
        data["queryType"] = this.queryType;
        data["commandType"] = this.commandType;
        data["queryOnWrite"] = this.queryOnWrite;
        data["idLong"] = this.idLong ? this.idLong.toJSON() : undefined as any;
        data["idInt"] = this.idInt ? this.idInt.toJSON() : undefined as any;
        data["dataLink"] = this.dataLink ? this.dataLink.toJSON() : undefined as any;
        data["authorization"] = this.authorization ? this.authorization.toJSON() : undefined as any;
        return data;
    }
}

export interface IEntityMeta {
    id?: number;
    name?: string;
    module?: ModuleMeta;
    entityType?: string;
    entityTypeWrite?: string;
    dtoType?: string;
    queryType?: string | undefined;
    commandType?: string | undefined;
    queryOnWrite?: boolean;
    idLong?: PropertyInfo | undefined;
    idInt?: PropertyInfo | undefined;
    dataLink?: EntityMetaDataLink;
    authorization?: EntityAuthorization;
}

export class ModuleMeta implements IModuleMeta {
    appMetaId?: number | undefined;
    name?: string;
    module?: Module;
    adminRoles?: number[];
    userRoles?: number[];
    auditHistory?: boolean;
    auditBasic?: boolean;
    isAppMetaDb?: boolean;
    isKontraktDb?: boolean;

    constructor(data?: IModuleMeta) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.appMetaId = _data["appMetaId"];
            this.name = _data["name"];
            this.module = _data["module"] ? Module.fromJS(_data["module"]) : undefined as any;
            if (Array.isArray(_data["adminRoles"])) {
                this.adminRoles = [] as any;
                for (let item of _data["adminRoles"])
                    this.adminRoles!.push(item);
            }
            if (Array.isArray(_data["userRoles"])) {
                this.userRoles = [] as any;
                for (let item of _data["userRoles"])
                    this.userRoles!.push(item);
            }
            this.auditHistory = _data["auditHistory"];
            this.auditBasic = _data["auditBasic"];
            this.isAppMetaDb = _data["isAppMetaDb"];
            this.isKontraktDb = _data["isKontraktDb"];
        }
    }

    static fromJS(data: any): ModuleMeta {
        data = typeof data === 'object' ? data : {};
        let result = new ModuleMeta();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["appMetaId"] = this.appMetaId;
        data["name"] = this.name;
        data["module"] = this.module ? this.module.toJSON() : undefined as any;
        if (Array.isArray(this.adminRoles)) {
            data["adminRoles"] = [];
            for (let item of this.adminRoles)
                data["adminRoles"].push(item);
        }
        if (Array.isArray(this.userRoles)) {
            data["userRoles"] = [];
            for (let item of this.userRoles)
                data["userRoles"].push(item);
        }
        data["auditHistory"] = this.auditHistory;
        data["auditBasic"] = this.auditBasic;
        data["isAppMetaDb"] = this.isAppMetaDb;
        data["isKontraktDb"] = this.isKontraktDb;
        return data;
    }
}

export interface IModuleMeta {
    appMetaId?: number | undefined;
    name?: string;
    module?: Module;
    adminRoles?: number[];
    userRoles?: number[];
    auditHistory?: boolean;
    auditBasic?: boolean;
    isAppMetaDb?: boolean;
    isKontraktDb?: boolean;
}

export class Module implements IModule {
    id?: number;
    name!: string;
    created?: Date | undefined;
    createdBy?: number | undefined;
    modified?: Date | undefined;
    modifiedBy?: number | undefined;
    tables?: Table[] | undefined;

    constructor(data?: IModule) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : undefined as any;
            this.createdBy = _data["createdBy"];
            this.modified = _data["modified"] ? new Date(_data["modified"].toString()) : undefined as any;
            this.modifiedBy = _data["modifiedBy"];
            if (Array.isArray(_data["tables"])) {
                this.tables = [] as any;
                for (let item of _data["tables"])
                    this.tables!.push(Table.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Module {
        data = typeof data === 'object' ? data : {};
        let result = new Module();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["created"] = this.created ? this.created.toISOString() : undefined as any;
        data["createdBy"] = this.createdBy;
        data["modified"] = this.modified ? this.modified.toISOString() : undefined as any;
        data["modifiedBy"] = this.modifiedBy;
        if (Array.isArray(this.tables)) {
            data["tables"] = [];
            for (let item of this.tables)
                data["tables"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IModule {
    id?: number;
    name: string;
    created?: Date | undefined;
    createdBy?: number | undefined;
    modified?: Date | undefined;
    modifiedBy?: number | undefined;
    tables?: Table[] | undefined;
}

export class Table implements ITable {
    id?: number;
    name!: string;
    module?: number;
    idMigrated?: number | undefined;
    created?: Date | undefined;
    createdBy?: number | undefined;
    modified?: Date | undefined;
    modifiedBy?: number | undefined;
    moduleNavigation?: Module | undefined;

    constructor(data?: ITable) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.module = _data["module"];
            this.idMigrated = _data["idMigrated"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : undefined as any;
            this.createdBy = _data["createdBy"];
            this.modified = _data["modified"] ? new Date(_data["modified"].toString()) : undefined as any;
            this.modifiedBy = _data["modifiedBy"];
            this.moduleNavigation = _data["moduleNavigation"] ? Module.fromJS(_data["moduleNavigation"]) : undefined as any;
        }
    }

    static fromJS(data: any): Table {
        data = typeof data === 'object' ? data : {};
        let result = new Table();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["module"] = this.module;
        data["idMigrated"] = this.idMigrated;
        data["created"] = this.created ? this.created.toISOString() : undefined as any;
        data["createdBy"] = this.createdBy;
        data["modified"] = this.modified ? this.modified.toISOString() : undefined as any;
        data["modifiedBy"] = this.modifiedBy;
        data["moduleNavigation"] = this.moduleNavigation ? this.moduleNavigation.toJSON() : undefined as any;
        return data;
    }
}

export interface ITable {
    id?: number;
    name: string;
    module?: number;
    idMigrated?: number | undefined;
    created?: Date | undefined;
    createdBy?: number | undefined;
    modified?: Date | undefined;
    modifiedBy?: number | undefined;
    moduleNavigation?: Module | undefined;
}

export abstract class MemberInfo implements IMemberInfo {
    module?: Module2;
    customAttributes?: CustomAttributeData[];
    isCollectible?: boolean;
    metadataToken?: number;

    constructor(data?: IMemberInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.module = _data["module"] ? Module2.fromJS(_data["module"]) : undefined as any;
            if (Array.isArray(_data["customAttributes"])) {
                this.customAttributes = [] as any;
                for (let item of _data["customAttributes"])
                    this.customAttributes!.push(CustomAttributeData.fromJS(item));
            }
            this.isCollectible = _data["isCollectible"];
            this.metadataToken = _data["metadataToken"];
        }
    }

    static fromJS(data: any): MemberInfo {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'MemberInfo' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["module"] = this.module ? this.module.toJSON() : undefined as any;
        if (Array.isArray(this.customAttributes)) {
            data["customAttributes"] = [];
            for (let item of this.customAttributes)
                data["customAttributes"].push(item ? item.toJSON() : undefined as any);
        }
        data["isCollectible"] = this.isCollectible;
        data["metadataToken"] = this.metadataToken;
        return data;
    }
}

export interface IMemberInfo {
    module?: Module2;
    customAttributes?: CustomAttributeData[];
    isCollectible?: boolean;
    metadataToken?: number;
}

export abstract class PropertyInfo extends MemberInfo implements IPropertyInfo {
    memberType?: MemberTypes;
    isSpecialName?: boolean;
    getMethod?: MethodInfo | undefined;
    setMethod?: MethodInfo | undefined;

    constructor(data?: IPropertyInfo) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.memberType = _data["memberType"];
            this.isSpecialName = _data["isSpecialName"];
            this.getMethod = _data["getMethod"] ? MethodInfo.fromJS(_data["getMethod"]) : undefined as any;
            this.setMethod = _data["setMethod"] ? MethodInfo.fromJS(_data["setMethod"]) : undefined as any;
        }
    }

    static override fromJS(data: any): PropertyInfo {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'PropertyInfo' cannot be instantiated.");
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["memberType"] = this.memberType;
        data["isSpecialName"] = this.isSpecialName;
        data["getMethod"] = this.getMethod ? this.getMethod.toJSON() : undefined as any;
        data["setMethod"] = this.setMethod ? this.setMethod.toJSON() : undefined as any;
        super.toJSON(data);
        return data;
    }
}

export interface IPropertyInfo extends IMemberInfo {
    memberType?: MemberTypes;
    isSpecialName?: boolean;
    getMethod?: MethodInfo | undefined;
    setMethod?: MethodInfo | undefined;
}

export enum MemberTypes {
    Constructor = 1,
    Event = 2,
    Field = 4,
    Method = 8,
    Property = 16,
    TypeInfo = 32,
    Custom = 64,
    NestedType = 128,
    All = 191,
}

export abstract class MethodBase extends MemberInfo implements IMethodBase {
    methodImplementationFlags?: MethodImplAttributes;
    callingConvention?: CallingConventions;
    isAbstract?: boolean;
    isConstructor?: boolean;
    isFinal?: boolean;
    isHideBySig?: boolean;
    isSpecialName?: boolean;
    isStatic?: boolean;
    isVirtual?: boolean;
    isAssembly?: boolean;
    isFamily?: boolean;
    isFamilyAndAssembly?: boolean;
    isFamilyOrAssembly?: boolean;
    isPrivate?: boolean;
    isPublic?: boolean;
    isConstructedGenericMethod?: boolean;
    isGenericMethod?: boolean;
    isGenericMethodDefinition?: boolean;
    containsGenericParameters?: boolean;
    isSecurityCritical?: boolean;
    isSecuritySafeCritical?: boolean;
    isSecurityTransparent?: boolean;

    constructor(data?: IMethodBase) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.methodImplementationFlags = _data["methodImplementationFlags"];
            this.callingConvention = _data["callingConvention"];
            this.isAbstract = _data["isAbstract"];
            this.isConstructor = _data["isConstructor"];
            this.isFinal = _data["isFinal"];
            this.isHideBySig = _data["isHideBySig"];
            this.isSpecialName = _data["isSpecialName"];
            this.isStatic = _data["isStatic"];
            this.isVirtual = _data["isVirtual"];
            this.isAssembly = _data["isAssembly"];
            this.isFamily = _data["isFamily"];
            this.isFamilyAndAssembly = _data["isFamilyAndAssembly"];
            this.isFamilyOrAssembly = _data["isFamilyOrAssembly"];
            this.isPrivate = _data["isPrivate"];
            this.isPublic = _data["isPublic"];
            this.isConstructedGenericMethod = _data["isConstructedGenericMethod"];
            this.isGenericMethod = _data["isGenericMethod"];
            this.isGenericMethodDefinition = _data["isGenericMethodDefinition"];
            this.containsGenericParameters = _data["containsGenericParameters"];
            this.isSecurityCritical = _data["isSecurityCritical"];
            this.isSecuritySafeCritical = _data["isSecuritySafeCritical"];
            this.isSecurityTransparent = _data["isSecurityTransparent"];
        }
    }

    static override fromJS(data: any): MethodBase {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'MethodBase' cannot be instantiated.");
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["methodImplementationFlags"] = this.methodImplementationFlags;
        data["callingConvention"] = this.callingConvention;
        data["isAbstract"] = this.isAbstract;
        data["isConstructor"] = this.isConstructor;
        data["isFinal"] = this.isFinal;
        data["isHideBySig"] = this.isHideBySig;
        data["isSpecialName"] = this.isSpecialName;
        data["isStatic"] = this.isStatic;
        data["isVirtual"] = this.isVirtual;
        data["isAssembly"] = this.isAssembly;
        data["isFamily"] = this.isFamily;
        data["isFamilyAndAssembly"] = this.isFamilyAndAssembly;
        data["isFamilyOrAssembly"] = this.isFamilyOrAssembly;
        data["isPrivate"] = this.isPrivate;
        data["isPublic"] = this.isPublic;
        data["isConstructedGenericMethod"] = this.isConstructedGenericMethod;
        data["isGenericMethod"] = this.isGenericMethod;
        data["isGenericMethodDefinition"] = this.isGenericMethodDefinition;
        data["containsGenericParameters"] = this.containsGenericParameters;
        data["isSecurityCritical"] = this.isSecurityCritical;
        data["isSecuritySafeCritical"] = this.isSecuritySafeCritical;
        data["isSecurityTransparent"] = this.isSecurityTransparent;
        super.toJSON(data);
        return data;
    }
}

export interface IMethodBase extends IMemberInfo {
    methodImplementationFlags?: MethodImplAttributes;
    callingConvention?: CallingConventions;
    isAbstract?: boolean;
    isConstructor?: boolean;
    isFinal?: boolean;
    isHideBySig?: boolean;
    isSpecialName?: boolean;
    isStatic?: boolean;
    isVirtual?: boolean;
    isAssembly?: boolean;
    isFamily?: boolean;
    isFamilyAndAssembly?: boolean;
    isFamilyOrAssembly?: boolean;
    isPrivate?: boolean;
    isPublic?: boolean;
    isConstructedGenericMethod?: boolean;
    isGenericMethod?: boolean;
    isGenericMethodDefinition?: boolean;
    containsGenericParameters?: boolean;
    isSecurityCritical?: boolean;
    isSecuritySafeCritical?: boolean;
    isSecurityTransparent?: boolean;
}

export abstract class MethodInfo extends MethodBase implements IMethodInfo {
    memberType?: MemberTypes;
    returnParameter?: ParameterInfo;
    returnType?: string;

    constructor(data?: IMethodInfo) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.memberType = _data["memberType"];
            this.returnParameter = _data["returnParameter"] ? ParameterInfo.fromJS(_data["returnParameter"]) : undefined as any;
            this.returnType = _data["returnType"];
        }
    }

    static override fromJS(data: any): MethodInfo {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'MethodInfo' cannot be instantiated.");
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["memberType"] = this.memberType;
        data["returnParameter"] = this.returnParameter ? this.returnParameter.toJSON() : undefined as any;
        data["returnType"] = this.returnType;
        super.toJSON(data);
        return data;
    }
}

export interface IMethodInfo extends IMethodBase {
    memberType?: MemberTypes;
    returnParameter?: ParameterInfo;
    returnType?: string;
}

export class ParameterInfo implements IParameterInfo {
    attributes?: ParameterAttributes;
    member?: MemberInfo;
    name?: string | undefined;
    parameterType?: string;
    position?: number;
    isIn?: boolean;
    isLcid?: boolean;
    isOptional?: boolean;
    isOut?: boolean;
    isRetval?: boolean;
    defaultValue?: any | undefined;
    rawDefaultValue?: any | undefined;
    hasDefaultValue?: boolean;
    customAttributes?: CustomAttributeData[];
    metadataToken?: number;

    constructor(data?: IParameterInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.attributes = _data["attributes"];
            this.member = _data["member"] ? MemberInfo.fromJS(_data["member"]) : undefined as any;
            this.name = _data["name"];
            this.parameterType = _data["parameterType"];
            this.position = _data["position"];
            this.isIn = _data["isIn"];
            this.isLcid = _data["isLcid"];
            this.isOptional = _data["isOptional"];
            this.isOut = _data["isOut"];
            this.isRetval = _data["isRetval"];
            this.defaultValue = _data["defaultValue"];
            this.rawDefaultValue = _data["rawDefaultValue"];
            this.hasDefaultValue = _data["hasDefaultValue"];
            if (Array.isArray(_data["customAttributes"])) {
                this.customAttributes = [] as any;
                for (let item of _data["customAttributes"])
                    this.customAttributes!.push(CustomAttributeData.fromJS(item));
            }
            this.metadataToken = _data["metadataToken"];
        }
    }

    static fromJS(data: any): ParameterInfo {
        data = typeof data === 'object' ? data : {};
        let result = new ParameterInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["attributes"] = this.attributes;
        data["member"] = this.member ? this.member.toJSON() : undefined as any;
        data["name"] = this.name;
        data["parameterType"] = this.parameterType;
        data["position"] = this.position;
        data["isIn"] = this.isIn;
        data["isLcid"] = this.isLcid;
        data["isOptional"] = this.isOptional;
        data["isOut"] = this.isOut;
        data["isRetval"] = this.isRetval;
        data["defaultValue"] = this.defaultValue;
        data["rawDefaultValue"] = this.rawDefaultValue;
        data["hasDefaultValue"] = this.hasDefaultValue;
        if (Array.isArray(this.customAttributes)) {
            data["customAttributes"] = [];
            for (let item of this.customAttributes)
                data["customAttributes"].push(item ? item.toJSON() : undefined as any);
        }
        data["metadataToken"] = this.metadataToken;
        return data;
    }
}

export interface IParameterInfo {
    attributes?: ParameterAttributes;
    member?: MemberInfo;
    name?: string | undefined;
    parameterType?: string;
    position?: number;
    isIn?: boolean;
    isLcid?: boolean;
    isOptional?: boolean;
    isOut?: boolean;
    isRetval?: boolean;
    defaultValue?: any | undefined;
    rawDefaultValue?: any | undefined;
    hasDefaultValue?: boolean;
    customAttributes?: CustomAttributeData[];
    metadataToken?: number;
}

export enum ParameterAttributes {
    None = 0,
    In = 1,
    Out = 2,
    Lcid = 4,
    Retval = 8,
    Optional = 16,
    HasDefault = 4096,
    HasFieldMarshal = 8192,
    Reserved3 = 16384,
    Reserved4 = 32768,
    ReservedMask = 61440,
}

export abstract class Module2 implements IModule2 {
    assembly?: Assembly;
    fullyQualifiedName?: string;
    name?: string;
    mdStreamVersion?: number;
    moduleVersionId?: string;
    scopeName?: string;
    moduleHandle?: ModuleHandle;
    customAttributes?: CustomAttributeData[];
    metadataToken?: number;

    constructor(data?: IModule2) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.assembly = _data["assembly"] ? Assembly.fromJS(_data["assembly"]) : undefined as any;
            this.fullyQualifiedName = _data["fullyQualifiedName"];
            this.name = _data["name"];
            this.mdStreamVersion = _data["mdStreamVersion"];
            this.moduleVersionId = _data["moduleVersionId"];
            this.scopeName = _data["scopeName"];
            this.moduleHandle = _data["moduleHandle"] ? ModuleHandle.fromJS(_data["moduleHandle"]) : undefined as any;
            if (Array.isArray(_data["customAttributes"])) {
                this.customAttributes = [] as any;
                for (let item of _data["customAttributes"])
                    this.customAttributes!.push(CustomAttributeData.fromJS(item));
            }
            this.metadataToken = _data["metadataToken"];
        }
    }

    static fromJS(data: any): Module2 {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'Module2' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["assembly"] = this.assembly ? this.assembly.toJSON() : undefined as any;
        data["fullyQualifiedName"] = this.fullyQualifiedName;
        data["name"] = this.name;
        data["mdStreamVersion"] = this.mdStreamVersion;
        data["moduleVersionId"] = this.moduleVersionId;
        data["scopeName"] = this.scopeName;
        data["moduleHandle"] = this.moduleHandle ? this.moduleHandle.toJSON() : undefined as any;
        if (Array.isArray(this.customAttributes)) {
            data["customAttributes"] = [];
            for (let item of this.customAttributes)
                data["customAttributes"].push(item ? item.toJSON() : undefined as any);
        }
        data["metadataToken"] = this.metadataToken;
        return data;
    }
}

export interface IModule2 {
    assembly?: Assembly;
    fullyQualifiedName?: string;
    name?: string;
    mdStreamVersion?: number;
    moduleVersionId?: string;
    scopeName?: string;
    moduleHandle?: ModuleHandle;
    customAttributes?: CustomAttributeData[];
    metadataToken?: number;
}

export abstract class Assembly implements IAssembly {
    definedTypes?: string[];
    exportedTypes?: string[];
    codeBase?: string | undefined;
    entryPoint?: MethodInfo | undefined;
    fullName?: string | undefined;
    imageRuntimeVersion?: string;
    isDynamic?: boolean;
    location?: string;
    reflectionOnly?: boolean;
    isCollectible?: boolean;
    isFullyTrusted?: boolean;
    customAttributes?: CustomAttributeData[];
    escapedCodeBase?: string;
    manifestModule?: Module2;
    modules?: Module2[];
    globalAssemblyCache?: boolean;
    hostContext?: number;
    securityRuleSet?: SecurityRuleSet;

    constructor(data?: IAssembly) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["definedTypes"])) {
                this.definedTypes = [] as any;
                for (let item of _data["definedTypes"])
                    this.definedTypes!.push(item);
            }
            if (Array.isArray(_data["exportedTypes"])) {
                this.exportedTypes = [] as any;
                for (let item of _data["exportedTypes"])
                    this.exportedTypes!.push(item);
            }
            this.codeBase = _data["codeBase"];
            this.entryPoint = _data["entryPoint"] ? MethodInfo.fromJS(_data["entryPoint"]) : undefined as any;
            this.fullName = _data["fullName"];
            this.imageRuntimeVersion = _data["imageRuntimeVersion"];
            this.isDynamic = _data["isDynamic"];
            this.location = _data["location"];
            this.reflectionOnly = _data["reflectionOnly"];
            this.isCollectible = _data["isCollectible"];
            this.isFullyTrusted = _data["isFullyTrusted"];
            if (Array.isArray(_data["customAttributes"])) {
                this.customAttributes = [] as any;
                for (let item of _data["customAttributes"])
                    this.customAttributes!.push(CustomAttributeData.fromJS(item));
            }
            this.escapedCodeBase = _data["escapedCodeBase"];
            this.manifestModule = _data["manifestModule"] ? Module2.fromJS(_data["manifestModule"]) : undefined as any;
            if (Array.isArray(_data["modules"])) {
                this.modules = [] as any;
                for (let item of _data["modules"])
                    this.modules!.push(Module2.fromJS(item));
            }
            this.globalAssemblyCache = _data["globalAssemblyCache"];
            this.hostContext = _data["hostContext"];
            this.securityRuleSet = _data["securityRuleSet"];
        }
    }

    static fromJS(data: any): Assembly {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'Assembly' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.definedTypes)) {
            data["definedTypes"] = [];
            for (let item of this.definedTypes)
                data["definedTypes"].push(item);
        }
        if (Array.isArray(this.exportedTypes)) {
            data["exportedTypes"] = [];
            for (let item of this.exportedTypes)
                data["exportedTypes"].push(item);
        }
        data["codeBase"] = this.codeBase;
        data["entryPoint"] = this.entryPoint ? this.entryPoint.toJSON() : undefined as any;
        data["fullName"] = this.fullName;
        data["imageRuntimeVersion"] = this.imageRuntimeVersion;
        data["isDynamic"] = this.isDynamic;
        data["location"] = this.location;
        data["reflectionOnly"] = this.reflectionOnly;
        data["isCollectible"] = this.isCollectible;
        data["isFullyTrusted"] = this.isFullyTrusted;
        if (Array.isArray(this.customAttributes)) {
            data["customAttributes"] = [];
            for (let item of this.customAttributes)
                data["customAttributes"].push(item ? item.toJSON() : undefined as any);
        }
        data["escapedCodeBase"] = this.escapedCodeBase;
        data["manifestModule"] = this.manifestModule ? this.manifestModule.toJSON() : undefined as any;
        if (Array.isArray(this.modules)) {
            data["modules"] = [];
            for (let item of this.modules)
                data["modules"].push(item ? item.toJSON() : undefined as any);
        }
        data["globalAssemblyCache"] = this.globalAssemblyCache;
        data["hostContext"] = this.hostContext;
        data["securityRuleSet"] = this.securityRuleSet;
        return data;
    }
}

export interface IAssembly {
    definedTypes?: string[];
    exportedTypes?: string[];
    codeBase?: string | undefined;
    entryPoint?: MethodInfo | undefined;
    fullName?: string | undefined;
    imageRuntimeVersion?: string;
    isDynamic?: boolean;
    location?: string;
    reflectionOnly?: boolean;
    isCollectible?: boolean;
    isFullyTrusted?: boolean;
    customAttributes?: CustomAttributeData[];
    escapedCodeBase?: string;
    manifestModule?: Module2;
    modules?: Module2[];
    globalAssemblyCache?: boolean;
    hostContext?: number;
    securityRuleSet?: SecurityRuleSet;
}

export class CustomAttributeData implements ICustomAttributeData {
    attributeType?: string;
    constructor_?: ConstructorInfo;
    constructorArguments?: CustomAttributeTypedArgument[];
    namedArguments?: CustomAttributeNamedArgument[];

    constructor(data?: ICustomAttributeData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.attributeType = _data["attributeType"];
            this.constructor_ = _data["constructor"] ? ConstructorInfo.fromJS(_data["constructor"]) : undefined as any;
            if (Array.isArray(_data["constructorArguments"])) {
                this.constructorArguments = [] as any;
                for (let item of _data["constructorArguments"])
                    this.constructorArguments!.push(CustomAttributeTypedArgument.fromJS(item));
            }
            if (Array.isArray(_data["namedArguments"])) {
                this.namedArguments = [] as any;
                for (let item of _data["namedArguments"])
                    this.namedArguments!.push(CustomAttributeNamedArgument.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CustomAttributeData {
        data = typeof data === 'object' ? data : {};
        let result = new CustomAttributeData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["attributeType"] = this.attributeType;
        data["constructor"] = this.constructor_ ? this.constructor_.toJSON() : undefined as any;
        if (Array.isArray(this.constructorArguments)) {
            data["constructorArguments"] = [];
            for (let item of this.constructorArguments)
                data["constructorArguments"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.namedArguments)) {
            data["namedArguments"] = [];
            for (let item of this.namedArguments)
                data["namedArguments"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ICustomAttributeData {
    attributeType?: string;
    constructor_?: ConstructorInfo;
    constructorArguments?: CustomAttributeTypedArgument[];
    namedArguments?: CustomAttributeNamedArgument[];
}

export abstract class ConstructorInfo extends MethodBase implements IConstructorInfo {
    memberType?: MemberTypes;

    constructor(data?: IConstructorInfo) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.memberType = _data["memberType"];
        }
    }

    static override fromJS(data: any): ConstructorInfo {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'ConstructorInfo' cannot be instantiated.");
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["memberType"] = this.memberType;
        super.toJSON(data);
        return data;
    }
}

export interface IConstructorInfo extends IMethodBase {
    memberType?: MemberTypes;
}

export enum MethodImplAttributes {
    IL = 0,
    Managed = 0,
    Native = 1,
    OPTIL = 2,
    CodeTypeMask = 3,
    Runtime = 3,
    ManagedMask = 4,
    Unmanaged = 4,
    NoInlining = 8,
    ForwardRef = 16,
    Synchronized = 32,
    NoOptimization = 64,
    PreserveSig = 128,
    AggressiveInlining = 256,
    AggressiveOptimization = 512,
    InternalCall = 4096,
    Async = 8192,
    MaxMethodImplVal = 65535,
}

export enum CallingConventions {
    Standard = 1,
    VarArgs = 2,
    Any = 3,
    HasThis = 32,
    ExplicitThis = 64,
}

export class CustomAttributeTypedArgument implements ICustomAttributeTypedArgument {
    argumentType?: string;
    value?: any | undefined;

    constructor(data?: ICustomAttributeTypedArgument) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.argumentType = _data["argumentType"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): CustomAttributeTypedArgument {
        data = typeof data === 'object' ? data : {};
        let result = new CustomAttributeTypedArgument();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["argumentType"] = this.argumentType;
        data["value"] = this.value;
        return data;
    }
}

export interface ICustomAttributeTypedArgument {
    argumentType?: string;
    value?: any | undefined;
}

export class CustomAttributeNamedArgument implements ICustomAttributeNamedArgument {
    memberInfo?: MemberInfo;
    typedValue?: CustomAttributeTypedArgument;
    memberName?: string;
    isField?: boolean;

    constructor(data?: ICustomAttributeNamedArgument) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.memberInfo = _data["memberInfo"] ? MemberInfo.fromJS(_data["memberInfo"]) : undefined as any;
            this.typedValue = _data["typedValue"] ? CustomAttributeTypedArgument.fromJS(_data["typedValue"]) : undefined as any;
            this.memberName = _data["memberName"];
            this.isField = _data["isField"];
        }
    }

    static fromJS(data: any): CustomAttributeNamedArgument {
        data = typeof data === 'object' ? data : {};
        let result = new CustomAttributeNamedArgument();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["memberInfo"] = this.memberInfo ? this.memberInfo.toJSON() : undefined as any;
        data["typedValue"] = this.typedValue ? this.typedValue.toJSON() : undefined as any;
        data["memberName"] = this.memberName;
        data["isField"] = this.isField;
        return data;
    }
}

export interface ICustomAttributeNamedArgument {
    memberInfo?: MemberInfo;
    typedValue?: CustomAttributeTypedArgument;
    memberName?: string;
    isField?: boolean;
}

export enum SecurityRuleSet {
    None = 0,
    Level1 = 1,
    Level2 = 2,
}

export class ModuleHandle implements IModuleHandle {
    mdStreamVersion?: number;

    constructor(data?: IModuleHandle) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.mdStreamVersion = _data["mdStreamVersion"];
        }
    }

    static fromJS(data: any): ModuleHandle {
        data = typeof data === 'object' ? data : {};
        let result = new ModuleHandle();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["mdStreamVersion"] = this.mdStreamVersion;
        return data;
    }
}

export interface IModuleHandle {
    mdStreamVersion?: number;
}

export class EntityMetaDataLink implements IEntityMetaDataLink {
    type?: string | undefined;
    entityIsDataLinkChild?: boolean | undefined;
    queryInclude?: boolean;
    auditHistory?: boolean | undefined;
    auditCreatedModifiedSync?: boolean | undefined;
    chat?: boolean | undefined;
    attachment?: boolean | undefined;
    notification?: boolean | undefined;
    vmDtoImplemented?: boolean | undefined;
    documentLib?: number | undefined;
    documentLibPath?: string | undefined;

    constructor(data?: IEntityMetaDataLink) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.type = _data["type"];
            this.entityIsDataLinkChild = _data["entityIsDataLinkChild"];
            this.queryInclude = _data["queryInclude"];
            this.auditHistory = _data["auditHistory"];
            this.auditCreatedModifiedSync = _data["auditCreatedModifiedSync"];
            this.chat = _data["chat"];
            this.attachment = _data["attachment"];
            this.notification = _data["notification"];
            this.vmDtoImplemented = _data["vmDtoImplemented"];
            this.documentLib = _data["documentLib"];
            this.documentLibPath = _data["documentLibPath"];
        }
    }

    static fromJS(data: any): EntityMetaDataLink {
        data = typeof data === 'object' ? data : {};
        let result = new EntityMetaDataLink();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type;
        data["entityIsDataLinkChild"] = this.entityIsDataLinkChild;
        data["queryInclude"] = this.queryInclude;
        data["auditHistory"] = this.auditHistory;
        data["auditCreatedModifiedSync"] = this.auditCreatedModifiedSync;
        data["chat"] = this.chat;
        data["attachment"] = this.attachment;
        data["notification"] = this.notification;
        data["vmDtoImplemented"] = this.vmDtoImplemented;
        data["documentLib"] = this.documentLib;
        data["documentLibPath"] = this.documentLibPath;
        return data;
    }
}

export interface IEntityMetaDataLink {
    type?: string | undefined;
    entityIsDataLinkChild?: boolean | undefined;
    queryInclude?: boolean;
    auditHistory?: boolean | undefined;
    auditCreatedModifiedSync?: boolean | undefined;
    chat?: boolean | undefined;
    attachment?: boolean | undefined;
    notification?: boolean | undefined;
    vmDtoImplemented?: boolean | undefined;
    documentLib?: number | undefined;
    documentLibPath?: string | undefined;
}

export class EntityAuthorization implements IEntityAuthorization {
    maxAccess?: EntityMetaAccessLevelEnum;
    userMaxAccess?: EntityMetaAccessLevelEnum | undefined;
    readRoles?: number[] | undefined;
    createRoles?: number[] | undefined;
    updateRoles?: number[] | undefined;
    deleteRoles?: number[] | undefined;

    constructor(data?: IEntityAuthorization) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.maxAccess = _data["maxAccess"];
            this.userMaxAccess = _data["userMaxAccess"];
            if (Array.isArray(_data["readRoles"])) {
                this.readRoles = [] as any;
                for (let item of _data["readRoles"])
                    this.readRoles!.push(item);
            }
            if (Array.isArray(_data["createRoles"])) {
                this.createRoles = [] as any;
                for (let item of _data["createRoles"])
                    this.createRoles!.push(item);
            }
            if (Array.isArray(_data["updateRoles"])) {
                this.updateRoles = [] as any;
                for (let item of _data["updateRoles"])
                    this.updateRoles!.push(item);
            }
            if (Array.isArray(_data["deleteRoles"])) {
                this.deleteRoles = [] as any;
                for (let item of _data["deleteRoles"])
                    this.deleteRoles!.push(item);
            }
        }
    }

    static fromJS(data: any): EntityAuthorization {
        data = typeof data === 'object' ? data : {};
        let result = new EntityAuthorization();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["maxAccess"] = this.maxAccess;
        data["userMaxAccess"] = this.userMaxAccess;
        if (Array.isArray(this.readRoles)) {
            data["readRoles"] = [];
            for (let item of this.readRoles)
                data["readRoles"].push(item);
        }
        if (Array.isArray(this.createRoles)) {
            data["createRoles"] = [];
            for (let item of this.createRoles)
                data["createRoles"].push(item);
        }
        if (Array.isArray(this.updateRoles)) {
            data["updateRoles"] = [];
            for (let item of this.updateRoles)
                data["updateRoles"].push(item);
        }
        if (Array.isArray(this.deleteRoles)) {
            data["deleteRoles"] = [];
            for (let item of this.deleteRoles)
                data["deleteRoles"].push(item);
        }
        return data;
    }
}

export interface IEntityAuthorization {
    maxAccess?: EntityMetaAccessLevelEnum;
    userMaxAccess?: EntityMetaAccessLevelEnum | undefined;
    readRoles?: number[] | undefined;
    createRoles?: number[] | undefined;
    updateRoles?: number[] | undefined;
    deleteRoles?: number[] | undefined;
}

export enum EntityMetaAccessLevelEnum {
    None = 0,
    Read = 1,
    Create = 2,
    Update = 3,
    Delete = 4,
}

export enum DeleteBehavior {
    ClientSetNull = 0,
    Restrict = 1,
    SetNull = 2,
    Cascade = 3,
    ClientCascade = 4,
    NoAction = 5,
    ClientNoAction = 6,
}

export class EntityMetaTypeAttributesDto implements IEntityMetaTypeAttributesDto {
    baseType?: EntityMetaBaseDataTypeEnum;
    isConcurrencyToken?: boolean | undefined;
    maxLength?: number | undefined;
    width?: number | undefined;
    labels?: string[] | undefined;
    foreignKey?: EntityMetaForeignKeyDto | undefined;
    isForeignKeyToSelf?: boolean | undefined;

    constructor(data?: IEntityMetaTypeAttributesDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.baseType = _data["baseType"];
            this.isConcurrencyToken = _data["isConcurrencyToken"];
            this.maxLength = _data["maxLength"];
            this.width = _data["width"];
            if (Array.isArray(_data["labels"])) {
                this.labels = [] as any;
                for (let item of _data["labels"])
                    this.labels!.push(item);
            }
            this.foreignKey = _data["foreignKey"] ? EntityMetaForeignKeyDto.fromJS(_data["foreignKey"]) : undefined as any;
            this.isForeignKeyToSelf = _data["isForeignKeyToSelf"];
        }
    }

    static fromJS(data: any): EntityMetaTypeAttributesDto {
        data = typeof data === 'object' ? data : {};
        let result = new EntityMetaTypeAttributesDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["baseType"] = this.baseType;
        data["isConcurrencyToken"] = this.isConcurrencyToken;
        data["maxLength"] = this.maxLength;
        data["width"] = this.width;
        if (Array.isArray(this.labels)) {
            data["labels"] = [];
            for (let item of this.labels)
                data["labels"].push(item);
        }
        data["foreignKey"] = this.foreignKey ? this.foreignKey.toJSON() : undefined as any;
        data["isForeignKeyToSelf"] = this.isForeignKeyToSelf;
        return data;
    }
}

export interface IEntityMetaTypeAttributesDto {
    baseType?: EntityMetaBaseDataTypeEnum;
    isConcurrencyToken?: boolean | undefined;
    maxLength?: number | undefined;
    width?: number | undefined;
    labels?: string[] | undefined;
    foreignKey?: EntityMetaForeignKeyDto | undefined;
    isForeignKeyToSelf?: boolean | undefined;
}

export class EntityMetaForeignKeyDto implements IEntityMetaForeignKeyDto {
    entity?: string;
    column?: string;
    parentEntity?: string | undefined;
    parentColumn?: string | undefined;
    deleteBehavior?: DeleteBehavior;
    url?: string | undefined;

    constructor(data?: IEntityMetaForeignKeyDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.entity = _data["entity"];
            this.column = _data["column"];
            this.parentEntity = _data["parentEntity"];
            this.parentColumn = _data["parentColumn"];
            this.deleteBehavior = _data["deleteBehavior"];
            this.url = _data["url"];
        }
    }

    static fromJS(data: any): EntityMetaForeignKeyDto {
        data = typeof data === 'object' ? data : {};
        let result = new EntityMetaForeignKeyDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["entity"] = this.entity;
        data["column"] = this.column;
        data["parentEntity"] = this.parentEntity;
        data["parentColumn"] = this.parentColumn;
        data["deleteBehavior"] = this.deleteBehavior;
        data["url"] = this.url;
        return data;
    }
}

export interface IEntityMetaForeignKeyDto {
    entity?: string;
    column?: string;
    parentEntity?: string | undefined;
    parentColumn?: string | undefined;
    deleteBehavior?: DeleteBehavior;
    url?: string | undefined;
}

export class ModuleMetaDto implements IModuleMetaDto {
    name?: string | undefined;
    access?: EntityMetaAccessLevelEnum;

    constructor(data?: IModuleMetaDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.access = _data["access"];
        }
    }

    static fromJS(data: any): ModuleMetaDto {
        data = typeof data === 'object' ? data : {};
        let result = new ModuleMetaDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["access"] = this.access;
        return data;
    }
}

export interface IModuleMetaDto {
    name?: string | undefined;
    access?: EntityMetaAccessLevelEnum;
}

export class DataResponse implements IDataResponse {
    items?: any[];
    count?: number;

    constructor(data?: IDataResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["Items"])) {
                this.items = [] as any;
                for (let item of _data["Items"])
                    this.items!.push(item);
            }
            this.count = _data["Count"];
        }
    }

    static fromJS(data: any): DataResponse {
        data = typeof data === 'object' ? data : {};
        let result = new DataResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["Items"] = [];
            for (let item of this.items)
                data["Items"].push(item);
        }
        data["Count"] = this.count;
        return data;
    }
}

export interface IDataResponse {
    items?: any[];
    count?: number;
}

export class BankAccountTransactionDto implements IBankAccountTransactionDto {
    id?: number | undefined;
    bankAccount?: number | undefined;
    source?: number | undefined;
    sourceBatch?: number | undefined;
    sourceId?: number | undefined;
    voucherNum?: string | undefined;
    transDate?: Date | undefined;
    bankTransId?: string | undefined;
    bankTransType?: string | undefined;
    currency?: number | undefined;
    amountCur?: number | undefined;
    amount?: number | undefined;
    balance?: number | undefined;
    exchRate?: number | undefined;
    txt?: string | undefined;
    authReference?: string | undefined;
    status?: number | undefined;
    bankCreditCard?: number | undefined;
    user?: number | undefined;
    created?: Date | undefined;
    createdBy?: number | undefined;
    modified?: Date | undefined;
    modifiedBy?: number | undefined;

    constructor(data?: IBankAccountTransactionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.bankAccount = _data["bankAccount"];
            this.source = _data["source"];
            this.sourceBatch = _data["sourceBatch"];
            this.sourceId = _data["sourceId"];
            this.voucherNum = _data["voucherNum"];
            this.transDate = _data["transDate"] ? new Date(_data["transDate"].toString()) : undefined as any;
            this.bankTransId = _data["bankTransId"];
            this.bankTransType = _data["bankTransType"];
            this.currency = _data["currency"];
            this.amountCur = _data["amountCur"];
            this.amount = _data["amount"];
            this.balance = _data["balance"];
            this.exchRate = _data["exchRate"];
            this.txt = _data["txt"];
            this.authReference = _data["authReference"];
            this.status = _data["status"];
            this.bankCreditCard = _data["bankCreditCard"];
            this.user = _data["user"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : undefined as any;
            this.createdBy = _data["createdBy"];
            this.modified = _data["modified"] ? new Date(_data["modified"].toString()) : undefined as any;
            this.modifiedBy = _data["modifiedBy"];
        }
    }

    static fromJS(data: any): BankAccountTransactionDto {
        data = typeof data === 'object' ? data : {};
        let result = new BankAccountTransactionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["bankAccount"] = this.bankAccount;
        data["source"] = this.source;
        data["sourceBatch"] = this.sourceBatch;
        data["sourceId"] = this.sourceId;
        data["voucherNum"] = this.voucherNum;
        data["transDate"] = this.transDate ? this.transDate.toISOString() : undefined as any;
        data["bankTransId"] = this.bankTransId;
        data["bankTransType"] = this.bankTransType;
        data["currency"] = this.currency;
        data["amountCur"] = this.amountCur;
        data["amount"] = this.amount;
        data["balance"] = this.balance;
        data["exchRate"] = this.exchRate;
        data["txt"] = this.txt;
        data["authReference"] = this.authReference;
        data["status"] = this.status;
        data["bankCreditCard"] = this.bankCreditCard;
        data["user"] = this.user;
        data["created"] = this.created ? this.created.toISOString() : undefined as any;
        data["createdBy"] = this.createdBy;
        data["modified"] = this.modified ? this.modified.toISOString() : undefined as any;
        data["modifiedBy"] = this.modifiedBy;
        return data;
    }
}

export interface IBankAccountTransactionDto {
    id?: number | undefined;
    bankAccount?: number | undefined;
    source?: number | undefined;
    sourceBatch?: number | undefined;
    sourceId?: number | undefined;
    voucherNum?: string | undefined;
    transDate?: Date | undefined;
    bankTransId?: string | undefined;
    bankTransType?: string | undefined;
    currency?: number | undefined;
    amountCur?: number | undefined;
    amount?: number | undefined;
    balance?: number | undefined;
    exchRate?: number | undefined;
    txt?: string | undefined;
    authReference?: string | undefined;
    status?: number | undefined;
    bankCreditCard?: number | undefined;
    user?: number | undefined;
    created?: Date | undefined;
    createdBy?: number | undefined;
    modified?: Date | undefined;
    modifiedBy?: number | undefined;
}

export class BankAccountSettlementStatusSetCommand implements IBankAccountSettlementStatusSetCommand {
    settlementId?: number;
    status?: BankSettlementStatusEnum;

    constructor(data?: IBankAccountSettlementStatusSetCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.settlementId = _data["settlementId"];
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): BankAccountSettlementStatusSetCommand {
        data = typeof data === 'object' ? data : {};
        let result = new BankAccountSettlementStatusSetCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["settlementId"] = this.settlementId;
        data["status"] = this.status;
        return data;
    }
}

export interface IBankAccountSettlementStatusSetCommand {
    settlementId?: number;
    status?: BankSettlementStatusEnum;
}

export enum BankSettlementStatusEnum {
    Open = 1,
    Postponed = 2,
    Requested = 3,
    Selected = 4,
    Settled = 5,
    PendingApproval = 6,
    OnHold = 7,
    Approved = 8,
    Created = 9,
    Draft = 10,
}

export class BankTransactionSuggestSettlementResult implements IBankTransactionSuggestSettlementResult {
    isMatch?: boolean;
    rule?: BankAccountSettlementRule | undefined;
    voucherTransMatchList?: BankAccountTransaction[] | undefined;
    bankTransMatchList?: BankAccountTransaction[] | undefined;

    constructor(data?: IBankTransactionSuggestSettlementResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isMatch = _data["isMatch"];
            this.rule = _data["rule"] ? BankAccountSettlementRule.fromJS(_data["rule"]) : undefined as any;
            if (Array.isArray(_data["voucherTransMatchList"])) {
                this.voucherTransMatchList = [] as any;
                for (let item of _data["voucherTransMatchList"])
                    this.voucherTransMatchList!.push(BankAccountTransaction.fromJS(item));
            }
            if (Array.isArray(_data["bankTransMatchList"])) {
                this.bankTransMatchList = [] as any;
                for (let item of _data["bankTransMatchList"])
                    this.bankTransMatchList!.push(BankAccountTransaction.fromJS(item));
            }
        }
    }

    static fromJS(data: any): BankTransactionSuggestSettlementResult {
        data = typeof data === 'object' ? data : {};
        let result = new BankTransactionSuggestSettlementResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isMatch"] = this.isMatch;
        data["rule"] = this.rule ? this.rule.toJSON() : undefined as any;
        if (Array.isArray(this.voucherTransMatchList)) {
            data["voucherTransMatchList"] = [];
            for (let item of this.voucherTransMatchList)
                data["voucherTransMatchList"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.bankTransMatchList)) {
            data["bankTransMatchList"] = [];
            for (let item of this.bankTransMatchList)
                data["bankTransMatchList"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IBankTransactionSuggestSettlementResult {
    isMatch?: boolean;
    rule?: BankAccountSettlementRule | undefined;
    voucherTransMatchList?: BankAccountTransaction[] | undefined;
    bankTransMatchList?: BankAccountTransaction[] | undefined;
}

export class BankAccountSettlementRule implements IBankAccountSettlementRule {
    id?: number;
    name!: string;
    bankAccount?: number | undefined;
    active?: boolean;
    priority?: number;
    bankTransType?: string | undefined;
    bankAuthReferenceRequired?: boolean;
    voucherAuthReferenceRequired?: boolean;
    userMatchRequired?: boolean;
    maxAmtCurDiffPositive?: number | undefined;
    maxAmtCurDiffNegative?: number | undefined;
    maxAmtPctDiffPositive?: number | undefined;
    maxAmtPctDiffNegative?: number | undefined;
    maxDaysDiffPositive?: number | undefined;
    maxDaysDiffNegative?: number | undefined;
    ledgerAccountDiff?: string | undefined;
    created?: Date | undefined;
    createdBy?: number | undefined;
    modified?: Date | undefined;
    modifiedBy?: number | undefined;
    bankAccountNavigation?: BankAccount | undefined;

    constructor(data?: IBankAccountSettlementRule) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.bankAccount = _data["bankAccount"];
            this.active = _data["active"];
            this.priority = _data["priority"];
            this.bankTransType = _data["bankTransType"];
            this.bankAuthReferenceRequired = _data["bankAuthReferenceRequired"];
            this.voucherAuthReferenceRequired = _data["voucherAuthReferenceRequired"];
            this.userMatchRequired = _data["userMatchRequired"];
            this.maxAmtCurDiffPositive = _data["maxAmtCurDiffPositive"];
            this.maxAmtCurDiffNegative = _data["maxAmtCurDiffNegative"];
            this.maxAmtPctDiffPositive = _data["maxAmtPctDiffPositive"];
            this.maxAmtPctDiffNegative = _data["maxAmtPctDiffNegative"];
            this.maxDaysDiffPositive = _data["maxDaysDiffPositive"];
            this.maxDaysDiffNegative = _data["maxDaysDiffNegative"];
            this.ledgerAccountDiff = _data["ledgerAccountDiff"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : undefined as any;
            this.createdBy = _data["createdBy"];
            this.modified = _data["modified"] ? new Date(_data["modified"].toString()) : undefined as any;
            this.modifiedBy = _data["modifiedBy"];
            this.bankAccountNavigation = _data["bankAccountNavigation"] ? BankAccount.fromJS(_data["bankAccountNavigation"]) : undefined as any;
        }
    }

    static fromJS(data: any): BankAccountSettlementRule {
        data = typeof data === 'object' ? data : {};
        let result = new BankAccountSettlementRule();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["bankAccount"] = this.bankAccount;
        data["active"] = this.active;
        data["priority"] = this.priority;
        data["bankTransType"] = this.bankTransType;
        data["bankAuthReferenceRequired"] = this.bankAuthReferenceRequired;
        data["voucherAuthReferenceRequired"] = this.voucherAuthReferenceRequired;
        data["userMatchRequired"] = this.userMatchRequired;
        data["maxAmtCurDiffPositive"] = this.maxAmtCurDiffPositive;
        data["maxAmtCurDiffNegative"] = this.maxAmtCurDiffNegative;
        data["maxAmtPctDiffPositive"] = this.maxAmtPctDiffPositive;
        data["maxAmtPctDiffNegative"] = this.maxAmtPctDiffNegative;
        data["maxDaysDiffPositive"] = this.maxDaysDiffPositive;
        data["maxDaysDiffNegative"] = this.maxDaysDiffNegative;
        data["ledgerAccountDiff"] = this.ledgerAccountDiff;
        data["created"] = this.created ? this.created.toISOString() : undefined as any;
        data["createdBy"] = this.createdBy;
        data["modified"] = this.modified ? this.modified.toISOString() : undefined as any;
        data["modifiedBy"] = this.modifiedBy;
        data["bankAccountNavigation"] = this.bankAccountNavigation ? this.bankAccountNavigation.toJSON() : undefined as any;
        return data;
    }
}

export interface IBankAccountSettlementRule {
    id?: number;
    name: string;
    bankAccount?: number | undefined;
    active?: boolean;
    priority?: number;
    bankTransType?: string | undefined;
    bankAuthReferenceRequired?: boolean;
    voucherAuthReferenceRequired?: boolean;
    userMatchRequired?: boolean;
    maxAmtCurDiffPositive?: number | undefined;
    maxAmtCurDiffNegative?: number | undefined;
    maxAmtPctDiffPositive?: number | undefined;
    maxAmtPctDiffNegative?: number | undefined;
    maxDaysDiffPositive?: number | undefined;
    maxDaysDiffNegative?: number | undefined;
    ledgerAccountDiff?: string | undefined;
    created?: Date | undefined;
    createdBy?: number | undefined;
    modified?: Date | undefined;
    modifiedBy?: number | undefined;
    bankAccountNavigation?: BankAccount | undefined;
}

export class BankAccount implements IBankAccount {
    id?: number;
    name!: string;
    description?: string | undefined;
    currency?: number;
    ledgerAccount?: string | undefined;
    bankIBAN?: string | undefined;
    bankRegNum?: string | undefined;
    bankAccountNum?: string | undefined;
    bankBIC?: string | undefined;
    bankName?: string | undefined;
    bankTownName?: string | undefined;
    bankCountry?: string | undefined;
    bankTransferSetup?: number | undefined;
    accountName?: string | undefined;
    accountTownName?: string | undefined;
    accountCountry?: string | undefined;
    active?: boolean;
    openingBalanceCur?: number | undefined;
    openingBalanceDate?: Date | undefined;
    created?: Date | undefined;
    createdBy?: number | undefined;
    modified?: Date | undefined;
    modifiedBy?: number | undefined;
    bankTransferSetupNavigation?: BankAccountTransferSetup | undefined;
    currencyNavigation?: Currency | undefined;
    bankAccountSettlementRules?: BankAccountSettlementRule[] | undefined;
    bankAccountSettlements?: BankAccountSettlement[] | undefined;
    bankAccountSources?: BankAccountSource[] | undefined;
    bankAccountTransactions?: BankAccountTransaction[] | undefined;
    bankAccountTransactionSourceBatches?: BankAccountTransactionSourceBatch[] | undefined;
    bankCreditCards?: BankCreditCard[] | undefined;

    constructor(data?: IBankAccount) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.currency = _data["currency"];
            this.ledgerAccount = _data["ledgerAccount"];
            this.bankIBAN = _data["bankIBAN"];
            this.bankRegNum = _data["bankRegNum"];
            this.bankAccountNum = _data["bankAccountNum"];
            this.bankBIC = _data["bankBIC"];
            this.bankName = _data["bankName"];
            this.bankTownName = _data["bankTownName"];
            this.bankCountry = _data["bankCountry"];
            this.bankTransferSetup = _data["bankTransferSetup"];
            this.accountName = _data["accountName"];
            this.accountTownName = _data["accountTownName"];
            this.accountCountry = _data["accountCountry"];
            this.active = _data["active"];
            this.openingBalanceCur = _data["openingBalanceCur"];
            this.openingBalanceDate = _data["openingBalanceDate"] ? new Date(_data["openingBalanceDate"].toString()) : undefined as any;
            this.created = _data["created"] ? new Date(_data["created"].toString()) : undefined as any;
            this.createdBy = _data["createdBy"];
            this.modified = _data["modified"] ? new Date(_data["modified"].toString()) : undefined as any;
            this.modifiedBy = _data["modifiedBy"];
            this.bankTransferSetupNavigation = _data["bankTransferSetupNavigation"] ? BankAccountTransferSetup.fromJS(_data["bankTransferSetupNavigation"]) : undefined as any;
            this.currencyNavigation = _data["currencyNavigation"] ? Currency.fromJS(_data["currencyNavigation"]) : undefined as any;
            if (Array.isArray(_data["bankAccountSettlementRules"])) {
                this.bankAccountSettlementRules = [] as any;
                for (let item of _data["bankAccountSettlementRules"])
                    this.bankAccountSettlementRules!.push(BankAccountSettlementRule.fromJS(item));
            }
            if (Array.isArray(_data["bankAccountSettlements"])) {
                this.bankAccountSettlements = [] as any;
                for (let item of _data["bankAccountSettlements"])
                    this.bankAccountSettlements!.push(BankAccountSettlement.fromJS(item));
            }
            if (Array.isArray(_data["bankAccountSources"])) {
                this.bankAccountSources = [] as any;
                for (let item of _data["bankAccountSources"])
                    this.bankAccountSources!.push(BankAccountSource.fromJS(item));
            }
            if (Array.isArray(_data["bankAccountTransactions"])) {
                this.bankAccountTransactions = [] as any;
                for (let item of _data["bankAccountTransactions"])
                    this.bankAccountTransactions!.push(BankAccountTransaction.fromJS(item));
            }
            if (Array.isArray(_data["bankAccountTransactionSourceBatches"])) {
                this.bankAccountTransactionSourceBatches = [] as any;
                for (let item of _data["bankAccountTransactionSourceBatches"])
                    this.bankAccountTransactionSourceBatches!.push(BankAccountTransactionSourceBatch.fromJS(item));
            }
            if (Array.isArray(_data["bankCreditCards"])) {
                this.bankCreditCards = [] as any;
                for (let item of _data["bankCreditCards"])
                    this.bankCreditCards!.push(BankCreditCard.fromJS(item));
            }
        }
    }

    static fromJS(data: any): BankAccount {
        data = typeof data === 'object' ? data : {};
        let result = new BankAccount();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["description"] = this.description;
        data["currency"] = this.currency;
        data["ledgerAccount"] = this.ledgerAccount;
        data["bankIBAN"] = this.bankIBAN;
        data["bankRegNum"] = this.bankRegNum;
        data["bankAccountNum"] = this.bankAccountNum;
        data["bankBIC"] = this.bankBIC;
        data["bankName"] = this.bankName;
        data["bankTownName"] = this.bankTownName;
        data["bankCountry"] = this.bankCountry;
        data["bankTransferSetup"] = this.bankTransferSetup;
        data["accountName"] = this.accountName;
        data["accountTownName"] = this.accountTownName;
        data["accountCountry"] = this.accountCountry;
        data["active"] = this.active;
        data["openingBalanceCur"] = this.openingBalanceCur;
        data["openingBalanceDate"] = this.openingBalanceDate ? this.openingBalanceDate.toISOString() : undefined as any;
        data["created"] = this.created ? this.created.toISOString() : undefined as any;
        data["createdBy"] = this.createdBy;
        data["modified"] = this.modified ? this.modified.toISOString() : undefined as any;
        data["modifiedBy"] = this.modifiedBy;
        data["bankTransferSetupNavigation"] = this.bankTransferSetupNavigation ? this.bankTransferSetupNavigation.toJSON() : undefined as any;
        data["currencyNavigation"] = this.currencyNavigation ? this.currencyNavigation.toJSON() : undefined as any;
        if (Array.isArray(this.bankAccountSettlementRules)) {
            data["bankAccountSettlementRules"] = [];
            for (let item of this.bankAccountSettlementRules)
                data["bankAccountSettlementRules"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.bankAccountSettlements)) {
            data["bankAccountSettlements"] = [];
            for (let item of this.bankAccountSettlements)
                data["bankAccountSettlements"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.bankAccountSources)) {
            data["bankAccountSources"] = [];
            for (let item of this.bankAccountSources)
                data["bankAccountSources"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.bankAccountTransactions)) {
            data["bankAccountTransactions"] = [];
            for (let item of this.bankAccountTransactions)
                data["bankAccountTransactions"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.bankAccountTransactionSourceBatches)) {
            data["bankAccountTransactionSourceBatches"] = [];
            for (let item of this.bankAccountTransactionSourceBatches)
                data["bankAccountTransactionSourceBatches"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.bankCreditCards)) {
            data["bankCreditCards"] = [];
            for (let item of this.bankCreditCards)
                data["bankCreditCards"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IBankAccount {
    id?: number;
    name: string;
    description?: string | undefined;
    currency?: number;
    ledgerAccount?: string | undefined;
    bankIBAN?: string | undefined;
    bankRegNum?: string | undefined;
    bankAccountNum?: string | undefined;
    bankBIC?: string | undefined;
    bankName?: string | undefined;
    bankTownName?: string | undefined;
    bankCountry?: string | undefined;
    bankTransferSetup?: number | undefined;
    accountName?: string | undefined;
    accountTownName?: string | undefined;
    accountCountry?: string | undefined;
    active?: boolean;
    openingBalanceCur?: number | undefined;
    openingBalanceDate?: Date | undefined;
    created?: Date | undefined;
    createdBy?: number | undefined;
    modified?: Date | undefined;
    modifiedBy?: number | undefined;
    bankTransferSetupNavigation?: BankAccountTransferSetup | undefined;
    currencyNavigation?: Currency | undefined;
    bankAccountSettlementRules?: BankAccountSettlementRule[] | undefined;
    bankAccountSettlements?: BankAccountSettlement[] | undefined;
    bankAccountSources?: BankAccountSource[] | undefined;
    bankAccountTransactions?: BankAccountTransaction[] | undefined;
    bankAccountTransactionSourceBatches?: BankAccountTransactionSourceBatch[] | undefined;
    bankCreditCards?: BankCreditCard[] | undefined;
}

export class BankAccountTransferSetup implements IBankAccountTransferSetup {
    id?: number;
    initiatingName?: string | undefined;
    initiatingOrgId!: string;
    initiatingOrgIdScheme!: string;
    ownerName!: string;
    ownerAdrLine1?: string | undefined;
    ownerAdrLine2?: string | undefined;
    ownerPostalCode?: string | undefined;
    ownerTownName!: string;
    ownerCountry!: string;
    ownerOrgId?: string | undefined;
    ownerOrgIdScheme?: string | undefined;
    format!: string;
    created?: Date | undefined;
    createdBy?: number | undefined;
    modified?: Date | undefined;
    modifiedBy?: number | undefined;
    ownerCountryNavigation?: GlobalCountry | undefined;
    bankAccounts?: BankAccount[] | undefined;
    bankAccountTransfers?: BankAccountTransfer[] | undefined;

    constructor(data?: IBankAccountTransferSetup) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.initiatingName = _data["initiatingName"];
            this.initiatingOrgId = _data["initiatingOrgId"];
            this.initiatingOrgIdScheme = _data["initiatingOrgIdScheme"];
            this.ownerName = _data["ownerName"];
            this.ownerAdrLine1 = _data["ownerAdrLine1"];
            this.ownerAdrLine2 = _data["ownerAdrLine2"];
            this.ownerPostalCode = _data["ownerPostalCode"];
            this.ownerTownName = _data["ownerTownName"];
            this.ownerCountry = _data["ownerCountry"];
            this.ownerOrgId = _data["ownerOrgId"];
            this.ownerOrgIdScheme = _data["ownerOrgIdScheme"];
            this.format = _data["format"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : undefined as any;
            this.createdBy = _data["createdBy"];
            this.modified = _data["modified"] ? new Date(_data["modified"].toString()) : undefined as any;
            this.modifiedBy = _data["modifiedBy"];
            this.ownerCountryNavigation = _data["ownerCountryNavigation"] ? GlobalCountry.fromJS(_data["ownerCountryNavigation"]) : undefined as any;
            if (Array.isArray(_data["bankAccounts"])) {
                this.bankAccounts = [] as any;
                for (let item of _data["bankAccounts"])
                    this.bankAccounts!.push(BankAccount.fromJS(item));
            }
            if (Array.isArray(_data["bankAccountTransfers"])) {
                this.bankAccountTransfers = [] as any;
                for (let item of _data["bankAccountTransfers"])
                    this.bankAccountTransfers!.push(BankAccountTransfer.fromJS(item));
            }
        }
    }

    static fromJS(data: any): BankAccountTransferSetup {
        data = typeof data === 'object' ? data : {};
        let result = new BankAccountTransferSetup();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["initiatingName"] = this.initiatingName;
        data["initiatingOrgId"] = this.initiatingOrgId;
        data["initiatingOrgIdScheme"] = this.initiatingOrgIdScheme;
        data["ownerName"] = this.ownerName;
        data["ownerAdrLine1"] = this.ownerAdrLine1;
        data["ownerAdrLine2"] = this.ownerAdrLine2;
        data["ownerPostalCode"] = this.ownerPostalCode;
        data["ownerTownName"] = this.ownerTownName;
        data["ownerCountry"] = this.ownerCountry;
        data["ownerOrgId"] = this.ownerOrgId;
        data["ownerOrgIdScheme"] = this.ownerOrgIdScheme;
        data["format"] = this.format;
        data["created"] = this.created ? this.created.toISOString() : undefined as any;
        data["createdBy"] = this.createdBy;
        data["modified"] = this.modified ? this.modified.toISOString() : undefined as any;
        data["modifiedBy"] = this.modifiedBy;
        data["ownerCountryNavigation"] = this.ownerCountryNavigation ? this.ownerCountryNavigation.toJSON() : undefined as any;
        if (Array.isArray(this.bankAccounts)) {
            data["bankAccounts"] = [];
            for (let item of this.bankAccounts)
                data["bankAccounts"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.bankAccountTransfers)) {
            data["bankAccountTransfers"] = [];
            for (let item of this.bankAccountTransfers)
                data["bankAccountTransfers"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IBankAccountTransferSetup {
    id?: number;
    initiatingName?: string | undefined;
    initiatingOrgId: string;
    initiatingOrgIdScheme: string;
    ownerName: string;
    ownerAdrLine1?: string | undefined;
    ownerAdrLine2?: string | undefined;
    ownerPostalCode?: string | undefined;
    ownerTownName: string;
    ownerCountry: string;
    ownerOrgId?: string | undefined;
    ownerOrgIdScheme?: string | undefined;
    format: string;
    created?: Date | undefined;
    createdBy?: number | undefined;
    modified?: Date | undefined;
    modifiedBy?: number | undefined;
    ownerCountryNavigation?: GlobalCountry | undefined;
    bankAccounts?: BankAccount[] | undefined;
    bankAccountTransfers?: BankAccountTransfer[] | undefined;
}

export class GlobalCountry implements IGlobalCountry {
    id?: number;
    num?: string | undefined;
    name!: string;
    nameLocal?: string | undefined;
    active?: boolean;
    sorting?: number | undefined;
    isO2!: string;
    isO3?: string | undefined;
    tld?: string | undefined;
    phonePrefix?: number | undefined;
    postalAddressFormat?: number | undefined;
    created?: Date | undefined;
    createdBy?: number | undefined;
    modified?: Date | undefined;
    modifiedBy?: number | undefined;
    bankAccountTransferSetups?: BankAccountTransferSetup[] | undefined;
    globalLocales?: GlobalLocale[] | undefined;

    constructor(data?: IGlobalCountry) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.num = _data["num"];
            this.name = _data["name"];
            this.nameLocal = _data["nameLocal"];
            this.active = _data["active"];
            this.sorting = _data["sorting"];
            this.isO2 = _data["isO2"];
            this.isO3 = _data["isO3"];
            this.tld = _data["tld"];
            this.phonePrefix = _data["phonePrefix"];
            this.postalAddressFormat = _data["postalAddressFormat"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : undefined as any;
            this.createdBy = _data["createdBy"];
            this.modified = _data["modified"] ? new Date(_data["modified"].toString()) : undefined as any;
            this.modifiedBy = _data["modifiedBy"];
            if (Array.isArray(_data["bankAccountTransferSetups"])) {
                this.bankAccountTransferSetups = [] as any;
                for (let item of _data["bankAccountTransferSetups"])
                    this.bankAccountTransferSetups!.push(BankAccountTransferSetup.fromJS(item));
            }
            if (Array.isArray(_data["globalLocales"])) {
                this.globalLocales = [] as any;
                for (let item of _data["globalLocales"])
                    this.globalLocales!.push(GlobalLocale.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GlobalCountry {
        data = typeof data === 'object' ? data : {};
        let result = new GlobalCountry();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["num"] = this.num;
        data["name"] = this.name;
        data["nameLocal"] = this.nameLocal;
        data["active"] = this.active;
        data["sorting"] = this.sorting;
        data["isO2"] = this.isO2;
        data["isO3"] = this.isO3;
        data["tld"] = this.tld;
        data["phonePrefix"] = this.phonePrefix;
        data["postalAddressFormat"] = this.postalAddressFormat;
        data["created"] = this.created ? this.created.toISOString() : undefined as any;
        data["createdBy"] = this.createdBy;
        data["modified"] = this.modified ? this.modified.toISOString() : undefined as any;
        data["modifiedBy"] = this.modifiedBy;
        if (Array.isArray(this.bankAccountTransferSetups)) {
            data["bankAccountTransferSetups"] = [];
            for (let item of this.bankAccountTransferSetups)
                data["bankAccountTransferSetups"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.globalLocales)) {
            data["globalLocales"] = [];
            for (let item of this.globalLocales)
                data["globalLocales"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IGlobalCountry {
    id?: number;
    num?: string | undefined;
    name: string;
    nameLocal?: string | undefined;
    active?: boolean;
    sorting?: number | undefined;
    isO2: string;
    isO3?: string | undefined;
    tld?: string | undefined;
    phonePrefix?: number | undefined;
    postalAddressFormat?: number | undefined;
    created?: Date | undefined;
    createdBy?: number | undefined;
    modified?: Date | undefined;
    modifiedBy?: number | undefined;
    bankAccountTransferSetups?: BankAccountTransferSetup[] | undefined;
    globalLocales?: GlobalLocale[] | undefined;
}

export class GlobalLocale implements IGlobalLocale {
    id?: number;
    num?: string | undefined;
    name!: string;
    language?: string | undefined;
    country?: string | undefined;
    created?: Date | undefined;
    createdBy?: number | undefined;
    modified?: Date | undefined;
    modifiedBy?: number | undefined;
    countryNavigation?: GlobalCountry | undefined;
    languageNavigation?: GlobalLanguage | undefined;
    users?: User[] | undefined;

    constructor(data?: IGlobalLocale) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.num = _data["num"];
            this.name = _data["name"];
            this.language = _data["language"];
            this.country = _data["country"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : undefined as any;
            this.createdBy = _data["createdBy"];
            this.modified = _data["modified"] ? new Date(_data["modified"].toString()) : undefined as any;
            this.modifiedBy = _data["modifiedBy"];
            this.countryNavigation = _data["countryNavigation"] ? GlobalCountry.fromJS(_data["countryNavigation"]) : undefined as any;
            this.languageNavigation = _data["languageNavigation"] ? GlobalLanguage.fromJS(_data["languageNavigation"]) : undefined as any;
            if (Array.isArray(_data["users"])) {
                this.users = [] as any;
                for (let item of _data["users"])
                    this.users!.push(User.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GlobalLocale {
        data = typeof data === 'object' ? data : {};
        let result = new GlobalLocale();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["num"] = this.num;
        data["name"] = this.name;
        data["language"] = this.language;
        data["country"] = this.country;
        data["created"] = this.created ? this.created.toISOString() : undefined as any;
        data["createdBy"] = this.createdBy;
        data["modified"] = this.modified ? this.modified.toISOString() : undefined as any;
        data["modifiedBy"] = this.modifiedBy;
        data["countryNavigation"] = this.countryNavigation ? this.countryNavigation.toJSON() : undefined as any;
        data["languageNavigation"] = this.languageNavigation ? this.languageNavigation.toJSON() : undefined as any;
        if (Array.isArray(this.users)) {
            data["users"] = [];
            for (let item of this.users)
                data["users"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IGlobalLocale {
    id?: number;
    num?: string | undefined;
    name: string;
    language?: string | undefined;
    country?: string | undefined;
    created?: Date | undefined;
    createdBy?: number | undefined;
    modified?: Date | undefined;
    modifiedBy?: number | undefined;
    countryNavigation?: GlobalCountry | undefined;
    languageNavigation?: GlobalLanguage | undefined;
    users?: User[] | undefined;
}

export class GlobalLanguage implements IGlobalLanguage {
    id?: number;
    num?: string | undefined;
    name!: string;
    nameLocal?: string | undefined;
    active?: boolean;
    sorting?: number | undefined;
    isO2?: string | undefined;
    isO3?: string | undefined;
    onix?: string | undefined;
    created?: Date | undefined;
    createdBy?: number | undefined;
    modified?: Date | undefined;
    modifiedBy?: number | undefined;
    globalLocales?: GlobalLocale[] | undefined;
    productLanguageNavigations?: Product[] | undefined;
    productLanguageOriginalNavigations?: Product[] | undefined;

    constructor(data?: IGlobalLanguage) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.num = _data["num"];
            this.name = _data["name"];
            this.nameLocal = _data["nameLocal"];
            this.active = _data["active"];
            this.sorting = _data["sorting"];
            this.isO2 = _data["isO2"];
            this.isO3 = _data["isO3"];
            this.onix = _data["onix"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : undefined as any;
            this.createdBy = _data["createdBy"];
            this.modified = _data["modified"] ? new Date(_data["modified"].toString()) : undefined as any;
            this.modifiedBy = _data["modifiedBy"];
            if (Array.isArray(_data["globalLocales"])) {
                this.globalLocales = [] as any;
                for (let item of _data["globalLocales"])
                    this.globalLocales!.push(GlobalLocale.fromJS(item));
            }
            if (Array.isArray(_data["productLanguageNavigations"])) {
                this.productLanguageNavigations = [] as any;
                for (let item of _data["productLanguageNavigations"])
                    this.productLanguageNavigations!.push(Product.fromJS(item));
            }
            if (Array.isArray(_data["productLanguageOriginalNavigations"])) {
                this.productLanguageOriginalNavigations = [] as any;
                for (let item of _data["productLanguageOriginalNavigations"])
                    this.productLanguageOriginalNavigations!.push(Product.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GlobalLanguage {
        data = typeof data === 'object' ? data : {};
        let result = new GlobalLanguage();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["num"] = this.num;
        data["name"] = this.name;
        data["nameLocal"] = this.nameLocal;
        data["active"] = this.active;
        data["sorting"] = this.sorting;
        data["isO2"] = this.isO2;
        data["isO3"] = this.isO3;
        data["onix"] = this.onix;
        data["created"] = this.created ? this.created.toISOString() : undefined as any;
        data["createdBy"] = this.createdBy;
        data["modified"] = this.modified ? this.modified.toISOString() : undefined as any;
        data["modifiedBy"] = this.modifiedBy;
        if (Array.isArray(this.globalLocales)) {
            data["globalLocales"] = [];
            for (let item of this.globalLocales)
                data["globalLocales"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.productLanguageNavigations)) {
            data["productLanguageNavigations"] = [];
            for (let item of this.productLanguageNavigations)
                data["productLanguageNavigations"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.productLanguageOriginalNavigations)) {
            data["productLanguageOriginalNavigations"] = [];
            for (let item of this.productLanguageOriginalNavigations)
                data["productLanguageOriginalNavigations"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IGlobalLanguage {
    id?: number;
    num?: string | undefined;
    name: string;
    nameLocal?: string | undefined;
    active?: boolean;
    sorting?: number | undefined;
    isO2?: string | undefined;
    isO3?: string | undefined;
    onix?: string | undefined;
    created?: Date | undefined;
    createdBy?: number | undefined;
    modified?: Date | undefined;
    modifiedBy?: number | undefined;
    globalLocales?: GlobalLocale[] | undefined;
    productLanguageNavigations?: Product[] | undefined;
    productLanguageOriginalNavigations?: Product[] | undefined;
}

export class Product implements IProduct {
    id?: number;
    num?: string | undefined;
    name?: string | undefined;
    nameSub?: string | undefined;
    nameWorking?: string | undefined;
    nameOriginal?: string | undefined;
    nameSubOriginal?: string | undefined;
    projectNum?: string | undefined;
    itemNum?: string | undefined;
    contract?: string | undefined;
    responsible?: number | undefined;
    template?: string | undefined;
    group?: string | undefined;
    type?: string | undefined;
    internal?: boolean;
    status?: string | undefined;
    pool?: string | undefined;
    productForm?: string | undefined;
    productComposition?: string | undefined;
    productFormDetail?: string | undefined;
    collectionName?: string | undefined;
    collectionNameSub?: string | undefined;
    collectionNameOriginal?: string | undefined;
    collectionNameSubOriginal?: string | undefined;
    collectionSequenceNumber?: number | undefined;
    contributorAuthor?: string | undefined;
    contributorIllustrator?: string | undefined;
    contributorPhotographer?: string | undefined;
    contributorForeword?: string | undefined;
    contributorCover?: string | undefined;
    contributorTranslator?: string | undefined;
    contributorTechnicalEditor?: string | undefined;
    contributorReadBy?: string | undefined;
    language?: string | undefined;
    languageOriginal?: string | undefined;
    measurementHeightMM?: number | undefined;
    measurementWidthMM?: number | undefined;
    measurementThicknessMM?: number | undefined;
    measurementWeightGR?: number | undefined;
    extendPages?: number | undefined;
    editionNumber?: number | undefined;
    subjectThema?: string | undefined;
    subjectKeywords?: string | undefined;
    subjectBookstoreClassification?: string | undefined;
    contentDescription?: string | undefined;
    contentAudience?: string | undefined;
    resourceFrontCoverImageURL?: string | undefined;
    resourceFrontCoverImageLatestUpdate?: Date | undefined;
    publisher?: string | undefined;
    publisherImprint?: string | undefined;
    publishingStatus?: string | undefined;
    publishingDate?: Date | undefined;
    publishingDateFirstPublished?: Date | undefined;
    publishingDateSalesEmbargo?: Date | undefined;
    publishingDateLatestReissue?: Date | undefined;
    publishingDateOutOfPrint?: Date | undefined;
    publishingLatestReprintNumber?: number | undefined;
    salesPrice?: number | undefined;
    salesPriceCurrency?: string | undefined;
    salesDiscountCode?: string | undefined;
    sourcingMinOnhandQty?: number | undefined;
    sourcingManager?: string | undefined;
    sourcingSupplier?: string | undefined;
    supplyMarketAvailability?: string | undefined;
    supplyDistributor?: string | undefined;
    supplyDate?: Date | undefined;
    supplyReturnsCodeReplacement?: string | undefined;
    supplyOrderTime?: number | undefined;
    supplyOrderQtyMin?: number | undefined;
    legacyId?: number | undefined;
    closedDate?: Date | undefined;
    closedBy?: number | undefined;
    isDeleted?: boolean | undefined;
    deletedReason?: string | undefined;
    deletedDate?: Date | undefined;
    deletedBy?: number | undefined;
    created?: Date | undefined;
    createdBy?: number | undefined;
    modified?: Date | undefined;
    modifiedBy?: number | undefined;
    contractNavigation?: Contract | undefined;
    groupNavigation?: ProductGroup | undefined;
    languageNavigation?: GlobalLanguage | undefined;
    languageOriginalNavigation?: GlobalLanguage | undefined;
    poolNavigation?: ProductPool | undefined;
    productCompositionNavigation?: ProductComposition | undefined;
    productFormDetailNavigation?: ProductFormDetail | undefined;
    productFormNavigation?: ProductForm | undefined;
    responsibleNavigation?: User | undefined;
    statusNavigation?: ProductStatus | undefined;
    subjectBookstoreClassificationNavigation?: ProductCategory | undefined;
    typeNavigation?: ProductType | undefined;
    productPartyRoles?: ProductPartyRole[] | undefined;

    constructor(data?: IProduct) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.num = _data["num"];
            this.name = _data["name"];
            this.nameSub = _data["nameSub"];
            this.nameWorking = _data["nameWorking"];
            this.nameOriginal = _data["nameOriginal"];
            this.nameSubOriginal = _data["nameSubOriginal"];
            this.projectNum = _data["projectNum"];
            this.itemNum = _data["itemNum"];
            this.contract = _data["contract"];
            this.responsible = _data["responsible"];
            this.template = _data["template"];
            this.group = _data["group"];
            this.type = _data["type"];
            this.internal = _data["internal"];
            this.status = _data["status"];
            this.pool = _data["pool"];
            this.productForm = _data["productForm"];
            this.productComposition = _data["productComposition"];
            this.productFormDetail = _data["productFormDetail"];
            this.collectionName = _data["collectionName"];
            this.collectionNameSub = _data["collectionNameSub"];
            this.collectionNameOriginal = _data["collectionNameOriginal"];
            this.collectionNameSubOriginal = _data["collectionNameSubOriginal"];
            this.collectionSequenceNumber = _data["collectionSequenceNumber"];
            this.contributorAuthor = _data["contributorAuthor"];
            this.contributorIllustrator = _data["contributorIllustrator"];
            this.contributorPhotographer = _data["contributorPhotographer"];
            this.contributorForeword = _data["contributorForeword"];
            this.contributorCover = _data["contributorCover"];
            this.contributorTranslator = _data["contributorTranslator"];
            this.contributorTechnicalEditor = _data["contributorTechnicalEditor"];
            this.contributorReadBy = _data["contributorReadBy"];
            this.language = _data["language"];
            this.languageOriginal = _data["languageOriginal"];
            this.measurementHeightMM = _data["measurementHeightMM"];
            this.measurementWidthMM = _data["measurementWidthMM"];
            this.measurementThicknessMM = _data["measurementThicknessMM"];
            this.measurementWeightGR = _data["measurementWeightGR"];
            this.extendPages = _data["extendPages"];
            this.editionNumber = _data["editionNumber"];
            this.subjectThema = _data["subjectThema"];
            this.subjectKeywords = _data["subjectKeywords"];
            this.subjectBookstoreClassification = _data["subjectBookstoreClassification"];
            this.contentDescription = _data["contentDescription"];
            this.contentAudience = _data["contentAudience"];
            this.resourceFrontCoverImageURL = _data["resourceFrontCoverImageURL"];
            this.resourceFrontCoverImageLatestUpdate = _data["resourceFrontCoverImageLatestUpdate"] ? new Date(_data["resourceFrontCoverImageLatestUpdate"].toString()) : undefined as any;
            this.publisher = _data["publisher"];
            this.publisherImprint = _data["publisherImprint"];
            this.publishingStatus = _data["publishingStatus"];
            this.publishingDate = _data["publishingDate"] ? new Date(_data["publishingDate"].toString()) : undefined as any;
            this.publishingDateFirstPublished = _data["publishingDateFirstPublished"] ? new Date(_data["publishingDateFirstPublished"].toString()) : undefined as any;
            this.publishingDateSalesEmbargo = _data["publishingDateSalesEmbargo"] ? new Date(_data["publishingDateSalesEmbargo"].toString()) : undefined as any;
            this.publishingDateLatestReissue = _data["publishingDateLatestReissue"] ? new Date(_data["publishingDateLatestReissue"].toString()) : undefined as any;
            this.publishingDateOutOfPrint = _data["publishingDateOutOfPrint"] ? new Date(_data["publishingDateOutOfPrint"].toString()) : undefined as any;
            this.publishingLatestReprintNumber = _data["publishingLatestReprintNumber"];
            this.salesPrice = _data["salesPrice"];
            this.salesPriceCurrency = _data["salesPriceCurrency"];
            this.salesDiscountCode = _data["salesDiscountCode"];
            this.sourcingMinOnhandQty = _data["sourcingMinOnhandQty"];
            this.sourcingManager = _data["sourcingManager"];
            this.sourcingSupplier = _data["sourcingSupplier"];
            this.supplyMarketAvailability = _data["supplyMarketAvailability"];
            this.supplyDistributor = _data["supplyDistributor"];
            this.supplyDate = _data["supplyDate"] ? new Date(_data["supplyDate"].toString()) : undefined as any;
            this.supplyReturnsCodeReplacement = _data["supplyReturnsCodeReplacement"];
            this.supplyOrderTime = _data["supplyOrderTime"];
            this.supplyOrderQtyMin = _data["supplyOrderQtyMin"];
            this.legacyId = _data["legacyId"];
            this.closedDate = _data["closedDate"] ? new Date(_data["closedDate"].toString()) : undefined as any;
            this.closedBy = _data["closedBy"];
            this.isDeleted = _data["isDeleted"];
            this.deletedReason = _data["deletedReason"];
            this.deletedDate = _data["deletedDate"] ? new Date(_data["deletedDate"].toString()) : undefined as any;
            this.deletedBy = _data["deletedBy"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : undefined as any;
            this.createdBy = _data["createdBy"];
            this.modified = _data["modified"] ? new Date(_data["modified"].toString()) : undefined as any;
            this.modifiedBy = _data["modifiedBy"];
            this.contractNavigation = _data["contractNavigation"] ? Contract.fromJS(_data["contractNavigation"]) : undefined as any;
            this.groupNavigation = _data["groupNavigation"] ? ProductGroup.fromJS(_data["groupNavigation"]) : undefined as any;
            this.languageNavigation = _data["languageNavigation"] ? GlobalLanguage.fromJS(_data["languageNavigation"]) : undefined as any;
            this.languageOriginalNavigation = _data["languageOriginalNavigation"] ? GlobalLanguage.fromJS(_data["languageOriginalNavigation"]) : undefined as any;
            this.poolNavigation = _data["poolNavigation"] ? ProductPool.fromJS(_data["poolNavigation"]) : undefined as any;
            this.productCompositionNavigation = _data["productCompositionNavigation"] ? ProductComposition.fromJS(_data["productCompositionNavigation"]) : undefined as any;
            this.productFormDetailNavigation = _data["productFormDetailNavigation"] ? ProductFormDetail.fromJS(_data["productFormDetailNavigation"]) : undefined as any;
            this.productFormNavigation = _data["productFormNavigation"] ? ProductForm.fromJS(_data["productFormNavigation"]) : undefined as any;
            this.responsibleNavigation = _data["responsibleNavigation"] ? User.fromJS(_data["responsibleNavigation"]) : undefined as any;
            this.statusNavigation = _data["statusNavigation"] ? ProductStatus.fromJS(_data["statusNavigation"]) : undefined as any;
            this.subjectBookstoreClassificationNavigation = _data["subjectBookstoreClassificationNavigation"] ? ProductCategory.fromJS(_data["subjectBookstoreClassificationNavigation"]) : undefined as any;
            this.typeNavigation = _data["typeNavigation"] ? ProductType.fromJS(_data["typeNavigation"]) : undefined as any;
            if (Array.isArray(_data["productPartyRoles"])) {
                this.productPartyRoles = [] as any;
                for (let item of _data["productPartyRoles"])
                    this.productPartyRoles!.push(ProductPartyRole.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Product {
        data = typeof data === 'object' ? data : {};
        let result = new Product();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["num"] = this.num;
        data["name"] = this.name;
        data["nameSub"] = this.nameSub;
        data["nameWorking"] = this.nameWorking;
        data["nameOriginal"] = this.nameOriginal;
        data["nameSubOriginal"] = this.nameSubOriginal;
        data["projectNum"] = this.projectNum;
        data["itemNum"] = this.itemNum;
        data["contract"] = this.contract;
        data["responsible"] = this.responsible;
        data["template"] = this.template;
        data["group"] = this.group;
        data["type"] = this.type;
        data["internal"] = this.internal;
        data["status"] = this.status;
        data["pool"] = this.pool;
        data["productForm"] = this.productForm;
        data["productComposition"] = this.productComposition;
        data["productFormDetail"] = this.productFormDetail;
        data["collectionName"] = this.collectionName;
        data["collectionNameSub"] = this.collectionNameSub;
        data["collectionNameOriginal"] = this.collectionNameOriginal;
        data["collectionNameSubOriginal"] = this.collectionNameSubOriginal;
        data["collectionSequenceNumber"] = this.collectionSequenceNumber;
        data["contributorAuthor"] = this.contributorAuthor;
        data["contributorIllustrator"] = this.contributorIllustrator;
        data["contributorPhotographer"] = this.contributorPhotographer;
        data["contributorForeword"] = this.contributorForeword;
        data["contributorCover"] = this.contributorCover;
        data["contributorTranslator"] = this.contributorTranslator;
        data["contributorTechnicalEditor"] = this.contributorTechnicalEditor;
        data["contributorReadBy"] = this.contributorReadBy;
        data["language"] = this.language;
        data["languageOriginal"] = this.languageOriginal;
        data["measurementHeightMM"] = this.measurementHeightMM;
        data["measurementWidthMM"] = this.measurementWidthMM;
        data["measurementThicknessMM"] = this.measurementThicknessMM;
        data["measurementWeightGR"] = this.measurementWeightGR;
        data["extendPages"] = this.extendPages;
        data["editionNumber"] = this.editionNumber;
        data["subjectThema"] = this.subjectThema;
        data["subjectKeywords"] = this.subjectKeywords;
        data["subjectBookstoreClassification"] = this.subjectBookstoreClassification;
        data["contentDescription"] = this.contentDescription;
        data["contentAudience"] = this.contentAudience;
        data["resourceFrontCoverImageURL"] = this.resourceFrontCoverImageURL;
        data["resourceFrontCoverImageLatestUpdate"] = this.resourceFrontCoverImageLatestUpdate ? this.resourceFrontCoverImageLatestUpdate.toISOString() : undefined as any;
        data["publisher"] = this.publisher;
        data["publisherImprint"] = this.publisherImprint;
        data["publishingStatus"] = this.publishingStatus;
        data["publishingDate"] = this.publishingDate ? this.publishingDate.toISOString() : undefined as any;
        data["publishingDateFirstPublished"] = this.publishingDateFirstPublished ? this.publishingDateFirstPublished.toISOString() : undefined as any;
        data["publishingDateSalesEmbargo"] = this.publishingDateSalesEmbargo ? this.publishingDateSalesEmbargo.toISOString() : undefined as any;
        data["publishingDateLatestReissue"] = this.publishingDateLatestReissue ? this.publishingDateLatestReissue.toISOString() : undefined as any;
        data["publishingDateOutOfPrint"] = this.publishingDateOutOfPrint ? this.publishingDateOutOfPrint.toISOString() : undefined as any;
        data["publishingLatestReprintNumber"] = this.publishingLatestReprintNumber;
        data["salesPrice"] = this.salesPrice;
        data["salesPriceCurrency"] = this.salesPriceCurrency;
        data["salesDiscountCode"] = this.salesDiscountCode;
        data["sourcingMinOnhandQty"] = this.sourcingMinOnhandQty;
        data["sourcingManager"] = this.sourcingManager;
        data["sourcingSupplier"] = this.sourcingSupplier;
        data["supplyMarketAvailability"] = this.supplyMarketAvailability;
        data["supplyDistributor"] = this.supplyDistributor;
        data["supplyDate"] = this.supplyDate ? this.supplyDate.toISOString() : undefined as any;
        data["supplyReturnsCodeReplacement"] = this.supplyReturnsCodeReplacement;
        data["supplyOrderTime"] = this.supplyOrderTime;
        data["supplyOrderQtyMin"] = this.supplyOrderQtyMin;
        data["legacyId"] = this.legacyId;
        data["closedDate"] = this.closedDate ? this.closedDate.toISOString() : undefined as any;
        data["closedBy"] = this.closedBy;
        data["isDeleted"] = this.isDeleted;
        data["deletedReason"] = this.deletedReason;
        data["deletedDate"] = this.deletedDate ? this.deletedDate.toISOString() : undefined as any;
        data["deletedBy"] = this.deletedBy;
        data["created"] = this.created ? this.created.toISOString() : undefined as any;
        data["createdBy"] = this.createdBy;
        data["modified"] = this.modified ? this.modified.toISOString() : undefined as any;
        data["modifiedBy"] = this.modifiedBy;
        data["contractNavigation"] = this.contractNavigation ? this.contractNavigation.toJSON() : undefined as any;
        data["groupNavigation"] = this.groupNavigation ? this.groupNavigation.toJSON() : undefined as any;
        data["languageNavigation"] = this.languageNavigation ? this.languageNavigation.toJSON() : undefined as any;
        data["languageOriginalNavigation"] = this.languageOriginalNavigation ? this.languageOriginalNavigation.toJSON() : undefined as any;
        data["poolNavigation"] = this.poolNavigation ? this.poolNavigation.toJSON() : undefined as any;
        data["productCompositionNavigation"] = this.productCompositionNavigation ? this.productCompositionNavigation.toJSON() : undefined as any;
        data["productFormDetailNavigation"] = this.productFormDetailNavigation ? this.productFormDetailNavigation.toJSON() : undefined as any;
        data["productFormNavigation"] = this.productFormNavigation ? this.productFormNavigation.toJSON() : undefined as any;
        data["responsibleNavigation"] = this.responsibleNavigation ? this.responsibleNavigation.toJSON() : undefined as any;
        data["statusNavigation"] = this.statusNavigation ? this.statusNavigation.toJSON() : undefined as any;
        data["subjectBookstoreClassificationNavigation"] = this.subjectBookstoreClassificationNavigation ? this.subjectBookstoreClassificationNavigation.toJSON() : undefined as any;
        data["typeNavigation"] = this.typeNavigation ? this.typeNavigation.toJSON() : undefined as any;
        if (Array.isArray(this.productPartyRoles)) {
            data["productPartyRoles"] = [];
            for (let item of this.productPartyRoles)
                data["productPartyRoles"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IProduct {
    id?: number;
    num?: string | undefined;
    name?: string | undefined;
    nameSub?: string | undefined;
    nameWorking?: string | undefined;
    nameOriginal?: string | undefined;
    nameSubOriginal?: string | undefined;
    projectNum?: string | undefined;
    itemNum?: string | undefined;
    contract?: string | undefined;
    responsible?: number | undefined;
    template?: string | undefined;
    group?: string | undefined;
    type?: string | undefined;
    internal?: boolean;
    status?: string | undefined;
    pool?: string | undefined;
    productForm?: string | undefined;
    productComposition?: string | undefined;
    productFormDetail?: string | undefined;
    collectionName?: string | undefined;
    collectionNameSub?: string | undefined;
    collectionNameOriginal?: string | undefined;
    collectionNameSubOriginal?: string | undefined;
    collectionSequenceNumber?: number | undefined;
    contributorAuthor?: string | undefined;
    contributorIllustrator?: string | undefined;
    contributorPhotographer?: string | undefined;
    contributorForeword?: string | undefined;
    contributorCover?: string | undefined;
    contributorTranslator?: string | undefined;
    contributorTechnicalEditor?: string | undefined;
    contributorReadBy?: string | undefined;
    language?: string | undefined;
    languageOriginal?: string | undefined;
    measurementHeightMM?: number | undefined;
    measurementWidthMM?: number | undefined;
    measurementThicknessMM?: number | undefined;
    measurementWeightGR?: number | undefined;
    extendPages?: number | undefined;
    editionNumber?: number | undefined;
    subjectThema?: string | undefined;
    subjectKeywords?: string | undefined;
    subjectBookstoreClassification?: string | undefined;
    contentDescription?: string | undefined;
    contentAudience?: string | undefined;
    resourceFrontCoverImageURL?: string | undefined;
    resourceFrontCoverImageLatestUpdate?: Date | undefined;
    publisher?: string | undefined;
    publisherImprint?: string | undefined;
    publishingStatus?: string | undefined;
    publishingDate?: Date | undefined;
    publishingDateFirstPublished?: Date | undefined;
    publishingDateSalesEmbargo?: Date | undefined;
    publishingDateLatestReissue?: Date | undefined;
    publishingDateOutOfPrint?: Date | undefined;
    publishingLatestReprintNumber?: number | undefined;
    salesPrice?: number | undefined;
    salesPriceCurrency?: string | undefined;
    salesDiscountCode?: string | undefined;
    sourcingMinOnhandQty?: number | undefined;
    sourcingManager?: string | undefined;
    sourcingSupplier?: string | undefined;
    supplyMarketAvailability?: string | undefined;
    supplyDistributor?: string | undefined;
    supplyDate?: Date | undefined;
    supplyReturnsCodeReplacement?: string | undefined;
    supplyOrderTime?: number | undefined;
    supplyOrderQtyMin?: number | undefined;
    legacyId?: number | undefined;
    closedDate?: Date | undefined;
    closedBy?: number | undefined;
    isDeleted?: boolean | undefined;
    deletedReason?: string | undefined;
    deletedDate?: Date | undefined;
    deletedBy?: number | undefined;
    created?: Date | undefined;
    createdBy?: number | undefined;
    modified?: Date | undefined;
    modifiedBy?: number | undefined;
    contractNavigation?: Contract | undefined;
    groupNavigation?: ProductGroup | undefined;
    languageNavigation?: GlobalLanguage | undefined;
    languageOriginalNavigation?: GlobalLanguage | undefined;
    poolNavigation?: ProductPool | undefined;
    productCompositionNavigation?: ProductComposition | undefined;
    productFormDetailNavigation?: ProductFormDetail | undefined;
    productFormNavigation?: ProductForm | undefined;
    responsibleNavigation?: User | undefined;
    statusNavigation?: ProductStatus | undefined;
    subjectBookstoreClassificationNavigation?: ProductCategory | undefined;
    typeNavigation?: ProductType | undefined;
    productPartyRoles?: ProductPartyRole[] | undefined;
}

export class Contract implements IContract {
    id?: number;
    num?: string | undefined;
    name!: string;
    type!: string;
    currency?: string | undefined;
    responsible?: number;
    counterParty?: string | undefined;
    agentParty?: string | undefined;
    legacyId?: number | undefined;
    closed?: Date | undefined;
    closedBy?: number | undefined;
    deleted?: Date | undefined;
    deletedBy?: number | undefined;
    created?: Date | undefined;
    createdBy?: number | undefined;
    modified?: Date | undefined;
    modifiedBy?: number | undefined;
    agentPartyNavigation?: Party | undefined;
    counterPartyNavigation?: Party | undefined;
    responsibleNavigation?: User | undefined;
    typeNavigation?: ContractType | undefined;
    contractPartyRoles?: ContractPartyRole[] | undefined;
    products?: Product[] | undefined;

    constructor(data?: IContract) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.num = _data["num"];
            this.name = _data["name"];
            this.type = _data["type"];
            this.currency = _data["currency"];
            this.responsible = _data["responsible"];
            this.counterParty = _data["counterParty"];
            this.agentParty = _data["agentParty"];
            this.legacyId = _data["legacyId"];
            this.closed = _data["closed"] ? new Date(_data["closed"].toString()) : undefined as any;
            this.closedBy = _data["closedBy"];
            this.deleted = _data["deleted"] ? new Date(_data["deleted"].toString()) : undefined as any;
            this.deletedBy = _data["deletedBy"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : undefined as any;
            this.createdBy = _data["createdBy"];
            this.modified = _data["modified"] ? new Date(_data["modified"].toString()) : undefined as any;
            this.modifiedBy = _data["modifiedBy"];
            this.agentPartyNavigation = _data["agentPartyNavigation"] ? Party.fromJS(_data["agentPartyNavigation"]) : undefined as any;
            this.counterPartyNavigation = _data["counterPartyNavigation"] ? Party.fromJS(_data["counterPartyNavigation"]) : undefined as any;
            this.responsibleNavigation = _data["responsibleNavigation"] ? User.fromJS(_data["responsibleNavigation"]) : undefined as any;
            this.typeNavigation = _data["typeNavigation"] ? ContractType.fromJS(_data["typeNavigation"]) : undefined as any;
            if (Array.isArray(_data["contractPartyRoles"])) {
                this.contractPartyRoles = [] as any;
                for (let item of _data["contractPartyRoles"])
                    this.contractPartyRoles!.push(ContractPartyRole.fromJS(item));
            }
            if (Array.isArray(_data["products"])) {
                this.products = [] as any;
                for (let item of _data["products"])
                    this.products!.push(Product.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Contract {
        data = typeof data === 'object' ? data : {};
        let result = new Contract();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["num"] = this.num;
        data["name"] = this.name;
        data["type"] = this.type;
        data["currency"] = this.currency;
        data["responsible"] = this.responsible;
        data["counterParty"] = this.counterParty;
        data["agentParty"] = this.agentParty;
        data["legacyId"] = this.legacyId;
        data["closed"] = this.closed ? this.closed.toISOString() : undefined as any;
        data["closedBy"] = this.closedBy;
        data["deleted"] = this.deleted ? this.deleted.toISOString() : undefined as any;
        data["deletedBy"] = this.deletedBy;
        data["created"] = this.created ? this.created.toISOString() : undefined as any;
        data["createdBy"] = this.createdBy;
        data["modified"] = this.modified ? this.modified.toISOString() : undefined as any;
        data["modifiedBy"] = this.modifiedBy;
        data["agentPartyNavigation"] = this.agentPartyNavigation ? this.agentPartyNavigation.toJSON() : undefined as any;
        data["counterPartyNavigation"] = this.counterPartyNavigation ? this.counterPartyNavigation.toJSON() : undefined as any;
        data["responsibleNavigation"] = this.responsibleNavigation ? this.responsibleNavigation.toJSON() : undefined as any;
        data["typeNavigation"] = this.typeNavigation ? this.typeNavigation.toJSON() : undefined as any;
        if (Array.isArray(this.contractPartyRoles)) {
            data["contractPartyRoles"] = [];
            for (let item of this.contractPartyRoles)
                data["contractPartyRoles"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.products)) {
            data["products"] = [];
            for (let item of this.products)
                data["products"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IContract {
    id?: number;
    num?: string | undefined;
    name: string;
    type: string;
    currency?: string | undefined;
    responsible?: number;
    counterParty?: string | undefined;
    agentParty?: string | undefined;
    legacyId?: number | undefined;
    closed?: Date | undefined;
    closedBy?: number | undefined;
    deleted?: Date | undefined;
    deletedBy?: number | undefined;
    created?: Date | undefined;
    createdBy?: number | undefined;
    modified?: Date | undefined;
    modifiedBy?: number | undefined;
    agentPartyNavigation?: Party | undefined;
    counterPartyNavigation?: Party | undefined;
    responsibleNavigation?: User | undefined;
    typeNavigation?: ContractType | undefined;
    contractPartyRoles?: ContractPartyRole[] | undefined;
    products?: Product[] | undefined;
}

export class Party implements IParty {
    id?: number;
    num?: string | undefined;
    name!: string;
    nameBeforeKey?: string | undefined;
    nameKey?: string | undefined;
    attention?: string | undefined;
    address?: string | undefined;
    address2?: string | undefined;
    country?: string | undefined;
    comments?: string | undefined;
    publicId?: string | undefined;
    publicIdIsCompany?: boolean | undefined;
    legacyId?: string | undefined;
    phone?: string | undefined;
    email?: string | undefined;
    url?: string | undefined;
    carrier?: string | undefined;
    carrierServicePoint?: string | undefined;
    isAuthor?: boolean;
    isPublisher?: boolean;
    isAgent?: boolean;
    isVendor?: boolean;
    isReviewer?: boolean;
    tags?: string[] | undefined;
    created?: Date | undefined;
    createdBy?: number | undefined;
    modified?: Date | undefined;
    modifiedBy?: number | undefined;
    contractAgentPartyNavigations?: Contract[] | undefined;
    contractCounterPartyNavigations?: Contract[] | undefined;
    contractPartyRoles?: ContractPartyRole[] | undefined;
    contractSaleAgentPartyNavigations?: ContractSale[] | undefined;
    contractSaleCounterPartyNavigations?: ContractSale[] | undefined;
    partyContacts?: PartyContact[] | undefined;
    productPartyRoles?: ProductPartyRole[] | undefined;
    projectTaskContacts?: ProjectTaskContact[] | undefined;
    vendors?: Vendor[] | undefined;

    constructor(data?: IParty) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.num = _data["num"];
            this.name = _data["name"];
            this.nameBeforeKey = _data["nameBeforeKey"];
            this.nameKey = _data["nameKey"];
            this.attention = _data["attention"];
            this.address = _data["address"];
            this.address2 = _data["address2"];
            this.country = _data["country"];
            this.comments = _data["comments"];
            this.publicId = _data["publicId"];
            this.publicIdIsCompany = _data["publicIdIsCompany"];
            this.legacyId = _data["legacyId"];
            this.phone = _data["phone"];
            this.email = _data["email"];
            this.url = _data["url"];
            this.carrier = _data["carrier"];
            this.carrierServicePoint = _data["carrierServicePoint"];
            this.isAuthor = _data["isAuthor"];
            this.isPublisher = _data["isPublisher"];
            this.isAgent = _data["isAgent"];
            this.isVendor = _data["isVendor"];
            this.isReviewer = _data["isReviewer"];
            if (Array.isArray(_data["tags"])) {
                this.tags = [] as any;
                for (let item of _data["tags"])
                    this.tags!.push(item);
            }
            this.created = _data["created"] ? new Date(_data["created"].toString()) : undefined as any;
            this.createdBy = _data["createdBy"];
            this.modified = _data["modified"] ? new Date(_data["modified"].toString()) : undefined as any;
            this.modifiedBy = _data["modifiedBy"];
            if (Array.isArray(_data["contractAgentPartyNavigations"])) {
                this.contractAgentPartyNavigations = [] as any;
                for (let item of _data["contractAgentPartyNavigations"])
                    this.contractAgentPartyNavigations!.push(Contract.fromJS(item));
            }
            if (Array.isArray(_data["contractCounterPartyNavigations"])) {
                this.contractCounterPartyNavigations = [] as any;
                for (let item of _data["contractCounterPartyNavigations"])
                    this.contractCounterPartyNavigations!.push(Contract.fromJS(item));
            }
            if (Array.isArray(_data["contractPartyRoles"])) {
                this.contractPartyRoles = [] as any;
                for (let item of _data["contractPartyRoles"])
                    this.contractPartyRoles!.push(ContractPartyRole.fromJS(item));
            }
            if (Array.isArray(_data["contractSaleAgentPartyNavigations"])) {
                this.contractSaleAgentPartyNavigations = [] as any;
                for (let item of _data["contractSaleAgentPartyNavigations"])
                    this.contractSaleAgentPartyNavigations!.push(ContractSale.fromJS(item));
            }
            if (Array.isArray(_data["contractSaleCounterPartyNavigations"])) {
                this.contractSaleCounterPartyNavigations = [] as any;
                for (let item of _data["contractSaleCounterPartyNavigations"])
                    this.contractSaleCounterPartyNavigations!.push(ContractSale.fromJS(item));
            }
            if (Array.isArray(_data["partyContacts"])) {
                this.partyContacts = [] as any;
                for (let item of _data["partyContacts"])
                    this.partyContacts!.push(PartyContact.fromJS(item));
            }
            if (Array.isArray(_data["productPartyRoles"])) {
                this.productPartyRoles = [] as any;
                for (let item of _data["productPartyRoles"])
                    this.productPartyRoles!.push(ProductPartyRole.fromJS(item));
            }
            if (Array.isArray(_data["projectTaskContacts"])) {
                this.projectTaskContacts = [] as any;
                for (let item of _data["projectTaskContacts"])
                    this.projectTaskContacts!.push(ProjectTaskContact.fromJS(item));
            }
            if (Array.isArray(_data["vendors"])) {
                this.vendors = [] as any;
                for (let item of _data["vendors"])
                    this.vendors!.push(Vendor.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Party {
        data = typeof data === 'object' ? data : {};
        let result = new Party();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["num"] = this.num;
        data["name"] = this.name;
        data["nameBeforeKey"] = this.nameBeforeKey;
        data["nameKey"] = this.nameKey;
        data["attention"] = this.attention;
        data["address"] = this.address;
        data["address2"] = this.address2;
        data["country"] = this.country;
        data["comments"] = this.comments;
        data["publicId"] = this.publicId;
        data["publicIdIsCompany"] = this.publicIdIsCompany;
        data["legacyId"] = this.legacyId;
        data["phone"] = this.phone;
        data["email"] = this.email;
        data["url"] = this.url;
        data["carrier"] = this.carrier;
        data["carrierServicePoint"] = this.carrierServicePoint;
        data["isAuthor"] = this.isAuthor;
        data["isPublisher"] = this.isPublisher;
        data["isAgent"] = this.isAgent;
        data["isVendor"] = this.isVendor;
        data["isReviewer"] = this.isReviewer;
        if (Array.isArray(this.tags)) {
            data["tags"] = [];
            for (let item of this.tags)
                data["tags"].push(item);
        }
        data["created"] = this.created ? this.created.toISOString() : undefined as any;
        data["createdBy"] = this.createdBy;
        data["modified"] = this.modified ? this.modified.toISOString() : undefined as any;
        data["modifiedBy"] = this.modifiedBy;
        if (Array.isArray(this.contractAgentPartyNavigations)) {
            data["contractAgentPartyNavigations"] = [];
            for (let item of this.contractAgentPartyNavigations)
                data["contractAgentPartyNavigations"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.contractCounterPartyNavigations)) {
            data["contractCounterPartyNavigations"] = [];
            for (let item of this.contractCounterPartyNavigations)
                data["contractCounterPartyNavigations"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.contractPartyRoles)) {
            data["contractPartyRoles"] = [];
            for (let item of this.contractPartyRoles)
                data["contractPartyRoles"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.contractSaleAgentPartyNavigations)) {
            data["contractSaleAgentPartyNavigations"] = [];
            for (let item of this.contractSaleAgentPartyNavigations)
                data["contractSaleAgentPartyNavigations"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.contractSaleCounterPartyNavigations)) {
            data["contractSaleCounterPartyNavigations"] = [];
            for (let item of this.contractSaleCounterPartyNavigations)
                data["contractSaleCounterPartyNavigations"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.partyContacts)) {
            data["partyContacts"] = [];
            for (let item of this.partyContacts)
                data["partyContacts"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.productPartyRoles)) {
            data["productPartyRoles"] = [];
            for (let item of this.productPartyRoles)
                data["productPartyRoles"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.projectTaskContacts)) {
            data["projectTaskContacts"] = [];
            for (let item of this.projectTaskContacts)
                data["projectTaskContacts"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.vendors)) {
            data["vendors"] = [];
            for (let item of this.vendors)
                data["vendors"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IParty {
    id?: number;
    num?: string | undefined;
    name: string;
    nameBeforeKey?: string | undefined;
    nameKey?: string | undefined;
    attention?: string | undefined;
    address?: string | undefined;
    address2?: string | undefined;
    country?: string | undefined;
    comments?: string | undefined;
    publicId?: string | undefined;
    publicIdIsCompany?: boolean | undefined;
    legacyId?: string | undefined;
    phone?: string | undefined;
    email?: string | undefined;
    url?: string | undefined;
    carrier?: string | undefined;
    carrierServicePoint?: string | undefined;
    isAuthor?: boolean;
    isPublisher?: boolean;
    isAgent?: boolean;
    isVendor?: boolean;
    isReviewer?: boolean;
    tags?: string[] | undefined;
    created?: Date | undefined;
    createdBy?: number | undefined;
    modified?: Date | undefined;
    modifiedBy?: number | undefined;
    contractAgentPartyNavigations?: Contract[] | undefined;
    contractCounterPartyNavigations?: Contract[] | undefined;
    contractPartyRoles?: ContractPartyRole[] | undefined;
    contractSaleAgentPartyNavigations?: ContractSale[] | undefined;
    contractSaleCounterPartyNavigations?: ContractSale[] | undefined;
    partyContacts?: PartyContact[] | undefined;
    productPartyRoles?: ProductPartyRole[] | undefined;
    projectTaskContacts?: ProjectTaskContact[] | undefined;
    vendors?: Vendor[] | undefined;
}

export class ContractPartyRole implements IContractPartyRole {
    id?: number;
    contract!: string;
    party!: string;
    partyRole!: string;
    fromDate?: Date | undefined;
    toDate?: Date | undefined;
    created?: Date | undefined;
    createdBy?: number | undefined;
    modified?: Date | undefined;
    modifiedBy?: number | undefined;
    contractNavigation?: Contract | undefined;
    partyNavigation?: Party | undefined;
    partyRoleNavigation?: PartyRole | undefined;

    constructor(data?: IContractPartyRole) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.contract = _data["contract"];
            this.party = _data["party"];
            this.partyRole = _data["partyRole"];
            this.fromDate = _data["fromDate"] ? new Date(_data["fromDate"].toString()) : undefined as any;
            this.toDate = _data["toDate"] ? new Date(_data["toDate"].toString()) : undefined as any;
            this.created = _data["created"] ? new Date(_data["created"].toString()) : undefined as any;
            this.createdBy = _data["createdBy"];
            this.modified = _data["modified"] ? new Date(_data["modified"].toString()) : undefined as any;
            this.modifiedBy = _data["modifiedBy"];
            this.contractNavigation = _data["contractNavigation"] ? Contract.fromJS(_data["contractNavigation"]) : undefined as any;
            this.partyNavigation = _data["partyNavigation"] ? Party.fromJS(_data["partyNavigation"]) : undefined as any;
            this.partyRoleNavigation = _data["partyRoleNavigation"] ? PartyRole.fromJS(_data["partyRoleNavigation"]) : undefined as any;
        }
    }

    static fromJS(data: any): ContractPartyRole {
        data = typeof data === 'object' ? data : {};
        let result = new ContractPartyRole();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["contract"] = this.contract;
        data["party"] = this.party;
        data["partyRole"] = this.partyRole;
        data["fromDate"] = this.fromDate ? this.fromDate.toISOString() : undefined as any;
        data["toDate"] = this.toDate ? this.toDate.toISOString() : undefined as any;
        data["created"] = this.created ? this.created.toISOString() : undefined as any;
        data["createdBy"] = this.createdBy;
        data["modified"] = this.modified ? this.modified.toISOString() : undefined as any;
        data["modifiedBy"] = this.modifiedBy;
        data["contractNavigation"] = this.contractNavigation ? this.contractNavigation.toJSON() : undefined as any;
        data["partyNavigation"] = this.partyNavigation ? this.partyNavigation.toJSON() : undefined as any;
        data["partyRoleNavigation"] = this.partyRoleNavigation ? this.partyRoleNavigation.toJSON() : undefined as any;
        return data;
    }
}

export interface IContractPartyRole {
    id?: number;
    contract: string;
    party: string;
    partyRole: string;
    fromDate?: Date | undefined;
    toDate?: Date | undefined;
    created?: Date | undefined;
    createdBy?: number | undefined;
    modified?: Date | undefined;
    modifiedBy?: number | undefined;
    contractNavigation?: Contract | undefined;
    partyNavigation?: Party | undefined;
    partyRoleNavigation?: PartyRole | undefined;
}

export class PartyRole implements IPartyRole {
    id?: number;
    num?: string | undefined;
    name!: string;
    isContract?: boolean | undefined;
    isProduct?: boolean | undefined;
    isProductReviewer?: boolean | undefined;
    onix?: string | undefined;
    onixName?: string | undefined;
    created?: Date | undefined;
    createdBy?: number | undefined;
    modified?: Date | undefined;
    modifiedBy?: number | undefined;
    contractPartyRoles?: ContractPartyRole[] | undefined;
    productPartyRoles?: ProductPartyRole[] | undefined;
    projectTaskContacts?: ProjectTaskContact[] | undefined;

    constructor(data?: IPartyRole) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.num = _data["num"];
            this.name = _data["name"];
            this.isContract = _data["isContract"];
            this.isProduct = _data["isProduct"];
            this.isProductReviewer = _data["isProductReviewer"];
            this.onix = _data["onix"];
            this.onixName = _data["onixName"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : undefined as any;
            this.createdBy = _data["createdBy"];
            this.modified = _data["modified"] ? new Date(_data["modified"].toString()) : undefined as any;
            this.modifiedBy = _data["modifiedBy"];
            if (Array.isArray(_data["contractPartyRoles"])) {
                this.contractPartyRoles = [] as any;
                for (let item of _data["contractPartyRoles"])
                    this.contractPartyRoles!.push(ContractPartyRole.fromJS(item));
            }
            if (Array.isArray(_data["productPartyRoles"])) {
                this.productPartyRoles = [] as any;
                for (let item of _data["productPartyRoles"])
                    this.productPartyRoles!.push(ProductPartyRole.fromJS(item));
            }
            if (Array.isArray(_data["projectTaskContacts"])) {
                this.projectTaskContacts = [] as any;
                for (let item of _data["projectTaskContacts"])
                    this.projectTaskContacts!.push(ProjectTaskContact.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PartyRole {
        data = typeof data === 'object' ? data : {};
        let result = new PartyRole();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["num"] = this.num;
        data["name"] = this.name;
        data["isContract"] = this.isContract;
        data["isProduct"] = this.isProduct;
        data["isProductReviewer"] = this.isProductReviewer;
        data["onix"] = this.onix;
        data["onixName"] = this.onixName;
        data["created"] = this.created ? this.created.toISOString() : undefined as any;
        data["createdBy"] = this.createdBy;
        data["modified"] = this.modified ? this.modified.toISOString() : undefined as any;
        data["modifiedBy"] = this.modifiedBy;
        if (Array.isArray(this.contractPartyRoles)) {
            data["contractPartyRoles"] = [];
            for (let item of this.contractPartyRoles)
                data["contractPartyRoles"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.productPartyRoles)) {
            data["productPartyRoles"] = [];
            for (let item of this.productPartyRoles)
                data["productPartyRoles"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.projectTaskContacts)) {
            data["projectTaskContacts"] = [];
            for (let item of this.projectTaskContacts)
                data["projectTaskContacts"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IPartyRole {
    id?: number;
    num?: string | undefined;
    name: string;
    isContract?: boolean | undefined;
    isProduct?: boolean | undefined;
    isProductReviewer?: boolean | undefined;
    onix?: string | undefined;
    onixName?: string | undefined;
    created?: Date | undefined;
    createdBy?: number | undefined;
    modified?: Date | undefined;
    modifiedBy?: number | undefined;
    contractPartyRoles?: ContractPartyRole[] | undefined;
    productPartyRoles?: ProductPartyRole[] | undefined;
    projectTaskContacts?: ProjectTaskContact[] | undefined;
}

export class ProductPartyRole implements IProductPartyRole {
    id?: number;
    product!: string;
    party!: string;
    partyRole!: string;
    fromDate?: Date | undefined;
    toDate?: Date | undefined;
    created?: Date | undefined;
    createdBy?: number | undefined;
    modified?: Date | undefined;
    modifiedBy?: number | undefined;
    partyNavigation?: Party | undefined;
    partyRoleNavigation?: PartyRole | undefined;
    productNavigation?: Product | undefined;

    constructor(data?: IProductPartyRole) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.product = _data["product"];
            this.party = _data["party"];
            this.partyRole = _data["partyRole"];
            this.fromDate = _data["fromDate"] ? new Date(_data["fromDate"].toString()) : undefined as any;
            this.toDate = _data["toDate"] ? new Date(_data["toDate"].toString()) : undefined as any;
            this.created = _data["created"] ? new Date(_data["created"].toString()) : undefined as any;
            this.createdBy = _data["createdBy"];
            this.modified = _data["modified"] ? new Date(_data["modified"].toString()) : undefined as any;
            this.modifiedBy = _data["modifiedBy"];
            this.partyNavigation = _data["partyNavigation"] ? Party.fromJS(_data["partyNavigation"]) : undefined as any;
            this.partyRoleNavigation = _data["partyRoleNavigation"] ? PartyRole.fromJS(_data["partyRoleNavigation"]) : undefined as any;
            this.productNavigation = _data["productNavigation"] ? Product.fromJS(_data["productNavigation"]) : undefined as any;
        }
    }

    static fromJS(data: any): ProductPartyRole {
        data = typeof data === 'object' ? data : {};
        let result = new ProductPartyRole();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["product"] = this.product;
        data["party"] = this.party;
        data["partyRole"] = this.partyRole;
        data["fromDate"] = this.fromDate ? this.fromDate.toISOString() : undefined as any;
        data["toDate"] = this.toDate ? this.toDate.toISOString() : undefined as any;
        data["created"] = this.created ? this.created.toISOString() : undefined as any;
        data["createdBy"] = this.createdBy;
        data["modified"] = this.modified ? this.modified.toISOString() : undefined as any;
        data["modifiedBy"] = this.modifiedBy;
        data["partyNavigation"] = this.partyNavigation ? this.partyNavigation.toJSON() : undefined as any;
        data["partyRoleNavigation"] = this.partyRoleNavigation ? this.partyRoleNavigation.toJSON() : undefined as any;
        data["productNavigation"] = this.productNavigation ? this.productNavigation.toJSON() : undefined as any;
        return data;
    }
}

export interface IProductPartyRole {
    id?: number;
    product: string;
    party: string;
    partyRole: string;
    fromDate?: Date | undefined;
    toDate?: Date | undefined;
    created?: Date | undefined;
    createdBy?: number | undefined;
    modified?: Date | undefined;
    modifiedBy?: number | undefined;
    partyNavigation?: Party | undefined;
    partyRoleNavigation?: PartyRole | undefined;
    productNavigation?: Product | undefined;
}

export class ProjectTaskContact implements IProjectTaskContact {
    id?: number;
    task?: number | undefined;
    partyRole?: string | undefined;
    party?: string | undefined;
    contact?: string | undefined;
    name?: string | undefined;
    status?: string | undefined;
    responsibleTeam?: string | undefined;
    responsibleUser?: string | undefined;
    description?: string | undefined;
    document?: string | undefined;
    created?: Date | undefined;
    createdBy?: number | undefined;
    modified?: Date | undefined;
    modifiedBy?: number | undefined;
    partyNavigation?: Party | undefined;
    partyRoleNavigation?: PartyRole | undefined;
    responsibleTeamNavigation?: Team | undefined;
    responsibleUserNavigation?: User | undefined;
    statusNavigation?: ProjectTaskStatus | undefined;
    taskNavigation?: ProjectTask | undefined;

    constructor(data?: IProjectTaskContact) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.task = _data["task"];
            this.partyRole = _data["partyRole"];
            this.party = _data["party"];
            this.contact = _data["contact"];
            this.name = _data["name"];
            this.status = _data["status"];
            this.responsibleTeam = _data["responsibleTeam"];
            this.responsibleUser = _data["responsibleUser"];
            this.description = _data["description"];
            this.document = _data["document"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : undefined as any;
            this.createdBy = _data["createdBy"];
            this.modified = _data["modified"] ? new Date(_data["modified"].toString()) : undefined as any;
            this.modifiedBy = _data["modifiedBy"];
            this.partyNavigation = _data["partyNavigation"] ? Party.fromJS(_data["partyNavigation"]) : undefined as any;
            this.partyRoleNavigation = _data["partyRoleNavigation"] ? PartyRole.fromJS(_data["partyRoleNavigation"]) : undefined as any;
            this.responsibleTeamNavigation = _data["responsibleTeamNavigation"] ? Team.fromJS(_data["responsibleTeamNavigation"]) : undefined as any;
            this.responsibleUserNavigation = _data["responsibleUserNavigation"] ? User.fromJS(_data["responsibleUserNavigation"]) : undefined as any;
            this.statusNavigation = _data["statusNavigation"] ? ProjectTaskStatus.fromJS(_data["statusNavigation"]) : undefined as any;
            this.taskNavigation = _data["taskNavigation"] ? ProjectTask.fromJS(_data["taskNavigation"]) : undefined as any;
        }
    }

    static fromJS(data: any): ProjectTaskContact {
        data = typeof data === 'object' ? data : {};
        let result = new ProjectTaskContact();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["task"] = this.task;
        data["partyRole"] = this.partyRole;
        data["party"] = this.party;
        data["contact"] = this.contact;
        data["name"] = this.name;
        data["status"] = this.status;
        data["responsibleTeam"] = this.responsibleTeam;
        data["responsibleUser"] = this.responsibleUser;
        data["description"] = this.description;
        data["document"] = this.document;
        data["created"] = this.created ? this.created.toISOString() : undefined as any;
        data["createdBy"] = this.createdBy;
        data["modified"] = this.modified ? this.modified.toISOString() : undefined as any;
        data["modifiedBy"] = this.modifiedBy;
        data["partyNavigation"] = this.partyNavigation ? this.partyNavigation.toJSON() : undefined as any;
        data["partyRoleNavigation"] = this.partyRoleNavigation ? this.partyRoleNavigation.toJSON() : undefined as any;
        data["responsibleTeamNavigation"] = this.responsibleTeamNavigation ? this.responsibleTeamNavigation.toJSON() : undefined as any;
        data["responsibleUserNavigation"] = this.responsibleUserNavigation ? this.responsibleUserNavigation.toJSON() : undefined as any;
        data["statusNavigation"] = this.statusNavigation ? this.statusNavigation.toJSON() : undefined as any;
        data["taskNavigation"] = this.taskNavigation ? this.taskNavigation.toJSON() : undefined as any;
        return data;
    }
}

export interface IProjectTaskContact {
    id?: number;
    task?: number | undefined;
    partyRole?: string | undefined;
    party?: string | undefined;
    contact?: string | undefined;
    name?: string | undefined;
    status?: string | undefined;
    responsibleTeam?: string | undefined;
    responsibleUser?: string | undefined;
    description?: string | undefined;
    document?: string | undefined;
    created?: Date | undefined;
    createdBy?: number | undefined;
    modified?: Date | undefined;
    modifiedBy?: number | undefined;
    partyNavigation?: Party | undefined;
    partyRoleNavigation?: PartyRole | undefined;
    responsibleTeamNavigation?: Team | undefined;
    responsibleUserNavigation?: User | undefined;
    statusNavigation?: ProjectTaskStatus | undefined;
    taskNavigation?: ProjectTask | undefined;
}

export class Team implements ITeam {
    id?: number;
    num?: string | undefined;
    name!: string;
    created?: Date | undefined;
    createdBy?: number | undefined;
    modified?: Date | undefined;
    modifiedBy?: number | undefined;
    projectNodes?: ProjectNode[] | undefined;
    projectTaskContacts?: ProjectTaskContact[] | undefined;
    projectTasks?: ProjectTask[] | undefined;
    projectTaskTypes?: ProjectTaskType[] | undefined;
    teamUsers?: TeamUser[] | undefined;

    constructor(data?: ITeam) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.num = _data["num"];
            this.name = _data["name"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : undefined as any;
            this.createdBy = _data["createdBy"];
            this.modified = _data["modified"] ? new Date(_data["modified"].toString()) : undefined as any;
            this.modifiedBy = _data["modifiedBy"];
            if (Array.isArray(_data["projectNodes"])) {
                this.projectNodes = [] as any;
                for (let item of _data["projectNodes"])
                    this.projectNodes!.push(ProjectNode.fromJS(item));
            }
            if (Array.isArray(_data["projectTaskContacts"])) {
                this.projectTaskContacts = [] as any;
                for (let item of _data["projectTaskContacts"])
                    this.projectTaskContacts!.push(ProjectTaskContact.fromJS(item));
            }
            if (Array.isArray(_data["projectTasks"])) {
                this.projectTasks = [] as any;
                for (let item of _data["projectTasks"])
                    this.projectTasks!.push(ProjectTask.fromJS(item));
            }
            if (Array.isArray(_data["projectTaskTypes"])) {
                this.projectTaskTypes = [] as any;
                for (let item of _data["projectTaskTypes"])
                    this.projectTaskTypes!.push(ProjectTaskType.fromJS(item));
            }
            if (Array.isArray(_data["teamUsers"])) {
                this.teamUsers = [] as any;
                for (let item of _data["teamUsers"])
                    this.teamUsers!.push(TeamUser.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Team {
        data = typeof data === 'object' ? data : {};
        let result = new Team();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["num"] = this.num;
        data["name"] = this.name;
        data["created"] = this.created ? this.created.toISOString() : undefined as any;
        data["createdBy"] = this.createdBy;
        data["modified"] = this.modified ? this.modified.toISOString() : undefined as any;
        data["modifiedBy"] = this.modifiedBy;
        if (Array.isArray(this.projectNodes)) {
            data["projectNodes"] = [];
            for (let item of this.projectNodes)
                data["projectNodes"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.projectTaskContacts)) {
            data["projectTaskContacts"] = [];
            for (let item of this.projectTaskContacts)
                data["projectTaskContacts"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.projectTasks)) {
            data["projectTasks"] = [];
            for (let item of this.projectTasks)
                data["projectTasks"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.projectTaskTypes)) {
            data["projectTaskTypes"] = [];
            for (let item of this.projectTaskTypes)
                data["projectTaskTypes"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.teamUsers)) {
            data["teamUsers"] = [];
            for (let item of this.teamUsers)
                data["teamUsers"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ITeam {
    id?: number;
    num?: string | undefined;
    name: string;
    created?: Date | undefined;
    createdBy?: number | undefined;
    modified?: Date | undefined;
    modifiedBy?: number | undefined;
    projectNodes?: ProjectNode[] | undefined;
    projectTaskContacts?: ProjectTaskContact[] | undefined;
    projectTasks?: ProjectTask[] | undefined;
    projectTaskTypes?: ProjectTaskType[] | undefined;
    teamUsers?: TeamUser[] | undefined;
}

export class ProjectNode implements IProjectNode {
    id?: number;
    num!: string;
    name!: string;
    parentId?: number | undefined;
    level?: number | undefined;
    responsible!: string;
    taskStatus?: string | undefined;
    taskType?: string | undefined;
    taskResponsibleTeam?: string | undefined;
    taskResponsibleUser?: string | undefined;
    created?: Date | undefined;
    createdBy?: number | undefined;
    modified?: Date | undefined;
    modifiedBy?: number | undefined;
    levelNavigation?: ProjectLevel | undefined;
    parent?: ProjectNode | undefined;
    responsibleNavigation?: User | undefined;
    taskResponsibleTeamNavigation?: Team | undefined;
    taskResponsibleUserNavigation?: User | undefined;
    taskStatusNavigation?: ProjectTaskStatus | undefined;
    taskTypeNavigation?: ProjectTaskType | undefined;
    inverseParent?: ProjectNode[] | undefined;
    projectTasks?: ProjectTask[] | undefined;

    constructor(data?: IProjectNode) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.num = _data["num"];
            this.name = _data["name"];
            this.parentId = _data["parentId"];
            this.level = _data["level"];
            this.responsible = _data["responsible"];
            this.taskStatus = _data["taskStatus"];
            this.taskType = _data["taskType"];
            this.taskResponsibleTeam = _data["taskResponsibleTeam"];
            this.taskResponsibleUser = _data["taskResponsibleUser"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : undefined as any;
            this.createdBy = _data["createdBy"];
            this.modified = _data["modified"] ? new Date(_data["modified"].toString()) : undefined as any;
            this.modifiedBy = _data["modifiedBy"];
            this.levelNavigation = _data["levelNavigation"] ? ProjectLevel.fromJS(_data["levelNavigation"]) : undefined as any;
            this.parent = _data["parent"] ? ProjectNode.fromJS(_data["parent"]) : undefined as any;
            this.responsibleNavigation = _data["responsibleNavigation"] ? User.fromJS(_data["responsibleNavigation"]) : undefined as any;
            this.taskResponsibleTeamNavigation = _data["taskResponsibleTeamNavigation"] ? Team.fromJS(_data["taskResponsibleTeamNavigation"]) : undefined as any;
            this.taskResponsibleUserNavigation = _data["taskResponsibleUserNavigation"] ? User.fromJS(_data["taskResponsibleUserNavigation"]) : undefined as any;
            this.taskStatusNavigation = _data["taskStatusNavigation"] ? ProjectTaskStatus.fromJS(_data["taskStatusNavigation"]) : undefined as any;
            this.taskTypeNavigation = _data["taskTypeNavigation"] ? ProjectTaskType.fromJS(_data["taskTypeNavigation"]) : undefined as any;
            if (Array.isArray(_data["inverseParent"])) {
                this.inverseParent = [] as any;
                for (let item of _data["inverseParent"])
                    this.inverseParent!.push(ProjectNode.fromJS(item));
            }
            if (Array.isArray(_data["projectTasks"])) {
                this.projectTasks = [] as any;
                for (let item of _data["projectTasks"])
                    this.projectTasks!.push(ProjectTask.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ProjectNode {
        data = typeof data === 'object' ? data : {};
        let result = new ProjectNode();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["num"] = this.num;
        data["name"] = this.name;
        data["parentId"] = this.parentId;
        data["level"] = this.level;
        data["responsible"] = this.responsible;
        data["taskStatus"] = this.taskStatus;
        data["taskType"] = this.taskType;
        data["taskResponsibleTeam"] = this.taskResponsibleTeam;
        data["taskResponsibleUser"] = this.taskResponsibleUser;
        data["created"] = this.created ? this.created.toISOString() : undefined as any;
        data["createdBy"] = this.createdBy;
        data["modified"] = this.modified ? this.modified.toISOString() : undefined as any;
        data["modifiedBy"] = this.modifiedBy;
        data["levelNavigation"] = this.levelNavigation ? this.levelNavigation.toJSON() : undefined as any;
        data["parent"] = this.parent ? this.parent.toJSON() : undefined as any;
        data["responsibleNavigation"] = this.responsibleNavigation ? this.responsibleNavigation.toJSON() : undefined as any;
        data["taskResponsibleTeamNavigation"] = this.taskResponsibleTeamNavigation ? this.taskResponsibleTeamNavigation.toJSON() : undefined as any;
        data["taskResponsibleUserNavigation"] = this.taskResponsibleUserNavigation ? this.taskResponsibleUserNavigation.toJSON() : undefined as any;
        data["taskStatusNavigation"] = this.taskStatusNavigation ? this.taskStatusNavigation.toJSON() : undefined as any;
        data["taskTypeNavigation"] = this.taskTypeNavigation ? this.taskTypeNavigation.toJSON() : undefined as any;
        if (Array.isArray(this.inverseParent)) {
            data["inverseParent"] = [];
            for (let item of this.inverseParent)
                data["inverseParent"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.projectTasks)) {
            data["projectTasks"] = [];
            for (let item of this.projectTasks)
                data["projectTasks"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IProjectNode {
    id?: number;
    num: string;
    name: string;
    parentId?: number | undefined;
    level?: number | undefined;
    responsible: string;
    taskStatus?: string | undefined;
    taskType?: string | undefined;
    taskResponsibleTeam?: string | undefined;
    taskResponsibleUser?: string | undefined;
    created?: Date | undefined;
    createdBy?: number | undefined;
    modified?: Date | undefined;
    modifiedBy?: number | undefined;
    levelNavigation?: ProjectLevel | undefined;
    parent?: ProjectNode | undefined;
    responsibleNavigation?: User | undefined;
    taskResponsibleTeamNavigation?: Team | undefined;
    taskResponsibleUserNavigation?: User | undefined;
    taskStatusNavigation?: ProjectTaskStatus | undefined;
    taskTypeNavigation?: ProjectTaskType | undefined;
    inverseParent?: ProjectNode[] | undefined;
    projectTasks?: ProjectTask[] | undefined;
}

export class ProjectLevel implements IProjectLevel {
    id?: number;
    name?: string | undefined;
    created?: Date | undefined;
    createdBy?: number | undefined;
    modified?: Date | undefined;
    modifiedBy?: number | undefined;
    projectNodes?: ProjectNode[] | undefined;

    constructor(data?: IProjectLevel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : undefined as any;
            this.createdBy = _data["createdBy"];
            this.modified = _data["modified"] ? new Date(_data["modified"].toString()) : undefined as any;
            this.modifiedBy = _data["modifiedBy"];
            if (Array.isArray(_data["projectNodes"])) {
                this.projectNodes = [] as any;
                for (let item of _data["projectNodes"])
                    this.projectNodes!.push(ProjectNode.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ProjectLevel {
        data = typeof data === 'object' ? data : {};
        let result = new ProjectLevel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["created"] = this.created ? this.created.toISOString() : undefined as any;
        data["createdBy"] = this.createdBy;
        data["modified"] = this.modified ? this.modified.toISOString() : undefined as any;
        data["modifiedBy"] = this.modifiedBy;
        if (Array.isArray(this.projectNodes)) {
            data["projectNodes"] = [];
            for (let item of this.projectNodes)
                data["projectNodes"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IProjectLevel {
    id?: number;
    name?: string | undefined;
    created?: Date | undefined;
    createdBy?: number | undefined;
    modified?: Date | undefined;
    modifiedBy?: number | undefined;
    projectNodes?: ProjectNode[] | undefined;
}

export class User implements IUser {
    id?: number;
    shortName!: string;
    name!: string;
    appUserId?: string | undefined;
    email?: string | undefined;
    active?: boolean;
    chatNotify?: number | undefined;
    locale?: string | undefined;
    uiPagerShow?: boolean;
    legacyId?: number | undefined;
    created?: Date | undefined;
    createdBy?: number | undefined;
    modified?: Date | undefined;
    modifiedBy?: number | undefined;
    localeNavigation?: GlobalLocale | undefined;
    bankAccountTransactions?: BankAccountTransaction[] | undefined;
    bankCreditCards?: BankCreditCard[] | undefined;
    chatUsers?: ChatUser[] | undefined;
    contracts?: Contract[] | undefined;
    contractSales?: ContractSale[] | undefined;
    dataProcessStageProperties?: DataProcessStageProperty[] | undefined;
    dataProcessStages?: DataProcessStage[] | undefined;
    dataTagTypes?: DataTagType[] | undefined;
    products?: Product[] | undefined;
    productSeries?: ProductSeries[] | undefined;
    projectNodeResponsibleNavigations?: ProjectNode[] | undefined;
    projectNodeTaskResponsibleUserNavigations?: ProjectNode[] | undefined;
    projectTaskContacts?: ProjectTaskContact[] | undefined;
    projectTasks?: ProjectTask[] | undefined;
    projectTaskTypes?: ProjectTaskType[] | undefined;
    rightsApprovals?: RightsApproval[] | undefined;
    roleUsers?: RoleUser[] | undefined;
    teamUsers?: TeamUser[] | undefined;
    userApprovalDelegationUserDelegateeNavigations?: UserApprovalDelegation[] | undefined;
    userApprovalDelegationUserNavigations?: UserApprovalDelegation[] | undefined;
    voucherApprovalPolicyUsers?: VoucherApprovalPolicyUser[] | undefined;
    voucherApprovals?: VoucherApproval[] | undefined;
    voucherApproverNavigations?: Voucher[] | undefined;
    voucherCreatedByNavigations?: Voucher[] | undefined;
    voucherMessageChannelUsers?: VoucherMessageChannelUser[] | undefined;
    voucherMessageMailVendorHistories?: VoucherMessageMailVendorHistory[] | undefined;
    voucherModifiedByNavigations?: Voucher[] | undefined;
    voucherRequests?: VoucherRequest[] | undefined;

    constructor(data?: IUser) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.shortName = _data["shortName"];
            this.name = _data["name"];
            this.appUserId = _data["appUserId"];
            this.email = _data["email"];
            this.active = _data["active"];
            this.chatNotify = _data["chatNotify"];
            this.locale = _data["locale"];
            this.uiPagerShow = _data["uiPagerShow"];
            this.legacyId = _data["legacyId"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : undefined as any;
            this.createdBy = _data["createdBy"];
            this.modified = _data["modified"] ? new Date(_data["modified"].toString()) : undefined as any;
            this.modifiedBy = _data["modifiedBy"];
            this.localeNavigation = _data["localeNavigation"] ? GlobalLocale.fromJS(_data["localeNavigation"]) : undefined as any;
            if (Array.isArray(_data["bankAccountTransactions"])) {
                this.bankAccountTransactions = [] as any;
                for (let item of _data["bankAccountTransactions"])
                    this.bankAccountTransactions!.push(BankAccountTransaction.fromJS(item));
            }
            if (Array.isArray(_data["bankCreditCards"])) {
                this.bankCreditCards = [] as any;
                for (let item of _data["bankCreditCards"])
                    this.bankCreditCards!.push(BankCreditCard.fromJS(item));
            }
            if (Array.isArray(_data["chatUsers"])) {
                this.chatUsers = [] as any;
                for (let item of _data["chatUsers"])
                    this.chatUsers!.push(ChatUser.fromJS(item));
            }
            if (Array.isArray(_data["contracts"])) {
                this.contracts = [] as any;
                for (let item of _data["contracts"])
                    this.contracts!.push(Contract.fromJS(item));
            }
            if (Array.isArray(_data["contractSales"])) {
                this.contractSales = [] as any;
                for (let item of _data["contractSales"])
                    this.contractSales!.push(ContractSale.fromJS(item));
            }
            if (Array.isArray(_data["dataProcessStageProperties"])) {
                this.dataProcessStageProperties = [] as any;
                for (let item of _data["dataProcessStageProperties"])
                    this.dataProcessStageProperties!.push(DataProcessStageProperty.fromJS(item));
            }
            if (Array.isArray(_data["dataProcessStages"])) {
                this.dataProcessStages = [] as any;
                for (let item of _data["dataProcessStages"])
                    this.dataProcessStages!.push(DataProcessStage.fromJS(item));
            }
            if (Array.isArray(_data["dataTagTypes"])) {
                this.dataTagTypes = [] as any;
                for (let item of _data["dataTagTypes"])
                    this.dataTagTypes!.push(DataTagType.fromJS(item));
            }
            if (Array.isArray(_data["products"])) {
                this.products = [] as any;
                for (let item of _data["products"])
                    this.products!.push(Product.fromJS(item));
            }
            if (Array.isArray(_data["productSeries"])) {
                this.productSeries = [] as any;
                for (let item of _data["productSeries"])
                    this.productSeries!.push(ProductSeries.fromJS(item));
            }
            if (Array.isArray(_data["projectNodeResponsibleNavigations"])) {
                this.projectNodeResponsibleNavigations = [] as any;
                for (let item of _data["projectNodeResponsibleNavigations"])
                    this.projectNodeResponsibleNavigations!.push(ProjectNode.fromJS(item));
            }
            if (Array.isArray(_data["projectNodeTaskResponsibleUserNavigations"])) {
                this.projectNodeTaskResponsibleUserNavigations = [] as any;
                for (let item of _data["projectNodeTaskResponsibleUserNavigations"])
                    this.projectNodeTaskResponsibleUserNavigations!.push(ProjectNode.fromJS(item));
            }
            if (Array.isArray(_data["projectTaskContacts"])) {
                this.projectTaskContacts = [] as any;
                for (let item of _data["projectTaskContacts"])
                    this.projectTaskContacts!.push(ProjectTaskContact.fromJS(item));
            }
            if (Array.isArray(_data["projectTasks"])) {
                this.projectTasks = [] as any;
                for (let item of _data["projectTasks"])
                    this.projectTasks!.push(ProjectTask.fromJS(item));
            }
            if (Array.isArray(_data["projectTaskTypes"])) {
                this.projectTaskTypes = [] as any;
                for (let item of _data["projectTaskTypes"])
                    this.projectTaskTypes!.push(ProjectTaskType.fromJS(item));
            }
            if (Array.isArray(_data["rightsApprovals"])) {
                this.rightsApprovals = [] as any;
                for (let item of _data["rightsApprovals"])
                    this.rightsApprovals!.push(RightsApproval.fromJS(item));
            }
            if (Array.isArray(_data["roleUsers"])) {
                this.roleUsers = [] as any;
                for (let item of _data["roleUsers"])
                    this.roleUsers!.push(RoleUser.fromJS(item));
            }
            if (Array.isArray(_data["teamUsers"])) {
                this.teamUsers = [] as any;
                for (let item of _data["teamUsers"])
                    this.teamUsers!.push(TeamUser.fromJS(item));
            }
            if (Array.isArray(_data["userApprovalDelegationUserDelegateeNavigations"])) {
                this.userApprovalDelegationUserDelegateeNavigations = [] as any;
                for (let item of _data["userApprovalDelegationUserDelegateeNavigations"])
                    this.userApprovalDelegationUserDelegateeNavigations!.push(UserApprovalDelegation.fromJS(item));
            }
            if (Array.isArray(_data["userApprovalDelegationUserNavigations"])) {
                this.userApprovalDelegationUserNavigations = [] as any;
                for (let item of _data["userApprovalDelegationUserNavigations"])
                    this.userApprovalDelegationUserNavigations!.push(UserApprovalDelegation.fromJS(item));
            }
            if (Array.isArray(_data["voucherApprovalPolicyUsers"])) {
                this.voucherApprovalPolicyUsers = [] as any;
                for (let item of _data["voucherApprovalPolicyUsers"])
                    this.voucherApprovalPolicyUsers!.push(VoucherApprovalPolicyUser.fromJS(item));
            }
            if (Array.isArray(_data["voucherApprovals"])) {
                this.voucherApprovals = [] as any;
                for (let item of _data["voucherApprovals"])
                    this.voucherApprovals!.push(VoucherApproval.fromJS(item));
            }
            if (Array.isArray(_data["voucherApproverNavigations"])) {
                this.voucherApproverNavigations = [] as any;
                for (let item of _data["voucherApproverNavigations"])
                    this.voucherApproverNavigations!.push(Voucher.fromJS(item));
            }
            if (Array.isArray(_data["voucherCreatedByNavigations"])) {
                this.voucherCreatedByNavigations = [] as any;
                for (let item of _data["voucherCreatedByNavigations"])
                    this.voucherCreatedByNavigations!.push(Voucher.fromJS(item));
            }
            if (Array.isArray(_data["voucherMessageChannelUsers"])) {
                this.voucherMessageChannelUsers = [] as any;
                for (let item of _data["voucherMessageChannelUsers"])
                    this.voucherMessageChannelUsers!.push(VoucherMessageChannelUser.fromJS(item));
            }
            if (Array.isArray(_data["voucherMessageMailVendorHistories"])) {
                this.voucherMessageMailVendorHistories = [] as any;
                for (let item of _data["voucherMessageMailVendorHistories"])
                    this.voucherMessageMailVendorHistories!.push(VoucherMessageMailVendorHistory.fromJS(item));
            }
            if (Array.isArray(_data["voucherModifiedByNavigations"])) {
                this.voucherModifiedByNavigations = [] as any;
                for (let item of _data["voucherModifiedByNavigations"])
                    this.voucherModifiedByNavigations!.push(Voucher.fromJS(item));
            }
            if (Array.isArray(_data["voucherRequests"])) {
                this.voucherRequests = [] as any;
                for (let item of _data["voucherRequests"])
                    this.voucherRequests!.push(VoucherRequest.fromJS(item));
            }
        }
    }

    static fromJS(data: any): User {
        data = typeof data === 'object' ? data : {};
        let result = new User();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["shortName"] = this.shortName;
        data["name"] = this.name;
        data["appUserId"] = this.appUserId;
        data["email"] = this.email;
        data["active"] = this.active;
        data["chatNotify"] = this.chatNotify;
        data["locale"] = this.locale;
        data["uiPagerShow"] = this.uiPagerShow;
        data["legacyId"] = this.legacyId;
        data["created"] = this.created ? this.created.toISOString() : undefined as any;
        data["createdBy"] = this.createdBy;
        data["modified"] = this.modified ? this.modified.toISOString() : undefined as any;
        data["modifiedBy"] = this.modifiedBy;
        data["localeNavigation"] = this.localeNavigation ? this.localeNavigation.toJSON() : undefined as any;
        if (Array.isArray(this.bankAccountTransactions)) {
            data["bankAccountTransactions"] = [];
            for (let item of this.bankAccountTransactions)
                data["bankAccountTransactions"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.bankCreditCards)) {
            data["bankCreditCards"] = [];
            for (let item of this.bankCreditCards)
                data["bankCreditCards"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.chatUsers)) {
            data["chatUsers"] = [];
            for (let item of this.chatUsers)
                data["chatUsers"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.contracts)) {
            data["contracts"] = [];
            for (let item of this.contracts)
                data["contracts"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.contractSales)) {
            data["contractSales"] = [];
            for (let item of this.contractSales)
                data["contractSales"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.dataProcessStageProperties)) {
            data["dataProcessStageProperties"] = [];
            for (let item of this.dataProcessStageProperties)
                data["dataProcessStageProperties"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.dataProcessStages)) {
            data["dataProcessStages"] = [];
            for (let item of this.dataProcessStages)
                data["dataProcessStages"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.dataTagTypes)) {
            data["dataTagTypes"] = [];
            for (let item of this.dataTagTypes)
                data["dataTagTypes"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.products)) {
            data["products"] = [];
            for (let item of this.products)
                data["products"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.productSeries)) {
            data["productSeries"] = [];
            for (let item of this.productSeries)
                data["productSeries"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.projectNodeResponsibleNavigations)) {
            data["projectNodeResponsibleNavigations"] = [];
            for (let item of this.projectNodeResponsibleNavigations)
                data["projectNodeResponsibleNavigations"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.projectNodeTaskResponsibleUserNavigations)) {
            data["projectNodeTaskResponsibleUserNavigations"] = [];
            for (let item of this.projectNodeTaskResponsibleUserNavigations)
                data["projectNodeTaskResponsibleUserNavigations"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.projectTaskContacts)) {
            data["projectTaskContacts"] = [];
            for (let item of this.projectTaskContacts)
                data["projectTaskContacts"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.projectTasks)) {
            data["projectTasks"] = [];
            for (let item of this.projectTasks)
                data["projectTasks"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.projectTaskTypes)) {
            data["projectTaskTypes"] = [];
            for (let item of this.projectTaskTypes)
                data["projectTaskTypes"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.rightsApprovals)) {
            data["rightsApprovals"] = [];
            for (let item of this.rightsApprovals)
                data["rightsApprovals"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.roleUsers)) {
            data["roleUsers"] = [];
            for (let item of this.roleUsers)
                data["roleUsers"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.teamUsers)) {
            data["teamUsers"] = [];
            for (let item of this.teamUsers)
                data["teamUsers"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.userApprovalDelegationUserDelegateeNavigations)) {
            data["userApprovalDelegationUserDelegateeNavigations"] = [];
            for (let item of this.userApprovalDelegationUserDelegateeNavigations)
                data["userApprovalDelegationUserDelegateeNavigations"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.userApprovalDelegationUserNavigations)) {
            data["userApprovalDelegationUserNavigations"] = [];
            for (let item of this.userApprovalDelegationUserNavigations)
                data["userApprovalDelegationUserNavigations"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.voucherApprovalPolicyUsers)) {
            data["voucherApprovalPolicyUsers"] = [];
            for (let item of this.voucherApprovalPolicyUsers)
                data["voucherApprovalPolicyUsers"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.voucherApprovals)) {
            data["voucherApprovals"] = [];
            for (let item of this.voucherApprovals)
                data["voucherApprovals"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.voucherApproverNavigations)) {
            data["voucherApproverNavigations"] = [];
            for (let item of this.voucherApproverNavigations)
                data["voucherApproverNavigations"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.voucherCreatedByNavigations)) {
            data["voucherCreatedByNavigations"] = [];
            for (let item of this.voucherCreatedByNavigations)
                data["voucherCreatedByNavigations"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.voucherMessageChannelUsers)) {
            data["voucherMessageChannelUsers"] = [];
            for (let item of this.voucherMessageChannelUsers)
                data["voucherMessageChannelUsers"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.voucherMessageMailVendorHistories)) {
            data["voucherMessageMailVendorHistories"] = [];
            for (let item of this.voucherMessageMailVendorHistories)
                data["voucherMessageMailVendorHistories"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.voucherModifiedByNavigations)) {
            data["voucherModifiedByNavigations"] = [];
            for (let item of this.voucherModifiedByNavigations)
                data["voucherModifiedByNavigations"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.voucherRequests)) {
            data["voucherRequests"] = [];
            for (let item of this.voucherRequests)
                data["voucherRequests"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IUser {
    id?: number;
    shortName: string;
    name: string;
    appUserId?: string | undefined;
    email?: string | undefined;
    active?: boolean;
    chatNotify?: number | undefined;
    locale?: string | undefined;
    uiPagerShow?: boolean;
    legacyId?: number | undefined;
    created?: Date | undefined;
    createdBy?: number | undefined;
    modified?: Date | undefined;
    modifiedBy?: number | undefined;
    localeNavigation?: GlobalLocale | undefined;
    bankAccountTransactions?: BankAccountTransaction[] | undefined;
    bankCreditCards?: BankCreditCard[] | undefined;
    chatUsers?: ChatUser[] | undefined;
    contracts?: Contract[] | undefined;
    contractSales?: ContractSale[] | undefined;
    dataProcessStageProperties?: DataProcessStageProperty[] | undefined;
    dataProcessStages?: DataProcessStage[] | undefined;
    dataTagTypes?: DataTagType[] | undefined;
    products?: Product[] | undefined;
    productSeries?: ProductSeries[] | undefined;
    projectNodeResponsibleNavigations?: ProjectNode[] | undefined;
    projectNodeTaskResponsibleUserNavigations?: ProjectNode[] | undefined;
    projectTaskContacts?: ProjectTaskContact[] | undefined;
    projectTasks?: ProjectTask[] | undefined;
    projectTaskTypes?: ProjectTaskType[] | undefined;
    rightsApprovals?: RightsApproval[] | undefined;
    roleUsers?: RoleUser[] | undefined;
    teamUsers?: TeamUser[] | undefined;
    userApprovalDelegationUserDelegateeNavigations?: UserApprovalDelegation[] | undefined;
    userApprovalDelegationUserNavigations?: UserApprovalDelegation[] | undefined;
    voucherApprovalPolicyUsers?: VoucherApprovalPolicyUser[] | undefined;
    voucherApprovals?: VoucherApproval[] | undefined;
    voucherApproverNavigations?: Voucher[] | undefined;
    voucherCreatedByNavigations?: Voucher[] | undefined;
    voucherMessageChannelUsers?: VoucherMessageChannelUser[] | undefined;
    voucherMessageMailVendorHistories?: VoucherMessageMailVendorHistory[] | undefined;
    voucherModifiedByNavigations?: Voucher[] | undefined;
    voucherRequests?: VoucherRequest[] | undefined;
}

export class BankAccountTransaction implements IBankAccountTransaction {
    id?: number;
    bankAccount?: number | undefined;
    source?: number;
    sourceBatch?: number | undefined;
    sourceId?: number | undefined;
    voucherNum?: string | undefined;
    transDate?: Date;
    bankTransId?: string | undefined;
    bankTransType?: string | undefined;
    currency?: number;
    amountCur?: number | undefined;
    amount?: number | undefined;
    balance?: number | undefined;
    exchRate?: number | undefined;
    txt?: string | undefined;
    authReference?: string | undefined;
    status?: number;
    created?: Date | undefined;
    createdBy?: number | undefined;
    modified?: Date | undefined;
    modifiedBy?: number | undefined;
    user?: number | undefined;
    bankCreditCard?: number | undefined;
    bankAccountNavigation?: BankAccount | undefined;
    bankCreditCardNavigation?: BankCreditCard | undefined;
    currencyNavigation?: Currency | undefined;
    sourceBatchNavigation?: BankAccountTransactionSourceBatch | undefined;
    sourceNavigation?: BankAccountTransactionSource | undefined;
    statusNavigation?: BankAccountTransactionStatus | undefined;
    userNavigation?: User | undefined;
    bankAccountTransactionSettles?: BankAccountTransactionSettle[] | undefined;
    voucherRequests?: VoucherRequest[] | undefined;

    constructor(data?: IBankAccountTransaction) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.bankAccount = _data["bankAccount"];
            this.source = _data["source"];
            this.sourceBatch = _data["sourceBatch"];
            this.sourceId = _data["sourceId"];
            this.voucherNum = _data["voucherNum"];
            this.transDate = _data["transDate"] ? new Date(_data["transDate"].toString()) : undefined as any;
            this.bankTransId = _data["bankTransId"];
            this.bankTransType = _data["bankTransType"];
            this.currency = _data["currency"];
            this.amountCur = _data["amountCur"];
            this.amount = _data["amount"];
            this.balance = _data["balance"];
            this.exchRate = _data["exchRate"];
            this.txt = _data["txt"];
            this.authReference = _data["authReference"];
            this.status = _data["status"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : undefined as any;
            this.createdBy = _data["createdBy"];
            this.modified = _data["modified"] ? new Date(_data["modified"].toString()) : undefined as any;
            this.modifiedBy = _data["modifiedBy"];
            this.user = _data["user"];
            this.bankCreditCard = _data["bankCreditCard"];
            this.bankAccountNavigation = _data["bankAccountNavigation"] ? BankAccount.fromJS(_data["bankAccountNavigation"]) : undefined as any;
            this.bankCreditCardNavigation = _data["bankCreditCardNavigation"] ? BankCreditCard.fromJS(_data["bankCreditCardNavigation"]) : undefined as any;
            this.currencyNavigation = _data["currencyNavigation"] ? Currency.fromJS(_data["currencyNavigation"]) : undefined as any;
            this.sourceBatchNavigation = _data["sourceBatchNavigation"] ? BankAccountTransactionSourceBatch.fromJS(_data["sourceBatchNavigation"]) : undefined as any;
            this.sourceNavigation = _data["sourceNavigation"] ? BankAccountTransactionSource.fromJS(_data["sourceNavigation"]) : undefined as any;
            this.statusNavigation = _data["statusNavigation"] ? BankAccountTransactionStatus.fromJS(_data["statusNavigation"]) : undefined as any;
            this.userNavigation = _data["userNavigation"] ? User.fromJS(_data["userNavigation"]) : undefined as any;
            if (Array.isArray(_data["bankAccountTransactionSettles"])) {
                this.bankAccountTransactionSettles = [] as any;
                for (let item of _data["bankAccountTransactionSettles"])
                    this.bankAccountTransactionSettles!.push(BankAccountTransactionSettle.fromJS(item));
            }
            if (Array.isArray(_data["voucherRequests"])) {
                this.voucherRequests = [] as any;
                for (let item of _data["voucherRequests"])
                    this.voucherRequests!.push(VoucherRequest.fromJS(item));
            }
        }
    }

    static fromJS(data: any): BankAccountTransaction {
        data = typeof data === 'object' ? data : {};
        let result = new BankAccountTransaction();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["bankAccount"] = this.bankAccount;
        data["source"] = this.source;
        data["sourceBatch"] = this.sourceBatch;
        data["sourceId"] = this.sourceId;
        data["voucherNum"] = this.voucherNum;
        data["transDate"] = this.transDate ? this.transDate.toISOString() : undefined as any;
        data["bankTransId"] = this.bankTransId;
        data["bankTransType"] = this.bankTransType;
        data["currency"] = this.currency;
        data["amountCur"] = this.amountCur;
        data["amount"] = this.amount;
        data["balance"] = this.balance;
        data["exchRate"] = this.exchRate;
        data["txt"] = this.txt;
        data["authReference"] = this.authReference;
        data["status"] = this.status;
        data["created"] = this.created ? this.created.toISOString() : undefined as any;
        data["createdBy"] = this.createdBy;
        data["modified"] = this.modified ? this.modified.toISOString() : undefined as any;
        data["modifiedBy"] = this.modifiedBy;
        data["user"] = this.user;
        data["bankCreditCard"] = this.bankCreditCard;
        data["bankAccountNavigation"] = this.bankAccountNavigation ? this.bankAccountNavigation.toJSON() : undefined as any;
        data["bankCreditCardNavigation"] = this.bankCreditCardNavigation ? this.bankCreditCardNavigation.toJSON() : undefined as any;
        data["currencyNavigation"] = this.currencyNavigation ? this.currencyNavigation.toJSON() : undefined as any;
        data["sourceBatchNavigation"] = this.sourceBatchNavigation ? this.sourceBatchNavigation.toJSON() : undefined as any;
        data["sourceNavigation"] = this.sourceNavigation ? this.sourceNavigation.toJSON() : undefined as any;
        data["statusNavigation"] = this.statusNavigation ? this.statusNavigation.toJSON() : undefined as any;
        data["userNavigation"] = this.userNavigation ? this.userNavigation.toJSON() : undefined as any;
        if (Array.isArray(this.bankAccountTransactionSettles)) {
            data["bankAccountTransactionSettles"] = [];
            for (let item of this.bankAccountTransactionSettles)
                data["bankAccountTransactionSettles"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.voucherRequests)) {
            data["voucherRequests"] = [];
            for (let item of this.voucherRequests)
                data["voucherRequests"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IBankAccountTransaction {
    id?: number;
    bankAccount?: number | undefined;
    source?: number;
    sourceBatch?: number | undefined;
    sourceId?: number | undefined;
    voucherNum?: string | undefined;
    transDate?: Date;
    bankTransId?: string | undefined;
    bankTransType?: string | undefined;
    currency?: number;
    amountCur?: number | undefined;
    amount?: number | undefined;
    balance?: number | undefined;
    exchRate?: number | undefined;
    txt?: string | undefined;
    authReference?: string | undefined;
    status?: number;
    created?: Date | undefined;
    createdBy?: number | undefined;
    modified?: Date | undefined;
    modifiedBy?: number | undefined;
    user?: number | undefined;
    bankCreditCard?: number | undefined;
    bankAccountNavigation?: BankAccount | undefined;
    bankCreditCardNavigation?: BankCreditCard | undefined;
    currencyNavigation?: Currency | undefined;
    sourceBatchNavigation?: BankAccountTransactionSourceBatch | undefined;
    sourceNavigation?: BankAccountTransactionSource | undefined;
    statusNavigation?: BankAccountTransactionStatus | undefined;
    userNavigation?: User | undefined;
    bankAccountTransactionSettles?: BankAccountTransactionSettle[] | undefined;
    voucherRequests?: VoucherRequest[] | undefined;
}

export class BankCreditCard implements IBankCreditCard {
    id?: number;
    name!: string;
    bankAccount?: number;
    cardNumber?: string | undefined;
    cardNumberPublic?: string | undefined;
    user?: number | undefined;
    active?: boolean;
    created?: Date | undefined;
    createdBy?: number | undefined;
    modified?: Date | undefined;
    modifiedBy?: number | undefined;
    bankAccountNavigation?: BankAccount | undefined;
    userNavigation?: User | undefined;
    bankAccountTransactions?: BankAccountTransaction[] | undefined;

    constructor(data?: IBankCreditCard) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.bankAccount = _data["bankAccount"];
            this.cardNumber = _data["cardNumber"];
            this.cardNumberPublic = _data["cardNumberPublic"];
            this.user = _data["user"];
            this.active = _data["active"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : undefined as any;
            this.createdBy = _data["createdBy"];
            this.modified = _data["modified"] ? new Date(_data["modified"].toString()) : undefined as any;
            this.modifiedBy = _data["modifiedBy"];
            this.bankAccountNavigation = _data["bankAccountNavigation"] ? BankAccount.fromJS(_data["bankAccountNavigation"]) : undefined as any;
            this.userNavigation = _data["userNavigation"] ? User.fromJS(_data["userNavigation"]) : undefined as any;
            if (Array.isArray(_data["bankAccountTransactions"])) {
                this.bankAccountTransactions = [] as any;
                for (let item of _data["bankAccountTransactions"])
                    this.bankAccountTransactions!.push(BankAccountTransaction.fromJS(item));
            }
        }
    }

    static fromJS(data: any): BankCreditCard {
        data = typeof data === 'object' ? data : {};
        let result = new BankCreditCard();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["bankAccount"] = this.bankAccount;
        data["cardNumber"] = this.cardNumber;
        data["cardNumberPublic"] = this.cardNumberPublic;
        data["user"] = this.user;
        data["active"] = this.active;
        data["created"] = this.created ? this.created.toISOString() : undefined as any;
        data["createdBy"] = this.createdBy;
        data["modified"] = this.modified ? this.modified.toISOString() : undefined as any;
        data["modifiedBy"] = this.modifiedBy;
        data["bankAccountNavigation"] = this.bankAccountNavigation ? this.bankAccountNavigation.toJSON() : undefined as any;
        data["userNavigation"] = this.userNavigation ? this.userNavigation.toJSON() : undefined as any;
        if (Array.isArray(this.bankAccountTransactions)) {
            data["bankAccountTransactions"] = [];
            for (let item of this.bankAccountTransactions)
                data["bankAccountTransactions"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IBankCreditCard {
    id?: number;
    name: string;
    bankAccount?: number;
    cardNumber?: string | undefined;
    cardNumberPublic?: string | undefined;
    user?: number | undefined;
    active?: boolean;
    created?: Date | undefined;
    createdBy?: number | undefined;
    modified?: Date | undefined;
    modifiedBy?: number | undefined;
    bankAccountNavigation?: BankAccount | undefined;
    userNavigation?: User | undefined;
    bankAccountTransactions?: BankAccountTransaction[] | undefined;
}

export class Currency implements ICurrency {
    id?: number;
    num!: string;
    name!: string;
    created?: Date | undefined;
    createdBy?: number | undefined;
    modified?: Date | undefined;
    modifiedBy?: number | undefined;
    bankAccounts?: BankAccount[] | undefined;
    bankAccountTransactions?: BankAccountTransaction[] | undefined;
    legalEntities?: LegalEntity[] | undefined;
    productSalesPrices?: ProductSalesPrice[] | undefined;
    vouchers?: Voucher[] | undefined;

    constructor(data?: ICurrency) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.num = _data["num"];
            this.name = _data["name"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : undefined as any;
            this.createdBy = _data["createdBy"];
            this.modified = _data["modified"] ? new Date(_data["modified"].toString()) : undefined as any;
            this.modifiedBy = _data["modifiedBy"];
            if (Array.isArray(_data["bankAccounts"])) {
                this.bankAccounts = [] as any;
                for (let item of _data["bankAccounts"])
                    this.bankAccounts!.push(BankAccount.fromJS(item));
            }
            if (Array.isArray(_data["bankAccountTransactions"])) {
                this.bankAccountTransactions = [] as any;
                for (let item of _data["bankAccountTransactions"])
                    this.bankAccountTransactions!.push(BankAccountTransaction.fromJS(item));
            }
            if (Array.isArray(_data["legalEntities"])) {
                this.legalEntities = [] as any;
                for (let item of _data["legalEntities"])
                    this.legalEntities!.push(LegalEntity.fromJS(item));
            }
            if (Array.isArray(_data["productSalesPrices"])) {
                this.productSalesPrices = [] as any;
                for (let item of _data["productSalesPrices"])
                    this.productSalesPrices!.push(ProductSalesPrice.fromJS(item));
            }
            if (Array.isArray(_data["vouchers"])) {
                this.vouchers = [] as any;
                for (let item of _data["vouchers"])
                    this.vouchers!.push(Voucher.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Currency {
        data = typeof data === 'object' ? data : {};
        let result = new Currency();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["num"] = this.num;
        data["name"] = this.name;
        data["created"] = this.created ? this.created.toISOString() : undefined as any;
        data["createdBy"] = this.createdBy;
        data["modified"] = this.modified ? this.modified.toISOString() : undefined as any;
        data["modifiedBy"] = this.modifiedBy;
        if (Array.isArray(this.bankAccounts)) {
            data["bankAccounts"] = [];
            for (let item of this.bankAccounts)
                data["bankAccounts"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.bankAccountTransactions)) {
            data["bankAccountTransactions"] = [];
            for (let item of this.bankAccountTransactions)
                data["bankAccountTransactions"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.legalEntities)) {
            data["legalEntities"] = [];
            for (let item of this.legalEntities)
                data["legalEntities"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.productSalesPrices)) {
            data["productSalesPrices"] = [];
            for (let item of this.productSalesPrices)
                data["productSalesPrices"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.vouchers)) {
            data["vouchers"] = [];
            for (let item of this.vouchers)
                data["vouchers"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ICurrency {
    id?: number;
    num: string;
    name: string;
    created?: Date | undefined;
    createdBy?: number | undefined;
    modified?: Date | undefined;
    modifiedBy?: number | undefined;
    bankAccounts?: BankAccount[] | undefined;
    bankAccountTransactions?: BankAccountTransaction[] | undefined;
    legalEntities?: LegalEntity[] | undefined;
    productSalesPrices?: ProductSalesPrice[] | undefined;
    vouchers?: Voucher[] | undefined;
}

export class LegalEntity implements ILegalEntity {
    id?: number;
    name!: string;
    currency?: number;
    created?: Date | undefined;
    createdBy?: number | undefined;
    modified?: Date | undefined;
    modifiedBy?: number | undefined;
    currencyNavigation?: Currency | undefined;

    constructor(data?: ILegalEntity) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.currency = _data["currency"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : undefined as any;
            this.createdBy = _data["createdBy"];
            this.modified = _data["modified"] ? new Date(_data["modified"].toString()) : undefined as any;
            this.modifiedBy = _data["modifiedBy"];
            this.currencyNavigation = _data["currencyNavigation"] ? Currency.fromJS(_data["currencyNavigation"]) : undefined as any;
        }
    }

    static fromJS(data: any): LegalEntity {
        data = typeof data === 'object' ? data : {};
        let result = new LegalEntity();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["currency"] = this.currency;
        data["created"] = this.created ? this.created.toISOString() : undefined as any;
        data["createdBy"] = this.createdBy;
        data["modified"] = this.modified ? this.modified.toISOString() : undefined as any;
        data["modifiedBy"] = this.modifiedBy;
        data["currencyNavigation"] = this.currencyNavigation ? this.currencyNavigation.toJSON() : undefined as any;
        return data;
    }
}

export interface ILegalEntity {
    id?: number;
    name: string;
    currency?: number;
    created?: Date | undefined;
    createdBy?: number | undefined;
    modified?: Date | undefined;
    modifiedBy?: number | undefined;
    currencyNavigation?: Currency | undefined;
}

export class ProductSalesPrice implements IProductSalesPrice {
    id?: number;
    product!: string;
    salesPrice?: number;
    currency!: string;
    fromDate?: Date | undefined;
    toDate?: Date | undefined;
    created?: Date | undefined;
    createdBy?: number | undefined;
    modified?: Date | undefined;
    modifiedBy?: number | undefined;
    currencyNavigation?: Currency | undefined;

    constructor(data?: IProductSalesPrice) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.product = _data["product"];
            this.salesPrice = _data["salesPrice"];
            this.currency = _data["currency"];
            this.fromDate = _data["fromDate"] ? new Date(_data["fromDate"].toString()) : undefined as any;
            this.toDate = _data["toDate"] ? new Date(_data["toDate"].toString()) : undefined as any;
            this.created = _data["created"] ? new Date(_data["created"].toString()) : undefined as any;
            this.createdBy = _data["createdBy"];
            this.modified = _data["modified"] ? new Date(_data["modified"].toString()) : undefined as any;
            this.modifiedBy = _data["modifiedBy"];
            this.currencyNavigation = _data["currencyNavigation"] ? Currency.fromJS(_data["currencyNavigation"]) : undefined as any;
        }
    }

    static fromJS(data: any): ProductSalesPrice {
        data = typeof data === 'object' ? data : {};
        let result = new ProductSalesPrice();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["product"] = this.product;
        data["salesPrice"] = this.salesPrice;
        data["currency"] = this.currency;
        data["fromDate"] = this.fromDate ? this.fromDate.toISOString() : undefined as any;
        data["toDate"] = this.toDate ? this.toDate.toISOString() : undefined as any;
        data["created"] = this.created ? this.created.toISOString() : undefined as any;
        data["createdBy"] = this.createdBy;
        data["modified"] = this.modified ? this.modified.toISOString() : undefined as any;
        data["modifiedBy"] = this.modifiedBy;
        data["currencyNavigation"] = this.currencyNavigation ? this.currencyNavigation.toJSON() : undefined as any;
        return data;
    }
}

export interface IProductSalesPrice {
    id?: number;
    product: string;
    salesPrice?: number;
    currency: string;
    fromDate?: Date | undefined;
    toDate?: Date | undefined;
    created?: Date | undefined;
    createdBy?: number | undefined;
    modified?: Date | undefined;
    modifiedBy?: number | undefined;
    currencyNavigation?: Currency | undefined;
}

export class Voucher implements IVoucher {
    id?: number;
    voucherNum?: string | undefined;
    status?: number;
    approver?: number | undefined;
    currency?: number | undefined;
    amountCur?: number | undefined;
    transDate?: Date | undefined;
    documentDate?: Date | undefined;
    documentNum?: string | undefined;
    txt?: string | undefined;
    notes?: string | undefined;
    created?: Date | undefined;
    modified?: Date | undefined;
    createdBy?: number | undefined;
    modifiedBy?: number | undefined;
    msgId?: number | undefined;
    postedStatus?: number | undefined;
    category?: number | undefined;
    authReference?: string | undefined;
    approverNavigation?: User | undefined;
    categoryNavigation?: VoucherCategory | undefined;
    createdByNavigation?: User | undefined;
    currencyNavigation?: Currency | undefined;
    modifiedByNavigation?: User | undefined;
    msg?: VoucherMessage | undefined;
    statusNavigation?: VoucherApprovalStatus | undefined;
    voucherApprovals?: VoucherApproval[] | undefined;
    voucherPostings?: VoucherPosting[] | undefined;
    voucherPostingSales?: VoucherPostingSale[] | undefined;

    constructor(data?: IVoucher) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.voucherNum = _data["voucherNum"];
            this.status = _data["status"];
            this.approver = _data["approver"];
            this.currency = _data["currency"];
            this.amountCur = _data["amountCur"];
            this.transDate = _data["transDate"] ? new Date(_data["transDate"].toString()) : undefined as any;
            this.documentDate = _data["documentDate"] ? new Date(_data["documentDate"].toString()) : undefined as any;
            this.documentNum = _data["documentNum"];
            this.txt = _data["txt"];
            this.notes = _data["notes"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : undefined as any;
            this.modified = _data["modified"] ? new Date(_data["modified"].toString()) : undefined as any;
            this.createdBy = _data["createdBy"];
            this.modifiedBy = _data["modifiedBy"];
            this.msgId = _data["msgId"];
            this.postedStatus = _data["postedStatus"];
            this.category = _data["category"];
            this.authReference = _data["authReference"];
            this.approverNavigation = _data["approverNavigation"] ? User.fromJS(_data["approverNavigation"]) : undefined as any;
            this.categoryNavigation = _data["categoryNavigation"] ? VoucherCategory.fromJS(_data["categoryNavigation"]) : undefined as any;
            this.createdByNavigation = _data["createdByNavigation"] ? User.fromJS(_data["createdByNavigation"]) : undefined as any;
            this.currencyNavigation = _data["currencyNavigation"] ? Currency.fromJS(_data["currencyNavigation"]) : undefined as any;
            this.modifiedByNavigation = _data["modifiedByNavigation"] ? User.fromJS(_data["modifiedByNavigation"]) : undefined as any;
            this.msg = _data["msg"] ? VoucherMessage.fromJS(_data["msg"]) : undefined as any;
            this.statusNavigation = _data["statusNavigation"] ? VoucherApprovalStatus.fromJS(_data["statusNavigation"]) : undefined as any;
            if (Array.isArray(_data["voucherApprovals"])) {
                this.voucherApprovals = [] as any;
                for (let item of _data["voucherApprovals"])
                    this.voucherApprovals!.push(VoucherApproval.fromJS(item));
            }
            if (Array.isArray(_data["voucherPostings"])) {
                this.voucherPostings = [] as any;
                for (let item of _data["voucherPostings"])
                    this.voucherPostings!.push(VoucherPosting.fromJS(item));
            }
            if (Array.isArray(_data["voucherPostingSales"])) {
                this.voucherPostingSales = [] as any;
                for (let item of _data["voucherPostingSales"])
                    this.voucherPostingSales!.push(VoucherPostingSale.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Voucher {
        data = typeof data === 'object' ? data : {};
        let result = new Voucher();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["voucherNum"] = this.voucherNum;
        data["status"] = this.status;
        data["approver"] = this.approver;
        data["currency"] = this.currency;
        data["amountCur"] = this.amountCur;
        data["transDate"] = this.transDate ? this.transDate.toISOString() : undefined as any;
        data["documentDate"] = this.documentDate ? this.documentDate.toISOString() : undefined as any;
        data["documentNum"] = this.documentNum;
        data["txt"] = this.txt;
        data["notes"] = this.notes;
        data["created"] = this.created ? this.created.toISOString() : undefined as any;
        data["modified"] = this.modified ? this.modified.toISOString() : undefined as any;
        data["createdBy"] = this.createdBy;
        data["modifiedBy"] = this.modifiedBy;
        data["msgId"] = this.msgId;
        data["postedStatus"] = this.postedStatus;
        data["category"] = this.category;
        data["authReference"] = this.authReference;
        data["approverNavigation"] = this.approverNavigation ? this.approverNavigation.toJSON() : undefined as any;
        data["categoryNavigation"] = this.categoryNavigation ? this.categoryNavigation.toJSON() : undefined as any;
        data["createdByNavigation"] = this.createdByNavigation ? this.createdByNavigation.toJSON() : undefined as any;
        data["currencyNavigation"] = this.currencyNavigation ? this.currencyNavigation.toJSON() : undefined as any;
        data["modifiedByNavigation"] = this.modifiedByNavigation ? this.modifiedByNavigation.toJSON() : undefined as any;
        data["msg"] = this.msg ? this.msg.toJSON() : undefined as any;
        data["statusNavigation"] = this.statusNavigation ? this.statusNavigation.toJSON() : undefined as any;
        if (Array.isArray(this.voucherApprovals)) {
            data["voucherApprovals"] = [];
            for (let item of this.voucherApprovals)
                data["voucherApprovals"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.voucherPostings)) {
            data["voucherPostings"] = [];
            for (let item of this.voucherPostings)
                data["voucherPostings"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.voucherPostingSales)) {
            data["voucherPostingSales"] = [];
            for (let item of this.voucherPostingSales)
                data["voucherPostingSales"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IVoucher {
    id?: number;
    voucherNum?: string | undefined;
    status?: number;
    approver?: number | undefined;
    currency?: number | undefined;
    amountCur?: number | undefined;
    transDate?: Date | undefined;
    documentDate?: Date | undefined;
    documentNum?: string | undefined;
    txt?: string | undefined;
    notes?: string | undefined;
    created?: Date | undefined;
    modified?: Date | undefined;
    createdBy?: number | undefined;
    modifiedBy?: number | undefined;
    msgId?: number | undefined;
    postedStatus?: number | undefined;
    category?: number | undefined;
    authReference?: string | undefined;
    approverNavigation?: User | undefined;
    categoryNavigation?: VoucherCategory | undefined;
    createdByNavigation?: User | undefined;
    currencyNavigation?: Currency | undefined;
    modifiedByNavigation?: User | undefined;
    msg?: VoucherMessage | undefined;
    statusNavigation?: VoucherApprovalStatus | undefined;
    voucherApprovals?: VoucherApproval[] | undefined;
    voucherPostings?: VoucherPosting[] | undefined;
    voucherPostingSales?: VoucherPostingSale[] | undefined;
}

export class VoucherCategory implements IVoucherCategory {
    id?: number;
    name!: string;
    created?: Date | undefined;
    createdBy?: number | undefined;
    modified?: Date | undefined;
    modifiedBy?: number | undefined;
    vouchers?: Voucher[] | undefined;

    constructor(data?: IVoucherCategory) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : undefined as any;
            this.createdBy = _data["createdBy"];
            this.modified = _data["modified"] ? new Date(_data["modified"].toString()) : undefined as any;
            this.modifiedBy = _data["modifiedBy"];
            if (Array.isArray(_data["vouchers"])) {
                this.vouchers = [] as any;
                for (let item of _data["vouchers"])
                    this.vouchers!.push(Voucher.fromJS(item));
            }
        }
    }

    static fromJS(data: any): VoucherCategory {
        data = typeof data === 'object' ? data : {};
        let result = new VoucherCategory();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["created"] = this.created ? this.created.toISOString() : undefined as any;
        data["createdBy"] = this.createdBy;
        data["modified"] = this.modified ? this.modified.toISOString() : undefined as any;
        data["modifiedBy"] = this.modifiedBy;
        if (Array.isArray(this.vouchers)) {
            data["vouchers"] = [];
            for (let item of this.vouchers)
                data["vouchers"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IVoucherCategory {
    id?: number;
    name: string;
    created?: Date | undefined;
    createdBy?: number | undefined;
    modified?: Date | undefined;
    modifiedBy?: number | undefined;
    vouchers?: Voucher[] | undefined;
}

export class VoucherMessage implements IVoucherMessage {
    id?: number;
    channel?: number;
    status?: number;
    channelNum?: string | undefined;
    description!: string;
    attachmentCount?: number;
    archivePath!: string;
    validationStatus?: number;
    created?: Date;
    createdBy?: number | undefined;
    modified?: Date | undefined;
    modifiedBy?: number | undefined;
    channelNavigation?: VoucherMessageChannel | undefined;
    statusNavigation?: VoucherMessageStatus | undefined;
    validationStatusNavigation?: VoucherValidationStatus | undefined;
    voucherMessageMails?: VoucherMessageMail[] | undefined;
    vouchers?: Voucher[] | undefined;

    constructor(data?: IVoucherMessage) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.channel = _data["channel"];
            this.status = _data["status"];
            this.channelNum = _data["channelNum"];
            this.description = _data["description"];
            this.attachmentCount = _data["attachmentCount"];
            this.archivePath = _data["archivePath"];
            this.validationStatus = _data["validationStatus"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : undefined as any;
            this.createdBy = _data["createdBy"];
            this.modified = _data["modified"] ? new Date(_data["modified"].toString()) : undefined as any;
            this.modifiedBy = _data["modifiedBy"];
            this.channelNavigation = _data["channelNavigation"] ? VoucherMessageChannel.fromJS(_data["channelNavigation"]) : undefined as any;
            this.statusNavigation = _data["statusNavigation"] ? VoucherMessageStatus.fromJS(_data["statusNavigation"]) : undefined as any;
            this.validationStatusNavigation = _data["validationStatusNavigation"] ? VoucherValidationStatus.fromJS(_data["validationStatusNavigation"]) : undefined as any;
            if (Array.isArray(_data["voucherMessageMails"])) {
                this.voucherMessageMails = [] as any;
                for (let item of _data["voucherMessageMails"])
                    this.voucherMessageMails!.push(VoucherMessageMail.fromJS(item));
            }
            if (Array.isArray(_data["vouchers"])) {
                this.vouchers = [] as any;
                for (let item of _data["vouchers"])
                    this.vouchers!.push(Voucher.fromJS(item));
            }
        }
    }

    static fromJS(data: any): VoucherMessage {
        data = typeof data === 'object' ? data : {};
        let result = new VoucherMessage();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["channel"] = this.channel;
        data["status"] = this.status;
        data["channelNum"] = this.channelNum;
        data["description"] = this.description;
        data["attachmentCount"] = this.attachmentCount;
        data["archivePath"] = this.archivePath;
        data["validationStatus"] = this.validationStatus;
        data["created"] = this.created ? this.created.toISOString() : undefined as any;
        data["createdBy"] = this.createdBy;
        data["modified"] = this.modified ? this.modified.toISOString() : undefined as any;
        data["modifiedBy"] = this.modifiedBy;
        data["channelNavigation"] = this.channelNavigation ? this.channelNavigation.toJSON() : undefined as any;
        data["statusNavigation"] = this.statusNavigation ? this.statusNavigation.toJSON() : undefined as any;
        data["validationStatusNavigation"] = this.validationStatusNavigation ? this.validationStatusNavigation.toJSON() : undefined as any;
        if (Array.isArray(this.voucherMessageMails)) {
            data["voucherMessageMails"] = [];
            for (let item of this.voucherMessageMails)
                data["voucherMessageMails"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.vouchers)) {
            data["vouchers"] = [];
            for (let item of this.vouchers)
                data["vouchers"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IVoucherMessage {
    id?: number;
    channel?: number;
    status?: number;
    channelNum?: string | undefined;
    description: string;
    attachmentCount?: number;
    archivePath: string;
    validationStatus?: number;
    created?: Date;
    createdBy?: number | undefined;
    modified?: Date | undefined;
    modifiedBy?: number | undefined;
    channelNavigation?: VoucherMessageChannel | undefined;
    statusNavigation?: VoucherMessageStatus | undefined;
    validationStatusNavigation?: VoucherValidationStatus | undefined;
    voucherMessageMails?: VoucherMessageMail[] | undefined;
    vouchers?: Voucher[] | undefined;
}

export class VoucherMessageChannel implements IVoucherMessageChannel {
    id?: number;
    name!: string;
    type?: number | undefined;
    formRecognizer?: number | undefined;
    ledgerJournalName?: string | undefined;
    created?: Date | undefined;
    createdBy?: number | undefined;
    modified?: Date | undefined;
    modifiedBy?: number | undefined;
    voucherStatus?: number | undefined;
    formRecognizerNavigation?: FormRecognizer | undefined;
    typeNavigation?: VoucherMessageChannelType | undefined;
    voucherStatusNavigation?: VoucherApprovalStatus | undefined;
    bankAccountTransactionSources?: BankAccountTransactionSource[] | undefined;
    voucherApprovalPolicies?: VoucherApprovalPolicy[] | undefined;
    voucherMessageChannelNextVouchers?: VoucherMessageChannelNextVoucher[] | undefined;
    voucherMessageChannelUsers?: VoucherMessageChannelUser[] | undefined;
    voucherMessages?: VoucherMessage[] | undefined;

    constructor(data?: IVoucherMessageChannel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.type = _data["type"];
            this.formRecognizer = _data["formRecognizer"];
            this.ledgerJournalName = _data["ledgerJournalName"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : undefined as any;
            this.createdBy = _data["createdBy"];
            this.modified = _data["modified"] ? new Date(_data["modified"].toString()) : undefined as any;
            this.modifiedBy = _data["modifiedBy"];
            this.voucherStatus = _data["voucherStatus"];
            this.formRecognizerNavigation = _data["formRecognizerNavigation"] ? FormRecognizer.fromJS(_data["formRecognizerNavigation"]) : undefined as any;
            this.typeNavigation = _data["typeNavigation"] ? VoucherMessageChannelType.fromJS(_data["typeNavigation"]) : undefined as any;
            this.voucherStatusNavigation = _data["voucherStatusNavigation"] ? VoucherApprovalStatus.fromJS(_data["voucherStatusNavigation"]) : undefined as any;
            if (Array.isArray(_data["bankAccountTransactionSources"])) {
                this.bankAccountTransactionSources = [] as any;
                for (let item of _data["bankAccountTransactionSources"])
                    this.bankAccountTransactionSources!.push(BankAccountTransactionSource.fromJS(item));
            }
            if (Array.isArray(_data["voucherApprovalPolicies"])) {
                this.voucherApprovalPolicies = [] as any;
                for (let item of _data["voucherApprovalPolicies"])
                    this.voucherApprovalPolicies!.push(VoucherApprovalPolicy.fromJS(item));
            }
            if (Array.isArray(_data["voucherMessageChannelNextVouchers"])) {
                this.voucherMessageChannelNextVouchers = [] as any;
                for (let item of _data["voucherMessageChannelNextVouchers"])
                    this.voucherMessageChannelNextVouchers!.push(VoucherMessageChannelNextVoucher.fromJS(item));
            }
            if (Array.isArray(_data["voucherMessageChannelUsers"])) {
                this.voucherMessageChannelUsers = [] as any;
                for (let item of _data["voucherMessageChannelUsers"])
                    this.voucherMessageChannelUsers!.push(VoucherMessageChannelUser.fromJS(item));
            }
            if (Array.isArray(_data["voucherMessages"])) {
                this.voucherMessages = [] as any;
                for (let item of _data["voucherMessages"])
                    this.voucherMessages!.push(VoucherMessage.fromJS(item));
            }
        }
    }

    static fromJS(data: any): VoucherMessageChannel {
        data = typeof data === 'object' ? data : {};
        let result = new VoucherMessageChannel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["type"] = this.type;
        data["formRecognizer"] = this.formRecognizer;
        data["ledgerJournalName"] = this.ledgerJournalName;
        data["created"] = this.created ? this.created.toISOString() : undefined as any;
        data["createdBy"] = this.createdBy;
        data["modified"] = this.modified ? this.modified.toISOString() : undefined as any;
        data["modifiedBy"] = this.modifiedBy;
        data["voucherStatus"] = this.voucherStatus;
        data["formRecognizerNavigation"] = this.formRecognizerNavigation ? this.formRecognizerNavigation.toJSON() : undefined as any;
        data["typeNavigation"] = this.typeNavigation ? this.typeNavigation.toJSON() : undefined as any;
        data["voucherStatusNavigation"] = this.voucherStatusNavigation ? this.voucherStatusNavigation.toJSON() : undefined as any;
        if (Array.isArray(this.bankAccountTransactionSources)) {
            data["bankAccountTransactionSources"] = [];
            for (let item of this.bankAccountTransactionSources)
                data["bankAccountTransactionSources"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.voucherApprovalPolicies)) {
            data["voucherApprovalPolicies"] = [];
            for (let item of this.voucherApprovalPolicies)
                data["voucherApprovalPolicies"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.voucherMessageChannelNextVouchers)) {
            data["voucherMessageChannelNextVouchers"] = [];
            for (let item of this.voucherMessageChannelNextVouchers)
                data["voucherMessageChannelNextVouchers"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.voucherMessageChannelUsers)) {
            data["voucherMessageChannelUsers"] = [];
            for (let item of this.voucherMessageChannelUsers)
                data["voucherMessageChannelUsers"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.voucherMessages)) {
            data["voucherMessages"] = [];
            for (let item of this.voucherMessages)
                data["voucherMessages"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IVoucherMessageChannel {
    id?: number;
    name: string;
    type?: number | undefined;
    formRecognizer?: number | undefined;
    ledgerJournalName?: string | undefined;
    created?: Date | undefined;
    createdBy?: number | undefined;
    modified?: Date | undefined;
    modifiedBy?: number | undefined;
    voucherStatus?: number | undefined;
    formRecognizerNavigation?: FormRecognizer | undefined;
    typeNavigation?: VoucherMessageChannelType | undefined;
    voucherStatusNavigation?: VoucherApprovalStatus | undefined;
    bankAccountTransactionSources?: BankAccountTransactionSource[] | undefined;
    voucherApprovalPolicies?: VoucherApprovalPolicy[] | undefined;
    voucherMessageChannelNextVouchers?: VoucherMessageChannelNextVoucher[] | undefined;
    voucherMessageChannelUsers?: VoucherMessageChannelUser[] | undefined;
    voucherMessages?: VoucherMessage[] | undefined;
}

export class FormRecognizer implements IFormRecognizer {
    id?: number;
    name!: string;
    type?: number;
    created?: Date | undefined;
    createdBy?: number | undefined;
    modified?: Date | undefined;
    modifiedBy?: number | undefined;
    typeNavigation?: FormRecognizerType | undefined;
    formRecognizerDocuments?: FormRecognizerDocument[] | undefined;
    formRecognizerFields?: FormRecognizerField[] | undefined;
    voucherMessageChannels?: VoucherMessageChannel[] | undefined;
    voucherMessageMailVendorHistories?: VoucherMessageMailVendorHistory[] | undefined;

    constructor(data?: IFormRecognizer) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.type = _data["type"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : undefined as any;
            this.createdBy = _data["createdBy"];
            this.modified = _data["modified"] ? new Date(_data["modified"].toString()) : undefined as any;
            this.modifiedBy = _data["modifiedBy"];
            this.typeNavigation = _data["typeNavigation"] ? FormRecognizerType.fromJS(_data["typeNavigation"]) : undefined as any;
            if (Array.isArray(_data["formRecognizerDocuments"])) {
                this.formRecognizerDocuments = [] as any;
                for (let item of _data["formRecognizerDocuments"])
                    this.formRecognizerDocuments!.push(FormRecognizerDocument.fromJS(item));
            }
            if (Array.isArray(_data["formRecognizerFields"])) {
                this.formRecognizerFields = [] as any;
                for (let item of _data["formRecognizerFields"])
                    this.formRecognizerFields!.push(FormRecognizerField.fromJS(item));
            }
            if (Array.isArray(_data["voucherMessageChannels"])) {
                this.voucherMessageChannels = [] as any;
                for (let item of _data["voucherMessageChannels"])
                    this.voucherMessageChannels!.push(VoucherMessageChannel.fromJS(item));
            }
            if (Array.isArray(_data["voucherMessageMailVendorHistories"])) {
                this.voucherMessageMailVendorHistories = [] as any;
                for (let item of _data["voucherMessageMailVendorHistories"])
                    this.voucherMessageMailVendorHistories!.push(VoucherMessageMailVendorHistory.fromJS(item));
            }
        }
    }

    static fromJS(data: any): FormRecognizer {
        data = typeof data === 'object' ? data : {};
        let result = new FormRecognizer();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["type"] = this.type;
        data["created"] = this.created ? this.created.toISOString() : undefined as any;
        data["createdBy"] = this.createdBy;
        data["modified"] = this.modified ? this.modified.toISOString() : undefined as any;
        data["modifiedBy"] = this.modifiedBy;
        data["typeNavigation"] = this.typeNavigation ? this.typeNavigation.toJSON() : undefined as any;
        if (Array.isArray(this.formRecognizerDocuments)) {
            data["formRecognizerDocuments"] = [];
            for (let item of this.formRecognizerDocuments)
                data["formRecognizerDocuments"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.formRecognizerFields)) {
            data["formRecognizerFields"] = [];
            for (let item of this.formRecognizerFields)
                data["formRecognizerFields"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.voucherMessageChannels)) {
            data["voucherMessageChannels"] = [];
            for (let item of this.voucherMessageChannels)
                data["voucherMessageChannels"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.voucherMessageMailVendorHistories)) {
            data["voucherMessageMailVendorHistories"] = [];
            for (let item of this.voucherMessageMailVendorHistories)
                data["voucherMessageMailVendorHistories"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IFormRecognizer {
    id?: number;
    name: string;
    type?: number;
    created?: Date | undefined;
    createdBy?: number | undefined;
    modified?: Date | undefined;
    modifiedBy?: number | undefined;
    typeNavigation?: FormRecognizerType | undefined;
    formRecognizerDocuments?: FormRecognizerDocument[] | undefined;
    formRecognizerFields?: FormRecognizerField[] | undefined;
    voucherMessageChannels?: VoucherMessageChannel[] | undefined;
    voucherMessageMailVendorHistories?: VoucherMessageMailVendorHistory[] | undefined;
}

export class FormRecognizerType implements IFormRecognizerType {
    id?: number;
    name!: string;
    created?: Date | undefined;
    createdBy?: number | undefined;
    modified?: Date | undefined;
    modifiedBy?: number | undefined;
    formRecognizers?: FormRecognizer[] | undefined;

    constructor(data?: IFormRecognizerType) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : undefined as any;
            this.createdBy = _data["createdBy"];
            this.modified = _data["modified"] ? new Date(_data["modified"].toString()) : undefined as any;
            this.modifiedBy = _data["modifiedBy"];
            if (Array.isArray(_data["formRecognizers"])) {
                this.formRecognizers = [] as any;
                for (let item of _data["formRecognizers"])
                    this.formRecognizers!.push(FormRecognizer.fromJS(item));
            }
        }
    }

    static fromJS(data: any): FormRecognizerType {
        data = typeof data === 'object' ? data : {};
        let result = new FormRecognizerType();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["created"] = this.created ? this.created.toISOString() : undefined as any;
        data["createdBy"] = this.createdBy;
        data["modified"] = this.modified ? this.modified.toISOString() : undefined as any;
        data["modifiedBy"] = this.modifiedBy;
        if (Array.isArray(this.formRecognizers)) {
            data["formRecognizers"] = [];
            for (let item of this.formRecognizers)
                data["formRecognizers"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IFormRecognizerType {
    id?: number;
    name: string;
    created?: Date | undefined;
    createdBy?: number | undefined;
    modified?: Date | undefined;
    modifiedBy?: number | undefined;
    formRecognizers?: FormRecognizer[] | undefined;
}

export class FormRecognizerDocument implements IFormRecognizerDocument {
    id?: number;
    refTableId?: number;
    refRowId?: number;
    formRecognizer?: number;
    blobStorage?: number | undefined;
    folder!: string;
    fileName!: string;
    processed?: boolean;
    result?: string | undefined;
    created?: Date | undefined;
    createdBy?: number | undefined;
    modified?: Date | undefined;
    modifiedBy?: number | undefined;
    blobStorageNavigation?: BlobStorage | undefined;
    formRecognizerNavigation?: FormRecognizer | undefined;
    formRecognizerDocumentFields?: FormRecognizerDocumentField[] | undefined;
    formRecognizerDocumentLines?: FormRecognizerDocumentLine[] | undefined;

    constructor(data?: IFormRecognizerDocument) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.refTableId = _data["refTableId"];
            this.refRowId = _data["refRowId"];
            this.formRecognizer = _data["formRecognizer"];
            this.blobStorage = _data["blobStorage"];
            this.folder = _data["folder"];
            this.fileName = _data["fileName"];
            this.processed = _data["processed"];
            this.result = _data["result"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : undefined as any;
            this.createdBy = _data["createdBy"];
            this.modified = _data["modified"] ? new Date(_data["modified"].toString()) : undefined as any;
            this.modifiedBy = _data["modifiedBy"];
            this.blobStorageNavigation = _data["blobStorageNavigation"] ? BlobStorage.fromJS(_data["blobStorageNavigation"]) : undefined as any;
            this.formRecognizerNavigation = _data["formRecognizerNavigation"] ? FormRecognizer.fromJS(_data["formRecognizerNavigation"]) : undefined as any;
            if (Array.isArray(_data["formRecognizerDocumentFields"])) {
                this.formRecognizerDocumentFields = [] as any;
                for (let item of _data["formRecognizerDocumentFields"])
                    this.formRecognizerDocumentFields!.push(FormRecognizerDocumentField.fromJS(item));
            }
            if (Array.isArray(_data["formRecognizerDocumentLines"])) {
                this.formRecognizerDocumentLines = [] as any;
                for (let item of _data["formRecognizerDocumentLines"])
                    this.formRecognizerDocumentLines!.push(FormRecognizerDocumentLine.fromJS(item));
            }
        }
    }

    static fromJS(data: any): FormRecognizerDocument {
        data = typeof data === 'object' ? data : {};
        let result = new FormRecognizerDocument();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["refTableId"] = this.refTableId;
        data["refRowId"] = this.refRowId;
        data["formRecognizer"] = this.formRecognizer;
        data["blobStorage"] = this.blobStorage;
        data["folder"] = this.folder;
        data["fileName"] = this.fileName;
        data["processed"] = this.processed;
        data["result"] = this.result;
        data["created"] = this.created ? this.created.toISOString() : undefined as any;
        data["createdBy"] = this.createdBy;
        data["modified"] = this.modified ? this.modified.toISOString() : undefined as any;
        data["modifiedBy"] = this.modifiedBy;
        data["blobStorageNavigation"] = this.blobStorageNavigation ? this.blobStorageNavigation.toJSON() : undefined as any;
        data["formRecognizerNavigation"] = this.formRecognizerNavigation ? this.formRecognizerNavigation.toJSON() : undefined as any;
        if (Array.isArray(this.formRecognizerDocumentFields)) {
            data["formRecognizerDocumentFields"] = [];
            for (let item of this.formRecognizerDocumentFields)
                data["formRecognizerDocumentFields"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.formRecognizerDocumentLines)) {
            data["formRecognizerDocumentLines"] = [];
            for (let item of this.formRecognizerDocumentLines)
                data["formRecognizerDocumentLines"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IFormRecognizerDocument {
    id?: number;
    refTableId?: number;
    refRowId?: number;
    formRecognizer?: number;
    blobStorage?: number | undefined;
    folder: string;
    fileName: string;
    processed?: boolean;
    result?: string | undefined;
    created?: Date | undefined;
    createdBy?: number | undefined;
    modified?: Date | undefined;
    modifiedBy?: number | undefined;
    blobStorageNavigation?: BlobStorage | undefined;
    formRecognizerNavigation?: FormRecognizer | undefined;
    formRecognizerDocumentFields?: FormRecognizerDocumentField[] | undefined;
    formRecognizerDocumentLines?: FormRecognizerDocumentLine[] | undefined;
}

export class BlobStorage implements IBlobStorage {
    id?: number;
    name!: string;
    type?: number;
    created?: Date | undefined;
    createdBy?: number | undefined;
    modified?: Date | undefined;
    modifiedBy?: number | undefined;
    typeNavigation?: BlobStorageType | undefined;
    documentLibs?: DocumentLib[] | undefined;
    formRecognizerDocuments?: FormRecognizerDocument[] | undefined;

    constructor(data?: IBlobStorage) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.type = _data["type"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : undefined as any;
            this.createdBy = _data["createdBy"];
            this.modified = _data["modified"] ? new Date(_data["modified"].toString()) : undefined as any;
            this.modifiedBy = _data["modifiedBy"];
            this.typeNavigation = _data["typeNavigation"] ? BlobStorageType.fromJS(_data["typeNavigation"]) : undefined as any;
            if (Array.isArray(_data["documentLibs"])) {
                this.documentLibs = [] as any;
                for (let item of _data["documentLibs"])
                    this.documentLibs!.push(DocumentLib.fromJS(item));
            }
            if (Array.isArray(_data["formRecognizerDocuments"])) {
                this.formRecognizerDocuments = [] as any;
                for (let item of _data["formRecognizerDocuments"])
                    this.formRecognizerDocuments!.push(FormRecognizerDocument.fromJS(item));
            }
        }
    }

    static fromJS(data: any): BlobStorage {
        data = typeof data === 'object' ? data : {};
        let result = new BlobStorage();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["type"] = this.type;
        data["created"] = this.created ? this.created.toISOString() : undefined as any;
        data["createdBy"] = this.createdBy;
        data["modified"] = this.modified ? this.modified.toISOString() : undefined as any;
        data["modifiedBy"] = this.modifiedBy;
        data["typeNavigation"] = this.typeNavigation ? this.typeNavigation.toJSON() : undefined as any;
        if (Array.isArray(this.documentLibs)) {
            data["documentLibs"] = [];
            for (let item of this.documentLibs)
                data["documentLibs"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.formRecognizerDocuments)) {
            data["formRecognizerDocuments"] = [];
            for (let item of this.formRecognizerDocuments)
                data["formRecognizerDocuments"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IBlobStorage {
    id?: number;
    name: string;
    type?: number;
    created?: Date | undefined;
    createdBy?: number | undefined;
    modified?: Date | undefined;
    modifiedBy?: number | undefined;
    typeNavigation?: BlobStorageType | undefined;
    documentLibs?: DocumentLib[] | undefined;
    formRecognizerDocuments?: FormRecognizerDocument[] | undefined;
}

export class BlobStorageType implements IBlobStorageType {
    id?: number;
    name!: string;
    created?: Date | undefined;
    createdBy?: number | undefined;
    modified?: Date | undefined;
    modifiedBy?: number | undefined;
    blobStorages?: BlobStorage[] | undefined;

    constructor(data?: IBlobStorageType) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : undefined as any;
            this.createdBy = _data["createdBy"];
            this.modified = _data["modified"] ? new Date(_data["modified"].toString()) : undefined as any;
            this.modifiedBy = _data["modifiedBy"];
            if (Array.isArray(_data["blobStorages"])) {
                this.blobStorages = [] as any;
                for (let item of _data["blobStorages"])
                    this.blobStorages!.push(BlobStorage.fromJS(item));
            }
        }
    }

    static fromJS(data: any): BlobStorageType {
        data = typeof data === 'object' ? data : {};
        let result = new BlobStorageType();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["created"] = this.created ? this.created.toISOString() : undefined as any;
        data["createdBy"] = this.createdBy;
        data["modified"] = this.modified ? this.modified.toISOString() : undefined as any;
        data["modifiedBy"] = this.modifiedBy;
        if (Array.isArray(this.blobStorages)) {
            data["blobStorages"] = [];
            for (let item of this.blobStorages)
                data["blobStorages"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IBlobStorageType {
    id?: number;
    name: string;
    created?: Date | undefined;
    createdBy?: number | undefined;
    modified?: Date | undefined;
    modifiedBy?: number | undefined;
    blobStorages?: BlobStorage[] | undefined;
}

export class DocumentLib implements IDocumentLib {
    id?: number;
    name!: string;
    blobStorage?: number | undefined;
    path!: string;
    created?: Date | undefined;
    createdBy?: number | undefined;
    modified?: Date | undefined;
    modifiedBy?: number | undefined;
    blobStorageNavigation?: BlobStorage | undefined;
    dataTableDocumentLibs?: DataTableDocumentLib[] | undefined;
    dataTables?: DataTable[] | undefined;
    documentLibUsers?: DocumentLibUser[] | undefined;

    constructor(data?: IDocumentLib) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.blobStorage = _data["blobStorage"];
            this.path = _data["path"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : undefined as any;
            this.createdBy = _data["createdBy"];
            this.modified = _data["modified"] ? new Date(_data["modified"].toString()) : undefined as any;
            this.modifiedBy = _data["modifiedBy"];
            this.blobStorageNavigation = _data["blobStorageNavigation"] ? BlobStorage.fromJS(_data["blobStorageNavigation"]) : undefined as any;
            if (Array.isArray(_data["dataTableDocumentLibs"])) {
                this.dataTableDocumentLibs = [] as any;
                for (let item of _data["dataTableDocumentLibs"])
                    this.dataTableDocumentLibs!.push(DataTableDocumentLib.fromJS(item));
            }
            if (Array.isArray(_data["dataTables"])) {
                this.dataTables = [] as any;
                for (let item of _data["dataTables"])
                    this.dataTables!.push(DataTable.fromJS(item));
            }
            if (Array.isArray(_data["documentLibUsers"])) {
                this.documentLibUsers = [] as any;
                for (let item of _data["documentLibUsers"])
                    this.documentLibUsers!.push(DocumentLibUser.fromJS(item));
            }
        }
    }

    static fromJS(data: any): DocumentLib {
        data = typeof data === 'object' ? data : {};
        let result = new DocumentLib();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["blobStorage"] = this.blobStorage;
        data["path"] = this.path;
        data["created"] = this.created ? this.created.toISOString() : undefined as any;
        data["createdBy"] = this.createdBy;
        data["modified"] = this.modified ? this.modified.toISOString() : undefined as any;
        data["modifiedBy"] = this.modifiedBy;
        data["blobStorageNavigation"] = this.blobStorageNavigation ? this.blobStorageNavigation.toJSON() : undefined as any;
        if (Array.isArray(this.dataTableDocumentLibs)) {
            data["dataTableDocumentLibs"] = [];
            for (let item of this.dataTableDocumentLibs)
                data["dataTableDocumentLibs"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.dataTables)) {
            data["dataTables"] = [];
            for (let item of this.dataTables)
                data["dataTables"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.documentLibUsers)) {
            data["documentLibUsers"] = [];
            for (let item of this.documentLibUsers)
                data["documentLibUsers"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IDocumentLib {
    id?: number;
    name: string;
    blobStorage?: number | undefined;
    path: string;
    created?: Date | undefined;
    createdBy?: number | undefined;
    modified?: Date | undefined;
    modifiedBy?: number | undefined;
    blobStorageNavigation?: BlobStorage | undefined;
    dataTableDocumentLibs?: DataTableDocumentLib[] | undefined;
    dataTables?: DataTable[] | undefined;
    documentLibUsers?: DocumentLibUser[] | undefined;
}

export class DataTableDocumentLib implements IDataTableDocumentLib {
    id?: number;
    table?: number;
    documentLib?: number;
    created?: Date | undefined;
    createdBy?: number | undefined;
    modified?: Date | undefined;
    modifiedBy?: number | undefined;
    documentLibNavigation?: DocumentLib | undefined;
    tableNavigation?: DataTable | undefined;

    constructor(data?: IDataTableDocumentLib) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.table = _data["table"];
            this.documentLib = _data["documentLib"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : undefined as any;
            this.createdBy = _data["createdBy"];
            this.modified = _data["modified"] ? new Date(_data["modified"].toString()) : undefined as any;
            this.modifiedBy = _data["modifiedBy"];
            this.documentLibNavigation = _data["documentLibNavigation"] ? DocumentLib.fromJS(_data["documentLibNavigation"]) : undefined as any;
            this.tableNavigation = _data["tableNavigation"] ? DataTable.fromJS(_data["tableNavigation"]) : undefined as any;
        }
    }

    static fromJS(data: any): DataTableDocumentLib {
        data = typeof data === 'object' ? data : {};
        let result = new DataTableDocumentLib();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["table"] = this.table;
        data["documentLib"] = this.documentLib;
        data["created"] = this.created ? this.created.toISOString() : undefined as any;
        data["createdBy"] = this.createdBy;
        data["modified"] = this.modified ? this.modified.toISOString() : undefined as any;
        data["modifiedBy"] = this.modifiedBy;
        data["documentLibNavigation"] = this.documentLibNavigation ? this.documentLibNavigation.toJSON() : undefined as any;
        data["tableNavigation"] = this.tableNavigation ? this.tableNavigation.toJSON() : undefined as any;
        return data;
    }
}

export interface IDataTableDocumentLib {
    id?: number;
    table?: number;
    documentLib?: number;
    created?: Date | undefined;
    createdBy?: number | undefined;
    modified?: Date | undefined;
    modifiedBy?: number | undefined;
    documentLibNavigation?: DocumentLib | undefined;
    tableNavigation?: DataTable | undefined;
}

export class DataTable implements IDataTable {
    id?: number;
    name!: string;
    isDynamic?: boolean;
    documentLib?: number | undefined;
    documentLibPath?: string | undefined;
    created?: Date | undefined;
    createdBy?: number | undefined;
    modified?: Date | undefined;
    modifiedBy?: number | undefined;
    documentLibNavigation?: DocumentLib | undefined;
    dataLogs?: DataLog[] | undefined;
    dataNotes?: DataNote[] | undefined;
    dataNotifications?: DataNotification[] | undefined;
    dataTableColumns?: DataTableColumn[] | undefined;
    dataTableDocumentLibs?: DataTableDocumentLib[] | undefined;
    dataTableRows?: DataTableRow[] | undefined;
    dataTags?: DataTag[] | undefined;

    constructor(data?: IDataTable) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.isDynamic = _data["isDynamic"];
            this.documentLib = _data["documentLib"];
            this.documentLibPath = _data["documentLibPath"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : undefined as any;
            this.createdBy = _data["createdBy"];
            this.modified = _data["modified"] ? new Date(_data["modified"].toString()) : undefined as any;
            this.modifiedBy = _data["modifiedBy"];
            this.documentLibNavigation = _data["documentLibNavigation"] ? DocumentLib.fromJS(_data["documentLibNavigation"]) : undefined as any;
            if (Array.isArray(_data["dataLogs"])) {
                this.dataLogs = [] as any;
                for (let item of _data["dataLogs"])
                    this.dataLogs!.push(DataLog.fromJS(item));
            }
            if (Array.isArray(_data["dataNotes"])) {
                this.dataNotes = [] as any;
                for (let item of _data["dataNotes"])
                    this.dataNotes!.push(DataNote.fromJS(item));
            }
            if (Array.isArray(_data["dataNotifications"])) {
                this.dataNotifications = [] as any;
                for (let item of _data["dataNotifications"])
                    this.dataNotifications!.push(DataNotification.fromJS(item));
            }
            if (Array.isArray(_data["dataTableColumns"])) {
                this.dataTableColumns = [] as any;
                for (let item of _data["dataTableColumns"])
                    this.dataTableColumns!.push(DataTableColumn.fromJS(item));
            }
            if (Array.isArray(_data["dataTableDocumentLibs"])) {
                this.dataTableDocumentLibs = [] as any;
                for (let item of _data["dataTableDocumentLibs"])
                    this.dataTableDocumentLibs!.push(DataTableDocumentLib.fromJS(item));
            }
            if (Array.isArray(_data["dataTableRows"])) {
                this.dataTableRows = [] as any;
                for (let item of _data["dataTableRows"])
                    this.dataTableRows!.push(DataTableRow.fromJS(item));
            }
            if (Array.isArray(_data["dataTags"])) {
                this.dataTags = [] as any;
                for (let item of _data["dataTags"])
                    this.dataTags!.push(DataTag.fromJS(item));
            }
        }
    }

    static fromJS(data: any): DataTable {
        data = typeof data === 'object' ? data : {};
        let result = new DataTable();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["isDynamic"] = this.isDynamic;
        data["documentLib"] = this.documentLib;
        data["documentLibPath"] = this.documentLibPath;
        data["created"] = this.created ? this.created.toISOString() : undefined as any;
        data["createdBy"] = this.createdBy;
        data["modified"] = this.modified ? this.modified.toISOString() : undefined as any;
        data["modifiedBy"] = this.modifiedBy;
        data["documentLibNavigation"] = this.documentLibNavigation ? this.documentLibNavigation.toJSON() : undefined as any;
        if (Array.isArray(this.dataLogs)) {
            data["dataLogs"] = [];
            for (let item of this.dataLogs)
                data["dataLogs"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.dataNotes)) {
            data["dataNotes"] = [];
            for (let item of this.dataNotes)
                data["dataNotes"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.dataNotifications)) {
            data["dataNotifications"] = [];
            for (let item of this.dataNotifications)
                data["dataNotifications"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.dataTableColumns)) {
            data["dataTableColumns"] = [];
            for (let item of this.dataTableColumns)
                data["dataTableColumns"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.dataTableDocumentLibs)) {
            data["dataTableDocumentLibs"] = [];
            for (let item of this.dataTableDocumentLibs)
                data["dataTableDocumentLibs"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.dataTableRows)) {
            data["dataTableRows"] = [];
            for (let item of this.dataTableRows)
                data["dataTableRows"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.dataTags)) {
            data["dataTags"] = [];
            for (let item of this.dataTags)
                data["dataTags"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IDataTable {
    id?: number;
    name: string;
    isDynamic?: boolean;
    documentLib?: number | undefined;
    documentLibPath?: string | undefined;
    created?: Date | undefined;
    createdBy?: number | undefined;
    modified?: Date | undefined;
    modifiedBy?: number | undefined;
    documentLibNavigation?: DocumentLib | undefined;
    dataLogs?: DataLog[] | undefined;
    dataNotes?: DataNote[] | undefined;
    dataNotifications?: DataNotification[] | undefined;
    dataTableColumns?: DataTableColumn[] | undefined;
    dataTableDocumentLibs?: DataTableDocumentLib[] | undefined;
    dataTableRows?: DataTableRow[] | undefined;
    dataTags?: DataTag[] | undefined;
}

export class DataLog implements IDataLog {
    id?: number;
    table?: number;
    row?: number;
    actionType?: number;
    created?: Date;
    createdBy?: number;
    fields?: string | undefined;
    modified?: Date | undefined;
    modifiedBy?: number | undefined;
    uuid?: string | undefined;
    actionTypeNavigation?: DataLogActionType | undefined;
    tableNavigation?: DataTable | undefined;

    constructor(data?: IDataLog) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.table = _data["table"];
            this.row = _data["row"];
            this.actionType = _data["actionType"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : undefined as any;
            this.createdBy = _data["createdBy"];
            this.fields = _data["fields"];
            this.modified = _data["modified"] ? new Date(_data["modified"].toString()) : undefined as any;
            this.modifiedBy = _data["modifiedBy"];
            this.uuid = _data["uuid"];
            this.actionTypeNavigation = _data["actionTypeNavigation"] ? DataLogActionType.fromJS(_data["actionTypeNavigation"]) : undefined as any;
            this.tableNavigation = _data["tableNavigation"] ? DataTable.fromJS(_data["tableNavigation"]) : undefined as any;
        }
    }

    static fromJS(data: any): DataLog {
        data = typeof data === 'object' ? data : {};
        let result = new DataLog();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["table"] = this.table;
        data["row"] = this.row;
        data["actionType"] = this.actionType;
        data["created"] = this.created ? this.created.toISOString() : undefined as any;
        data["createdBy"] = this.createdBy;
        data["fields"] = this.fields;
        data["modified"] = this.modified ? this.modified.toISOString() : undefined as any;
        data["modifiedBy"] = this.modifiedBy;
        data["uuid"] = this.uuid;
        data["actionTypeNavigation"] = this.actionTypeNavigation ? this.actionTypeNavigation.toJSON() : undefined as any;
        data["tableNavigation"] = this.tableNavigation ? this.tableNavigation.toJSON() : undefined as any;
        return data;
    }
}

export interface IDataLog {
    id?: number;
    table?: number;
    row?: number;
    actionType?: number;
    created?: Date;
    createdBy?: number;
    fields?: string | undefined;
    modified?: Date | undefined;
    modifiedBy?: number | undefined;
    uuid?: string | undefined;
    actionTypeNavigation?: DataLogActionType | undefined;
    tableNavigation?: DataTable | undefined;
}

export class DataLogActionType implements IDataLogActionType {
    id?: number;
    name!: string;
    created?: Date | undefined;
    createdBy?: number | undefined;
    modified?: Date | undefined;
    modifiedBy?: number | undefined;
    dataLogs?: DataLog[] | undefined;
    salesChannels?: SalesChannel[] | undefined;

    constructor(data?: IDataLogActionType) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : undefined as any;
            this.createdBy = _data["createdBy"];
            this.modified = _data["modified"] ? new Date(_data["modified"].toString()) : undefined as any;
            this.modifiedBy = _data["modifiedBy"];
            if (Array.isArray(_data["dataLogs"])) {
                this.dataLogs = [] as any;
                for (let item of _data["dataLogs"])
                    this.dataLogs!.push(DataLog.fromJS(item));
            }
            if (Array.isArray(_data["salesChannels"])) {
                this.salesChannels = [] as any;
                for (let item of _data["salesChannels"])
                    this.salesChannels!.push(SalesChannel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): DataLogActionType {
        data = typeof data === 'object' ? data : {};
        let result = new DataLogActionType();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["created"] = this.created ? this.created.toISOString() : undefined as any;
        data["createdBy"] = this.createdBy;
        data["modified"] = this.modified ? this.modified.toISOString() : undefined as any;
        data["modifiedBy"] = this.modifiedBy;
        if (Array.isArray(this.dataLogs)) {
            data["dataLogs"] = [];
            for (let item of this.dataLogs)
                data["dataLogs"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.salesChannels)) {
            data["salesChannels"] = [];
            for (let item of this.salesChannels)
                data["salesChannels"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IDataLogActionType {
    id?: number;
    name: string;
    created?: Date | undefined;
    createdBy?: number | undefined;
    modified?: Date | undefined;
    modifiedBy?: number | undefined;
    dataLogs?: DataLog[] | undefined;
    salesChannels?: SalesChannel[] | undefined;
}

export class SalesChannel implements ISalesChannel {
    id?: number;
    num!: string;
    name!: string;
    orderNumIntNextCompleted?: number;
    orderNumIntNext?: number;
    orderNumFormat!: string;
    orderType?: string | undefined;
    orderMaintenance?: number | undefined;
    warehouseOutboundOrderType?: string | undefined;
    synced?: Date | undefined;
    syncedBy?: number | undefined;
    created?: Date | undefined;
    createdBy?: number | undefined;
    modified?: Date | undefined;
    modifiedBy?: number | undefined;
    orderMaintenanceNavigation?: DataLogActionType | undefined;
    orderTypeNavigation?: SalesOrderType | undefined;
    warehouseOutboundOrderTypeNavigation?: WarehouseOutboundOrderType | undefined;
    custInvoices?: CustInvoice[] | undefined;
    salesChannelOrderStatuses?: SalesChannelOrderStatus[] | undefined;
    salesChannelProducts?: SalesChannelProduct[] | undefined;
    salesOrders?: SalesOrder[] | undefined;

    constructor(data?: ISalesChannel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.num = _data["num"];
            this.name = _data["name"];
            this.orderNumIntNextCompleted = _data["orderNumIntNextCompleted"];
            this.orderNumIntNext = _data["orderNumIntNext"];
            this.orderNumFormat = _data["orderNumFormat"];
            this.orderType = _data["orderType"];
            this.orderMaintenance = _data["orderMaintenance"];
            this.warehouseOutboundOrderType = _data["warehouseOutboundOrderType"];
            this.synced = _data["synced"] ? new Date(_data["synced"].toString()) : undefined as any;
            this.syncedBy = _data["syncedBy"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : undefined as any;
            this.createdBy = _data["createdBy"];
            this.modified = _data["modified"] ? new Date(_data["modified"].toString()) : undefined as any;
            this.modifiedBy = _data["modifiedBy"];
            this.orderMaintenanceNavigation = _data["orderMaintenanceNavigation"] ? DataLogActionType.fromJS(_data["orderMaintenanceNavigation"]) : undefined as any;
            this.orderTypeNavigation = _data["orderTypeNavigation"] ? SalesOrderType.fromJS(_data["orderTypeNavigation"]) : undefined as any;
            this.warehouseOutboundOrderTypeNavigation = _data["warehouseOutboundOrderTypeNavigation"] ? WarehouseOutboundOrderType.fromJS(_data["warehouseOutboundOrderTypeNavigation"]) : undefined as any;
            if (Array.isArray(_data["custInvoices"])) {
                this.custInvoices = [] as any;
                for (let item of _data["custInvoices"])
                    this.custInvoices!.push(CustInvoice.fromJS(item));
            }
            if (Array.isArray(_data["salesChannelOrderStatuses"])) {
                this.salesChannelOrderStatuses = [] as any;
                for (let item of _data["salesChannelOrderStatuses"])
                    this.salesChannelOrderStatuses!.push(SalesChannelOrderStatus.fromJS(item));
            }
            if (Array.isArray(_data["salesChannelProducts"])) {
                this.salesChannelProducts = [] as any;
                for (let item of _data["salesChannelProducts"])
                    this.salesChannelProducts!.push(SalesChannelProduct.fromJS(item));
            }
            if (Array.isArray(_data["salesOrders"])) {
                this.salesOrders = [] as any;
                for (let item of _data["salesOrders"])
                    this.salesOrders!.push(SalesOrder.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SalesChannel {
        data = typeof data === 'object' ? data : {};
        let result = new SalesChannel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["num"] = this.num;
        data["name"] = this.name;
        data["orderNumIntNextCompleted"] = this.orderNumIntNextCompleted;
        data["orderNumIntNext"] = this.orderNumIntNext;
        data["orderNumFormat"] = this.orderNumFormat;
        data["orderType"] = this.orderType;
        data["orderMaintenance"] = this.orderMaintenance;
        data["warehouseOutboundOrderType"] = this.warehouseOutboundOrderType;
        data["synced"] = this.synced ? this.synced.toISOString() : undefined as any;
        data["syncedBy"] = this.syncedBy;
        data["created"] = this.created ? this.created.toISOString() : undefined as any;
        data["createdBy"] = this.createdBy;
        data["modified"] = this.modified ? this.modified.toISOString() : undefined as any;
        data["modifiedBy"] = this.modifiedBy;
        data["orderMaintenanceNavigation"] = this.orderMaintenanceNavigation ? this.orderMaintenanceNavigation.toJSON() : undefined as any;
        data["orderTypeNavigation"] = this.orderTypeNavigation ? this.orderTypeNavigation.toJSON() : undefined as any;
        data["warehouseOutboundOrderTypeNavigation"] = this.warehouseOutboundOrderTypeNavigation ? this.warehouseOutboundOrderTypeNavigation.toJSON() : undefined as any;
        if (Array.isArray(this.custInvoices)) {
            data["custInvoices"] = [];
            for (let item of this.custInvoices)
                data["custInvoices"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.salesChannelOrderStatuses)) {
            data["salesChannelOrderStatuses"] = [];
            for (let item of this.salesChannelOrderStatuses)
                data["salesChannelOrderStatuses"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.salesChannelProducts)) {
            data["salesChannelProducts"] = [];
            for (let item of this.salesChannelProducts)
                data["salesChannelProducts"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.salesOrders)) {
            data["salesOrders"] = [];
            for (let item of this.salesOrders)
                data["salesOrders"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ISalesChannel {
    id?: number;
    num: string;
    name: string;
    orderNumIntNextCompleted?: number;
    orderNumIntNext?: number;
    orderNumFormat: string;
    orderType?: string | undefined;
    orderMaintenance?: number | undefined;
    warehouseOutboundOrderType?: string | undefined;
    synced?: Date | undefined;
    syncedBy?: number | undefined;
    created?: Date | undefined;
    createdBy?: number | undefined;
    modified?: Date | undefined;
    modifiedBy?: number | undefined;
    orderMaintenanceNavigation?: DataLogActionType | undefined;
    orderTypeNavigation?: SalesOrderType | undefined;
    warehouseOutboundOrderTypeNavigation?: WarehouseOutboundOrderType | undefined;
    custInvoices?: CustInvoice[] | undefined;
    salesChannelOrderStatuses?: SalesChannelOrderStatus[] | undefined;
    salesChannelProducts?: SalesChannelProduct[] | undefined;
    salesOrders?: SalesOrder[] | undefined;
}

export class SalesOrderType implements ISalesOrderType {
    id?: number;
    num?: string | undefined;
    name!: string;
    created?: Date | undefined;
    createdBy?: number | undefined;
    modified?: Date | undefined;
    modifiedBy?: number | undefined;
    salesChannels?: SalesChannel[] | undefined;
    salesOrders?: SalesOrder[] | undefined;

    constructor(data?: ISalesOrderType) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.num = _data["num"];
            this.name = _data["name"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : undefined as any;
            this.createdBy = _data["createdBy"];
            this.modified = _data["modified"] ? new Date(_data["modified"].toString()) : undefined as any;
            this.modifiedBy = _data["modifiedBy"];
            if (Array.isArray(_data["salesChannels"])) {
                this.salesChannels = [] as any;
                for (let item of _data["salesChannels"])
                    this.salesChannels!.push(SalesChannel.fromJS(item));
            }
            if (Array.isArray(_data["salesOrders"])) {
                this.salesOrders = [] as any;
                for (let item of _data["salesOrders"])
                    this.salesOrders!.push(SalesOrder.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SalesOrderType {
        data = typeof data === 'object' ? data : {};
        let result = new SalesOrderType();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["num"] = this.num;
        data["name"] = this.name;
        data["created"] = this.created ? this.created.toISOString() : undefined as any;
        data["createdBy"] = this.createdBy;
        data["modified"] = this.modified ? this.modified.toISOString() : undefined as any;
        data["modifiedBy"] = this.modifiedBy;
        if (Array.isArray(this.salesChannels)) {
            data["salesChannels"] = [];
            for (let item of this.salesChannels)
                data["salesChannels"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.salesOrders)) {
            data["salesOrders"] = [];
            for (let item of this.salesOrders)
                data["salesOrders"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ISalesOrderType {
    id?: number;
    num?: string | undefined;
    name: string;
    created?: Date | undefined;
    createdBy?: number | undefined;
    modified?: Date | undefined;
    modifiedBy?: number | undefined;
    salesChannels?: SalesChannel[] | undefined;
    salesOrders?: SalesOrder[] | undefined;
}

export class SalesOrder implements ISalesOrder {
    id?: number;
    num?: string | undefined;
    name?: string | undefined;
    status?: number;
    type!: string;
    outboundOrderType?: string | undefined;
    channel!: string;
    channelOrder!: string;
    currency!: string;
    amountCurExTax?: number;
    amountCurTax?: number | undefined;
    amountCur?: number;
    custNote?: string | undefined;
    custType?: string | undefined;
    custNum?: string | undefined;
    custEAN?: string | undefined;
    custVATNum?: string | undefined;
    custEmail?: string | undefined;
    custPhone?: string | undefined;
    carrier?: string | undefined;
    carrierServicePoint?: string | undefined;
    shipToBillAddress?: boolean;
    shipFirstName?: string | undefined;
    shipLastName?: string | undefined;
    shipCompanyName?: string | undefined;
    shipAddress1?: string | undefined;
    shipAddress2?: string | undefined;
    shipPostalCode?: string | undefined;
    shipPostalDistrict?: string | undefined;
    shipCountryCode?: string | undefined;
    billFirstName?: string | undefined;
    billLastName?: string | undefined;
    billCompanyName?: string | undefined;
    billAddress1?: string | undefined;
    billAddress2?: string | undefined;
    billPostalCode?: string | undefined;
    billPostalDistrict?: string | undefined;
    billCountryCode?: string | undefined;
    paymentType?: string | undefined;
    paymentReference?: string | undefined;
    orderDate?: Date | undefined;
    orderChangeDate?: Date | undefined;
    reservedDate?: Date | undefined;
    shipDate?: Date | undefined;
    invoiceDate?: Date | undefined;
    invoiceNum?: string | undefined;
    captureDate?: Date | undefined;
    captureAmountCur?: number | undefined;
    settleDate?: Date | undefined;
    created?: Date | undefined;
    createdBy?: number | undefined;
    createdJobId?: number | undefined;
    modified?: Date | undefined;
    modifiedBy?: number | undefined;
    modifiedJobId?: number | undefined;
    carrierNavigation?: WarehouseCarrier | undefined;
    channelNavigation?: SalesChannel | undefined;
    outboundOrderTypeNavigation?: WarehouseOutboundOrderType | undefined;
    paymentTypeNavigation?: SalesPaymentType | undefined;
    statusNavigation?: SalesOrderStatus | undefined;
    typeNavigation?: SalesOrderType | undefined;
    custInvoices?: CustInvoice[] | undefined;
    salesOrderLines?: SalesOrderLine[] | undefined;
    salesOrderTransLineNavigations?: SalesOrderTrans[] | undefined;
    salesOrderTransOrderNavigations?: SalesOrderTrans[] | undefined;
    warehouseOutboundOrders?: WarehouseOutboundOrder[] | undefined;

    constructor(data?: ISalesOrder) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.num = _data["num"];
            this.name = _data["name"];
            this.status = _data["status"];
            this.type = _data["type"];
            this.outboundOrderType = _data["outboundOrderType"];
            this.channel = _data["channel"];
            this.channelOrder = _data["channelOrder"];
            this.currency = _data["currency"];
            this.amountCurExTax = _data["amountCurExTax"];
            this.amountCurTax = _data["amountCurTax"];
            this.amountCur = _data["amountCur"];
            this.custNote = _data["custNote"];
            this.custType = _data["custType"];
            this.custNum = _data["custNum"];
            this.custEAN = _data["custEAN"];
            this.custVATNum = _data["custVATNum"];
            this.custEmail = _data["custEmail"];
            this.custPhone = _data["custPhone"];
            this.carrier = _data["carrier"];
            this.carrierServicePoint = _data["carrierServicePoint"];
            this.shipToBillAddress = _data["shipToBillAddress"];
            this.shipFirstName = _data["shipFirstName"];
            this.shipLastName = _data["shipLastName"];
            this.shipCompanyName = _data["shipCompanyName"];
            this.shipAddress1 = _data["shipAddress1"];
            this.shipAddress2 = _data["shipAddress2"];
            this.shipPostalCode = _data["shipPostalCode"];
            this.shipPostalDistrict = _data["shipPostalDistrict"];
            this.shipCountryCode = _data["shipCountryCode"];
            this.billFirstName = _data["billFirstName"];
            this.billLastName = _data["billLastName"];
            this.billCompanyName = _data["billCompanyName"];
            this.billAddress1 = _data["billAddress1"];
            this.billAddress2 = _data["billAddress2"];
            this.billPostalCode = _data["billPostalCode"];
            this.billPostalDistrict = _data["billPostalDistrict"];
            this.billCountryCode = _data["billCountryCode"];
            this.paymentType = _data["paymentType"];
            this.paymentReference = _data["paymentReference"];
            this.orderDate = _data["orderDate"] ? new Date(_data["orderDate"].toString()) : undefined as any;
            this.orderChangeDate = _data["orderChangeDate"] ? new Date(_data["orderChangeDate"].toString()) : undefined as any;
            this.reservedDate = _data["reservedDate"] ? new Date(_data["reservedDate"].toString()) : undefined as any;
            this.shipDate = _data["shipDate"] ? new Date(_data["shipDate"].toString()) : undefined as any;
            this.invoiceDate = _data["invoiceDate"] ? new Date(_data["invoiceDate"].toString()) : undefined as any;
            this.invoiceNum = _data["invoiceNum"];
            this.captureDate = _data["captureDate"] ? new Date(_data["captureDate"].toString()) : undefined as any;
            this.captureAmountCur = _data["captureAmountCur"];
            this.settleDate = _data["settleDate"] ? new Date(_data["settleDate"].toString()) : undefined as any;
            this.created = _data["created"] ? new Date(_data["created"].toString()) : undefined as any;
            this.createdBy = _data["createdBy"];
            this.createdJobId = _data["createdJobId"];
            this.modified = _data["modified"] ? new Date(_data["modified"].toString()) : undefined as any;
            this.modifiedBy = _data["modifiedBy"];
            this.modifiedJobId = _data["modifiedJobId"];
            this.carrierNavigation = _data["carrierNavigation"] ? WarehouseCarrier.fromJS(_data["carrierNavigation"]) : undefined as any;
            this.channelNavigation = _data["channelNavigation"] ? SalesChannel.fromJS(_data["channelNavigation"]) : undefined as any;
            this.outboundOrderTypeNavigation = _data["outboundOrderTypeNavigation"] ? WarehouseOutboundOrderType.fromJS(_data["outboundOrderTypeNavigation"]) : undefined as any;
            this.paymentTypeNavigation = _data["paymentTypeNavigation"] ? SalesPaymentType.fromJS(_data["paymentTypeNavigation"]) : undefined as any;
            this.statusNavigation = _data["statusNavigation"] ? SalesOrderStatus.fromJS(_data["statusNavigation"]) : undefined as any;
            this.typeNavigation = _data["typeNavigation"] ? SalesOrderType.fromJS(_data["typeNavigation"]) : undefined as any;
            if (Array.isArray(_data["custInvoices"])) {
                this.custInvoices = [] as any;
                for (let item of _data["custInvoices"])
                    this.custInvoices!.push(CustInvoice.fromJS(item));
            }
            if (Array.isArray(_data["salesOrderLines"])) {
                this.salesOrderLines = [] as any;
                for (let item of _data["salesOrderLines"])
                    this.salesOrderLines!.push(SalesOrderLine.fromJS(item));
            }
            if (Array.isArray(_data["salesOrderTransLineNavigations"])) {
                this.salesOrderTransLineNavigations = [] as any;
                for (let item of _data["salesOrderTransLineNavigations"])
                    this.salesOrderTransLineNavigations!.push(SalesOrderTrans.fromJS(item));
            }
            if (Array.isArray(_data["salesOrderTransOrderNavigations"])) {
                this.salesOrderTransOrderNavigations = [] as any;
                for (let item of _data["salesOrderTransOrderNavigations"])
                    this.salesOrderTransOrderNavigations!.push(SalesOrderTrans.fromJS(item));
            }
            if (Array.isArray(_data["warehouseOutboundOrders"])) {
                this.warehouseOutboundOrders = [] as any;
                for (let item of _data["warehouseOutboundOrders"])
                    this.warehouseOutboundOrders!.push(WarehouseOutboundOrder.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SalesOrder {
        data = typeof data === 'object' ? data : {};
        let result = new SalesOrder();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["num"] = this.num;
        data["name"] = this.name;
        data["status"] = this.status;
        data["type"] = this.type;
        data["outboundOrderType"] = this.outboundOrderType;
        data["channel"] = this.channel;
        data["channelOrder"] = this.channelOrder;
        data["currency"] = this.currency;
        data["amountCurExTax"] = this.amountCurExTax;
        data["amountCurTax"] = this.amountCurTax;
        data["amountCur"] = this.amountCur;
        data["custNote"] = this.custNote;
        data["custType"] = this.custType;
        data["custNum"] = this.custNum;
        data["custEAN"] = this.custEAN;
        data["custVATNum"] = this.custVATNum;
        data["custEmail"] = this.custEmail;
        data["custPhone"] = this.custPhone;
        data["carrier"] = this.carrier;
        data["carrierServicePoint"] = this.carrierServicePoint;
        data["shipToBillAddress"] = this.shipToBillAddress;
        data["shipFirstName"] = this.shipFirstName;
        data["shipLastName"] = this.shipLastName;
        data["shipCompanyName"] = this.shipCompanyName;
        data["shipAddress1"] = this.shipAddress1;
        data["shipAddress2"] = this.shipAddress2;
        data["shipPostalCode"] = this.shipPostalCode;
        data["shipPostalDistrict"] = this.shipPostalDistrict;
        data["shipCountryCode"] = this.shipCountryCode;
        data["billFirstName"] = this.billFirstName;
        data["billLastName"] = this.billLastName;
        data["billCompanyName"] = this.billCompanyName;
        data["billAddress1"] = this.billAddress1;
        data["billAddress2"] = this.billAddress2;
        data["billPostalCode"] = this.billPostalCode;
        data["billPostalDistrict"] = this.billPostalDistrict;
        data["billCountryCode"] = this.billCountryCode;
        data["paymentType"] = this.paymentType;
        data["paymentReference"] = this.paymentReference;
        data["orderDate"] = this.orderDate ? this.orderDate.toISOString() : undefined as any;
        data["orderChangeDate"] = this.orderChangeDate ? this.orderChangeDate.toISOString() : undefined as any;
        data["reservedDate"] = this.reservedDate ? this.reservedDate.toISOString() : undefined as any;
        data["shipDate"] = this.shipDate ? this.shipDate.toISOString() : undefined as any;
        data["invoiceDate"] = this.invoiceDate ? this.invoiceDate.toISOString() : undefined as any;
        data["invoiceNum"] = this.invoiceNum;
        data["captureDate"] = this.captureDate ? this.captureDate.toISOString() : undefined as any;
        data["captureAmountCur"] = this.captureAmountCur;
        data["settleDate"] = this.settleDate ? this.settleDate.toISOString() : undefined as any;
        data["created"] = this.created ? this.created.toISOString() : undefined as any;
        data["createdBy"] = this.createdBy;
        data["createdJobId"] = this.createdJobId;
        data["modified"] = this.modified ? this.modified.toISOString() : undefined as any;
        data["modifiedBy"] = this.modifiedBy;
        data["modifiedJobId"] = this.modifiedJobId;
        data["carrierNavigation"] = this.carrierNavigation ? this.carrierNavigation.toJSON() : undefined as any;
        data["channelNavigation"] = this.channelNavigation ? this.channelNavigation.toJSON() : undefined as any;
        data["outboundOrderTypeNavigation"] = this.outboundOrderTypeNavigation ? this.outboundOrderTypeNavigation.toJSON() : undefined as any;
        data["paymentTypeNavigation"] = this.paymentTypeNavigation ? this.paymentTypeNavigation.toJSON() : undefined as any;
        data["statusNavigation"] = this.statusNavigation ? this.statusNavigation.toJSON() : undefined as any;
        data["typeNavigation"] = this.typeNavigation ? this.typeNavigation.toJSON() : undefined as any;
        if (Array.isArray(this.custInvoices)) {
            data["custInvoices"] = [];
            for (let item of this.custInvoices)
                data["custInvoices"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.salesOrderLines)) {
            data["salesOrderLines"] = [];
            for (let item of this.salesOrderLines)
                data["salesOrderLines"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.salesOrderTransLineNavigations)) {
            data["salesOrderTransLineNavigations"] = [];
            for (let item of this.salesOrderTransLineNavigations)
                data["salesOrderTransLineNavigations"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.salesOrderTransOrderNavigations)) {
            data["salesOrderTransOrderNavigations"] = [];
            for (let item of this.salesOrderTransOrderNavigations)
                data["salesOrderTransOrderNavigations"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.warehouseOutboundOrders)) {
            data["warehouseOutboundOrders"] = [];
            for (let item of this.warehouseOutboundOrders)
                data["warehouseOutboundOrders"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ISalesOrder {
    id?: number;
    num?: string | undefined;
    name?: string | undefined;
    status?: number;
    type: string;
    outboundOrderType?: string | undefined;
    channel: string;
    channelOrder: string;
    currency: string;
    amountCurExTax?: number;
    amountCurTax?: number | undefined;
    amountCur?: number;
    custNote?: string | undefined;
    custType?: string | undefined;
    custNum?: string | undefined;
    custEAN?: string | undefined;
    custVATNum?: string | undefined;
    custEmail?: string | undefined;
    custPhone?: string | undefined;
    carrier?: string | undefined;
    carrierServicePoint?: string | undefined;
    shipToBillAddress?: boolean;
    shipFirstName?: string | undefined;
    shipLastName?: string | undefined;
    shipCompanyName?: string | undefined;
    shipAddress1?: string | undefined;
    shipAddress2?: string | undefined;
    shipPostalCode?: string | undefined;
    shipPostalDistrict?: string | undefined;
    shipCountryCode?: string | undefined;
    billFirstName?: string | undefined;
    billLastName?: string | undefined;
    billCompanyName?: string | undefined;
    billAddress1?: string | undefined;
    billAddress2?: string | undefined;
    billPostalCode?: string | undefined;
    billPostalDistrict?: string | undefined;
    billCountryCode?: string | undefined;
    paymentType?: string | undefined;
    paymentReference?: string | undefined;
    orderDate?: Date | undefined;
    orderChangeDate?: Date | undefined;
    reservedDate?: Date | undefined;
    shipDate?: Date | undefined;
    invoiceDate?: Date | undefined;
    invoiceNum?: string | undefined;
    captureDate?: Date | undefined;
    captureAmountCur?: number | undefined;
    settleDate?: Date | undefined;
    created?: Date | undefined;
    createdBy?: number | undefined;
    createdJobId?: number | undefined;
    modified?: Date | undefined;
    modifiedBy?: number | undefined;
    modifiedJobId?: number | undefined;
    carrierNavigation?: WarehouseCarrier | undefined;
    channelNavigation?: SalesChannel | undefined;
    outboundOrderTypeNavigation?: WarehouseOutboundOrderType | undefined;
    paymentTypeNavigation?: SalesPaymentType | undefined;
    statusNavigation?: SalesOrderStatus | undefined;
    typeNavigation?: SalesOrderType | undefined;
    custInvoices?: CustInvoice[] | undefined;
    salesOrderLines?: SalesOrderLine[] | undefined;
    salesOrderTransLineNavigations?: SalesOrderTrans[] | undefined;
    salesOrderTransOrderNavigations?: SalesOrderTrans[] | undefined;
    warehouseOutboundOrders?: WarehouseOutboundOrder[] | undefined;
}

export class WarehouseCarrier implements IWarehouseCarrier {
    id?: number;
    num?: string | undefined;
    name!: string;
    sorting?: number;
    created?: Date | undefined;
    createdBy?: number | undefined;
    modified?: Date | undefined;
    modifiedBy?: number | undefined;
    salesOrders?: SalesOrder[] | undefined;
    warehouseOutboundOrders?: WarehouseOutboundOrder[] | undefined;
    warehouseOutboundOrderTypes?: WarehouseOutboundOrderType[] | undefined;

    constructor(data?: IWarehouseCarrier) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.num = _data["num"];
            this.name = _data["name"];
            this.sorting = _data["sorting"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : undefined as any;
            this.createdBy = _data["createdBy"];
            this.modified = _data["modified"] ? new Date(_data["modified"].toString()) : undefined as any;
            this.modifiedBy = _data["modifiedBy"];
            if (Array.isArray(_data["salesOrders"])) {
                this.salesOrders = [] as any;
                for (let item of _data["salesOrders"])
                    this.salesOrders!.push(SalesOrder.fromJS(item));
            }
            if (Array.isArray(_data["warehouseOutboundOrders"])) {
                this.warehouseOutboundOrders = [] as any;
                for (let item of _data["warehouseOutboundOrders"])
                    this.warehouseOutboundOrders!.push(WarehouseOutboundOrder.fromJS(item));
            }
            if (Array.isArray(_data["warehouseOutboundOrderTypes"])) {
                this.warehouseOutboundOrderTypes = [] as any;
                for (let item of _data["warehouseOutboundOrderTypes"])
                    this.warehouseOutboundOrderTypes!.push(WarehouseOutboundOrderType.fromJS(item));
            }
        }
    }

    static fromJS(data: any): WarehouseCarrier {
        data = typeof data === 'object' ? data : {};
        let result = new WarehouseCarrier();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["num"] = this.num;
        data["name"] = this.name;
        data["sorting"] = this.sorting;
        data["created"] = this.created ? this.created.toISOString() : undefined as any;
        data["createdBy"] = this.createdBy;
        data["modified"] = this.modified ? this.modified.toISOString() : undefined as any;
        data["modifiedBy"] = this.modifiedBy;
        if (Array.isArray(this.salesOrders)) {
            data["salesOrders"] = [];
            for (let item of this.salesOrders)
                data["salesOrders"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.warehouseOutboundOrders)) {
            data["warehouseOutboundOrders"] = [];
            for (let item of this.warehouseOutboundOrders)
                data["warehouseOutboundOrders"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.warehouseOutboundOrderTypes)) {
            data["warehouseOutboundOrderTypes"] = [];
            for (let item of this.warehouseOutboundOrderTypes)
                data["warehouseOutboundOrderTypes"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IWarehouseCarrier {
    id?: number;
    num?: string | undefined;
    name: string;
    sorting?: number;
    created?: Date | undefined;
    createdBy?: number | undefined;
    modified?: Date | undefined;
    modifiedBy?: number | undefined;
    salesOrders?: SalesOrder[] | undefined;
    warehouseOutboundOrders?: WarehouseOutboundOrder[] | undefined;
    warehouseOutboundOrderTypes?: WarehouseOutboundOrderType[] | undefined;
}

export class WarehouseOutboundOrder implements IWarehouseOutboundOrder {
    id?: number;
    num!: string;
    warehouse!: string;
    type!: string;
    status?: number;
    salesOrder?: string | undefined;
    name?: string | undefined;
    shipDateRequested?: Date;
    carrier!: string;
    carrierServicePoint?: string | undefined;
    trackTrace?: string | undefined;
    note?: string | undefined;
    email?: string | undefined;
    phone?: string | undefined;
    shipName?: string | undefined;
    shipName2?: string | undefined;
    shipAddress1?: string | undefined;
    shipAddress2?: string | undefined;
    shipPostalCode?: string | undefined;
    shipPostalDistrict?: string | undefined;
    shipCountryCode?: string | undefined;
    releasedDate?: Date | undefined;
    confirmedDate?: Date | undefined;
    reservedDate?: Date | undefined;
    shipDateDispatched?: Date | undefined;
    created?: Date | undefined;
    createdBy?: number | undefined;
    modified?: Date | undefined;
    modifiedBy?: number | undefined;
    carrierNavigation?: WarehouseCarrier | undefined;
    salesOrderNavigation?: SalesOrder | undefined;
    statusNavigation?: WarehouseOutboundOrderStatus | undefined;
    typeNavigation?: WarehouseOutboundOrderType | undefined;
    warehouseNavigation?: Warehouse | undefined;
    salesOrderTrans?: SalesOrderTrans[] | undefined;
    warehouseOutboundOrderLines?: WarehouseOutboundOrderLine[] | undefined;

    constructor(data?: IWarehouseOutboundOrder) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.num = _data["num"];
            this.warehouse = _data["warehouse"];
            this.type = _data["type"];
            this.status = _data["status"];
            this.salesOrder = _data["salesOrder"];
            this.name = _data["name"];
            this.shipDateRequested = _data["shipDateRequested"] ? new Date(_data["shipDateRequested"].toString()) : undefined as any;
            this.carrier = _data["carrier"];
            this.carrierServicePoint = _data["carrierServicePoint"];
            this.trackTrace = _data["trackTrace"];
            this.note = _data["note"];
            this.email = _data["email"];
            this.phone = _data["phone"];
            this.shipName = _data["shipName"];
            this.shipName2 = _data["shipName2"];
            this.shipAddress1 = _data["shipAddress1"];
            this.shipAddress2 = _data["shipAddress2"];
            this.shipPostalCode = _data["shipPostalCode"];
            this.shipPostalDistrict = _data["shipPostalDistrict"];
            this.shipCountryCode = _data["shipCountryCode"];
            this.releasedDate = _data["releasedDate"] ? new Date(_data["releasedDate"].toString()) : undefined as any;
            this.confirmedDate = _data["confirmedDate"] ? new Date(_data["confirmedDate"].toString()) : undefined as any;
            this.reservedDate = _data["reservedDate"] ? new Date(_data["reservedDate"].toString()) : undefined as any;
            this.shipDateDispatched = _data["shipDateDispatched"] ? new Date(_data["shipDateDispatched"].toString()) : undefined as any;
            this.created = _data["created"] ? new Date(_data["created"].toString()) : undefined as any;
            this.createdBy = _data["createdBy"];
            this.modified = _data["modified"] ? new Date(_data["modified"].toString()) : undefined as any;
            this.modifiedBy = _data["modifiedBy"];
            this.carrierNavigation = _data["carrierNavigation"] ? WarehouseCarrier.fromJS(_data["carrierNavigation"]) : undefined as any;
            this.salesOrderNavigation = _data["salesOrderNavigation"] ? SalesOrder.fromJS(_data["salesOrderNavigation"]) : undefined as any;
            this.statusNavigation = _data["statusNavigation"] ? WarehouseOutboundOrderStatus.fromJS(_data["statusNavigation"]) : undefined as any;
            this.typeNavigation = _data["typeNavigation"] ? WarehouseOutboundOrderType.fromJS(_data["typeNavigation"]) : undefined as any;
            this.warehouseNavigation = _data["warehouseNavigation"] ? Warehouse.fromJS(_data["warehouseNavigation"]) : undefined as any;
            if (Array.isArray(_data["salesOrderTrans"])) {
                this.salesOrderTrans = [] as any;
                for (let item of _data["salesOrderTrans"])
                    this.salesOrderTrans!.push(SalesOrderTrans.fromJS(item));
            }
            if (Array.isArray(_data["warehouseOutboundOrderLines"])) {
                this.warehouseOutboundOrderLines = [] as any;
                for (let item of _data["warehouseOutboundOrderLines"])
                    this.warehouseOutboundOrderLines!.push(WarehouseOutboundOrderLine.fromJS(item));
            }
        }
    }

    static fromJS(data: any): WarehouseOutboundOrder {
        data = typeof data === 'object' ? data : {};
        let result = new WarehouseOutboundOrder();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["num"] = this.num;
        data["warehouse"] = this.warehouse;
        data["type"] = this.type;
        data["status"] = this.status;
        data["salesOrder"] = this.salesOrder;
        data["name"] = this.name;
        data["shipDateRequested"] = this.shipDateRequested ? this.shipDateRequested.toISOString() : undefined as any;
        data["carrier"] = this.carrier;
        data["carrierServicePoint"] = this.carrierServicePoint;
        data["trackTrace"] = this.trackTrace;
        data["note"] = this.note;
        data["email"] = this.email;
        data["phone"] = this.phone;
        data["shipName"] = this.shipName;
        data["shipName2"] = this.shipName2;
        data["shipAddress1"] = this.shipAddress1;
        data["shipAddress2"] = this.shipAddress2;
        data["shipPostalCode"] = this.shipPostalCode;
        data["shipPostalDistrict"] = this.shipPostalDistrict;
        data["shipCountryCode"] = this.shipCountryCode;
        data["releasedDate"] = this.releasedDate ? this.releasedDate.toISOString() : undefined as any;
        data["confirmedDate"] = this.confirmedDate ? this.confirmedDate.toISOString() : undefined as any;
        data["reservedDate"] = this.reservedDate ? this.reservedDate.toISOString() : undefined as any;
        data["shipDateDispatched"] = this.shipDateDispatched ? this.shipDateDispatched.toISOString() : undefined as any;
        data["created"] = this.created ? this.created.toISOString() : undefined as any;
        data["createdBy"] = this.createdBy;
        data["modified"] = this.modified ? this.modified.toISOString() : undefined as any;
        data["modifiedBy"] = this.modifiedBy;
        data["carrierNavigation"] = this.carrierNavigation ? this.carrierNavigation.toJSON() : undefined as any;
        data["salesOrderNavigation"] = this.salesOrderNavigation ? this.salesOrderNavigation.toJSON() : undefined as any;
        data["statusNavigation"] = this.statusNavigation ? this.statusNavigation.toJSON() : undefined as any;
        data["typeNavigation"] = this.typeNavigation ? this.typeNavigation.toJSON() : undefined as any;
        data["warehouseNavigation"] = this.warehouseNavigation ? this.warehouseNavigation.toJSON() : undefined as any;
        if (Array.isArray(this.salesOrderTrans)) {
            data["salesOrderTrans"] = [];
            for (let item of this.salesOrderTrans)
                data["salesOrderTrans"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.warehouseOutboundOrderLines)) {
            data["warehouseOutboundOrderLines"] = [];
            for (let item of this.warehouseOutboundOrderLines)
                data["warehouseOutboundOrderLines"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IWarehouseOutboundOrder {
    id?: number;
    num: string;
    warehouse: string;
    type: string;
    status?: number;
    salesOrder?: string | undefined;
    name?: string | undefined;
    shipDateRequested?: Date;
    carrier: string;
    carrierServicePoint?: string | undefined;
    trackTrace?: string | undefined;
    note?: string | undefined;
    email?: string | undefined;
    phone?: string | undefined;
    shipName?: string | undefined;
    shipName2?: string | undefined;
    shipAddress1?: string | undefined;
    shipAddress2?: string | undefined;
    shipPostalCode?: string | undefined;
    shipPostalDistrict?: string | undefined;
    shipCountryCode?: string | undefined;
    releasedDate?: Date | undefined;
    confirmedDate?: Date | undefined;
    reservedDate?: Date | undefined;
    shipDateDispatched?: Date | undefined;
    created?: Date | undefined;
    createdBy?: number | undefined;
    modified?: Date | undefined;
    modifiedBy?: number | undefined;
    carrierNavigation?: WarehouseCarrier | undefined;
    salesOrderNavigation?: SalesOrder | undefined;
    statusNavigation?: WarehouseOutboundOrderStatus | undefined;
    typeNavigation?: WarehouseOutboundOrderType | undefined;
    warehouseNavigation?: Warehouse | undefined;
    salesOrderTrans?: SalesOrderTrans[] | undefined;
    warehouseOutboundOrderLines?: WarehouseOutboundOrderLine[] | undefined;
}

export class WarehouseOutboundOrderStatus implements IWarehouseOutboundOrderStatus {
    id?: number;
    num!: string;
    name!: string;
    isClosed?: boolean;
    sorting?: number;
    created?: Date | undefined;
    createdBy?: number | undefined;
    modified?: Date | undefined;
    modifiedBy?: number | undefined;
    warehouseOutboundOrderLines?: WarehouseOutboundOrderLine[] | undefined;
    warehouseOutboundOrders?: WarehouseOutboundOrder[] | undefined;

    constructor(data?: IWarehouseOutboundOrderStatus) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.num = _data["num"];
            this.name = _data["name"];
            this.isClosed = _data["isClosed"];
            this.sorting = _data["sorting"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : undefined as any;
            this.createdBy = _data["createdBy"];
            this.modified = _data["modified"] ? new Date(_data["modified"].toString()) : undefined as any;
            this.modifiedBy = _data["modifiedBy"];
            if (Array.isArray(_data["warehouseOutboundOrderLines"])) {
                this.warehouseOutboundOrderLines = [] as any;
                for (let item of _data["warehouseOutboundOrderLines"])
                    this.warehouseOutboundOrderLines!.push(WarehouseOutboundOrderLine.fromJS(item));
            }
            if (Array.isArray(_data["warehouseOutboundOrders"])) {
                this.warehouseOutboundOrders = [] as any;
                for (let item of _data["warehouseOutboundOrders"])
                    this.warehouseOutboundOrders!.push(WarehouseOutboundOrder.fromJS(item));
            }
        }
    }

    static fromJS(data: any): WarehouseOutboundOrderStatus {
        data = typeof data === 'object' ? data : {};
        let result = new WarehouseOutboundOrderStatus();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["num"] = this.num;
        data["name"] = this.name;
        data["isClosed"] = this.isClosed;
        data["sorting"] = this.sorting;
        data["created"] = this.created ? this.created.toISOString() : undefined as any;
        data["createdBy"] = this.createdBy;
        data["modified"] = this.modified ? this.modified.toISOString() : undefined as any;
        data["modifiedBy"] = this.modifiedBy;
        if (Array.isArray(this.warehouseOutboundOrderLines)) {
            data["warehouseOutboundOrderLines"] = [];
            for (let item of this.warehouseOutboundOrderLines)
                data["warehouseOutboundOrderLines"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.warehouseOutboundOrders)) {
            data["warehouseOutboundOrders"] = [];
            for (let item of this.warehouseOutboundOrders)
                data["warehouseOutboundOrders"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IWarehouseOutboundOrderStatus {
    id?: number;
    num: string;
    name: string;
    isClosed?: boolean;
    sorting?: number;
    created?: Date | undefined;
    createdBy?: number | undefined;
    modified?: Date | undefined;
    modifiedBy?: number | undefined;
    warehouseOutboundOrderLines?: WarehouseOutboundOrderLine[] | undefined;
    warehouseOutboundOrders?: WarehouseOutboundOrder[] | undefined;
}

export class WarehouseOutboundOrderLine implements IWarehouseOutboundOrderLine {
    id?: number;
    order?: number;
    status?: number;
    product?: string | undefined;
    name!: string;
    line?: number;
    salesOrderLine?: number | undefined;
    orderedQty?: number;
    orderedInventQty?: number;
    reservedQty?: number;
    unreservedQty?: number;
    deliveredQty?: number;
    deliveredRemainQty?: number;
    shipDate?: Date | undefined;
    trackTrace?: string | undefined;
    created?: Date | undefined;
    createdBy?: number | undefined;
    createdJobId?: number | undefined;
    modified?: Date | undefined;
    modifiedBy?: number | undefined;
    modifiedJobId?: number | undefined;
    orderNavigation?: WarehouseOutboundOrder | undefined;
    salesOrderLineNavigation?: SalesOrderLine | undefined;
    statusNavigation?: WarehouseOutboundOrderStatus | undefined;
    salesOrderTrans?: SalesOrderTrans[] | undefined;

    constructor(data?: IWarehouseOutboundOrderLine) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.order = _data["order"];
            this.status = _data["status"];
            this.product = _data["product"];
            this.name = _data["name"];
            this.line = _data["line"];
            this.salesOrderLine = _data["salesOrderLine"];
            this.orderedQty = _data["orderedQty"];
            this.orderedInventQty = _data["orderedInventQty"];
            this.reservedQty = _data["reservedQty"];
            this.unreservedQty = _data["unreservedQty"];
            this.deliveredQty = _data["deliveredQty"];
            this.deliveredRemainQty = _data["deliveredRemainQty"];
            this.shipDate = _data["shipDate"] ? new Date(_data["shipDate"].toString()) : undefined as any;
            this.trackTrace = _data["trackTrace"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : undefined as any;
            this.createdBy = _data["createdBy"];
            this.createdJobId = _data["createdJobId"];
            this.modified = _data["modified"] ? new Date(_data["modified"].toString()) : undefined as any;
            this.modifiedBy = _data["modifiedBy"];
            this.modifiedJobId = _data["modifiedJobId"];
            this.orderNavigation = _data["orderNavigation"] ? WarehouseOutboundOrder.fromJS(_data["orderNavigation"]) : undefined as any;
            this.salesOrderLineNavigation = _data["salesOrderLineNavigation"] ? SalesOrderLine.fromJS(_data["salesOrderLineNavigation"]) : undefined as any;
            this.statusNavigation = _data["statusNavigation"] ? WarehouseOutboundOrderStatus.fromJS(_data["statusNavigation"]) : undefined as any;
            if (Array.isArray(_data["salesOrderTrans"])) {
                this.salesOrderTrans = [] as any;
                for (let item of _data["salesOrderTrans"])
                    this.salesOrderTrans!.push(SalesOrderTrans.fromJS(item));
            }
        }
    }

    static fromJS(data: any): WarehouseOutboundOrderLine {
        data = typeof data === 'object' ? data : {};
        let result = new WarehouseOutboundOrderLine();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["order"] = this.order;
        data["status"] = this.status;
        data["product"] = this.product;
        data["name"] = this.name;
        data["line"] = this.line;
        data["salesOrderLine"] = this.salesOrderLine;
        data["orderedQty"] = this.orderedQty;
        data["orderedInventQty"] = this.orderedInventQty;
        data["reservedQty"] = this.reservedQty;
        data["unreservedQty"] = this.unreservedQty;
        data["deliveredQty"] = this.deliveredQty;
        data["deliveredRemainQty"] = this.deliveredRemainQty;
        data["shipDate"] = this.shipDate ? this.shipDate.toISOString() : undefined as any;
        data["trackTrace"] = this.trackTrace;
        data["created"] = this.created ? this.created.toISOString() : undefined as any;
        data["createdBy"] = this.createdBy;
        data["createdJobId"] = this.createdJobId;
        data["modified"] = this.modified ? this.modified.toISOString() : undefined as any;
        data["modifiedBy"] = this.modifiedBy;
        data["modifiedJobId"] = this.modifiedJobId;
        data["orderNavigation"] = this.orderNavigation ? this.orderNavigation.toJSON() : undefined as any;
        data["salesOrderLineNavigation"] = this.salesOrderLineNavigation ? this.salesOrderLineNavigation.toJSON() : undefined as any;
        data["statusNavigation"] = this.statusNavigation ? this.statusNavigation.toJSON() : undefined as any;
        if (Array.isArray(this.salesOrderTrans)) {
            data["salesOrderTrans"] = [];
            for (let item of this.salesOrderTrans)
                data["salesOrderTrans"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IWarehouseOutboundOrderLine {
    id?: number;
    order?: number;
    status?: number;
    product?: string | undefined;
    name: string;
    line?: number;
    salesOrderLine?: number | undefined;
    orderedQty?: number;
    orderedInventQty?: number;
    reservedQty?: number;
    unreservedQty?: number;
    deliveredQty?: number;
    deliveredRemainQty?: number;
    shipDate?: Date | undefined;
    trackTrace?: string | undefined;
    created?: Date | undefined;
    createdBy?: number | undefined;
    createdJobId?: number | undefined;
    modified?: Date | undefined;
    modifiedBy?: number | undefined;
    modifiedJobId?: number | undefined;
    orderNavigation?: WarehouseOutboundOrder | undefined;
    salesOrderLineNavigation?: SalesOrderLine | undefined;
    statusNavigation?: WarehouseOutboundOrderStatus | undefined;
    salesOrderTrans?: SalesOrderTrans[] | undefined;
}

export class SalesOrderLine implements ISalesOrderLine {
    id?: number;
    order!: string;
    status?: number;
    type?: number;
    product?: string | undefined;
    category?: string | undefined;
    name!: string;
    line?: number;
    channelLine?: number | undefined;
    salesQty?: number;
    salesInventQty?: number;
    reservedQty?: number;
    unreservedQty?: number;
    deliveredQty?: number;
    deliveredRemainQty?: number;
    invoicedQty?: number;
    invoicedRemainQty?: number;
    salesPrice?: number;
    amountCurDiscount?: number;
    amountCurExTax?: number;
    amountCurTax?: number;
    amountCur?: number;
    shipDate?: Date | undefined;
    invoiceDate?: Date | undefined;
    created?: Date | undefined;
    createdBy?: number | undefined;
    createdJobId?: number | undefined;
    modified?: Date | undefined;
    modifiedBy?: number | undefined;
    modifiedJobId?: number | undefined;
    orderNavigation?: SalesOrder | undefined;
    statusNavigation?: SalesOrderStatus | undefined;
    typeNavigation?: SalesOrderLineType | undefined;
    warehouseOutboundOrderLines?: WarehouseOutboundOrderLine[] | undefined;

    constructor(data?: ISalesOrderLine) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.order = _data["order"];
            this.status = _data["status"];
            this.type = _data["type"];
            this.product = _data["product"];
            this.category = _data["category"];
            this.name = _data["name"];
            this.line = _data["line"];
            this.channelLine = _data["channelLine"];
            this.salesQty = _data["salesQty"];
            this.salesInventQty = _data["salesInventQty"];
            this.reservedQty = _data["reservedQty"];
            this.unreservedQty = _data["unreservedQty"];
            this.deliveredQty = _data["deliveredQty"];
            this.deliveredRemainQty = _data["deliveredRemainQty"];
            this.invoicedQty = _data["invoicedQty"];
            this.invoicedRemainQty = _data["invoicedRemainQty"];
            this.salesPrice = _data["salesPrice"];
            this.amountCurDiscount = _data["amountCurDiscount"];
            this.amountCurExTax = _data["amountCurExTax"];
            this.amountCurTax = _data["amountCurTax"];
            this.amountCur = _data["amountCur"];
            this.shipDate = _data["shipDate"] ? new Date(_data["shipDate"].toString()) : undefined as any;
            this.invoiceDate = _data["invoiceDate"] ? new Date(_data["invoiceDate"].toString()) : undefined as any;
            this.created = _data["created"] ? new Date(_data["created"].toString()) : undefined as any;
            this.createdBy = _data["createdBy"];
            this.createdJobId = _data["createdJobId"];
            this.modified = _data["modified"] ? new Date(_data["modified"].toString()) : undefined as any;
            this.modifiedBy = _data["modifiedBy"];
            this.modifiedJobId = _data["modifiedJobId"];
            this.orderNavigation = _data["orderNavigation"] ? SalesOrder.fromJS(_data["orderNavigation"]) : undefined as any;
            this.statusNavigation = _data["statusNavigation"] ? SalesOrderStatus.fromJS(_data["statusNavigation"]) : undefined as any;
            this.typeNavigation = _data["typeNavigation"] ? SalesOrderLineType.fromJS(_data["typeNavigation"]) : undefined as any;
            if (Array.isArray(_data["warehouseOutboundOrderLines"])) {
                this.warehouseOutboundOrderLines = [] as any;
                for (let item of _data["warehouseOutboundOrderLines"])
                    this.warehouseOutboundOrderLines!.push(WarehouseOutboundOrderLine.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SalesOrderLine {
        data = typeof data === 'object' ? data : {};
        let result = new SalesOrderLine();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["order"] = this.order;
        data["status"] = this.status;
        data["type"] = this.type;
        data["product"] = this.product;
        data["category"] = this.category;
        data["name"] = this.name;
        data["line"] = this.line;
        data["channelLine"] = this.channelLine;
        data["salesQty"] = this.salesQty;
        data["salesInventQty"] = this.salesInventQty;
        data["reservedQty"] = this.reservedQty;
        data["unreservedQty"] = this.unreservedQty;
        data["deliveredQty"] = this.deliveredQty;
        data["deliveredRemainQty"] = this.deliveredRemainQty;
        data["invoicedQty"] = this.invoicedQty;
        data["invoicedRemainQty"] = this.invoicedRemainQty;
        data["salesPrice"] = this.salesPrice;
        data["amountCurDiscount"] = this.amountCurDiscount;
        data["amountCurExTax"] = this.amountCurExTax;
        data["amountCurTax"] = this.amountCurTax;
        data["amountCur"] = this.amountCur;
        data["shipDate"] = this.shipDate ? this.shipDate.toISOString() : undefined as any;
        data["invoiceDate"] = this.invoiceDate ? this.invoiceDate.toISOString() : undefined as any;
        data["created"] = this.created ? this.created.toISOString() : undefined as any;
        data["createdBy"] = this.createdBy;
        data["createdJobId"] = this.createdJobId;
        data["modified"] = this.modified ? this.modified.toISOString() : undefined as any;
        data["modifiedBy"] = this.modifiedBy;
        data["modifiedJobId"] = this.modifiedJobId;
        data["orderNavigation"] = this.orderNavigation ? this.orderNavigation.toJSON() : undefined as any;
        data["statusNavigation"] = this.statusNavigation ? this.statusNavigation.toJSON() : undefined as any;
        data["typeNavigation"] = this.typeNavigation ? this.typeNavigation.toJSON() : undefined as any;
        if (Array.isArray(this.warehouseOutboundOrderLines)) {
            data["warehouseOutboundOrderLines"] = [];
            for (let item of this.warehouseOutboundOrderLines)
                data["warehouseOutboundOrderLines"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ISalesOrderLine {
    id?: number;
    order: string;
    status?: number;
    type?: number;
    product?: string | undefined;
    category?: string | undefined;
    name: string;
    line?: number;
    channelLine?: number | undefined;
    salesQty?: number;
    salesInventQty?: number;
    reservedQty?: number;
    unreservedQty?: number;
    deliveredQty?: number;
    deliveredRemainQty?: number;
    invoicedQty?: number;
    invoicedRemainQty?: number;
    salesPrice?: number;
    amountCurDiscount?: number;
    amountCurExTax?: number;
    amountCurTax?: number;
    amountCur?: number;
    shipDate?: Date | undefined;
    invoiceDate?: Date | undefined;
    created?: Date | undefined;
    createdBy?: number | undefined;
    createdJobId?: number | undefined;
    modified?: Date | undefined;
    modifiedBy?: number | undefined;
    modifiedJobId?: number | undefined;
    orderNavigation?: SalesOrder | undefined;
    statusNavigation?: SalesOrderStatus | undefined;
    typeNavigation?: SalesOrderLineType | undefined;
    warehouseOutboundOrderLines?: WarehouseOutboundOrderLine[] | undefined;
}

export class SalesOrderStatus implements ISalesOrderStatus {
    id?: number;
    num!: string;
    name!: string;
    isClosed?: boolean;
    sorting?: number;
    created?: Date | undefined;
    createdBy?: number | undefined;
    modified?: Date | undefined;
    modifiedBy?: number | undefined;
    salesOrderLines?: SalesOrderLine[] | undefined;
    salesOrders?: SalesOrder[] | undefined;
    salesOrderTrans?: SalesOrderTrans[] | undefined;

    constructor(data?: ISalesOrderStatus) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.num = _data["num"];
            this.name = _data["name"];
            this.isClosed = _data["isClosed"];
            this.sorting = _data["sorting"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : undefined as any;
            this.createdBy = _data["createdBy"];
            this.modified = _data["modified"] ? new Date(_data["modified"].toString()) : undefined as any;
            this.modifiedBy = _data["modifiedBy"];
            if (Array.isArray(_data["salesOrderLines"])) {
                this.salesOrderLines = [] as any;
                for (let item of _data["salesOrderLines"])
                    this.salesOrderLines!.push(SalesOrderLine.fromJS(item));
            }
            if (Array.isArray(_data["salesOrders"])) {
                this.salesOrders = [] as any;
                for (let item of _data["salesOrders"])
                    this.salesOrders!.push(SalesOrder.fromJS(item));
            }
            if (Array.isArray(_data["salesOrderTrans"])) {
                this.salesOrderTrans = [] as any;
                for (let item of _data["salesOrderTrans"])
                    this.salesOrderTrans!.push(SalesOrderTrans.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SalesOrderStatus {
        data = typeof data === 'object' ? data : {};
        let result = new SalesOrderStatus();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["num"] = this.num;
        data["name"] = this.name;
        data["isClosed"] = this.isClosed;
        data["sorting"] = this.sorting;
        data["created"] = this.created ? this.created.toISOString() : undefined as any;
        data["createdBy"] = this.createdBy;
        data["modified"] = this.modified ? this.modified.toISOString() : undefined as any;
        data["modifiedBy"] = this.modifiedBy;
        if (Array.isArray(this.salesOrderLines)) {
            data["salesOrderLines"] = [];
            for (let item of this.salesOrderLines)
                data["salesOrderLines"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.salesOrders)) {
            data["salesOrders"] = [];
            for (let item of this.salesOrders)
                data["salesOrders"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.salesOrderTrans)) {
            data["salesOrderTrans"] = [];
            for (let item of this.salesOrderTrans)
                data["salesOrderTrans"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ISalesOrderStatus {
    id?: number;
    num: string;
    name: string;
    isClosed?: boolean;
    sorting?: number;
    created?: Date | undefined;
    createdBy?: number | undefined;
    modified?: Date | undefined;
    modifiedBy?: number | undefined;
    salesOrderLines?: SalesOrderLine[] | undefined;
    salesOrders?: SalesOrder[] | undefined;
    salesOrderTrans?: SalesOrderTrans[] | undefined;
}

export class SalesOrderTrans implements ISalesOrderTrans {
    id?: number;
    order?: string | undefined;
    line?: number | undefined;
    warehouseOutboundOrder?: number | undefined;
    warehouseOutboundOrderLine?: number | undefined;
    documentNum?: string | undefined;
    transType?: number;
    transDate?: Date;
    processed?: boolean | undefined;
    paymentReference?: string | undefined;
    category?: string | undefined;
    product?: string | undefined;
    salesQty?: number | undefined;
    inventQty?: number | undefined;
    salesPrice?: number | undefined;
    amountCurDisc?: number | undefined;
    amountCurExTax?: number | undefined;
    amountCurTax?: number | undefined;
    amountCur?: number | undefined;
    currency?: string | undefined;
    created?: Date | undefined;
    createdBy?: number | undefined;
    createdJobId?: number | undefined;
    modified?: Date | undefined;
    modifiedBy?: number | undefined;
    modifiedJobId?: number | undefined;
    lineNavigation?: SalesOrder | undefined;
    orderNavigation?: SalesOrder | undefined;
    transTypeNavigation?: SalesOrderStatus | undefined;
    warehouseOutboundOrderLineNavigation?: WarehouseOutboundOrderLine | undefined;
    warehouseOutboundOrderNavigation?: WarehouseOutboundOrder | undefined;

    constructor(data?: ISalesOrderTrans) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.order = _data["order"];
            this.line = _data["line"];
            this.warehouseOutboundOrder = _data["warehouseOutboundOrder"];
            this.warehouseOutboundOrderLine = _data["warehouseOutboundOrderLine"];
            this.documentNum = _data["documentNum"];
            this.transType = _data["transType"];
            this.transDate = _data["transDate"] ? new Date(_data["transDate"].toString()) : undefined as any;
            this.processed = _data["processed"];
            this.paymentReference = _data["paymentReference"];
            this.category = _data["category"];
            this.product = _data["product"];
            this.salesQty = _data["salesQty"];
            this.inventQty = _data["inventQty"];
            this.salesPrice = _data["salesPrice"];
            this.amountCurDisc = _data["amountCurDisc"];
            this.amountCurExTax = _data["amountCurExTax"];
            this.amountCurTax = _data["amountCurTax"];
            this.amountCur = _data["amountCur"];
            this.currency = _data["currency"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : undefined as any;
            this.createdBy = _data["createdBy"];
            this.createdJobId = _data["createdJobId"];
            this.modified = _data["modified"] ? new Date(_data["modified"].toString()) : undefined as any;
            this.modifiedBy = _data["modifiedBy"];
            this.modifiedJobId = _data["modifiedJobId"];
            this.lineNavigation = _data["lineNavigation"] ? SalesOrder.fromJS(_data["lineNavigation"]) : undefined as any;
            this.orderNavigation = _data["orderNavigation"] ? SalesOrder.fromJS(_data["orderNavigation"]) : undefined as any;
            this.transTypeNavigation = _data["transTypeNavigation"] ? SalesOrderStatus.fromJS(_data["transTypeNavigation"]) : undefined as any;
            this.warehouseOutboundOrderLineNavigation = _data["warehouseOutboundOrderLineNavigation"] ? WarehouseOutboundOrderLine.fromJS(_data["warehouseOutboundOrderLineNavigation"]) : undefined as any;
            this.warehouseOutboundOrderNavigation = _data["warehouseOutboundOrderNavigation"] ? WarehouseOutboundOrder.fromJS(_data["warehouseOutboundOrderNavigation"]) : undefined as any;
        }
    }

    static fromJS(data: any): SalesOrderTrans {
        data = typeof data === 'object' ? data : {};
        let result = new SalesOrderTrans();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["order"] = this.order;
        data["line"] = this.line;
        data["warehouseOutboundOrder"] = this.warehouseOutboundOrder;
        data["warehouseOutboundOrderLine"] = this.warehouseOutboundOrderLine;
        data["documentNum"] = this.documentNum;
        data["transType"] = this.transType;
        data["transDate"] = this.transDate ? this.transDate.toISOString() : undefined as any;
        data["processed"] = this.processed;
        data["paymentReference"] = this.paymentReference;
        data["category"] = this.category;
        data["product"] = this.product;
        data["salesQty"] = this.salesQty;
        data["inventQty"] = this.inventQty;
        data["salesPrice"] = this.salesPrice;
        data["amountCurDisc"] = this.amountCurDisc;
        data["amountCurExTax"] = this.amountCurExTax;
        data["amountCurTax"] = this.amountCurTax;
        data["amountCur"] = this.amountCur;
        data["currency"] = this.currency;
        data["created"] = this.created ? this.created.toISOString() : undefined as any;
        data["createdBy"] = this.createdBy;
        data["createdJobId"] = this.createdJobId;
        data["modified"] = this.modified ? this.modified.toISOString() : undefined as any;
        data["modifiedBy"] = this.modifiedBy;
        data["modifiedJobId"] = this.modifiedJobId;
        data["lineNavigation"] = this.lineNavigation ? this.lineNavigation.toJSON() : undefined as any;
        data["orderNavigation"] = this.orderNavigation ? this.orderNavigation.toJSON() : undefined as any;
        data["transTypeNavigation"] = this.transTypeNavigation ? this.transTypeNavigation.toJSON() : undefined as any;
        data["warehouseOutboundOrderLineNavigation"] = this.warehouseOutboundOrderLineNavigation ? this.warehouseOutboundOrderLineNavigation.toJSON() : undefined as any;
        data["warehouseOutboundOrderNavigation"] = this.warehouseOutboundOrderNavigation ? this.warehouseOutboundOrderNavigation.toJSON() : undefined as any;
        return data;
    }
}

export interface ISalesOrderTrans {
    id?: number;
    order?: string | undefined;
    line?: number | undefined;
    warehouseOutboundOrder?: number | undefined;
    warehouseOutboundOrderLine?: number | undefined;
    documentNum?: string | undefined;
    transType?: number;
    transDate?: Date;
    processed?: boolean | undefined;
    paymentReference?: string | undefined;
    category?: string | undefined;
    product?: string | undefined;
    salesQty?: number | undefined;
    inventQty?: number | undefined;
    salesPrice?: number | undefined;
    amountCurDisc?: number | undefined;
    amountCurExTax?: number | undefined;
    amountCurTax?: number | undefined;
    amountCur?: number | undefined;
    currency?: string | undefined;
    created?: Date | undefined;
    createdBy?: number | undefined;
    createdJobId?: number | undefined;
    modified?: Date | undefined;
    modifiedBy?: number | undefined;
    modifiedJobId?: number | undefined;
    lineNavigation?: SalesOrder | undefined;
    orderNavigation?: SalesOrder | undefined;
    transTypeNavigation?: SalesOrderStatus | undefined;
    warehouseOutboundOrderLineNavigation?: WarehouseOutboundOrderLine | undefined;
    warehouseOutboundOrderNavigation?: WarehouseOutboundOrder | undefined;
}

export class SalesOrderLineType implements ISalesOrderLineType {
    id?: number;
    num?: string | undefined;
    name!: string;
    logisticsOutboundActive?: boolean;
    logisticsInboundActive?: boolean;
    isBundle?: boolean;
    created?: Date | undefined;
    createdBy?: number | undefined;
    modified?: Date | undefined;
    modifiedBy?: number | undefined;
    custInvoiceLines?: CustInvoiceLine[] | undefined;
    salesOrderLines?: SalesOrderLine[] | undefined;

    constructor(data?: ISalesOrderLineType) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.num = _data["num"];
            this.name = _data["name"];
            this.logisticsOutboundActive = _data["logisticsOutboundActive"];
            this.logisticsInboundActive = _data["logisticsInboundActive"];
            this.isBundle = _data["isBundle"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : undefined as any;
            this.createdBy = _data["createdBy"];
            this.modified = _data["modified"] ? new Date(_data["modified"].toString()) : undefined as any;
            this.modifiedBy = _data["modifiedBy"];
            if (Array.isArray(_data["custInvoiceLines"])) {
                this.custInvoiceLines = [] as any;
                for (let item of _data["custInvoiceLines"])
                    this.custInvoiceLines!.push(CustInvoiceLine.fromJS(item));
            }
            if (Array.isArray(_data["salesOrderLines"])) {
                this.salesOrderLines = [] as any;
                for (let item of _data["salesOrderLines"])
                    this.salesOrderLines!.push(SalesOrderLine.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SalesOrderLineType {
        data = typeof data === 'object' ? data : {};
        let result = new SalesOrderLineType();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["num"] = this.num;
        data["name"] = this.name;
        data["logisticsOutboundActive"] = this.logisticsOutboundActive;
        data["logisticsInboundActive"] = this.logisticsInboundActive;
        data["isBundle"] = this.isBundle;
        data["created"] = this.created ? this.created.toISOString() : undefined as any;
        data["createdBy"] = this.createdBy;
        data["modified"] = this.modified ? this.modified.toISOString() : undefined as any;
        data["modifiedBy"] = this.modifiedBy;
        if (Array.isArray(this.custInvoiceLines)) {
            data["custInvoiceLines"] = [];
            for (let item of this.custInvoiceLines)
                data["custInvoiceLines"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.salesOrderLines)) {
            data["salesOrderLines"] = [];
            for (let item of this.salesOrderLines)
                data["salesOrderLines"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ISalesOrderLineType {
    id?: number;
    num?: string | undefined;
    name: string;
    logisticsOutboundActive?: boolean;
    logisticsInboundActive?: boolean;
    isBundle?: boolean;
    created?: Date | undefined;
    createdBy?: number | undefined;
    modified?: Date | undefined;
    modifiedBy?: number | undefined;
    custInvoiceLines?: CustInvoiceLine[] | undefined;
    salesOrderLines?: SalesOrderLine[] | undefined;
}

export class CustInvoiceLine implements ICustInvoiceLine {
    id?: number;
    invoice!: string;
    line?: number;
    type?: number;
    product?: string | undefined;
    category?: string | undefined;
    name?: string | undefined;
    salesOrderLine?: number | undefined;
    qty?: number;
    price?: number;
    amountCurDiscount?: number;
    amountCurExTax?: number;
    amountCurTax?: number;
    amountCur?: number;
    created?: Date | undefined;
    createdBy?: number | undefined;
    modified?: Date | undefined;
    modifiedBy?: number | undefined;
    invoiceNavigation?: CustInvoice | undefined;
    typeNavigation?: SalesOrderLineType | undefined;

    constructor(data?: ICustInvoiceLine) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.invoice = _data["invoice"];
            this.line = _data["line"];
            this.type = _data["type"];
            this.product = _data["product"];
            this.category = _data["category"];
            this.name = _data["name"];
            this.salesOrderLine = _data["salesOrderLine"];
            this.qty = _data["qty"];
            this.price = _data["price"];
            this.amountCurDiscount = _data["amountCurDiscount"];
            this.amountCurExTax = _data["amountCurExTax"];
            this.amountCurTax = _data["amountCurTax"];
            this.amountCur = _data["amountCur"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : undefined as any;
            this.createdBy = _data["createdBy"];
            this.modified = _data["modified"] ? new Date(_data["modified"].toString()) : undefined as any;
            this.modifiedBy = _data["modifiedBy"];
            this.invoiceNavigation = _data["invoiceNavigation"] ? CustInvoice.fromJS(_data["invoiceNavigation"]) : undefined as any;
            this.typeNavigation = _data["typeNavigation"] ? SalesOrderLineType.fromJS(_data["typeNavigation"]) : undefined as any;
        }
    }

    static fromJS(data: any): CustInvoiceLine {
        data = typeof data === 'object' ? data : {};
        let result = new CustInvoiceLine();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["invoice"] = this.invoice;
        data["line"] = this.line;
        data["type"] = this.type;
        data["product"] = this.product;
        data["category"] = this.category;
        data["name"] = this.name;
        data["salesOrderLine"] = this.salesOrderLine;
        data["qty"] = this.qty;
        data["price"] = this.price;
        data["amountCurDiscount"] = this.amountCurDiscount;
        data["amountCurExTax"] = this.amountCurExTax;
        data["amountCurTax"] = this.amountCurTax;
        data["amountCur"] = this.amountCur;
        data["created"] = this.created ? this.created.toISOString() : undefined as any;
        data["createdBy"] = this.createdBy;
        data["modified"] = this.modified ? this.modified.toISOString() : undefined as any;
        data["modifiedBy"] = this.modifiedBy;
        data["invoiceNavigation"] = this.invoiceNavigation ? this.invoiceNavigation.toJSON() : undefined as any;
        data["typeNavigation"] = this.typeNavigation ? this.typeNavigation.toJSON() : undefined as any;
        return data;
    }
}

export interface ICustInvoiceLine {
    id?: number;
    invoice: string;
    line?: number;
    type?: number;
    product?: string | undefined;
    category?: string | undefined;
    name?: string | undefined;
    salesOrderLine?: number | undefined;
    qty?: number;
    price?: number;
    amountCurDiscount?: number;
    amountCurExTax?: number;
    amountCurTax?: number;
    amountCur?: number;
    created?: Date | undefined;
    createdBy?: number | undefined;
    modified?: Date | undefined;
    modifiedBy?: number | undefined;
    invoiceNavigation?: CustInvoice | undefined;
    typeNavigation?: SalesOrderLineType | undefined;
}

export class CustInvoice implements ICustInvoice {
    id?: number;
    num?: string | undefined;
    invoiceDate?: Date;
    invoiceNum?: string | undefined;
    settleDate?: Date;
    formRecognizerDocument?: number | undefined;
    voucherMessage?: number | undefined;
    voucher?: number | undefined;
    voucherNum?: string | undefined;
    name?: string | undefined;
    status?: number;
    custNum?: string | undefined;
    custEAN?: string | undefined;
    custVATNum?: string | undefined;
    custEmail?: string | undefined;
    custPhone?: string | undefined;
    note?: string | undefined;
    paymentType?: string | undefined;
    paymentReference?: string | undefined;
    paymentFeeMst?: number;
    salesOrder?: string | undefined;
    salesChannel?: string | undefined;
    currency!: string;
    amountCurExTax?: number;
    amountCurTax?: number | undefined;
    amountCurService?: number | undefined;
    amountCur?: number;
    companyName?: string | undefined;
    address1?: string | undefined;
    address2?: string | undefined;
    postalCode?: string | undefined;
    postalDistrict?: string | undefined;
    countryCode?: string | undefined;
    created?: Date | undefined;
    createdBy?: number | undefined;
    createdJobId?: number | undefined;
    modified?: Date | undefined;
    modifiedBy?: number | undefined;
    modifiedJobId?: number | undefined;
    paymentTypeNavigation?: SalesPaymentType | undefined;
    salesChannelNavigation?: SalesChannel | undefined;
    salesOrderNavigation?: SalesOrder | undefined;
    custInvoiceLines?: CustInvoiceLine[] | undefined;

    constructor(data?: ICustInvoice) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.num = _data["num"];
            this.invoiceDate = _data["invoiceDate"] ? new Date(_data["invoiceDate"].toString()) : undefined as any;
            this.invoiceNum = _data["invoiceNum"];
            this.settleDate = _data["settleDate"] ? new Date(_data["settleDate"].toString()) : undefined as any;
            this.formRecognizerDocument = _data["formRecognizerDocument"];
            this.voucherMessage = _data["voucherMessage"];
            this.voucher = _data["voucher"];
            this.voucherNum = _data["voucherNum"];
            this.name = _data["name"];
            this.status = _data["status"];
            this.custNum = _data["custNum"];
            this.custEAN = _data["custEAN"];
            this.custVATNum = _data["custVATNum"];
            this.custEmail = _data["custEmail"];
            this.custPhone = _data["custPhone"];
            this.note = _data["note"];
            this.paymentType = _data["paymentType"];
            this.paymentReference = _data["paymentReference"];
            this.paymentFeeMst = _data["paymentFeeMst"];
            this.salesOrder = _data["salesOrder"];
            this.salesChannel = _data["salesChannel"];
            this.currency = _data["currency"];
            this.amountCurExTax = _data["amountCurExTax"];
            this.amountCurTax = _data["amountCurTax"];
            this.amountCurService = _data["amountCurService"];
            this.amountCur = _data["amountCur"];
            this.companyName = _data["companyName"];
            this.address1 = _data["address1"];
            this.address2 = _data["address2"];
            this.postalCode = _data["postalCode"];
            this.postalDistrict = _data["postalDistrict"];
            this.countryCode = _data["countryCode"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : undefined as any;
            this.createdBy = _data["createdBy"];
            this.createdJobId = _data["createdJobId"];
            this.modified = _data["modified"] ? new Date(_data["modified"].toString()) : undefined as any;
            this.modifiedBy = _data["modifiedBy"];
            this.modifiedJobId = _data["modifiedJobId"];
            this.paymentTypeNavigation = _data["paymentTypeNavigation"] ? SalesPaymentType.fromJS(_data["paymentTypeNavigation"]) : undefined as any;
            this.salesChannelNavigation = _data["salesChannelNavigation"] ? SalesChannel.fromJS(_data["salesChannelNavigation"]) : undefined as any;
            this.salesOrderNavigation = _data["salesOrderNavigation"] ? SalesOrder.fromJS(_data["salesOrderNavigation"]) : undefined as any;
            if (Array.isArray(_data["custInvoiceLines"])) {
                this.custInvoiceLines = [] as any;
                for (let item of _data["custInvoiceLines"])
                    this.custInvoiceLines!.push(CustInvoiceLine.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CustInvoice {
        data = typeof data === 'object' ? data : {};
        let result = new CustInvoice();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["num"] = this.num;
        data["invoiceDate"] = this.invoiceDate ? this.invoiceDate.toISOString() : undefined as any;
        data["invoiceNum"] = this.invoiceNum;
        data["settleDate"] = this.settleDate ? this.settleDate.toISOString() : undefined as any;
        data["formRecognizerDocument"] = this.formRecognizerDocument;
        data["voucherMessage"] = this.voucherMessage;
        data["voucher"] = this.voucher;
        data["voucherNum"] = this.voucherNum;
        data["name"] = this.name;
        data["status"] = this.status;
        data["custNum"] = this.custNum;
        data["custEAN"] = this.custEAN;
        data["custVATNum"] = this.custVATNum;
        data["custEmail"] = this.custEmail;
        data["custPhone"] = this.custPhone;
        data["note"] = this.note;
        data["paymentType"] = this.paymentType;
        data["paymentReference"] = this.paymentReference;
        data["paymentFeeMst"] = this.paymentFeeMst;
        data["salesOrder"] = this.salesOrder;
        data["salesChannel"] = this.salesChannel;
        data["currency"] = this.currency;
        data["amountCurExTax"] = this.amountCurExTax;
        data["amountCurTax"] = this.amountCurTax;
        data["amountCurService"] = this.amountCurService;
        data["amountCur"] = this.amountCur;
        data["companyName"] = this.companyName;
        data["address1"] = this.address1;
        data["address2"] = this.address2;
        data["postalCode"] = this.postalCode;
        data["postalDistrict"] = this.postalDistrict;
        data["countryCode"] = this.countryCode;
        data["created"] = this.created ? this.created.toISOString() : undefined as any;
        data["createdBy"] = this.createdBy;
        data["createdJobId"] = this.createdJobId;
        data["modified"] = this.modified ? this.modified.toISOString() : undefined as any;
        data["modifiedBy"] = this.modifiedBy;
        data["modifiedJobId"] = this.modifiedJobId;
        data["paymentTypeNavigation"] = this.paymentTypeNavigation ? this.paymentTypeNavigation.toJSON() : undefined as any;
        data["salesChannelNavigation"] = this.salesChannelNavigation ? this.salesChannelNavigation.toJSON() : undefined as any;
        data["salesOrderNavigation"] = this.salesOrderNavigation ? this.salesOrderNavigation.toJSON() : undefined as any;
        if (Array.isArray(this.custInvoiceLines)) {
            data["custInvoiceLines"] = [];
            for (let item of this.custInvoiceLines)
                data["custInvoiceLines"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ICustInvoice {
    id?: number;
    num?: string | undefined;
    invoiceDate?: Date;
    invoiceNum?: string | undefined;
    settleDate?: Date;
    formRecognizerDocument?: number | undefined;
    voucherMessage?: number | undefined;
    voucher?: number | undefined;
    voucherNum?: string | undefined;
    name?: string | undefined;
    status?: number;
    custNum?: string | undefined;
    custEAN?: string | undefined;
    custVATNum?: string | undefined;
    custEmail?: string | undefined;
    custPhone?: string | undefined;
    note?: string | undefined;
    paymentType?: string | undefined;
    paymentReference?: string | undefined;
    paymentFeeMst?: number;
    salesOrder?: string | undefined;
    salesChannel?: string | undefined;
    currency: string;
    amountCurExTax?: number;
    amountCurTax?: number | undefined;
    amountCurService?: number | undefined;
    amountCur?: number;
    companyName?: string | undefined;
    address1?: string | undefined;
    address2?: string | undefined;
    postalCode?: string | undefined;
    postalDistrict?: string | undefined;
    countryCode?: string | undefined;
    created?: Date | undefined;
    createdBy?: number | undefined;
    createdJobId?: number | undefined;
    modified?: Date | undefined;
    modifiedBy?: number | undefined;
    modifiedJobId?: number | undefined;
    paymentTypeNavigation?: SalesPaymentType | undefined;
    salesChannelNavigation?: SalesChannel | undefined;
    salesOrderNavigation?: SalesOrder | undefined;
    custInvoiceLines?: CustInvoiceLine[] | undefined;
}

export class SalesPaymentType implements ISalesPaymentType {
    id?: number;
    num?: string | undefined;
    name!: string;
    createInvoice?: boolean;
    paymentCapture?: boolean;
    created?: Date | undefined;
    createdBy?: number | undefined;
    modified?: Date | undefined;
    modifiedBy?: number | undefined;
    custInvoices?: CustInvoice[] | undefined;
    salesOrders?: SalesOrder[] | undefined;

    constructor(data?: ISalesPaymentType) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.num = _data["num"];
            this.name = _data["name"];
            this.createInvoice = _data["createInvoice"];
            this.paymentCapture = _data["paymentCapture"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : undefined as any;
            this.createdBy = _data["createdBy"];
            this.modified = _data["modified"] ? new Date(_data["modified"].toString()) : undefined as any;
            this.modifiedBy = _data["modifiedBy"];
            if (Array.isArray(_data["custInvoices"])) {
                this.custInvoices = [] as any;
                for (let item of _data["custInvoices"])
                    this.custInvoices!.push(CustInvoice.fromJS(item));
            }
            if (Array.isArray(_data["salesOrders"])) {
                this.salesOrders = [] as any;
                for (let item of _data["salesOrders"])
                    this.salesOrders!.push(SalesOrder.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SalesPaymentType {
        data = typeof data === 'object' ? data : {};
        let result = new SalesPaymentType();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["num"] = this.num;
        data["name"] = this.name;
        data["createInvoice"] = this.createInvoice;
        data["paymentCapture"] = this.paymentCapture;
        data["created"] = this.created ? this.created.toISOString() : undefined as any;
        data["createdBy"] = this.createdBy;
        data["modified"] = this.modified ? this.modified.toISOString() : undefined as any;
        data["modifiedBy"] = this.modifiedBy;
        if (Array.isArray(this.custInvoices)) {
            data["custInvoices"] = [];
            for (let item of this.custInvoices)
                data["custInvoices"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.salesOrders)) {
            data["salesOrders"] = [];
            for (let item of this.salesOrders)
                data["salesOrders"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ISalesPaymentType {
    id?: number;
    num?: string | undefined;
    name: string;
    createInvoice?: boolean;
    paymentCapture?: boolean;
    created?: Date | undefined;
    createdBy?: number | undefined;
    modified?: Date | undefined;
    modifiedBy?: number | undefined;
    custInvoices?: CustInvoice[] | undefined;
    salesOrders?: SalesOrder[] | undefined;
}

export class WarehouseOutboundOrderType implements IWarehouseOutboundOrderType {
    id?: number;
    num?: string | undefined;
    name!: string;
    warehouse!: string;
    orderNumNext?: number | undefined;
    email?: string | undefined;
    orderCreate?: boolean;
    orderCreateFromConfirmed?: boolean;
    orderCreateFromLineStatusCancelled?: boolean;
    orderAutoRelease?: boolean;
    orderAutoReleaseFromLineStatusCancelled?: boolean;
    requireCustomerKnown?: boolean;
    requirePublished?: boolean;
    requireBuyable?: boolean;
    requireOnHand?: boolean;
    bomConsolidate?: boolean;
    bomExpand?: boolean;
    bomConsolidateRequireOnHand?: boolean;
    bomLineExpandWhenBOMOnHand?: boolean;
    carrier?: string | undefined;
    dataPublishing_OrderRelease?: string | undefined;
    extCustNum?: string | undefined;
    extOrderType?: string | undefined;
    extOrderGroup?: string | undefined;
    extHandlingType?: string | undefined;
    extCarrierType?: string | undefined;
    extPriority?: string | undefined;
    extPrintDeliveyNote?: boolean;
    extPrintInvoice?: boolean;
    extPrintFooter?: string | undefined;
    created?: Date | undefined;
    createdBy?: number | undefined;
    modified?: Date | undefined;
    modifiedBy?: number | undefined;
    carrierNavigation?: WarehouseCarrier | undefined;
    warehouseNavigation?: Warehouse | undefined;
    salesChannels?: SalesChannel[] | undefined;
    salesOrders?: SalesOrder[] | undefined;
    warehouseOutboundOrders?: WarehouseOutboundOrder[] | undefined;
    warehouseOutboundOrderTypeProducts?: WarehouseOutboundOrderTypeProduct[] | undefined;

    constructor(data?: IWarehouseOutboundOrderType) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.num = _data["num"];
            this.name = _data["name"];
            this.warehouse = _data["warehouse"];
            this.orderNumNext = _data["orderNumNext"];
            this.email = _data["email"];
            this.orderCreate = _data["orderCreate"];
            this.orderCreateFromConfirmed = _data["orderCreateFromConfirmed"];
            this.orderCreateFromLineStatusCancelled = _data["orderCreateFromLineStatusCancelled"];
            this.orderAutoRelease = _data["orderAutoRelease"];
            this.orderAutoReleaseFromLineStatusCancelled = _data["orderAutoReleaseFromLineStatusCancelled"];
            this.requireCustomerKnown = _data["requireCustomerKnown"];
            this.requirePublished = _data["requirePublished"];
            this.requireBuyable = _data["requireBuyable"];
            this.requireOnHand = _data["requireOnHand"];
            this.bomConsolidate = _data["bomConsolidate"];
            this.bomExpand = _data["bomExpand"];
            this.bomConsolidateRequireOnHand = _data["bomConsolidateRequireOnHand"];
            this.bomLineExpandWhenBOMOnHand = _data["bomLineExpandWhenBOMOnHand"];
            this.carrier = _data["carrier"];
            this.dataPublishing_OrderRelease = _data["dataPublishing_OrderRelease"];
            this.extCustNum = _data["extCustNum"];
            this.extOrderType = _data["extOrderType"];
            this.extOrderGroup = _data["extOrderGroup"];
            this.extHandlingType = _data["extHandlingType"];
            this.extCarrierType = _data["extCarrierType"];
            this.extPriority = _data["extPriority"];
            this.extPrintDeliveyNote = _data["extPrintDeliveyNote"];
            this.extPrintInvoice = _data["extPrintInvoice"];
            this.extPrintFooter = _data["extPrintFooter"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : undefined as any;
            this.createdBy = _data["createdBy"];
            this.modified = _data["modified"] ? new Date(_data["modified"].toString()) : undefined as any;
            this.modifiedBy = _data["modifiedBy"];
            this.carrierNavigation = _data["carrierNavigation"] ? WarehouseCarrier.fromJS(_data["carrierNavigation"]) : undefined as any;
            this.warehouseNavigation = _data["warehouseNavigation"] ? Warehouse.fromJS(_data["warehouseNavigation"]) : undefined as any;
            if (Array.isArray(_data["salesChannels"])) {
                this.salesChannels = [] as any;
                for (let item of _data["salesChannels"])
                    this.salesChannels!.push(SalesChannel.fromJS(item));
            }
            if (Array.isArray(_data["salesOrders"])) {
                this.salesOrders = [] as any;
                for (let item of _data["salesOrders"])
                    this.salesOrders!.push(SalesOrder.fromJS(item));
            }
            if (Array.isArray(_data["warehouseOutboundOrders"])) {
                this.warehouseOutboundOrders = [] as any;
                for (let item of _data["warehouseOutboundOrders"])
                    this.warehouseOutboundOrders!.push(WarehouseOutboundOrder.fromJS(item));
            }
            if (Array.isArray(_data["warehouseOutboundOrderTypeProducts"])) {
                this.warehouseOutboundOrderTypeProducts = [] as any;
                for (let item of _data["warehouseOutboundOrderTypeProducts"])
                    this.warehouseOutboundOrderTypeProducts!.push(WarehouseOutboundOrderTypeProduct.fromJS(item));
            }
        }
    }

    static fromJS(data: any): WarehouseOutboundOrderType {
        data = typeof data === 'object' ? data : {};
        let result = new WarehouseOutboundOrderType();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["num"] = this.num;
        data["name"] = this.name;
        data["warehouse"] = this.warehouse;
        data["orderNumNext"] = this.orderNumNext;
        data["email"] = this.email;
        data["orderCreate"] = this.orderCreate;
        data["orderCreateFromConfirmed"] = this.orderCreateFromConfirmed;
        data["orderCreateFromLineStatusCancelled"] = this.orderCreateFromLineStatusCancelled;
        data["orderAutoRelease"] = this.orderAutoRelease;
        data["orderAutoReleaseFromLineStatusCancelled"] = this.orderAutoReleaseFromLineStatusCancelled;
        data["requireCustomerKnown"] = this.requireCustomerKnown;
        data["requirePublished"] = this.requirePublished;
        data["requireBuyable"] = this.requireBuyable;
        data["requireOnHand"] = this.requireOnHand;
        data["bomConsolidate"] = this.bomConsolidate;
        data["bomExpand"] = this.bomExpand;
        data["bomConsolidateRequireOnHand"] = this.bomConsolidateRequireOnHand;
        data["bomLineExpandWhenBOMOnHand"] = this.bomLineExpandWhenBOMOnHand;
        data["carrier"] = this.carrier;
        data["dataPublishing_OrderRelease"] = this.dataPublishing_OrderRelease;
        data["extCustNum"] = this.extCustNum;
        data["extOrderType"] = this.extOrderType;
        data["extOrderGroup"] = this.extOrderGroup;
        data["extHandlingType"] = this.extHandlingType;
        data["extCarrierType"] = this.extCarrierType;
        data["extPriority"] = this.extPriority;
        data["extPrintDeliveyNote"] = this.extPrintDeliveyNote;
        data["extPrintInvoice"] = this.extPrintInvoice;
        data["extPrintFooter"] = this.extPrintFooter;
        data["created"] = this.created ? this.created.toISOString() : undefined as any;
        data["createdBy"] = this.createdBy;
        data["modified"] = this.modified ? this.modified.toISOString() : undefined as any;
        data["modifiedBy"] = this.modifiedBy;
        data["carrierNavigation"] = this.carrierNavigation ? this.carrierNavigation.toJSON() : undefined as any;
        data["warehouseNavigation"] = this.warehouseNavigation ? this.warehouseNavigation.toJSON() : undefined as any;
        if (Array.isArray(this.salesChannels)) {
            data["salesChannels"] = [];
            for (let item of this.salesChannels)
                data["salesChannels"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.salesOrders)) {
            data["salesOrders"] = [];
            for (let item of this.salesOrders)
                data["salesOrders"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.warehouseOutboundOrders)) {
            data["warehouseOutboundOrders"] = [];
            for (let item of this.warehouseOutboundOrders)
                data["warehouseOutboundOrders"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.warehouseOutboundOrderTypeProducts)) {
            data["warehouseOutboundOrderTypeProducts"] = [];
            for (let item of this.warehouseOutboundOrderTypeProducts)
                data["warehouseOutboundOrderTypeProducts"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IWarehouseOutboundOrderType {
    id?: number;
    num?: string | undefined;
    name: string;
    warehouse: string;
    orderNumNext?: number | undefined;
    email?: string | undefined;
    orderCreate?: boolean;
    orderCreateFromConfirmed?: boolean;
    orderCreateFromLineStatusCancelled?: boolean;
    orderAutoRelease?: boolean;
    orderAutoReleaseFromLineStatusCancelled?: boolean;
    requireCustomerKnown?: boolean;
    requirePublished?: boolean;
    requireBuyable?: boolean;
    requireOnHand?: boolean;
    bomConsolidate?: boolean;
    bomExpand?: boolean;
    bomConsolidateRequireOnHand?: boolean;
    bomLineExpandWhenBOMOnHand?: boolean;
    carrier?: string | undefined;
    dataPublishing_OrderRelease?: string | undefined;
    extCustNum?: string | undefined;
    extOrderType?: string | undefined;
    extOrderGroup?: string | undefined;
    extHandlingType?: string | undefined;
    extCarrierType?: string | undefined;
    extPriority?: string | undefined;
    extPrintDeliveyNote?: boolean;
    extPrintInvoice?: boolean;
    extPrintFooter?: string | undefined;
    created?: Date | undefined;
    createdBy?: number | undefined;
    modified?: Date | undefined;
    modifiedBy?: number | undefined;
    carrierNavigation?: WarehouseCarrier | undefined;
    warehouseNavigation?: Warehouse | undefined;
    salesChannels?: SalesChannel[] | undefined;
    salesOrders?: SalesOrder[] | undefined;
    warehouseOutboundOrders?: WarehouseOutboundOrder[] | undefined;
    warehouseOutboundOrderTypeProducts?: WarehouseOutboundOrderTypeProduct[] | undefined;
}

export class Warehouse implements IWarehouse {
    id?: number;
    num?: string | undefined;
    name!: string;
    created?: Date | undefined;
    createdBy?: number | undefined;
    modified?: Date | undefined;
    modifiedBy?: number | undefined;
    warehouseInboundOrderTypes?: WarehouseInboundOrderType[] | undefined;
    warehouseOutboundOrders?: WarehouseOutboundOrder[] | undefined;
    warehouseOutboundOrderTypes?: WarehouseOutboundOrderType[] | undefined;

    constructor(data?: IWarehouse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.num = _data["num"];
            this.name = _data["name"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : undefined as any;
            this.createdBy = _data["createdBy"];
            this.modified = _data["modified"] ? new Date(_data["modified"].toString()) : undefined as any;
            this.modifiedBy = _data["modifiedBy"];
            if (Array.isArray(_data["warehouseInboundOrderTypes"])) {
                this.warehouseInboundOrderTypes = [] as any;
                for (let item of _data["warehouseInboundOrderTypes"])
                    this.warehouseInboundOrderTypes!.push(WarehouseInboundOrderType.fromJS(item));
            }
            if (Array.isArray(_data["warehouseOutboundOrders"])) {
                this.warehouseOutboundOrders = [] as any;
                for (let item of _data["warehouseOutboundOrders"])
                    this.warehouseOutboundOrders!.push(WarehouseOutboundOrder.fromJS(item));
            }
            if (Array.isArray(_data["warehouseOutboundOrderTypes"])) {
                this.warehouseOutboundOrderTypes = [] as any;
                for (let item of _data["warehouseOutboundOrderTypes"])
                    this.warehouseOutboundOrderTypes!.push(WarehouseOutboundOrderType.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Warehouse {
        data = typeof data === 'object' ? data : {};
        let result = new Warehouse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["num"] = this.num;
        data["name"] = this.name;
        data["created"] = this.created ? this.created.toISOString() : undefined as any;
        data["createdBy"] = this.createdBy;
        data["modified"] = this.modified ? this.modified.toISOString() : undefined as any;
        data["modifiedBy"] = this.modifiedBy;
        if (Array.isArray(this.warehouseInboundOrderTypes)) {
            data["warehouseInboundOrderTypes"] = [];
            for (let item of this.warehouseInboundOrderTypes)
                data["warehouseInboundOrderTypes"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.warehouseOutboundOrders)) {
            data["warehouseOutboundOrders"] = [];
            for (let item of this.warehouseOutboundOrders)
                data["warehouseOutboundOrders"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.warehouseOutboundOrderTypes)) {
            data["warehouseOutboundOrderTypes"] = [];
            for (let item of this.warehouseOutboundOrderTypes)
                data["warehouseOutboundOrderTypes"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IWarehouse {
    id?: number;
    num?: string | undefined;
    name: string;
    created?: Date | undefined;
    createdBy?: number | undefined;
    modified?: Date | undefined;
    modifiedBy?: number | undefined;
    warehouseInboundOrderTypes?: WarehouseInboundOrderType[] | undefined;
    warehouseOutboundOrders?: WarehouseOutboundOrder[] | undefined;
    warehouseOutboundOrderTypes?: WarehouseOutboundOrderType[] | undefined;
}

export class WarehouseInboundOrderType implements IWarehouseInboundOrderType {
    id?: number;
    num?: string | undefined;
    name!: string;
    warehouse!: string;
    created?: Date | undefined;
    createdBy?: number | undefined;
    modified?: Date | undefined;
    modifiedBy?: number | undefined;
    warehouseNavigation?: Warehouse | undefined;

    constructor(data?: IWarehouseInboundOrderType) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.num = _data["num"];
            this.name = _data["name"];
            this.warehouse = _data["warehouse"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : undefined as any;
            this.createdBy = _data["createdBy"];
            this.modified = _data["modified"] ? new Date(_data["modified"].toString()) : undefined as any;
            this.modifiedBy = _data["modifiedBy"];
            this.warehouseNavigation = _data["warehouseNavigation"] ? Warehouse.fromJS(_data["warehouseNavigation"]) : undefined as any;
        }
    }

    static fromJS(data: any): WarehouseInboundOrderType {
        data = typeof data === 'object' ? data : {};
        let result = new WarehouseInboundOrderType();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["num"] = this.num;
        data["name"] = this.name;
        data["warehouse"] = this.warehouse;
        data["created"] = this.created ? this.created.toISOString() : undefined as any;
        data["createdBy"] = this.createdBy;
        data["modified"] = this.modified ? this.modified.toISOString() : undefined as any;
        data["modifiedBy"] = this.modifiedBy;
        data["warehouseNavigation"] = this.warehouseNavigation ? this.warehouseNavigation.toJSON() : undefined as any;
        return data;
    }
}

export interface IWarehouseInboundOrderType {
    id?: number;
    num?: string | undefined;
    name: string;
    warehouse: string;
    created?: Date | undefined;
    createdBy?: number | undefined;
    modified?: Date | undefined;
    modifiedBy?: number | undefined;
    warehouseNavigation?: Warehouse | undefined;
}

export class WarehouseOutboundOrderTypeProduct implements IWarehouseOutboundOrderTypeProduct {
    id?: number;
    orderType!: string;
    product!: string;
    name!: string;
    addEveryOrder?: boolean;
    periodFrom?: Date | undefined;
    periodTo?: Date | undefined;
    created?: Date | undefined;
    createdBy?: number | undefined;
    modified?: Date | undefined;
    modifiedBy?: number | undefined;
    orderTypeNavigation?: WarehouseOutboundOrderType | undefined;

    constructor(data?: IWarehouseOutboundOrderTypeProduct) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.orderType = _data["orderType"];
            this.product = _data["product"];
            this.name = _data["name"];
            this.addEveryOrder = _data["addEveryOrder"];
            this.periodFrom = _data["periodFrom"] ? new Date(_data["periodFrom"].toString()) : undefined as any;
            this.periodTo = _data["periodTo"] ? new Date(_data["periodTo"].toString()) : undefined as any;
            this.created = _data["created"] ? new Date(_data["created"].toString()) : undefined as any;
            this.createdBy = _data["createdBy"];
            this.modified = _data["modified"] ? new Date(_data["modified"].toString()) : undefined as any;
            this.modifiedBy = _data["modifiedBy"];
            this.orderTypeNavigation = _data["orderTypeNavigation"] ? WarehouseOutboundOrderType.fromJS(_data["orderTypeNavigation"]) : undefined as any;
        }
    }

    static fromJS(data: any): WarehouseOutboundOrderTypeProduct {
        data = typeof data === 'object' ? data : {};
        let result = new WarehouseOutboundOrderTypeProduct();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["orderType"] = this.orderType;
        data["product"] = this.product;
        data["name"] = this.name;
        data["addEveryOrder"] = this.addEveryOrder;
        data["periodFrom"] = this.periodFrom ? this.periodFrom.toISOString() : undefined as any;
        data["periodTo"] = this.periodTo ? this.periodTo.toISOString() : undefined as any;
        data["created"] = this.created ? this.created.toISOString() : undefined as any;
        data["createdBy"] = this.createdBy;
        data["modified"] = this.modified ? this.modified.toISOString() : undefined as any;
        data["modifiedBy"] = this.modifiedBy;
        data["orderTypeNavigation"] = this.orderTypeNavigation ? this.orderTypeNavigation.toJSON() : undefined as any;
        return data;
    }
}

export interface IWarehouseOutboundOrderTypeProduct {
    id?: number;
    orderType: string;
    product: string;
    name: string;
    addEveryOrder?: boolean;
    periodFrom?: Date | undefined;
    periodTo?: Date | undefined;
    created?: Date | undefined;
    createdBy?: number | undefined;
    modified?: Date | undefined;
    modifiedBy?: number | undefined;
    orderTypeNavigation?: WarehouseOutboundOrderType | undefined;
}

export class SalesChannelOrderStatus implements ISalesChannelOrderStatus {
    id?: number;
    channel!: string;
    channelOrderStatus!: string;
    orderStatus!: string;
    name?: string | undefined;
    created?: Date | undefined;
    createdBy?: number | undefined;
    modified?: Date | undefined;
    modifiedBy?: number | undefined;
    channelNavigation?: SalesChannel | undefined;

    constructor(data?: ISalesChannelOrderStatus) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.channel = _data["channel"];
            this.channelOrderStatus = _data["channelOrderStatus"];
            this.orderStatus = _data["orderStatus"];
            this.name = _data["name"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : undefined as any;
            this.createdBy = _data["createdBy"];
            this.modified = _data["modified"] ? new Date(_data["modified"].toString()) : undefined as any;
            this.modifiedBy = _data["modifiedBy"];
            this.channelNavigation = _data["channelNavigation"] ? SalesChannel.fromJS(_data["channelNavigation"]) : undefined as any;
        }
    }

    static fromJS(data: any): SalesChannelOrderStatus {
        data = typeof data === 'object' ? data : {};
        let result = new SalesChannelOrderStatus();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["channel"] = this.channel;
        data["channelOrderStatus"] = this.channelOrderStatus;
        data["orderStatus"] = this.orderStatus;
        data["name"] = this.name;
        data["created"] = this.created ? this.created.toISOString() : undefined as any;
        data["createdBy"] = this.createdBy;
        data["modified"] = this.modified ? this.modified.toISOString() : undefined as any;
        data["modifiedBy"] = this.modifiedBy;
        data["channelNavigation"] = this.channelNavigation ? this.channelNavigation.toJSON() : undefined as any;
        return data;
    }
}

export interface ISalesChannelOrderStatus {
    id?: number;
    channel: string;
    channelOrderStatus: string;
    orderStatus: string;
    name?: string | undefined;
    created?: Date | undefined;
    createdBy?: number | undefined;
    modified?: Date | undefined;
    modifiedBy?: number | undefined;
    channelNavigation?: SalesChannel | undefined;
}

export class SalesChannelProduct implements ISalesChannelProduct {
    id?: number;
    salesChannel!: string;
    num!: string;
    product!: string;
    name!: string;
    convertQtyFactor?: number;
    convertBOM?: boolean;
    created?: Date | undefined;
    createdBy?: number | undefined;
    modified?: Date | undefined;
    modifiedBy?: number | undefined;
    salesChannelNavigation?: SalesChannel | undefined;

    constructor(data?: ISalesChannelProduct) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.salesChannel = _data["salesChannel"];
            this.num = _data["num"];
            this.product = _data["product"];
            this.name = _data["name"];
            this.convertQtyFactor = _data["convertQtyFactor"];
            this.convertBOM = _data["convertBOM"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : undefined as any;
            this.createdBy = _data["createdBy"];
            this.modified = _data["modified"] ? new Date(_data["modified"].toString()) : undefined as any;
            this.modifiedBy = _data["modifiedBy"];
            this.salesChannelNavigation = _data["salesChannelNavigation"] ? SalesChannel.fromJS(_data["salesChannelNavigation"]) : undefined as any;
        }
    }

    static fromJS(data: any): SalesChannelProduct {
        data = typeof data === 'object' ? data : {};
        let result = new SalesChannelProduct();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["salesChannel"] = this.salesChannel;
        data["num"] = this.num;
        data["product"] = this.product;
        data["name"] = this.name;
        data["convertQtyFactor"] = this.convertQtyFactor;
        data["convertBOM"] = this.convertBOM;
        data["created"] = this.created ? this.created.toISOString() : undefined as any;
        data["createdBy"] = this.createdBy;
        data["modified"] = this.modified ? this.modified.toISOString() : undefined as any;
        data["modifiedBy"] = this.modifiedBy;
        data["salesChannelNavigation"] = this.salesChannelNavigation ? this.salesChannelNavigation.toJSON() : undefined as any;
        return data;
    }
}

export interface ISalesChannelProduct {
    id?: number;
    salesChannel: string;
    num: string;
    product: string;
    name: string;
    convertQtyFactor?: number;
    convertBOM?: boolean;
    created?: Date | undefined;
    createdBy?: number | undefined;
    modified?: Date | undefined;
    modifiedBy?: number | undefined;
    salesChannelNavigation?: SalesChannel | undefined;
}

export class DataNote implements IDataNote {
    id?: number;
    table?: number;
    row?: number;
    type?: number;
    text!: string;
    created?: Date;
    createdBy?: number;
    modified?: Date | undefined;
    modifiedBy?: number | undefined;
    tableNavigation?: DataTable | undefined;
    typeNavigation?: DataNoteType | undefined;

    constructor(data?: IDataNote) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.table = _data["table"];
            this.row = _data["row"];
            this.type = _data["type"];
            this.text = _data["text"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : undefined as any;
            this.createdBy = _data["createdBy"];
            this.modified = _data["modified"] ? new Date(_data["modified"].toString()) : undefined as any;
            this.modifiedBy = _data["modifiedBy"];
            this.tableNavigation = _data["tableNavigation"] ? DataTable.fromJS(_data["tableNavigation"]) : undefined as any;
            this.typeNavigation = _data["typeNavigation"] ? DataNoteType.fromJS(_data["typeNavigation"]) : undefined as any;
        }
    }

    static fromJS(data: any): DataNote {
        data = typeof data === 'object' ? data : {};
        let result = new DataNote();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["table"] = this.table;
        data["row"] = this.row;
        data["type"] = this.type;
        data["text"] = this.text;
        data["created"] = this.created ? this.created.toISOString() : undefined as any;
        data["createdBy"] = this.createdBy;
        data["modified"] = this.modified ? this.modified.toISOString() : undefined as any;
        data["modifiedBy"] = this.modifiedBy;
        data["tableNavigation"] = this.tableNavigation ? this.tableNavigation.toJSON() : undefined as any;
        data["typeNavigation"] = this.typeNavigation ? this.typeNavigation.toJSON() : undefined as any;
        return data;
    }
}

export interface IDataNote {
    id?: number;
    table?: number;
    row?: number;
    type?: number;
    text: string;
    created?: Date;
    createdBy?: number;
    modified?: Date | undefined;
    modifiedBy?: number | undefined;
    tableNavigation?: DataTable | undefined;
    typeNavigation?: DataNoteType | undefined;
}

export class DataNoteType implements IDataNoteType {
    id?: number;
    name!: string;
    created?: Date | undefined;
    createdBy?: number | undefined;
    modified?: Date | undefined;
    modifiedBy?: number | undefined;
    dataNotes?: DataNote[] | undefined;

    constructor(data?: IDataNoteType) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : undefined as any;
            this.createdBy = _data["createdBy"];
            this.modified = _data["modified"] ? new Date(_data["modified"].toString()) : undefined as any;
            this.modifiedBy = _data["modifiedBy"];
            if (Array.isArray(_data["dataNotes"])) {
                this.dataNotes = [] as any;
                for (let item of _data["dataNotes"])
                    this.dataNotes!.push(DataNote.fromJS(item));
            }
        }
    }

    static fromJS(data: any): DataNoteType {
        data = typeof data === 'object' ? data : {};
        let result = new DataNoteType();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["created"] = this.created ? this.created.toISOString() : undefined as any;
        data["createdBy"] = this.createdBy;
        data["modified"] = this.modified ? this.modified.toISOString() : undefined as any;
        data["modifiedBy"] = this.modifiedBy;
        if (Array.isArray(this.dataNotes)) {
            data["dataNotes"] = [];
            for (let item of this.dataNotes)
                data["dataNotes"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IDataNoteType {
    id?: number;
    name: string;
    created?: Date | undefined;
    createdBy?: number | undefined;
    modified?: Date | undefined;
    modifiedBy?: number | undefined;
    dataNotes?: DataNote[] | undefined;
}

export class DataNotification implements IDataNotification {
    id?: number;
    name!: string;
    active?: boolean;
    table?: number;
    row?: number;
    template?: number;
    schedule?: number;
    nextRun?: Date | undefined;
    address!: string;
    created?: Date;
    createdBy?: number;
    modified?: Date | undefined;
    modifiedBy?: number | undefined;
    scheduleNavigation?: ScheduleType | undefined;
    tableNavigation?: DataTable | undefined;
    templateNavigation?: MailTemplate | undefined;

    constructor(data?: IDataNotification) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.active = _data["active"];
            this.table = _data["table"];
            this.row = _data["row"];
            this.template = _data["template"];
            this.schedule = _data["schedule"];
            this.nextRun = _data["nextRun"] ? new Date(_data["nextRun"].toString()) : undefined as any;
            this.address = _data["address"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : undefined as any;
            this.createdBy = _data["createdBy"];
            this.modified = _data["modified"] ? new Date(_data["modified"].toString()) : undefined as any;
            this.modifiedBy = _data["modifiedBy"];
            this.scheduleNavigation = _data["scheduleNavigation"] ? ScheduleType.fromJS(_data["scheduleNavigation"]) : undefined as any;
            this.tableNavigation = _data["tableNavigation"] ? DataTable.fromJS(_data["tableNavigation"]) : undefined as any;
            this.templateNavigation = _data["templateNavigation"] ? MailTemplate.fromJS(_data["templateNavigation"]) : undefined as any;
        }
    }

    static fromJS(data: any): DataNotification {
        data = typeof data === 'object' ? data : {};
        let result = new DataNotification();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["active"] = this.active;
        data["table"] = this.table;
        data["row"] = this.row;
        data["template"] = this.template;
        data["schedule"] = this.schedule;
        data["nextRun"] = this.nextRun ? this.nextRun.toISOString() : undefined as any;
        data["address"] = this.address;
        data["created"] = this.created ? this.created.toISOString() : undefined as any;
        data["createdBy"] = this.createdBy;
        data["modified"] = this.modified ? this.modified.toISOString() : undefined as any;
        data["modifiedBy"] = this.modifiedBy;
        data["scheduleNavigation"] = this.scheduleNavigation ? this.scheduleNavigation.toJSON() : undefined as any;
        data["tableNavigation"] = this.tableNavigation ? this.tableNavigation.toJSON() : undefined as any;
        data["templateNavigation"] = this.templateNavigation ? this.templateNavigation.toJSON() : undefined as any;
        return data;
    }
}

export interface IDataNotification {
    id?: number;
    name: string;
    active?: boolean;
    table?: number;
    row?: number;
    template?: number;
    schedule?: number;
    nextRun?: Date | undefined;
    address: string;
    created?: Date;
    createdBy?: number;
    modified?: Date | undefined;
    modifiedBy?: number | undefined;
    scheduleNavigation?: ScheduleType | undefined;
    tableNavigation?: DataTable | undefined;
    templateNavigation?: MailTemplate | undefined;
}

export class ScheduleType implements IScheduleType {
    id?: number;
    name!: string;
    cron!: string;
    created?: Date | undefined;
    createdBy?: number | undefined;
    modified?: Date | undefined;
    modifiedBy?: number | undefined;
    dataNotifications?: DataNotification[] | undefined;

    constructor(data?: IScheduleType) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.cron = _data["cron"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : undefined as any;
            this.createdBy = _data["createdBy"];
            this.modified = _data["modified"] ? new Date(_data["modified"].toString()) : undefined as any;
            this.modifiedBy = _data["modifiedBy"];
            if (Array.isArray(_data["dataNotifications"])) {
                this.dataNotifications = [] as any;
                for (let item of _data["dataNotifications"])
                    this.dataNotifications!.push(DataNotification.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ScheduleType {
        data = typeof data === 'object' ? data : {};
        let result = new ScheduleType();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["cron"] = this.cron;
        data["created"] = this.created ? this.created.toISOString() : undefined as any;
        data["createdBy"] = this.createdBy;
        data["modified"] = this.modified ? this.modified.toISOString() : undefined as any;
        data["modifiedBy"] = this.modifiedBy;
        if (Array.isArray(this.dataNotifications)) {
            data["dataNotifications"] = [];
            for (let item of this.dataNotifications)
                data["dataNotifications"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IScheduleType {
    id?: number;
    name: string;
    cron: string;
    created?: Date | undefined;
    createdBy?: number | undefined;
    modified?: Date | undefined;
    modifiedBy?: number | undefined;
    dataNotifications?: DataNotification[] | undefined;
}

export class MailTemplate implements IMailTemplate {
    id?: number;
    name!: string;
    channel?: number;
    fromEmail?: string | undefined;
    fromName?: string | undefined;
    toEmails?: string | undefined;
    ccEmails?: string | undefined;
    subject?: string | undefined;
    body?: string | undefined;
    bodyIsHtml?: boolean | undefined;
    created?: Date | undefined;
    createdBy?: number | undefined;
    modified?: Date | undefined;
    modifiedBy?: number | undefined;
    channelNavigation?: MailChannel | undefined;
    dataNotifications?: DataNotification[] | undefined;
    mailTemplateLocales?: MailTemplateLocale[] | undefined;

    constructor(data?: IMailTemplate) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.channel = _data["channel"];
            this.fromEmail = _data["fromEmail"];
            this.fromName = _data["fromName"];
            this.toEmails = _data["toEmails"];
            this.ccEmails = _data["ccEmails"];
            this.subject = _data["subject"];
            this.body = _data["body"];
            this.bodyIsHtml = _data["bodyIsHtml"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : undefined as any;
            this.createdBy = _data["createdBy"];
            this.modified = _data["modified"] ? new Date(_data["modified"].toString()) : undefined as any;
            this.modifiedBy = _data["modifiedBy"];
            this.channelNavigation = _data["channelNavigation"] ? MailChannel.fromJS(_data["channelNavigation"]) : undefined as any;
            if (Array.isArray(_data["dataNotifications"])) {
                this.dataNotifications = [] as any;
                for (let item of _data["dataNotifications"])
                    this.dataNotifications!.push(DataNotification.fromJS(item));
            }
            if (Array.isArray(_data["mailTemplateLocales"])) {
                this.mailTemplateLocales = [] as any;
                for (let item of _data["mailTemplateLocales"])
                    this.mailTemplateLocales!.push(MailTemplateLocale.fromJS(item));
            }
        }
    }

    static fromJS(data: any): MailTemplate {
        data = typeof data === 'object' ? data : {};
        let result = new MailTemplate();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["channel"] = this.channel;
        data["fromEmail"] = this.fromEmail;
        data["fromName"] = this.fromName;
        data["toEmails"] = this.toEmails;
        data["ccEmails"] = this.ccEmails;
        data["subject"] = this.subject;
        data["body"] = this.body;
        data["bodyIsHtml"] = this.bodyIsHtml;
        data["created"] = this.created ? this.created.toISOString() : undefined as any;
        data["createdBy"] = this.createdBy;
        data["modified"] = this.modified ? this.modified.toISOString() : undefined as any;
        data["modifiedBy"] = this.modifiedBy;
        data["channelNavigation"] = this.channelNavigation ? this.channelNavigation.toJSON() : undefined as any;
        if (Array.isArray(this.dataNotifications)) {
            data["dataNotifications"] = [];
            for (let item of this.dataNotifications)
                data["dataNotifications"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.mailTemplateLocales)) {
            data["mailTemplateLocales"] = [];
            for (let item of this.mailTemplateLocales)
                data["mailTemplateLocales"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IMailTemplate {
    id?: number;
    name: string;
    channel?: number;
    fromEmail?: string | undefined;
    fromName?: string | undefined;
    toEmails?: string | undefined;
    ccEmails?: string | undefined;
    subject?: string | undefined;
    body?: string | undefined;
    bodyIsHtml?: boolean | undefined;
    created?: Date | undefined;
    createdBy?: number | undefined;
    modified?: Date | undefined;
    modifiedBy?: number | undefined;
    channelNavigation?: MailChannel | undefined;
    dataNotifications?: DataNotification[] | undefined;
    mailTemplateLocales?: MailTemplateLocale[] | undefined;
}

export class MailChannel implements IMailChannel {
    id?: number;
    name!: string;
    active?: boolean;
    created?: Date | undefined;
    createdBy?: number | undefined;
    modified?: Date | undefined;
    modifiedBy?: number | undefined;
    mailTemplates?: MailTemplate[] | undefined;

    constructor(data?: IMailChannel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.active = _data["active"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : undefined as any;
            this.createdBy = _data["createdBy"];
            this.modified = _data["modified"] ? new Date(_data["modified"].toString()) : undefined as any;
            this.modifiedBy = _data["modifiedBy"];
            if (Array.isArray(_data["mailTemplates"])) {
                this.mailTemplates = [] as any;
                for (let item of _data["mailTemplates"])
                    this.mailTemplates!.push(MailTemplate.fromJS(item));
            }
        }
    }

    static fromJS(data: any): MailChannel {
        data = typeof data === 'object' ? data : {};
        let result = new MailChannel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["active"] = this.active;
        data["created"] = this.created ? this.created.toISOString() : undefined as any;
        data["createdBy"] = this.createdBy;
        data["modified"] = this.modified ? this.modified.toISOString() : undefined as any;
        data["modifiedBy"] = this.modifiedBy;
        if (Array.isArray(this.mailTemplates)) {
            data["mailTemplates"] = [];
            for (let item of this.mailTemplates)
                data["mailTemplates"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IMailChannel {
    id?: number;
    name: string;
    active?: boolean;
    created?: Date | undefined;
    createdBy?: number | undefined;
    modified?: Date | undefined;
    modifiedBy?: number | undefined;
    mailTemplates?: MailTemplate[] | undefined;
}

export class MailTemplateLocale implements IMailTemplateLocale {
    id?: number;
    template?: number;
    locale?: number;
    subject?: string | undefined;
    body?: string | undefined;
    created?: Date | undefined;
    createdBy?: number | undefined;
    modified?: Date | undefined;
    modifiedBy?: number | undefined;
    templateNavigation?: MailTemplate | undefined;

    constructor(data?: IMailTemplateLocale) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.template = _data["template"];
            this.locale = _data["locale"];
            this.subject = _data["subject"];
            this.body = _data["body"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : undefined as any;
            this.createdBy = _data["createdBy"];
            this.modified = _data["modified"] ? new Date(_data["modified"].toString()) : undefined as any;
            this.modifiedBy = _data["modifiedBy"];
            this.templateNavigation = _data["templateNavigation"] ? MailTemplate.fromJS(_data["templateNavigation"]) : undefined as any;
        }
    }

    static fromJS(data: any): MailTemplateLocale {
        data = typeof data === 'object' ? data : {};
        let result = new MailTemplateLocale();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["template"] = this.template;
        data["locale"] = this.locale;
        data["subject"] = this.subject;
        data["body"] = this.body;
        data["created"] = this.created ? this.created.toISOString() : undefined as any;
        data["createdBy"] = this.createdBy;
        data["modified"] = this.modified ? this.modified.toISOString() : undefined as any;
        data["modifiedBy"] = this.modifiedBy;
        data["templateNavigation"] = this.templateNavigation ? this.templateNavigation.toJSON() : undefined as any;
        return data;
    }
}

export interface IMailTemplateLocale {
    id?: number;
    template?: number;
    locale?: number;
    subject?: string | undefined;
    body?: string | undefined;
    created?: Date | undefined;
    createdBy?: number | undefined;
    modified?: Date | undefined;
    modifiedBy?: number | undefined;
    templateNavigation?: MailTemplate | undefined;
}

export class DataTableColumn implements IDataTableColumn {
    id?: number;
    table?: number;
    isDynamic?: boolean;
    order?: number;
    name!: string;
    type?: number;
    length?: number | undefined;
    caption!: string;
    captionShort?: string | undefined;
    description?: string | undefined;
    required?: number;
    visible?: number;
    allowEdit?: number;
    allowEditOnCreate?: number;
    foreignKeyTable?: number | undefined;
    foreignKeyColumns?: string | undefined;
    tableNavigation?: DataTable | undefined;

    constructor(data?: IDataTableColumn) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.table = _data["table"];
            this.isDynamic = _data["isDynamic"];
            this.order = _data["order"];
            this.name = _data["name"];
            this.type = _data["type"];
            this.length = _data["length"];
            this.caption = _data["caption"];
            this.captionShort = _data["captionShort"];
            this.description = _data["description"];
            this.required = _data["required"];
            this.visible = _data["visible"];
            this.allowEdit = _data["allowEdit"];
            this.allowEditOnCreate = _data["allowEditOnCreate"];
            this.foreignKeyTable = _data["foreignKeyTable"];
            this.foreignKeyColumns = _data["foreignKeyColumns"];
            this.tableNavigation = _data["tableNavigation"] ? DataTable.fromJS(_data["tableNavigation"]) : undefined as any;
        }
    }

    static fromJS(data: any): DataTableColumn {
        data = typeof data === 'object' ? data : {};
        let result = new DataTableColumn();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["table"] = this.table;
        data["isDynamic"] = this.isDynamic;
        data["order"] = this.order;
        data["name"] = this.name;
        data["type"] = this.type;
        data["length"] = this.length;
        data["caption"] = this.caption;
        data["captionShort"] = this.captionShort;
        data["description"] = this.description;
        data["required"] = this.required;
        data["visible"] = this.visible;
        data["allowEdit"] = this.allowEdit;
        data["allowEditOnCreate"] = this.allowEditOnCreate;
        data["foreignKeyTable"] = this.foreignKeyTable;
        data["foreignKeyColumns"] = this.foreignKeyColumns;
        data["tableNavigation"] = this.tableNavigation ? this.tableNavigation.toJSON() : undefined as any;
        return data;
    }
}

export interface IDataTableColumn {
    id?: number;
    table?: number;
    isDynamic?: boolean;
    order?: number;
    name: string;
    type?: number;
    length?: number | undefined;
    caption: string;
    captionShort?: string | undefined;
    description?: string | undefined;
    required?: number;
    visible?: number;
    allowEdit?: number;
    allowEditOnCreate?: number;
    foreignKeyTable?: number | undefined;
    foreignKeyColumns?: string | undefined;
    tableNavigation?: DataTable | undefined;
}

export class DataTableRow implements IDataTableRow {
    id?: number;
    table?: number;
    data!: string;
    created?: Date;
    createdBy?: number;
    modified?: Date | undefined;
    modifiedBy?: number | undefined;
    tableNavigation?: DataTable | undefined;

    constructor(data?: IDataTableRow) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.table = _data["table"];
            this.data = _data["data"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : undefined as any;
            this.createdBy = _data["createdBy"];
            this.modified = _data["modified"] ? new Date(_data["modified"].toString()) : undefined as any;
            this.modifiedBy = _data["modifiedBy"];
            this.tableNavigation = _data["tableNavigation"] ? DataTable.fromJS(_data["tableNavigation"]) : undefined as any;
        }
    }

    static fromJS(data: any): DataTableRow {
        data = typeof data === 'object' ? data : {};
        let result = new DataTableRow();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["table"] = this.table;
        data["data"] = this.data;
        data["created"] = this.created ? this.created.toISOString() : undefined as any;
        data["createdBy"] = this.createdBy;
        data["modified"] = this.modified ? this.modified.toISOString() : undefined as any;
        data["modifiedBy"] = this.modifiedBy;
        data["tableNavigation"] = this.tableNavigation ? this.tableNavigation.toJSON() : undefined as any;
        return data;
    }
}

export interface IDataTableRow {
    id?: number;
    table?: number;
    data: string;
    created?: Date;
    createdBy?: number;
    modified?: Date | undefined;
    modifiedBy?: number | undefined;
    tableNavigation?: DataTable | undefined;
}

export class DataTag implements IDataTag {
    id?: number;
    table?: number;
    row?: number;
    type?: number;
    created?: Date;
    createdBy?: number;
    modified?: Date | undefined;
    modifiedBy?: number | undefined;
    tableNavigation?: DataTable | undefined;
    typeNavigation?: DataTagType | undefined;

    constructor(data?: IDataTag) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.table = _data["table"];
            this.row = _data["row"];
            this.type = _data["type"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : undefined as any;
            this.createdBy = _data["createdBy"];
            this.modified = _data["modified"] ? new Date(_data["modified"].toString()) : undefined as any;
            this.modifiedBy = _data["modifiedBy"];
            this.tableNavigation = _data["tableNavigation"] ? DataTable.fromJS(_data["tableNavigation"]) : undefined as any;
            this.typeNavigation = _data["typeNavigation"] ? DataTagType.fromJS(_data["typeNavigation"]) : undefined as any;
        }
    }

    static fromJS(data: any): DataTag {
        data = typeof data === 'object' ? data : {};
        let result = new DataTag();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["table"] = this.table;
        data["row"] = this.row;
        data["type"] = this.type;
        data["created"] = this.created ? this.created.toISOString() : undefined as any;
        data["createdBy"] = this.createdBy;
        data["modified"] = this.modified ? this.modified.toISOString() : undefined as any;
        data["modifiedBy"] = this.modifiedBy;
        data["tableNavigation"] = this.tableNavigation ? this.tableNavigation.toJSON() : undefined as any;
        data["typeNavigation"] = this.typeNavigation ? this.typeNavigation.toJSON() : undefined as any;
        return data;
    }
}

export interface IDataTag {
    id?: number;
    table?: number;
    row?: number;
    type?: number;
    created?: Date;
    createdBy?: number;
    modified?: Date | undefined;
    modifiedBy?: number | undefined;
    tableNavigation?: DataTable | undefined;
    typeNavigation?: DataTagType | undefined;
}

export class DataTagType implements IDataTagType {
    id?: number;
    name!: string;
    shortName?: string | undefined;
    dataTable?: number | undefined;
    roleId?: number | undefined;
    userId?: number | undefined;
    color?: number | undefined;
    created?: Date | undefined;
    createdBy?: number | undefined;
    modified?: Date | undefined;
    modifiedBy?: number | undefined;
    role?: Role | undefined;
    user?: User | undefined;
    dataTags?: DataTag[] | undefined;

    constructor(data?: IDataTagType) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.shortName = _data["shortName"];
            this.dataTable = _data["dataTable"];
            this.roleId = _data["roleId"];
            this.userId = _data["userId"];
            this.color = _data["color"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : undefined as any;
            this.createdBy = _data["createdBy"];
            this.modified = _data["modified"] ? new Date(_data["modified"].toString()) : undefined as any;
            this.modifiedBy = _data["modifiedBy"];
            this.role = _data["role"] ? Role.fromJS(_data["role"]) : undefined as any;
            this.user = _data["user"] ? User.fromJS(_data["user"]) : undefined as any;
            if (Array.isArray(_data["dataTags"])) {
                this.dataTags = [] as any;
                for (let item of _data["dataTags"])
                    this.dataTags!.push(DataTag.fromJS(item));
            }
        }
    }

    static fromJS(data: any): DataTagType {
        data = typeof data === 'object' ? data : {};
        let result = new DataTagType();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["shortName"] = this.shortName;
        data["dataTable"] = this.dataTable;
        data["roleId"] = this.roleId;
        data["userId"] = this.userId;
        data["color"] = this.color;
        data["created"] = this.created ? this.created.toISOString() : undefined as any;
        data["createdBy"] = this.createdBy;
        data["modified"] = this.modified ? this.modified.toISOString() : undefined as any;
        data["modifiedBy"] = this.modifiedBy;
        data["role"] = this.role ? this.role.toJSON() : undefined as any;
        data["user"] = this.user ? this.user.toJSON() : undefined as any;
        if (Array.isArray(this.dataTags)) {
            data["dataTags"] = [];
            for (let item of this.dataTags)
                data["dataTags"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IDataTagType {
    id?: number;
    name: string;
    shortName?: string | undefined;
    dataTable?: number | undefined;
    roleId?: number | undefined;
    userId?: number | undefined;
    color?: number | undefined;
    created?: Date | undefined;
    createdBy?: number | undefined;
    modified?: Date | undefined;
    modifiedBy?: number | undefined;
    role?: Role | undefined;
    user?: User | undefined;
    dataTags?: DataTag[] | undefined;
}

export class Role implements IRole {
    id?: number;
    name!: string;
    created?: Date | undefined;
    createdBy?: number | undefined;
    modified?: Date | undefined;
    modifiedBy?: number | undefined;
    dataProcessStageProperties?: DataProcessStageProperty[] | undefined;
    dataProcessStages?: DataProcessStage[] | undefined;
    dataTagTypes?: DataTagType[] | undefined;
    roleRoutes?: RoleRoute[] | undefined;
    roleUsers?: RoleUser[] | undefined;

    constructor(data?: IRole) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : undefined as any;
            this.createdBy = _data["createdBy"];
            this.modified = _data["modified"] ? new Date(_data["modified"].toString()) : undefined as any;
            this.modifiedBy = _data["modifiedBy"];
            if (Array.isArray(_data["dataProcessStageProperties"])) {
                this.dataProcessStageProperties = [] as any;
                for (let item of _data["dataProcessStageProperties"])
                    this.dataProcessStageProperties!.push(DataProcessStageProperty.fromJS(item));
            }
            if (Array.isArray(_data["dataProcessStages"])) {
                this.dataProcessStages = [] as any;
                for (let item of _data["dataProcessStages"])
                    this.dataProcessStages!.push(DataProcessStage.fromJS(item));
            }
            if (Array.isArray(_data["dataTagTypes"])) {
                this.dataTagTypes = [] as any;
                for (let item of _data["dataTagTypes"])
                    this.dataTagTypes!.push(DataTagType.fromJS(item));
            }
            if (Array.isArray(_data["roleRoutes"])) {
                this.roleRoutes = [] as any;
                for (let item of _data["roleRoutes"])
                    this.roleRoutes!.push(RoleRoute.fromJS(item));
            }
            if (Array.isArray(_data["roleUsers"])) {
                this.roleUsers = [] as any;
                for (let item of _data["roleUsers"])
                    this.roleUsers!.push(RoleUser.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Role {
        data = typeof data === 'object' ? data : {};
        let result = new Role();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["created"] = this.created ? this.created.toISOString() : undefined as any;
        data["createdBy"] = this.createdBy;
        data["modified"] = this.modified ? this.modified.toISOString() : undefined as any;
        data["modifiedBy"] = this.modifiedBy;
        if (Array.isArray(this.dataProcessStageProperties)) {
            data["dataProcessStageProperties"] = [];
            for (let item of this.dataProcessStageProperties)
                data["dataProcessStageProperties"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.dataProcessStages)) {
            data["dataProcessStages"] = [];
            for (let item of this.dataProcessStages)
                data["dataProcessStages"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.dataTagTypes)) {
            data["dataTagTypes"] = [];
            for (let item of this.dataTagTypes)
                data["dataTagTypes"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.roleRoutes)) {
            data["roleRoutes"] = [];
            for (let item of this.roleRoutes)
                data["roleRoutes"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.roleUsers)) {
            data["roleUsers"] = [];
            for (let item of this.roleUsers)
                data["roleUsers"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IRole {
    id?: number;
    name: string;
    created?: Date | undefined;
    createdBy?: number | undefined;
    modified?: Date | undefined;
    modifiedBy?: number | undefined;
    dataProcessStageProperties?: DataProcessStageProperty[] | undefined;
    dataProcessStages?: DataProcessStage[] | undefined;
    dataTagTypes?: DataTagType[] | undefined;
    roleRoutes?: RoleRoute[] | undefined;
    roleUsers?: RoleUser[] | undefined;
}

export class DataProcessStageProperty implements IDataProcessStageProperty {
    id?: number;
    dataProcessStage?: number;
    name!: string;
    propertyType?: number | undefined;
    propertyName?: number | undefined;
    mandatory?: boolean;
    validation?: string | undefined;
    responsibleUser?: number | undefined;
    responsibleRole?: number | undefined;
    created?: Date | undefined;
    createdBy?: number | undefined;
    modified?: Date | undefined;
    modifiedBy?: number | undefined;
    dataProcessStageNavigation?: DataProcessStage | undefined;
    responsibleRoleNavigation?: Role | undefined;
    responsibleUserNavigation?: User | undefined;

    constructor(data?: IDataProcessStageProperty) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.dataProcessStage = _data["dataProcessStage"];
            this.name = _data["name"];
            this.propertyType = _data["propertyType"];
            this.propertyName = _data["propertyName"];
            this.mandatory = _data["mandatory"];
            this.validation = _data["validation"];
            this.responsibleUser = _data["responsibleUser"];
            this.responsibleRole = _data["responsibleRole"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : undefined as any;
            this.createdBy = _data["createdBy"];
            this.modified = _data["modified"] ? new Date(_data["modified"].toString()) : undefined as any;
            this.modifiedBy = _data["modifiedBy"];
            this.dataProcessStageNavigation = _data["dataProcessStageNavigation"] ? DataProcessStage.fromJS(_data["dataProcessStageNavigation"]) : undefined as any;
            this.responsibleRoleNavigation = _data["responsibleRoleNavigation"] ? Role.fromJS(_data["responsibleRoleNavigation"]) : undefined as any;
            this.responsibleUserNavigation = _data["responsibleUserNavigation"] ? User.fromJS(_data["responsibleUserNavigation"]) : undefined as any;
        }
    }

    static fromJS(data: any): DataProcessStageProperty {
        data = typeof data === 'object' ? data : {};
        let result = new DataProcessStageProperty();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["dataProcessStage"] = this.dataProcessStage;
        data["name"] = this.name;
        data["propertyType"] = this.propertyType;
        data["propertyName"] = this.propertyName;
        data["mandatory"] = this.mandatory;
        data["validation"] = this.validation;
        data["responsibleUser"] = this.responsibleUser;
        data["responsibleRole"] = this.responsibleRole;
        data["created"] = this.created ? this.created.toISOString() : undefined as any;
        data["createdBy"] = this.createdBy;
        data["modified"] = this.modified ? this.modified.toISOString() : undefined as any;
        data["modifiedBy"] = this.modifiedBy;
        data["dataProcessStageNavigation"] = this.dataProcessStageNavigation ? this.dataProcessStageNavigation.toJSON() : undefined as any;
        data["responsibleRoleNavigation"] = this.responsibleRoleNavigation ? this.responsibleRoleNavigation.toJSON() : undefined as any;
        data["responsibleUserNavigation"] = this.responsibleUserNavigation ? this.responsibleUserNavigation.toJSON() : undefined as any;
        return data;
    }
}

export interface IDataProcessStageProperty {
    id?: number;
    dataProcessStage?: number;
    name: string;
    propertyType?: number | undefined;
    propertyName?: number | undefined;
    mandatory?: boolean;
    validation?: string | undefined;
    responsibleUser?: number | undefined;
    responsibleRole?: number | undefined;
    created?: Date | undefined;
    createdBy?: number | undefined;
    modified?: Date | undefined;
    modifiedBy?: number | undefined;
    dataProcessStageNavigation?: DataProcessStage | undefined;
    responsibleRoleNavigation?: Role | undefined;
    responsibleUserNavigation?: User | undefined;
}

export class DataProcessStage implements IDataProcessStage {
    id?: number;
    name!: string;
    order?: number | undefined;
    dataProcess?: number;
    responsibleUser?: number | undefined;
    responsibleRole?: number | undefined;
    created?: Date | undefined;
    createdBy?: number | undefined;
    modified?: Date | undefined;
    modifiedBy?: number | undefined;
    dataProcessNavigation?: DataProcess | undefined;
    responsibleRoleNavigation?: Role | undefined;
    responsibleUserNavigation?: User | undefined;
    dataProcessStageProperties?: DataProcessStageProperty[] | undefined;

    constructor(data?: IDataProcessStage) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.order = _data["order"];
            this.dataProcess = _data["dataProcess"];
            this.responsibleUser = _data["responsibleUser"];
            this.responsibleRole = _data["responsibleRole"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : undefined as any;
            this.createdBy = _data["createdBy"];
            this.modified = _data["modified"] ? new Date(_data["modified"].toString()) : undefined as any;
            this.modifiedBy = _data["modifiedBy"];
            this.dataProcessNavigation = _data["dataProcessNavigation"] ? DataProcess.fromJS(_data["dataProcessNavigation"]) : undefined as any;
            this.responsibleRoleNavigation = _data["responsibleRoleNavigation"] ? Role.fromJS(_data["responsibleRoleNavigation"]) : undefined as any;
            this.responsibleUserNavigation = _data["responsibleUserNavigation"] ? User.fromJS(_data["responsibleUserNavigation"]) : undefined as any;
            if (Array.isArray(_data["dataProcessStageProperties"])) {
                this.dataProcessStageProperties = [] as any;
                for (let item of _data["dataProcessStageProperties"])
                    this.dataProcessStageProperties!.push(DataProcessStageProperty.fromJS(item));
            }
        }
    }

    static fromJS(data: any): DataProcessStage {
        data = typeof data === 'object' ? data : {};
        let result = new DataProcessStage();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["order"] = this.order;
        data["dataProcess"] = this.dataProcess;
        data["responsibleUser"] = this.responsibleUser;
        data["responsibleRole"] = this.responsibleRole;
        data["created"] = this.created ? this.created.toISOString() : undefined as any;
        data["createdBy"] = this.createdBy;
        data["modified"] = this.modified ? this.modified.toISOString() : undefined as any;
        data["modifiedBy"] = this.modifiedBy;
        data["dataProcessNavigation"] = this.dataProcessNavigation ? this.dataProcessNavigation.toJSON() : undefined as any;
        data["responsibleRoleNavigation"] = this.responsibleRoleNavigation ? this.responsibleRoleNavigation.toJSON() : undefined as any;
        data["responsibleUserNavigation"] = this.responsibleUserNavigation ? this.responsibleUserNavigation.toJSON() : undefined as any;
        if (Array.isArray(this.dataProcessStageProperties)) {
            data["dataProcessStageProperties"] = [];
            for (let item of this.dataProcessStageProperties)
                data["dataProcessStageProperties"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IDataProcessStage {
    id?: number;
    name: string;
    order?: number | undefined;
    dataProcess?: number;
    responsibleUser?: number | undefined;
    responsibleRole?: number | undefined;
    created?: Date | undefined;
    createdBy?: number | undefined;
    modified?: Date | undefined;
    modifiedBy?: number | undefined;
    dataProcessNavigation?: DataProcess | undefined;
    responsibleRoleNavigation?: Role | undefined;
    responsibleUserNavigation?: User | undefined;
    dataProcessStageProperties?: DataProcessStageProperty[] | undefined;
}

export class DataProcess implements IDataProcess {
    id?: number;
    name!: string;
    dataTable?: string | undefined;
    created?: Date | undefined;
    createdBy?: number | undefined;
    modified?: Date | undefined;
    modifiedBy?: number | undefined;
    dataProcessStages?: DataProcessStage[] | undefined;

    constructor(data?: IDataProcess) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.dataTable = _data["dataTable"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : undefined as any;
            this.createdBy = _data["createdBy"];
            this.modified = _data["modified"] ? new Date(_data["modified"].toString()) : undefined as any;
            this.modifiedBy = _data["modifiedBy"];
            if (Array.isArray(_data["dataProcessStages"])) {
                this.dataProcessStages = [] as any;
                for (let item of _data["dataProcessStages"])
                    this.dataProcessStages!.push(DataProcessStage.fromJS(item));
            }
        }
    }

    static fromJS(data: any): DataProcess {
        data = typeof data === 'object' ? data : {};
        let result = new DataProcess();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["dataTable"] = this.dataTable;
        data["created"] = this.created ? this.created.toISOString() : undefined as any;
        data["createdBy"] = this.createdBy;
        data["modified"] = this.modified ? this.modified.toISOString() : undefined as any;
        data["modifiedBy"] = this.modifiedBy;
        if (Array.isArray(this.dataProcessStages)) {
            data["dataProcessStages"] = [];
            for (let item of this.dataProcessStages)
                data["dataProcessStages"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IDataProcess {
    id?: number;
    name: string;
    dataTable?: string | undefined;
    created?: Date | undefined;
    createdBy?: number | undefined;
    modified?: Date | undefined;
    modifiedBy?: number | undefined;
    dataProcessStages?: DataProcessStage[] | undefined;
}

export class RoleRoute implements IRoleRoute {
    id?: number;
    role?: number | undefined;
    routeName?: string | undefined;
    active?: boolean;
    allowCreate?: boolean;
    allowRead?: boolean;
    allowUpdate?: boolean;
    allowDelete?: boolean;
    denyCreate?: boolean;
    denyRead?: boolean;
    denyUpdate?: boolean;
    denyDelete?: boolean;
    created?: Date;
    createdBy?: number | undefined;
    modified?: Date;
    modifiedBy?: number | undefined;
    roleNavigation?: Role | undefined;

    constructor(data?: IRoleRoute) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.role = _data["role"];
            this.routeName = _data["routeName"];
            this.active = _data["active"];
            this.allowCreate = _data["allowCreate"];
            this.allowRead = _data["allowRead"];
            this.allowUpdate = _data["allowUpdate"];
            this.allowDelete = _data["allowDelete"];
            this.denyCreate = _data["denyCreate"];
            this.denyRead = _data["denyRead"];
            this.denyUpdate = _data["denyUpdate"];
            this.denyDelete = _data["denyDelete"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : undefined as any;
            this.createdBy = _data["createdBy"];
            this.modified = _data["modified"] ? new Date(_data["modified"].toString()) : undefined as any;
            this.modifiedBy = _data["modifiedBy"];
            this.roleNavigation = _data["roleNavigation"] ? Role.fromJS(_data["roleNavigation"]) : undefined as any;
        }
    }

    static fromJS(data: any): RoleRoute {
        data = typeof data === 'object' ? data : {};
        let result = new RoleRoute();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["role"] = this.role;
        data["routeName"] = this.routeName;
        data["active"] = this.active;
        data["allowCreate"] = this.allowCreate;
        data["allowRead"] = this.allowRead;
        data["allowUpdate"] = this.allowUpdate;
        data["allowDelete"] = this.allowDelete;
        data["denyCreate"] = this.denyCreate;
        data["denyRead"] = this.denyRead;
        data["denyUpdate"] = this.denyUpdate;
        data["denyDelete"] = this.denyDelete;
        data["created"] = this.created ? this.created.toISOString() : undefined as any;
        data["createdBy"] = this.createdBy;
        data["modified"] = this.modified ? this.modified.toISOString() : undefined as any;
        data["modifiedBy"] = this.modifiedBy;
        data["roleNavigation"] = this.roleNavigation ? this.roleNavigation.toJSON() : undefined as any;
        return data;
    }
}

export interface IRoleRoute {
    id?: number;
    role?: number | undefined;
    routeName?: string | undefined;
    active?: boolean;
    allowCreate?: boolean;
    allowRead?: boolean;
    allowUpdate?: boolean;
    allowDelete?: boolean;
    denyCreate?: boolean;
    denyRead?: boolean;
    denyUpdate?: boolean;
    denyDelete?: boolean;
    created?: Date;
    createdBy?: number | undefined;
    modified?: Date;
    modifiedBy?: number | undefined;
    roleNavigation?: Role | undefined;
}

export class RoleUser implements IRoleUser {
    id?: number;
    roleId?: number;
    userId?: number;
    isActive?: boolean;
    created?: Date | undefined;
    createdBy?: number | undefined;
    modified?: Date | undefined;
    modifiedBy?: number | undefined;
    role?: Role | undefined;
    user?: User | undefined;

    constructor(data?: IRoleUser) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.roleId = _data["roleId"];
            this.userId = _data["userId"];
            this.isActive = _data["isActive"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : undefined as any;
            this.createdBy = _data["createdBy"];
            this.modified = _data["modified"] ? new Date(_data["modified"].toString()) : undefined as any;
            this.modifiedBy = _data["modifiedBy"];
            this.role = _data["role"] ? Role.fromJS(_data["role"]) : undefined as any;
            this.user = _data["user"] ? User.fromJS(_data["user"]) : undefined as any;
        }
    }

    static fromJS(data: any): RoleUser {
        data = typeof data === 'object' ? data : {};
        let result = new RoleUser();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["roleId"] = this.roleId;
        data["userId"] = this.userId;
        data["isActive"] = this.isActive;
        data["created"] = this.created ? this.created.toISOString() : undefined as any;
        data["createdBy"] = this.createdBy;
        data["modified"] = this.modified ? this.modified.toISOString() : undefined as any;
        data["modifiedBy"] = this.modifiedBy;
        data["role"] = this.role ? this.role.toJSON() : undefined as any;
        data["user"] = this.user ? this.user.toJSON() : undefined as any;
        return data;
    }
}

export interface IRoleUser {
    id?: number;
    roleId?: number;
    userId?: number;
    isActive?: boolean;
    created?: Date | undefined;
    createdBy?: number | undefined;
    modified?: Date | undefined;
    modifiedBy?: number | undefined;
    role?: Role | undefined;
    user?: User | undefined;
}

export class DocumentLibUser implements IDocumentLibUser {
    id?: number;
    documentLib?: number;
    role?: number | undefined;
    user?: number | undefined;
    active?: boolean;
    owner?: boolean;
    allowEdit?: boolean;
    allowCreate?: boolean;
    allowDelete?: boolean;
    indirectAccess?: boolean;
    created?: Date | undefined;
    createdBy?: number | undefined;
    modified?: Date | undefined;
    modifiedBy?: number | undefined;
    documentLibNavigation?: DocumentLib | undefined;

    constructor(data?: IDocumentLibUser) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.documentLib = _data["documentLib"];
            this.role = _data["role"];
            this.user = _data["user"];
            this.active = _data["active"];
            this.owner = _data["owner"];
            this.allowEdit = _data["allowEdit"];
            this.allowCreate = _data["allowCreate"];
            this.allowDelete = _data["allowDelete"];
            this.indirectAccess = _data["indirectAccess"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : undefined as any;
            this.createdBy = _data["createdBy"];
            this.modified = _data["modified"] ? new Date(_data["modified"].toString()) : undefined as any;
            this.modifiedBy = _data["modifiedBy"];
            this.documentLibNavigation = _data["documentLibNavigation"] ? DocumentLib.fromJS(_data["documentLibNavigation"]) : undefined as any;
        }
    }

    static fromJS(data: any): DocumentLibUser {
        data = typeof data === 'object' ? data : {};
        let result = new DocumentLibUser();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["documentLib"] = this.documentLib;
        data["role"] = this.role;
        data["user"] = this.user;
        data["active"] = this.active;
        data["owner"] = this.owner;
        data["allowEdit"] = this.allowEdit;
        data["allowCreate"] = this.allowCreate;
        data["allowDelete"] = this.allowDelete;
        data["indirectAccess"] = this.indirectAccess;
        data["created"] = this.created ? this.created.toISOString() : undefined as any;
        data["createdBy"] = this.createdBy;
        data["modified"] = this.modified ? this.modified.toISOString() : undefined as any;
        data["modifiedBy"] = this.modifiedBy;
        data["documentLibNavigation"] = this.documentLibNavigation ? this.documentLibNavigation.toJSON() : undefined as any;
        return data;
    }
}

export interface IDocumentLibUser {
    id?: number;
    documentLib?: number;
    role?: number | undefined;
    user?: number | undefined;
    active?: boolean;
    owner?: boolean;
    allowEdit?: boolean;
    allowCreate?: boolean;
    allowDelete?: boolean;
    indirectAccess?: boolean;
    created?: Date | undefined;
    createdBy?: number | undefined;
    modified?: Date | undefined;
    modifiedBy?: number | undefined;
    documentLibNavigation?: DocumentLib | undefined;
}

export class FormRecognizerDocumentField implements IFormRecognizerDocumentField {
    id?: number;
    document?: number;
    field?: number;
    value?: string | undefined;
    created?: Date | undefined;
    createdBy?: number | undefined;
    modified?: Date | undefined;
    modifiedBy?: number | undefined;
    documentNavigation?: FormRecognizerDocument | undefined;
    fieldNavigation?: FormRecognizerFieldType | undefined;

    constructor(data?: IFormRecognizerDocumentField) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.document = _data["document"];
            this.field = _data["field"];
            this.value = _data["value"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : undefined as any;
            this.createdBy = _data["createdBy"];
            this.modified = _data["modified"] ? new Date(_data["modified"].toString()) : undefined as any;
            this.modifiedBy = _data["modifiedBy"];
            this.documentNavigation = _data["documentNavigation"] ? FormRecognizerDocument.fromJS(_data["documentNavigation"]) : undefined as any;
            this.fieldNavigation = _data["fieldNavigation"] ? FormRecognizerFieldType.fromJS(_data["fieldNavigation"]) : undefined as any;
        }
    }

    static fromJS(data: any): FormRecognizerDocumentField {
        data = typeof data === 'object' ? data : {};
        let result = new FormRecognizerDocumentField();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["document"] = this.document;
        data["field"] = this.field;
        data["value"] = this.value;
        data["created"] = this.created ? this.created.toISOString() : undefined as any;
        data["createdBy"] = this.createdBy;
        data["modified"] = this.modified ? this.modified.toISOString() : undefined as any;
        data["modifiedBy"] = this.modifiedBy;
        data["documentNavigation"] = this.documentNavigation ? this.documentNavigation.toJSON() : undefined as any;
        data["fieldNavigation"] = this.fieldNavigation ? this.fieldNavigation.toJSON() : undefined as any;
        return data;
    }
}

export interface IFormRecognizerDocumentField {
    id?: number;
    document?: number;
    field?: number;
    value?: string | undefined;
    created?: Date | undefined;
    createdBy?: number | undefined;
    modified?: Date | undefined;
    modifiedBy?: number | undefined;
    documentNavigation?: FormRecognizerDocument | undefined;
    fieldNavigation?: FormRecognizerFieldType | undefined;
}

export class FormRecognizerFieldType implements IFormRecognizerFieldType {
    id?: number;
    name!: string;
    created?: Date | undefined;
    createdBy?: number | undefined;
    modified?: Date | undefined;
    modifiedBy?: number | undefined;
    formRecognizerDocumentFields?: FormRecognizerDocumentField[] | undefined;
    formRecognizerFields?: FormRecognizerField[] | undefined;

    constructor(data?: IFormRecognizerFieldType) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : undefined as any;
            this.createdBy = _data["createdBy"];
            this.modified = _data["modified"] ? new Date(_data["modified"].toString()) : undefined as any;
            this.modifiedBy = _data["modifiedBy"];
            if (Array.isArray(_data["formRecognizerDocumentFields"])) {
                this.formRecognizerDocumentFields = [] as any;
                for (let item of _data["formRecognizerDocumentFields"])
                    this.formRecognizerDocumentFields!.push(FormRecognizerDocumentField.fromJS(item));
            }
            if (Array.isArray(_data["formRecognizerFields"])) {
                this.formRecognizerFields = [] as any;
                for (let item of _data["formRecognizerFields"])
                    this.formRecognizerFields!.push(FormRecognizerField.fromJS(item));
            }
        }
    }

    static fromJS(data: any): FormRecognizerFieldType {
        data = typeof data === 'object' ? data : {};
        let result = new FormRecognizerFieldType();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["created"] = this.created ? this.created.toISOString() : undefined as any;
        data["createdBy"] = this.createdBy;
        data["modified"] = this.modified ? this.modified.toISOString() : undefined as any;
        data["modifiedBy"] = this.modifiedBy;
        if (Array.isArray(this.formRecognizerDocumentFields)) {
            data["formRecognizerDocumentFields"] = [];
            for (let item of this.formRecognizerDocumentFields)
                data["formRecognizerDocumentFields"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.formRecognizerFields)) {
            data["formRecognizerFields"] = [];
            for (let item of this.formRecognizerFields)
                data["formRecognizerFields"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IFormRecognizerFieldType {
    id?: number;
    name: string;
    created?: Date | undefined;
    createdBy?: number | undefined;
    modified?: Date | undefined;
    modifiedBy?: number | undefined;
    formRecognizerDocumentFields?: FormRecognizerDocumentField[] | undefined;
    formRecognizerFields?: FormRecognizerField[] | undefined;
}

export class FormRecognizerField implements IFormRecognizerField {
    id?: number;
    formRecognizer?: number;
    type?: number;
    key?: string | undefined;
    value?: string | undefined;
    valueNext?: boolean;
    valueConstant?: boolean;
    keyValuePair?: boolean;
    replaceFrom?: string | undefined;
    replaceTo?: string | undefined;
    format?: string | undefined;
    culture?: string | undefined;
    created?: Date | undefined;
    createdBy?: number | undefined;
    modified?: Date | undefined;
    modifiedBy?: number | undefined;
    formRecognizerNavigation?: FormRecognizer | undefined;
    typeNavigation?: FormRecognizerFieldType | undefined;

    constructor(data?: IFormRecognizerField) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.formRecognizer = _data["formRecognizer"];
            this.type = _data["type"];
            this.key = _data["key"];
            this.value = _data["value"];
            this.valueNext = _data["valueNext"];
            this.valueConstant = _data["valueConstant"];
            this.keyValuePair = _data["keyValuePair"];
            this.replaceFrom = _data["replaceFrom"];
            this.replaceTo = _data["replaceTo"];
            this.format = _data["format"];
            this.culture = _data["culture"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : undefined as any;
            this.createdBy = _data["createdBy"];
            this.modified = _data["modified"] ? new Date(_data["modified"].toString()) : undefined as any;
            this.modifiedBy = _data["modifiedBy"];
            this.formRecognizerNavigation = _data["formRecognizerNavigation"] ? FormRecognizer.fromJS(_data["formRecognizerNavigation"]) : undefined as any;
            this.typeNavigation = _data["typeNavigation"] ? FormRecognizerFieldType.fromJS(_data["typeNavigation"]) : undefined as any;
        }
    }

    static fromJS(data: any): FormRecognizerField {
        data = typeof data === 'object' ? data : {};
        let result = new FormRecognizerField();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["formRecognizer"] = this.formRecognizer;
        data["type"] = this.type;
        data["key"] = this.key;
        data["value"] = this.value;
        data["valueNext"] = this.valueNext;
        data["valueConstant"] = this.valueConstant;
        data["keyValuePair"] = this.keyValuePair;
        data["replaceFrom"] = this.replaceFrom;
        data["replaceTo"] = this.replaceTo;
        data["format"] = this.format;
        data["culture"] = this.culture;
        data["created"] = this.created ? this.created.toISOString() : undefined as any;
        data["createdBy"] = this.createdBy;
        data["modified"] = this.modified ? this.modified.toISOString() : undefined as any;
        data["modifiedBy"] = this.modifiedBy;
        data["formRecognizerNavigation"] = this.formRecognizerNavigation ? this.formRecognizerNavigation.toJSON() : undefined as any;
        data["typeNavigation"] = this.typeNavigation ? this.typeNavigation.toJSON() : undefined as any;
        return data;
    }
}

export interface IFormRecognizerField {
    id?: number;
    formRecognizer?: number;
    type?: number;
    key?: string | undefined;
    value?: string | undefined;
    valueNext?: boolean;
    valueConstant?: boolean;
    keyValuePair?: boolean;
    replaceFrom?: string | undefined;
    replaceTo?: string | undefined;
    format?: string | undefined;
    culture?: string | undefined;
    created?: Date | undefined;
    createdBy?: number | undefined;
    modified?: Date | undefined;
    modifiedBy?: number | undefined;
    formRecognizerNavigation?: FormRecognizer | undefined;
    typeNavigation?: FormRecognizerFieldType | undefined;
}

export class FormRecognizerDocumentLine implements IFormRecognizerDocumentLine {
    id?: number;
    document?: number;
    lineNum?: number;
    postingType?: number;
    accountNum?: string | undefined;
    transDate?: Date | undefined;
    amountCur?: number | undefined;
    dueDate?: Date | undefined;
    dimension?: string | undefined;
    txt?: string | undefined;
    paymentRef?: string | undefined;
    created?: Date | undefined;
    createdBy?: number | undefined;
    modified?: Date | undefined;
    modifiedBy?: number | undefined;
    documentNavigation?: FormRecognizerDocument | undefined;

    constructor(data?: IFormRecognizerDocumentLine) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.document = _data["document"];
            this.lineNum = _data["lineNum"];
            this.postingType = _data["postingType"];
            this.accountNum = _data["accountNum"];
            this.transDate = _data["transDate"] ? new Date(_data["transDate"].toString()) : undefined as any;
            this.amountCur = _data["amountCur"];
            this.dueDate = _data["dueDate"] ? new Date(_data["dueDate"].toString()) : undefined as any;
            this.dimension = _data["dimension"];
            this.txt = _data["txt"];
            this.paymentRef = _data["paymentRef"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : undefined as any;
            this.createdBy = _data["createdBy"];
            this.modified = _data["modified"] ? new Date(_data["modified"].toString()) : undefined as any;
            this.modifiedBy = _data["modifiedBy"];
            this.documentNavigation = _data["documentNavigation"] ? FormRecognizerDocument.fromJS(_data["documentNavigation"]) : undefined as any;
        }
    }

    static fromJS(data: any): FormRecognizerDocumentLine {
        data = typeof data === 'object' ? data : {};
        let result = new FormRecognizerDocumentLine();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["document"] = this.document;
        data["lineNum"] = this.lineNum;
        data["postingType"] = this.postingType;
        data["accountNum"] = this.accountNum;
        data["transDate"] = this.transDate ? this.transDate.toISOString() : undefined as any;
        data["amountCur"] = this.amountCur;
        data["dueDate"] = this.dueDate ? this.dueDate.toISOString() : undefined as any;
        data["dimension"] = this.dimension;
        data["txt"] = this.txt;
        data["paymentRef"] = this.paymentRef;
        data["created"] = this.created ? this.created.toISOString() : undefined as any;
        data["createdBy"] = this.createdBy;
        data["modified"] = this.modified ? this.modified.toISOString() : undefined as any;
        data["modifiedBy"] = this.modifiedBy;
        data["documentNavigation"] = this.documentNavigation ? this.documentNavigation.toJSON() : undefined as any;
        return data;
    }
}

export interface IFormRecognizerDocumentLine {
    id?: number;
    document?: number;
    lineNum?: number;
    postingType?: number;
    accountNum?: string | undefined;
    transDate?: Date | undefined;
    amountCur?: number | undefined;
    dueDate?: Date | undefined;
    dimension?: string | undefined;
    txt?: string | undefined;
    paymentRef?: string | undefined;
    created?: Date | undefined;
    createdBy?: number | undefined;
    modified?: Date | undefined;
    modifiedBy?: number | undefined;
    documentNavigation?: FormRecognizerDocument | undefined;
}

export class VoucherMessageMailVendorHistory implements IVoucherMessageMailVendorHistory {
    id?: number;
    accountNum?: string | undefined;
    accountName?: string | undefined;
    fromEmail!: string;
    useCount?: number;
    created?: Date | undefined;
    modified?: Date | undefined;
    isDefault?: boolean;
    formRecognizer?: number | undefined;
    postingType?: number | undefined;
    createdBy?: number | undefined;
    modifiedBy?: number | undefined;
    voucherApprover?: number | undefined;
    formRecognizerNavigation?: FormRecognizer | undefined;
    voucherApproverNavigation?: User | undefined;

    constructor(data?: IVoucherMessageMailVendorHistory) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.accountNum = _data["accountNum"];
            this.accountName = _data["accountName"];
            this.fromEmail = _data["fromEmail"];
            this.useCount = _data["useCount"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : undefined as any;
            this.modified = _data["modified"] ? new Date(_data["modified"].toString()) : undefined as any;
            this.isDefault = _data["isDefault"];
            this.formRecognizer = _data["formRecognizer"];
            this.postingType = _data["postingType"];
            this.createdBy = _data["createdBy"];
            this.modifiedBy = _data["modifiedBy"];
            this.voucherApprover = _data["voucherApprover"];
            this.formRecognizerNavigation = _data["formRecognizerNavigation"] ? FormRecognizer.fromJS(_data["formRecognizerNavigation"]) : undefined as any;
            this.voucherApproverNavigation = _data["voucherApproverNavigation"] ? User.fromJS(_data["voucherApproverNavigation"]) : undefined as any;
        }
    }

    static fromJS(data: any): VoucherMessageMailVendorHistory {
        data = typeof data === 'object' ? data : {};
        let result = new VoucherMessageMailVendorHistory();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["accountNum"] = this.accountNum;
        data["accountName"] = this.accountName;
        data["fromEmail"] = this.fromEmail;
        data["useCount"] = this.useCount;
        data["created"] = this.created ? this.created.toISOString() : undefined as any;
        data["modified"] = this.modified ? this.modified.toISOString() : undefined as any;
        data["isDefault"] = this.isDefault;
        data["formRecognizer"] = this.formRecognizer;
        data["postingType"] = this.postingType;
        data["createdBy"] = this.createdBy;
        data["modifiedBy"] = this.modifiedBy;
        data["voucherApprover"] = this.voucherApprover;
        data["formRecognizerNavigation"] = this.formRecognizerNavigation ? this.formRecognizerNavigation.toJSON() : undefined as any;
        data["voucherApproverNavigation"] = this.voucherApproverNavigation ? this.voucherApproverNavigation.toJSON() : undefined as any;
        return data;
    }
}

export interface IVoucherMessageMailVendorHistory {
    id?: number;
    accountNum?: string | undefined;
    accountName?: string | undefined;
    fromEmail: string;
    useCount?: number;
    created?: Date | undefined;
    modified?: Date | undefined;
    isDefault?: boolean;
    formRecognizer?: number | undefined;
    postingType?: number | undefined;
    createdBy?: number | undefined;
    modifiedBy?: number | undefined;
    voucherApprover?: number | undefined;
    formRecognizerNavigation?: FormRecognizer | undefined;
    voucherApproverNavigation?: User | undefined;
}

export class VoucherMessageChannelType implements IVoucherMessageChannelType {
    id?: number;
    name!: string;
    active?: boolean;
    created?: Date | undefined;
    createdBy?: number | undefined;
    modified?: Date | undefined;
    modifiedBy?: number | undefined;
    voucherMessageChannels?: VoucherMessageChannel[] | undefined;

    constructor(data?: IVoucherMessageChannelType) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.active = _data["active"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : undefined as any;
            this.createdBy = _data["createdBy"];
            this.modified = _data["modified"] ? new Date(_data["modified"].toString()) : undefined as any;
            this.modifiedBy = _data["modifiedBy"];
            if (Array.isArray(_data["voucherMessageChannels"])) {
                this.voucherMessageChannels = [] as any;
                for (let item of _data["voucherMessageChannels"])
                    this.voucherMessageChannels!.push(VoucherMessageChannel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): VoucherMessageChannelType {
        data = typeof data === 'object' ? data : {};
        let result = new VoucherMessageChannelType();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["active"] = this.active;
        data["created"] = this.created ? this.created.toISOString() : undefined as any;
        data["createdBy"] = this.createdBy;
        data["modified"] = this.modified ? this.modified.toISOString() : undefined as any;
        data["modifiedBy"] = this.modifiedBy;
        if (Array.isArray(this.voucherMessageChannels)) {
            data["voucherMessageChannels"] = [];
            for (let item of this.voucherMessageChannels)
                data["voucherMessageChannels"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IVoucherMessageChannelType {
    id?: number;
    name: string;
    active?: boolean;
    created?: Date | undefined;
    createdBy?: number | undefined;
    modified?: Date | undefined;
    modifiedBy?: number | undefined;
    voucherMessageChannels?: VoucherMessageChannel[] | undefined;
}

export class VoucherApprovalStatus implements IVoucherApprovalStatus {
    id?: number;
    name!: string;
    created?: Date | undefined;
    createdBy?: number | undefined;
    modified?: Date | undefined;
    modifiedBy?: number | undefined;
    voucherMessageChannels?: VoucherMessageChannel[] | undefined;
    vouchers?: Voucher[] | undefined;

    constructor(data?: IVoucherApprovalStatus) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : undefined as any;
            this.createdBy = _data["createdBy"];
            this.modified = _data["modified"] ? new Date(_data["modified"].toString()) : undefined as any;
            this.modifiedBy = _data["modifiedBy"];
            if (Array.isArray(_data["voucherMessageChannels"])) {
                this.voucherMessageChannels = [] as any;
                for (let item of _data["voucherMessageChannels"])
                    this.voucherMessageChannels!.push(VoucherMessageChannel.fromJS(item));
            }
            if (Array.isArray(_data["vouchers"])) {
                this.vouchers = [] as any;
                for (let item of _data["vouchers"])
                    this.vouchers!.push(Voucher.fromJS(item));
            }
        }
    }

    static fromJS(data: any): VoucherApprovalStatus {
        data = typeof data === 'object' ? data : {};
        let result = new VoucherApprovalStatus();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["created"] = this.created ? this.created.toISOString() : undefined as any;
        data["createdBy"] = this.createdBy;
        data["modified"] = this.modified ? this.modified.toISOString() : undefined as any;
        data["modifiedBy"] = this.modifiedBy;
        if (Array.isArray(this.voucherMessageChannels)) {
            data["voucherMessageChannels"] = [];
            for (let item of this.voucherMessageChannels)
                data["voucherMessageChannels"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.vouchers)) {
            data["vouchers"] = [];
            for (let item of this.vouchers)
                data["vouchers"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IVoucherApprovalStatus {
    id?: number;
    name: string;
    created?: Date | undefined;
    createdBy?: number | undefined;
    modified?: Date | undefined;
    modifiedBy?: number | undefined;
    voucherMessageChannels?: VoucherMessageChannel[] | undefined;
    vouchers?: Voucher[] | undefined;
}

export class BankAccountTransactionSource implements IBankAccountTransactionSource {
    id?: number;
    name!: string;
    offsetAmount?: boolean | undefined;
    sourceGroup?: number | undefined;
    voucherMessageChannel?: number | undefined;
    created?: Date | undefined;
    createdBy?: number | undefined;
    modified?: Date | undefined;
    modifiedBy?: number | undefined;
    sourceGroupNavigation?: BankAccountTransactionSourceGroup | undefined;
    voucherMessageChannelNavigation?: VoucherMessageChannel | undefined;
    bankAccountSources?: BankAccountSource[] | undefined;
    bankAccountTransactions?: BankAccountTransaction[] | undefined;

    constructor(data?: IBankAccountTransactionSource) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.offsetAmount = _data["offsetAmount"];
            this.sourceGroup = _data["sourceGroup"];
            this.voucherMessageChannel = _data["voucherMessageChannel"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : undefined as any;
            this.createdBy = _data["createdBy"];
            this.modified = _data["modified"] ? new Date(_data["modified"].toString()) : undefined as any;
            this.modifiedBy = _data["modifiedBy"];
            this.sourceGroupNavigation = _data["sourceGroupNavigation"] ? BankAccountTransactionSourceGroup.fromJS(_data["sourceGroupNavigation"]) : undefined as any;
            this.voucherMessageChannelNavigation = _data["voucherMessageChannelNavigation"] ? VoucherMessageChannel.fromJS(_data["voucherMessageChannelNavigation"]) : undefined as any;
            if (Array.isArray(_data["bankAccountSources"])) {
                this.bankAccountSources = [] as any;
                for (let item of _data["bankAccountSources"])
                    this.bankAccountSources!.push(BankAccountSource.fromJS(item));
            }
            if (Array.isArray(_data["bankAccountTransactions"])) {
                this.bankAccountTransactions = [] as any;
                for (let item of _data["bankAccountTransactions"])
                    this.bankAccountTransactions!.push(BankAccountTransaction.fromJS(item));
            }
        }
    }

    static fromJS(data: any): BankAccountTransactionSource {
        data = typeof data === 'object' ? data : {};
        let result = new BankAccountTransactionSource();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["offsetAmount"] = this.offsetAmount;
        data["sourceGroup"] = this.sourceGroup;
        data["voucherMessageChannel"] = this.voucherMessageChannel;
        data["created"] = this.created ? this.created.toISOString() : undefined as any;
        data["createdBy"] = this.createdBy;
        data["modified"] = this.modified ? this.modified.toISOString() : undefined as any;
        data["modifiedBy"] = this.modifiedBy;
        data["sourceGroupNavigation"] = this.sourceGroupNavigation ? this.sourceGroupNavigation.toJSON() : undefined as any;
        data["voucherMessageChannelNavigation"] = this.voucherMessageChannelNavigation ? this.voucherMessageChannelNavigation.toJSON() : undefined as any;
        if (Array.isArray(this.bankAccountSources)) {
            data["bankAccountSources"] = [];
            for (let item of this.bankAccountSources)
                data["bankAccountSources"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.bankAccountTransactions)) {
            data["bankAccountTransactions"] = [];
            for (let item of this.bankAccountTransactions)
                data["bankAccountTransactions"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IBankAccountTransactionSource {
    id?: number;
    name: string;
    offsetAmount?: boolean | undefined;
    sourceGroup?: number | undefined;
    voucherMessageChannel?: number | undefined;
    created?: Date | undefined;
    createdBy?: number | undefined;
    modified?: Date | undefined;
    modifiedBy?: number | undefined;
    sourceGroupNavigation?: BankAccountTransactionSourceGroup | undefined;
    voucherMessageChannelNavigation?: VoucherMessageChannel | undefined;
    bankAccountSources?: BankAccountSource[] | undefined;
    bankAccountTransactions?: BankAccountTransaction[] | undefined;
}

export class BankAccountTransactionSourceGroup implements IBankAccountTransactionSourceGroup {
    id?: number;
    name!: string;
    sumOrder?: number | undefined;
    created?: Date | undefined;
    createdBy?: number | undefined;
    modified?: Date | undefined;
    modifiedBy?: number | undefined;
    bankAccountTransactionSources?: BankAccountTransactionSource[] | undefined;

    constructor(data?: IBankAccountTransactionSourceGroup) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.sumOrder = _data["sumOrder"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : undefined as any;
            this.createdBy = _data["createdBy"];
            this.modified = _data["modified"] ? new Date(_data["modified"].toString()) : undefined as any;
            this.modifiedBy = _data["modifiedBy"];
            if (Array.isArray(_data["bankAccountTransactionSources"])) {
                this.bankAccountTransactionSources = [] as any;
                for (let item of _data["bankAccountTransactionSources"])
                    this.bankAccountTransactionSources!.push(BankAccountTransactionSource.fromJS(item));
            }
        }
    }

    static fromJS(data: any): BankAccountTransactionSourceGroup {
        data = typeof data === 'object' ? data : {};
        let result = new BankAccountTransactionSourceGroup();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["sumOrder"] = this.sumOrder;
        data["created"] = this.created ? this.created.toISOString() : undefined as any;
        data["createdBy"] = this.createdBy;
        data["modified"] = this.modified ? this.modified.toISOString() : undefined as any;
        data["modifiedBy"] = this.modifiedBy;
        if (Array.isArray(this.bankAccountTransactionSources)) {
            data["bankAccountTransactionSources"] = [];
            for (let item of this.bankAccountTransactionSources)
                data["bankAccountTransactionSources"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IBankAccountTransactionSourceGroup {
    id?: number;
    name: string;
    sumOrder?: number | undefined;
    created?: Date | undefined;
    createdBy?: number | undefined;
    modified?: Date | undefined;
    modifiedBy?: number | undefined;
    bankAccountTransactionSources?: BankAccountTransactionSource[] | undefined;
}

export class BankAccountSource implements IBankAccountSource {
    id?: number;
    bankAccount?: number;
    source?: number;
    address?: string | undefined;
    active?: boolean;
    created?: Date | undefined;
    createdBy?: number | undefined;
    modified?: Date | undefined;
    modifiedBy?: number | undefined;
    bankAccountNavigation?: BankAccount | undefined;
    sourceNavigation?: BankAccountTransactionSource | undefined;

    constructor(data?: IBankAccountSource) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.bankAccount = _data["bankAccount"];
            this.source = _data["source"];
            this.address = _data["address"];
            this.active = _data["active"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : undefined as any;
            this.createdBy = _data["createdBy"];
            this.modified = _data["modified"] ? new Date(_data["modified"].toString()) : undefined as any;
            this.modifiedBy = _data["modifiedBy"];
            this.bankAccountNavigation = _data["bankAccountNavigation"] ? BankAccount.fromJS(_data["bankAccountNavigation"]) : undefined as any;
            this.sourceNavigation = _data["sourceNavigation"] ? BankAccountTransactionSource.fromJS(_data["sourceNavigation"]) : undefined as any;
        }
    }

    static fromJS(data: any): BankAccountSource {
        data = typeof data === 'object' ? data : {};
        let result = new BankAccountSource();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["bankAccount"] = this.bankAccount;
        data["source"] = this.source;
        data["address"] = this.address;
        data["active"] = this.active;
        data["created"] = this.created ? this.created.toISOString() : undefined as any;
        data["createdBy"] = this.createdBy;
        data["modified"] = this.modified ? this.modified.toISOString() : undefined as any;
        data["modifiedBy"] = this.modifiedBy;
        data["bankAccountNavigation"] = this.bankAccountNavigation ? this.bankAccountNavigation.toJSON() : undefined as any;
        data["sourceNavigation"] = this.sourceNavigation ? this.sourceNavigation.toJSON() : undefined as any;
        return data;
    }
}

export interface IBankAccountSource {
    id?: number;
    bankAccount?: number;
    source?: number;
    address?: string | undefined;
    active?: boolean;
    created?: Date | undefined;
    createdBy?: number | undefined;
    modified?: Date | undefined;
    modifiedBy?: number | undefined;
    bankAccountNavigation?: BankAccount | undefined;
    sourceNavigation?: BankAccountTransactionSource | undefined;
}

export class VoucherApprovalPolicy implements IVoucherApprovalPolicy {
    id?: number;
    name!: string;
    channel?: number;
    amountCur?: number;
    currency!: string;
    approvalCount?: number;
    active?: boolean;
    created?: Date | undefined;
    createdBy?: number | undefined;
    modified?: Date | undefined;
    modifiedBy?: number | undefined;
    channelNavigation?: VoucherMessageChannel | undefined;
    voucherApprovalPolicyUsers?: VoucherApprovalPolicyUser[] | undefined;
    voucherApprovals?: VoucherApproval[] | undefined;

    constructor(data?: IVoucherApprovalPolicy) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.channel = _data["channel"];
            this.amountCur = _data["amountCur"];
            this.currency = _data["currency"];
            this.approvalCount = _data["approvalCount"];
            this.active = _data["active"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : undefined as any;
            this.createdBy = _data["createdBy"];
            this.modified = _data["modified"] ? new Date(_data["modified"].toString()) : undefined as any;
            this.modifiedBy = _data["modifiedBy"];
            this.channelNavigation = _data["channelNavigation"] ? VoucherMessageChannel.fromJS(_data["channelNavigation"]) : undefined as any;
            if (Array.isArray(_data["voucherApprovalPolicyUsers"])) {
                this.voucherApprovalPolicyUsers = [] as any;
                for (let item of _data["voucherApprovalPolicyUsers"])
                    this.voucherApprovalPolicyUsers!.push(VoucherApprovalPolicyUser.fromJS(item));
            }
            if (Array.isArray(_data["voucherApprovals"])) {
                this.voucherApprovals = [] as any;
                for (let item of _data["voucherApprovals"])
                    this.voucherApprovals!.push(VoucherApproval.fromJS(item));
            }
        }
    }

    static fromJS(data: any): VoucherApprovalPolicy {
        data = typeof data === 'object' ? data : {};
        let result = new VoucherApprovalPolicy();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["channel"] = this.channel;
        data["amountCur"] = this.amountCur;
        data["currency"] = this.currency;
        data["approvalCount"] = this.approvalCount;
        data["active"] = this.active;
        data["created"] = this.created ? this.created.toISOString() : undefined as any;
        data["createdBy"] = this.createdBy;
        data["modified"] = this.modified ? this.modified.toISOString() : undefined as any;
        data["modifiedBy"] = this.modifiedBy;
        data["channelNavigation"] = this.channelNavigation ? this.channelNavigation.toJSON() : undefined as any;
        if (Array.isArray(this.voucherApprovalPolicyUsers)) {
            data["voucherApprovalPolicyUsers"] = [];
            for (let item of this.voucherApprovalPolicyUsers)
                data["voucherApprovalPolicyUsers"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.voucherApprovals)) {
            data["voucherApprovals"] = [];
            for (let item of this.voucherApprovals)
                data["voucherApprovals"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IVoucherApprovalPolicy {
    id?: number;
    name: string;
    channel?: number;
    amountCur?: number;
    currency: string;
    approvalCount?: number;
    active?: boolean;
    created?: Date | undefined;
    createdBy?: number | undefined;
    modified?: Date | undefined;
    modifiedBy?: number | undefined;
    channelNavigation?: VoucherMessageChannel | undefined;
    voucherApprovalPolicyUsers?: VoucherApprovalPolicyUser[] | undefined;
    voucherApprovals?: VoucherApproval[] | undefined;
}

export class VoucherApprovalPolicyUser implements IVoucherApprovalPolicyUser {
    id?: number;
    policy?: number;
    approver?: number;
    active?: boolean;
    priority?: number;
    created?: Date | undefined;
    createdBy?: number | undefined;
    modified?: Date | undefined;
    modifiedBy?: number | undefined;
    approverNavigation?: User | undefined;
    policyNavigation?: VoucherApprovalPolicy | undefined;

    constructor(data?: IVoucherApprovalPolicyUser) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.policy = _data["policy"];
            this.approver = _data["approver"];
            this.active = _data["active"];
            this.priority = _data["priority"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : undefined as any;
            this.createdBy = _data["createdBy"];
            this.modified = _data["modified"] ? new Date(_data["modified"].toString()) : undefined as any;
            this.modifiedBy = _data["modifiedBy"];
            this.approverNavigation = _data["approverNavigation"] ? User.fromJS(_data["approverNavigation"]) : undefined as any;
            this.policyNavigation = _data["policyNavigation"] ? VoucherApprovalPolicy.fromJS(_data["policyNavigation"]) : undefined as any;
        }
    }

    static fromJS(data: any): VoucherApprovalPolicyUser {
        data = typeof data === 'object' ? data : {};
        let result = new VoucherApprovalPolicyUser();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["policy"] = this.policy;
        data["approver"] = this.approver;
        data["active"] = this.active;
        data["priority"] = this.priority;
        data["created"] = this.created ? this.created.toISOString() : undefined as any;
        data["createdBy"] = this.createdBy;
        data["modified"] = this.modified ? this.modified.toISOString() : undefined as any;
        data["modifiedBy"] = this.modifiedBy;
        data["approverNavigation"] = this.approverNavigation ? this.approverNavigation.toJSON() : undefined as any;
        data["policyNavigation"] = this.policyNavigation ? this.policyNavigation.toJSON() : undefined as any;
        return data;
    }
}

export interface IVoucherApprovalPolicyUser {
    id?: number;
    policy?: number;
    approver?: number;
    active?: boolean;
    priority?: number;
    created?: Date | undefined;
    createdBy?: number | undefined;
    modified?: Date | undefined;
    modifiedBy?: number | undefined;
    approverNavigation?: User | undefined;
    policyNavigation?: VoucherApprovalPolicy | undefined;
}

export class VoucherApproval implements IVoucherApproval {
    id?: number;
    voucher?: number;
    policy?: number;
    approver?: number;
    approved?: boolean;
    created?: Date | undefined;
    createdBy?: number | undefined;
    modified?: Date | undefined;
    modifiedBy?: number | undefined;
    approverNavigation?: User | undefined;
    policyNavigation?: VoucherApprovalPolicy | undefined;
    voucherNavigation?: Voucher | undefined;

    constructor(data?: IVoucherApproval) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.voucher = _data["voucher"];
            this.policy = _data["policy"];
            this.approver = _data["approver"];
            this.approved = _data["approved"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : undefined as any;
            this.createdBy = _data["createdBy"];
            this.modified = _data["modified"] ? new Date(_data["modified"].toString()) : undefined as any;
            this.modifiedBy = _data["modifiedBy"];
            this.approverNavigation = _data["approverNavigation"] ? User.fromJS(_data["approverNavigation"]) : undefined as any;
            this.policyNavigation = _data["policyNavigation"] ? VoucherApprovalPolicy.fromJS(_data["policyNavigation"]) : undefined as any;
            this.voucherNavigation = _data["voucherNavigation"] ? Voucher.fromJS(_data["voucherNavigation"]) : undefined as any;
        }
    }

    static fromJS(data: any): VoucherApproval {
        data = typeof data === 'object' ? data : {};
        let result = new VoucherApproval();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["voucher"] = this.voucher;
        data["policy"] = this.policy;
        data["approver"] = this.approver;
        data["approved"] = this.approved;
        data["created"] = this.created ? this.created.toISOString() : undefined as any;
        data["createdBy"] = this.createdBy;
        data["modified"] = this.modified ? this.modified.toISOString() : undefined as any;
        data["modifiedBy"] = this.modifiedBy;
        data["approverNavigation"] = this.approverNavigation ? this.approverNavigation.toJSON() : undefined as any;
        data["policyNavigation"] = this.policyNavigation ? this.policyNavigation.toJSON() : undefined as any;
        data["voucherNavigation"] = this.voucherNavigation ? this.voucherNavigation.toJSON() : undefined as any;
        return data;
    }
}

export interface IVoucherApproval {
    id?: number;
    voucher?: number;
    policy?: number;
    approver?: number;
    approved?: boolean;
    created?: Date | undefined;
    createdBy?: number | undefined;
    modified?: Date | undefined;
    modifiedBy?: number | undefined;
    approverNavigation?: User | undefined;
    policyNavigation?: VoucherApprovalPolicy | undefined;
    voucherNavigation?: Voucher | undefined;
}

export class VoucherMessageChannelNextVoucher implements IVoucherMessageChannelNextVoucher {
    id?: number;
    channelId?: number;
    year?: number;
    maskVoucher!: string;
    nextVoucher?: number;
    created?: Date | undefined;
    createdBy?: number | undefined;
    modified?: Date | undefined;
    modifiedBy?: number | undefined;
    channel?: VoucherMessageChannel | undefined;

    constructor(data?: IVoucherMessageChannelNextVoucher) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.channelId = _data["channelId"];
            this.year = _data["year"];
            this.maskVoucher = _data["maskVoucher"];
            this.nextVoucher = _data["nextVoucher"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : undefined as any;
            this.createdBy = _data["createdBy"];
            this.modified = _data["modified"] ? new Date(_data["modified"].toString()) : undefined as any;
            this.modifiedBy = _data["modifiedBy"];
            this.channel = _data["channel"] ? VoucherMessageChannel.fromJS(_data["channel"]) : undefined as any;
        }
    }

    static fromJS(data: any): VoucherMessageChannelNextVoucher {
        data = typeof data === 'object' ? data : {};
        let result = new VoucherMessageChannelNextVoucher();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["channelId"] = this.channelId;
        data["year"] = this.year;
        data["maskVoucher"] = this.maskVoucher;
        data["nextVoucher"] = this.nextVoucher;
        data["created"] = this.created ? this.created.toISOString() : undefined as any;
        data["createdBy"] = this.createdBy;
        data["modified"] = this.modified ? this.modified.toISOString() : undefined as any;
        data["modifiedBy"] = this.modifiedBy;
        data["channel"] = this.channel ? this.channel.toJSON() : undefined as any;
        return data;
    }
}

export interface IVoucherMessageChannelNextVoucher {
    id?: number;
    channelId?: number;
    year?: number;
    maskVoucher: string;
    nextVoucher?: number;
    created?: Date | undefined;
    createdBy?: number | undefined;
    modified?: Date | undefined;
    modifiedBy?: number | undefined;
    channel?: VoucherMessageChannel | undefined;
}

export class VoucherMessageChannelUser implements IVoucherMessageChannelUser {
    id?: number;
    userId?: number;
    channelId?: number;
    primary?: boolean;
    admin?: boolean;
    ledgerJournalName?: string | undefined;
    created?: Date | undefined;
    createdBy?: number | undefined;
    modified?: Date | undefined;
    modifiedBy?: number | undefined;
    channel?: VoucherMessageChannel | undefined;
    user?: User | undefined;

    constructor(data?: IVoucherMessageChannelUser) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.userId = _data["userId"];
            this.channelId = _data["channelId"];
            this.primary = _data["primary"];
            this.admin = _data["admin"];
            this.ledgerJournalName = _data["ledgerJournalName"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : undefined as any;
            this.createdBy = _data["createdBy"];
            this.modified = _data["modified"] ? new Date(_data["modified"].toString()) : undefined as any;
            this.modifiedBy = _data["modifiedBy"];
            this.channel = _data["channel"] ? VoucherMessageChannel.fromJS(_data["channel"]) : undefined as any;
            this.user = _data["user"] ? User.fromJS(_data["user"]) : undefined as any;
        }
    }

    static fromJS(data: any): VoucherMessageChannelUser {
        data = typeof data === 'object' ? data : {};
        let result = new VoucherMessageChannelUser();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["userId"] = this.userId;
        data["channelId"] = this.channelId;
        data["primary"] = this.primary;
        data["admin"] = this.admin;
        data["ledgerJournalName"] = this.ledgerJournalName;
        data["created"] = this.created ? this.created.toISOString() : undefined as any;
        data["createdBy"] = this.createdBy;
        data["modified"] = this.modified ? this.modified.toISOString() : undefined as any;
        data["modifiedBy"] = this.modifiedBy;
        data["channel"] = this.channel ? this.channel.toJSON() : undefined as any;
        data["user"] = this.user ? this.user.toJSON() : undefined as any;
        return data;
    }
}

export interface IVoucherMessageChannelUser {
    id?: number;
    userId?: number;
    channelId?: number;
    primary?: boolean;
    admin?: boolean;
    ledgerJournalName?: string | undefined;
    created?: Date | undefined;
    createdBy?: number | undefined;
    modified?: Date | undefined;
    modifiedBy?: number | undefined;
    channel?: VoucherMessageChannel | undefined;
    user?: User | undefined;
}

export class VoucherMessageStatus implements IVoucherMessageStatus {
    id?: number;
    name!: string;
    created?: Date | undefined;
    createdBy?: number | undefined;
    modified?: Date | undefined;
    modifiedBy?: number | undefined;
    voucherMessages?: VoucherMessage[] | undefined;

    constructor(data?: IVoucherMessageStatus) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : undefined as any;
            this.createdBy = _data["createdBy"];
            this.modified = _data["modified"] ? new Date(_data["modified"].toString()) : undefined as any;
            this.modifiedBy = _data["modifiedBy"];
            if (Array.isArray(_data["voucherMessages"])) {
                this.voucherMessages = [] as any;
                for (let item of _data["voucherMessages"])
                    this.voucherMessages!.push(VoucherMessage.fromJS(item));
            }
        }
    }

    static fromJS(data: any): VoucherMessageStatus {
        data = typeof data === 'object' ? data : {};
        let result = new VoucherMessageStatus();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["created"] = this.created ? this.created.toISOString() : undefined as any;
        data["createdBy"] = this.createdBy;
        data["modified"] = this.modified ? this.modified.toISOString() : undefined as any;
        data["modifiedBy"] = this.modifiedBy;
        if (Array.isArray(this.voucherMessages)) {
            data["voucherMessages"] = [];
            for (let item of this.voucherMessages)
                data["voucherMessages"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IVoucherMessageStatus {
    id?: number;
    name: string;
    created?: Date | undefined;
    createdBy?: number | undefined;
    modified?: Date | undefined;
    modifiedBy?: number | undefined;
    voucherMessages?: VoucherMessage[] | undefined;
}

export class VoucherValidationStatus implements IVoucherValidationStatus {
    id?: number;
    name!: string;
    created?: Date | undefined;
    createdBy?: number | undefined;
    modified?: Date | undefined;
    modifiedBy?: number | undefined;
    voucherMessages?: VoucherMessage[] | undefined;

    constructor(data?: IVoucherValidationStatus) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : undefined as any;
            this.createdBy = _data["createdBy"];
            this.modified = _data["modified"] ? new Date(_data["modified"].toString()) : undefined as any;
            this.modifiedBy = _data["modifiedBy"];
            if (Array.isArray(_data["voucherMessages"])) {
                this.voucherMessages = [] as any;
                for (let item of _data["voucherMessages"])
                    this.voucherMessages!.push(VoucherMessage.fromJS(item));
            }
        }
    }

    static fromJS(data: any): VoucherValidationStatus {
        data = typeof data === 'object' ? data : {};
        let result = new VoucherValidationStatus();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["created"] = this.created ? this.created.toISOString() : undefined as any;
        data["createdBy"] = this.createdBy;
        data["modified"] = this.modified ? this.modified.toISOString() : undefined as any;
        data["modifiedBy"] = this.modifiedBy;
        if (Array.isArray(this.voucherMessages)) {
            data["voucherMessages"] = [];
            for (let item of this.voucherMessages)
                data["voucherMessages"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IVoucherValidationStatus {
    id?: number;
    name: string;
    created?: Date | undefined;
    createdBy?: number | undefined;
    modified?: Date | undefined;
    modifiedBy?: number | undefined;
    voucherMessages?: VoucherMessage[] | undefined;
}

export class VoucherMessageMail implements IVoucherMessageMail {
    id?: number;
    msgId?: number;
    created?: Date;
    fromEmail?: string | undefined;
    fromName?: string | undefined;
    toEmails?: string | undefined;
    toNames?: string | undefined;
    ccEmails?: string | undefined;
    ccNames?: string | undefined;
    subject!: string;
    webLink?: string | undefined;
    createdBy?: number | undefined;
    modified?: Date | undefined;
    modifiedBy?: number | undefined;
    msg?: VoucherMessage | undefined;

    constructor(data?: IVoucherMessageMail) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.msgId = _data["msgId"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : undefined as any;
            this.fromEmail = _data["fromEmail"];
            this.fromName = _data["fromName"];
            this.toEmails = _data["toEmails"];
            this.toNames = _data["toNames"];
            this.ccEmails = _data["ccEmails"];
            this.ccNames = _data["ccNames"];
            this.subject = _data["subject"];
            this.webLink = _data["webLink"];
            this.createdBy = _data["createdBy"];
            this.modified = _data["modified"] ? new Date(_data["modified"].toString()) : undefined as any;
            this.modifiedBy = _data["modifiedBy"];
            this.msg = _data["msg"] ? VoucherMessage.fromJS(_data["msg"]) : undefined as any;
        }
    }

    static fromJS(data: any): VoucherMessageMail {
        data = typeof data === 'object' ? data : {};
        let result = new VoucherMessageMail();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["msgId"] = this.msgId;
        data["created"] = this.created ? this.created.toISOString() : undefined as any;
        data["fromEmail"] = this.fromEmail;
        data["fromName"] = this.fromName;
        data["toEmails"] = this.toEmails;
        data["toNames"] = this.toNames;
        data["ccEmails"] = this.ccEmails;
        data["ccNames"] = this.ccNames;
        data["subject"] = this.subject;
        data["webLink"] = this.webLink;
        data["createdBy"] = this.createdBy;
        data["modified"] = this.modified ? this.modified.toISOString() : undefined as any;
        data["modifiedBy"] = this.modifiedBy;
        data["msg"] = this.msg ? this.msg.toJSON() : undefined as any;
        return data;
    }
}

export interface IVoucherMessageMail {
    id?: number;
    msgId?: number;
    created?: Date;
    fromEmail?: string | undefined;
    fromName?: string | undefined;
    toEmails?: string | undefined;
    toNames?: string | undefined;
    ccEmails?: string | undefined;
    ccNames?: string | undefined;
    subject: string;
    webLink?: string | undefined;
    createdBy?: number | undefined;
    modified?: Date | undefined;
    modifiedBy?: number | undefined;
    msg?: VoucherMessage | undefined;
}

export class VoucherPosting implements IVoucherPosting {
    id?: number;
    voucherId?: number;
    lineNum?: number | undefined;
    postingType?: number;
    accountNum?: string | undefined;
    transDate?: Date | undefined;
    amountCur?: number | undefined;
    amountCost?: number | undefined;
    dueDate?: Date | undefined;
    txt?: string | undefined;
    dimension?: string | undefined;
    projectCostGroup?: string | undefined;
    projectCostType?: string | undefined;
    projectLedgerNum?: string | undefined;
    paymentRef?: string | undefined;
    bankAccount?: string | undefined;
    bankSwift?: string | undefined;
    bankIban?: string | undefined;
    created?: Date | undefined;
    createdBy?: number | undefined;
    modified?: Date | undefined;
    modifiedBy?: number | undefined;
    accountDescription?: string | undefined;
    taxCode?: string | undefined;
    voucher?: Voucher | undefined;

    constructor(data?: IVoucherPosting) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.voucherId = _data["voucherId"];
            this.lineNum = _data["lineNum"];
            this.postingType = _data["postingType"];
            this.accountNum = _data["accountNum"];
            this.transDate = _data["transDate"] ? new Date(_data["transDate"].toString()) : undefined as any;
            this.amountCur = _data["amountCur"];
            this.amountCost = _data["amountCost"];
            this.dueDate = _data["dueDate"] ? new Date(_data["dueDate"].toString()) : undefined as any;
            this.txt = _data["txt"];
            this.dimension = _data["dimension"];
            this.projectCostGroup = _data["projectCostGroup"];
            this.projectCostType = _data["projectCostType"];
            this.projectLedgerNum = _data["projectLedgerNum"];
            this.paymentRef = _data["paymentRef"];
            this.bankAccount = _data["bankAccount"];
            this.bankSwift = _data["bankSwift"];
            this.bankIban = _data["bankIban"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : undefined as any;
            this.createdBy = _data["createdBy"];
            this.modified = _data["modified"] ? new Date(_data["modified"].toString()) : undefined as any;
            this.modifiedBy = _data["modifiedBy"];
            this.accountDescription = _data["accountDescription"];
            this.taxCode = _data["taxCode"];
            this.voucher = _data["voucher"] ? Voucher.fromJS(_data["voucher"]) : undefined as any;
        }
    }

    static fromJS(data: any): VoucherPosting {
        data = typeof data === 'object' ? data : {};
        let result = new VoucherPosting();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["voucherId"] = this.voucherId;
        data["lineNum"] = this.lineNum;
        data["postingType"] = this.postingType;
        data["accountNum"] = this.accountNum;
        data["transDate"] = this.transDate ? this.transDate.toISOString() : undefined as any;
        data["amountCur"] = this.amountCur;
        data["amountCost"] = this.amountCost;
        data["dueDate"] = this.dueDate ? this.dueDate.toISOString() : undefined as any;
        data["txt"] = this.txt;
        data["dimension"] = this.dimension;
        data["projectCostGroup"] = this.projectCostGroup;
        data["projectCostType"] = this.projectCostType;
        data["projectLedgerNum"] = this.projectLedgerNum;
        data["paymentRef"] = this.paymentRef;
        data["bankAccount"] = this.bankAccount;
        data["bankSwift"] = this.bankSwift;
        data["bankIban"] = this.bankIban;
        data["created"] = this.created ? this.created.toISOString() : undefined as any;
        data["createdBy"] = this.createdBy;
        data["modified"] = this.modified ? this.modified.toISOString() : undefined as any;
        data["modifiedBy"] = this.modifiedBy;
        data["accountDescription"] = this.accountDescription;
        data["taxCode"] = this.taxCode;
        data["voucher"] = this.voucher ? this.voucher.toJSON() : undefined as any;
        return data;
    }
}

export interface IVoucherPosting {
    id?: number;
    voucherId?: number;
    lineNum?: number | undefined;
    postingType?: number;
    accountNum?: string | undefined;
    transDate?: Date | undefined;
    amountCur?: number | undefined;
    amountCost?: number | undefined;
    dueDate?: Date | undefined;
    txt?: string | undefined;
    dimension?: string | undefined;
    projectCostGroup?: string | undefined;
    projectCostType?: string | undefined;
    projectLedgerNum?: string | undefined;
    paymentRef?: string | undefined;
    bankAccount?: string | undefined;
    bankSwift?: string | undefined;
    bankIban?: string | undefined;
    created?: Date | undefined;
    createdBy?: number | undefined;
    modified?: Date | undefined;
    modifiedBy?: number | undefined;
    accountDescription?: string | undefined;
    taxCode?: string | undefined;
    voucher?: Voucher | undefined;
}

export class VoucherPostingSale implements IVoucherPostingSale {
    id?: number;
    voucherId?: number;
    fromDate?: Date;
    toDate?: Date;
    isBOM?: boolean;
    created?: Date | undefined;
    createdBy?: number | undefined;
    modified?: Date | undefined;
    modifiedBy?: number | undefined;
    voucher?: Voucher | undefined;

    constructor(data?: IVoucherPostingSale) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.voucherId = _data["voucherId"];
            this.fromDate = _data["fromDate"] ? new Date(_data["fromDate"].toString()) : undefined as any;
            this.toDate = _data["toDate"] ? new Date(_data["toDate"].toString()) : undefined as any;
            this.isBOM = _data["isBOM"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : undefined as any;
            this.createdBy = _data["createdBy"];
            this.modified = _data["modified"] ? new Date(_data["modified"].toString()) : undefined as any;
            this.modifiedBy = _data["modifiedBy"];
            this.voucher = _data["voucher"] ? Voucher.fromJS(_data["voucher"]) : undefined as any;
        }
    }

    static fromJS(data: any): VoucherPostingSale {
        data = typeof data === 'object' ? data : {};
        let result = new VoucherPostingSale();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["voucherId"] = this.voucherId;
        data["fromDate"] = this.fromDate ? this.fromDate.toISOString() : undefined as any;
        data["toDate"] = this.toDate ? this.toDate.toISOString() : undefined as any;
        data["isBOM"] = this.isBOM;
        data["created"] = this.created ? this.created.toISOString() : undefined as any;
        data["createdBy"] = this.createdBy;
        data["modified"] = this.modified ? this.modified.toISOString() : undefined as any;
        data["modifiedBy"] = this.modifiedBy;
        data["voucher"] = this.voucher ? this.voucher.toJSON() : undefined as any;
        return data;
    }
}

export interface IVoucherPostingSale {
    id?: number;
    voucherId?: number;
    fromDate?: Date;
    toDate?: Date;
    isBOM?: boolean;
    created?: Date | undefined;
    createdBy?: number | undefined;
    modified?: Date | undefined;
    modifiedBy?: number | undefined;
    voucher?: Voucher | undefined;
}

export class BankAccountTransactionSourceBatch implements IBankAccountTransactionSourceBatch {
    id?: number;
    bankAccount?: number | undefined;
    source?: number;
    sourceId?: number | undefined;
    name?: string | undefined;
    batchDate?: Date;
    startBalance?: number | undefined;
    endBalance?: number | undefined;
    status?: number;
    created?: Date | undefined;
    createdBy?: number | undefined;
    modified?: Date | undefined;
    modifiedBy?: number | undefined;
    bankAccountNavigation?: BankAccount | undefined;
    statusNavigation?: BankAccountTransactionStatus | undefined;
    bankAccountTransactions?: BankAccountTransaction[] | undefined;

    constructor(data?: IBankAccountTransactionSourceBatch) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.bankAccount = _data["bankAccount"];
            this.source = _data["source"];
            this.sourceId = _data["sourceId"];
            this.name = _data["name"];
            this.batchDate = _data["batchDate"] ? new Date(_data["batchDate"].toString()) : undefined as any;
            this.startBalance = _data["startBalance"];
            this.endBalance = _data["endBalance"];
            this.status = _data["status"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : undefined as any;
            this.createdBy = _data["createdBy"];
            this.modified = _data["modified"] ? new Date(_data["modified"].toString()) : undefined as any;
            this.modifiedBy = _data["modifiedBy"];
            this.bankAccountNavigation = _data["bankAccountNavigation"] ? BankAccount.fromJS(_data["bankAccountNavigation"]) : undefined as any;
            this.statusNavigation = _data["statusNavigation"] ? BankAccountTransactionStatus.fromJS(_data["statusNavigation"]) : undefined as any;
            if (Array.isArray(_data["bankAccountTransactions"])) {
                this.bankAccountTransactions = [] as any;
                for (let item of _data["bankAccountTransactions"])
                    this.bankAccountTransactions!.push(BankAccountTransaction.fromJS(item));
            }
        }
    }

    static fromJS(data: any): BankAccountTransactionSourceBatch {
        data = typeof data === 'object' ? data : {};
        let result = new BankAccountTransactionSourceBatch();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["bankAccount"] = this.bankAccount;
        data["source"] = this.source;
        data["sourceId"] = this.sourceId;
        data["name"] = this.name;
        data["batchDate"] = this.batchDate ? this.batchDate.toISOString() : undefined as any;
        data["startBalance"] = this.startBalance;
        data["endBalance"] = this.endBalance;
        data["status"] = this.status;
        data["created"] = this.created ? this.created.toISOString() : undefined as any;
        data["createdBy"] = this.createdBy;
        data["modified"] = this.modified ? this.modified.toISOString() : undefined as any;
        data["modifiedBy"] = this.modifiedBy;
        data["bankAccountNavigation"] = this.bankAccountNavigation ? this.bankAccountNavigation.toJSON() : undefined as any;
        data["statusNavigation"] = this.statusNavigation ? this.statusNavigation.toJSON() : undefined as any;
        if (Array.isArray(this.bankAccountTransactions)) {
            data["bankAccountTransactions"] = [];
            for (let item of this.bankAccountTransactions)
                data["bankAccountTransactions"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IBankAccountTransactionSourceBatch {
    id?: number;
    bankAccount?: number | undefined;
    source?: number;
    sourceId?: number | undefined;
    name?: string | undefined;
    batchDate?: Date;
    startBalance?: number | undefined;
    endBalance?: number | undefined;
    status?: number;
    created?: Date | undefined;
    createdBy?: number | undefined;
    modified?: Date | undefined;
    modifiedBy?: number | undefined;
    bankAccountNavigation?: BankAccount | undefined;
    statusNavigation?: BankAccountTransactionStatus | undefined;
    bankAccountTransactions?: BankAccountTransaction[] | undefined;
}

export class BankAccountTransactionStatus implements IBankAccountTransactionStatus {
    id?: number;
    name!: string;
    created?: Date | undefined;
    createdBy?: number | undefined;
    modified?: Date | undefined;
    modifiedBy?: number | undefined;
    bankAccountSettlements?: BankAccountSettlement[] | undefined;
    bankAccountTransactions?: BankAccountTransaction[] | undefined;
    bankAccountTransactionSourceBatches?: BankAccountTransactionSourceBatch[] | undefined;

    constructor(data?: IBankAccountTransactionStatus) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : undefined as any;
            this.createdBy = _data["createdBy"];
            this.modified = _data["modified"] ? new Date(_data["modified"].toString()) : undefined as any;
            this.modifiedBy = _data["modifiedBy"];
            if (Array.isArray(_data["bankAccountSettlements"])) {
                this.bankAccountSettlements = [] as any;
                for (let item of _data["bankAccountSettlements"])
                    this.bankAccountSettlements!.push(BankAccountSettlement.fromJS(item));
            }
            if (Array.isArray(_data["bankAccountTransactions"])) {
                this.bankAccountTransactions = [] as any;
                for (let item of _data["bankAccountTransactions"])
                    this.bankAccountTransactions!.push(BankAccountTransaction.fromJS(item));
            }
            if (Array.isArray(_data["bankAccountTransactionSourceBatches"])) {
                this.bankAccountTransactionSourceBatches = [] as any;
                for (let item of _data["bankAccountTransactionSourceBatches"])
                    this.bankAccountTransactionSourceBatches!.push(BankAccountTransactionSourceBatch.fromJS(item));
            }
        }
    }

    static fromJS(data: any): BankAccountTransactionStatus {
        data = typeof data === 'object' ? data : {};
        let result = new BankAccountTransactionStatus();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["created"] = this.created ? this.created.toISOString() : undefined as any;
        data["createdBy"] = this.createdBy;
        data["modified"] = this.modified ? this.modified.toISOString() : undefined as any;
        data["modifiedBy"] = this.modifiedBy;
        if (Array.isArray(this.bankAccountSettlements)) {
            data["bankAccountSettlements"] = [];
            for (let item of this.bankAccountSettlements)
                data["bankAccountSettlements"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.bankAccountTransactions)) {
            data["bankAccountTransactions"] = [];
            for (let item of this.bankAccountTransactions)
                data["bankAccountTransactions"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.bankAccountTransactionSourceBatches)) {
            data["bankAccountTransactionSourceBatches"] = [];
            for (let item of this.bankAccountTransactionSourceBatches)
                data["bankAccountTransactionSourceBatches"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IBankAccountTransactionStatus {
    id?: number;
    name: string;
    created?: Date | undefined;
    createdBy?: number | undefined;
    modified?: Date | undefined;
    modifiedBy?: number | undefined;
    bankAccountSettlements?: BankAccountSettlement[] | undefined;
    bankAccountTransactions?: BankAccountTransaction[] | undefined;
    bankAccountTransactionSourceBatches?: BankAccountTransactionSourceBatch[] | undefined;
}

export class BankAccountSettlement implements IBankAccountSettlement {
    id?: number;
    bankAccount?: number;
    settlementDate?: Date;
    status?: number;
    created?: Date | undefined;
    createdBy?: number | undefined;
    modified?: Date | undefined;
    modifiedBy?: number | undefined;
    bankAccountNavigation?: BankAccount | undefined;
    statusNavigation?: BankAccountTransactionStatus | undefined;
    bankAccountTransactionSettles?: BankAccountTransactionSettle[] | undefined;

    constructor(data?: IBankAccountSettlement) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.bankAccount = _data["bankAccount"];
            this.settlementDate = _data["settlementDate"] ? new Date(_data["settlementDate"].toString()) : undefined as any;
            this.status = _data["status"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : undefined as any;
            this.createdBy = _data["createdBy"];
            this.modified = _data["modified"] ? new Date(_data["modified"].toString()) : undefined as any;
            this.modifiedBy = _data["modifiedBy"];
            this.bankAccountNavigation = _data["bankAccountNavigation"] ? BankAccount.fromJS(_data["bankAccountNavigation"]) : undefined as any;
            this.statusNavigation = _data["statusNavigation"] ? BankAccountTransactionStatus.fromJS(_data["statusNavigation"]) : undefined as any;
            if (Array.isArray(_data["bankAccountTransactionSettles"])) {
                this.bankAccountTransactionSettles = [] as any;
                for (let item of _data["bankAccountTransactionSettles"])
                    this.bankAccountTransactionSettles!.push(BankAccountTransactionSettle.fromJS(item));
            }
        }
    }

    static fromJS(data: any): BankAccountSettlement {
        data = typeof data === 'object' ? data : {};
        let result = new BankAccountSettlement();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["bankAccount"] = this.bankAccount;
        data["settlementDate"] = this.settlementDate ? this.settlementDate.toISOString() : undefined as any;
        data["status"] = this.status;
        data["created"] = this.created ? this.created.toISOString() : undefined as any;
        data["createdBy"] = this.createdBy;
        data["modified"] = this.modified ? this.modified.toISOString() : undefined as any;
        data["modifiedBy"] = this.modifiedBy;
        data["bankAccountNavigation"] = this.bankAccountNavigation ? this.bankAccountNavigation.toJSON() : undefined as any;
        data["statusNavigation"] = this.statusNavigation ? this.statusNavigation.toJSON() : undefined as any;
        if (Array.isArray(this.bankAccountTransactionSettles)) {
            data["bankAccountTransactionSettles"] = [];
            for (let item of this.bankAccountTransactionSettles)
                data["bankAccountTransactionSettles"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IBankAccountSettlement {
    id?: number;
    bankAccount?: number;
    settlementDate?: Date;
    status?: number;
    created?: Date | undefined;
    createdBy?: number | undefined;
    modified?: Date | undefined;
    modifiedBy?: number | undefined;
    bankAccountNavigation?: BankAccount | undefined;
    statusNavigation?: BankAccountTransactionStatus | undefined;
    bankAccountTransactionSettles?: BankAccountTransactionSettle[] | undefined;
}

export class BankAccountTransactionSettle implements IBankAccountTransactionSettle {
    id?: number;
    settlement?: number;
    transaction?: number;
    created?: Date | undefined;
    createdBy?: number | undefined;
    modified?: Date | undefined;
    modifiedBy?: number | undefined;
    settlementNavigation?: BankAccountSettlement | undefined;
    transactionNavigation?: BankAccountTransaction | undefined;

    constructor(data?: IBankAccountTransactionSettle) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.settlement = _data["settlement"];
            this.transaction = _data["transaction"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : undefined as any;
            this.createdBy = _data["createdBy"];
            this.modified = _data["modified"] ? new Date(_data["modified"].toString()) : undefined as any;
            this.modifiedBy = _data["modifiedBy"];
            this.settlementNavigation = _data["settlementNavigation"] ? BankAccountSettlement.fromJS(_data["settlementNavigation"]) : undefined as any;
            this.transactionNavigation = _data["transactionNavigation"] ? BankAccountTransaction.fromJS(_data["transactionNavigation"]) : undefined as any;
        }
    }

    static fromJS(data: any): BankAccountTransactionSettle {
        data = typeof data === 'object' ? data : {};
        let result = new BankAccountTransactionSettle();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["settlement"] = this.settlement;
        data["transaction"] = this.transaction;
        data["created"] = this.created ? this.created.toISOString() : undefined as any;
        data["createdBy"] = this.createdBy;
        data["modified"] = this.modified ? this.modified.toISOString() : undefined as any;
        data["modifiedBy"] = this.modifiedBy;
        data["settlementNavigation"] = this.settlementNavigation ? this.settlementNavigation.toJSON() : undefined as any;
        data["transactionNavigation"] = this.transactionNavigation ? this.transactionNavigation.toJSON() : undefined as any;
        return data;
    }
}

export interface IBankAccountTransactionSettle {
    id?: number;
    settlement?: number;
    transaction?: number;
    created?: Date | undefined;
    createdBy?: number | undefined;
    modified?: Date | undefined;
    modifiedBy?: number | undefined;
    settlementNavigation?: BankAccountSettlement | undefined;
    transactionNavigation?: BankAccountTransaction | undefined;
}

export class VoucherRequest implements IVoucherRequest {
    id?: number;
    description!: string;
    responsible?: number;
    amountCur?: number | undefined;
    currency?: number | undefined;
    transDate?: Date | undefined;
    bankTransaction?: number | undefined;
    notified?: boolean | undefined;
    completed?: boolean | undefined;
    created?: Date | undefined;
    createdBy?: number | undefined;
    modified?: Date | undefined;
    modifiedBy?: number | undefined;
    bankTransactionNavigation?: BankAccountTransaction | undefined;
    responsibleNavigation?: User | undefined;

    constructor(data?: IVoucherRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.description = _data["description"];
            this.responsible = _data["responsible"];
            this.amountCur = _data["amountCur"];
            this.currency = _data["currency"];
            this.transDate = _data["transDate"] ? new Date(_data["transDate"].toString()) : undefined as any;
            this.bankTransaction = _data["bankTransaction"];
            this.notified = _data["notified"];
            this.completed = _data["completed"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : undefined as any;
            this.createdBy = _data["createdBy"];
            this.modified = _data["modified"] ? new Date(_data["modified"].toString()) : undefined as any;
            this.modifiedBy = _data["modifiedBy"];
            this.bankTransactionNavigation = _data["bankTransactionNavigation"] ? BankAccountTransaction.fromJS(_data["bankTransactionNavigation"]) : undefined as any;
            this.responsibleNavigation = _data["responsibleNavigation"] ? User.fromJS(_data["responsibleNavigation"]) : undefined as any;
        }
    }

    static fromJS(data: any): VoucherRequest {
        data = typeof data === 'object' ? data : {};
        let result = new VoucherRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["description"] = this.description;
        data["responsible"] = this.responsible;
        data["amountCur"] = this.amountCur;
        data["currency"] = this.currency;
        data["transDate"] = this.transDate ? this.transDate.toISOString() : undefined as any;
        data["bankTransaction"] = this.bankTransaction;
        data["notified"] = this.notified;
        data["completed"] = this.completed;
        data["created"] = this.created ? this.created.toISOString() : undefined as any;
        data["createdBy"] = this.createdBy;
        data["modified"] = this.modified ? this.modified.toISOString() : undefined as any;
        data["modifiedBy"] = this.modifiedBy;
        data["bankTransactionNavigation"] = this.bankTransactionNavigation ? this.bankTransactionNavigation.toJSON() : undefined as any;
        data["responsibleNavigation"] = this.responsibleNavigation ? this.responsibleNavigation.toJSON() : undefined as any;
        return data;
    }
}

export interface IVoucherRequest {
    id?: number;
    description: string;
    responsible?: number;
    amountCur?: number | undefined;
    currency?: number | undefined;
    transDate?: Date | undefined;
    bankTransaction?: number | undefined;
    notified?: boolean | undefined;
    completed?: boolean | undefined;
    created?: Date | undefined;
    createdBy?: number | undefined;
    modified?: Date | undefined;
    modifiedBy?: number | undefined;
    bankTransactionNavigation?: BankAccountTransaction | undefined;
    responsibleNavigation?: User | undefined;
}

export class ChatUser implements IChatUser {
    id?: number;
    chatId?: number;
    userId?: number;
    isNotified?: boolean | undefined;
    isRead?: boolean;
    created?: Date | undefined;
    createdBy?: number | undefined;
    modified?: Date | undefined;
    modifiedBy?: number | undefined;
    chat?: Chat | undefined;
    user?: User | undefined;

    constructor(data?: IChatUser) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.chatId = _data["chatId"];
            this.userId = _data["userId"];
            this.isNotified = _data["isNotified"];
            this.isRead = _data["isRead"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : undefined as any;
            this.createdBy = _data["createdBy"];
            this.modified = _data["modified"] ? new Date(_data["modified"].toString()) : undefined as any;
            this.modifiedBy = _data["modifiedBy"];
            this.chat = _data["chat"] ? Chat.fromJS(_data["chat"]) : undefined as any;
            this.user = _data["user"] ? User.fromJS(_data["user"]) : undefined as any;
        }
    }

    static fromJS(data: any): ChatUser {
        data = typeof data === 'object' ? data : {};
        let result = new ChatUser();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["chatId"] = this.chatId;
        data["userId"] = this.userId;
        data["isNotified"] = this.isNotified;
        data["isRead"] = this.isRead;
        data["created"] = this.created ? this.created.toISOString() : undefined as any;
        data["createdBy"] = this.createdBy;
        data["modified"] = this.modified ? this.modified.toISOString() : undefined as any;
        data["modifiedBy"] = this.modifiedBy;
        data["chat"] = this.chat ? this.chat.toJSON() : undefined as any;
        data["user"] = this.user ? this.user.toJSON() : undefined as any;
        return data;
    }
}

export interface IChatUser {
    id?: number;
    chatId?: number;
    userId?: number;
    isNotified?: boolean | undefined;
    isRead?: boolean;
    created?: Date | undefined;
    createdBy?: number | undefined;
    modified?: Date | undefined;
    modifiedBy?: number | undefined;
    chat?: Chat | undefined;
    user?: User | undefined;
}

export class Chat implements IChat {
    id?: number;
    refTableId?: number;
    refRowId?: number;
    txt!: string;
    isPrivate?: boolean;
    created?: Date | undefined;
    createdBy?: number | undefined;
    modified?: Date | undefined;
    modifiedBy?: number | undefined;
    chatUsers?: ChatUser[] | undefined;

    constructor(data?: IChat) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.refTableId = _data["refTableId"];
            this.refRowId = _data["refRowId"];
            this.txt = _data["txt"];
            this.isPrivate = _data["isPrivate"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : undefined as any;
            this.createdBy = _data["createdBy"];
            this.modified = _data["modified"] ? new Date(_data["modified"].toString()) : undefined as any;
            this.modifiedBy = _data["modifiedBy"];
            if (Array.isArray(_data["chatUsers"])) {
                this.chatUsers = [] as any;
                for (let item of _data["chatUsers"])
                    this.chatUsers!.push(ChatUser.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Chat {
        data = typeof data === 'object' ? data : {};
        let result = new Chat();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["refTableId"] = this.refTableId;
        data["refRowId"] = this.refRowId;
        data["txt"] = this.txt;
        data["isPrivate"] = this.isPrivate;
        data["created"] = this.created ? this.created.toISOString() : undefined as any;
        data["createdBy"] = this.createdBy;
        data["modified"] = this.modified ? this.modified.toISOString() : undefined as any;
        data["modifiedBy"] = this.modifiedBy;
        if (Array.isArray(this.chatUsers)) {
            data["chatUsers"] = [];
            for (let item of this.chatUsers)
                data["chatUsers"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IChat {
    id?: number;
    refTableId?: number;
    refRowId?: number;
    txt: string;
    isPrivate?: boolean;
    created?: Date | undefined;
    createdBy?: number | undefined;
    modified?: Date | undefined;
    modifiedBy?: number | undefined;
    chatUsers?: ChatUser[] | undefined;
}

export class ContractSale implements IContractSale {
    id?: number;
    num?: string | undefined;
    name!: string;
    scope!: string;
    documentLibPath?: string | undefined;
    responsible?: number;
    counterParty?: string | undefined;
    counterPartyContact?: string | undefined;
    agentParty?: string | undefined;
    authors?: string | undefined;
    illustrators?: string | undefined;
    legacyId?: number | undefined;
    closed?: Date | undefined;
    closedBy?: number | undefined;
    deleted?: Date | undefined;
    deletedBy?: number | undefined;
    created?: Date | undefined;
    createdBy?: number | undefined;
    modified?: Date | undefined;
    modifiedBy?: number | undefined;
    agentPartyNavigation?: Party | undefined;
    counterPartyNavigation?: Party | undefined;
    responsibleNavigation?: User | undefined;

    constructor(data?: IContractSale) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.num = _data["num"];
            this.name = _data["name"];
            this.scope = _data["scope"];
            this.documentLibPath = _data["documentLibPath"];
            this.responsible = _data["responsible"];
            this.counterParty = _data["counterParty"];
            this.counterPartyContact = _data["counterPartyContact"];
            this.agentParty = _data["agentParty"];
            this.authors = _data["authors"];
            this.illustrators = _data["illustrators"];
            this.legacyId = _data["legacyId"];
            this.closed = _data["closed"] ? new Date(_data["closed"].toString()) : undefined as any;
            this.closedBy = _data["closedBy"];
            this.deleted = _data["deleted"] ? new Date(_data["deleted"].toString()) : undefined as any;
            this.deletedBy = _data["deletedBy"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : undefined as any;
            this.createdBy = _data["createdBy"];
            this.modified = _data["modified"] ? new Date(_data["modified"].toString()) : undefined as any;
            this.modifiedBy = _data["modifiedBy"];
            this.agentPartyNavigation = _data["agentPartyNavigation"] ? Party.fromJS(_data["agentPartyNavigation"]) : undefined as any;
            this.counterPartyNavigation = _data["counterPartyNavigation"] ? Party.fromJS(_data["counterPartyNavigation"]) : undefined as any;
            this.responsibleNavigation = _data["responsibleNavigation"] ? User.fromJS(_data["responsibleNavigation"]) : undefined as any;
        }
    }

    static fromJS(data: any): ContractSale {
        data = typeof data === 'object' ? data : {};
        let result = new ContractSale();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["num"] = this.num;
        data["name"] = this.name;
        data["scope"] = this.scope;
        data["documentLibPath"] = this.documentLibPath;
        data["responsible"] = this.responsible;
        data["counterParty"] = this.counterParty;
        data["counterPartyContact"] = this.counterPartyContact;
        data["agentParty"] = this.agentParty;
        data["authors"] = this.authors;
        data["illustrators"] = this.illustrators;
        data["legacyId"] = this.legacyId;
        data["closed"] = this.closed ? this.closed.toISOString() : undefined as any;
        data["closedBy"] = this.closedBy;
        data["deleted"] = this.deleted ? this.deleted.toISOString() : undefined as any;
        data["deletedBy"] = this.deletedBy;
        data["created"] = this.created ? this.created.toISOString() : undefined as any;
        data["createdBy"] = this.createdBy;
        data["modified"] = this.modified ? this.modified.toISOString() : undefined as any;
        data["modifiedBy"] = this.modifiedBy;
        data["agentPartyNavigation"] = this.agentPartyNavigation ? this.agentPartyNavigation.toJSON() : undefined as any;
        data["counterPartyNavigation"] = this.counterPartyNavigation ? this.counterPartyNavigation.toJSON() : undefined as any;
        data["responsibleNavigation"] = this.responsibleNavigation ? this.responsibleNavigation.toJSON() : undefined as any;
        return data;
    }
}

export interface IContractSale {
    id?: number;
    num?: string | undefined;
    name: string;
    scope: string;
    documentLibPath?: string | undefined;
    responsible?: number;
    counterParty?: string | undefined;
    counterPartyContact?: string | undefined;
    agentParty?: string | undefined;
    authors?: string | undefined;
    illustrators?: string | undefined;
    legacyId?: number | undefined;
    closed?: Date | undefined;
    closedBy?: number | undefined;
    deleted?: Date | undefined;
    deletedBy?: number | undefined;
    created?: Date | undefined;
    createdBy?: number | undefined;
    modified?: Date | undefined;
    modifiedBy?: number | undefined;
    agentPartyNavigation?: Party | undefined;
    counterPartyNavigation?: Party | undefined;
    responsibleNavigation?: User | undefined;
}

export class ProductSeries implements IProductSeries {
    id?: number;
    num?: string | undefined;
    name?: string | undefined;
    author?: string | undefined;
    responsible?: number | undefined;
    group?: string | undefined;
    theme?: string | undefined;
    description?: string | undefined;
    closed?: Date | undefined;
    closedBy?: number | undefined;
    created?: Date | undefined;
    createdBy?: number | undefined;
    modified?: Date | undefined;
    modifiedBy?: number | undefined;
    groupNavigation?: ProductGroup | undefined;
    responsibleNavigation?: User | undefined;
    themeNavigation?: ProductTheme | undefined;

    constructor(data?: IProductSeries) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.num = _data["num"];
            this.name = _data["name"];
            this.author = _data["author"];
            this.responsible = _data["responsible"];
            this.group = _data["group"];
            this.theme = _data["theme"];
            this.description = _data["description"];
            this.closed = _data["closed"] ? new Date(_data["closed"].toString()) : undefined as any;
            this.closedBy = _data["closedBy"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : undefined as any;
            this.createdBy = _data["createdBy"];
            this.modified = _data["modified"] ? new Date(_data["modified"].toString()) : undefined as any;
            this.modifiedBy = _data["modifiedBy"];
            this.groupNavigation = _data["groupNavigation"] ? ProductGroup.fromJS(_data["groupNavigation"]) : undefined as any;
            this.responsibleNavigation = _data["responsibleNavigation"] ? User.fromJS(_data["responsibleNavigation"]) : undefined as any;
            this.themeNavigation = _data["themeNavigation"] ? ProductTheme.fromJS(_data["themeNavigation"]) : undefined as any;
        }
    }

    static fromJS(data: any): ProductSeries {
        data = typeof data === 'object' ? data : {};
        let result = new ProductSeries();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["num"] = this.num;
        data["name"] = this.name;
        data["author"] = this.author;
        data["responsible"] = this.responsible;
        data["group"] = this.group;
        data["theme"] = this.theme;
        data["description"] = this.description;
        data["closed"] = this.closed ? this.closed.toISOString() : undefined as any;
        data["closedBy"] = this.closedBy;
        data["created"] = this.created ? this.created.toISOString() : undefined as any;
        data["createdBy"] = this.createdBy;
        data["modified"] = this.modified ? this.modified.toISOString() : undefined as any;
        data["modifiedBy"] = this.modifiedBy;
        data["groupNavigation"] = this.groupNavigation ? this.groupNavigation.toJSON() : undefined as any;
        data["responsibleNavigation"] = this.responsibleNavigation ? this.responsibleNavigation.toJSON() : undefined as any;
        data["themeNavigation"] = this.themeNavigation ? this.themeNavigation.toJSON() : undefined as any;
        return data;
    }
}

export interface IProductSeries {
    id?: number;
    num?: string | undefined;
    name?: string | undefined;
    author?: string | undefined;
    responsible?: number | undefined;
    group?: string | undefined;
    theme?: string | undefined;
    description?: string | undefined;
    closed?: Date | undefined;
    closedBy?: number | undefined;
    created?: Date | undefined;
    createdBy?: number | undefined;
    modified?: Date | undefined;
    modifiedBy?: number | undefined;
    groupNavigation?: ProductGroup | undefined;
    responsibleNavigation?: User | undefined;
    themeNavigation?: ProductTheme | undefined;
}

export class ProductGroup implements IProductGroup {
    id?: number;
    num?: string | undefined;
    name!: string;
    sorting?: number | undefined;
    created?: Date | undefined;
    createdBy?: number | undefined;
    modified?: Date | undefined;
    modifiedBy?: number | undefined;
    search!: string;
    products?: Product[] | undefined;
    productSeries?: ProductSeries[] | undefined;

    constructor(data?: IProductGroup) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.num = _data["num"];
            this.name = _data["name"];
            this.sorting = _data["sorting"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : undefined as any;
            this.createdBy = _data["createdBy"];
            this.modified = _data["modified"] ? new Date(_data["modified"].toString()) : undefined as any;
            this.modifiedBy = _data["modifiedBy"];
            this.search = _data["search"];
            if (Array.isArray(_data["products"])) {
                this.products = [] as any;
                for (let item of _data["products"])
                    this.products!.push(Product.fromJS(item));
            }
            if (Array.isArray(_data["productSeries"])) {
                this.productSeries = [] as any;
                for (let item of _data["productSeries"])
                    this.productSeries!.push(ProductSeries.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ProductGroup {
        data = typeof data === 'object' ? data : {};
        let result = new ProductGroup();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["num"] = this.num;
        data["name"] = this.name;
        data["sorting"] = this.sorting;
        data["created"] = this.created ? this.created.toISOString() : undefined as any;
        data["createdBy"] = this.createdBy;
        data["modified"] = this.modified ? this.modified.toISOString() : undefined as any;
        data["modifiedBy"] = this.modifiedBy;
        data["search"] = this.search;
        if (Array.isArray(this.products)) {
            data["products"] = [];
            for (let item of this.products)
                data["products"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.productSeries)) {
            data["productSeries"] = [];
            for (let item of this.productSeries)
                data["productSeries"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IProductGroup {
    id?: number;
    num?: string | undefined;
    name: string;
    sorting?: number | undefined;
    created?: Date | undefined;
    createdBy?: number | undefined;
    modified?: Date | undefined;
    modifiedBy?: number | undefined;
    search: string;
    products?: Product[] | undefined;
    productSeries?: ProductSeries[] | undefined;
}

export class ProductTheme implements IProductTheme {
    id?: number;
    num?: string | undefined;
    name!: string;
    description?: string | undefined;
    parentNum?: string | undefined;
    createdRev?: string | undefined;
    modifiedRev?: string | undefined;
    created?: Date | undefined;
    createdBy?: number | undefined;
    modified?: Date | undefined;
    modifiedBy?: number | undefined;
    search!: string;
    productSeries?: ProductSeries[] | undefined;

    constructor(data?: IProductTheme) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.num = _data["num"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.parentNum = _data["parentNum"];
            this.createdRev = _data["createdRev"];
            this.modifiedRev = _data["modifiedRev"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : undefined as any;
            this.createdBy = _data["createdBy"];
            this.modified = _data["modified"] ? new Date(_data["modified"].toString()) : undefined as any;
            this.modifiedBy = _data["modifiedBy"];
            this.search = _data["search"];
            if (Array.isArray(_data["productSeries"])) {
                this.productSeries = [] as any;
                for (let item of _data["productSeries"])
                    this.productSeries!.push(ProductSeries.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ProductTheme {
        data = typeof data === 'object' ? data : {};
        let result = new ProductTheme();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["num"] = this.num;
        data["name"] = this.name;
        data["description"] = this.description;
        data["parentNum"] = this.parentNum;
        data["createdRev"] = this.createdRev;
        data["modifiedRev"] = this.modifiedRev;
        data["created"] = this.created ? this.created.toISOString() : undefined as any;
        data["createdBy"] = this.createdBy;
        data["modified"] = this.modified ? this.modified.toISOString() : undefined as any;
        data["modifiedBy"] = this.modifiedBy;
        data["search"] = this.search;
        if (Array.isArray(this.productSeries)) {
            data["productSeries"] = [];
            for (let item of this.productSeries)
                data["productSeries"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IProductTheme {
    id?: number;
    num?: string | undefined;
    name: string;
    description?: string | undefined;
    parentNum?: string | undefined;
    createdRev?: string | undefined;
    modifiedRev?: string | undefined;
    created?: Date | undefined;
    createdBy?: number | undefined;
    modified?: Date | undefined;
    modifiedBy?: number | undefined;
    search: string;
    productSeries?: ProductSeries[] | undefined;
}

export class ProjectTask implements IProjectTask {
    id?: number;
    projectNode?: number;
    name!: string;
    type!: string;
    product?: string | undefined;
    status!: string;
    responsibleTeam?: string | undefined;
    responsibleUser?: string | undefined;
    description?: string | undefined;
    document?: string | undefined;
    created?: Date | undefined;
    createdBy?: number | undefined;
    modified?: Date | undefined;
    modifiedBy?: number | undefined;
    projectNodeNavigation?: ProjectNode | undefined;
    responsibleTeamNavigation?: Team | undefined;
    responsibleUserNavigation?: User | undefined;
    statusNavigation?: ProjectTaskStatus | undefined;
    typeNavigation?: ProjectTaskType | undefined;
    projectTaskContacts?: ProjectTaskContact[] | undefined;

    constructor(data?: IProjectTask) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.projectNode = _data["projectNode"];
            this.name = _data["name"];
            this.type = _data["type"];
            this.product = _data["product"];
            this.status = _data["status"];
            this.responsibleTeam = _data["responsibleTeam"];
            this.responsibleUser = _data["responsibleUser"];
            this.description = _data["description"];
            this.document = _data["document"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : undefined as any;
            this.createdBy = _data["createdBy"];
            this.modified = _data["modified"] ? new Date(_data["modified"].toString()) : undefined as any;
            this.modifiedBy = _data["modifiedBy"];
            this.projectNodeNavigation = _data["projectNodeNavigation"] ? ProjectNode.fromJS(_data["projectNodeNavigation"]) : undefined as any;
            this.responsibleTeamNavigation = _data["responsibleTeamNavigation"] ? Team.fromJS(_data["responsibleTeamNavigation"]) : undefined as any;
            this.responsibleUserNavigation = _data["responsibleUserNavigation"] ? User.fromJS(_data["responsibleUserNavigation"]) : undefined as any;
            this.statusNavigation = _data["statusNavigation"] ? ProjectTaskStatus.fromJS(_data["statusNavigation"]) : undefined as any;
            this.typeNavigation = _data["typeNavigation"] ? ProjectTaskType.fromJS(_data["typeNavigation"]) : undefined as any;
            if (Array.isArray(_data["projectTaskContacts"])) {
                this.projectTaskContacts = [] as any;
                for (let item of _data["projectTaskContacts"])
                    this.projectTaskContacts!.push(ProjectTaskContact.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ProjectTask {
        data = typeof data === 'object' ? data : {};
        let result = new ProjectTask();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["projectNode"] = this.projectNode;
        data["name"] = this.name;
        data["type"] = this.type;
        data["product"] = this.product;
        data["status"] = this.status;
        data["responsibleTeam"] = this.responsibleTeam;
        data["responsibleUser"] = this.responsibleUser;
        data["description"] = this.description;
        data["document"] = this.document;
        data["created"] = this.created ? this.created.toISOString() : undefined as any;
        data["createdBy"] = this.createdBy;
        data["modified"] = this.modified ? this.modified.toISOString() : undefined as any;
        data["modifiedBy"] = this.modifiedBy;
        data["projectNodeNavigation"] = this.projectNodeNavigation ? this.projectNodeNavigation.toJSON() : undefined as any;
        data["responsibleTeamNavigation"] = this.responsibleTeamNavigation ? this.responsibleTeamNavigation.toJSON() : undefined as any;
        data["responsibleUserNavigation"] = this.responsibleUserNavigation ? this.responsibleUserNavigation.toJSON() : undefined as any;
        data["statusNavigation"] = this.statusNavigation ? this.statusNavigation.toJSON() : undefined as any;
        data["typeNavigation"] = this.typeNavigation ? this.typeNavigation.toJSON() : undefined as any;
        if (Array.isArray(this.projectTaskContacts)) {
            data["projectTaskContacts"] = [];
            for (let item of this.projectTaskContacts)
                data["projectTaskContacts"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IProjectTask {
    id?: number;
    projectNode?: number;
    name: string;
    type: string;
    product?: string | undefined;
    status: string;
    responsibleTeam?: string | undefined;
    responsibleUser?: string | undefined;
    description?: string | undefined;
    document?: string | undefined;
    created?: Date | undefined;
    createdBy?: number | undefined;
    modified?: Date | undefined;
    modifiedBy?: number | undefined;
    projectNodeNavigation?: ProjectNode | undefined;
    responsibleTeamNavigation?: Team | undefined;
    responsibleUserNavigation?: User | undefined;
    statusNavigation?: ProjectTaskStatus | undefined;
    typeNavigation?: ProjectTaskType | undefined;
    projectTaskContacts?: ProjectTaskContact[] | undefined;
}

export class ProjectTaskStatus implements IProjectTaskStatus {
    id?: number;
    num?: string | undefined;
    name!: string;
    isClosed?: boolean;
    created?: Date | undefined;
    createdBy?: number | undefined;
    modified?: Date | undefined;
    modifiedBy?: number | undefined;
    projectNodes?: ProjectNode[] | undefined;
    projectTaskContacts?: ProjectTaskContact[] | undefined;
    projectTasks?: ProjectTask[] | undefined;

    constructor(data?: IProjectTaskStatus) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.num = _data["num"];
            this.name = _data["name"];
            this.isClosed = _data["isClosed"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : undefined as any;
            this.createdBy = _data["createdBy"];
            this.modified = _data["modified"] ? new Date(_data["modified"].toString()) : undefined as any;
            this.modifiedBy = _data["modifiedBy"];
            if (Array.isArray(_data["projectNodes"])) {
                this.projectNodes = [] as any;
                for (let item of _data["projectNodes"])
                    this.projectNodes!.push(ProjectNode.fromJS(item));
            }
            if (Array.isArray(_data["projectTaskContacts"])) {
                this.projectTaskContacts = [] as any;
                for (let item of _data["projectTaskContacts"])
                    this.projectTaskContacts!.push(ProjectTaskContact.fromJS(item));
            }
            if (Array.isArray(_data["projectTasks"])) {
                this.projectTasks = [] as any;
                for (let item of _data["projectTasks"])
                    this.projectTasks!.push(ProjectTask.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ProjectTaskStatus {
        data = typeof data === 'object' ? data : {};
        let result = new ProjectTaskStatus();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["num"] = this.num;
        data["name"] = this.name;
        data["isClosed"] = this.isClosed;
        data["created"] = this.created ? this.created.toISOString() : undefined as any;
        data["createdBy"] = this.createdBy;
        data["modified"] = this.modified ? this.modified.toISOString() : undefined as any;
        data["modifiedBy"] = this.modifiedBy;
        if (Array.isArray(this.projectNodes)) {
            data["projectNodes"] = [];
            for (let item of this.projectNodes)
                data["projectNodes"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.projectTaskContacts)) {
            data["projectTaskContacts"] = [];
            for (let item of this.projectTaskContacts)
                data["projectTaskContacts"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.projectTasks)) {
            data["projectTasks"] = [];
            for (let item of this.projectTasks)
                data["projectTasks"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IProjectTaskStatus {
    id?: number;
    num?: string | undefined;
    name: string;
    isClosed?: boolean;
    created?: Date | undefined;
    createdBy?: number | undefined;
    modified?: Date | undefined;
    modifiedBy?: number | undefined;
    projectNodes?: ProjectNode[] | undefined;
    projectTaskContacts?: ProjectTaskContact[] | undefined;
    projectTasks?: ProjectTask[] | undefined;
}

export class ProjectTaskType implements IProjectTaskType {
    id?: number;
    num?: string | undefined;
    name!: string;
    status?: string | undefined;
    responsibleTeam?: string | undefined;
    responsibleUser?: string | undefined;
    product?: boolean;
    productRoles?: boolean;
    created?: Date | undefined;
    createdBy?: number | undefined;
    modified?: Date | undefined;
    modifiedBy?: number | undefined;
    responsibleTeamNavigation?: Team | undefined;
    responsibleUserNavigation?: User | undefined;
    projectNodes?: ProjectNode[] | undefined;
    projectTasks?: ProjectTask[] | undefined;

    constructor(data?: IProjectTaskType) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.num = _data["num"];
            this.name = _data["name"];
            this.status = _data["status"];
            this.responsibleTeam = _data["responsibleTeam"];
            this.responsibleUser = _data["responsibleUser"];
            this.product = _data["product"];
            this.productRoles = _data["productRoles"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : undefined as any;
            this.createdBy = _data["createdBy"];
            this.modified = _data["modified"] ? new Date(_data["modified"].toString()) : undefined as any;
            this.modifiedBy = _data["modifiedBy"];
            this.responsibleTeamNavigation = _data["responsibleTeamNavigation"] ? Team.fromJS(_data["responsibleTeamNavigation"]) : undefined as any;
            this.responsibleUserNavigation = _data["responsibleUserNavigation"] ? User.fromJS(_data["responsibleUserNavigation"]) : undefined as any;
            if (Array.isArray(_data["projectNodes"])) {
                this.projectNodes = [] as any;
                for (let item of _data["projectNodes"])
                    this.projectNodes!.push(ProjectNode.fromJS(item));
            }
            if (Array.isArray(_data["projectTasks"])) {
                this.projectTasks = [] as any;
                for (let item of _data["projectTasks"])
                    this.projectTasks!.push(ProjectTask.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ProjectTaskType {
        data = typeof data === 'object' ? data : {};
        let result = new ProjectTaskType();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["num"] = this.num;
        data["name"] = this.name;
        data["status"] = this.status;
        data["responsibleTeam"] = this.responsibleTeam;
        data["responsibleUser"] = this.responsibleUser;
        data["product"] = this.product;
        data["productRoles"] = this.productRoles;
        data["created"] = this.created ? this.created.toISOString() : undefined as any;
        data["createdBy"] = this.createdBy;
        data["modified"] = this.modified ? this.modified.toISOString() : undefined as any;
        data["modifiedBy"] = this.modifiedBy;
        data["responsibleTeamNavigation"] = this.responsibleTeamNavigation ? this.responsibleTeamNavigation.toJSON() : undefined as any;
        data["responsibleUserNavigation"] = this.responsibleUserNavigation ? this.responsibleUserNavigation.toJSON() : undefined as any;
        if (Array.isArray(this.projectNodes)) {
            data["projectNodes"] = [];
            for (let item of this.projectNodes)
                data["projectNodes"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.projectTasks)) {
            data["projectTasks"] = [];
            for (let item of this.projectTasks)
                data["projectTasks"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IProjectTaskType {
    id?: number;
    num?: string | undefined;
    name: string;
    status?: string | undefined;
    responsibleTeam?: string | undefined;
    responsibleUser?: string | undefined;
    product?: boolean;
    productRoles?: boolean;
    created?: Date | undefined;
    createdBy?: number | undefined;
    modified?: Date | undefined;
    modifiedBy?: number | undefined;
    responsibleTeamNavigation?: Team | undefined;
    responsibleUserNavigation?: User | undefined;
    projectNodes?: ProjectNode[] | undefined;
    projectTasks?: ProjectTask[] | undefined;
}

export class RightsApproval implements IRightsApproval {
    id?: number;
    period?: number;
    approver?: number;
    approvalStatus?: number;
    closeStatus?: number;
    vendorNum?: string | undefined;
    description!: string;
    folder!: string;
    fileName!: string;
    created?: Date;
    createdBy?: number;
    modified?: Date;
    modifiedBy?: number;
    approvalStatusNavigation?: RightsApprovalStatus | undefined;
    approverNavigation?: User | undefined;
    closeStatusNavigation?: RightsCloseStatus | undefined;
    periodNavigation?: RightsPeriod | undefined;

    constructor(data?: IRightsApproval) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.period = _data["period"];
            this.approver = _data["approver"];
            this.approvalStatus = _data["approvalStatus"];
            this.closeStatus = _data["closeStatus"];
            this.vendorNum = _data["vendorNum"];
            this.description = _data["description"];
            this.folder = _data["folder"];
            this.fileName = _data["fileName"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : undefined as any;
            this.createdBy = _data["createdBy"];
            this.modified = _data["modified"] ? new Date(_data["modified"].toString()) : undefined as any;
            this.modifiedBy = _data["modifiedBy"];
            this.approvalStatusNavigation = _data["approvalStatusNavigation"] ? RightsApprovalStatus.fromJS(_data["approvalStatusNavigation"]) : undefined as any;
            this.approverNavigation = _data["approverNavigation"] ? User.fromJS(_data["approverNavigation"]) : undefined as any;
            this.closeStatusNavigation = _data["closeStatusNavigation"] ? RightsCloseStatus.fromJS(_data["closeStatusNavigation"]) : undefined as any;
            this.periodNavigation = _data["periodNavigation"] ? RightsPeriod.fromJS(_data["periodNavigation"]) : undefined as any;
        }
    }

    static fromJS(data: any): RightsApproval {
        data = typeof data === 'object' ? data : {};
        let result = new RightsApproval();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["period"] = this.period;
        data["approver"] = this.approver;
        data["approvalStatus"] = this.approvalStatus;
        data["closeStatus"] = this.closeStatus;
        data["vendorNum"] = this.vendorNum;
        data["description"] = this.description;
        data["folder"] = this.folder;
        data["fileName"] = this.fileName;
        data["created"] = this.created ? this.created.toISOString() : undefined as any;
        data["createdBy"] = this.createdBy;
        data["modified"] = this.modified ? this.modified.toISOString() : undefined as any;
        data["modifiedBy"] = this.modifiedBy;
        data["approvalStatusNavigation"] = this.approvalStatusNavigation ? this.approvalStatusNavigation.toJSON() : undefined as any;
        data["approverNavigation"] = this.approverNavigation ? this.approverNavigation.toJSON() : undefined as any;
        data["closeStatusNavigation"] = this.closeStatusNavigation ? this.closeStatusNavigation.toJSON() : undefined as any;
        data["periodNavigation"] = this.periodNavigation ? this.periodNavigation.toJSON() : undefined as any;
        return data;
    }
}

export interface IRightsApproval {
    id?: number;
    period?: number;
    approver?: number;
    approvalStatus?: number;
    closeStatus?: number;
    vendorNum?: string | undefined;
    description: string;
    folder: string;
    fileName: string;
    created?: Date;
    createdBy?: number;
    modified?: Date;
    modifiedBy?: number;
    approvalStatusNavigation?: RightsApprovalStatus | undefined;
    approverNavigation?: User | undefined;
    closeStatusNavigation?: RightsCloseStatus | undefined;
    periodNavigation?: RightsPeriod | undefined;
}

export class RightsApprovalStatus implements IRightsApprovalStatus {
    id?: number;
    name!: string;
    created?: Date | undefined;
    createdBy?: number | undefined;
    modified?: Date | undefined;
    modifiedBy?: number | undefined;
    rightsApprovals?: RightsApproval[] | undefined;

    constructor(data?: IRightsApprovalStatus) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : undefined as any;
            this.createdBy = _data["createdBy"];
            this.modified = _data["modified"] ? new Date(_data["modified"].toString()) : undefined as any;
            this.modifiedBy = _data["modifiedBy"];
            if (Array.isArray(_data["rightsApprovals"])) {
                this.rightsApprovals = [] as any;
                for (let item of _data["rightsApprovals"])
                    this.rightsApprovals!.push(RightsApproval.fromJS(item));
            }
        }
    }

    static fromJS(data: any): RightsApprovalStatus {
        data = typeof data === 'object' ? data : {};
        let result = new RightsApprovalStatus();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["created"] = this.created ? this.created.toISOString() : undefined as any;
        data["createdBy"] = this.createdBy;
        data["modified"] = this.modified ? this.modified.toISOString() : undefined as any;
        data["modifiedBy"] = this.modifiedBy;
        if (Array.isArray(this.rightsApprovals)) {
            data["rightsApprovals"] = [];
            for (let item of this.rightsApprovals)
                data["rightsApprovals"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IRightsApprovalStatus {
    id?: number;
    name: string;
    created?: Date | undefined;
    createdBy?: number | undefined;
    modified?: Date | undefined;
    modifiedBy?: number | undefined;
    rightsApprovals?: RightsApproval[] | undefined;
}

export class RightsCloseStatus implements IRightsCloseStatus {
    id?: number;
    name!: string;
    created?: Date | undefined;
    createdBy?: number | undefined;
    modified?: Date | undefined;
    modifiedBy?: number | undefined;
    rightsApprovals?: RightsApproval[] | undefined;

    constructor(data?: IRightsCloseStatus) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : undefined as any;
            this.createdBy = _data["createdBy"];
            this.modified = _data["modified"] ? new Date(_data["modified"].toString()) : undefined as any;
            this.modifiedBy = _data["modifiedBy"];
            if (Array.isArray(_data["rightsApprovals"])) {
                this.rightsApprovals = [] as any;
                for (let item of _data["rightsApprovals"])
                    this.rightsApprovals!.push(RightsApproval.fromJS(item));
            }
        }
    }

    static fromJS(data: any): RightsCloseStatus {
        data = typeof data === 'object' ? data : {};
        let result = new RightsCloseStatus();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["created"] = this.created ? this.created.toISOString() : undefined as any;
        data["createdBy"] = this.createdBy;
        data["modified"] = this.modified ? this.modified.toISOString() : undefined as any;
        data["modifiedBy"] = this.modifiedBy;
        if (Array.isArray(this.rightsApprovals)) {
            data["rightsApprovals"] = [];
            for (let item of this.rightsApprovals)
                data["rightsApprovals"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IRightsCloseStatus {
    id?: number;
    name: string;
    created?: Date | undefined;
    createdBy?: number | undefined;
    modified?: Date | undefined;
    modifiedBy?: number | undefined;
    rightsApprovals?: RightsApproval[] | undefined;
}

export class RightsPeriod implements IRightsPeriod {
    id?: number;
    name!: string;
    path!: string;
    active?: boolean;
    created?: Date | undefined;
    createdBy?: number | undefined;
    modified?: Date | undefined;
    modifiedBy?: number | undefined;
    rightsApprovals?: RightsApproval[] | undefined;

    constructor(data?: IRightsPeriod) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.path = _data["path"];
            this.active = _data["active"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : undefined as any;
            this.createdBy = _data["createdBy"];
            this.modified = _data["modified"] ? new Date(_data["modified"].toString()) : undefined as any;
            this.modifiedBy = _data["modifiedBy"];
            if (Array.isArray(_data["rightsApprovals"])) {
                this.rightsApprovals = [] as any;
                for (let item of _data["rightsApprovals"])
                    this.rightsApprovals!.push(RightsApproval.fromJS(item));
            }
        }
    }

    static fromJS(data: any): RightsPeriod {
        data = typeof data === 'object' ? data : {};
        let result = new RightsPeriod();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["path"] = this.path;
        data["active"] = this.active;
        data["created"] = this.created ? this.created.toISOString() : undefined as any;
        data["createdBy"] = this.createdBy;
        data["modified"] = this.modified ? this.modified.toISOString() : undefined as any;
        data["modifiedBy"] = this.modifiedBy;
        if (Array.isArray(this.rightsApprovals)) {
            data["rightsApprovals"] = [];
            for (let item of this.rightsApprovals)
                data["rightsApprovals"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IRightsPeriod {
    id?: number;
    name: string;
    path: string;
    active?: boolean;
    created?: Date | undefined;
    createdBy?: number | undefined;
    modified?: Date | undefined;
    modifiedBy?: number | undefined;
    rightsApprovals?: RightsApproval[] | undefined;
}

export class TeamUser implements ITeamUser {
    id?: number;
    team!: string;
    user!: string;
    isActive?: boolean;
    created?: Date | undefined;
    createdBy?: number | undefined;
    modified?: Date | undefined;
    modifiedBy?: number | undefined;
    teamNavigation?: Team | undefined;
    userNavigation?: User | undefined;

    constructor(data?: ITeamUser) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.team = _data["team"];
            this.user = _data["user"];
            this.isActive = _data["isActive"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : undefined as any;
            this.createdBy = _data["createdBy"];
            this.modified = _data["modified"] ? new Date(_data["modified"].toString()) : undefined as any;
            this.modifiedBy = _data["modifiedBy"];
            this.teamNavigation = _data["teamNavigation"] ? Team.fromJS(_data["teamNavigation"]) : undefined as any;
            this.userNavigation = _data["userNavigation"] ? User.fromJS(_data["userNavigation"]) : undefined as any;
        }
    }

    static fromJS(data: any): TeamUser {
        data = typeof data === 'object' ? data : {};
        let result = new TeamUser();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["team"] = this.team;
        data["user"] = this.user;
        data["isActive"] = this.isActive;
        data["created"] = this.created ? this.created.toISOString() : undefined as any;
        data["createdBy"] = this.createdBy;
        data["modified"] = this.modified ? this.modified.toISOString() : undefined as any;
        data["modifiedBy"] = this.modifiedBy;
        data["teamNavigation"] = this.teamNavigation ? this.teamNavigation.toJSON() : undefined as any;
        data["userNavigation"] = this.userNavigation ? this.userNavigation.toJSON() : undefined as any;
        return data;
    }
}

export interface ITeamUser {
    id?: number;
    team: string;
    user: string;
    isActive?: boolean;
    created?: Date | undefined;
    createdBy?: number | undefined;
    modified?: Date | undefined;
    modifiedBy?: number | undefined;
    teamNavigation?: Team | undefined;
    userNavigation?: User | undefined;
}

export class UserApprovalDelegation implements IUserApprovalDelegation {
    id?: number;
    user?: number;
    userDelegatee?: number;
    isActive?: boolean;
    fromDate?: Date | undefined;
    toDate?: Date | undefined;
    reason!: string;
    created?: Date | undefined;
    createdBy?: number | undefined;
    modified?: Date | undefined;
    modifiedBy?: number | undefined;
    userDelegateeNavigation?: User | undefined;
    userNavigation?: User | undefined;

    constructor(data?: IUserApprovalDelegation) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.user = _data["user"];
            this.userDelegatee = _data["userDelegatee"];
            this.isActive = _data["isActive"];
            this.fromDate = _data["fromDate"] ? new Date(_data["fromDate"].toString()) : undefined as any;
            this.toDate = _data["toDate"] ? new Date(_data["toDate"].toString()) : undefined as any;
            this.reason = _data["reason"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : undefined as any;
            this.createdBy = _data["createdBy"];
            this.modified = _data["modified"] ? new Date(_data["modified"].toString()) : undefined as any;
            this.modifiedBy = _data["modifiedBy"];
            this.userDelegateeNavigation = _data["userDelegateeNavigation"] ? User.fromJS(_data["userDelegateeNavigation"]) : undefined as any;
            this.userNavigation = _data["userNavigation"] ? User.fromJS(_data["userNavigation"]) : undefined as any;
        }
    }

    static fromJS(data: any): UserApprovalDelegation {
        data = typeof data === 'object' ? data : {};
        let result = new UserApprovalDelegation();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["user"] = this.user;
        data["userDelegatee"] = this.userDelegatee;
        data["isActive"] = this.isActive;
        data["fromDate"] = this.fromDate ? this.fromDate.toISOString() : undefined as any;
        data["toDate"] = this.toDate ? this.toDate.toISOString() : undefined as any;
        data["reason"] = this.reason;
        data["created"] = this.created ? this.created.toISOString() : undefined as any;
        data["createdBy"] = this.createdBy;
        data["modified"] = this.modified ? this.modified.toISOString() : undefined as any;
        data["modifiedBy"] = this.modifiedBy;
        data["userDelegateeNavigation"] = this.userDelegateeNavigation ? this.userDelegateeNavigation.toJSON() : undefined as any;
        data["userNavigation"] = this.userNavigation ? this.userNavigation.toJSON() : undefined as any;
        return data;
    }
}

export interface IUserApprovalDelegation {
    id?: number;
    user?: number;
    userDelegatee?: number;
    isActive?: boolean;
    fromDate?: Date | undefined;
    toDate?: Date | undefined;
    reason: string;
    created?: Date | undefined;
    createdBy?: number | undefined;
    modified?: Date | undefined;
    modifiedBy?: number | undefined;
    userDelegateeNavigation?: User | undefined;
    userNavigation?: User | undefined;
}

export class PartyContact implements IPartyContact {
    id?: number;
    party!: string;
    partyContactType!: string;
    address!: string;
    created?: Date | undefined;
    createdBy?: number | undefined;
    modified?: Date | undefined;
    modifiedBy?: number | undefined;
    partyContactTypeNavigation?: PartyContactType | undefined;
    partyNavigation?: Party | undefined;

    constructor(data?: IPartyContact) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.party = _data["party"];
            this.partyContactType = _data["partyContactType"];
            this.address = _data["address"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : undefined as any;
            this.createdBy = _data["createdBy"];
            this.modified = _data["modified"] ? new Date(_data["modified"].toString()) : undefined as any;
            this.modifiedBy = _data["modifiedBy"];
            this.partyContactTypeNavigation = _data["partyContactTypeNavigation"] ? PartyContactType.fromJS(_data["partyContactTypeNavigation"]) : undefined as any;
            this.partyNavigation = _data["partyNavigation"] ? Party.fromJS(_data["partyNavigation"]) : undefined as any;
        }
    }

    static fromJS(data: any): PartyContact {
        data = typeof data === 'object' ? data : {};
        let result = new PartyContact();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["party"] = this.party;
        data["partyContactType"] = this.partyContactType;
        data["address"] = this.address;
        data["created"] = this.created ? this.created.toISOString() : undefined as any;
        data["createdBy"] = this.createdBy;
        data["modified"] = this.modified ? this.modified.toISOString() : undefined as any;
        data["modifiedBy"] = this.modifiedBy;
        data["partyContactTypeNavigation"] = this.partyContactTypeNavigation ? this.partyContactTypeNavigation.toJSON() : undefined as any;
        data["partyNavigation"] = this.partyNavigation ? this.partyNavigation.toJSON() : undefined as any;
        return data;
    }
}

export interface IPartyContact {
    id?: number;
    party: string;
    partyContactType: string;
    address: string;
    created?: Date | undefined;
    createdBy?: number | undefined;
    modified?: Date | undefined;
    modifiedBy?: number | undefined;
    partyContactTypeNavigation?: PartyContactType | undefined;
    partyNavigation?: Party | undefined;
}

export class PartyContactType implements IPartyContactType {
    id?: number;
    num?: string | undefined;
    name!: string;
    isEmail?: boolean | undefined;
    isPhone?: boolean | undefined;
    defaultEmail?: boolean | undefined;
    defaultPhone?: boolean | undefined;
    created?: Date | undefined;
    createdBy?: number | undefined;
    modified?: Date | undefined;
    modifiedBy?: number | undefined;
    partyContacts?: PartyContact[] | undefined;

    constructor(data?: IPartyContactType) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.num = _data["num"];
            this.name = _data["name"];
            this.isEmail = _data["isEmail"];
            this.isPhone = _data["isPhone"];
            this.defaultEmail = _data["defaultEmail"];
            this.defaultPhone = _data["defaultPhone"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : undefined as any;
            this.createdBy = _data["createdBy"];
            this.modified = _data["modified"] ? new Date(_data["modified"].toString()) : undefined as any;
            this.modifiedBy = _data["modifiedBy"];
            if (Array.isArray(_data["partyContacts"])) {
                this.partyContacts = [] as any;
                for (let item of _data["partyContacts"])
                    this.partyContacts!.push(PartyContact.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PartyContactType {
        data = typeof data === 'object' ? data : {};
        let result = new PartyContactType();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["num"] = this.num;
        data["name"] = this.name;
        data["isEmail"] = this.isEmail;
        data["isPhone"] = this.isPhone;
        data["defaultEmail"] = this.defaultEmail;
        data["defaultPhone"] = this.defaultPhone;
        data["created"] = this.created ? this.created.toISOString() : undefined as any;
        data["createdBy"] = this.createdBy;
        data["modified"] = this.modified ? this.modified.toISOString() : undefined as any;
        data["modifiedBy"] = this.modifiedBy;
        if (Array.isArray(this.partyContacts)) {
            data["partyContacts"] = [];
            for (let item of this.partyContacts)
                data["partyContacts"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IPartyContactType {
    id?: number;
    num?: string | undefined;
    name: string;
    isEmail?: boolean | undefined;
    isPhone?: boolean | undefined;
    defaultEmail?: boolean | undefined;
    defaultPhone?: boolean | undefined;
    created?: Date | undefined;
    createdBy?: number | undefined;
    modified?: Date | undefined;
    modifiedBy?: number | undefined;
    partyContacts?: PartyContact[] | undefined;
}

export class Vendor implements IVendor {
    id?: number;
    num?: string | undefined;
    party!: string;
    name!: string;
    group?: string | undefined;
    approved?: boolean;
    currency!: string;
    paymentTerm?: string | undefined;
    blocked?: boolean;
    taxGroup?: string | undefined;
    taxId?: string | undefined;
    bankAccount?: string | undefined;
    bankIBAN?: string | undefined;
    bankSWIFT?: string | undefined;
    bankName?: string | undefined;
    bankAddress?: string | undefined;
    bankId?: string | undefined;
    created?: Date | undefined;
    createdBy?: number | undefined;
    modified?: Date | undefined;
    modifiedBy?: number | undefined;
    nameCurrency!: string;
    groupNavigation?: VendorGroup | undefined;
    partyNavigation?: Party | undefined;
    taxGroupNavigation?: VendorTaxGroup | undefined;

    constructor(data?: IVendor) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.num = _data["num"];
            this.party = _data["party"];
            this.name = _data["name"];
            this.group = _data["group"];
            this.approved = _data["approved"];
            this.currency = _data["currency"];
            this.paymentTerm = _data["paymentTerm"];
            this.blocked = _data["blocked"];
            this.taxGroup = _data["taxGroup"];
            this.taxId = _data["taxId"];
            this.bankAccount = _data["bankAccount"];
            this.bankIBAN = _data["bankIBAN"];
            this.bankSWIFT = _data["bankSWIFT"];
            this.bankName = _data["bankName"];
            this.bankAddress = _data["bankAddress"];
            this.bankId = _data["bankId"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : undefined as any;
            this.createdBy = _data["createdBy"];
            this.modified = _data["modified"] ? new Date(_data["modified"].toString()) : undefined as any;
            this.modifiedBy = _data["modifiedBy"];
            this.nameCurrency = _data["nameCurrency"];
            this.groupNavigation = _data["groupNavigation"] ? VendorGroup.fromJS(_data["groupNavigation"]) : undefined as any;
            this.partyNavigation = _data["partyNavigation"] ? Party.fromJS(_data["partyNavigation"]) : undefined as any;
            this.taxGroupNavigation = _data["taxGroupNavigation"] ? VendorTaxGroup.fromJS(_data["taxGroupNavigation"]) : undefined as any;
        }
    }

    static fromJS(data: any): Vendor {
        data = typeof data === 'object' ? data : {};
        let result = new Vendor();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["num"] = this.num;
        data["party"] = this.party;
        data["name"] = this.name;
        data["group"] = this.group;
        data["approved"] = this.approved;
        data["currency"] = this.currency;
        data["paymentTerm"] = this.paymentTerm;
        data["blocked"] = this.blocked;
        data["taxGroup"] = this.taxGroup;
        data["taxId"] = this.taxId;
        data["bankAccount"] = this.bankAccount;
        data["bankIBAN"] = this.bankIBAN;
        data["bankSWIFT"] = this.bankSWIFT;
        data["bankName"] = this.bankName;
        data["bankAddress"] = this.bankAddress;
        data["bankId"] = this.bankId;
        data["created"] = this.created ? this.created.toISOString() : undefined as any;
        data["createdBy"] = this.createdBy;
        data["modified"] = this.modified ? this.modified.toISOString() : undefined as any;
        data["modifiedBy"] = this.modifiedBy;
        data["nameCurrency"] = this.nameCurrency;
        data["groupNavigation"] = this.groupNavigation ? this.groupNavigation.toJSON() : undefined as any;
        data["partyNavigation"] = this.partyNavigation ? this.partyNavigation.toJSON() : undefined as any;
        data["taxGroupNavigation"] = this.taxGroupNavigation ? this.taxGroupNavigation.toJSON() : undefined as any;
        return data;
    }
}

export interface IVendor {
    id?: number;
    num?: string | undefined;
    party: string;
    name: string;
    group?: string | undefined;
    approved?: boolean;
    currency: string;
    paymentTerm?: string | undefined;
    blocked?: boolean;
    taxGroup?: string | undefined;
    taxId?: string | undefined;
    bankAccount?: string | undefined;
    bankIBAN?: string | undefined;
    bankSWIFT?: string | undefined;
    bankName?: string | undefined;
    bankAddress?: string | undefined;
    bankId?: string | undefined;
    created?: Date | undefined;
    createdBy?: number | undefined;
    modified?: Date | undefined;
    modifiedBy?: number | undefined;
    nameCurrency: string;
    groupNavigation?: VendorGroup | undefined;
    partyNavigation?: Party | undefined;
    taxGroupNavigation?: VendorTaxGroup | undefined;
}

export class VendorGroup implements IVendorGroup {
    id?: number;
    num?: string | undefined;
    name!: string;
    legacyId?: string | undefined;
    created?: Date | undefined;
    createdBy?: number | undefined;
    modified?: Date | undefined;
    modifiedBy?: number | undefined;
    vendors?: Vendor[] | undefined;

    constructor(data?: IVendorGroup) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.num = _data["num"];
            this.name = _data["name"];
            this.legacyId = _data["legacyId"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : undefined as any;
            this.createdBy = _data["createdBy"];
            this.modified = _data["modified"] ? new Date(_data["modified"].toString()) : undefined as any;
            this.modifiedBy = _data["modifiedBy"];
            if (Array.isArray(_data["vendors"])) {
                this.vendors = [] as any;
                for (let item of _data["vendors"])
                    this.vendors!.push(Vendor.fromJS(item));
            }
        }
    }

    static fromJS(data: any): VendorGroup {
        data = typeof data === 'object' ? data : {};
        let result = new VendorGroup();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["num"] = this.num;
        data["name"] = this.name;
        data["legacyId"] = this.legacyId;
        data["created"] = this.created ? this.created.toISOString() : undefined as any;
        data["createdBy"] = this.createdBy;
        data["modified"] = this.modified ? this.modified.toISOString() : undefined as any;
        data["modifiedBy"] = this.modifiedBy;
        if (Array.isArray(this.vendors)) {
            data["vendors"] = [];
            for (let item of this.vendors)
                data["vendors"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IVendorGroup {
    id?: number;
    num?: string | undefined;
    name: string;
    legacyId?: string | undefined;
    created?: Date | undefined;
    createdBy?: number | undefined;
    modified?: Date | undefined;
    modifiedBy?: number | undefined;
    vendors?: Vendor[] | undefined;
}

export class VendorTaxGroup implements IVendorTaxGroup {
    id?: number;
    num?: string | undefined;
    name?: string | undefined;
    taxCode?: string | undefined;
    created?: Date | undefined;
    createdBy?: number | undefined;
    modified?: Date | undefined;
    modifiedBy?: number | undefined;
    vendors?: Vendor[] | undefined;

    constructor(data?: IVendorTaxGroup) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.num = _data["num"];
            this.name = _data["name"];
            this.taxCode = _data["taxCode"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : undefined as any;
            this.createdBy = _data["createdBy"];
            this.modified = _data["modified"] ? new Date(_data["modified"].toString()) : undefined as any;
            this.modifiedBy = _data["modifiedBy"];
            if (Array.isArray(_data["vendors"])) {
                this.vendors = [] as any;
                for (let item of _data["vendors"])
                    this.vendors!.push(Vendor.fromJS(item));
            }
        }
    }

    static fromJS(data: any): VendorTaxGroup {
        data = typeof data === 'object' ? data : {};
        let result = new VendorTaxGroup();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["num"] = this.num;
        data["name"] = this.name;
        data["taxCode"] = this.taxCode;
        data["created"] = this.created ? this.created.toISOString() : undefined as any;
        data["createdBy"] = this.createdBy;
        data["modified"] = this.modified ? this.modified.toISOString() : undefined as any;
        data["modifiedBy"] = this.modifiedBy;
        if (Array.isArray(this.vendors)) {
            data["vendors"] = [];
            for (let item of this.vendors)
                data["vendors"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IVendorTaxGroup {
    id?: number;
    num?: string | undefined;
    name?: string | undefined;
    taxCode?: string | undefined;
    created?: Date | undefined;
    createdBy?: number | undefined;
    modified?: Date | undefined;
    modifiedBy?: number | undefined;
    vendors?: Vendor[] | undefined;
}

export class ContractType implements IContractType {
    id?: number;
    num?: string | undefined;
    name!: string;
    royalty?: boolean;
    author?: boolean;
    budget?: boolean;
    sorting?: number | undefined;
    legacyId?: number | undefined;
    created?: Date | undefined;
    createdBy?: number | undefined;
    modified?: Date | undefined;
    modifiedBy?: number | undefined;
    contracts?: Contract[] | undefined;

    constructor(data?: IContractType) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.num = _data["num"];
            this.name = _data["name"];
            this.royalty = _data["royalty"];
            this.author = _data["author"];
            this.budget = _data["budget"];
            this.sorting = _data["sorting"];
            this.legacyId = _data["legacyId"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : undefined as any;
            this.createdBy = _data["createdBy"];
            this.modified = _data["modified"] ? new Date(_data["modified"].toString()) : undefined as any;
            this.modifiedBy = _data["modifiedBy"];
            if (Array.isArray(_data["contracts"])) {
                this.contracts = [] as any;
                for (let item of _data["contracts"])
                    this.contracts!.push(Contract.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ContractType {
        data = typeof data === 'object' ? data : {};
        let result = new ContractType();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["num"] = this.num;
        data["name"] = this.name;
        data["royalty"] = this.royalty;
        data["author"] = this.author;
        data["budget"] = this.budget;
        data["sorting"] = this.sorting;
        data["legacyId"] = this.legacyId;
        data["created"] = this.created ? this.created.toISOString() : undefined as any;
        data["createdBy"] = this.createdBy;
        data["modified"] = this.modified ? this.modified.toISOString() : undefined as any;
        data["modifiedBy"] = this.modifiedBy;
        if (Array.isArray(this.contracts)) {
            data["contracts"] = [];
            for (let item of this.contracts)
                data["contracts"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IContractType {
    id?: number;
    num?: string | undefined;
    name: string;
    royalty?: boolean;
    author?: boolean;
    budget?: boolean;
    sorting?: number | undefined;
    legacyId?: number | undefined;
    created?: Date | undefined;
    createdBy?: number | undefined;
    modified?: Date | undefined;
    modifiedBy?: number | undefined;
    contracts?: Contract[] | undefined;
}

export class ProductPool implements IProductPool {
    id?: number;
    num?: string | undefined;
    name!: string;
    created?: Date | undefined;
    createdBy?: number | undefined;
    modified?: Date | undefined;
    modifiedBy?: number | undefined;
    products?: Product[] | undefined;

    constructor(data?: IProductPool) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.num = _data["num"];
            this.name = _data["name"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : undefined as any;
            this.createdBy = _data["createdBy"];
            this.modified = _data["modified"] ? new Date(_data["modified"].toString()) : undefined as any;
            this.modifiedBy = _data["modifiedBy"];
            if (Array.isArray(_data["products"])) {
                this.products = [] as any;
                for (let item of _data["products"])
                    this.products!.push(Product.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ProductPool {
        data = typeof data === 'object' ? data : {};
        let result = new ProductPool();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["num"] = this.num;
        data["name"] = this.name;
        data["created"] = this.created ? this.created.toISOString() : undefined as any;
        data["createdBy"] = this.createdBy;
        data["modified"] = this.modified ? this.modified.toISOString() : undefined as any;
        data["modifiedBy"] = this.modifiedBy;
        if (Array.isArray(this.products)) {
            data["products"] = [];
            for (let item of this.products)
                data["products"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IProductPool {
    id?: number;
    num?: string | undefined;
    name: string;
    created?: Date | undefined;
    createdBy?: number | undefined;
    modified?: Date | undefined;
    modifiedBy?: number | undefined;
    products?: Product[] | undefined;
}

export class ProductComposition implements IProductComposition {
    id?: number;
    num?: string | undefined;
    name!: string;
    sorting?: number | undefined;
    onix?: string | undefined;
    created?: Date | undefined;
    createdBy?: number | undefined;
    modified?: Date | undefined;
    modifiedBy?: number | undefined;
    onixName?: string | undefined;
    numName!: string;
    products?: Product[] | undefined;

    constructor(data?: IProductComposition) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.num = _data["num"];
            this.name = _data["name"];
            this.sorting = _data["sorting"];
            this.onix = _data["onix"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : undefined as any;
            this.createdBy = _data["createdBy"];
            this.modified = _data["modified"] ? new Date(_data["modified"].toString()) : undefined as any;
            this.modifiedBy = _data["modifiedBy"];
            this.onixName = _data["onixName"];
            this.numName = _data["numName"];
            if (Array.isArray(_data["products"])) {
                this.products = [] as any;
                for (let item of _data["products"])
                    this.products!.push(Product.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ProductComposition {
        data = typeof data === 'object' ? data : {};
        let result = new ProductComposition();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["num"] = this.num;
        data["name"] = this.name;
        data["sorting"] = this.sorting;
        data["onix"] = this.onix;
        data["created"] = this.created ? this.created.toISOString() : undefined as any;
        data["createdBy"] = this.createdBy;
        data["modified"] = this.modified ? this.modified.toISOString() : undefined as any;
        data["modifiedBy"] = this.modifiedBy;
        data["onixName"] = this.onixName;
        data["numName"] = this.numName;
        if (Array.isArray(this.products)) {
            data["products"] = [];
            for (let item of this.products)
                data["products"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IProductComposition {
    id?: number;
    num?: string | undefined;
    name: string;
    sorting?: number | undefined;
    onix?: string | undefined;
    created?: Date | undefined;
    createdBy?: number | undefined;
    modified?: Date | undefined;
    modifiedBy?: number | undefined;
    onixName?: string | undefined;
    numName: string;
    products?: Product[] | undefined;
}

export class ProductFormDetail implements IProductFormDetail {
    id?: number;
    num?: string | undefined;
    name!: string;
    isDigital?: boolean | undefined;
    sorting?: number | undefined;
    onix?: string | undefined;
    onixName?: string | undefined;
    created?: Date | undefined;
    createdBy?: number | undefined;
    modified?: Date | undefined;
    modifiedBy?: number | undefined;
    products?: Product[] | undefined;

    constructor(data?: IProductFormDetail) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.num = _data["num"];
            this.name = _data["name"];
            this.isDigital = _data["isDigital"];
            this.sorting = _data["sorting"];
            this.onix = _data["onix"];
            this.onixName = _data["onixName"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : undefined as any;
            this.createdBy = _data["createdBy"];
            this.modified = _data["modified"] ? new Date(_data["modified"].toString()) : undefined as any;
            this.modifiedBy = _data["modifiedBy"];
            if (Array.isArray(_data["products"])) {
                this.products = [] as any;
                for (let item of _data["products"])
                    this.products!.push(Product.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ProductFormDetail {
        data = typeof data === 'object' ? data : {};
        let result = new ProductFormDetail();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["num"] = this.num;
        data["name"] = this.name;
        data["isDigital"] = this.isDigital;
        data["sorting"] = this.sorting;
        data["onix"] = this.onix;
        data["onixName"] = this.onixName;
        data["created"] = this.created ? this.created.toISOString() : undefined as any;
        data["createdBy"] = this.createdBy;
        data["modified"] = this.modified ? this.modified.toISOString() : undefined as any;
        data["modifiedBy"] = this.modifiedBy;
        if (Array.isArray(this.products)) {
            data["products"] = [];
            for (let item of this.products)
                data["products"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IProductFormDetail {
    id?: number;
    num?: string | undefined;
    name: string;
    isDigital?: boolean | undefined;
    sorting?: number | undefined;
    onix?: string | undefined;
    onixName?: string | undefined;
    created?: Date | undefined;
    createdBy?: number | undefined;
    modified?: Date | undefined;
    modifiedBy?: number | undefined;
    products?: Product[] | undefined;
}

export class ProductForm implements IProductForm {
    id?: number;
    num?: string | undefined;
    name!: string;
    productType?: string | undefined;
    sorting?: number | undefined;
    onix?: string | undefined;
    onixName?: string | undefined;
    created?: Date | undefined;
    createdBy?: number | undefined;
    modified?: Date | undefined;
    modifiedBy?: number | undefined;
    productTypeNavigation?: ProductType | undefined;
    products?: Product[] | undefined;

    constructor(data?: IProductForm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.num = _data["num"];
            this.name = _data["name"];
            this.productType = _data["productType"];
            this.sorting = _data["sorting"];
            this.onix = _data["onix"];
            this.onixName = _data["onixName"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : undefined as any;
            this.createdBy = _data["createdBy"];
            this.modified = _data["modified"] ? new Date(_data["modified"].toString()) : undefined as any;
            this.modifiedBy = _data["modifiedBy"];
            this.productTypeNavigation = _data["productTypeNavigation"] ? ProductType.fromJS(_data["productTypeNavigation"]) : undefined as any;
            if (Array.isArray(_data["products"])) {
                this.products = [] as any;
                for (let item of _data["products"])
                    this.products!.push(Product.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ProductForm {
        data = typeof data === 'object' ? data : {};
        let result = new ProductForm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["num"] = this.num;
        data["name"] = this.name;
        data["productType"] = this.productType;
        data["sorting"] = this.sorting;
        data["onix"] = this.onix;
        data["onixName"] = this.onixName;
        data["created"] = this.created ? this.created.toISOString() : undefined as any;
        data["createdBy"] = this.createdBy;
        data["modified"] = this.modified ? this.modified.toISOString() : undefined as any;
        data["modifiedBy"] = this.modifiedBy;
        data["productTypeNavigation"] = this.productTypeNavigation ? this.productTypeNavigation.toJSON() : undefined as any;
        if (Array.isArray(this.products)) {
            data["products"] = [];
            for (let item of this.products)
                data["products"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IProductForm {
    id?: number;
    num?: string | undefined;
    name: string;
    productType?: string | undefined;
    sorting?: number | undefined;
    onix?: string | undefined;
    onixName?: string | undefined;
    created?: Date | undefined;
    createdBy?: number | undefined;
    modified?: Date | undefined;
    modifiedBy?: number | undefined;
    productTypeNavigation?: ProductType | undefined;
    products?: Product[] | undefined;
}

export class ProductType implements IProductType {
    id?: number;
    num?: string | undefined;
    name!: string;
    isPrimary?: boolean | undefined;
    isAudio?: boolean | undefined;
    isDigital?: boolean | undefined;
    isBOM?: boolean | undefined;
    distributor?: string | undefined;
    legacyId?: number | undefined;
    sorting?: number | undefined;
    created?: Date | undefined;
    createdBy?: number | undefined;
    modified?: Date | undefined;
    modifiedBy?: number | undefined;
    distributorNavigation?: ProductDistributor | undefined;
    productForms?: ProductForm[] | undefined;
    products?: Product[] | undefined;

    constructor(data?: IProductType) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.num = _data["num"];
            this.name = _data["name"];
            this.isPrimary = _data["isPrimary"];
            this.isAudio = _data["isAudio"];
            this.isDigital = _data["isDigital"];
            this.isBOM = _data["isBOM"];
            this.distributor = _data["distributor"];
            this.legacyId = _data["legacyId"];
            this.sorting = _data["sorting"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : undefined as any;
            this.createdBy = _data["createdBy"];
            this.modified = _data["modified"] ? new Date(_data["modified"].toString()) : undefined as any;
            this.modifiedBy = _data["modifiedBy"];
            this.distributorNavigation = _data["distributorNavigation"] ? ProductDistributor.fromJS(_data["distributorNavigation"]) : undefined as any;
            if (Array.isArray(_data["productForms"])) {
                this.productForms = [] as any;
                for (let item of _data["productForms"])
                    this.productForms!.push(ProductForm.fromJS(item));
            }
            if (Array.isArray(_data["products"])) {
                this.products = [] as any;
                for (let item of _data["products"])
                    this.products!.push(Product.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ProductType {
        data = typeof data === 'object' ? data : {};
        let result = new ProductType();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["num"] = this.num;
        data["name"] = this.name;
        data["isPrimary"] = this.isPrimary;
        data["isAudio"] = this.isAudio;
        data["isDigital"] = this.isDigital;
        data["isBOM"] = this.isBOM;
        data["distributor"] = this.distributor;
        data["legacyId"] = this.legacyId;
        data["sorting"] = this.sorting;
        data["created"] = this.created ? this.created.toISOString() : undefined as any;
        data["createdBy"] = this.createdBy;
        data["modified"] = this.modified ? this.modified.toISOString() : undefined as any;
        data["modifiedBy"] = this.modifiedBy;
        data["distributorNavigation"] = this.distributorNavigation ? this.distributorNavigation.toJSON() : undefined as any;
        if (Array.isArray(this.productForms)) {
            data["productForms"] = [];
            for (let item of this.productForms)
                data["productForms"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.products)) {
            data["products"] = [];
            for (let item of this.products)
                data["products"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IProductType {
    id?: number;
    num?: string | undefined;
    name: string;
    isPrimary?: boolean | undefined;
    isAudio?: boolean | undefined;
    isDigital?: boolean | undefined;
    isBOM?: boolean | undefined;
    distributor?: string | undefined;
    legacyId?: number | undefined;
    sorting?: number | undefined;
    created?: Date | undefined;
    createdBy?: number | undefined;
    modified?: Date | undefined;
    modifiedBy?: number | undefined;
    distributorNavigation?: ProductDistributor | undefined;
    productForms?: ProductForm[] | undefined;
    products?: Product[] | undefined;
}

export class ProductDistributor implements IProductDistributor {
    id?: number;
    num?: string | undefined;
    name!: string;
    sorting?: number | undefined;
    onix?: string | undefined;
    created?: Date | undefined;
    createdBy?: number | undefined;
    modified?: Date | undefined;
    modifiedBy?: number | undefined;
    productTypes?: ProductType[] | undefined;

    constructor(data?: IProductDistributor) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.num = _data["num"];
            this.name = _data["name"];
            this.sorting = _data["sorting"];
            this.onix = _data["onix"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : undefined as any;
            this.createdBy = _data["createdBy"];
            this.modified = _data["modified"] ? new Date(_data["modified"].toString()) : undefined as any;
            this.modifiedBy = _data["modifiedBy"];
            if (Array.isArray(_data["productTypes"])) {
                this.productTypes = [] as any;
                for (let item of _data["productTypes"])
                    this.productTypes!.push(ProductType.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ProductDistributor {
        data = typeof data === 'object' ? data : {};
        let result = new ProductDistributor();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["num"] = this.num;
        data["name"] = this.name;
        data["sorting"] = this.sorting;
        data["onix"] = this.onix;
        data["created"] = this.created ? this.created.toISOString() : undefined as any;
        data["createdBy"] = this.createdBy;
        data["modified"] = this.modified ? this.modified.toISOString() : undefined as any;
        data["modifiedBy"] = this.modifiedBy;
        if (Array.isArray(this.productTypes)) {
            data["productTypes"] = [];
            for (let item of this.productTypes)
                data["productTypes"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IProductDistributor {
    id?: number;
    num?: string | undefined;
    name: string;
    sorting?: number | undefined;
    onix?: string | undefined;
    created?: Date | undefined;
    createdBy?: number | undefined;
    modified?: Date | undefined;
    modifiedBy?: number | undefined;
    productTypes?: ProductType[] | undefined;
}

export class ProductStatus implements IProductStatus {
    id?: number;
    num?: string | undefined;
    name!: string;
    sorting?: number | undefined;
    publishingStatus?: string | undefined;
    marketAvailability?: string | undefined;
    publishingStatusInternal?: string | undefined;
    marketAvailabilityInternal?: string | undefined;
    created?: Date | undefined;
    createdBy?: number | undefined;
    modified?: Date | undefined;
    modifiedBy?: number | undefined;
    marketAvailabilityInternalNavigation?: ProductMarketAvailability | undefined;
    marketAvailabilityNavigation?: ProductMarketAvailability | undefined;
    publishingStatusInternalNavigation?: ProductPublishingStatus | undefined;
    publishingStatusNavigation?: ProductPublishingStatus | undefined;
    products?: Product[] | undefined;

    constructor(data?: IProductStatus) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.num = _data["num"];
            this.name = _data["name"];
            this.sorting = _data["sorting"];
            this.publishingStatus = _data["publishingStatus"];
            this.marketAvailability = _data["marketAvailability"];
            this.publishingStatusInternal = _data["publishingStatusInternal"];
            this.marketAvailabilityInternal = _data["marketAvailabilityInternal"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : undefined as any;
            this.createdBy = _data["createdBy"];
            this.modified = _data["modified"] ? new Date(_data["modified"].toString()) : undefined as any;
            this.modifiedBy = _data["modifiedBy"];
            this.marketAvailabilityInternalNavigation = _data["marketAvailabilityInternalNavigation"] ? ProductMarketAvailability.fromJS(_data["marketAvailabilityInternalNavigation"]) : undefined as any;
            this.marketAvailabilityNavigation = _data["marketAvailabilityNavigation"] ? ProductMarketAvailability.fromJS(_data["marketAvailabilityNavigation"]) : undefined as any;
            this.publishingStatusInternalNavigation = _data["publishingStatusInternalNavigation"] ? ProductPublishingStatus.fromJS(_data["publishingStatusInternalNavigation"]) : undefined as any;
            this.publishingStatusNavigation = _data["publishingStatusNavigation"] ? ProductPublishingStatus.fromJS(_data["publishingStatusNavigation"]) : undefined as any;
            if (Array.isArray(_data["products"])) {
                this.products = [] as any;
                for (let item of _data["products"])
                    this.products!.push(Product.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ProductStatus {
        data = typeof data === 'object' ? data : {};
        let result = new ProductStatus();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["num"] = this.num;
        data["name"] = this.name;
        data["sorting"] = this.sorting;
        data["publishingStatus"] = this.publishingStatus;
        data["marketAvailability"] = this.marketAvailability;
        data["publishingStatusInternal"] = this.publishingStatusInternal;
        data["marketAvailabilityInternal"] = this.marketAvailabilityInternal;
        data["created"] = this.created ? this.created.toISOString() : undefined as any;
        data["createdBy"] = this.createdBy;
        data["modified"] = this.modified ? this.modified.toISOString() : undefined as any;
        data["modifiedBy"] = this.modifiedBy;
        data["marketAvailabilityInternalNavigation"] = this.marketAvailabilityInternalNavigation ? this.marketAvailabilityInternalNavigation.toJSON() : undefined as any;
        data["marketAvailabilityNavigation"] = this.marketAvailabilityNavigation ? this.marketAvailabilityNavigation.toJSON() : undefined as any;
        data["publishingStatusInternalNavigation"] = this.publishingStatusInternalNavigation ? this.publishingStatusInternalNavigation.toJSON() : undefined as any;
        data["publishingStatusNavigation"] = this.publishingStatusNavigation ? this.publishingStatusNavigation.toJSON() : undefined as any;
        if (Array.isArray(this.products)) {
            data["products"] = [];
            for (let item of this.products)
                data["products"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IProductStatus {
    id?: number;
    num?: string | undefined;
    name: string;
    sorting?: number | undefined;
    publishingStatus?: string | undefined;
    marketAvailability?: string | undefined;
    publishingStatusInternal?: string | undefined;
    marketAvailabilityInternal?: string | undefined;
    created?: Date | undefined;
    createdBy?: number | undefined;
    modified?: Date | undefined;
    modifiedBy?: number | undefined;
    marketAvailabilityInternalNavigation?: ProductMarketAvailability | undefined;
    marketAvailabilityNavigation?: ProductMarketAvailability | undefined;
    publishingStatusInternalNavigation?: ProductPublishingStatus | undefined;
    publishingStatusNavigation?: ProductPublishingStatus | undefined;
    products?: Product[] | undefined;
}

export class ProductMarketAvailability implements IProductMarketAvailability {
    id?: number;
    num?: string | undefined;
    name!: string;
    sorting?: number | undefined;
    onix?: string | undefined;
    created?: Date | undefined;
    createdBy?: number | undefined;
    modified?: Date | undefined;
    modifiedBy?: number | undefined;
    onixName?: string | undefined;
    numName!: string;
    productStatusMarketAvailabilityInternalNavigations?: ProductStatus[] | undefined;
    productStatusMarketAvailabilityNavigations?: ProductStatus[] | undefined;

    constructor(data?: IProductMarketAvailability) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.num = _data["num"];
            this.name = _data["name"];
            this.sorting = _data["sorting"];
            this.onix = _data["onix"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : undefined as any;
            this.createdBy = _data["createdBy"];
            this.modified = _data["modified"] ? new Date(_data["modified"].toString()) : undefined as any;
            this.modifiedBy = _data["modifiedBy"];
            this.onixName = _data["onixName"];
            this.numName = _data["numName"];
            if (Array.isArray(_data["productStatusMarketAvailabilityInternalNavigations"])) {
                this.productStatusMarketAvailabilityInternalNavigations = [] as any;
                for (let item of _data["productStatusMarketAvailabilityInternalNavigations"])
                    this.productStatusMarketAvailabilityInternalNavigations!.push(ProductStatus.fromJS(item));
            }
            if (Array.isArray(_data["productStatusMarketAvailabilityNavigations"])) {
                this.productStatusMarketAvailabilityNavigations = [] as any;
                for (let item of _data["productStatusMarketAvailabilityNavigations"])
                    this.productStatusMarketAvailabilityNavigations!.push(ProductStatus.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ProductMarketAvailability {
        data = typeof data === 'object' ? data : {};
        let result = new ProductMarketAvailability();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["num"] = this.num;
        data["name"] = this.name;
        data["sorting"] = this.sorting;
        data["onix"] = this.onix;
        data["created"] = this.created ? this.created.toISOString() : undefined as any;
        data["createdBy"] = this.createdBy;
        data["modified"] = this.modified ? this.modified.toISOString() : undefined as any;
        data["modifiedBy"] = this.modifiedBy;
        data["onixName"] = this.onixName;
        data["numName"] = this.numName;
        if (Array.isArray(this.productStatusMarketAvailabilityInternalNavigations)) {
            data["productStatusMarketAvailabilityInternalNavigations"] = [];
            for (let item of this.productStatusMarketAvailabilityInternalNavigations)
                data["productStatusMarketAvailabilityInternalNavigations"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.productStatusMarketAvailabilityNavigations)) {
            data["productStatusMarketAvailabilityNavigations"] = [];
            for (let item of this.productStatusMarketAvailabilityNavigations)
                data["productStatusMarketAvailabilityNavigations"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IProductMarketAvailability {
    id?: number;
    num?: string | undefined;
    name: string;
    sorting?: number | undefined;
    onix?: string | undefined;
    created?: Date | undefined;
    createdBy?: number | undefined;
    modified?: Date | undefined;
    modifiedBy?: number | undefined;
    onixName?: string | undefined;
    numName: string;
    productStatusMarketAvailabilityInternalNavigations?: ProductStatus[] | undefined;
    productStatusMarketAvailabilityNavigations?: ProductStatus[] | undefined;
}

export class ProductPublishingStatus implements IProductPublishingStatus {
    id?: number;
    num?: string | undefined;
    name!: string;
    sorting?: number | undefined;
    onix?: string | undefined;
    created?: Date | undefined;
    createdBy?: number | undefined;
    modified?: Date | undefined;
    modifiedBy?: number | undefined;
    onixName?: string | undefined;
    numName!: string;
    productStatusPublishingStatusInternalNavigations?: ProductStatus[] | undefined;
    productStatusPublishingStatusNavigations?: ProductStatus[] | undefined;

    constructor(data?: IProductPublishingStatus) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.num = _data["num"];
            this.name = _data["name"];
            this.sorting = _data["sorting"];
            this.onix = _data["onix"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : undefined as any;
            this.createdBy = _data["createdBy"];
            this.modified = _data["modified"] ? new Date(_data["modified"].toString()) : undefined as any;
            this.modifiedBy = _data["modifiedBy"];
            this.onixName = _data["onixName"];
            this.numName = _data["numName"];
            if (Array.isArray(_data["productStatusPublishingStatusInternalNavigations"])) {
                this.productStatusPublishingStatusInternalNavigations = [] as any;
                for (let item of _data["productStatusPublishingStatusInternalNavigations"])
                    this.productStatusPublishingStatusInternalNavigations!.push(ProductStatus.fromJS(item));
            }
            if (Array.isArray(_data["productStatusPublishingStatusNavigations"])) {
                this.productStatusPublishingStatusNavigations = [] as any;
                for (let item of _data["productStatusPublishingStatusNavigations"])
                    this.productStatusPublishingStatusNavigations!.push(ProductStatus.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ProductPublishingStatus {
        data = typeof data === 'object' ? data : {};
        let result = new ProductPublishingStatus();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["num"] = this.num;
        data["name"] = this.name;
        data["sorting"] = this.sorting;
        data["onix"] = this.onix;
        data["created"] = this.created ? this.created.toISOString() : undefined as any;
        data["createdBy"] = this.createdBy;
        data["modified"] = this.modified ? this.modified.toISOString() : undefined as any;
        data["modifiedBy"] = this.modifiedBy;
        data["onixName"] = this.onixName;
        data["numName"] = this.numName;
        if (Array.isArray(this.productStatusPublishingStatusInternalNavigations)) {
            data["productStatusPublishingStatusInternalNavigations"] = [];
            for (let item of this.productStatusPublishingStatusInternalNavigations)
                data["productStatusPublishingStatusInternalNavigations"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.productStatusPublishingStatusNavigations)) {
            data["productStatusPublishingStatusNavigations"] = [];
            for (let item of this.productStatusPublishingStatusNavigations)
                data["productStatusPublishingStatusNavigations"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IProductPublishingStatus {
    id?: number;
    num?: string | undefined;
    name: string;
    sorting?: number | undefined;
    onix?: string | undefined;
    created?: Date | undefined;
    createdBy?: number | undefined;
    modified?: Date | undefined;
    modifiedBy?: number | undefined;
    onixName?: string | undefined;
    numName: string;
    productStatusPublishingStatusInternalNavigations?: ProductStatus[] | undefined;
    productStatusPublishingStatusNavigations?: ProductStatus[] | undefined;
}

export class ProductCategory implements IProductCategory {
    id?: number;
    num?: string | undefined;
    name!: string;
    sorting?: number;
    created?: Date | undefined;
    createdBy?: number | undefined;
    modified?: Date | undefined;
    modifiedBy?: number | undefined;
    search!: string;
    products?: Product[] | undefined;

    constructor(data?: IProductCategory) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.num = _data["num"];
            this.name = _data["name"];
            this.sorting = _data["sorting"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : undefined as any;
            this.createdBy = _data["createdBy"];
            this.modified = _data["modified"] ? new Date(_data["modified"].toString()) : undefined as any;
            this.modifiedBy = _data["modifiedBy"];
            this.search = _data["search"];
            if (Array.isArray(_data["products"])) {
                this.products = [] as any;
                for (let item of _data["products"])
                    this.products!.push(Product.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ProductCategory {
        data = typeof data === 'object' ? data : {};
        let result = new ProductCategory();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["num"] = this.num;
        data["name"] = this.name;
        data["sorting"] = this.sorting;
        data["created"] = this.created ? this.created.toISOString() : undefined as any;
        data["createdBy"] = this.createdBy;
        data["modified"] = this.modified ? this.modified.toISOString() : undefined as any;
        data["modifiedBy"] = this.modifiedBy;
        data["search"] = this.search;
        if (Array.isArray(this.products)) {
            data["products"] = [];
            for (let item of this.products)
                data["products"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IProductCategory {
    id?: number;
    num?: string | undefined;
    name: string;
    sorting?: number;
    created?: Date | undefined;
    createdBy?: number | undefined;
    modified?: Date | undefined;
    modifiedBy?: number | undefined;
    search: string;
    products?: Product[] | undefined;
}

export class BankAccountTransfer implements IBankAccountTransfer {
    id?: number;
    setup?: number;
    status?: number;
    created?: Date | undefined;
    createdBy?: number | undefined;
    modified?: Date | undefined;
    modifiedBy?: number | undefined;
    setupNavigation?: BankAccountTransferSetup | undefined;
    statusNavigation?: BankAccountTransferStatus | undefined;
    bankAccountTransferJournals?: BankAccountTransferJournal[] | undefined;

    constructor(data?: IBankAccountTransfer) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.setup = _data["setup"];
            this.status = _data["status"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : undefined as any;
            this.createdBy = _data["createdBy"];
            this.modified = _data["modified"] ? new Date(_data["modified"].toString()) : undefined as any;
            this.modifiedBy = _data["modifiedBy"];
            this.setupNavigation = _data["setupNavigation"] ? BankAccountTransferSetup.fromJS(_data["setupNavigation"]) : undefined as any;
            this.statusNavigation = _data["statusNavigation"] ? BankAccountTransferStatus.fromJS(_data["statusNavigation"]) : undefined as any;
            if (Array.isArray(_data["bankAccountTransferJournals"])) {
                this.bankAccountTransferJournals = [] as any;
                for (let item of _data["bankAccountTransferJournals"])
                    this.bankAccountTransferJournals!.push(BankAccountTransferJournal.fromJS(item));
            }
        }
    }

    static fromJS(data: any): BankAccountTransfer {
        data = typeof data === 'object' ? data : {};
        let result = new BankAccountTransfer();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["setup"] = this.setup;
        data["status"] = this.status;
        data["created"] = this.created ? this.created.toISOString() : undefined as any;
        data["createdBy"] = this.createdBy;
        data["modified"] = this.modified ? this.modified.toISOString() : undefined as any;
        data["modifiedBy"] = this.modifiedBy;
        data["setupNavigation"] = this.setupNavigation ? this.setupNavigation.toJSON() : undefined as any;
        data["statusNavigation"] = this.statusNavigation ? this.statusNavigation.toJSON() : undefined as any;
        if (Array.isArray(this.bankAccountTransferJournals)) {
            data["bankAccountTransferJournals"] = [];
            for (let item of this.bankAccountTransferJournals)
                data["bankAccountTransferJournals"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IBankAccountTransfer {
    id?: number;
    setup?: number;
    status?: number;
    created?: Date | undefined;
    createdBy?: number | undefined;
    modified?: Date | undefined;
    modifiedBy?: number | undefined;
    setupNavigation?: BankAccountTransferSetup | undefined;
    statusNavigation?: BankAccountTransferStatus | undefined;
    bankAccountTransferJournals?: BankAccountTransferJournal[] | undefined;
}

export class BankAccountTransferStatus implements IBankAccountTransferStatus {
    id?: number;
    name!: string;
    created?: Date | undefined;
    createdBy?: number | undefined;
    modified?: Date | undefined;
    modifiedBy?: number | undefined;
    bankAccountTransferJournals?: BankAccountTransferJournal[] | undefined;
    bankAccountTransfers?: BankAccountTransfer[] | undefined;

    constructor(data?: IBankAccountTransferStatus) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : undefined as any;
            this.createdBy = _data["createdBy"];
            this.modified = _data["modified"] ? new Date(_data["modified"].toString()) : undefined as any;
            this.modifiedBy = _data["modifiedBy"];
            if (Array.isArray(_data["bankAccountTransferJournals"])) {
                this.bankAccountTransferJournals = [] as any;
                for (let item of _data["bankAccountTransferJournals"])
                    this.bankAccountTransferJournals!.push(BankAccountTransferJournal.fromJS(item));
            }
            if (Array.isArray(_data["bankAccountTransfers"])) {
                this.bankAccountTransfers = [] as any;
                for (let item of _data["bankAccountTransfers"])
                    this.bankAccountTransfers!.push(BankAccountTransfer.fromJS(item));
            }
        }
    }

    static fromJS(data: any): BankAccountTransferStatus {
        data = typeof data === 'object' ? data : {};
        let result = new BankAccountTransferStatus();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["created"] = this.created ? this.created.toISOString() : undefined as any;
        data["createdBy"] = this.createdBy;
        data["modified"] = this.modified ? this.modified.toISOString() : undefined as any;
        data["modifiedBy"] = this.modifiedBy;
        if (Array.isArray(this.bankAccountTransferJournals)) {
            data["bankAccountTransferJournals"] = [];
            for (let item of this.bankAccountTransferJournals)
                data["bankAccountTransferJournals"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.bankAccountTransfers)) {
            data["bankAccountTransfers"] = [];
            for (let item of this.bankAccountTransfers)
                data["bankAccountTransfers"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IBankAccountTransferStatus {
    id?: number;
    name: string;
    created?: Date | undefined;
    createdBy?: number | undefined;
    modified?: Date | undefined;
    modifiedBy?: number | undefined;
    bankAccountTransferJournals?: BankAccountTransferJournal[] | undefined;
    bankAccountTransfers?: BankAccountTransfer[] | undefined;
}

export class BankAccountTransferJournal implements IBankAccountTransferJournal {
    id?: number;
    transfer?: number;
    journalLine?: number;
    status?: number;
    created?: Date | undefined;
    createdBy?: number | undefined;
    modified?: Date | undefined;
    modifiedBy?: number | undefined;
    statusNavigation?: BankAccountTransferStatus | undefined;
    transferNavigation?: BankAccountTransfer | undefined;

    constructor(data?: IBankAccountTransferJournal) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.transfer = _data["transfer"];
            this.journalLine = _data["journalLine"];
            this.status = _data["status"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : undefined as any;
            this.createdBy = _data["createdBy"];
            this.modified = _data["modified"] ? new Date(_data["modified"].toString()) : undefined as any;
            this.modifiedBy = _data["modifiedBy"];
            this.statusNavigation = _data["statusNavigation"] ? BankAccountTransferStatus.fromJS(_data["statusNavigation"]) : undefined as any;
            this.transferNavigation = _data["transferNavigation"] ? BankAccountTransfer.fromJS(_data["transferNavigation"]) : undefined as any;
        }
    }

    static fromJS(data: any): BankAccountTransferJournal {
        data = typeof data === 'object' ? data : {};
        let result = new BankAccountTransferJournal();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["transfer"] = this.transfer;
        data["journalLine"] = this.journalLine;
        data["status"] = this.status;
        data["created"] = this.created ? this.created.toISOString() : undefined as any;
        data["createdBy"] = this.createdBy;
        data["modified"] = this.modified ? this.modified.toISOString() : undefined as any;
        data["modifiedBy"] = this.modifiedBy;
        data["statusNavigation"] = this.statusNavigation ? this.statusNavigation.toJSON() : undefined as any;
        data["transferNavigation"] = this.transferNavigation ? this.transferNavigation.toJSON() : undefined as any;
        return data;
    }
}

export interface IBankAccountTransferJournal {
    id?: number;
    transfer?: number;
    journalLine?: number;
    status?: number;
    created?: Date | undefined;
    createdBy?: number | undefined;
    modified?: Date | undefined;
    modifiedBy?: number | undefined;
    statusNavigation?: BankAccountTransferStatus | undefined;
    transferNavigation?: BankAccountTransfer | undefined;
}

export class BankTransactionSuggestSettlementCommand implements IBankTransactionSuggestSettlementCommand {
    bankAccountId?: number | undefined;
    bankTransId?: number | undefined;
    voucherTransId?: number | undefined;
    saveSuggestion?: boolean;

    constructor(data?: IBankTransactionSuggestSettlementCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.bankAccountId = _data["bankAccountId"];
            this.bankTransId = _data["bankTransId"];
            this.voucherTransId = _data["voucherTransId"];
            this.saveSuggestion = _data["saveSuggestion"];
        }
    }

    static fromJS(data: any): BankTransactionSuggestSettlementCommand {
        data = typeof data === 'object' ? data : {};
        let result = new BankTransactionSuggestSettlementCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["bankAccountId"] = this.bankAccountId;
        data["bankTransId"] = this.bankTransId;
        data["voucherTransId"] = this.voucherTransId;
        data["saveSuggestion"] = this.saveSuggestion;
        return data;
    }
}

export interface IBankTransactionSuggestSettlementCommand {
    bankAccountId?: number | undefined;
    bankTransId?: number | undefined;
    voucherTransId?: number | undefined;
    saveSuggestion?: boolean;
}

export class BankTransactionVoucherCombineSelectedCommand implements IBankTransactionVoucherCombineSelectedCommand {
    msgId?: number | undefined;
    userId?: number | undefined;

    constructor(data?: IBankTransactionVoucherCombineSelectedCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.msgId = _data["msgId"];
            this.userId = _data["userId"];
        }
    }

    static fromJS(data: any): BankTransactionVoucherCombineSelectedCommand {
        data = typeof data === 'object' ? data : {};
        let result = new BankTransactionVoucherCombineSelectedCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["msgId"] = this.msgId;
        data["userId"] = this.userId;
        return data;
    }
}

export interface IBankTransactionVoucherCombineSelectedCommand {
    msgId?: number | undefined;
    userId?: number | undefined;
}

export class BankTransactionStatusSetCommand implements IBankTransactionStatusSetCommand {
    transIdList?: number[] | undefined;
    status?: BankSettlementStatusEnum;
    voucherRequestResponsible?: number | undefined;
    voucherRequestDescription?: string | undefined;

    constructor(data?: IBankTransactionStatusSetCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["transIdList"])) {
                this.transIdList = [] as any;
                for (let item of _data["transIdList"])
                    this.transIdList!.push(item);
            }
            this.status = _data["status"];
            this.voucherRequestResponsible = _data["voucherRequestResponsible"];
            this.voucherRequestDescription = _data["voucherRequestDescription"];
        }
    }

    static fromJS(data: any): BankTransactionStatusSetCommand {
        data = typeof data === 'object' ? data : {};
        let result = new BankTransactionStatusSetCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.transIdList)) {
            data["transIdList"] = [];
            for (let item of this.transIdList)
                data["transIdList"].push(item);
        }
        data["status"] = this.status;
        data["voucherRequestResponsible"] = this.voucherRequestResponsible;
        data["voucherRequestDescription"] = this.voucherRequestDescription;
        return data;
    }
}

export interface IBankTransactionStatusSetCommand {
    transIdList?: number[] | undefined;
    status?: BankSettlementStatusEnum;
    voucherRequestResponsible?: number | undefined;
    voucherRequestDescription?: string | undefined;
}

export class BankAccountTransactionVoucherCreateCommand implements IBankAccountTransactionVoucherCreateCommand {
    bankTransactionId?: number | undefined;
    status?: BankSettlementStatusEnum;

    constructor(data?: IBankAccountTransactionVoucherCreateCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.bankTransactionId = _data["bankTransactionId"];
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): BankAccountTransactionVoucherCreateCommand {
        data = typeof data === 'object' ? data : {};
        let result = new BankAccountTransactionVoucherCreateCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["bankTransactionId"] = this.bankTransactionId;
        data["status"] = this.status;
        return data;
    }
}

export interface IBankAccountTransactionVoucherCreateCommand {
    bankTransactionId?: number | undefined;
    status?: BankSettlementStatusEnum;
}

export abstract class RequestExtendedInfo implements IRequestExtendedInfo {
    extendedInfo?: { [key: string]: string; } | undefined;

    constructor(data?: IRequestExtendedInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (_data["extendedInfo"]) {
                this.extendedInfo = {} as any;
                for (let key in _data["extendedInfo"]) {
                    if (_data["extendedInfo"].hasOwnProperty(key))
                        (this.extendedInfo as any)![key] = _data["extendedInfo"][key];
                }
            }
        }
    }

    static fromJS(data: any): RequestExtendedInfo {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'RequestExtendedInfo' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.extendedInfo) {
            data["extendedInfo"] = {};
            for (let key in this.extendedInfo) {
                if (this.extendedInfo.hasOwnProperty(key))
                    (data["extendedInfo"] as any)[key] = (this.extendedInfo as any)[key];
            }
        }
        return data;
    }
}

export interface IRequestExtendedInfo {
    extendedInfo?: { [key: string]: string; } | undefined;
}

export class BankAccountSourceSyncCommand extends RequestExtendedInfo implements IBankAccountSourceSyncCommand {
    bankAccount?: number | undefined;
    source?: number | undefined;
    syncGenericSources?: boolean;

    constructor(data?: IBankAccountSourceSyncCommand) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.bankAccount = _data["bankAccount"];
            this.source = _data["source"];
            this.syncGenericSources = _data["syncGenericSources"];
        }
    }

    static override fromJS(data: any): BankAccountSourceSyncCommand {
        data = typeof data === 'object' ? data : {};
        let result = new BankAccountSourceSyncCommand();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["bankAccount"] = this.bankAccount;
        data["source"] = this.source;
        data["syncGenericSources"] = this.syncGenericSources;
        super.toJSON(data);
        return data;
    }
}

export interface IBankAccountSourceSyncCommand extends IRequestExtendedInfo {
    bankAccount?: number | undefined;
    source?: number | undefined;
    syncGenericSources?: boolean;
}

export class BankTransactionBatchStatusSetCommand implements IBankTransactionBatchStatusSetCommand {
    batchIdList?: number[] | undefined;
    status?: BankSettlementStatusEnum;

    constructor(data?: IBankTransactionBatchStatusSetCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["batchIdList"])) {
                this.batchIdList = [] as any;
                for (let item of _data["batchIdList"])
                    this.batchIdList!.push(item);
            }
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): BankTransactionBatchStatusSetCommand {
        data = typeof data === 'object' ? data : {};
        let result = new BankTransactionBatchStatusSetCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.batchIdList)) {
            data["batchIdList"] = [];
            for (let item of this.batchIdList)
                data["batchIdList"].push(item);
        }
        data["status"] = this.status;
        return data;
    }
}

export interface IBankTransactionBatchStatusSetCommand {
    batchIdList?: number[] | undefined;
    status?: BankSettlementStatusEnum;
}

export class ChatDto implements IChatDto {
    id?: number | undefined;
    refTableId?: number;
    refRowId?: number;
    txt?: string | undefined;
    isPrivate?: boolean;
    created?: Date | undefined;
    createdBy?: number | undefined;
    modified?: Date | undefined;
    modifiedBy?: number | undefined;
    chatUsers?: ChatUserDto[] | undefined;

    constructor(data?: IChatDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.refTableId = _data["refTableId"];
            this.refRowId = _data["refRowId"];
            this.txt = _data["txt"];
            this.isPrivate = _data["isPrivate"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : undefined as any;
            this.createdBy = _data["createdBy"];
            this.modified = _data["modified"] ? new Date(_data["modified"].toString()) : undefined as any;
            this.modifiedBy = _data["modifiedBy"];
            if (Array.isArray(_data["chatUsers"])) {
                this.chatUsers = [] as any;
                for (let item of _data["chatUsers"])
                    this.chatUsers!.push(ChatUserDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ChatDto {
        data = typeof data === 'object' ? data : {};
        let result = new ChatDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["refTableId"] = this.refTableId;
        data["refRowId"] = this.refRowId;
        data["txt"] = this.txt;
        data["isPrivate"] = this.isPrivate;
        data["created"] = this.created ? this.created.toISOString() : undefined as any;
        data["createdBy"] = this.createdBy;
        data["modified"] = this.modified ? this.modified.toISOString() : undefined as any;
        data["modifiedBy"] = this.modifiedBy;
        if (Array.isArray(this.chatUsers)) {
            data["chatUsers"] = [];
            for (let item of this.chatUsers)
                data["chatUsers"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IChatDto {
    id?: number | undefined;
    refTableId?: number;
    refRowId?: number;
    txt?: string | undefined;
    isPrivate?: boolean;
    created?: Date | undefined;
    createdBy?: number | undefined;
    modified?: Date | undefined;
    modifiedBy?: number | undefined;
    chatUsers?: ChatUserDto[] | undefined;
}

export class ChatUserDto implements IChatUserDto {
    id?: number | undefined;
    chatId?: number;
    userId?: number;
    isRead?: boolean;
    isNotified?: boolean;
    created?: Date | undefined;
    createdBy?: number | undefined;
    modified?: Date | undefined;
    modifiedBy?: number | undefined;

    constructor(data?: IChatUserDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.chatId = _data["chatId"];
            this.userId = _data["userId"];
            this.isRead = _data["isRead"];
            this.isNotified = _data["isNotified"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : undefined as any;
            this.createdBy = _data["createdBy"];
            this.modified = _data["modified"] ? new Date(_data["modified"].toString()) : undefined as any;
            this.modifiedBy = _data["modifiedBy"];
        }
    }

    static fromJS(data: any): ChatUserDto {
        data = typeof data === 'object' ? data : {};
        let result = new ChatUserDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["chatId"] = this.chatId;
        data["userId"] = this.userId;
        data["isRead"] = this.isRead;
        data["isNotified"] = this.isNotified;
        data["created"] = this.created ? this.created.toISOString() : undefined as any;
        data["createdBy"] = this.createdBy;
        data["modified"] = this.modified ? this.modified.toISOString() : undefined as any;
        data["modifiedBy"] = this.modifiedBy;
        return data;
    }
}

export interface IChatUserDto {
    id?: number | undefined;
    chatId?: number;
    userId?: number;
    isRead?: boolean;
    isNotified?: boolean;
    created?: Date | undefined;
    createdBy?: number | undefined;
    modified?: Date | undefined;
    modifiedBy?: number | undefined;
}

export class CustInvoiceDocumentCommand implements ICustInvoiceDocumentCommand {
    id?: number | undefined;
    createPDF?: boolean;
    createDraft?: boolean;

    constructor(data?: ICustInvoiceDocumentCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.createPDF = _data["createPDF"];
            this.createDraft = _data["createDraft"];
        }
    }

    static fromJS(data: any): CustInvoiceDocumentCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CustInvoiceDocumentCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["createPDF"] = this.createPDF;
        data["createDraft"] = this.createDraft;
        return data;
    }
}

export interface ICustInvoiceDocumentCommand {
    id?: number | undefined;
    createPDF?: boolean;
    createDraft?: boolean;
}

export class LinkedAttachmentDto implements ILinkedAttachmentDto {
    id?: number;
    attachmentIndex?: number;
    fileName?: string | undefined;
    title?: string | undefined;
    fileExtension?: string | undefined;
    docType?: string | undefined;
    url?: string | undefined;
    originalFileName?: string | undefined;
    originalFileExtension?: string | undefined;
    originalUrl?: string | undefined;
    originalDocType?: string | undefined;
    folderName?: string | undefined;
    contentType?: string | undefined;
    created?: Date | undefined;
    modified?: Date | undefined;
    properties?: LinkedAttachmentOptionDto[];

    constructor(data?: ILinkedAttachmentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.attachmentIndex = _data["attachmentIndex"];
            this.fileName = _data["fileName"];
            this.title = _data["title"];
            this.fileExtension = _data["fileExtension"];
            this.docType = _data["docType"];
            this.url = _data["url"];
            this.originalFileName = _data["originalFileName"];
            this.originalFileExtension = _data["originalFileExtension"];
            this.originalUrl = _data["originalUrl"];
            this.originalDocType = _data["originalDocType"];
            this.folderName = _data["folderName"];
            this.contentType = _data["contentType"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : undefined as any;
            this.modified = _data["modified"] ? new Date(_data["modified"].toString()) : undefined as any;
            if (Array.isArray(_data["properties"])) {
                this.properties = [] as any;
                for (let item of _data["properties"])
                    this.properties!.push(LinkedAttachmentOptionDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): LinkedAttachmentDto {
        data = typeof data === 'object' ? data : {};
        let result = new LinkedAttachmentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["attachmentIndex"] = this.attachmentIndex;
        data["fileName"] = this.fileName;
        data["title"] = this.title;
        data["fileExtension"] = this.fileExtension;
        data["docType"] = this.docType;
        data["url"] = this.url;
        data["originalFileName"] = this.originalFileName;
        data["originalFileExtension"] = this.originalFileExtension;
        data["originalUrl"] = this.originalUrl;
        data["originalDocType"] = this.originalDocType;
        data["folderName"] = this.folderName;
        data["contentType"] = this.contentType;
        data["created"] = this.created ? this.created.toISOString() : undefined as any;
        data["modified"] = this.modified ? this.modified.toISOString() : undefined as any;
        if (Array.isArray(this.properties)) {
            data["properties"] = [];
            for (let item of this.properties)
                data["properties"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ILinkedAttachmentDto {
    id?: number;
    attachmentIndex?: number;
    fileName?: string | undefined;
    title?: string | undefined;
    fileExtension?: string | undefined;
    docType?: string | undefined;
    url?: string | undefined;
    originalFileName?: string | undefined;
    originalFileExtension?: string | undefined;
    originalUrl?: string | undefined;
    originalDocType?: string | undefined;
    folderName?: string | undefined;
    contentType?: string | undefined;
    created?: Date | undefined;
    modified?: Date | undefined;
    properties?: LinkedAttachmentOptionDto[];
}

export class LinkedAttachmentOptionDto implements ILinkedAttachmentOptionDto {
    key?: string;
    value?: string;

    constructor(data?: ILinkedAttachmentOptionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.key = _data["key"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): LinkedAttachmentOptionDto {
        data = typeof data === 'object' ? data : {};
        let result = new LinkedAttachmentOptionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["key"] = this.key;
        data["value"] = this.value;
        return data;
    }
}

export interface ILinkedAttachmentOptionDto {
    key?: string;
    value?: string;
}

export class DataNotificationRunCommand implements IDataNotificationRunCommand {
    dataNotificationId?: number;

    constructor(data?: IDataNotificationRunCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dataNotificationId = _data["dataNotificationId"];
        }
    }

    static fromJS(data: any): DataNotificationRunCommand {
        data = typeof data === 'object' ? data : {};
        let result = new DataNotificationRunCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dataNotificationId"] = this.dataNotificationId;
        return data;
    }
}

export interface IDataNotificationRunCommand {
    dataNotificationId?: number;
}

export class DebtorDto implements IDebtorDto {
    source?: number;
    id?: number;
    num?: string | undefined;
    name?: string | undefined;
    address1?: string | undefined;
    address2?: string | undefined;
    address3?: string | undefined;
    country?: string | undefined;
    attention?: string | undefined;
    phone?: string | undefined;
    mobile?: string | undefined;
    email?: string | undefined;
    group?: string | undefined;
    approved?: number;
    currency?: string | undefined;
    language?: number;
    paymentTerm?: string | undefined;
    blocked?: number | undefined;
    taxCode?: string | undefined;
    taxId?: string | undefined;
    eInvoicingId?: string | undefined;
    eInvoicing?: number | undefined;
    isTemplate?: number;
    description?: string | undefined;

    constructor(data?: IDebtorDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.source = _data["source"];
            this.id = _data["id"];
            this.num = _data["num"];
            this.name = _data["name"];
            this.address1 = _data["address1"];
            this.address2 = _data["address2"];
            this.address3 = _data["address3"];
            this.country = _data["country"];
            this.attention = _data["attention"];
            this.phone = _data["phone"];
            this.mobile = _data["mobile"];
            this.email = _data["email"];
            this.group = _data["group"];
            this.approved = _data["approved"];
            this.currency = _data["currency"];
            this.language = _data["language"];
            this.paymentTerm = _data["paymentTerm"];
            this.blocked = _data["blocked"];
            this.taxCode = _data["taxCode"];
            this.taxId = _data["taxId"];
            this.eInvoicingId = _data["eInvoicingId"];
            this.eInvoicing = _data["eInvoicing"];
            this.isTemplate = _data["isTemplate"];
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): DebtorDto {
        data = typeof data === 'object' ? data : {};
        let result = new DebtorDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["source"] = this.source;
        data["id"] = this.id;
        data["num"] = this.num;
        data["name"] = this.name;
        data["address1"] = this.address1;
        data["address2"] = this.address2;
        data["address3"] = this.address3;
        data["country"] = this.country;
        data["attention"] = this.attention;
        data["phone"] = this.phone;
        data["mobile"] = this.mobile;
        data["email"] = this.email;
        data["group"] = this.group;
        data["approved"] = this.approved;
        data["currency"] = this.currency;
        data["language"] = this.language;
        data["paymentTerm"] = this.paymentTerm;
        data["blocked"] = this.blocked;
        data["taxCode"] = this.taxCode;
        data["taxId"] = this.taxId;
        data["eInvoicingId"] = this.eInvoicingId;
        data["eInvoicing"] = this.eInvoicing;
        data["isTemplate"] = this.isTemplate;
        data["description"] = this.description;
        return data;
    }
}

export interface IDebtorDto {
    source?: number;
    id?: number;
    num?: string | undefined;
    name?: string | undefined;
    address1?: string | undefined;
    address2?: string | undefined;
    address3?: string | undefined;
    country?: string | undefined;
    attention?: string | undefined;
    phone?: string | undefined;
    mobile?: string | undefined;
    email?: string | undefined;
    group?: string | undefined;
    approved?: number;
    currency?: string | undefined;
    language?: number;
    paymentTerm?: string | undefined;
    blocked?: number | undefined;
    taxCode?: string | undefined;
    taxId?: string | undefined;
    eInvoicingId?: string | undefined;
    eInvoicing?: number | undefined;
    isTemplate?: number;
    description?: string | undefined;
}

export class DtoBaseId implements IDtoBaseId {
    id?: number | undefined;

    constructor(data?: IDtoBaseId) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): DtoBaseId {
        data = typeof data === 'object' ? data : {};
        let result = new DtoBaseId();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}

export interface IDtoBaseId {
    id?: number | undefined;
}

export class DtoBaseIdHistory extends DtoBaseId implements IDtoBaseIdHistory {
    created?: Date | undefined;
    createdBy?: number | undefined;
    modified?: Date | undefined;
    modifiedBy?: number | undefined;

    constructor(data?: IDtoBaseIdHistory) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.created = _data["created"] ? new Date(_data["created"].toString()) : undefined as any;
            this.createdBy = _data["createdBy"];
            this.modified = _data["modified"] ? new Date(_data["modified"].toString()) : undefined as any;
            this.modifiedBy = _data["modifiedBy"];
        }
    }

    static override fromJS(data: any): DtoBaseIdHistory {
        data = typeof data === 'object' ? data : {};
        let result = new DtoBaseIdHistory();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["created"] = this.created ? this.created.toISOString() : undefined as any;
        data["createdBy"] = this.createdBy;
        data["modified"] = this.modified ? this.modified.toISOString() : undefined as any;
        data["modifiedBy"] = this.modifiedBy;
        super.toJSON(data);
        return data;
    }
}

export interface IDtoBaseIdHistory extends IDtoBaseId {
    created?: Date | undefined;
    createdBy?: number | undefined;
    modified?: Date | undefined;
    modifiedBy?: number | undefined;
}

export class DtoBaseIdHistoryName extends DtoBaseIdHistory implements IDtoBaseIdHistoryName {
    name?: string | undefined;

    constructor(data?: IDtoBaseIdHistoryName) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.name = _data["name"];
        }
    }

    static override fromJS(data: any): DtoBaseIdHistoryName {
        data = typeof data === 'object' ? data : {};
        let result = new DtoBaseIdHistoryName();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        super.toJSON(data);
        return data;
    }
}

export interface IDtoBaseIdHistoryName extends IDtoBaseIdHistory {
    name?: string | undefined;
}

export class DtoBaseIdHistoryNameNum extends DtoBaseIdHistoryName implements IDtoBaseIdHistoryNameNum {
    num?: string | undefined;

    constructor(data?: IDtoBaseIdHistoryNameNum) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.num = _data["num"];
        }
    }

    static override fromJS(data: any): DtoBaseIdHistoryNameNum {
        data = typeof data === 'object' ? data : {};
        let result = new DtoBaseIdHistoryNameNum();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["num"] = this.num;
        super.toJSON(data);
        return data;
    }
}

export interface IDtoBaseIdHistoryNameNum extends IDtoBaseIdHistoryName {
    num?: string | undefined;
}

export class SalesOrderDto extends DtoBaseIdHistoryNameNum implements ISalesOrderDto {
    status?: number | undefined;
    type?: string | undefined;
    channel?: string | undefined;
    channelOrder?: string | undefined;
    outboundOrderType?: string | undefined;
    currency?: string | undefined;
    amountCurExTax?: number | undefined;
    amountCurTax?: number | undefined;
    amountCur?: number | undefined;
    custNote?: string | undefined;
    custType?: string | undefined;
    custNum?: string | undefined;
    custEAN?: string | undefined;
    custVATNum?: string | undefined;
    custEmail?: string | undefined;
    custPhone?: string | undefined;
    carrier?: string | undefined;
    carrierServicePoint?: string | undefined;
    shipToBillAddress?: boolean | undefined;
    shipFirstName?: string | undefined;
    shipLastName?: string | undefined;
    shipCompanyName?: string | undefined;
    shipAddress1?: string | undefined;
    shipAddress2?: string | undefined;
    shipPostalCode?: string | undefined;
    shipPostalDistrict?: string | undefined;
    shipCountryCode?: string | undefined;
    billFirstName?: string | undefined;
    billLastName?: string | undefined;
    billCompanyName?: string | undefined;
    billAddress1?: string | undefined;
    billAddress2?: string | undefined;
    billPostalCode?: string | undefined;
    billPostalDistrict?: string | undefined;
    billCountryCode?: string | undefined;
    paymentType?: string | undefined;
    paymentReference?: string | undefined;
    orderDate?: Date | undefined;
    orderChangeDate?: Date | undefined;
    reservedDate?: Date | undefined;
    shipDate?: Date | undefined;
    invoiceDate?: Date | undefined;
    invoiceNum?: string | undefined;
    captureDate?: Date | undefined;
    settleDate?: Date | undefined;
    createdJobId?: number | undefined;
    modifiedJobId?: number | undefined;

    constructor(data?: ISalesOrderDto) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.status = _data["status"];
            this.type = _data["type"];
            this.channel = _data["channel"];
            this.channelOrder = _data["channelOrder"];
            this.outboundOrderType = _data["outboundOrderType"];
            this.currency = _data["currency"];
            this.amountCurExTax = _data["amountCurExTax"];
            this.amountCurTax = _data["amountCurTax"];
            this.amountCur = _data["amountCur"];
            this.custNote = _data["custNote"];
            this.custType = _data["custType"];
            this.custNum = _data["custNum"];
            this.custEAN = _data["custEAN"];
            this.custVATNum = _data["custVATNum"];
            this.custEmail = _data["custEmail"];
            this.custPhone = _data["custPhone"];
            this.carrier = _data["carrier"];
            this.carrierServicePoint = _data["carrierServicePoint"];
            this.shipToBillAddress = _data["shipToBillAddress"];
            this.shipFirstName = _data["shipFirstName"];
            this.shipLastName = _data["shipLastName"];
            this.shipCompanyName = _data["shipCompanyName"];
            this.shipAddress1 = _data["shipAddress1"];
            this.shipAddress2 = _data["shipAddress2"];
            this.shipPostalCode = _data["shipPostalCode"];
            this.shipPostalDistrict = _data["shipPostalDistrict"];
            this.shipCountryCode = _data["shipCountryCode"];
            this.billFirstName = _data["billFirstName"];
            this.billLastName = _data["billLastName"];
            this.billCompanyName = _data["billCompanyName"];
            this.billAddress1 = _data["billAddress1"];
            this.billAddress2 = _data["billAddress2"];
            this.billPostalCode = _data["billPostalCode"];
            this.billPostalDistrict = _data["billPostalDistrict"];
            this.billCountryCode = _data["billCountryCode"];
            this.paymentType = _data["paymentType"];
            this.paymentReference = _data["paymentReference"];
            this.orderDate = _data["orderDate"] ? new Date(_data["orderDate"].toString()) : undefined as any;
            this.orderChangeDate = _data["orderChangeDate"] ? new Date(_data["orderChangeDate"].toString()) : undefined as any;
            this.reservedDate = _data["reservedDate"] ? new Date(_data["reservedDate"].toString()) : undefined as any;
            this.shipDate = _data["shipDate"] ? new Date(_data["shipDate"].toString()) : undefined as any;
            this.invoiceDate = _data["invoiceDate"] ? new Date(_data["invoiceDate"].toString()) : undefined as any;
            this.invoiceNum = _data["invoiceNum"];
            this.captureDate = _data["captureDate"] ? new Date(_data["captureDate"].toString()) : undefined as any;
            this.settleDate = _data["settleDate"] ? new Date(_data["settleDate"].toString()) : undefined as any;
            this.createdJobId = _data["createdJobId"];
            this.modifiedJobId = _data["modifiedJobId"];
        }
    }

    static override fromJS(data: any): SalesOrderDto {
        data = typeof data === 'object' ? data : {};
        let result = new SalesOrderDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        data["type"] = this.type;
        data["channel"] = this.channel;
        data["channelOrder"] = this.channelOrder;
        data["outboundOrderType"] = this.outboundOrderType;
        data["currency"] = this.currency;
        data["amountCurExTax"] = this.amountCurExTax;
        data["amountCurTax"] = this.amountCurTax;
        data["amountCur"] = this.amountCur;
        data["custNote"] = this.custNote;
        data["custType"] = this.custType;
        data["custNum"] = this.custNum;
        data["custEAN"] = this.custEAN;
        data["custVATNum"] = this.custVATNum;
        data["custEmail"] = this.custEmail;
        data["custPhone"] = this.custPhone;
        data["carrier"] = this.carrier;
        data["carrierServicePoint"] = this.carrierServicePoint;
        data["shipToBillAddress"] = this.shipToBillAddress;
        data["shipFirstName"] = this.shipFirstName;
        data["shipLastName"] = this.shipLastName;
        data["shipCompanyName"] = this.shipCompanyName;
        data["shipAddress1"] = this.shipAddress1;
        data["shipAddress2"] = this.shipAddress2;
        data["shipPostalCode"] = this.shipPostalCode;
        data["shipPostalDistrict"] = this.shipPostalDistrict;
        data["shipCountryCode"] = this.shipCountryCode;
        data["billFirstName"] = this.billFirstName;
        data["billLastName"] = this.billLastName;
        data["billCompanyName"] = this.billCompanyName;
        data["billAddress1"] = this.billAddress1;
        data["billAddress2"] = this.billAddress2;
        data["billPostalCode"] = this.billPostalCode;
        data["billPostalDistrict"] = this.billPostalDistrict;
        data["billCountryCode"] = this.billCountryCode;
        data["paymentType"] = this.paymentType;
        data["paymentReference"] = this.paymentReference;
        data["orderDate"] = this.orderDate ? this.orderDate.toISOString() : undefined as any;
        data["orderChangeDate"] = this.orderChangeDate ? this.orderChangeDate.toISOString() : undefined as any;
        data["reservedDate"] = this.reservedDate ? this.reservedDate.toISOString() : undefined as any;
        data["shipDate"] = this.shipDate ? this.shipDate.toISOString() : undefined as any;
        data["invoiceDate"] = this.invoiceDate ? this.invoiceDate.toISOString() : undefined as any;
        data["invoiceNum"] = this.invoiceNum;
        data["captureDate"] = this.captureDate ? this.captureDate.toISOString() : undefined as any;
        data["settleDate"] = this.settleDate ? this.settleDate.toISOString() : undefined as any;
        data["createdJobId"] = this.createdJobId;
        data["modifiedJobId"] = this.modifiedJobId;
        super.toJSON(data);
        return data;
    }
}

export interface ISalesOrderDto extends IDtoBaseIdHistoryNameNum {
    status?: number | undefined;
    type?: string | undefined;
    channel?: string | undefined;
    channelOrder?: string | undefined;
    outboundOrderType?: string | undefined;
    currency?: string | undefined;
    amountCurExTax?: number | undefined;
    amountCurTax?: number | undefined;
    amountCur?: number | undefined;
    custNote?: string | undefined;
    custType?: string | undefined;
    custNum?: string | undefined;
    custEAN?: string | undefined;
    custVATNum?: string | undefined;
    custEmail?: string | undefined;
    custPhone?: string | undefined;
    carrier?: string | undefined;
    carrierServicePoint?: string | undefined;
    shipToBillAddress?: boolean | undefined;
    shipFirstName?: string | undefined;
    shipLastName?: string | undefined;
    shipCompanyName?: string | undefined;
    shipAddress1?: string | undefined;
    shipAddress2?: string | undefined;
    shipPostalCode?: string | undefined;
    shipPostalDistrict?: string | undefined;
    shipCountryCode?: string | undefined;
    billFirstName?: string | undefined;
    billLastName?: string | undefined;
    billCompanyName?: string | undefined;
    billAddress1?: string | undefined;
    billAddress2?: string | undefined;
    billPostalCode?: string | undefined;
    billPostalDistrict?: string | undefined;
    billCountryCode?: string | undefined;
    paymentType?: string | undefined;
    paymentReference?: string | undefined;
    orderDate?: Date | undefined;
    orderChangeDate?: Date | undefined;
    reservedDate?: Date | undefined;
    shipDate?: Date | undefined;
    invoiceDate?: Date | undefined;
    invoiceNum?: string | undefined;
    captureDate?: Date | undefined;
    settleDate?: Date | undefined;
    createdJobId?: number | undefined;
    modifiedJobId?: number | undefined;
}

export class CustomerCreateCommand implements ICustomerCreateCommand {
    debtorSegments?: DebtorDto[];

    constructor(data?: ICustomerCreateCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["debtorSegments"])) {
                this.debtorSegments = [] as any;
                for (let item of _data["debtorSegments"])
                    this.debtorSegments!.push(DebtorDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CustomerCreateCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CustomerCreateCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.debtorSegments)) {
            data["debtorSegments"] = [];
            for (let item of this.debtorSegments)
                data["debtorSegments"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface ICustomerCreateCommand {
    debtorSegments?: DebtorDto[];
}

export class ExchangeMsgSubscriberLogDto implements IExchangeMsgSubscriberLogDto {
    id?: number | undefined;
    msgSubscriberId?: number;
    log?: string | undefined;
    created?: Date | undefined;

    constructor(data?: IExchangeMsgSubscriberLogDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.msgSubscriberId = _data["msgSubscriberId"];
            this.log = _data["log"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): ExchangeMsgSubscriberLogDto {
        data = typeof data === 'object' ? data : {};
        let result = new ExchangeMsgSubscriberLogDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["msgSubscriberId"] = this.msgSubscriberId;
        data["log"] = this.log;
        data["created"] = this.created ? this.created.toISOString() : undefined as any;
        return data;
    }
}

export interface IExchangeMsgSubscriberLogDto {
    id?: number | undefined;
    msgSubscriberId?: number;
    log?: string | undefined;
    created?: Date | undefined;
}

export class HovedkontraktViewVm implements IHovedkontraktViewVm {
    userId?: string | undefined;
    userName?: string | undefined;
    userNameShort?: string | undefined;
    hovedkontraktViewDto?: HovedkontraktViewDto[] | undefined;
    varenumreDto?: VarenumreDto[] | undefined;
    forfatterDto?: ForfatterDto[] | undefined;
    valutaKoderDto?: ValutaKoderDto[] | undefined;

    constructor(data?: IHovedkontraktViewVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.userName = _data["userName"];
            this.userNameShort = _data["userNameShort"];
            if (Array.isArray(_data["hovedkontraktViewDto"])) {
                this.hovedkontraktViewDto = [] as any;
                for (let item of _data["hovedkontraktViewDto"])
                    this.hovedkontraktViewDto!.push(HovedkontraktViewDto.fromJS(item));
            }
            if (Array.isArray(_data["varenumreDto"])) {
                this.varenumreDto = [] as any;
                for (let item of _data["varenumreDto"])
                    this.varenumreDto!.push(VarenumreDto.fromJS(item));
            }
            if (Array.isArray(_data["forfatterDto"])) {
                this.forfatterDto = [] as any;
                for (let item of _data["forfatterDto"])
                    this.forfatterDto!.push(ForfatterDto.fromJS(item));
            }
            if (Array.isArray(_data["valutaKoderDto"])) {
                this.valutaKoderDto = [] as any;
                for (let item of _data["valutaKoderDto"])
                    this.valutaKoderDto!.push(ValutaKoderDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): HovedkontraktViewVm {
        data = typeof data === 'object' ? data : {};
        let result = new HovedkontraktViewVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["userName"] = this.userName;
        data["userNameShort"] = this.userNameShort;
        if (Array.isArray(this.hovedkontraktViewDto)) {
            data["hovedkontraktViewDto"] = [];
            for (let item of this.hovedkontraktViewDto)
                data["hovedkontraktViewDto"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.varenumreDto)) {
            data["varenumreDto"] = [];
            for (let item of this.varenumreDto)
                data["varenumreDto"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.forfatterDto)) {
            data["forfatterDto"] = [];
            for (let item of this.forfatterDto)
                data["forfatterDto"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.valutaKoderDto)) {
            data["valutaKoderDto"] = [];
            for (let item of this.valutaKoderDto)
                data["valutaKoderDto"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IHovedkontraktViewVm {
    userId?: string | undefined;
    userName?: string | undefined;
    userNameShort?: string | undefined;
    hovedkontraktViewDto?: HovedkontraktViewDto[] | undefined;
    varenumreDto?: VarenumreDto[] | undefined;
    forfatterDto?: ForfatterDto[] | undefined;
    valutaKoderDto?: ValutaKoderDto[] | undefined;
}

export class HovedkontraktViewDto implements IHovedkontraktViewDto {
    id?: number;
    hkontrakt?: number | undefined;
    hkontraktStr?: string | undefined;
    bogtitel?: string | undefined;
    type?: number | undefined;
    kontraktType?: string | undefined;
    gruppe?: number | undefined;
    gruppeNavn?: string | undefined;
    redaktor?: number | undefined;
    redaktorNavn?: string | undefined;
    afregnTermin?: number | undefined;
    afregnTerminNavn?: string | undefined;
    formaal?: number | undefined;
    formaalNavn?: string | undefined;
    afregningstype?: number | undefined;
    afregningstypeNavn?: string | undefined;
    startdato?: Date | undefined;
    budget?: boolean | undefined;
    specielAfregning?: string | undefined;
    forlag?: number | undefined;
    oprindeligTitel?: string | undefined;
    oprindeligForfatter?: string | undefined;
    infoTekst?: string | undefined;
    anmeldelse?: boolean | undefined;
    salgsark?: boolean | undefined;
    fastprisAfregning?: boolean | undefined;
    guidingPrice?: boolean | undefined;
    template?: number | undefined;
    agent?: number | undefined;
    agentId?: string | undefined;
    agentNavn?: string | undefined;
    forfatter?: number | undefined;
    forfatterId?: string | undefined;
    forfatterNavn?: string | undefined;
    isbn?: string | undefined;
    ssmaTimeStamp?: string | undefined;
    linkedAttachment?: LinkedAttachmentDto[];

    constructor(data?: IHovedkontraktViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.hkontrakt = _data["hkontrakt"];
            this.hkontraktStr = _data["hkontraktStr"];
            this.bogtitel = _data["bogtitel"];
            this.type = _data["type"];
            this.kontraktType = _data["kontraktType"];
            this.gruppe = _data["gruppe"];
            this.gruppeNavn = _data["gruppeNavn"];
            this.redaktor = _data["redaktor"];
            this.redaktorNavn = _data["redaktorNavn"];
            this.afregnTermin = _data["afregnTermin"];
            this.afregnTerminNavn = _data["afregnTerminNavn"];
            this.formaal = _data["formaal"];
            this.formaalNavn = _data["formaalNavn"];
            this.afregningstype = _data["afregningstype"];
            this.afregningstypeNavn = _data["afregningstypeNavn"];
            this.startdato = _data["startdato"] ? new Date(_data["startdato"].toString()) : undefined as any;
            this.budget = _data["budget"];
            this.specielAfregning = _data["specielAfregning"];
            this.forlag = _data["forlag"];
            this.oprindeligTitel = _data["oprindeligTitel"];
            this.oprindeligForfatter = _data["oprindeligForfatter"];
            this.infoTekst = _data["infoTekst"];
            this.anmeldelse = _data["anmeldelse"];
            this.salgsark = _data["salgsark"];
            this.fastprisAfregning = _data["fastprisAfregning"];
            this.guidingPrice = _data["guidingPrice"];
            this.template = _data["template"];
            this.agent = _data["agent"];
            this.agentId = _data["agentId"];
            this.agentNavn = _data["agentNavn"];
            this.forfatter = _data["forfatter"];
            this.forfatterId = _data["forfatterId"];
            this.forfatterNavn = _data["forfatterNavn"];
            this.isbn = _data["isbn"];
            this.ssmaTimeStamp = _data["ssmaTimeStamp"];
            if (Array.isArray(_data["linkedAttachment"])) {
                this.linkedAttachment = [] as any;
                for (let item of _data["linkedAttachment"])
                    this.linkedAttachment!.push(LinkedAttachmentDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): HovedkontraktViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new HovedkontraktViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["hkontrakt"] = this.hkontrakt;
        data["hkontraktStr"] = this.hkontraktStr;
        data["bogtitel"] = this.bogtitel;
        data["type"] = this.type;
        data["kontraktType"] = this.kontraktType;
        data["gruppe"] = this.gruppe;
        data["gruppeNavn"] = this.gruppeNavn;
        data["redaktor"] = this.redaktor;
        data["redaktorNavn"] = this.redaktorNavn;
        data["afregnTermin"] = this.afregnTermin;
        data["afregnTerminNavn"] = this.afregnTerminNavn;
        data["formaal"] = this.formaal;
        data["formaalNavn"] = this.formaalNavn;
        data["afregningstype"] = this.afregningstype;
        data["afregningstypeNavn"] = this.afregningstypeNavn;
        data["startdato"] = this.startdato ? this.startdato.toISOString() : undefined as any;
        data["budget"] = this.budget;
        data["specielAfregning"] = this.specielAfregning;
        data["forlag"] = this.forlag;
        data["oprindeligTitel"] = this.oprindeligTitel;
        data["oprindeligForfatter"] = this.oprindeligForfatter;
        data["infoTekst"] = this.infoTekst;
        data["anmeldelse"] = this.anmeldelse;
        data["salgsark"] = this.salgsark;
        data["fastprisAfregning"] = this.fastprisAfregning;
        data["guidingPrice"] = this.guidingPrice;
        data["template"] = this.template;
        data["agent"] = this.agent;
        data["agentId"] = this.agentId;
        data["agentNavn"] = this.agentNavn;
        data["forfatter"] = this.forfatter;
        data["forfatterId"] = this.forfatterId;
        data["forfatterNavn"] = this.forfatterNavn;
        data["isbn"] = this.isbn;
        data["ssmaTimeStamp"] = this.ssmaTimeStamp;
        if (Array.isArray(this.linkedAttachment)) {
            data["linkedAttachment"] = [];
            for (let item of this.linkedAttachment)
                data["linkedAttachment"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IHovedkontraktViewDto {
    id?: number;
    hkontrakt?: number | undefined;
    hkontraktStr?: string | undefined;
    bogtitel?: string | undefined;
    type?: number | undefined;
    kontraktType?: string | undefined;
    gruppe?: number | undefined;
    gruppeNavn?: string | undefined;
    redaktor?: number | undefined;
    redaktorNavn?: string | undefined;
    afregnTermin?: number | undefined;
    afregnTerminNavn?: string | undefined;
    formaal?: number | undefined;
    formaalNavn?: string | undefined;
    afregningstype?: number | undefined;
    afregningstypeNavn?: string | undefined;
    startdato?: Date | undefined;
    budget?: boolean | undefined;
    specielAfregning?: string | undefined;
    forlag?: number | undefined;
    oprindeligTitel?: string | undefined;
    oprindeligForfatter?: string | undefined;
    infoTekst?: string | undefined;
    anmeldelse?: boolean | undefined;
    salgsark?: boolean | undefined;
    fastprisAfregning?: boolean | undefined;
    guidingPrice?: boolean | undefined;
    template?: number | undefined;
    agent?: number | undefined;
    agentId?: string | undefined;
    agentNavn?: string | undefined;
    forfatter?: number | undefined;
    forfatterId?: string | undefined;
    forfatterNavn?: string | undefined;
    isbn?: string | undefined;
    ssmaTimeStamp?: string | undefined;
    linkedAttachment?: LinkedAttachmentDto[];
}

export class VarenumreDto implements IVarenumreDto {
    id?: number;
    isbn?: string | undefined;
    vareNr?: string | undefined;
    hkontrakt?: number | undefined;
    ukontrakt?: number | undefined;
    arbTitel?: string | undefined;
    bogtitel?: string | undefined;
    bogType?: number | undefined;
    opretDato?: Date | undefined;
    udgivelsesDato?: Date | undefined;
    lukketDato?: Date | undefined;
    bogformat?: number | undefined;
    indbinding?: number | undefined;
    editions?: number | undefined;
    endeligSalgspris?: number | undefined;
    forventetSalgspris?: number | undefined;
    logRef?: number | undefined;
    kladde?: number | undefined;
    ssmaTimeStamp?: string | undefined;

    constructor(data?: IVarenumreDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.isbn = _data["isbn"];
            this.vareNr = _data["vareNr"];
            this.hkontrakt = _data["hkontrakt"];
            this.ukontrakt = _data["ukontrakt"];
            this.arbTitel = _data["arbTitel"];
            this.bogtitel = _data["bogtitel"];
            this.bogType = _data["bogType"];
            this.opretDato = _data["opretDato"] ? new Date(_data["opretDato"].toString()) : undefined as any;
            this.udgivelsesDato = _data["udgivelsesDato"] ? new Date(_data["udgivelsesDato"].toString()) : undefined as any;
            this.lukketDato = _data["lukketDato"] ? new Date(_data["lukketDato"].toString()) : undefined as any;
            this.bogformat = _data["bogformat"];
            this.indbinding = _data["indbinding"];
            this.editions = _data["editions"];
            this.endeligSalgspris = _data["endeligSalgspris"];
            this.forventetSalgspris = _data["forventetSalgspris"];
            this.logRef = _data["logRef"];
            this.kladde = _data["kladde"];
            this.ssmaTimeStamp = _data["ssmaTimeStamp"];
        }
    }

    static fromJS(data: any): VarenumreDto {
        data = typeof data === 'object' ? data : {};
        let result = new VarenumreDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["isbn"] = this.isbn;
        data["vareNr"] = this.vareNr;
        data["hkontrakt"] = this.hkontrakt;
        data["ukontrakt"] = this.ukontrakt;
        data["arbTitel"] = this.arbTitel;
        data["bogtitel"] = this.bogtitel;
        data["bogType"] = this.bogType;
        data["opretDato"] = this.opretDato ? this.opretDato.toISOString() : undefined as any;
        data["udgivelsesDato"] = this.udgivelsesDato ? this.udgivelsesDato.toISOString() : undefined as any;
        data["lukketDato"] = this.lukketDato ? this.lukketDato.toISOString() : undefined as any;
        data["bogformat"] = this.bogformat;
        data["indbinding"] = this.indbinding;
        data["editions"] = this.editions;
        data["endeligSalgspris"] = this.endeligSalgspris;
        data["forventetSalgspris"] = this.forventetSalgspris;
        data["logRef"] = this.logRef;
        data["kladde"] = this.kladde;
        data["ssmaTimeStamp"] = this.ssmaTimeStamp;
        return data;
    }
}

export interface IVarenumreDto {
    id?: number;
    isbn?: string | undefined;
    vareNr?: string | undefined;
    hkontrakt?: number | undefined;
    ukontrakt?: number | undefined;
    arbTitel?: string | undefined;
    bogtitel?: string | undefined;
    bogType?: number | undefined;
    opretDato?: Date | undefined;
    udgivelsesDato?: Date | undefined;
    lukketDato?: Date | undefined;
    bogformat?: number | undefined;
    indbinding?: number | undefined;
    editions?: number | undefined;
    endeligSalgspris?: number | undefined;
    forventetSalgspris?: number | undefined;
    logRef?: number | undefined;
    kladde?: number | undefined;
    ssmaTimeStamp?: string | undefined;
}

export class ForfatterDto implements IForfatterDto {
    id?: number | undefined;
    forfatterId?: string | undefined;
    navn?: string | undefined;
    navnId?: string | undefined;
    idNavn?: string | undefined;
    adresse1?: string | undefined;
    adresse2?: string | undefined;
    postNr?: string | undefined;
    zipcity?: string | undefined;
    land?: string | undefined;
    telefonNr?: string | undefined;
    email?: string | undefined;
    bankRegNr?: string | undefined;
    kontoNr?: string | undefined;
    swift?: string | undefined;
    iban?: string | undefined;
    cvrCpr?: string | undefined;
    moms?: boolean | undefined;
    valuta?: number;
    attention?: string | undefined;
    bankKonto?: string | undefined;
    logRef?: number | undefined;
    inAktiv?: boolean | undefined;
    kladde?: number | undefined;
    ssmaTimeStamp?: string | undefined;

    constructor(data?: IForfatterDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.forfatterId = _data["forfatterId"];
            this.navn = _data["navn"];
            this.navnId = _data["navnId"];
            this.idNavn = _data["idNavn"];
            this.adresse1 = _data["adresse1"];
            this.adresse2 = _data["adresse2"];
            this.postNr = _data["postNr"];
            this.zipcity = _data["zipcity"];
            this.land = _data["land"];
            this.telefonNr = _data["telefonNr"];
            this.email = _data["email"];
            this.bankRegNr = _data["bankRegNr"];
            this.kontoNr = _data["kontoNr"];
            this.swift = _data["swift"];
            this.iban = _data["iban"];
            this.cvrCpr = _data["cvrCpr"];
            this.moms = _data["moms"];
            this.valuta = _data["valuta"];
            this.attention = _data["attention"];
            this.bankKonto = _data["bankKonto"];
            this.logRef = _data["logRef"];
            this.inAktiv = _data["inAktiv"];
            this.kladde = _data["kladde"];
            this.ssmaTimeStamp = _data["ssmaTimeStamp"];
        }
    }

    static fromJS(data: any): ForfatterDto {
        data = typeof data === 'object' ? data : {};
        let result = new ForfatterDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["forfatterId"] = this.forfatterId;
        data["navn"] = this.navn;
        data["navnId"] = this.navnId;
        data["idNavn"] = this.idNavn;
        data["adresse1"] = this.adresse1;
        data["adresse2"] = this.adresse2;
        data["postNr"] = this.postNr;
        data["zipcity"] = this.zipcity;
        data["land"] = this.land;
        data["telefonNr"] = this.telefonNr;
        data["email"] = this.email;
        data["bankRegNr"] = this.bankRegNr;
        data["kontoNr"] = this.kontoNr;
        data["swift"] = this.swift;
        data["iban"] = this.iban;
        data["cvrCpr"] = this.cvrCpr;
        data["moms"] = this.moms;
        data["valuta"] = this.valuta;
        data["attention"] = this.attention;
        data["bankKonto"] = this.bankKonto;
        data["logRef"] = this.logRef;
        data["inAktiv"] = this.inAktiv;
        data["kladde"] = this.kladde;
        data["ssmaTimeStamp"] = this.ssmaTimeStamp;
        return data;
    }
}

export interface IForfatterDto {
    id?: number | undefined;
    forfatterId?: string | undefined;
    navn?: string | undefined;
    navnId?: string | undefined;
    idNavn?: string | undefined;
    adresse1?: string | undefined;
    adresse2?: string | undefined;
    postNr?: string | undefined;
    zipcity?: string | undefined;
    land?: string | undefined;
    telefonNr?: string | undefined;
    email?: string | undefined;
    bankRegNr?: string | undefined;
    kontoNr?: string | undefined;
    swift?: string | undefined;
    iban?: string | undefined;
    cvrCpr?: string | undefined;
    moms?: boolean | undefined;
    valuta?: number;
    attention?: string | undefined;
    bankKonto?: string | undefined;
    logRef?: number | undefined;
    inAktiv?: boolean | undefined;
    kladde?: number | undefined;
    ssmaTimeStamp?: string | undefined;
}

export class ValutaKoderDto implements IValutaKoderDto {
    id?: number | undefined;
    valutaKode?: string | undefined;

    constructor(data?: IValutaKoderDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.valutaKode = _data["valutaKode"];
        }
    }

    static fromJS(data: any): ValutaKoderDto {
        data = typeof data === 'object' ? data : {};
        let result = new ValutaKoderDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["valutaKode"] = this.valutaKode;
        return data;
    }
}

export interface IValutaKoderDto {
    id?: number | undefined;
    valutaKode?: string | undefined;
}

export class UpdateHovedkontraktCommand implements IUpdateHovedkontraktCommand {
    id?: number;
    agent?: number | undefined;

    constructor(data?: IUpdateHovedkontraktCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.agent = _data["agent"];
        }
    }

    static fromJS(data: any): UpdateHovedkontraktCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateHovedkontraktCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["agent"] = this.agent;
        return data;
    }
}

export interface IUpdateHovedkontraktCommand {
    id?: number;
    agent?: number | undefined;
}

export class ContractViewDetailsVm implements IContractViewDetailsVm {
    projectNum?: number | undefined;
    hovedkontraktViewDto?: HovedkontraktViewDto | undefined;
    attachmentDtoList?: LinkedAttachmentDto[] | undefined;
    attachmentsSaveUrl?: string | undefined;
    attachmentsRemoveUrl?: string | undefined;

    constructor(data?: IContractViewDetailsVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.projectNum = _data["projectNum"];
            this.hovedkontraktViewDto = _data["hovedkontraktViewDto"] ? HovedkontraktViewDto.fromJS(_data["hovedkontraktViewDto"]) : undefined as any;
            if (Array.isArray(_data["attachmentDtoList"])) {
                this.attachmentDtoList = [] as any;
                for (let item of _data["attachmentDtoList"])
                    this.attachmentDtoList!.push(LinkedAttachmentDto.fromJS(item));
            }
            this.attachmentsSaveUrl = _data["attachmentsSaveUrl"];
            this.attachmentsRemoveUrl = _data["attachmentsRemoveUrl"];
        }
    }

    static fromJS(data: any): ContractViewDetailsVm {
        data = typeof data === 'object' ? data : {};
        let result = new ContractViewDetailsVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["projectNum"] = this.projectNum;
        data["hovedkontraktViewDto"] = this.hovedkontraktViewDto ? this.hovedkontraktViewDto.toJSON() : undefined as any;
        if (Array.isArray(this.attachmentDtoList)) {
            data["attachmentDtoList"] = [];
            for (let item of this.attachmentDtoList)
                data["attachmentDtoList"].push(item ? item.toJSON() : undefined as any);
        }
        data["attachmentsSaveUrl"] = this.attachmentsSaveUrl;
        data["attachmentsRemoveUrl"] = this.attachmentsRemoveUrl;
        return data;
    }
}

export interface IContractViewDetailsVm {
    projectNum?: number | undefined;
    hovedkontraktViewDto?: HovedkontraktViewDto | undefined;
    attachmentDtoList?: LinkedAttachmentDto[] | undefined;
    attachmentsSaveUrl?: string | undefined;
    attachmentsRemoveUrl?: string | undefined;
}

export class DtoBaseIdName extends DtoBaseId implements IDtoBaseIdName {
    name?: string | undefined;

    constructor(data?: IDtoBaseIdName) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.name = _data["name"];
        }
    }

    static override fromJS(data: any): DtoBaseIdName {
        data = typeof data === 'object' ? data : {};
        let result = new DtoBaseIdName();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        super.toJSON(data);
        return data;
    }
}

export interface IDtoBaseIdName extends IDtoBaseId {
    name?: string | undefined;
}

export class PartyExternalRefDto extends DtoBaseIdName implements IPartyExternalRefDto {
    externalRefType?: number | undefined;
    externalRefId?: number | undefined;
    externalRefNum?: string | undefined;
    externalRefMatchScore?: number | undefined;
    isCompany?: boolean;
    phone?: string | undefined;
    email?: string | undefined;
    coAddress?: string | undefined;
    address1?: string | undefined;
    address2?: string | undefined;
    address3?: string | undefined;
    zipCode?: string | undefined;
    city?: string | undefined;
    zipCodeCity?: string | undefined;
    countryCode?: string | undefined;
    countryName?: string | undefined;
    nace?: number | undefined;
    naceName?: string | undefined;
    status?: string | undefined;
    active?: boolean | undefined;

    constructor(data?: IPartyExternalRefDto) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.externalRefType = _data["externalRefType"];
            this.externalRefId = _data["externalRefId"];
            this.externalRefNum = _data["externalRefNum"];
            this.externalRefMatchScore = _data["externalRefMatchScore"];
            this.isCompany = _data["isCompany"];
            this.phone = _data["phone"];
            this.email = _data["email"];
            this.coAddress = _data["coAddress"];
            this.address1 = _data["address1"];
            this.address2 = _data["address2"];
            this.address3 = _data["address3"];
            this.zipCode = _data["zipCode"];
            this.city = _data["city"];
            this.zipCodeCity = _data["zipCodeCity"];
            this.countryCode = _data["countryCode"];
            this.countryName = _data["countryName"];
            this.nace = _data["nace"];
            this.naceName = _data["naceName"];
            this.status = _data["status"];
            this.active = _data["active"];
        }
    }

    static override fromJS(data: any): PartyExternalRefDto {
        data = typeof data === 'object' ? data : {};
        let result = new PartyExternalRefDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["externalRefType"] = this.externalRefType;
        data["externalRefId"] = this.externalRefId;
        data["externalRefNum"] = this.externalRefNum;
        data["externalRefMatchScore"] = this.externalRefMatchScore;
        data["isCompany"] = this.isCompany;
        data["phone"] = this.phone;
        data["email"] = this.email;
        data["coAddress"] = this.coAddress;
        data["address1"] = this.address1;
        data["address2"] = this.address2;
        data["address3"] = this.address3;
        data["zipCode"] = this.zipCode;
        data["city"] = this.city;
        data["zipCodeCity"] = this.zipCodeCity;
        data["countryCode"] = this.countryCode;
        data["countryName"] = this.countryName;
        data["nace"] = this.nace;
        data["naceName"] = this.naceName;
        data["status"] = this.status;
        data["active"] = this.active;
        super.toJSON(data);
        return data;
    }
}

export interface IPartyExternalRefDto extends IDtoBaseIdName {
    externalRefType?: number | undefined;
    externalRefId?: number | undefined;
    externalRefNum?: string | undefined;
    externalRefMatchScore?: number | undefined;
    isCompany?: boolean;
    phone?: string | undefined;
    email?: string | undefined;
    coAddress?: string | undefined;
    address1?: string | undefined;
    address2?: string | undefined;
    address3?: string | undefined;
    zipCode?: string | undefined;
    city?: string | undefined;
    zipCodeCity?: string | undefined;
    countryCode?: string | undefined;
    countryName?: string | undefined;
    nace?: number | undefined;
    naceName?: string | undefined;
    status?: string | undefined;
    active?: boolean | undefined;
}

export class PartyExternalRefSearchQuery implements IPartyExternalRefSearchQuery {
    searchCountry?: string | undefined;
    searchExternalRefId?: number | undefined;
    searchName?: string | undefined;

    constructor(data?: IPartyExternalRefSearchQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.searchCountry = _data["searchCountry"];
            this.searchExternalRefId = _data["searchExternalRefId"];
            this.searchName = _data["searchName"];
        }
    }

    static fromJS(data: any): PartyExternalRefSearchQuery {
        data = typeof data === 'object' ? data : {};
        let result = new PartyExternalRefSearchQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["searchCountry"] = this.searchCountry;
        data["searchExternalRefId"] = this.searchExternalRefId;
        data["searchName"] = this.searchName;
        return data;
    }
}

export interface IPartyExternalRefSearchQuery {
    searchCountry?: string | undefined;
    searchExternalRefId?: number | undefined;
    searchName?: string | undefined;
}

export class ProductSyncCommand implements IProductSyncCommand {
    productNums?: string[] | undefined;
    projectNums?: string[] | undefined;
    legacyIds?: number[] | undefined;
    legacySync?: boolean;
    budgetCreate?: boolean;
    budgetApprove?: boolean;

    constructor(data?: IProductSyncCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["productNums"])) {
                this.productNums = [] as any;
                for (let item of _data["productNums"])
                    this.productNums!.push(item);
            }
            if (Array.isArray(_data["projectNums"])) {
                this.projectNums = [] as any;
                for (let item of _data["projectNums"])
                    this.projectNums!.push(item);
            }
            if (Array.isArray(_data["legacyIds"])) {
                this.legacyIds = [] as any;
                for (let item of _data["legacyIds"])
                    this.legacyIds!.push(item);
            }
            this.legacySync = _data["legacySync"];
            this.budgetCreate = _data["budgetCreate"];
            this.budgetApprove = _data["budgetApprove"];
        }
    }

    static fromJS(data: any): ProductSyncCommand {
        data = typeof data === 'object' ? data : {};
        let result = new ProductSyncCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.productNums)) {
            data["productNums"] = [];
            for (let item of this.productNums)
                data["productNums"].push(item);
        }
        if (Array.isArray(this.projectNums)) {
            data["projectNums"] = [];
            for (let item of this.projectNums)
                data["projectNums"].push(item);
        }
        if (Array.isArray(this.legacyIds)) {
            data["legacyIds"] = [];
            for (let item of this.legacyIds)
                data["legacyIds"].push(item);
        }
        data["legacySync"] = this.legacySync;
        data["budgetCreate"] = this.budgetCreate;
        data["budgetApprove"] = this.budgetApprove;
        return data;
    }
}

export interface IProductSyncCommand {
    productNums?: string[] | undefined;
    projectNums?: string[] | undefined;
    legacyIds?: number[] | undefined;
    legacySync?: boolean;
    budgetCreate?: boolean;
    budgetApprove?: boolean;
}

export class AfregningstabelDto implements IAfregningstabelDto {
    hid?: number;
    fid?: number;
    antal?: number;
    procent?: number | undefined;
    forskud?: number | undefined;
    currency?: number | undefined;
    sortKey?: number | undefined;
    logRef?: number | undefined;
    ssmaTimeStamp?: string | undefined;
    kladde?: number | undefined;
    compositeKey?: string | undefined;
    fidNavigation?: ForfatterDto | undefined;

    constructor(data?: IAfregningstabelDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.hid = _data["hid"];
            this.fid = _data["fid"];
            this.antal = _data["antal"];
            this.procent = _data["procent"];
            this.forskud = _data["forskud"];
            this.currency = _data["currency"];
            this.sortKey = _data["sortKey"];
            this.logRef = _data["logRef"];
            this.ssmaTimeStamp = _data["ssmaTimeStamp"];
            this.kladde = _data["kladde"];
            this.compositeKey = _data["compositeKey"];
            this.fidNavigation = _data["fidNavigation"] ? ForfatterDto.fromJS(_data["fidNavigation"]) : undefined as any;
        }
    }

    static fromJS(data: any): AfregningstabelDto {
        data = typeof data === 'object' ? data : {};
        let result = new AfregningstabelDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["hid"] = this.hid;
        data["fid"] = this.fid;
        data["antal"] = this.antal;
        data["procent"] = this.procent;
        data["forskud"] = this.forskud;
        data["currency"] = this.currency;
        data["sortKey"] = this.sortKey;
        data["logRef"] = this.logRef;
        data["ssmaTimeStamp"] = this.ssmaTimeStamp;
        data["kladde"] = this.kladde;
        data["compositeKey"] = this.compositeKey;
        data["fidNavigation"] = this.fidNavigation ? this.fidNavigation.toJSON() : undefined as any;
        return data;
    }
}

export interface IAfregningstabelDto {
    hid?: number;
    fid?: number;
    antal?: number;
    procent?: number | undefined;
    forskud?: number | undefined;
    currency?: number | undefined;
    sortKey?: number | undefined;
    logRef?: number | undefined;
    ssmaTimeStamp?: string | undefined;
    kladde?: number | undefined;
    compositeKey?: string | undefined;
    fidNavigation?: ForfatterDto | undefined;
}

export class ProgressDto implements IProgressDto {
    text?: string;
    count?: number | undefined;
    total?: number | undefined;
    completed?: boolean;

    constructor(data?: IProgressDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.text = _data["text"];
            this.count = _data["count"];
            this.total = _data["total"];
            this.completed = _data["completed"];
        }
    }

    static fromJS(data: any): ProgressDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProgressDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["text"] = this.text;
        data["count"] = this.count;
        data["total"] = this.total;
        data["completed"] = this.completed;
        return data;
    }
}

export interface IProgressDto {
    text?: string;
    count?: number | undefined;
    total?: number | undefined;
    completed?: boolean;
}

export class ProjectDto implements IProjectDto {
    id?: number | undefined;
    num?: string | undefined;
    numParent?: string | undefined;
    numMain?: string | undefined;
    itemNum?: string | undefined;
    name?: string | undefined;
    nameAlt?: string | undefined;
    group?: string | undefined;
    isbn?: string | undefined;
    approved?: number;
    language?: number;
    blocked?: number;
    taxCode?: string | undefined;
    taxId?: string | undefined;
    type?: string | undefined;
    responsible?: string | undefined;
    referenceNumber?: string | undefined;
    contractType?: string | undefined;
    startDate?: Date | undefined;
    source?: number;
    description?: string | undefined;

    constructor(data?: IProjectDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.num = _data["num"];
            this.numParent = _data["numParent"];
            this.numMain = _data["numMain"];
            this.itemNum = _data["itemNum"];
            this.name = _data["name"];
            this.nameAlt = _data["nameAlt"];
            this.group = _data["group"];
            this.isbn = _data["isbn"];
            this.approved = _data["approved"];
            this.language = _data["language"];
            this.blocked = _data["blocked"];
            this.taxCode = _data["taxCode"];
            this.taxId = _data["taxId"];
            this.type = _data["type"];
            this.responsible = _data["responsible"];
            this.referenceNumber = _data["referenceNumber"];
            this.contractType = _data["contractType"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : undefined as any;
            this.source = _data["source"];
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): ProjectDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProjectDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["num"] = this.num;
        data["numParent"] = this.numParent;
        data["numMain"] = this.numMain;
        data["itemNum"] = this.itemNum;
        data["name"] = this.name;
        data["nameAlt"] = this.nameAlt;
        data["group"] = this.group;
        data["isbn"] = this.isbn;
        data["approved"] = this.approved;
        data["language"] = this.language;
        data["blocked"] = this.blocked;
        data["taxCode"] = this.taxCode;
        data["taxId"] = this.taxId;
        data["type"] = this.type;
        data["responsible"] = this.responsible;
        data["referenceNumber"] = this.referenceNumber;
        data["contractType"] = this.contractType;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : undefined as any;
        data["source"] = this.source;
        data["description"] = this.description;
        return data;
    }
}

export interface IProjectDto {
    id?: number | undefined;
    num?: string | undefined;
    numParent?: string | undefined;
    numMain?: string | undefined;
    itemNum?: string | undefined;
    name?: string | undefined;
    nameAlt?: string | undefined;
    group?: string | undefined;
    isbn?: string | undefined;
    approved?: number;
    language?: number;
    blocked?: number;
    taxCode?: string | undefined;
    taxId?: string | undefined;
    type?: string | undefined;
    responsible?: string | undefined;
    referenceNumber?: string | undefined;
    contractType?: string | undefined;
    startDate?: Date | undefined;
    source?: number;
    description?: string | undefined;
}

export class RightsApprovalDto implements IRightsApprovalDto {
    id?: number | undefined;
    name?: string | undefined;
    period?: number;
    approver?: number;
    approvalStatus?: number;
    closeStatus?: number;
    vendorNum?: string | undefined;
    description?: string | undefined;
    folder?: string | undefined;
    fileName?: string | undefined;
    created?: Date;
    createdBy?: number | undefined;
    modified?: Date | undefined;
    modifiedBy?: number | undefined;
    chat?: ChatDto[] | undefined;
    linkedAttachment?: LinkedAttachmentDto[] | undefined;

    constructor(data?: IRightsApprovalDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.period = _data["period"];
            this.approver = _data["approver"];
            this.approvalStatus = _data["approvalStatus"];
            this.closeStatus = _data["closeStatus"];
            this.vendorNum = _data["vendorNum"];
            this.description = _data["description"];
            this.folder = _data["folder"];
            this.fileName = _data["fileName"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : undefined as any;
            this.createdBy = _data["createdBy"];
            this.modified = _data["modified"] ? new Date(_data["modified"].toString()) : undefined as any;
            this.modifiedBy = _data["modifiedBy"];
            if (Array.isArray(_data["chat"])) {
                this.chat = [] as any;
                for (let item of _data["chat"])
                    this.chat!.push(ChatDto.fromJS(item));
            }
            if (Array.isArray(_data["linkedAttachment"])) {
                this.linkedAttachment = [] as any;
                for (let item of _data["linkedAttachment"])
                    this.linkedAttachment!.push(LinkedAttachmentDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): RightsApprovalDto {
        data = typeof data === 'object' ? data : {};
        let result = new RightsApprovalDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["period"] = this.period;
        data["approver"] = this.approver;
        data["approvalStatus"] = this.approvalStatus;
        data["closeStatus"] = this.closeStatus;
        data["vendorNum"] = this.vendorNum;
        data["description"] = this.description;
        data["folder"] = this.folder;
        data["fileName"] = this.fileName;
        data["created"] = this.created ? this.created.toISOString() : undefined as any;
        data["createdBy"] = this.createdBy;
        data["modified"] = this.modified ? this.modified.toISOString() : undefined as any;
        data["modifiedBy"] = this.modifiedBy;
        if (Array.isArray(this.chat)) {
            data["chat"] = [];
            for (let item of this.chat)
                data["chat"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.linkedAttachment)) {
            data["linkedAttachment"] = [];
            for (let item of this.linkedAttachment)
                data["linkedAttachment"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IRightsApprovalDto {
    id?: number | undefined;
    name?: string | undefined;
    period?: number;
    approver?: number;
    approvalStatus?: number;
    closeStatus?: number;
    vendorNum?: string | undefined;
    description?: string | undefined;
    folder?: string | undefined;
    fileName?: string | undefined;
    created?: Date;
    createdBy?: number | undefined;
    modified?: Date | undefined;
    modifiedBy?: number | undefined;
    chat?: ChatDto[] | undefined;
    linkedAttachment?: LinkedAttachmentDto[] | undefined;
}

export enum RightsApprovalStatusEnum {
    None = 1,
    Approved = 2,
    Rejected = 3,
    ApprovedAndCloseContract = 4,
}

export enum RightsCloseStatusEnum {
    None = 1,
    ModifiedOngoing = 2,
    ModifiedForApproval = 3,
    Completed = 4,
    Cancelled = 5,
}

export class DataLinkVmDto implements IDataLinkVmDto {
    dataLinks?: DataLinkVm | undefined;

    constructor(data?: IDataLinkVmDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dataLinks = _data["dataLinks"] ? DataLinkVm.fromJS(_data["dataLinks"]) : undefined as any;
        }
    }

    static fromJS(data: any): DataLinkVmDto {
        data = typeof data === 'object' ? data : {};
        let result = new DataLinkVmDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dataLinks"] = this.dataLinks ? this.dataLinks.toJSON() : undefined as any;
        return data;
    }
}

export interface IDataLinkVmDto {
    dataLinks?: DataLinkVm | undefined;
}

export class RightsPeriodDto extends DataLinkVmDto implements IRightsPeriodDto {
    id?: number | undefined;
    name?: string | undefined;
    path?: string | undefined;
    active?: boolean;

    constructor(data?: IRightsPeriodDto) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.path = _data["path"];
            this.active = _data["active"];
        }
    }

    static override fromJS(data: any): RightsPeriodDto {
        data = typeof data === 'object' ? data : {};
        let result = new RightsPeriodDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["path"] = this.path;
        data["active"] = this.active;
        super.toJSON(data);
        return data;
    }
}

export interface IRightsPeriodDto extends IDataLinkVmDto {
    id?: number | undefined;
    name?: string | undefined;
    path?: string | undefined;
    active?: boolean;
}

export class DataLinkVm implements IDataLinkVm {
    linkedEntityId?: number;
    linkedRowId?: number;
    linkedChats?: ChatDto[];
    linkedAttachments?: LinkedAttachmentDto[];
    linkedLogs?: DataLog[];
    linkedTags?: DataTag[];
    linkedNotes?: DataNote[];

    constructor(data?: IDataLinkVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.linkedEntityId = _data["linkedEntityId"];
            this.linkedRowId = _data["linkedRowId"];
            if (Array.isArray(_data["linkedChats"])) {
                this.linkedChats = [] as any;
                for (let item of _data["linkedChats"])
                    this.linkedChats!.push(ChatDto.fromJS(item));
            }
            if (Array.isArray(_data["linkedAttachments"])) {
                this.linkedAttachments = [] as any;
                for (let item of _data["linkedAttachments"])
                    this.linkedAttachments!.push(LinkedAttachmentDto.fromJS(item));
            }
            if (Array.isArray(_data["linkedLogs"])) {
                this.linkedLogs = [] as any;
                for (let item of _data["linkedLogs"])
                    this.linkedLogs!.push(DataLog.fromJS(item));
            }
            if (Array.isArray(_data["linkedTags"])) {
                this.linkedTags = [] as any;
                for (let item of _data["linkedTags"])
                    this.linkedTags!.push(DataTag.fromJS(item));
            }
            if (Array.isArray(_data["linkedNotes"])) {
                this.linkedNotes = [] as any;
                for (let item of _data["linkedNotes"])
                    this.linkedNotes!.push(DataNote.fromJS(item));
            }
        }
    }

    static fromJS(data: any): DataLinkVm {
        data = typeof data === 'object' ? data : {};
        let result = new DataLinkVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["linkedEntityId"] = this.linkedEntityId;
        data["linkedRowId"] = this.linkedRowId;
        if (Array.isArray(this.linkedChats)) {
            data["linkedChats"] = [];
            for (let item of this.linkedChats)
                data["linkedChats"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.linkedAttachments)) {
            data["linkedAttachments"] = [];
            for (let item of this.linkedAttachments)
                data["linkedAttachments"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.linkedLogs)) {
            data["linkedLogs"] = [];
            for (let item of this.linkedLogs)
                data["linkedLogs"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.linkedTags)) {
            data["linkedTags"] = [];
            for (let item of this.linkedTags)
                data["linkedTags"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.linkedNotes)) {
            data["linkedNotes"] = [];
            for (let item of this.linkedNotes)
                data["linkedNotes"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IDataLinkVm {
    linkedEntityId?: number;
    linkedRowId?: number;
    linkedChats?: ChatDto[];
    linkedAttachments?: LinkedAttachmentDto[];
    linkedLogs?: DataLog[];
    linkedTags?: DataTag[];
    linkedNotes?: DataNote[];
}

export class RoyaltyAfregningAktuelViewVm implements IRoyaltyAfregningAktuelViewVm {
    lists?: RoyaltyAfregningAktuelViewDto[] | undefined;

    constructor(data?: IRoyaltyAfregningAktuelViewVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["lists"])) {
                this.lists = [] as any;
                for (let item of _data["lists"])
                    this.lists!.push(RoyaltyAfregningAktuelViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): RoyaltyAfregningAktuelViewVm {
        data = typeof data === 'object' ? data : {};
        let result = new RoyaltyAfregningAktuelViewVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.lists)) {
            data["lists"] = [];
            for (let item of this.lists)
                data["lists"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IRoyaltyAfregningAktuelViewVm {
    lists?: RoyaltyAfregningAktuelViewDto[] | undefined;
}

export class RoyaltyAfregningAktuelViewDto implements IRoyaltyAfregningAktuelViewDto {
    hid?: number;
    fid?: number;
    id?: number;
    kontraktType?: string | undefined;
    afregningstype?: string | undefined;
    afregningId?: string | undefined;
    afregningNavn?: string | undefined;
    afregningAdresse?: string | undefined;
    afregningAdresse1?: string | undefined;
    afregningAdresse2?: string | undefined;
    afregningAdresse3?: string | undefined;
    afregningLand?: string | undefined;
    afregningEmail?: string | undefined;
    forlagId?: string | undefined;
    forlagNavn?: string | undefined;
    forlagAdresse?: string | undefined;
    forlagAdresse1?: string | undefined;
    forlagAdresse2?: string | undefined;
    forlagAdresse3?: string | undefined;
    forlagLand?: string | undefined;
    forlagEmail?: string | undefined;
    arbTitel?: string | undefined;
    bogTitel?: string | undefined;
    forfatterNavn?: string | undefined;
    redaktorNavn?: string | undefined;
    hovedKontraktId?: number;
    hovedKontrakt?: number | undefined;
    kontrakt?: string | undefined;
    vareNR?: string | undefined;
    isbn?: string | undefined;
    valutaKode?: string | undefined;
    endeligSalgspris?: number | undefined;
    valutaKurs?: number | undefined;
    slut?: Date;
    start?: Date | undefined;
    royaltyAmount?: number | undefined;
    godkendt?: number | undefined;
    godkendtAf?: string | undefined;
    godkendtDato?: Date | undefined;
    afsluttet?: number | undefined;
    afsluttetAf?: string | undefined;
    afsluttetDato?: Date | undefined;
    createdDate?: Date;
    afregningsNote?: string | undefined;
    status?: number;
    statusText?: string | undefined;
    faktureres?: boolean;
    lukkes?: boolean;
    afregningOgForlagId?: string | undefined;

    constructor(data?: IRoyaltyAfregningAktuelViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.hid = _data["hid"];
            this.fid = _data["fid"];
            this.id = _data["id"];
            this.kontraktType = _data["kontraktType"];
            this.afregningstype = _data["afregningstype"];
            this.afregningId = _data["afregningId"];
            this.afregningNavn = _data["afregningNavn"];
            this.afregningAdresse = _data["afregningAdresse"];
            this.afregningAdresse1 = _data["afregningAdresse1"];
            this.afregningAdresse2 = _data["afregningAdresse2"];
            this.afregningAdresse3 = _data["afregningAdresse3"];
            this.afregningLand = _data["afregningLand"];
            this.afregningEmail = _data["afregningEmail"];
            this.forlagId = _data["forlagId"];
            this.forlagNavn = _data["forlagNavn"];
            this.forlagAdresse = _data["forlagAdresse"];
            this.forlagAdresse1 = _data["forlagAdresse1"];
            this.forlagAdresse2 = _data["forlagAdresse2"];
            this.forlagAdresse3 = _data["forlagAdresse3"];
            this.forlagLand = _data["forlagLand"];
            this.forlagEmail = _data["forlagEmail"];
            this.arbTitel = _data["arbTitel"];
            this.bogTitel = _data["bogTitel"];
            this.forfatterNavn = _data["forfatterNavn"];
            this.redaktorNavn = _data["redaktorNavn"];
            this.hovedKontraktId = _data["hovedKontraktId"];
            this.hovedKontrakt = _data["hovedKontrakt"];
            this.kontrakt = _data["kontrakt"];
            this.vareNR = _data["vareNR"];
            this.isbn = _data["isbn"];
            this.valutaKode = _data["valutaKode"];
            this.endeligSalgspris = _data["endeligSalgspris"];
            this.valutaKurs = _data["valutaKurs"];
            this.slut = _data["slut"] ? new Date(_data["slut"].toString()) : undefined as any;
            this.start = _data["start"] ? new Date(_data["start"].toString()) : undefined as any;
            this.royaltyAmount = _data["royaltyAmount"];
            this.godkendt = _data["godkendt"];
            this.godkendtAf = _data["godkendtAf"];
            this.godkendtDato = _data["godkendtDato"] ? new Date(_data["godkendtDato"].toString()) : undefined as any;
            this.afsluttet = _data["afsluttet"];
            this.afsluttetAf = _data["afsluttetAf"];
            this.afsluttetDato = _data["afsluttetDato"] ? new Date(_data["afsluttetDato"].toString()) : undefined as any;
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : undefined as any;
            this.afregningsNote = _data["afregningsNote"];
            this.status = _data["status"];
            this.statusText = _data["statusText"];
            this.faktureres = _data["faktureres"];
            this.lukkes = _data["lukkes"];
            this.afregningOgForlagId = _data["afregningOgForlagId"];
        }
    }

    static fromJS(data: any): RoyaltyAfregningAktuelViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new RoyaltyAfregningAktuelViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["hid"] = this.hid;
        data["fid"] = this.fid;
        data["id"] = this.id;
        data["kontraktType"] = this.kontraktType;
        data["afregningstype"] = this.afregningstype;
        data["afregningId"] = this.afregningId;
        data["afregningNavn"] = this.afregningNavn;
        data["afregningAdresse"] = this.afregningAdresse;
        data["afregningAdresse1"] = this.afregningAdresse1;
        data["afregningAdresse2"] = this.afregningAdresse2;
        data["afregningAdresse3"] = this.afregningAdresse3;
        data["afregningLand"] = this.afregningLand;
        data["afregningEmail"] = this.afregningEmail;
        data["forlagId"] = this.forlagId;
        data["forlagNavn"] = this.forlagNavn;
        data["forlagAdresse"] = this.forlagAdresse;
        data["forlagAdresse1"] = this.forlagAdresse1;
        data["forlagAdresse2"] = this.forlagAdresse2;
        data["forlagAdresse3"] = this.forlagAdresse3;
        data["forlagLand"] = this.forlagLand;
        data["forlagEmail"] = this.forlagEmail;
        data["arbTitel"] = this.arbTitel;
        data["bogTitel"] = this.bogTitel;
        data["forfatterNavn"] = this.forfatterNavn;
        data["redaktorNavn"] = this.redaktorNavn;
        data["hovedKontraktId"] = this.hovedKontraktId;
        data["hovedKontrakt"] = this.hovedKontrakt;
        data["kontrakt"] = this.kontrakt;
        data["vareNR"] = this.vareNR;
        data["isbn"] = this.isbn;
        data["valutaKode"] = this.valutaKode;
        data["endeligSalgspris"] = this.endeligSalgspris;
        data["valutaKurs"] = this.valutaKurs;
        data["slut"] = this.slut ? this.slut.toISOString() : undefined as any;
        data["start"] = this.start ? this.start.toISOString() : undefined as any;
        data["royaltyAmount"] = this.royaltyAmount;
        data["godkendt"] = this.godkendt;
        data["godkendtAf"] = this.godkendtAf;
        data["godkendtDato"] = this.godkendtDato ? this.godkendtDato.toISOString() : undefined as any;
        data["afsluttet"] = this.afsluttet;
        data["afsluttetAf"] = this.afsluttetAf;
        data["afsluttetDato"] = this.afsluttetDato ? this.afsluttetDato.toISOString() : undefined as any;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : undefined as any;
        data["afregningsNote"] = this.afregningsNote;
        data["status"] = this.status;
        data["statusText"] = this.statusText;
        data["faktureres"] = this.faktureres;
        data["lukkes"] = this.lukkes;
        data["afregningOgForlagId"] = this.afregningOgForlagId;
        return data;
    }
}

export interface IRoyaltyAfregningAktuelViewDto {
    hid?: number;
    fid?: number;
    id?: number;
    kontraktType?: string | undefined;
    afregningstype?: string | undefined;
    afregningId?: string | undefined;
    afregningNavn?: string | undefined;
    afregningAdresse?: string | undefined;
    afregningAdresse1?: string | undefined;
    afregningAdresse2?: string | undefined;
    afregningAdresse3?: string | undefined;
    afregningLand?: string | undefined;
    afregningEmail?: string | undefined;
    forlagId?: string | undefined;
    forlagNavn?: string | undefined;
    forlagAdresse?: string | undefined;
    forlagAdresse1?: string | undefined;
    forlagAdresse2?: string | undefined;
    forlagAdresse3?: string | undefined;
    forlagLand?: string | undefined;
    forlagEmail?: string | undefined;
    arbTitel?: string | undefined;
    bogTitel?: string | undefined;
    forfatterNavn?: string | undefined;
    redaktorNavn?: string | undefined;
    hovedKontraktId?: number;
    hovedKontrakt?: number | undefined;
    kontrakt?: string | undefined;
    vareNR?: string | undefined;
    isbn?: string | undefined;
    valutaKode?: string | undefined;
    endeligSalgspris?: number | undefined;
    valutaKurs?: number | undefined;
    slut?: Date;
    start?: Date | undefined;
    royaltyAmount?: number | undefined;
    godkendt?: number | undefined;
    godkendtAf?: string | undefined;
    godkendtDato?: Date | undefined;
    afsluttet?: number | undefined;
    afsluttetAf?: string | undefined;
    afsluttetDato?: Date | undefined;
    createdDate?: Date;
    afregningsNote?: string | undefined;
    status?: number;
    statusText?: string | undefined;
    faktureres?: boolean;
    lukkes?: boolean;
    afregningOgForlagId?: string | undefined;
}

export class RoyaltyAfregningAktuelDetailViewVm implements IRoyaltyAfregningAktuelDetailViewVm {
    userName?: string | undefined;
    userNameShort?: string | undefined;
    royaltyAfregningAktuelViewDto?: RoyaltyAfregningAktuelViewDto | undefined;
    royaltyAfregningTransAktuelViewDto?: RoyaltyAfregningTransAktuelViewDto[] | undefined;
    royaltyAfregningTrappeAktuelViewDto?: RoyaltyAfregningTrappeAktuelViewDto[] | undefined;
    royaltyAfregningTransHistorikViewDto?: RoyaltyAfregningTransHistorikViewDto[] | undefined;
    royaltyNoteDto?: RoyaltyNoteDto[] | undefined;
    varenumre?: Varenumre[] | undefined;
    hovedkontrakt?: Hovedkontrakt | undefined;

    constructor(data?: IRoyaltyAfregningAktuelDetailViewVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userName = _data["userName"];
            this.userNameShort = _data["userNameShort"];
            this.royaltyAfregningAktuelViewDto = _data["royaltyAfregningAktuelViewDto"] ? RoyaltyAfregningAktuelViewDto.fromJS(_data["royaltyAfregningAktuelViewDto"]) : undefined as any;
            if (Array.isArray(_data["royaltyAfregningTransAktuelViewDto"])) {
                this.royaltyAfregningTransAktuelViewDto = [] as any;
                for (let item of _data["royaltyAfregningTransAktuelViewDto"])
                    this.royaltyAfregningTransAktuelViewDto!.push(RoyaltyAfregningTransAktuelViewDto.fromJS(item));
            }
            if (Array.isArray(_data["royaltyAfregningTrappeAktuelViewDto"])) {
                this.royaltyAfregningTrappeAktuelViewDto = [] as any;
                for (let item of _data["royaltyAfregningTrappeAktuelViewDto"])
                    this.royaltyAfregningTrappeAktuelViewDto!.push(RoyaltyAfregningTrappeAktuelViewDto.fromJS(item));
            }
            if (Array.isArray(_data["royaltyAfregningTransHistorikViewDto"])) {
                this.royaltyAfregningTransHistorikViewDto = [] as any;
                for (let item of _data["royaltyAfregningTransHistorikViewDto"])
                    this.royaltyAfregningTransHistorikViewDto!.push(RoyaltyAfregningTransHistorikViewDto.fromJS(item));
            }
            if (Array.isArray(_data["royaltyNoteDto"])) {
                this.royaltyNoteDto = [] as any;
                for (let item of _data["royaltyNoteDto"])
                    this.royaltyNoteDto!.push(RoyaltyNoteDto.fromJS(item));
            }
            if (Array.isArray(_data["varenumre"])) {
                this.varenumre = [] as any;
                for (let item of _data["varenumre"])
                    this.varenumre!.push(Varenumre.fromJS(item));
            }
            this.hovedkontrakt = _data["hovedkontrakt"] ? Hovedkontrakt.fromJS(_data["hovedkontrakt"]) : undefined as any;
        }
    }

    static fromJS(data: any): RoyaltyAfregningAktuelDetailViewVm {
        data = typeof data === 'object' ? data : {};
        let result = new RoyaltyAfregningAktuelDetailViewVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userName"] = this.userName;
        data["userNameShort"] = this.userNameShort;
        data["royaltyAfregningAktuelViewDto"] = this.royaltyAfregningAktuelViewDto ? this.royaltyAfregningAktuelViewDto.toJSON() : undefined as any;
        if (Array.isArray(this.royaltyAfregningTransAktuelViewDto)) {
            data["royaltyAfregningTransAktuelViewDto"] = [];
            for (let item of this.royaltyAfregningTransAktuelViewDto)
                data["royaltyAfregningTransAktuelViewDto"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.royaltyAfregningTrappeAktuelViewDto)) {
            data["royaltyAfregningTrappeAktuelViewDto"] = [];
            for (let item of this.royaltyAfregningTrappeAktuelViewDto)
                data["royaltyAfregningTrappeAktuelViewDto"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.royaltyAfregningTransHistorikViewDto)) {
            data["royaltyAfregningTransHistorikViewDto"] = [];
            for (let item of this.royaltyAfregningTransHistorikViewDto)
                data["royaltyAfregningTransHistorikViewDto"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.royaltyNoteDto)) {
            data["royaltyNoteDto"] = [];
            for (let item of this.royaltyNoteDto)
                data["royaltyNoteDto"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.varenumre)) {
            data["varenumre"] = [];
            for (let item of this.varenumre)
                data["varenumre"].push(item ? item.toJSON() : undefined as any);
        }
        data["hovedkontrakt"] = this.hovedkontrakt ? this.hovedkontrakt.toJSON() : undefined as any;
        return data;
    }
}

export interface IRoyaltyAfregningAktuelDetailViewVm {
    userName?: string | undefined;
    userNameShort?: string | undefined;
    royaltyAfregningAktuelViewDto?: RoyaltyAfregningAktuelViewDto | undefined;
    royaltyAfregningTransAktuelViewDto?: RoyaltyAfregningTransAktuelViewDto[] | undefined;
    royaltyAfregningTrappeAktuelViewDto?: RoyaltyAfregningTrappeAktuelViewDto[] | undefined;
    royaltyAfregningTransHistorikViewDto?: RoyaltyAfregningTransHistorikViewDto[] | undefined;
    royaltyNoteDto?: RoyaltyNoteDto[] | undefined;
    varenumre?: Varenumre[] | undefined;
    hovedkontrakt?: Hovedkontrakt | undefined;
}

export class RoyaltyAfregningTransAktuelViewDto implements IRoyaltyAfregningTransAktuelViewDto {
    sort?: number;
    hid?: number | undefined;
    fid?: number;
    id?: number | undefined;
    omsAntal?: number | undefined;
    omsBelobVal?: number | undefined;
    royaltyBelobBeregnVal?: number | undefined;
    title?: string | undefined;
    bogTitel?: string | undefined;
    edition?: string | undefined;
    isbn?: string | undefined;
    hovedKontraktId?: number;
    hovedKontrakt?: number | undefined;
    kontrakt?: string | undefined;
    vareNR?: string | undefined;
    dato?: Date | undefined;
    udgivelsesDato?: Date | undefined;
    lukketDato?: Date | undefined;
    lukket?: number | undefined;

    constructor(data?: IRoyaltyAfregningTransAktuelViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sort = _data["sort"];
            this.hid = _data["hid"];
            this.fid = _data["fid"];
            this.id = _data["id"];
            this.omsAntal = _data["omsAntal"];
            this.omsBelobVal = _data["omsBelobVal"];
            this.royaltyBelobBeregnVal = _data["royaltyBelobBeregnVal"];
            this.title = _data["title"];
            this.bogTitel = _data["bogTitel"];
            this.edition = _data["edition"];
            this.isbn = _data["isbn"];
            this.hovedKontraktId = _data["hovedKontraktId"];
            this.hovedKontrakt = _data["hovedKontrakt"];
            this.kontrakt = _data["kontrakt"];
            this.vareNR = _data["vareNR"];
            this.dato = _data["dato"] ? new Date(_data["dato"].toString()) : undefined as any;
            this.udgivelsesDato = _data["udgivelsesDato"] ? new Date(_data["udgivelsesDato"].toString()) : undefined as any;
            this.lukketDato = _data["lukketDato"] ? new Date(_data["lukketDato"].toString()) : undefined as any;
            this.lukket = _data["lukket"];
        }
    }

    static fromJS(data: any): RoyaltyAfregningTransAktuelViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new RoyaltyAfregningTransAktuelViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sort"] = this.sort;
        data["hid"] = this.hid;
        data["fid"] = this.fid;
        data["id"] = this.id;
        data["omsAntal"] = this.omsAntal;
        data["omsBelobVal"] = this.omsBelobVal;
        data["royaltyBelobBeregnVal"] = this.royaltyBelobBeregnVal;
        data["title"] = this.title;
        data["bogTitel"] = this.bogTitel;
        data["edition"] = this.edition;
        data["isbn"] = this.isbn;
        data["hovedKontraktId"] = this.hovedKontraktId;
        data["hovedKontrakt"] = this.hovedKontrakt;
        data["kontrakt"] = this.kontrakt;
        data["vareNR"] = this.vareNR;
        data["dato"] = this.dato ? this.dato.toISOString() : undefined as any;
        data["udgivelsesDato"] = this.udgivelsesDato ? this.udgivelsesDato.toISOString() : undefined as any;
        data["lukketDato"] = this.lukketDato ? this.lukketDato.toISOString() : undefined as any;
        data["lukket"] = this.lukket;
        return data;
    }
}

export interface IRoyaltyAfregningTransAktuelViewDto {
    sort?: number;
    hid?: number | undefined;
    fid?: number;
    id?: number | undefined;
    omsAntal?: number | undefined;
    omsBelobVal?: number | undefined;
    royaltyBelobBeregnVal?: number | undefined;
    title?: string | undefined;
    bogTitel?: string | undefined;
    edition?: string | undefined;
    isbn?: string | undefined;
    hovedKontraktId?: number;
    hovedKontrakt?: number | undefined;
    kontrakt?: string | undefined;
    vareNR?: string | undefined;
    dato?: Date | undefined;
    udgivelsesDato?: Date | undefined;
    lukketDato?: Date | undefined;
    lukket?: number | undefined;
}

export class RoyaltyAfregningTrappeAktuelViewDto implements IRoyaltyAfregningTrappeAktuelViewDto {
    hid?: number;
    fid?: number;
    id?: number;
    trappeFra?: number | undefined;
    trappeTil?: number | undefined;
    omsAntal?: number | undefined;
    salgsPrisVal?: number;
    omsBelobVal?: number;
    rate?: number | undefined;
    royalty?: number;
    valutaKode?: string | undefined;
    bogtitel?: string | undefined;
    edition?: string | undefined;
    isbn?: string | undefined;
    hovedKontraktId?: number;
    hovedKontrakt?: number | undefined;
    kontrakt?: string | undefined;
    vareNR?: string | undefined;
    dato?: Date;
    salgsPrisFraDato?: Date;
    salgsPrisTilDato?: Date;

    constructor(data?: IRoyaltyAfregningTrappeAktuelViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.hid = _data["hid"];
            this.fid = _data["fid"];
            this.id = _data["id"];
            this.trappeFra = _data["trappeFra"];
            this.trappeTil = _data["trappeTil"];
            this.omsAntal = _data["omsAntal"];
            this.salgsPrisVal = _data["salgsPrisVal"];
            this.omsBelobVal = _data["omsBelobVal"];
            this.rate = _data["rate"];
            this.royalty = _data["royalty"];
            this.valutaKode = _data["valutaKode"];
            this.bogtitel = _data["bogtitel"];
            this.edition = _data["edition"];
            this.isbn = _data["isbn"];
            this.hovedKontraktId = _data["hovedKontraktId"];
            this.hovedKontrakt = _data["hovedKontrakt"];
            this.kontrakt = _data["kontrakt"];
            this.vareNR = _data["vareNR"];
            this.dato = _data["dato"] ? new Date(_data["dato"].toString()) : undefined as any;
            this.salgsPrisFraDato = _data["salgsPrisFraDato"] ? new Date(_data["salgsPrisFraDato"].toString()) : undefined as any;
            this.salgsPrisTilDato = _data["salgsPrisTilDato"] ? new Date(_data["salgsPrisTilDato"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): RoyaltyAfregningTrappeAktuelViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new RoyaltyAfregningTrappeAktuelViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["hid"] = this.hid;
        data["fid"] = this.fid;
        data["id"] = this.id;
        data["trappeFra"] = this.trappeFra;
        data["trappeTil"] = this.trappeTil;
        data["omsAntal"] = this.omsAntal;
        data["salgsPrisVal"] = this.salgsPrisVal;
        data["omsBelobVal"] = this.omsBelobVal;
        data["rate"] = this.rate;
        data["royalty"] = this.royalty;
        data["valutaKode"] = this.valutaKode;
        data["bogtitel"] = this.bogtitel;
        data["edition"] = this.edition;
        data["isbn"] = this.isbn;
        data["hovedKontraktId"] = this.hovedKontraktId;
        data["hovedKontrakt"] = this.hovedKontrakt;
        data["kontrakt"] = this.kontrakt;
        data["vareNR"] = this.vareNR;
        data["dato"] = this.dato ? this.dato.toISOString() : undefined as any;
        data["salgsPrisFraDato"] = this.salgsPrisFraDato ? this.salgsPrisFraDato.toISOString() : undefined as any;
        data["salgsPrisTilDato"] = this.salgsPrisTilDato ? this.salgsPrisTilDato.toISOString() : undefined as any;
        return data;
    }
}

export interface IRoyaltyAfregningTrappeAktuelViewDto {
    hid?: number;
    fid?: number;
    id?: number;
    trappeFra?: number | undefined;
    trappeTil?: number | undefined;
    omsAntal?: number | undefined;
    salgsPrisVal?: number;
    omsBelobVal?: number;
    rate?: number | undefined;
    royalty?: number;
    valutaKode?: string | undefined;
    bogtitel?: string | undefined;
    edition?: string | undefined;
    isbn?: string | undefined;
    hovedKontraktId?: number;
    hovedKontrakt?: number | undefined;
    kontrakt?: string | undefined;
    vareNR?: string | undefined;
    dato?: Date;
    salgsPrisFraDato?: Date;
    salgsPrisTilDato?: Date;
}

export class RoyaltyAfregningTransHistorikViewDto implements IRoyaltyAfregningTransHistorikViewDto {
    hid?: number;
    fid?: number;
    id?: number;
    omsAntal?: number | undefined;
    omsBelobVal?: number | undefined;
    royaltyBelobBeregnVal?: number;
    valutaKode?: string | undefined;
    bogtitel?: string | undefined;
    edition?: string | undefined;
    isbn?: string | undefined;
    hovedKontraktId?: number;
    hovedKontrakt?: number | undefined;
    kontrakt?: string | undefined;
    vareNR?: string | undefined;
    dato?: Date;
    date?: string | undefined;
    type?: string | undefined;

    constructor(data?: IRoyaltyAfregningTransHistorikViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.hid = _data["hid"];
            this.fid = _data["fid"];
            this.id = _data["id"];
            this.omsAntal = _data["omsAntal"];
            this.omsBelobVal = _data["omsBelobVal"];
            this.royaltyBelobBeregnVal = _data["royaltyBelobBeregnVal"];
            this.valutaKode = _data["valutaKode"];
            this.bogtitel = _data["bogtitel"];
            this.edition = _data["edition"];
            this.isbn = _data["isbn"];
            this.hovedKontraktId = _data["hovedKontraktId"];
            this.hovedKontrakt = _data["hovedKontrakt"];
            this.kontrakt = _data["kontrakt"];
            this.vareNR = _data["vareNR"];
            this.dato = _data["dato"] ? new Date(_data["dato"].toString()) : undefined as any;
            this.date = _data["date"];
            this.type = _data["type"];
        }
    }

    static fromJS(data: any): RoyaltyAfregningTransHistorikViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new RoyaltyAfregningTransHistorikViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["hid"] = this.hid;
        data["fid"] = this.fid;
        data["id"] = this.id;
        data["omsAntal"] = this.omsAntal;
        data["omsBelobVal"] = this.omsBelobVal;
        data["royaltyBelobBeregnVal"] = this.royaltyBelobBeregnVal;
        data["valutaKode"] = this.valutaKode;
        data["bogtitel"] = this.bogtitel;
        data["edition"] = this.edition;
        data["isbn"] = this.isbn;
        data["hovedKontraktId"] = this.hovedKontraktId;
        data["hovedKontrakt"] = this.hovedKontrakt;
        data["kontrakt"] = this.kontrakt;
        data["vareNR"] = this.vareNR;
        data["dato"] = this.dato ? this.dato.toISOString() : undefined as any;
        data["date"] = this.date;
        data["type"] = this.type;
        return data;
    }
}

export interface IRoyaltyAfregningTransHistorikViewDto {
    hid?: number;
    fid?: number;
    id?: number;
    omsAntal?: number | undefined;
    omsBelobVal?: number | undefined;
    royaltyBelobBeregnVal?: number;
    valutaKode?: string | undefined;
    bogtitel?: string | undefined;
    edition?: string | undefined;
    isbn?: string | undefined;
    hovedKontraktId?: number;
    hovedKontrakt?: number | undefined;
    kontrakt?: string | undefined;
    vareNR?: string | undefined;
    dato?: Date;
    date?: string | undefined;
    type?: string | undefined;
}

export class RoyaltyNoteDto implements IRoyaltyNoteDto {
    hid?: number;
    id?: number;
    dato?: Date;
    userId?: string | undefined;
    note?: string | undefined;
    isPublic?: boolean;

    constructor(data?: IRoyaltyNoteDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.hid = _data["hid"];
            this.id = _data["id"];
            this.dato = _data["dato"] ? new Date(_data["dato"].toString()) : undefined as any;
            this.userId = _data["userId"];
            this.note = _data["note"];
            this.isPublic = _data["isPublic"];
        }
    }

    static fromJS(data: any): RoyaltyNoteDto {
        data = typeof data === 'object' ? data : {};
        let result = new RoyaltyNoteDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["hid"] = this.hid;
        data["id"] = this.id;
        data["dato"] = this.dato ? this.dato.toISOString() : undefined as any;
        data["userId"] = this.userId;
        data["note"] = this.note;
        data["isPublic"] = this.isPublic;
        return data;
    }
}

export interface IRoyaltyNoteDto {
    hid?: number;
    id?: number;
    dato?: Date;
    userId?: string | undefined;
    note?: string | undefined;
    isPublic?: boolean;
}

export class Varenumre implements IVarenumre {
    id?: number;
    isbn?: string | undefined;
    vareNr?: string | undefined;
    hkontrakt?: number | undefined;
    ukontrakt?: number | undefined;
    arbTitel?: string | undefined;
    bogtitel?: string | undefined;
    bogType?: number | undefined;
    opretDato?: Date | undefined;
    udgivelsesDato?: Date | undefined;
    lukketDato?: Date | undefined;
    bogformat?: number | undefined;
    indbinding?: number | undefined;
    editions?: number | undefined;
    endeligSalgspris?: number | undefined;
    forventetSalgspris?: number | undefined;
    logRef?: number | undefined;
    kladde?: number | undefined;
    ssmaTimeStamp?: string | undefined;
    bogTypeNavigation?: Bogtype | undefined;
    bogformatNavigation?: Bogformater | undefined;
    hkontraktNavigation?: Hovedkontrakt | undefined;
    indbindingNavigation?: Indbindinger | undefined;
    afregningstabel?: Afregningstabel[] | undefined;
    royaltyNote?: RoyaltyNote[] | undefined;
    royaltyTrans?: RoyaltyTrans[] | undefined;
    royaltyTransTrappe?: RoyaltyTransTrappe[] | undefined;
    stdBelob?: StdBelob[] | undefined;
    vareSalgsPrisHistorik?: VareSalgsPrisHistorik[] | undefined;

    constructor(data?: IVarenumre) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.isbn = _data["isbn"];
            this.vareNr = _data["vareNr"];
            this.hkontrakt = _data["hkontrakt"];
            this.ukontrakt = _data["ukontrakt"];
            this.arbTitel = _data["arbTitel"];
            this.bogtitel = _data["bogtitel"];
            this.bogType = _data["bogType"];
            this.opretDato = _data["opretDato"] ? new Date(_data["opretDato"].toString()) : undefined as any;
            this.udgivelsesDato = _data["udgivelsesDato"] ? new Date(_data["udgivelsesDato"].toString()) : undefined as any;
            this.lukketDato = _data["lukketDato"] ? new Date(_data["lukketDato"].toString()) : undefined as any;
            this.bogformat = _data["bogformat"];
            this.indbinding = _data["indbinding"];
            this.editions = _data["editions"];
            this.endeligSalgspris = _data["endeligSalgspris"];
            this.forventetSalgspris = _data["forventetSalgspris"];
            this.logRef = _data["logRef"];
            this.kladde = _data["kladde"];
            this.ssmaTimeStamp = _data["ssmaTimeStamp"];
            this.bogTypeNavigation = _data["bogTypeNavigation"] ? Bogtype.fromJS(_data["bogTypeNavigation"]) : undefined as any;
            this.bogformatNavigation = _data["bogformatNavigation"] ? Bogformater.fromJS(_data["bogformatNavigation"]) : undefined as any;
            this.hkontraktNavigation = _data["hkontraktNavigation"] ? Hovedkontrakt.fromJS(_data["hkontraktNavigation"]) : undefined as any;
            this.indbindingNavigation = _data["indbindingNavigation"] ? Indbindinger.fromJS(_data["indbindingNavigation"]) : undefined as any;
            if (Array.isArray(_data["afregningstabel"])) {
                this.afregningstabel = [] as any;
                for (let item of _data["afregningstabel"])
                    this.afregningstabel!.push(Afregningstabel.fromJS(item));
            }
            if (Array.isArray(_data["royaltyNote"])) {
                this.royaltyNote = [] as any;
                for (let item of _data["royaltyNote"])
                    this.royaltyNote!.push(RoyaltyNote.fromJS(item));
            }
            if (Array.isArray(_data["royaltyTrans"])) {
                this.royaltyTrans = [] as any;
                for (let item of _data["royaltyTrans"])
                    this.royaltyTrans!.push(RoyaltyTrans.fromJS(item));
            }
            if (Array.isArray(_data["royaltyTransTrappe"])) {
                this.royaltyTransTrappe = [] as any;
                for (let item of _data["royaltyTransTrappe"])
                    this.royaltyTransTrappe!.push(RoyaltyTransTrappe.fromJS(item));
            }
            if (Array.isArray(_data["stdBelob"])) {
                this.stdBelob = [] as any;
                for (let item of _data["stdBelob"])
                    this.stdBelob!.push(StdBelob.fromJS(item));
            }
            if (Array.isArray(_data["vareSalgsPrisHistorik"])) {
                this.vareSalgsPrisHistorik = [] as any;
                for (let item of _data["vareSalgsPrisHistorik"])
                    this.vareSalgsPrisHistorik!.push(VareSalgsPrisHistorik.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Varenumre {
        data = typeof data === 'object' ? data : {};
        let result = new Varenumre();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["isbn"] = this.isbn;
        data["vareNr"] = this.vareNr;
        data["hkontrakt"] = this.hkontrakt;
        data["ukontrakt"] = this.ukontrakt;
        data["arbTitel"] = this.arbTitel;
        data["bogtitel"] = this.bogtitel;
        data["bogType"] = this.bogType;
        data["opretDato"] = this.opretDato ? this.opretDato.toISOString() : undefined as any;
        data["udgivelsesDato"] = this.udgivelsesDato ? this.udgivelsesDato.toISOString() : undefined as any;
        data["lukketDato"] = this.lukketDato ? this.lukketDato.toISOString() : undefined as any;
        data["bogformat"] = this.bogformat;
        data["indbinding"] = this.indbinding;
        data["editions"] = this.editions;
        data["endeligSalgspris"] = this.endeligSalgspris;
        data["forventetSalgspris"] = this.forventetSalgspris;
        data["logRef"] = this.logRef;
        data["kladde"] = this.kladde;
        data["ssmaTimeStamp"] = this.ssmaTimeStamp;
        data["bogTypeNavigation"] = this.bogTypeNavigation ? this.bogTypeNavigation.toJSON() : undefined as any;
        data["bogformatNavigation"] = this.bogformatNavigation ? this.bogformatNavigation.toJSON() : undefined as any;
        data["hkontraktNavigation"] = this.hkontraktNavigation ? this.hkontraktNavigation.toJSON() : undefined as any;
        data["indbindingNavigation"] = this.indbindingNavigation ? this.indbindingNavigation.toJSON() : undefined as any;
        if (Array.isArray(this.afregningstabel)) {
            data["afregningstabel"] = [];
            for (let item of this.afregningstabel)
                data["afregningstabel"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.royaltyNote)) {
            data["royaltyNote"] = [];
            for (let item of this.royaltyNote)
                data["royaltyNote"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.royaltyTrans)) {
            data["royaltyTrans"] = [];
            for (let item of this.royaltyTrans)
                data["royaltyTrans"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.royaltyTransTrappe)) {
            data["royaltyTransTrappe"] = [];
            for (let item of this.royaltyTransTrappe)
                data["royaltyTransTrappe"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.stdBelob)) {
            data["stdBelob"] = [];
            for (let item of this.stdBelob)
                data["stdBelob"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.vareSalgsPrisHistorik)) {
            data["vareSalgsPrisHistorik"] = [];
            for (let item of this.vareSalgsPrisHistorik)
                data["vareSalgsPrisHistorik"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IVarenumre {
    id?: number;
    isbn?: string | undefined;
    vareNr?: string | undefined;
    hkontrakt?: number | undefined;
    ukontrakt?: number | undefined;
    arbTitel?: string | undefined;
    bogtitel?: string | undefined;
    bogType?: number | undefined;
    opretDato?: Date | undefined;
    udgivelsesDato?: Date | undefined;
    lukketDato?: Date | undefined;
    bogformat?: number | undefined;
    indbinding?: number | undefined;
    editions?: number | undefined;
    endeligSalgspris?: number | undefined;
    forventetSalgspris?: number | undefined;
    logRef?: number | undefined;
    kladde?: number | undefined;
    ssmaTimeStamp?: string | undefined;
    bogTypeNavigation?: Bogtype | undefined;
    bogformatNavigation?: Bogformater | undefined;
    hkontraktNavigation?: Hovedkontrakt | undefined;
    indbindingNavigation?: Indbindinger | undefined;
    afregningstabel?: Afregningstabel[] | undefined;
    royaltyNote?: RoyaltyNote[] | undefined;
    royaltyTrans?: RoyaltyTrans[] | undefined;
    royaltyTransTrappe?: RoyaltyTransTrappe[] | undefined;
    stdBelob?: StdBelob[] | undefined;
    vareSalgsPrisHistorik?: VareSalgsPrisHistorik[] | undefined;
}

export class Bogtype implements IBogtype {
    id?: number;
    bogtype1?: string | undefined;
    ref?: string | undefined;
    cost?: boolean;
    ssmaTimeStamp?: string | undefined;
    varenumre?: Varenumre[];

    constructor(data?: IBogtype) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.bogtype1 = _data["bogtype1"];
            this.ref = _data["ref"];
            this.cost = _data["cost"];
            this.ssmaTimeStamp = _data["ssmaTimeStamp"];
            if (Array.isArray(_data["varenumre"])) {
                this.varenumre = [] as any;
                for (let item of _data["varenumre"])
                    this.varenumre!.push(Varenumre.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Bogtype {
        data = typeof data === 'object' ? data : {};
        let result = new Bogtype();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["bogtype1"] = this.bogtype1;
        data["ref"] = this.ref;
        data["cost"] = this.cost;
        data["ssmaTimeStamp"] = this.ssmaTimeStamp;
        if (Array.isArray(this.varenumre)) {
            data["varenumre"] = [];
            for (let item of this.varenumre)
                data["varenumre"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IBogtype {
    id?: number;
    bogtype1?: string | undefined;
    ref?: string | undefined;
    cost?: boolean;
    ssmaTimeStamp?: string | undefined;
    varenumre?: Varenumre[];
}

export class Bogformater implements IBogformater {
    id?: number;
    bogformat?: string | undefined;
    varenumre?: Varenumre[] | undefined;

    constructor(data?: IBogformater) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.bogformat = _data["bogformat"];
            if (Array.isArray(_data["varenumre"])) {
                this.varenumre = [] as any;
                for (let item of _data["varenumre"])
                    this.varenumre!.push(Varenumre.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Bogformater {
        data = typeof data === 'object' ? data : {};
        let result = new Bogformater();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["bogformat"] = this.bogformat;
        if (Array.isArray(this.varenumre)) {
            data["varenumre"] = [];
            for (let item of this.varenumre)
                data["varenumre"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IBogformater {
    id?: number;
    bogformat?: string | undefined;
    varenumre?: Varenumre[] | undefined;
}

export class Hovedkontrakt implements IHovedkontrakt {
    id?: number;
    hkontrakt?: number | undefined;
    bogtitel?: string | undefined;
    type?: number | undefined;
    gruppe?: number | undefined;
    redaktor?: number | undefined;
    afregnTermin?: number | undefined;
    formaal?: number | undefined;
    afregningstype?: number | undefined;
    startdato?: Date | undefined;
    budget?: boolean | undefined;
    specielAfregning?: string | undefined;
    forlag?: number | undefined;
    oprindeligTitel?: string | undefined;
    oprindeligForfatter?: string | undefined;
    infoTekst?: string | undefined;
    anmeldelse?: boolean | undefined;
    salgsark?: boolean | undefined;
    fastprisAfregning?: boolean | undefined;
    guidingPrice?: boolean | undefined;
    template?: number | undefined;
    logRef?: number | undefined;
    kladde?: number | undefined;
    agent?: number | undefined;
    ssmaTimeStamp?: string | undefined;
    afregningstypeNavigation?: AfregningsType | undefined;
    forlagNavigation?: Forlag | undefined;
    formaalNavigation?: Formaal | undefined;
    gruppeNavigation?: Gruppe | undefined;
    redaktorNavigation?: Redaktoer | undefined;
    typeNavigation?: KontraktType | undefined;
    varenumre?: Varenumre[] | undefined;

    constructor(data?: IHovedkontrakt) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.hkontrakt = _data["hkontrakt"];
            this.bogtitel = _data["bogtitel"];
            this.type = _data["type"];
            this.gruppe = _data["gruppe"];
            this.redaktor = _data["redaktor"];
            this.afregnTermin = _data["afregnTermin"];
            this.formaal = _data["formaal"];
            this.afregningstype = _data["afregningstype"];
            this.startdato = _data["startdato"] ? new Date(_data["startdato"].toString()) : undefined as any;
            this.budget = _data["budget"];
            this.specielAfregning = _data["specielAfregning"];
            this.forlag = _data["forlag"];
            this.oprindeligTitel = _data["oprindeligTitel"];
            this.oprindeligForfatter = _data["oprindeligForfatter"];
            this.infoTekst = _data["infoTekst"];
            this.anmeldelse = _data["anmeldelse"];
            this.salgsark = _data["salgsark"];
            this.fastprisAfregning = _data["fastprisAfregning"];
            this.guidingPrice = _data["guidingPrice"];
            this.template = _data["template"];
            this.logRef = _data["logRef"];
            this.kladde = _data["kladde"];
            this.agent = _data["agent"];
            this.ssmaTimeStamp = _data["ssmaTimeStamp"];
            this.afregningstypeNavigation = _data["afregningstypeNavigation"] ? AfregningsType.fromJS(_data["afregningstypeNavigation"]) : undefined as any;
            this.forlagNavigation = _data["forlagNavigation"] ? Forlag.fromJS(_data["forlagNavigation"]) : undefined as any;
            this.formaalNavigation = _data["formaalNavigation"] ? Formaal.fromJS(_data["formaalNavigation"]) : undefined as any;
            this.gruppeNavigation = _data["gruppeNavigation"] ? Gruppe.fromJS(_data["gruppeNavigation"]) : undefined as any;
            this.redaktorNavigation = _data["redaktorNavigation"] ? Redaktoer.fromJS(_data["redaktorNavigation"]) : undefined as any;
            this.typeNavigation = _data["typeNavigation"] ? KontraktType.fromJS(_data["typeNavigation"]) : undefined as any;
            if (Array.isArray(_data["varenumre"])) {
                this.varenumre = [] as any;
                for (let item of _data["varenumre"])
                    this.varenumre!.push(Varenumre.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Hovedkontrakt {
        data = typeof data === 'object' ? data : {};
        let result = new Hovedkontrakt();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["hkontrakt"] = this.hkontrakt;
        data["bogtitel"] = this.bogtitel;
        data["type"] = this.type;
        data["gruppe"] = this.gruppe;
        data["redaktor"] = this.redaktor;
        data["afregnTermin"] = this.afregnTermin;
        data["formaal"] = this.formaal;
        data["afregningstype"] = this.afregningstype;
        data["startdato"] = this.startdato ? this.startdato.toISOString() : undefined as any;
        data["budget"] = this.budget;
        data["specielAfregning"] = this.specielAfregning;
        data["forlag"] = this.forlag;
        data["oprindeligTitel"] = this.oprindeligTitel;
        data["oprindeligForfatter"] = this.oprindeligForfatter;
        data["infoTekst"] = this.infoTekst;
        data["anmeldelse"] = this.anmeldelse;
        data["salgsark"] = this.salgsark;
        data["fastprisAfregning"] = this.fastprisAfregning;
        data["guidingPrice"] = this.guidingPrice;
        data["template"] = this.template;
        data["logRef"] = this.logRef;
        data["kladde"] = this.kladde;
        data["agent"] = this.agent;
        data["ssmaTimeStamp"] = this.ssmaTimeStamp;
        data["afregningstypeNavigation"] = this.afregningstypeNavigation ? this.afregningstypeNavigation.toJSON() : undefined as any;
        data["forlagNavigation"] = this.forlagNavigation ? this.forlagNavigation.toJSON() : undefined as any;
        data["formaalNavigation"] = this.formaalNavigation ? this.formaalNavigation.toJSON() : undefined as any;
        data["gruppeNavigation"] = this.gruppeNavigation ? this.gruppeNavigation.toJSON() : undefined as any;
        data["redaktorNavigation"] = this.redaktorNavigation ? this.redaktorNavigation.toJSON() : undefined as any;
        data["typeNavigation"] = this.typeNavigation ? this.typeNavigation.toJSON() : undefined as any;
        if (Array.isArray(this.varenumre)) {
            data["varenumre"] = [];
            for (let item of this.varenumre)
                data["varenumre"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IHovedkontrakt {
    id?: number;
    hkontrakt?: number | undefined;
    bogtitel?: string | undefined;
    type?: number | undefined;
    gruppe?: number | undefined;
    redaktor?: number | undefined;
    afregnTermin?: number | undefined;
    formaal?: number | undefined;
    afregningstype?: number | undefined;
    startdato?: Date | undefined;
    budget?: boolean | undefined;
    specielAfregning?: string | undefined;
    forlag?: number | undefined;
    oprindeligTitel?: string | undefined;
    oprindeligForfatter?: string | undefined;
    infoTekst?: string | undefined;
    anmeldelse?: boolean | undefined;
    salgsark?: boolean | undefined;
    fastprisAfregning?: boolean | undefined;
    guidingPrice?: boolean | undefined;
    template?: number | undefined;
    logRef?: number | undefined;
    kladde?: number | undefined;
    agent?: number | undefined;
    ssmaTimeStamp?: string | undefined;
    afregningstypeNavigation?: AfregningsType | undefined;
    forlagNavigation?: Forlag | undefined;
    formaalNavigation?: Formaal | undefined;
    gruppeNavigation?: Gruppe | undefined;
    redaktorNavigation?: Redaktoer | undefined;
    typeNavigation?: KontraktType | undefined;
    varenumre?: Varenumre[] | undefined;
}

export class AfregningsType implements IAfregningsType {
    id?: number;
    afregningstype1?: string | undefined;
    beskrivelse?: string | undefined;
    hovedkontrakt?: Hovedkontrakt[] | undefined;

    constructor(data?: IAfregningsType) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.afregningstype1 = _data["afregningstype1"];
            this.beskrivelse = _data["beskrivelse"];
            if (Array.isArray(_data["hovedkontrakt"])) {
                this.hovedkontrakt = [] as any;
                for (let item of _data["hovedkontrakt"])
                    this.hovedkontrakt!.push(Hovedkontrakt.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AfregningsType {
        data = typeof data === 'object' ? data : {};
        let result = new AfregningsType();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["afregningstype1"] = this.afregningstype1;
        data["beskrivelse"] = this.beskrivelse;
        if (Array.isArray(this.hovedkontrakt)) {
            data["hovedkontrakt"] = [];
            for (let item of this.hovedkontrakt)
                data["hovedkontrakt"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IAfregningsType {
    id?: number;
    afregningstype1?: string | undefined;
    beskrivelse?: string | undefined;
    hovedkontrakt?: Hovedkontrakt[] | undefined;
}

export class Forlag implements IForlag {
    id?: number;
    forlag1?: string | undefined;
    hovedkontrakt?: Hovedkontrakt[] | undefined;

    constructor(data?: IForlag) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.forlag1 = _data["forlag1"];
            if (Array.isArray(_data["hovedkontrakt"])) {
                this.hovedkontrakt = [] as any;
                for (let item of _data["hovedkontrakt"])
                    this.hovedkontrakt!.push(Hovedkontrakt.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Forlag {
        data = typeof data === 'object' ? data : {};
        let result = new Forlag();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["forlag1"] = this.forlag1;
        if (Array.isArray(this.hovedkontrakt)) {
            data["hovedkontrakt"] = [];
            for (let item of this.hovedkontrakt)
                data["hovedkontrakt"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IForlag {
    id?: number;
    forlag1?: string | undefined;
    hovedkontrakt?: Hovedkontrakt[] | undefined;
}

export class Formaal implements IFormaal {
    id?: number;
    formaal1?: string | undefined;
    hovedkontrakt?: Hovedkontrakt[] | undefined;

    constructor(data?: IFormaal) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.formaal1 = _data["formaal1"];
            if (Array.isArray(_data["hovedkontrakt"])) {
                this.hovedkontrakt = [] as any;
                for (let item of _data["hovedkontrakt"])
                    this.hovedkontrakt!.push(Hovedkontrakt.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Formaal {
        data = typeof data === 'object' ? data : {};
        let result = new Formaal();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["formaal1"] = this.formaal1;
        if (Array.isArray(this.hovedkontrakt)) {
            data["hovedkontrakt"] = [];
            for (let item of this.hovedkontrakt)
                data["hovedkontrakt"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IFormaal {
    id?: number;
    formaal1?: string | undefined;
    hovedkontrakt?: Hovedkontrakt[] | undefined;
}

export class Gruppe implements IGruppe {
    id?: number;
    gruppeNavn?: string | undefined;
    gruppeBeskrivelse?: string | undefined;
    hovedkontrakt?: Hovedkontrakt[] | undefined;

    constructor(data?: IGruppe) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.gruppeNavn = _data["gruppeNavn"];
            this.gruppeBeskrivelse = _data["gruppeBeskrivelse"];
            if (Array.isArray(_data["hovedkontrakt"])) {
                this.hovedkontrakt = [] as any;
                for (let item of _data["hovedkontrakt"])
                    this.hovedkontrakt!.push(Hovedkontrakt.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Gruppe {
        data = typeof data === 'object' ? data : {};
        let result = new Gruppe();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["gruppeNavn"] = this.gruppeNavn;
        data["gruppeBeskrivelse"] = this.gruppeBeskrivelse;
        if (Array.isArray(this.hovedkontrakt)) {
            data["hovedkontrakt"] = [];
            for (let item of this.hovedkontrakt)
                data["hovedkontrakt"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IGruppe {
    id?: number;
    gruppeNavn?: string | undefined;
    gruppeBeskrivelse?: string | undefined;
    hovedkontrakt?: Hovedkontrakt[] | undefined;
}

export class Redaktoer implements IRedaktoer {
    id?: number;
    redaktorInitialer?: string | undefined;
    navn?: string | undefined;
    email?: string | undefined;
    inActive?: boolean;
    hovedkontrakt?: Hovedkontrakt[] | undefined;

    constructor(data?: IRedaktoer) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.redaktorInitialer = _data["redaktorInitialer"];
            this.navn = _data["navn"];
            this.email = _data["email"];
            this.inActive = _data["inActive"];
            if (Array.isArray(_data["hovedkontrakt"])) {
                this.hovedkontrakt = [] as any;
                for (let item of _data["hovedkontrakt"])
                    this.hovedkontrakt!.push(Hovedkontrakt.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Redaktoer {
        data = typeof data === 'object' ? data : {};
        let result = new Redaktoer();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["redaktorInitialer"] = this.redaktorInitialer;
        data["navn"] = this.navn;
        data["email"] = this.email;
        data["inActive"] = this.inActive;
        if (Array.isArray(this.hovedkontrakt)) {
            data["hovedkontrakt"] = [];
            for (let item of this.hovedkontrakt)
                data["hovedkontrakt"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IRedaktoer {
    id?: number;
    redaktorInitialer?: string | undefined;
    navn?: string | undefined;
    email?: string | undefined;
    inActive?: boolean;
    hovedkontrakt?: Hovedkontrakt[] | undefined;
}

export class KontraktType implements IKontraktType {
    id?: number;
    kontraktType1?: string | undefined;
    afregning?: boolean;
    ssmaTimeStamp?: string | undefined;
    hovedkontrakt?: Hovedkontrakt[] | undefined;

    constructor(data?: IKontraktType) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.kontraktType1 = _data["kontraktType1"];
            this.afregning = _data["afregning"];
            this.ssmaTimeStamp = _data["ssmaTimeStamp"];
            if (Array.isArray(_data["hovedkontrakt"])) {
                this.hovedkontrakt = [] as any;
                for (let item of _data["hovedkontrakt"])
                    this.hovedkontrakt!.push(Hovedkontrakt.fromJS(item));
            }
        }
    }

    static fromJS(data: any): KontraktType {
        data = typeof data === 'object' ? data : {};
        let result = new KontraktType();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["kontraktType1"] = this.kontraktType1;
        data["afregning"] = this.afregning;
        data["ssmaTimeStamp"] = this.ssmaTimeStamp;
        if (Array.isArray(this.hovedkontrakt)) {
            data["hovedkontrakt"] = [];
            for (let item of this.hovedkontrakt)
                data["hovedkontrakt"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IKontraktType {
    id?: number;
    kontraktType1?: string | undefined;
    afregning?: boolean;
    ssmaTimeStamp?: string | undefined;
    hovedkontrakt?: Hovedkontrakt[] | undefined;
}

export class Indbindinger implements IIndbindinger {
    id?: number;
    indbinding?: string | undefined;
    varenumre?: Varenumre[] | undefined;

    constructor(data?: IIndbindinger) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.indbinding = _data["indbinding"];
            if (Array.isArray(_data["varenumre"])) {
                this.varenumre = [] as any;
                for (let item of _data["varenumre"])
                    this.varenumre!.push(Varenumre.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Indbindinger {
        data = typeof data === 'object' ? data : {};
        let result = new Indbindinger();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["indbinding"] = this.indbinding;
        if (Array.isArray(this.varenumre)) {
            data["varenumre"] = [];
            for (let item of this.varenumre)
                data["varenumre"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IIndbindinger {
    id?: number;
    indbinding?: string | undefined;
    varenumre?: Varenumre[] | undefined;
}

export class Afregningstabel implements IAfregningstabel {
    hid?: number;
    fid?: number;
    antal?: number;
    procent?: number | undefined;
    forskud?: number | undefined;
    currency?: number | undefined;
    sortKey?: number | undefined;
    logRef?: number | undefined;
    ssmaTimeStamp?: string | undefined;
    kladde?: number | undefined;
    f?: Forfatter | undefined;
    h?: Varenumre | undefined;

    constructor(data?: IAfregningstabel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.hid = _data["hid"];
            this.fid = _data["fid"];
            this.antal = _data["antal"];
            this.procent = _data["procent"];
            this.forskud = _data["forskud"];
            this.currency = _data["currency"];
            this.sortKey = _data["sortKey"];
            this.logRef = _data["logRef"];
            this.ssmaTimeStamp = _data["ssmaTimeStamp"];
            this.kladde = _data["kladde"];
            this.f = _data["f"] ? Forfatter.fromJS(_data["f"]) : undefined as any;
            this.h = _data["h"] ? Varenumre.fromJS(_data["h"]) : undefined as any;
        }
    }

    static fromJS(data: any): Afregningstabel {
        data = typeof data === 'object' ? data : {};
        let result = new Afregningstabel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["hid"] = this.hid;
        data["fid"] = this.fid;
        data["antal"] = this.antal;
        data["procent"] = this.procent;
        data["forskud"] = this.forskud;
        data["currency"] = this.currency;
        data["sortKey"] = this.sortKey;
        data["logRef"] = this.logRef;
        data["ssmaTimeStamp"] = this.ssmaTimeStamp;
        data["kladde"] = this.kladde;
        data["f"] = this.f ? this.f.toJSON() : undefined as any;
        data["h"] = this.h ? this.h.toJSON() : undefined as any;
        return data;
    }
}

export interface IAfregningstabel {
    hid?: number;
    fid?: number;
    antal?: number;
    procent?: number | undefined;
    forskud?: number | undefined;
    currency?: number | undefined;
    sortKey?: number | undefined;
    logRef?: number | undefined;
    ssmaTimeStamp?: string | undefined;
    kladde?: number | undefined;
    f?: Forfatter | undefined;
    h?: Varenumre | undefined;
}

export class Forfatter implements IForfatter {
    id?: number;
    forfatterId?: string | undefined;
    navn?: string | undefined;
    adresse1?: string | undefined;
    adresse2?: string | undefined;
    postNr?: string | undefined;
    zipcity?: string | undefined;
    land?: string | undefined;
    telefonNr?: string | undefined;
    email?: string | undefined;
    bankRegNr?: string | undefined;
    kontoNr?: string | undefined;
    swift?: string | undefined;
    iban?: string | undefined;
    cvrCpr?: string | undefined;
    moms?: boolean | undefined;
    valuta?: number | undefined;
    attention?: string | undefined;
    bankKonto?: string | undefined;
    logRef?: number | undefined;
    inAktiv?: boolean | undefined;
    kladde?: number | undefined;
    ssmaTimeStamp?: string | undefined;
    valutaNavigation?: ValutaKoder | undefined;
    afregningstabel?: Afregningstabel[] | undefined;
    royaltyTrans?: RoyaltyTrans[] | undefined;
    royaltyTransTrappe?: RoyaltyTransTrappe[] | undefined;

    constructor(data?: IForfatter) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.forfatterId = _data["forfatterId"];
            this.navn = _data["navn"];
            this.adresse1 = _data["adresse1"];
            this.adresse2 = _data["adresse2"];
            this.postNr = _data["postNr"];
            this.zipcity = _data["zipcity"];
            this.land = _data["land"];
            this.telefonNr = _data["telefonNr"];
            this.email = _data["email"];
            this.bankRegNr = _data["bankRegNr"];
            this.kontoNr = _data["kontoNr"];
            this.swift = _data["swift"];
            this.iban = _data["iban"];
            this.cvrCpr = _data["cvrCpr"];
            this.moms = _data["moms"];
            this.valuta = _data["valuta"];
            this.attention = _data["attention"];
            this.bankKonto = _data["bankKonto"];
            this.logRef = _data["logRef"];
            this.inAktiv = _data["inAktiv"];
            this.kladde = _data["kladde"];
            this.ssmaTimeStamp = _data["ssmaTimeStamp"];
            this.valutaNavigation = _data["valutaNavigation"] ? ValutaKoder.fromJS(_data["valutaNavigation"]) : undefined as any;
            if (Array.isArray(_data["afregningstabel"])) {
                this.afregningstabel = [] as any;
                for (let item of _data["afregningstabel"])
                    this.afregningstabel!.push(Afregningstabel.fromJS(item));
            }
            if (Array.isArray(_data["royaltyTrans"])) {
                this.royaltyTrans = [] as any;
                for (let item of _data["royaltyTrans"])
                    this.royaltyTrans!.push(RoyaltyTrans.fromJS(item));
            }
            if (Array.isArray(_data["royaltyTransTrappe"])) {
                this.royaltyTransTrappe = [] as any;
                for (let item of _data["royaltyTransTrappe"])
                    this.royaltyTransTrappe!.push(RoyaltyTransTrappe.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Forfatter {
        data = typeof data === 'object' ? data : {};
        let result = new Forfatter();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["forfatterId"] = this.forfatterId;
        data["navn"] = this.navn;
        data["adresse1"] = this.adresse1;
        data["adresse2"] = this.adresse2;
        data["postNr"] = this.postNr;
        data["zipcity"] = this.zipcity;
        data["land"] = this.land;
        data["telefonNr"] = this.telefonNr;
        data["email"] = this.email;
        data["bankRegNr"] = this.bankRegNr;
        data["kontoNr"] = this.kontoNr;
        data["swift"] = this.swift;
        data["iban"] = this.iban;
        data["cvrCpr"] = this.cvrCpr;
        data["moms"] = this.moms;
        data["valuta"] = this.valuta;
        data["attention"] = this.attention;
        data["bankKonto"] = this.bankKonto;
        data["logRef"] = this.logRef;
        data["inAktiv"] = this.inAktiv;
        data["kladde"] = this.kladde;
        data["ssmaTimeStamp"] = this.ssmaTimeStamp;
        data["valutaNavigation"] = this.valutaNavigation ? this.valutaNavigation.toJSON() : undefined as any;
        if (Array.isArray(this.afregningstabel)) {
            data["afregningstabel"] = [];
            for (let item of this.afregningstabel)
                data["afregningstabel"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.royaltyTrans)) {
            data["royaltyTrans"] = [];
            for (let item of this.royaltyTrans)
                data["royaltyTrans"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.royaltyTransTrappe)) {
            data["royaltyTransTrappe"] = [];
            for (let item of this.royaltyTransTrappe)
                data["royaltyTransTrappe"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IForfatter {
    id?: number;
    forfatterId?: string | undefined;
    navn?: string | undefined;
    adresse1?: string | undefined;
    adresse2?: string | undefined;
    postNr?: string | undefined;
    zipcity?: string | undefined;
    land?: string | undefined;
    telefonNr?: string | undefined;
    email?: string | undefined;
    bankRegNr?: string | undefined;
    kontoNr?: string | undefined;
    swift?: string | undefined;
    iban?: string | undefined;
    cvrCpr?: string | undefined;
    moms?: boolean | undefined;
    valuta?: number | undefined;
    attention?: string | undefined;
    bankKonto?: string | undefined;
    logRef?: number | undefined;
    inAktiv?: boolean | undefined;
    kladde?: number | undefined;
    ssmaTimeStamp?: string | undefined;
    valutaNavigation?: ValutaKoder | undefined;
    afregningstabel?: Afregningstabel[] | undefined;
    royaltyTrans?: RoyaltyTrans[] | undefined;
    royaltyTransTrappe?: RoyaltyTransTrappe[] | undefined;
}

export class ValutaKoder implements IValutaKoder {
    id?: number;
    valutaKode?: string | undefined;
    forfatter?: Forfatter[] | undefined;
    royaltyTrans?: RoyaltyTrans[] | undefined;
    royaltyTransTrappe?: RoyaltyTransTrappe[] | undefined;
    valutaKurser?: ValutaKurser[] | undefined;

    constructor(data?: IValutaKoder) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.valutaKode = _data["valutaKode"];
            if (Array.isArray(_data["forfatter"])) {
                this.forfatter = [] as any;
                for (let item of _data["forfatter"])
                    this.forfatter!.push(Forfatter.fromJS(item));
            }
            if (Array.isArray(_data["royaltyTrans"])) {
                this.royaltyTrans = [] as any;
                for (let item of _data["royaltyTrans"])
                    this.royaltyTrans!.push(RoyaltyTrans.fromJS(item));
            }
            if (Array.isArray(_data["royaltyTransTrappe"])) {
                this.royaltyTransTrappe = [] as any;
                for (let item of _data["royaltyTransTrappe"])
                    this.royaltyTransTrappe!.push(RoyaltyTransTrappe.fromJS(item));
            }
            if (Array.isArray(_data["valutaKurser"])) {
                this.valutaKurser = [] as any;
                for (let item of _data["valutaKurser"])
                    this.valutaKurser!.push(ValutaKurser.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ValutaKoder {
        data = typeof data === 'object' ? data : {};
        let result = new ValutaKoder();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["valutaKode"] = this.valutaKode;
        if (Array.isArray(this.forfatter)) {
            data["forfatter"] = [];
            for (let item of this.forfatter)
                data["forfatter"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.royaltyTrans)) {
            data["royaltyTrans"] = [];
            for (let item of this.royaltyTrans)
                data["royaltyTrans"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.royaltyTransTrappe)) {
            data["royaltyTransTrappe"] = [];
            for (let item of this.royaltyTransTrappe)
                data["royaltyTransTrappe"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.valutaKurser)) {
            data["valutaKurser"] = [];
            for (let item of this.valutaKurser)
                data["valutaKurser"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IValutaKoder {
    id?: number;
    valutaKode?: string | undefined;
    forfatter?: Forfatter[] | undefined;
    royaltyTrans?: RoyaltyTrans[] | undefined;
    royaltyTransTrappe?: RoyaltyTransTrappe[] | undefined;
    valutaKurser?: ValutaKurser[] | undefined;
}

export class RoyaltyTrans implements IRoyaltyTrans {
    hid?: number;
    fid?: number;
    dato?: Date;
    transType?: number;
    omsAntal?: number | undefined;
    omsAntalDiff?: number | undefined;
    valuta?: number;
    valutaKurs?: number | undefined;
    salgsPrisDkk?: number | undefined;
    salgsPrisVal?: number | undefined;
    omsBeløbVal?: number | undefined;
    royaltyBeløbBeregnVal?: number;
    ssmaTimeStamp?: string | undefined;
    id?: number;
    ukontrakt?: number | undefined;
    godkendt?: number | undefined;
    godkendtAf?: string | undefined;
    godkendtDato?: Date | undefined;
    afsluttet?: number | undefined;
    afsluttetAf?: string | undefined;
    afsluttetDato?: Date | undefined;
    createdDate?: Date | undefined;
    f?: Forfatter | undefined;
    h?: Varenumre | undefined;
    transTypeNavigation?: RoyaltyTransType | undefined;
    valutaNavigation?: ValutaKoder | undefined;

    constructor(data?: IRoyaltyTrans) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.hid = _data["hid"];
            this.fid = _data["fid"];
            this.dato = _data["dato"] ? new Date(_data["dato"].toString()) : undefined as any;
            this.transType = _data["transType"];
            this.omsAntal = _data["omsAntal"];
            this.omsAntalDiff = _data["omsAntalDiff"];
            this.valuta = _data["valuta"];
            this.valutaKurs = _data["valutaKurs"];
            this.salgsPrisDkk = _data["salgsPrisDkk"];
            this.salgsPrisVal = _data["salgsPrisVal"];
            this.omsBeløbVal = _data["omsBeløbVal"];
            this.royaltyBeløbBeregnVal = _data["royaltyBeløbBeregnVal"];
            this.ssmaTimeStamp = _data["ssmaTimeStamp"];
            this.id = _data["id"];
            this.ukontrakt = _data["ukontrakt"];
            this.godkendt = _data["godkendt"];
            this.godkendtAf = _data["godkendtAf"];
            this.godkendtDato = _data["godkendtDato"] ? new Date(_data["godkendtDato"].toString()) : undefined as any;
            this.afsluttet = _data["afsluttet"];
            this.afsluttetAf = _data["afsluttetAf"];
            this.afsluttetDato = _data["afsluttetDato"] ? new Date(_data["afsluttetDato"].toString()) : undefined as any;
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : undefined as any;
            this.f = _data["f"] ? Forfatter.fromJS(_data["f"]) : undefined as any;
            this.h = _data["h"] ? Varenumre.fromJS(_data["h"]) : undefined as any;
            this.transTypeNavigation = _data["transTypeNavigation"] ? RoyaltyTransType.fromJS(_data["transTypeNavigation"]) : undefined as any;
            this.valutaNavigation = _data["valutaNavigation"] ? ValutaKoder.fromJS(_data["valutaNavigation"]) : undefined as any;
        }
    }

    static fromJS(data: any): RoyaltyTrans {
        data = typeof data === 'object' ? data : {};
        let result = new RoyaltyTrans();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["hid"] = this.hid;
        data["fid"] = this.fid;
        data["dato"] = this.dato ? this.dato.toISOString() : undefined as any;
        data["transType"] = this.transType;
        data["omsAntal"] = this.omsAntal;
        data["omsAntalDiff"] = this.omsAntalDiff;
        data["valuta"] = this.valuta;
        data["valutaKurs"] = this.valutaKurs;
        data["salgsPrisDkk"] = this.salgsPrisDkk;
        data["salgsPrisVal"] = this.salgsPrisVal;
        data["omsBeløbVal"] = this.omsBeløbVal;
        data["royaltyBeløbBeregnVal"] = this.royaltyBeløbBeregnVal;
        data["ssmaTimeStamp"] = this.ssmaTimeStamp;
        data["id"] = this.id;
        data["ukontrakt"] = this.ukontrakt;
        data["godkendt"] = this.godkendt;
        data["godkendtAf"] = this.godkendtAf;
        data["godkendtDato"] = this.godkendtDato ? this.godkendtDato.toISOString() : undefined as any;
        data["afsluttet"] = this.afsluttet;
        data["afsluttetAf"] = this.afsluttetAf;
        data["afsluttetDato"] = this.afsluttetDato ? this.afsluttetDato.toISOString() : undefined as any;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : undefined as any;
        data["f"] = this.f ? this.f.toJSON() : undefined as any;
        data["h"] = this.h ? this.h.toJSON() : undefined as any;
        data["transTypeNavigation"] = this.transTypeNavigation ? this.transTypeNavigation.toJSON() : undefined as any;
        data["valutaNavigation"] = this.valutaNavigation ? this.valutaNavigation.toJSON() : undefined as any;
        return data;
    }
}

export interface IRoyaltyTrans {
    hid?: number;
    fid?: number;
    dato?: Date;
    transType?: number;
    omsAntal?: number | undefined;
    omsAntalDiff?: number | undefined;
    valuta?: number;
    valutaKurs?: number | undefined;
    salgsPrisDkk?: number | undefined;
    salgsPrisVal?: number | undefined;
    omsBeløbVal?: number | undefined;
    royaltyBeløbBeregnVal?: number;
    ssmaTimeStamp?: string | undefined;
    id?: number;
    ukontrakt?: number | undefined;
    godkendt?: number | undefined;
    godkendtAf?: string | undefined;
    godkendtDato?: Date | undefined;
    afsluttet?: number | undefined;
    afsluttetAf?: string | undefined;
    afsluttetDato?: Date | undefined;
    createdDate?: Date | undefined;
    f?: Forfatter | undefined;
    h?: Varenumre | undefined;
    transTypeNavigation?: RoyaltyTransType | undefined;
    valutaNavigation?: ValutaKoder | undefined;
}

export class RoyaltyTransType implements IRoyaltyTransType {
    id?: number;
    type?: string | undefined;
    ssmaTimeStamp?: string | undefined;
    royaltyTrans?: RoyaltyTrans[] | undefined;

    constructor(data?: IRoyaltyTransType) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.type = _data["type"];
            this.ssmaTimeStamp = _data["ssmaTimeStamp"];
            if (Array.isArray(_data["royaltyTrans"])) {
                this.royaltyTrans = [] as any;
                for (let item of _data["royaltyTrans"])
                    this.royaltyTrans!.push(RoyaltyTrans.fromJS(item));
            }
        }
    }

    static fromJS(data: any): RoyaltyTransType {
        data = typeof data === 'object' ? data : {};
        let result = new RoyaltyTransType();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["type"] = this.type;
        data["ssmaTimeStamp"] = this.ssmaTimeStamp;
        if (Array.isArray(this.royaltyTrans)) {
            data["royaltyTrans"] = [];
            for (let item of this.royaltyTrans)
                data["royaltyTrans"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IRoyaltyTransType {
    id?: number;
    type?: string | undefined;
    ssmaTimeStamp?: string | undefined;
    royaltyTrans?: RoyaltyTrans[] | undefined;
}

export class RoyaltyTransTrappe implements IRoyaltyTransTrappe {
    hid?: number;
    fid?: number;
    dato?: Date;
    trappeFra?: number | undefined;
    trappeTil?: number;
    royaltySats?: number | undefined;
    omsAntal?: number | undefined;
    omsAntalDiff?: number | undefined;
    valuta?: number;
    valutaKurs?: number;
    salgsPrisDkk?: number;
    salgsPrisVal?: number;
    omsBeløbVal?: number;
    royaltyBeløbBeregnVal?: number;
    royaltyBeløbSaldoVal?: number;
    ssmaTimeStamp?: string | undefined;
    id?: number;
    salgsPrisFraDato?: Date;
    salgsPrisTilDato?: Date;
    f?: Forfatter | undefined;
    h?: Varenumre | undefined;
    valutaNavigation?: ValutaKoder | undefined;

    constructor(data?: IRoyaltyTransTrappe) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.hid = _data["hid"];
            this.fid = _data["fid"];
            this.dato = _data["dato"] ? new Date(_data["dato"].toString()) : undefined as any;
            this.trappeFra = _data["trappeFra"];
            this.trappeTil = _data["trappeTil"];
            this.royaltySats = _data["royaltySats"];
            this.omsAntal = _data["omsAntal"];
            this.omsAntalDiff = _data["omsAntalDiff"];
            this.valuta = _data["valuta"];
            this.valutaKurs = _data["valutaKurs"];
            this.salgsPrisDkk = _data["salgsPrisDkk"];
            this.salgsPrisVal = _data["salgsPrisVal"];
            this.omsBeløbVal = _data["omsBeløbVal"];
            this.royaltyBeløbBeregnVal = _data["royaltyBeløbBeregnVal"];
            this.royaltyBeløbSaldoVal = _data["royaltyBeløbSaldoVal"];
            this.ssmaTimeStamp = _data["ssmaTimeStamp"];
            this.id = _data["id"];
            this.salgsPrisFraDato = _data["salgsPrisFraDato"] ? new Date(_data["salgsPrisFraDato"].toString()) : undefined as any;
            this.salgsPrisTilDato = _data["salgsPrisTilDato"] ? new Date(_data["salgsPrisTilDato"].toString()) : undefined as any;
            this.f = _data["f"] ? Forfatter.fromJS(_data["f"]) : undefined as any;
            this.h = _data["h"] ? Varenumre.fromJS(_data["h"]) : undefined as any;
            this.valutaNavigation = _data["valutaNavigation"] ? ValutaKoder.fromJS(_data["valutaNavigation"]) : undefined as any;
        }
    }

    static fromJS(data: any): RoyaltyTransTrappe {
        data = typeof data === 'object' ? data : {};
        let result = new RoyaltyTransTrappe();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["hid"] = this.hid;
        data["fid"] = this.fid;
        data["dato"] = this.dato ? this.dato.toISOString() : undefined as any;
        data["trappeFra"] = this.trappeFra;
        data["trappeTil"] = this.trappeTil;
        data["royaltySats"] = this.royaltySats;
        data["omsAntal"] = this.omsAntal;
        data["omsAntalDiff"] = this.omsAntalDiff;
        data["valuta"] = this.valuta;
        data["valutaKurs"] = this.valutaKurs;
        data["salgsPrisDkk"] = this.salgsPrisDkk;
        data["salgsPrisVal"] = this.salgsPrisVal;
        data["omsBeløbVal"] = this.omsBeløbVal;
        data["royaltyBeløbBeregnVal"] = this.royaltyBeløbBeregnVal;
        data["royaltyBeløbSaldoVal"] = this.royaltyBeløbSaldoVal;
        data["ssmaTimeStamp"] = this.ssmaTimeStamp;
        data["id"] = this.id;
        data["salgsPrisFraDato"] = this.salgsPrisFraDato ? this.salgsPrisFraDato.toISOString() : undefined as any;
        data["salgsPrisTilDato"] = this.salgsPrisTilDato ? this.salgsPrisTilDato.toISOString() : undefined as any;
        data["f"] = this.f ? this.f.toJSON() : undefined as any;
        data["h"] = this.h ? this.h.toJSON() : undefined as any;
        data["valutaNavigation"] = this.valutaNavigation ? this.valutaNavigation.toJSON() : undefined as any;
        return data;
    }
}

export interface IRoyaltyTransTrappe {
    hid?: number;
    fid?: number;
    dato?: Date;
    trappeFra?: number | undefined;
    trappeTil?: number;
    royaltySats?: number | undefined;
    omsAntal?: number | undefined;
    omsAntalDiff?: number | undefined;
    valuta?: number;
    valutaKurs?: number;
    salgsPrisDkk?: number;
    salgsPrisVal?: number;
    omsBeløbVal?: number;
    royaltyBeløbBeregnVal?: number;
    royaltyBeløbSaldoVal?: number;
    ssmaTimeStamp?: string | undefined;
    id?: number;
    salgsPrisFraDato?: Date;
    salgsPrisTilDato?: Date;
    f?: Forfatter | undefined;
    h?: Varenumre | undefined;
    valutaNavigation?: ValutaKoder | undefined;
}

export class ValutaKurser implements IValutaKurser {
    dato?: Date;
    valutaKode?: number;
    kurs?: number;
    valutaKodeNavigation?: ValutaKoder | undefined;

    constructor(data?: IValutaKurser) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dato = _data["dato"] ? new Date(_data["dato"].toString()) : undefined as any;
            this.valutaKode = _data["valutaKode"];
            this.kurs = _data["kurs"];
            this.valutaKodeNavigation = _data["valutaKodeNavigation"] ? ValutaKoder.fromJS(_data["valutaKodeNavigation"]) : undefined as any;
        }
    }

    static fromJS(data: any): ValutaKurser {
        data = typeof data === 'object' ? data : {};
        let result = new ValutaKurser();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dato"] = this.dato ? this.dato.toISOString() : undefined as any;
        data["valutaKode"] = this.valutaKode;
        data["kurs"] = this.kurs;
        data["valutaKodeNavigation"] = this.valutaKodeNavigation ? this.valutaKodeNavigation.toJSON() : undefined as any;
        return data;
    }
}

export interface IValutaKurser {
    dato?: Date;
    valutaKode?: number;
    kurs?: number;
    valutaKodeNavigation?: ValutaKoder | undefined;
}

export class RoyaltyNote implements IRoyaltyNote {
    hid?: number;
    dato?: Date;
    userId?: string | undefined;
    note?: string | undefined;
    isPublic?: boolean;
    ssmaTimeStamp?: string | undefined;
    id?: number;
    h?: Varenumre | undefined;

    constructor(data?: IRoyaltyNote) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.hid = _data["hid"];
            this.dato = _data["dato"] ? new Date(_data["dato"].toString()) : undefined as any;
            this.userId = _data["userId"];
            this.note = _data["note"];
            this.isPublic = _data["isPublic"];
            this.ssmaTimeStamp = _data["ssmaTimeStamp"];
            this.id = _data["id"];
            this.h = _data["h"] ? Varenumre.fromJS(_data["h"]) : undefined as any;
        }
    }

    static fromJS(data: any): RoyaltyNote {
        data = typeof data === 'object' ? data : {};
        let result = new RoyaltyNote();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["hid"] = this.hid;
        data["dato"] = this.dato ? this.dato.toISOString() : undefined as any;
        data["userId"] = this.userId;
        data["note"] = this.note;
        data["isPublic"] = this.isPublic;
        data["ssmaTimeStamp"] = this.ssmaTimeStamp;
        data["id"] = this.id;
        data["h"] = this.h ? this.h.toJSON() : undefined as any;
        return data;
    }
}

export interface IRoyaltyNote {
    hid?: number;
    dato?: Date;
    userId?: string | undefined;
    note?: string | undefined;
    isPublic?: boolean;
    ssmaTimeStamp?: string | undefined;
    id?: number;
    h?: Varenumre | undefined;
}

export class StdBelob implements IStdBelob {
    ukontrakt?: number;
    omkArt?: number;
    belob?: number | undefined;
    pct?: number | undefined;
    termin?: number | undefined;
    logRef?: number | undefined;
    kladde?: number | undefined;
    ssmaTimeStamp?: string | undefined;
    ukontraktNavigation?: Varenumre | undefined;

    constructor(data?: IStdBelob) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ukontrakt = _data["ukontrakt"];
            this.omkArt = _data["omkArt"];
            this.belob = _data["belob"];
            this.pct = _data["pct"];
            this.termin = _data["termin"];
            this.logRef = _data["logRef"];
            this.kladde = _data["kladde"];
            this.ssmaTimeStamp = _data["ssmaTimeStamp"];
            this.ukontraktNavigation = _data["ukontraktNavigation"] ? Varenumre.fromJS(_data["ukontraktNavigation"]) : undefined as any;
        }
    }

    static fromJS(data: any): StdBelob {
        data = typeof data === 'object' ? data : {};
        let result = new StdBelob();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ukontrakt"] = this.ukontrakt;
        data["omkArt"] = this.omkArt;
        data["belob"] = this.belob;
        data["pct"] = this.pct;
        data["termin"] = this.termin;
        data["logRef"] = this.logRef;
        data["kladde"] = this.kladde;
        data["ssmaTimeStamp"] = this.ssmaTimeStamp;
        data["ukontraktNavigation"] = this.ukontraktNavigation ? this.ukontraktNavigation.toJSON() : undefined as any;
        return data;
    }
}

export interface IStdBelob {
    ukontrakt?: number;
    omkArt?: number;
    belob?: number | undefined;
    pct?: number | undefined;
    termin?: number | undefined;
    logRef?: number | undefined;
    kladde?: number | undefined;
    ssmaTimeStamp?: string | undefined;
    ukontraktNavigation?: Varenumre | undefined;
}

export class VareSalgsPrisHistorik implements IVareSalgsPrisHistorik {
    id?: number;
    ukontrakt?: number;
    tilDato?: Date;
    salgsPris?: number;
    ssmaTimeStamp?: string | undefined;
    ukontraktNavigation?: Varenumre | undefined;

    constructor(data?: IVareSalgsPrisHistorik) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.ukontrakt = _data["ukontrakt"];
            this.tilDato = _data["tilDato"] ? new Date(_data["tilDato"].toString()) : undefined as any;
            this.salgsPris = _data["salgsPris"];
            this.ssmaTimeStamp = _data["ssmaTimeStamp"];
            this.ukontraktNavigation = _data["ukontraktNavigation"] ? Varenumre.fromJS(_data["ukontraktNavigation"]) : undefined as any;
        }
    }

    static fromJS(data: any): VareSalgsPrisHistorik {
        data = typeof data === 'object' ? data : {};
        let result = new VareSalgsPrisHistorik();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["ukontrakt"] = this.ukontrakt;
        data["tilDato"] = this.tilDato ? this.tilDato.toISOString() : undefined as any;
        data["salgsPris"] = this.salgsPris;
        data["ssmaTimeStamp"] = this.ssmaTimeStamp;
        data["ukontraktNavigation"] = this.ukontraktNavigation ? this.ukontraktNavigation.toJSON() : undefined as any;
        return data;
    }
}

export interface IVareSalgsPrisHistorik {
    id?: number;
    ukontrakt?: number;
    tilDato?: Date;
    salgsPris?: number;
    ssmaTimeStamp?: string | undefined;
    ukontraktNavigation?: Varenumre | undefined;
}

export class UpdateRoyaltyTransCommand implements IUpdateRoyaltyTransCommand {
    id?: number;
    godkendt?: number | undefined;
    afsluttet?: number | undefined;
    betaltDato?: Date | undefined;
    betaltBelob?: number | undefined;
    note?: string | undefined;
    noteIsPublic?: boolean | undefined;
    recalcRoyalty?: boolean | undefined;
    recalcRoyaltyHovedKontrakt?: number | undefined;

    constructor(data?: IUpdateRoyaltyTransCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.godkendt = _data["godkendt"];
            this.afsluttet = _data["afsluttet"];
            this.betaltDato = _data["betaltDato"] ? new Date(_data["betaltDato"].toString()) : undefined as any;
            this.betaltBelob = _data["betaltBelob"];
            this.note = _data["note"];
            this.noteIsPublic = _data["noteIsPublic"];
            this.recalcRoyalty = _data["recalcRoyalty"];
            this.recalcRoyaltyHovedKontrakt = _data["recalcRoyaltyHovedKontrakt"];
        }
    }

    static fromJS(data: any): UpdateRoyaltyTransCommand {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateRoyaltyTransCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["godkendt"] = this.godkendt;
        data["afsluttet"] = this.afsluttet;
        data["betaltDato"] = this.betaltDato ? this.betaltDato.toISOString() : undefined as any;
        data["betaltBelob"] = this.betaltBelob;
        data["note"] = this.note;
        data["noteIsPublic"] = this.noteIsPublic;
        data["recalcRoyalty"] = this.recalcRoyalty;
        data["recalcRoyaltyHovedKontrakt"] = this.recalcRoyaltyHovedKontrakt;
        return data;
    }
}

export interface IUpdateRoyaltyTransCommand {
    id?: number;
    godkendt?: number | undefined;
    afsluttet?: number | undefined;
    betaltDato?: Date | undefined;
    betaltBelob?: number | undefined;
    note?: string | undefined;
    noteIsPublic?: boolean | undefined;
    recalcRoyalty?: boolean | undefined;
    recalcRoyaltyHovedKontrakt?: number | undefined;
}

export class RoyaltyStatementDocMergeCommand implements IRoyaltyStatementDocMergeCommand {
    id?: number | undefined;
    fid?: number | undefined;
    dato?: Date | undefined;
    createPDF?: boolean;
    createDraft?: boolean;

    constructor(data?: IRoyaltyStatementDocMergeCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.fid = _data["fid"];
            this.dato = _data["dato"] ? new Date(_data["dato"].toString()) : undefined as any;
            this.createPDF = _data["createPDF"];
            this.createDraft = _data["createDraft"];
        }
    }

    static fromJS(data: any): RoyaltyStatementDocMergeCommand {
        data = typeof data === 'object' ? data : {};
        let result = new RoyaltyStatementDocMergeCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["fid"] = this.fid;
        data["dato"] = this.dato ? this.dato.toISOString() : undefined as any;
        data["createPDF"] = this.createPDF;
        data["createDraft"] = this.createDraft;
        return data;
    }
}

export interface IRoyaltyStatementDocMergeCommand {
    id?: number | undefined;
    fid?: number | undefined;
    dato?: Date | undefined;
    createPDF?: boolean;
    createDraft?: boolean;
}

export class RoyaltyForlagViewVm implements IRoyaltyForlagViewVm {
    lists?: RoyaltyForlagViewDto[];

    constructor(data?: IRoyaltyForlagViewVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["lists"])) {
                this.lists = [] as any;
                for (let item of _data["lists"])
                    this.lists!.push(RoyaltyForlagViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): RoyaltyForlagViewVm {
        data = typeof data === 'object' ? data : {};
        let result = new RoyaltyForlagViewVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.lists)) {
            data["lists"] = [];
            for (let item of this.lists)
                data["lists"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IRoyaltyForlagViewVm {
    lists?: RoyaltyForlagViewDto[];
}

export class RoyaltyForlagViewDto implements IRoyaltyForlagViewDto {
    fid?: number;
    afregningId?: string | undefined;
    afregningNavn?: string | undefined;
    afregningAdresse?: string | undefined;
    afregningAdresse1?: string | undefined;
    afregningAdresse2?: string | undefined;
    afregningAdresse3?: string | undefined;
    afregningLand?: string | undefined;
    afregningEmail?: string | undefined;
    forlagId?: string | undefined;
    forlagNavn?: string | undefined;
    forlagAdresse1?: string | undefined;
    forlagAdresse2?: string | undefined;
    forlagAdresse3?: string | undefined;
    forlagLand?: string | undefined;
    forlagEmail?: string | undefined;
    valutaKode?: string | undefined;
    royaltyAmount?: number | undefined;
    royaltyDue?: number | undefined;
    antalStatus0?: number;
    antalStatus1?: number;
    antalStatus2?: number;
    antalStatus3?: number;
    antalStatus4?: number;
    antalStatus5?: number;
    antalStatus6?: number;
    antalStatus7?: number;
    start?: Date;
    slut?: Date;
    afregningOgForlagId?: string | undefined;

    constructor(data?: IRoyaltyForlagViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fid = _data["fid"];
            this.afregningId = _data["afregningId"];
            this.afregningNavn = _data["afregningNavn"];
            this.afregningAdresse = _data["afregningAdresse"];
            this.afregningAdresse1 = _data["afregningAdresse1"];
            this.afregningAdresse2 = _data["afregningAdresse2"];
            this.afregningAdresse3 = _data["afregningAdresse3"];
            this.afregningLand = _data["afregningLand"];
            this.afregningEmail = _data["afregningEmail"];
            this.forlagId = _data["forlagId"];
            this.forlagNavn = _data["forlagNavn"];
            this.forlagAdresse1 = _data["forlagAdresse1"];
            this.forlagAdresse2 = _data["forlagAdresse2"];
            this.forlagAdresse3 = _data["forlagAdresse3"];
            this.forlagLand = _data["forlagLand"];
            this.forlagEmail = _data["forlagEmail"];
            this.valutaKode = _data["valutaKode"];
            this.royaltyAmount = _data["royaltyAmount"];
            this.royaltyDue = _data["royaltyDue"];
            this.antalStatus0 = _data["antalStatus0"];
            this.antalStatus1 = _data["antalStatus1"];
            this.antalStatus2 = _data["antalStatus2"];
            this.antalStatus3 = _data["antalStatus3"];
            this.antalStatus4 = _data["antalStatus4"];
            this.antalStatus5 = _data["antalStatus5"];
            this.antalStatus6 = _data["antalStatus6"];
            this.antalStatus7 = _data["antalStatus7"];
            this.start = _data["start"] ? new Date(_data["start"].toString()) : undefined as any;
            this.slut = _data["slut"] ? new Date(_data["slut"].toString()) : undefined as any;
            this.afregningOgForlagId = _data["afregningOgForlagId"];
        }
    }

    static fromJS(data: any): RoyaltyForlagViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new RoyaltyForlagViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fid"] = this.fid;
        data["afregningId"] = this.afregningId;
        data["afregningNavn"] = this.afregningNavn;
        data["afregningAdresse"] = this.afregningAdresse;
        data["afregningAdresse1"] = this.afregningAdresse1;
        data["afregningAdresse2"] = this.afregningAdresse2;
        data["afregningAdresse3"] = this.afregningAdresse3;
        data["afregningLand"] = this.afregningLand;
        data["afregningEmail"] = this.afregningEmail;
        data["forlagId"] = this.forlagId;
        data["forlagNavn"] = this.forlagNavn;
        data["forlagAdresse1"] = this.forlagAdresse1;
        data["forlagAdresse2"] = this.forlagAdresse2;
        data["forlagAdresse3"] = this.forlagAdresse3;
        data["forlagLand"] = this.forlagLand;
        data["forlagEmail"] = this.forlagEmail;
        data["valutaKode"] = this.valutaKode;
        data["royaltyAmount"] = this.royaltyAmount;
        data["royaltyDue"] = this.royaltyDue;
        data["antalStatus0"] = this.antalStatus0;
        data["antalStatus1"] = this.antalStatus1;
        data["antalStatus2"] = this.antalStatus2;
        data["antalStatus3"] = this.antalStatus3;
        data["antalStatus4"] = this.antalStatus4;
        data["antalStatus5"] = this.antalStatus5;
        data["antalStatus6"] = this.antalStatus6;
        data["antalStatus7"] = this.antalStatus7;
        data["start"] = this.start ? this.start.toISOString() : undefined as any;
        data["slut"] = this.slut ? this.slut.toISOString() : undefined as any;
        data["afregningOgForlagId"] = this.afregningOgForlagId;
        return data;
    }
}

export interface IRoyaltyForlagViewDto {
    fid?: number;
    afregningId?: string | undefined;
    afregningNavn?: string | undefined;
    afregningAdresse?: string | undefined;
    afregningAdresse1?: string | undefined;
    afregningAdresse2?: string | undefined;
    afregningAdresse3?: string | undefined;
    afregningLand?: string | undefined;
    afregningEmail?: string | undefined;
    forlagId?: string | undefined;
    forlagNavn?: string | undefined;
    forlagAdresse1?: string | undefined;
    forlagAdresse2?: string | undefined;
    forlagAdresse3?: string | undefined;
    forlagLand?: string | undefined;
    forlagEmail?: string | undefined;
    valutaKode?: string | undefined;
    royaltyAmount?: number | undefined;
    royaltyDue?: number | undefined;
    antalStatus0?: number;
    antalStatus1?: number;
    antalStatus2?: number;
    antalStatus3?: number;
    antalStatus4?: number;
    antalStatus5?: number;
    antalStatus6?: number;
    antalStatus7?: number;
    start?: Date;
    slut?: Date;
    afregningOgForlagId?: string | undefined;
}

export class RunRoyaltyCalculationCommand implements IRunRoyaltyCalculationCommand {

    constructor(data?: IRunRoyaltyCalculationCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): RunRoyaltyCalculationCommand {
        data = typeof data === 'object' ? data : {};
        let result = new RunRoyaltyCalculationCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface IRunRoyaltyCalculationCommand {
}

export class SalesOrderSetCommand implements ISalesOrderSetCommand {
    salesOrderNum?: string | undefined;
    accountNum?: string | undefined;
    accountNumSet?: boolean;
    custInvoiceCreate?: boolean;

    constructor(data?: ISalesOrderSetCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.salesOrderNum = _data["salesOrderNum"];
            this.accountNum = _data["accountNum"];
            this.accountNumSet = _data["accountNumSet"];
            this.custInvoiceCreate = _data["custInvoiceCreate"];
        }
    }

    static fromJS(data: any): SalesOrderSetCommand {
        data = typeof data === 'object' ? data : {};
        let result = new SalesOrderSetCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["salesOrderNum"] = this.salesOrderNum;
        data["accountNum"] = this.accountNum;
        data["accountNumSet"] = this.accountNumSet;
        data["custInvoiceCreate"] = this.custInvoiceCreate;
        return data;
    }
}

export interface ISalesOrderSetCommand {
    salesOrderNum?: string | undefined;
    accountNum?: string | undefined;
    accountNumSet?: boolean;
    custInvoiceCreate?: boolean;
}

export class SalesOrdersPaymentCommand implements ISalesOrdersPaymentCommand {
    capture?: boolean;
    orderNums?: string[];
    enqueueJob?: boolean;

    constructor(data?: ISalesOrdersPaymentCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.capture = _data["capture"];
            if (Array.isArray(_data["orderNums"])) {
                this.orderNums = [] as any;
                for (let item of _data["orderNums"])
                    this.orderNums!.push(item);
            }
            this.enqueueJob = _data["enqueueJob"];
        }
    }

    static fromJS(data: any): SalesOrdersPaymentCommand {
        data = typeof data === 'object' ? data : {};
        let result = new SalesOrdersPaymentCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["capture"] = this.capture;
        if (Array.isArray(this.orderNums)) {
            data["orderNums"] = [];
            for (let item of this.orderNums)
                data["orderNums"].push(item);
        }
        data["enqueueJob"] = this.enqueueJob;
        return data;
    }
}

export interface ISalesOrdersPaymentCommand {
    capture?: boolean;
    orderNums?: string[];
    enqueueJob?: boolean;
}

export class UserVm implements IUserVm {
    userState?: UserStateVm | undefined;
    applicationState?: ApplicationStateVm | undefined;

    constructor(data?: IUserVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userState = _data["userState"] ? UserStateVm.fromJS(_data["userState"]) : undefined as any;
            this.applicationState = _data["applicationState"] ? ApplicationStateVm.fromJS(_data["applicationState"]) : undefined as any;
        }
    }

    static fromJS(data: any): UserVm {
        data = typeof data === 'object' ? data : {};
        let result = new UserVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userState"] = this.userState ? this.userState.toJSON() : undefined as any;
        data["applicationState"] = this.applicationState ? this.applicationState.toJSON() : undefined as any;
        return data;
    }
}

export interface IUserVm {
    userState?: UserStateVm | undefined;
    applicationState?: ApplicationStateVm | undefined;
}

export class UserStateVm implements IUserStateVm {
    loggedIn?: boolean;
    user?: UserDto | undefined;
    entities?: EntityMetaDto[] | undefined;
    roles?: RoleDto[] | undefined;
    routes?: AppRouteDto[] | undefined;
    userRoutes?: AppUserRouteDto[] | undefined;
    userRouteViews?: AppUserRouteViewDto[] | undefined;
    notificationMessages?: NotificationMessageDto[] | undefined;
    documentLibs?: DocumentLibDto[] | undefined;

    constructor(data?: IUserStateVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.loggedIn = _data["loggedIn"];
            this.user = _data["user"] ? UserDto.fromJS(_data["user"]) : undefined as any;
            if (Array.isArray(_data["entities"])) {
                this.entities = [] as any;
                for (let item of _data["entities"])
                    this.entities!.push(EntityMetaDto.fromJS(item));
            }
            if (Array.isArray(_data["roles"])) {
                this.roles = [] as any;
                for (let item of _data["roles"])
                    this.roles!.push(RoleDto.fromJS(item));
            }
            if (Array.isArray(_data["routes"])) {
                this.routes = [] as any;
                for (let item of _data["routes"])
                    this.routes!.push(AppRouteDto.fromJS(item));
            }
            if (Array.isArray(_data["userRoutes"])) {
                this.userRoutes = [] as any;
                for (let item of _data["userRoutes"])
                    this.userRoutes!.push(AppUserRouteDto.fromJS(item));
            }
            if (Array.isArray(_data["userRouteViews"])) {
                this.userRouteViews = [] as any;
                for (let item of _data["userRouteViews"])
                    this.userRouteViews!.push(AppUserRouteViewDto.fromJS(item));
            }
            if (Array.isArray(_data["notificationMessages"])) {
                this.notificationMessages = [] as any;
                for (let item of _data["notificationMessages"])
                    this.notificationMessages!.push(NotificationMessageDto.fromJS(item));
            }
            if (Array.isArray(_data["documentLibs"])) {
                this.documentLibs = [] as any;
                for (let item of _data["documentLibs"])
                    this.documentLibs!.push(DocumentLibDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UserStateVm {
        data = typeof data === 'object' ? data : {};
        let result = new UserStateVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["loggedIn"] = this.loggedIn;
        data["user"] = this.user ? this.user.toJSON() : undefined as any;
        if (Array.isArray(this.entities)) {
            data["entities"] = [];
            for (let item of this.entities)
                data["entities"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.roles)) {
            data["roles"] = [];
            for (let item of this.roles)
                data["roles"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.routes)) {
            data["routes"] = [];
            for (let item of this.routes)
                data["routes"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.userRoutes)) {
            data["userRoutes"] = [];
            for (let item of this.userRoutes)
                data["userRoutes"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.userRouteViews)) {
            data["userRouteViews"] = [];
            for (let item of this.userRouteViews)
                data["userRouteViews"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.notificationMessages)) {
            data["notificationMessages"] = [];
            for (let item of this.notificationMessages)
                data["notificationMessages"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.documentLibs)) {
            data["documentLibs"] = [];
            for (let item of this.documentLibs)
                data["documentLibs"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IUserStateVm {
    loggedIn?: boolean;
    user?: UserDto | undefined;
    entities?: EntityMetaDto[] | undefined;
    roles?: RoleDto[] | undefined;
    routes?: AppRouteDto[] | undefined;
    userRoutes?: AppUserRouteDto[] | undefined;
    userRouteViews?: AppUserRouteViewDto[] | undefined;
    notificationMessages?: NotificationMessageDto[] | undefined;
    documentLibs?: DocumentLibDto[] | undefined;
}

export class UserDto implements IUserDto {
    id?: number | undefined;
    shortName?: string | undefined;
    name?: string | undefined;
    appUserId?: string | undefined;
    email?: string | undefined;
    active?: boolean;
    locale?: string | undefined;
    chatNotify?: number | undefined;
    uiPagerShow?: boolean;
    legacyId?: number | undefined;
    created?: Date | undefined;
    createdBy?: number | undefined;
    modified?: Date | undefined;
    modifiedBy?: number | undefined;

    constructor(data?: IUserDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.shortName = _data["shortName"];
            this.name = _data["name"];
            this.appUserId = _data["appUserId"];
            this.email = _data["email"];
            this.active = _data["active"];
            this.locale = _data["locale"];
            this.chatNotify = _data["chatNotify"];
            this.uiPagerShow = _data["uiPagerShow"];
            this.legacyId = _data["legacyId"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : undefined as any;
            this.createdBy = _data["createdBy"];
            this.modified = _data["modified"] ? new Date(_data["modified"].toString()) : undefined as any;
            this.modifiedBy = _data["modifiedBy"];
        }
    }

    static fromJS(data: any): UserDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["shortName"] = this.shortName;
        data["name"] = this.name;
        data["appUserId"] = this.appUserId;
        data["email"] = this.email;
        data["active"] = this.active;
        data["locale"] = this.locale;
        data["chatNotify"] = this.chatNotify;
        data["uiPagerShow"] = this.uiPagerShow;
        data["legacyId"] = this.legacyId;
        data["created"] = this.created ? this.created.toISOString() : undefined as any;
        data["createdBy"] = this.createdBy;
        data["modified"] = this.modified ? this.modified.toISOString() : undefined as any;
        data["modifiedBy"] = this.modifiedBy;
        return data;
    }
}

export interface IUserDto {
    id?: number | undefined;
    shortName?: string | undefined;
    name?: string | undefined;
    appUserId?: string | undefined;
    email?: string | undefined;
    active?: boolean;
    locale?: string | undefined;
    chatNotify?: number | undefined;
    uiPagerShow?: boolean;
    legacyId?: number | undefined;
    created?: Date | undefined;
    createdBy?: number | undefined;
    modified?: Date | undefined;
    modifiedBy?: number | undefined;
}

export class RoleDto implements IRoleDto {
    id?: number | undefined;
    name?: string | undefined;
    roleType?: RoleTypeEnum | undefined;

    constructor(data?: IRoleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.roleType = _data["roleType"];
        }
    }

    static fromJS(data: any): RoleDto {
        data = typeof data === 'object' ? data : {};
        let result = new RoleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["roleType"] = this.roleType;
        return data;
    }
}

export interface IRoleDto {
    id?: number | undefined;
    name?: string | undefined;
    roleType?: RoleTypeEnum | undefined;
}

export enum RoleTypeEnum {
    GlobalAdmin = 1,
    TennantAdmin = 2,
    RoyaltyAdmin = 3,
    RoyaltyApprover = 4,
    Webshop = 5,
    BaseData = 6,
    VoucherApproval = 7,
    VoucherVendorAdmin = 8,
    BaseDataBasic = 9,
    RightsBasic = 10,
    RightsAdmin = 11,
    VoucherExpenseBank = 12,
    VoucherExpenseAdmin = 13,
    VoucherExpenseCreate = 14,
    VoucherManualAdmin = 15,
    ProjectBasic = 16,
    ProjectTask = 17,
    ProjectStructure = 18,
    ProjectAdmin = 19,
    ProductBasic = 20,
    ProductAdmin = 21,
    Warehouse = 22,
    VoucherApprovalAll = 23,
    WarehouseProductList = 24,
    FinanceReporting = 25,
    FinanceAdmin = 26,
    AccountingBankPayment = 27,
    DocumentationView = 28,
    DocumentationEditor = 29,
    DocumentationEditorProcess = 30,
}

export class NotificationMessageDto implements INotificationMessageDto {
    id?: number;
    chatId?: number;
    userId?: number;
    isNotified?: boolean | undefined;
    isRead?: boolean;
    created?: Date | undefined;
    createdBy?: number | undefined;
    modified?: Date | undefined;
    modifiedBy?: number | undefined;
    userName?: string | undefined;
    userShortName?: string | undefined;
    fromUserId?: number | undefined;
    fromUserName?: string | undefined;
    fromShortName?: string | undefined;
    transDate?: Date | undefined;
    transType?: string | undefined;
    num?: string | undefined;
    title?: string | undefined;
    txt?: string | undefined;
    refTableId?: number;
    refRowId?: number;
    url?: string | undefined;
    queryParam?: string | undefined;

    constructor(data?: INotificationMessageDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.chatId = _data["chatId"];
            this.userId = _data["userId"];
            this.isNotified = _data["isNotified"];
            this.isRead = _data["isRead"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : undefined as any;
            this.createdBy = _data["createdBy"];
            this.modified = _data["modified"] ? new Date(_data["modified"].toString()) : undefined as any;
            this.modifiedBy = _data["modifiedBy"];
            this.userName = _data["userName"];
            this.userShortName = _data["userShortName"];
            this.fromUserId = _data["fromUserId"];
            this.fromUserName = _data["fromUserName"];
            this.fromShortName = _data["fromShortName"];
            this.transDate = _data["transDate"] ? new Date(_data["transDate"].toString()) : undefined as any;
            this.transType = _data["transType"];
            this.num = _data["num"];
            this.title = _data["title"];
            this.txt = _data["txt"];
            this.refTableId = _data["refTableId"];
            this.refRowId = _data["refRowId"];
            this.url = _data["url"];
            this.queryParam = _data["queryParam"];
        }
    }

    static fromJS(data: any): NotificationMessageDto {
        data = typeof data === 'object' ? data : {};
        let result = new NotificationMessageDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["chatId"] = this.chatId;
        data["userId"] = this.userId;
        data["isNotified"] = this.isNotified;
        data["isRead"] = this.isRead;
        data["created"] = this.created ? this.created.toISOString() : undefined as any;
        data["createdBy"] = this.createdBy;
        data["modified"] = this.modified ? this.modified.toISOString() : undefined as any;
        data["modifiedBy"] = this.modifiedBy;
        data["userName"] = this.userName;
        data["userShortName"] = this.userShortName;
        data["fromUserId"] = this.fromUserId;
        data["fromUserName"] = this.fromUserName;
        data["fromShortName"] = this.fromShortName;
        data["transDate"] = this.transDate ? this.transDate.toISOString() : undefined as any;
        data["transType"] = this.transType;
        data["num"] = this.num;
        data["title"] = this.title;
        data["txt"] = this.txt;
        data["refTableId"] = this.refTableId;
        data["refRowId"] = this.refRowId;
        data["url"] = this.url;
        data["queryParam"] = this.queryParam;
        return data;
    }
}

export interface INotificationMessageDto {
    id?: number;
    chatId?: number;
    userId?: number;
    isNotified?: boolean | undefined;
    isRead?: boolean;
    created?: Date | undefined;
    createdBy?: number | undefined;
    modified?: Date | undefined;
    modifiedBy?: number | undefined;
    userName?: string | undefined;
    userShortName?: string | undefined;
    fromUserId?: number | undefined;
    fromUserName?: string | undefined;
    fromShortName?: string | undefined;
    transDate?: Date | undefined;
    transType?: string | undefined;
    num?: string | undefined;
    title?: string | undefined;
    txt?: string | undefined;
    refTableId?: number;
    refRowId?: number;
    url?: string | undefined;
    queryParam?: string | undefined;
}

export class DocumentLibDto extends DtoBaseIdHistoryName implements IDocumentLibDto {
    blobStorage?: number | undefined;
    path?: string | undefined;
    linkId?: number | undefined;
    token?: string | undefined;
    allowEdit?: boolean | undefined;
    allowCreate?: boolean | undefined;
    allowDelete?: boolean | undefined;
    indirectAccess?: boolean | undefined;

    constructor(data?: IDocumentLibDto) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.blobStorage = _data["blobStorage"];
            this.path = _data["path"];
            this.linkId = _data["linkId"];
            this.token = _data["token"];
            this.allowEdit = _data["allowEdit"];
            this.allowCreate = _data["allowCreate"];
            this.allowDelete = _data["allowDelete"];
            this.indirectAccess = _data["indirectAccess"];
        }
    }

    static override fromJS(data: any): DocumentLibDto {
        data = typeof data === 'object' ? data : {};
        let result = new DocumentLibDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["blobStorage"] = this.blobStorage;
        data["path"] = this.path;
        data["linkId"] = this.linkId;
        data["token"] = this.token;
        data["allowEdit"] = this.allowEdit;
        data["allowCreate"] = this.allowCreate;
        data["allowDelete"] = this.allowDelete;
        data["indirectAccess"] = this.indirectAccess;
        super.toJSON(data);
        return data;
    }
}

export interface IDocumentLibDto extends IDtoBaseIdHistoryName {
    blobStorage?: number | undefined;
    path?: string | undefined;
    linkId?: number | undefined;
    token?: string | undefined;
    allowEdit?: boolean | undefined;
    allowCreate?: boolean | undefined;
    allowDelete?: boolean | undefined;
    indirectAccess?: boolean | undefined;
}

export class ApplicationStateVm implements IApplicationStateVm {
    modules?: ModuleMetaDto[];
    users?: UserDto[] | undefined;
    dataTypes?: EntityMetaDataTypeDto[];
    environment?: EnvironmentDto;
    settings?: UserSettingDto;
    requestUserState?: boolean;

    constructor(data?: IApplicationStateVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["modules"])) {
                this.modules = [] as any;
                for (let item of _data["modules"])
                    this.modules!.push(ModuleMetaDto.fromJS(item));
            }
            if (Array.isArray(_data["users"])) {
                this.users = [] as any;
                for (let item of _data["users"])
                    this.users!.push(UserDto.fromJS(item));
            }
            if (Array.isArray(_data["dataTypes"])) {
                this.dataTypes = [] as any;
                for (let item of _data["dataTypes"])
                    this.dataTypes!.push(EntityMetaDataTypeDto.fromJS(item));
            }
            this.environment = _data["environment"] ? EnvironmentDto.fromJS(_data["environment"]) : undefined as any;
            this.settings = _data["settings"] ? UserSettingDto.fromJS(_data["settings"]) : undefined as any;
            this.requestUserState = _data["requestUserState"];
        }
    }

    static fromJS(data: any): ApplicationStateVm {
        data = typeof data === 'object' ? data : {};
        let result = new ApplicationStateVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.modules)) {
            data["modules"] = [];
            for (let item of this.modules)
                data["modules"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.users)) {
            data["users"] = [];
            for (let item of this.users)
                data["users"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.dataTypes)) {
            data["dataTypes"] = [];
            for (let item of this.dataTypes)
                data["dataTypes"].push(item ? item.toJSON() : undefined as any);
        }
        data["environment"] = this.environment ? this.environment.toJSON() : undefined as any;
        data["settings"] = this.settings ? this.settings.toJSON() : undefined as any;
        data["requestUserState"] = this.requestUserState;
        return data;
    }
}

export interface IApplicationStateVm {
    modules?: ModuleMetaDto[];
    users?: UserDto[] | undefined;
    dataTypes?: EntityMetaDataTypeDto[];
    environment?: EnvironmentDto;
    settings?: UserSettingDto;
    requestUserState?: boolean;
}

export class EntityMetaDataTypeDto implements IEntityMetaDataTypeDto {
    name?: string | undefined;
    attributes?: EntityMetaTypeAttributesDto | undefined;

    constructor(data?: IEntityMetaDataTypeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.attributes = _data["attributes"] ? EntityMetaTypeAttributesDto.fromJS(_data["attributes"]) : undefined as any;
        }
    }

    static fromJS(data: any): EntityMetaDataTypeDto {
        data = typeof data === 'object' ? data : {};
        let result = new EntityMetaDataTypeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["attributes"] = this.attributes ? this.attributes.toJSON() : undefined as any;
        return data;
    }
}

export interface IEntityMetaDataTypeDto {
    name?: string | undefined;
    attributes?: EntityMetaTypeAttributesDto | undefined;
}

export class EnvironmentDto implements IEnvironmentDto {
    version?: string | undefined;
    versionReload?: number;
    documentationLibraryId?: number;
    name?: string | undefined;
    title?: string | undefined;
    licenseIssuedTo?: string | undefined;
    primaryColor?: string | undefined;
    defaultIdentityActive?: boolean;
    sessionIdleMinutes?: number | undefined;
    sessionKeepaliveMinutes?: number | undefined;
    host?: string | undefined;
    maxUploadBytes?: number | undefined;
    maxUrlLength?: number;

    constructor(data?: IEnvironmentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.version = _data["version"];
            this.versionReload = _data["versionReload"];
            this.documentationLibraryId = _data["documentationLibraryId"];
            this.name = _data["name"];
            this.title = _data["title"];
            this.licenseIssuedTo = _data["licenseIssuedTo"];
            this.primaryColor = _data["primaryColor"];
            this.defaultIdentityActive = _data["defaultIdentityActive"];
            this.sessionIdleMinutes = _data["sessionIdleMinutes"];
            this.sessionKeepaliveMinutes = _data["sessionKeepaliveMinutes"];
            this.host = _data["host"];
            this.maxUploadBytes = _data["maxUploadBytes"];
            this.maxUrlLength = _data["maxUrlLength"];
        }
    }

    static fromJS(data: any): EnvironmentDto {
        data = typeof data === 'object' ? data : {};
        let result = new EnvironmentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["version"] = this.version;
        data["versionReload"] = this.versionReload;
        data["documentationLibraryId"] = this.documentationLibraryId;
        data["name"] = this.name;
        data["title"] = this.title;
        data["licenseIssuedTo"] = this.licenseIssuedTo;
        data["primaryColor"] = this.primaryColor;
        data["defaultIdentityActive"] = this.defaultIdentityActive;
        data["sessionIdleMinutes"] = this.sessionIdleMinutes;
        data["sessionKeepaliveMinutes"] = this.sessionKeepaliveMinutes;
        data["host"] = this.host;
        data["maxUploadBytes"] = this.maxUploadBytes;
        data["maxUrlLength"] = this.maxUrlLength;
        return data;
    }
}

export interface IEnvironmentDto {
    version?: string | undefined;
    versionReload?: number;
    documentationLibraryId?: number;
    name?: string | undefined;
    title?: string | undefined;
    licenseIssuedTo?: string | undefined;
    primaryColor?: string | undefined;
    defaultIdentityActive?: boolean;
    sessionIdleMinutes?: number | undefined;
    sessionKeepaliveMinutes?: number | undefined;
    host?: string | undefined;
    maxUploadBytes?: number | undefined;
    maxUrlLength?: number;
}

export class UserSettingDto implements IUserSettingDto {
    settings?: { [key: string]: string; };

    constructor(data?: IUserSettingDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (_data["settings"]) {
                this.settings = {} as any;
                for (let key in _data["settings"]) {
                    if (_data["settings"].hasOwnProperty(key))
                        (this.settings as any)![key] = _data["settings"][key];
                }
            }
        }
    }

    static fromJS(data: any): UserSettingDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserSettingDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.settings) {
            data["settings"] = {};
            for (let key in this.settings) {
                if (this.settings.hasOwnProperty(key))
                    (data["settings"] as any)[key] = (this.settings as any)[key];
            }
        }
        return data;
    }
}

export interface IUserSettingDto {
    settings?: { [key: string]: string; };
}

export class ExternalIdentity implements IExternalIdentity {
    id?: string;
    name?: string;
    principalName?: string;
    email?: string | undefined;
    phone?: string | undefined;

    constructor(data?: IExternalIdentity) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.principalName = _data["principalName"];
            this.email = _data["email"];
            this.phone = _data["phone"];
        }
    }

    static fromJS(data: any): ExternalIdentity {
        data = typeof data === 'object' ? data : {};
        let result = new ExternalIdentity();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["principalName"] = this.principalName;
        data["email"] = this.email;
        data["phone"] = this.phone;
        return data;
    }
}

export interface IExternalIdentity {
    id?: string;
    name?: string;
    principalName?: string;
    email?: string | undefined;
    phone?: string | undefined;
}

export class UserRoleVm implements IUserRoleVm {
    user?: UserDto | undefined;
    users?: UserDto[] | undefined;
    identities?: IdentityDto[] | undefined;
    roles?: RoleDto[] | undefined;
    roleUsers?: RoleUserDto[] | undefined;

    constructor(data?: IUserRoleVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.user = _data["user"] ? UserDto.fromJS(_data["user"]) : undefined as any;
            if (Array.isArray(_data["users"])) {
                this.users = [] as any;
                for (let item of _data["users"])
                    this.users!.push(UserDto.fromJS(item));
            }
            if (Array.isArray(_data["identities"])) {
                this.identities = [] as any;
                for (let item of _data["identities"])
                    this.identities!.push(IdentityDto.fromJS(item));
            }
            if (Array.isArray(_data["roles"])) {
                this.roles = [] as any;
                for (let item of _data["roles"])
                    this.roles!.push(RoleDto.fromJS(item));
            }
            if (Array.isArray(_data["roleUsers"])) {
                this.roleUsers = [] as any;
                for (let item of _data["roleUsers"])
                    this.roleUsers!.push(RoleUserDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UserRoleVm {
        data = typeof data === 'object' ? data : {};
        let result = new UserRoleVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["user"] = this.user ? this.user.toJSON() : undefined as any;
        if (Array.isArray(this.users)) {
            data["users"] = [];
            for (let item of this.users)
                data["users"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.identities)) {
            data["identities"] = [];
            for (let item of this.identities)
                data["identities"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.roles)) {
            data["roles"] = [];
            for (let item of this.roles)
                data["roles"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.roleUsers)) {
            data["roleUsers"] = [];
            for (let item of this.roleUsers)
                data["roleUsers"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IUserRoleVm {
    user?: UserDto | undefined;
    users?: UserDto[] | undefined;
    identities?: IdentityDto[] | undefined;
    roles?: RoleDto[] | undefined;
    roleUsers?: RoleUserDto[] | undefined;
}

export class IdentityDto implements IIdentityDto {
    id?: string | undefined;
    email?: string | undefined;
    emailConfirmed?: boolean;

    constructor(data?: IIdentityDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.email = _data["email"];
            this.emailConfirmed = _data["emailConfirmed"];
        }
    }

    static fromJS(data: any): IdentityDto {
        data = typeof data === 'object' ? data : {};
        let result = new IdentityDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["email"] = this.email;
        data["emailConfirmed"] = this.emailConfirmed;
        return data;
    }
}

export interface IIdentityDto {
    id?: string | undefined;
    email?: string | undefined;
    emailConfirmed?: boolean;
}

export class RoleUserDto implements IRoleUserDto {
    id?: number | undefined;
    roleId?: number;
    userId?: number;
    isActive?: boolean;
    created?: Date | undefined;
    createdBy?: number | undefined;
    modified?: Date | undefined;
    modifiedBy?: number | undefined;
    roleType?: RoleTypeEnum | undefined;

    constructor(data?: IRoleUserDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.roleId = _data["roleId"];
            this.userId = _data["userId"];
            this.isActive = _data["isActive"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : undefined as any;
            this.createdBy = _data["createdBy"];
            this.modified = _data["modified"] ? new Date(_data["modified"].toString()) : undefined as any;
            this.modifiedBy = _data["modifiedBy"];
            this.roleType = _data["roleType"];
        }
    }

    static fromJS(data: any): RoleUserDto {
        data = typeof data === 'object' ? data : {};
        let result = new RoleUserDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["roleId"] = this.roleId;
        data["userId"] = this.userId;
        data["isActive"] = this.isActive;
        data["created"] = this.created ? this.created.toISOString() : undefined as any;
        data["createdBy"] = this.createdBy;
        data["modified"] = this.modified ? this.modified.toISOString() : undefined as any;
        data["modifiedBy"] = this.modifiedBy;
        data["roleType"] = this.roleType;
        return data;
    }
}

export interface IRoleUserDto {
    id?: number | undefined;
    roleId?: number;
    userId?: number;
    isActive?: boolean;
    created?: Date | undefined;
    createdBy?: number | undefined;
    modified?: Date | undefined;
    modifiedBy?: number | undefined;
    roleType?: RoleTypeEnum | undefined;
}

export class UserStatusVm implements IUserStatusVm {
    applicationState?: ApplicationStateVm | undefined;
    voucherStatusCountByUserList?: VoucherApprovalStatusCountDto[] | undefined;
    voucherStatusCountByChannelTypeList?: VoucherApprovalStatusCountDto[] | undefined;
    messageStatusCountByChannelTypeList?: VoucherMessageStatusCountDto[] | undefined;

    constructor(data?: IUserStatusVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.applicationState = _data["applicationState"] ? ApplicationStateVm.fromJS(_data["applicationState"]) : undefined as any;
            if (Array.isArray(_data["voucherStatusCountByUserList"])) {
                this.voucherStatusCountByUserList = [] as any;
                for (let item of _data["voucherStatusCountByUserList"])
                    this.voucherStatusCountByUserList!.push(VoucherApprovalStatusCountDto.fromJS(item));
            }
            if (Array.isArray(_data["voucherStatusCountByChannelTypeList"])) {
                this.voucherStatusCountByChannelTypeList = [] as any;
                for (let item of _data["voucherStatusCountByChannelTypeList"])
                    this.voucherStatusCountByChannelTypeList!.push(VoucherApprovalStatusCountDto.fromJS(item));
            }
            if (Array.isArray(_data["messageStatusCountByChannelTypeList"])) {
                this.messageStatusCountByChannelTypeList = [] as any;
                for (let item of _data["messageStatusCountByChannelTypeList"])
                    this.messageStatusCountByChannelTypeList!.push(VoucherMessageStatusCountDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UserStatusVm {
        data = typeof data === 'object' ? data : {};
        let result = new UserStatusVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["applicationState"] = this.applicationState ? this.applicationState.toJSON() : undefined as any;
        if (Array.isArray(this.voucherStatusCountByUserList)) {
            data["voucherStatusCountByUserList"] = [];
            for (let item of this.voucherStatusCountByUserList)
                data["voucherStatusCountByUserList"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.voucherStatusCountByChannelTypeList)) {
            data["voucherStatusCountByChannelTypeList"] = [];
            for (let item of this.voucherStatusCountByChannelTypeList)
                data["voucherStatusCountByChannelTypeList"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.messageStatusCountByChannelTypeList)) {
            data["messageStatusCountByChannelTypeList"] = [];
            for (let item of this.messageStatusCountByChannelTypeList)
                data["messageStatusCountByChannelTypeList"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IUserStatusVm {
    applicationState?: ApplicationStateVm | undefined;
    voucherStatusCountByUserList?: VoucherApprovalStatusCountDto[] | undefined;
    voucherStatusCountByChannelTypeList?: VoucherApprovalStatusCountDto[] | undefined;
    messageStatusCountByChannelTypeList?: VoucherMessageStatusCountDto[] | undefined;
}

export class VoucherApprovalStatusCountDto implements IVoucherApprovalStatusCountDto {
    channelType?: VoucherMessageChannelTypeEnum | undefined;
    status?: VoucherApprovalStatusEnum | undefined;
    approver?: number | undefined;
    count?: number;

    constructor(data?: IVoucherApprovalStatusCountDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.channelType = _data["channelType"];
            this.status = _data["status"];
            this.approver = _data["approver"];
            this.count = _data["count"];
        }
    }

    static fromJS(data: any): VoucherApprovalStatusCountDto {
        data = typeof data === 'object' ? data : {};
        let result = new VoucherApprovalStatusCountDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["channelType"] = this.channelType;
        data["status"] = this.status;
        data["approver"] = this.approver;
        data["count"] = this.count;
        return data;
    }
}

export interface IVoucherApprovalStatusCountDto {
    channelType?: VoucherMessageChannelTypeEnum | undefined;
    status?: VoucherApprovalStatusEnum | undefined;
    approver?: number | undefined;
    count?: number;
}

export enum VoucherMessageChannelTypeEnum {
    VendorVoucher = 1,
    ExpenseVoucher = 2,
    ManualVoucher = 3,
    SalesVoucher = 4,
}

export enum VoucherApprovalStatusEnum {
    Pending = 1,
    OnHold = 2,
    Approved = 3,
    Accounted = 4,
    Posted = 5,
    Created = 6,
}

export class VoucherMessageStatusCountDto implements IVoucherMessageStatusCountDto {
    channelType?: VoucherMessageChannelTypeEnum;
    status?: VoucherMessageStatusEnum;
    count?: number;

    constructor(data?: IVoucherMessageStatusCountDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.channelType = _data["channelType"];
            this.status = _data["status"];
            this.count = _data["count"];
        }
    }

    static fromJS(data: any): VoucherMessageStatusCountDto {
        data = typeof data === 'object' ? data : {};
        let result = new VoucherMessageStatusCountDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["channelType"] = this.channelType;
        data["status"] = this.status;
        data["count"] = this.count;
        return data;
    }
}

export interface IVoucherMessageStatusCountDto {
    channelType?: VoucherMessageChannelTypeEnum;
    status?: VoucherMessageStatusEnum;
    count?: number;
}

export enum VoucherMessageStatusEnum {
    Inbox = 1,
    OnHold = 2,
    Voucher = 3,
    Forwarded = 4,
    Rejected = 5,
    AccountStatement = 6,
}

export class VoucherBaseDataVm implements IVoucherBaseDataVm {
    taxCodes?: Finance_TaxCode[] | undefined;
    currencies?: CurrencyDto[] | undefined;
    projectCostTypes?: ProjectCostTypeDto[] | undefined;
    usersAll?: UserDto[] | undefined;
    users?: UserDto[] | undefined;
    userApprovalDelegations?: UserApprovalDelegationDto[] | undefined;
    userCurrent?: UserDto | undefined;
    postingTypes?: VoucherPostingTypeDto[] | undefined;
    projectCostGroups?: FinanceProjectCostGroupDto[] | undefined;
    projectCostGroupTypes?: FinanceProjectCostGroupTypeDto[] | undefined;
    projectLedgerAccounts?: FinanceLedgerAccountDto[] | undefined;
    ledgerAccounts?: FinanceLedgerAccountDto[] | undefined;
    ledgerDimensions?: FinanceLedgerDepartmentDto[] | undefined;
    vendorsDefault?: VendorViewDto[] | undefined;
    debtorsDefault?: DebtorDto[] | undefined;
    projectsDefault?: ProjectDto[] | undefined;
    bankAccounts?: BankAccountDto[] | undefined;

    constructor(data?: IVoucherBaseDataVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["taxCodes"])) {
                this.taxCodes = [] as any;
                for (let item of _data["taxCodes"])
                    this.taxCodes!.push(Finance_TaxCode.fromJS(item));
            }
            if (Array.isArray(_data["currencies"])) {
                this.currencies = [] as any;
                for (let item of _data["currencies"])
                    this.currencies!.push(CurrencyDto.fromJS(item));
            }
            if (Array.isArray(_data["projectCostTypes"])) {
                this.projectCostTypes = [] as any;
                for (let item of _data["projectCostTypes"])
                    this.projectCostTypes!.push(ProjectCostTypeDto.fromJS(item));
            }
            if (Array.isArray(_data["usersAll"])) {
                this.usersAll = [] as any;
                for (let item of _data["usersAll"])
                    this.usersAll!.push(UserDto.fromJS(item));
            }
            if (Array.isArray(_data["users"])) {
                this.users = [] as any;
                for (let item of _data["users"])
                    this.users!.push(UserDto.fromJS(item));
            }
            if (Array.isArray(_data["userApprovalDelegations"])) {
                this.userApprovalDelegations = [] as any;
                for (let item of _data["userApprovalDelegations"])
                    this.userApprovalDelegations!.push(UserApprovalDelegationDto.fromJS(item));
            }
            this.userCurrent = _data["userCurrent"] ? UserDto.fromJS(_data["userCurrent"]) : undefined as any;
            if (Array.isArray(_data["postingTypes"])) {
                this.postingTypes = [] as any;
                for (let item of _data["postingTypes"])
                    this.postingTypes!.push(VoucherPostingTypeDto.fromJS(item));
            }
            if (Array.isArray(_data["projectCostGroups"])) {
                this.projectCostGroups = [] as any;
                for (let item of _data["projectCostGroups"])
                    this.projectCostGroups!.push(FinanceProjectCostGroupDto.fromJS(item));
            }
            if (Array.isArray(_data["projectCostGroupTypes"])) {
                this.projectCostGroupTypes = [] as any;
                for (let item of _data["projectCostGroupTypes"])
                    this.projectCostGroupTypes!.push(FinanceProjectCostGroupTypeDto.fromJS(item));
            }
            if (Array.isArray(_data["projectLedgerAccounts"])) {
                this.projectLedgerAccounts = [] as any;
                for (let item of _data["projectLedgerAccounts"])
                    this.projectLedgerAccounts!.push(FinanceLedgerAccountDto.fromJS(item));
            }
            if (Array.isArray(_data["ledgerAccounts"])) {
                this.ledgerAccounts = [] as any;
                for (let item of _data["ledgerAccounts"])
                    this.ledgerAccounts!.push(FinanceLedgerAccountDto.fromJS(item));
            }
            if (Array.isArray(_data["ledgerDimensions"])) {
                this.ledgerDimensions = [] as any;
                for (let item of _data["ledgerDimensions"])
                    this.ledgerDimensions!.push(FinanceLedgerDepartmentDto.fromJS(item));
            }
            if (Array.isArray(_data["vendorsDefault"])) {
                this.vendorsDefault = [] as any;
                for (let item of _data["vendorsDefault"])
                    this.vendorsDefault!.push(VendorViewDto.fromJS(item));
            }
            if (Array.isArray(_data["debtorsDefault"])) {
                this.debtorsDefault = [] as any;
                for (let item of _data["debtorsDefault"])
                    this.debtorsDefault!.push(DebtorDto.fromJS(item));
            }
            if (Array.isArray(_data["projectsDefault"])) {
                this.projectsDefault = [] as any;
                for (let item of _data["projectsDefault"])
                    this.projectsDefault!.push(ProjectDto.fromJS(item));
            }
            if (Array.isArray(_data["bankAccounts"])) {
                this.bankAccounts = [] as any;
                for (let item of _data["bankAccounts"])
                    this.bankAccounts!.push(BankAccountDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): VoucherBaseDataVm {
        data = typeof data === 'object' ? data : {};
        let result = new VoucherBaseDataVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.taxCodes)) {
            data["taxCodes"] = [];
            for (let item of this.taxCodes)
                data["taxCodes"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.currencies)) {
            data["currencies"] = [];
            for (let item of this.currencies)
                data["currencies"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.projectCostTypes)) {
            data["projectCostTypes"] = [];
            for (let item of this.projectCostTypes)
                data["projectCostTypes"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.usersAll)) {
            data["usersAll"] = [];
            for (let item of this.usersAll)
                data["usersAll"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.users)) {
            data["users"] = [];
            for (let item of this.users)
                data["users"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.userApprovalDelegations)) {
            data["userApprovalDelegations"] = [];
            for (let item of this.userApprovalDelegations)
                data["userApprovalDelegations"].push(item ? item.toJSON() : undefined as any);
        }
        data["userCurrent"] = this.userCurrent ? this.userCurrent.toJSON() : undefined as any;
        if (Array.isArray(this.postingTypes)) {
            data["postingTypes"] = [];
            for (let item of this.postingTypes)
                data["postingTypes"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.projectCostGroups)) {
            data["projectCostGroups"] = [];
            for (let item of this.projectCostGroups)
                data["projectCostGroups"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.projectCostGroupTypes)) {
            data["projectCostGroupTypes"] = [];
            for (let item of this.projectCostGroupTypes)
                data["projectCostGroupTypes"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.projectLedgerAccounts)) {
            data["projectLedgerAccounts"] = [];
            for (let item of this.projectLedgerAccounts)
                data["projectLedgerAccounts"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.ledgerAccounts)) {
            data["ledgerAccounts"] = [];
            for (let item of this.ledgerAccounts)
                data["ledgerAccounts"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.ledgerDimensions)) {
            data["ledgerDimensions"] = [];
            for (let item of this.ledgerDimensions)
                data["ledgerDimensions"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.vendorsDefault)) {
            data["vendorsDefault"] = [];
            for (let item of this.vendorsDefault)
                data["vendorsDefault"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.debtorsDefault)) {
            data["debtorsDefault"] = [];
            for (let item of this.debtorsDefault)
                data["debtorsDefault"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.projectsDefault)) {
            data["projectsDefault"] = [];
            for (let item of this.projectsDefault)
                data["projectsDefault"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.bankAccounts)) {
            data["bankAccounts"] = [];
            for (let item of this.bankAccounts)
                data["bankAccounts"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IVoucherBaseDataVm {
    taxCodes?: Finance_TaxCode[] | undefined;
    currencies?: CurrencyDto[] | undefined;
    projectCostTypes?: ProjectCostTypeDto[] | undefined;
    usersAll?: UserDto[] | undefined;
    users?: UserDto[] | undefined;
    userApprovalDelegations?: UserApprovalDelegationDto[] | undefined;
    userCurrent?: UserDto | undefined;
    postingTypes?: VoucherPostingTypeDto[] | undefined;
    projectCostGroups?: FinanceProjectCostGroupDto[] | undefined;
    projectCostGroupTypes?: FinanceProjectCostGroupTypeDto[] | undefined;
    projectLedgerAccounts?: FinanceLedgerAccountDto[] | undefined;
    ledgerAccounts?: FinanceLedgerAccountDto[] | undefined;
    ledgerDimensions?: FinanceLedgerDepartmentDto[] | undefined;
    vendorsDefault?: VendorViewDto[] | undefined;
    debtorsDefault?: DebtorDto[] | undefined;
    projectsDefault?: ProjectDto[] | undefined;
    bankAccounts?: BankAccountDto[] | undefined;
}

export class Finance_TaxCode implements IFinance_TaxCode {
    id?: number;
    num?: string | undefined;
    name!: string;
    rate?: number;

    constructor(data?: IFinance_TaxCode) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.num = _data["num"];
            this.name = _data["name"];
            this.rate = _data["rate"];
        }
    }

    static fromJS(data: any): Finance_TaxCode {
        data = typeof data === 'object' ? data : {};
        let result = new Finance_TaxCode();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["num"] = this.num;
        data["name"] = this.name;
        data["rate"] = this.rate;
        return data;
    }
}

export interface IFinance_TaxCode {
    id?: number;
    num?: string | undefined;
    name: string;
    rate?: number;
}

export class CurrencyDto implements ICurrencyDto {
    id?: number | undefined;
    num?: string | undefined;
    name?: string | undefined;

    constructor(data?: ICurrencyDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.num = _data["num"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): CurrencyDto {
        data = typeof data === 'object' ? data : {};
        let result = new CurrencyDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["num"] = this.num;
        data["name"] = this.name;
        return data;
    }
}

export interface ICurrencyDto {
    id?: number | undefined;
    num?: string | undefined;
    name?: string | undefined;
}

export class ProjectCostTypeDto implements IProjectCostTypeDto {
    id?: number;
    num?: string | undefined;
    name?: string | undefined;
    description?: string | undefined;
    costOnly?: boolean | undefined;

    constructor(data?: IProjectCostTypeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.num = _data["num"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.costOnly = _data["costOnly"];
        }
    }

    static fromJS(data: any): ProjectCostTypeDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProjectCostTypeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["num"] = this.num;
        data["name"] = this.name;
        data["description"] = this.description;
        data["costOnly"] = this.costOnly;
        return data;
    }
}

export interface IProjectCostTypeDto {
    id?: number;
    num?: string | undefined;
    name?: string | undefined;
    description?: string | undefined;
    costOnly?: boolean | undefined;
}

export class UserApprovalDelegationDto extends DtoBaseIdHistory implements IUserApprovalDelegationDto {
    user?: number;
    userDelegatee?: number;
    isActive?: boolean;
    fromDate?: Date | undefined;
    toDate?: Date | undefined;
    reason?: string | undefined;

    constructor(data?: IUserApprovalDelegationDto) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.user = _data["user"];
            this.userDelegatee = _data["userDelegatee"];
            this.isActive = _data["isActive"];
            this.fromDate = _data["fromDate"] ? new Date(_data["fromDate"].toString()) : undefined as any;
            this.toDate = _data["toDate"] ? new Date(_data["toDate"].toString()) : undefined as any;
            this.reason = _data["reason"];
        }
    }

    static override fromJS(data: any): UserApprovalDelegationDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserApprovalDelegationDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["user"] = this.user;
        data["userDelegatee"] = this.userDelegatee;
        data["isActive"] = this.isActive;
        data["fromDate"] = this.fromDate ? this.fromDate.toISOString() : undefined as any;
        data["toDate"] = this.toDate ? this.toDate.toISOString() : undefined as any;
        data["reason"] = this.reason;
        super.toJSON(data);
        return data;
    }
}

export interface IUserApprovalDelegationDto extends IDtoBaseIdHistory {
    user?: number;
    userDelegatee?: number;
    isActive?: boolean;
    fromDate?: Date | undefined;
    toDate?: Date | undefined;
    reason?: string | undefined;
}

export class VoucherPostingTypeDto implements IVoucherPostingTypeDto {
    id?: number | undefined;
    name?: string | undefined;

    constructor(data?: IVoucherPostingTypeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): VoucherPostingTypeDto {
        data = typeof data === 'object' ? data : {};
        let result = new VoucherPostingTypeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

export interface IVoucherPostingTypeDto {
    id?: number | undefined;
    name?: string | undefined;
}

export class FinanceProjectCostGroupDto implements IFinanceProjectCostGroupDto {
    id?: number;
    num?: string | undefined;
    name?: string | undefined;
    sort?: number;

    constructor(data?: IFinanceProjectCostGroupDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.num = _data["num"];
            this.name = _data["name"];
            this.sort = _data["sort"];
        }
    }

    static fromJS(data: any): FinanceProjectCostGroupDto {
        data = typeof data === 'object' ? data : {};
        let result = new FinanceProjectCostGroupDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["num"] = this.num;
        data["name"] = this.name;
        data["sort"] = this.sort;
        return data;
    }
}

export interface IFinanceProjectCostGroupDto {
    id?: number;
    num?: string | undefined;
    name?: string | undefined;
    sort?: number;
}

export class FinanceProjectCostGroupTypeDto implements IFinanceProjectCostGroupTypeDto {
    id?: number;
    num?: string | undefined;
    group?: string | undefined;

    constructor(data?: IFinanceProjectCostGroupTypeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.num = _data["num"];
            this.group = _data["group"];
        }
    }

    static fromJS(data: any): FinanceProjectCostGroupTypeDto {
        data = typeof data === 'object' ? data : {};
        let result = new FinanceProjectCostGroupTypeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["num"] = this.num;
        data["group"] = this.group;
        return data;
    }
}

export interface IFinanceProjectCostGroupTypeDto {
    id?: number;
    num?: string | undefined;
    group?: string | undefined;
}

export class FinanceLedgerAccountDto implements IFinanceLedgerAccountDto {
    id?: number | undefined;
    num?: string | undefined;
    numRight?: string | undefined;
    name?: string | undefined;
    taxCode?: string | undefined;
    projCostType?: string | undefined;
    description?: string | undefined;
    numName?: string | undefined;

    constructor(data?: IFinanceLedgerAccountDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.num = _data["num"];
            this.numRight = _data["numRight"];
            this.name = _data["name"];
            this.taxCode = _data["taxCode"];
            this.projCostType = _data["projCostType"];
            this.description = _data["description"];
            this.numName = _data["numName"];
        }
    }

    static fromJS(data: any): FinanceLedgerAccountDto {
        data = typeof data === 'object' ? data : {};
        let result = new FinanceLedgerAccountDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["num"] = this.num;
        data["numRight"] = this.numRight;
        data["name"] = this.name;
        data["taxCode"] = this.taxCode;
        data["projCostType"] = this.projCostType;
        data["description"] = this.description;
        data["numName"] = this.numName;
        return data;
    }
}

export interface IFinanceLedgerAccountDto {
    id?: number | undefined;
    num?: string | undefined;
    numRight?: string | undefined;
    name?: string | undefined;
    taxCode?: string | undefined;
    projCostType?: string | undefined;
    description?: string | undefined;
    numName?: string | undefined;
}

export class FinanceLedgerDepartmentDto implements IFinanceLedgerDepartmentDto {
    id?: number;
    num?: string | undefined;
    name?: string | undefined;

    constructor(data?: IFinanceLedgerDepartmentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.num = _data["num"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): FinanceLedgerDepartmentDto {
        data = typeof data === 'object' ? data : {};
        let result = new FinanceLedgerDepartmentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["num"] = this.num;
        data["name"] = this.name;
        return data;
    }
}

export interface IFinanceLedgerDepartmentDto {
    id?: number;
    num?: string | undefined;
    name?: string | undefined;
}

export class VendorViewDto implements IVendorViewDto {
    source?: number;
    id?: number;
    num?: string | undefined;
    name?: string | undefined;
    address1?: string | undefined;
    address2?: string | undefined;
    address3?: string | undefined;
    country?: string | undefined;
    attention?: string | undefined;
    phone?: string | undefined;
    mobile?: string | undefined;
    email?: string | undefined;
    group?: string | undefined;
    approved?: number;
    currency?: string | undefined;
    language?: number;
    paymentTerm?: string | undefined;
    blocked?: number | undefined;
    taxCode?: string | undefined;
    bankAccount?: string | undefined;
    taxId?: string | undefined;
    taxIdType?: string | undefined;
    description?: string | undefined;
    nameCurrency?: string | undefined;

    constructor(data?: IVendorViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.source = _data["source"];
            this.id = _data["id"];
            this.num = _data["num"];
            this.name = _data["name"];
            this.address1 = _data["address1"];
            this.address2 = _data["address2"];
            this.address3 = _data["address3"];
            this.country = _data["country"];
            this.attention = _data["attention"];
            this.phone = _data["phone"];
            this.mobile = _data["mobile"];
            this.email = _data["email"];
            this.group = _data["group"];
            this.approved = _data["approved"];
            this.currency = _data["currency"];
            this.language = _data["language"];
            this.paymentTerm = _data["paymentTerm"];
            this.blocked = _data["blocked"];
            this.taxCode = _data["taxCode"];
            this.bankAccount = _data["bankAccount"];
            this.taxId = _data["taxId"];
            this.taxIdType = _data["taxIdType"];
            this.description = _data["description"];
            this.nameCurrency = _data["nameCurrency"];
        }
    }

    static fromJS(data: any): VendorViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new VendorViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["source"] = this.source;
        data["id"] = this.id;
        data["num"] = this.num;
        data["name"] = this.name;
        data["address1"] = this.address1;
        data["address2"] = this.address2;
        data["address3"] = this.address3;
        data["country"] = this.country;
        data["attention"] = this.attention;
        data["phone"] = this.phone;
        data["mobile"] = this.mobile;
        data["email"] = this.email;
        data["group"] = this.group;
        data["approved"] = this.approved;
        data["currency"] = this.currency;
        data["language"] = this.language;
        data["paymentTerm"] = this.paymentTerm;
        data["blocked"] = this.blocked;
        data["taxCode"] = this.taxCode;
        data["bankAccount"] = this.bankAccount;
        data["taxId"] = this.taxId;
        data["taxIdType"] = this.taxIdType;
        data["description"] = this.description;
        data["nameCurrency"] = this.nameCurrency;
        return data;
    }
}

export interface IVendorViewDto {
    source?: number;
    id?: number;
    num?: string | undefined;
    name?: string | undefined;
    address1?: string | undefined;
    address2?: string | undefined;
    address3?: string | undefined;
    country?: string | undefined;
    attention?: string | undefined;
    phone?: string | undefined;
    mobile?: string | undefined;
    email?: string | undefined;
    group?: string | undefined;
    approved?: number;
    currency?: string | undefined;
    language?: number;
    paymentTerm?: string | undefined;
    blocked?: number | undefined;
    taxCode?: string | undefined;
    bankAccount?: string | undefined;
    taxId?: string | undefined;
    taxIdType?: string | undefined;
    description?: string | undefined;
    nameCurrency?: string | undefined;
}

export class BankAccountDto implements IBankAccountDto {
    id?: number | undefined;
    name?: string | undefined;
    description?: string | undefined;
    currency?: number | undefined;
    ledgerAccount?: string | undefined;
    bankIBAN?: string | undefined;
    bankRegNum?: string | undefined;
    bankAccountNum?: string | undefined;
    bankBIC?: string | undefined;
    bankName?: string | undefined;
    bankTownName?: string | undefined;
    bankCountry?: string | undefined;
    bankTransferSetup?: number | undefined;
    accountName?: string | undefined;
    accountTownName?: string | undefined;
    accountCountry?: string | undefined;
    active?: boolean;
    openingBalanceCur?: number | undefined;
    openingBalanceDate?: Date | undefined;
    created?: Date | undefined;
    createdBy?: number | undefined;
    modified?: Date | undefined;
    modifiedBy?: number | undefined;
    num?: string | undefined;

    constructor(data?: IBankAccountDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.currency = _data["currency"];
            this.ledgerAccount = _data["ledgerAccount"];
            this.bankIBAN = _data["bankIBAN"];
            this.bankRegNum = _data["bankRegNum"];
            this.bankAccountNum = _data["bankAccountNum"];
            this.bankBIC = _data["bankBIC"];
            this.bankName = _data["bankName"];
            this.bankTownName = _data["bankTownName"];
            this.bankCountry = _data["bankCountry"];
            this.bankTransferSetup = _data["bankTransferSetup"];
            this.accountName = _data["accountName"];
            this.accountTownName = _data["accountTownName"];
            this.accountCountry = _data["accountCountry"];
            this.active = _data["active"];
            this.openingBalanceCur = _data["openingBalanceCur"];
            this.openingBalanceDate = _data["openingBalanceDate"] ? new Date(_data["openingBalanceDate"].toString()) : undefined as any;
            this.created = _data["created"] ? new Date(_data["created"].toString()) : undefined as any;
            this.createdBy = _data["createdBy"];
            this.modified = _data["modified"] ? new Date(_data["modified"].toString()) : undefined as any;
            this.modifiedBy = _data["modifiedBy"];
            this.num = _data["num"];
        }
    }

    static fromJS(data: any): BankAccountDto {
        data = typeof data === 'object' ? data : {};
        let result = new BankAccountDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["description"] = this.description;
        data["currency"] = this.currency;
        data["ledgerAccount"] = this.ledgerAccount;
        data["bankIBAN"] = this.bankIBAN;
        data["bankRegNum"] = this.bankRegNum;
        data["bankAccountNum"] = this.bankAccountNum;
        data["bankBIC"] = this.bankBIC;
        data["bankName"] = this.bankName;
        data["bankTownName"] = this.bankTownName;
        data["bankCountry"] = this.bankCountry;
        data["bankTransferSetup"] = this.bankTransferSetup;
        data["accountName"] = this.accountName;
        data["accountTownName"] = this.accountTownName;
        data["accountCountry"] = this.accountCountry;
        data["active"] = this.active;
        data["openingBalanceCur"] = this.openingBalanceCur;
        data["openingBalanceDate"] = this.openingBalanceDate ? this.openingBalanceDate.toISOString() : undefined as any;
        data["created"] = this.created ? this.created.toISOString() : undefined as any;
        data["createdBy"] = this.createdBy;
        data["modified"] = this.modified ? this.modified.toISOString() : undefined as any;
        data["modifiedBy"] = this.modifiedBy;
        data["num"] = this.num;
        return data;
    }
}

export interface IBankAccountDto {
    id?: number | undefined;
    name?: string | undefined;
    description?: string | undefined;
    currency?: number | undefined;
    ledgerAccount?: string | undefined;
    bankIBAN?: string | undefined;
    bankRegNum?: string | undefined;
    bankAccountNum?: string | undefined;
    bankBIC?: string | undefined;
    bankName?: string | undefined;
    bankTownName?: string | undefined;
    bankCountry?: string | undefined;
    bankTransferSetup?: number | undefined;
    accountName?: string | undefined;
    accountTownName?: string | undefined;
    accountCountry?: string | undefined;
    active?: boolean;
    openingBalanceCur?: number | undefined;
    openingBalanceDate?: Date | undefined;
    created?: Date | undefined;
    createdBy?: number | undefined;
    modified?: Date | undefined;
    modifiedBy?: number | undefined;
    num?: string | undefined;
}

export class VoucherMessageMailSyncCommand extends RequestExtendedInfo implements IVoucherMessageMailSyncCommand {
    allVoucherChannels?: boolean;
    channelType?: VoucherMessageChannelTypeEnum;
    voucherChannelName?: string | undefined;

    constructor(data?: IVoucherMessageMailSyncCommand) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.allVoucherChannels = _data["allVoucherChannels"];
            this.channelType = _data["channelType"];
            this.voucherChannelName = _data["voucherChannelName"];
        }
    }

    static override fromJS(data: any): VoucherMessageMailSyncCommand {
        data = typeof data === 'object' ? data : {};
        let result = new VoucherMessageMailSyncCommand();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["allVoucherChannels"] = this.allVoucherChannels;
        data["channelType"] = this.channelType;
        data["voucherChannelName"] = this.voucherChannelName;
        super.toJSON(data);
        return data;
    }
}

export interface IVoucherMessageMailSyncCommand extends IRequestExtendedInfo {
    allVoucherChannels?: boolean;
    channelType?: VoucherMessageChannelTypeEnum;
    voucherChannelName?: string | undefined;
}

export class VoucherMessageVm implements IVoucherMessageVm {
    voucherMessageViewDto?: VoucherMessageViewDto[] | undefined;
    voucherMessageStatusDto?: VoucherMessageStatusDto[] | undefined;
    voucherMessageChannelUsersDto?: VoucherMessageChannelUserDto[] | undefined;
    userCurrentDto?: UserDto | undefined;
    messageChannelNameFilter?: string | undefined;

    constructor(data?: IVoucherMessageVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["voucherMessageViewDto"])) {
                this.voucherMessageViewDto = [] as any;
                for (let item of _data["voucherMessageViewDto"])
                    this.voucherMessageViewDto!.push(VoucherMessageViewDto.fromJS(item));
            }
            if (Array.isArray(_data["voucherMessageStatusDto"])) {
                this.voucherMessageStatusDto = [] as any;
                for (let item of _data["voucherMessageStatusDto"])
                    this.voucherMessageStatusDto!.push(VoucherMessageStatusDto.fromJS(item));
            }
            if (Array.isArray(_data["voucherMessageChannelUsersDto"])) {
                this.voucherMessageChannelUsersDto = [] as any;
                for (let item of _data["voucherMessageChannelUsersDto"])
                    this.voucherMessageChannelUsersDto!.push(VoucherMessageChannelUserDto.fromJS(item));
            }
            this.userCurrentDto = _data["userCurrentDto"] ? UserDto.fromJS(_data["userCurrentDto"]) : undefined as any;
            this.messageChannelNameFilter = _data["messageChannelNameFilter"];
        }
    }

    static fromJS(data: any): VoucherMessageVm {
        data = typeof data === 'object' ? data : {};
        let result = new VoucherMessageVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.voucherMessageViewDto)) {
            data["voucherMessageViewDto"] = [];
            for (let item of this.voucherMessageViewDto)
                data["voucherMessageViewDto"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.voucherMessageStatusDto)) {
            data["voucherMessageStatusDto"] = [];
            for (let item of this.voucherMessageStatusDto)
                data["voucherMessageStatusDto"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.voucherMessageChannelUsersDto)) {
            data["voucherMessageChannelUsersDto"] = [];
            for (let item of this.voucherMessageChannelUsersDto)
                data["voucherMessageChannelUsersDto"].push(item ? item.toJSON() : undefined as any);
        }
        data["userCurrentDto"] = this.userCurrentDto ? this.userCurrentDto.toJSON() : undefined as any;
        data["messageChannelNameFilter"] = this.messageChannelNameFilter;
        return data;
    }
}

export interface IVoucherMessageVm {
    voucherMessageViewDto?: VoucherMessageViewDto[] | undefined;
    voucherMessageStatusDto?: VoucherMessageStatusDto[] | undefined;
    voucherMessageChannelUsersDto?: VoucherMessageChannelUserDto[] | undefined;
    userCurrentDto?: UserDto | undefined;
    messageChannelNameFilter?: string | undefined;
}

export class VoucherMessageViewDto implements IVoucherMessageViewDto {
    id?: number;
    channel?: number;
    channelName?: string | undefined;
    channelNum?: string | undefined;
    status?: number;
    statusName?: string | undefined;
    description?: string | undefined;
    attachmentCount?: number;
    created?: Date | undefined;
    modified?: Date | undefined;
    recieved?: Date | undefined;
    createdBy?: number | undefined;
    modifiedBy?: number | undefined;
    createdByName?: string | undefined;
    createdShortName?: string | undefined;
    modifiedByName?: string | undefined;
    modifiedByShortName?: string | undefined;
    mailId?: number | undefined;
    subject?: string | undefined;
    fromEmail?: string | undefined;
    fromName?: string | undefined;
    toEmails?: string | undefined;
    toNames?: string | undefined;
    ccEmails?: string | undefined;
    ccNames?: string | undefined;
    messageToken?: string | undefined;
    webLink?: string | undefined;
    channelType?: number | undefined;
    validationStatus?: number | undefined;
    validationName?: string | undefined;

    constructor(data?: IVoucherMessageViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.channel = _data["channel"];
            this.channelName = _data["channelName"];
            this.channelNum = _data["channelNum"];
            this.status = _data["status"];
            this.statusName = _data["statusName"];
            this.description = _data["description"];
            this.attachmentCount = _data["attachmentCount"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : undefined as any;
            this.modified = _data["modified"] ? new Date(_data["modified"].toString()) : undefined as any;
            this.recieved = _data["recieved"] ? new Date(_data["recieved"].toString()) : undefined as any;
            this.createdBy = _data["createdBy"];
            this.modifiedBy = _data["modifiedBy"];
            this.createdByName = _data["createdByName"];
            this.createdShortName = _data["createdShortName"];
            this.modifiedByName = _data["modifiedByName"];
            this.modifiedByShortName = _data["modifiedByShortName"];
            this.mailId = _data["mailId"];
            this.subject = _data["subject"];
            this.fromEmail = _data["fromEmail"];
            this.fromName = _data["fromName"];
            this.toEmails = _data["toEmails"];
            this.toNames = _data["toNames"];
            this.ccEmails = _data["ccEmails"];
            this.ccNames = _data["ccNames"];
            this.messageToken = _data["messageToken"];
            this.webLink = _data["webLink"];
            this.channelType = _data["channelType"];
            this.validationStatus = _data["validationStatus"];
            this.validationName = _data["validationName"];
        }
    }

    static fromJS(data: any): VoucherMessageViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new VoucherMessageViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["channel"] = this.channel;
        data["channelName"] = this.channelName;
        data["channelNum"] = this.channelNum;
        data["status"] = this.status;
        data["statusName"] = this.statusName;
        data["description"] = this.description;
        data["attachmentCount"] = this.attachmentCount;
        data["created"] = this.created ? this.created.toISOString() : undefined as any;
        data["modified"] = this.modified ? this.modified.toISOString() : undefined as any;
        data["recieved"] = this.recieved ? this.recieved.toISOString() : undefined as any;
        data["createdBy"] = this.createdBy;
        data["modifiedBy"] = this.modifiedBy;
        data["createdByName"] = this.createdByName;
        data["createdShortName"] = this.createdShortName;
        data["modifiedByName"] = this.modifiedByName;
        data["modifiedByShortName"] = this.modifiedByShortName;
        data["mailId"] = this.mailId;
        data["subject"] = this.subject;
        data["fromEmail"] = this.fromEmail;
        data["fromName"] = this.fromName;
        data["toEmails"] = this.toEmails;
        data["toNames"] = this.toNames;
        data["ccEmails"] = this.ccEmails;
        data["ccNames"] = this.ccNames;
        data["messageToken"] = this.messageToken;
        data["webLink"] = this.webLink;
        data["channelType"] = this.channelType;
        data["validationStatus"] = this.validationStatus;
        data["validationName"] = this.validationName;
        return data;
    }
}

export interface IVoucherMessageViewDto {
    id?: number;
    channel?: number;
    channelName?: string | undefined;
    channelNum?: string | undefined;
    status?: number;
    statusName?: string | undefined;
    description?: string | undefined;
    attachmentCount?: number;
    created?: Date | undefined;
    modified?: Date | undefined;
    recieved?: Date | undefined;
    createdBy?: number | undefined;
    modifiedBy?: number | undefined;
    createdByName?: string | undefined;
    createdShortName?: string | undefined;
    modifiedByName?: string | undefined;
    modifiedByShortName?: string | undefined;
    mailId?: number | undefined;
    subject?: string | undefined;
    fromEmail?: string | undefined;
    fromName?: string | undefined;
    toEmails?: string | undefined;
    toNames?: string | undefined;
    ccEmails?: string | undefined;
    ccNames?: string | undefined;
    messageToken?: string | undefined;
    webLink?: string | undefined;
    channelType?: number | undefined;
    validationStatus?: number | undefined;
    validationName?: string | undefined;
}

export class VoucherMessageStatusDto implements IVoucherMessageStatusDto {
    id?: number;
    name?: string | undefined;

    constructor(data?: IVoucherMessageStatusDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): VoucherMessageStatusDto {
        data = typeof data === 'object' ? data : {};
        let result = new VoucherMessageStatusDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

export interface IVoucherMessageStatusDto {
    id?: number;
    name?: string | undefined;
}

export class VoucherMessageChannelUserDto implements IVoucherMessageChannelUserDto {
    id?: number | undefined;
    userId?: number;
    channelId?: number;
    primary?: boolean;
    admin?: boolean;
    ledgerJournalName?: string | undefined;

    constructor(data?: IVoucherMessageChannelUserDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.userId = _data["userId"];
            this.channelId = _data["channelId"];
            this.primary = _data["primary"];
            this.admin = _data["admin"];
            this.ledgerJournalName = _data["ledgerJournalName"];
        }
    }

    static fromJS(data: any): VoucherMessageChannelUserDto {
        data = typeof data === 'object' ? data : {};
        let result = new VoucherMessageChannelUserDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["userId"] = this.userId;
        data["channelId"] = this.channelId;
        data["primary"] = this.primary;
        data["admin"] = this.admin;
        data["ledgerJournalName"] = this.ledgerJournalName;
        return data;
    }
}

export interface IVoucherMessageChannelUserDto {
    id?: number | undefined;
    userId?: number;
    channelId?: number;
    primary?: boolean;
    admin?: boolean;
    ledgerJournalName?: string | undefined;
}

export enum VoucherMessageStatusAllEnum {
    All = 0,
    Inbox = 1,
    OnHold = 2,
    Voucher = 3,
    Forwarded = 4,
    Rejected = 5,
    AccountStatement = 6,
}

export class MessageVoucherCreateBaseDataVm implements IMessageVoucherCreateBaseDataVm {
    channelId?: number;
    currencyIdDefault?: number;
    currencyList?: CurrencyDto[] | undefined;
    voucherCategoryList?: VoucherCategoryDto[] | undefined;
    voucherRequestList?: VoucherRequestDto[] | undefined;
    validExtensions?: string[] | undefined;
    validImageExtensions?: string[] | undefined;

    constructor(data?: IMessageVoucherCreateBaseDataVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.channelId = _data["channelId"];
            this.currencyIdDefault = _data["currencyIdDefault"];
            if (Array.isArray(_data["currencyList"])) {
                this.currencyList = [] as any;
                for (let item of _data["currencyList"])
                    this.currencyList!.push(CurrencyDto.fromJS(item));
            }
            if (Array.isArray(_data["voucherCategoryList"])) {
                this.voucherCategoryList = [] as any;
                for (let item of _data["voucherCategoryList"])
                    this.voucherCategoryList!.push(VoucherCategoryDto.fromJS(item));
            }
            if (Array.isArray(_data["voucherRequestList"])) {
                this.voucherRequestList = [] as any;
                for (let item of _data["voucherRequestList"])
                    this.voucherRequestList!.push(VoucherRequestDto.fromJS(item));
            }
            if (Array.isArray(_data["validExtensions"])) {
                this.validExtensions = [] as any;
                for (let item of _data["validExtensions"])
                    this.validExtensions!.push(item);
            }
            if (Array.isArray(_data["validImageExtensions"])) {
                this.validImageExtensions = [] as any;
                for (let item of _data["validImageExtensions"])
                    this.validImageExtensions!.push(item);
            }
        }
    }

    static fromJS(data: any): MessageVoucherCreateBaseDataVm {
        data = typeof data === 'object' ? data : {};
        let result = new MessageVoucherCreateBaseDataVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["channelId"] = this.channelId;
        data["currencyIdDefault"] = this.currencyIdDefault;
        if (Array.isArray(this.currencyList)) {
            data["currencyList"] = [];
            for (let item of this.currencyList)
                data["currencyList"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.voucherCategoryList)) {
            data["voucherCategoryList"] = [];
            for (let item of this.voucherCategoryList)
                data["voucherCategoryList"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.voucherRequestList)) {
            data["voucherRequestList"] = [];
            for (let item of this.voucherRequestList)
                data["voucherRequestList"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.validExtensions)) {
            data["validExtensions"] = [];
            for (let item of this.validExtensions)
                data["validExtensions"].push(item);
        }
        if (Array.isArray(this.validImageExtensions)) {
            data["validImageExtensions"] = [];
            for (let item of this.validImageExtensions)
                data["validImageExtensions"].push(item);
        }
        return data;
    }
}

export interface IMessageVoucherCreateBaseDataVm {
    channelId?: number;
    currencyIdDefault?: number;
    currencyList?: CurrencyDto[] | undefined;
    voucherCategoryList?: VoucherCategoryDto[] | undefined;
    voucherRequestList?: VoucherRequestDto[] | undefined;
    validExtensions?: string[] | undefined;
    validImageExtensions?: string[] | undefined;
}

export class VoucherCategoryDto implements IVoucherCategoryDto {
    id?: number | undefined;
    name?: string | undefined;

    constructor(data?: IVoucherCategoryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): VoucherCategoryDto {
        data = typeof data === 'object' ? data : {};
        let result = new VoucherCategoryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

export interface IVoucherCategoryDto {
    id?: number | undefined;
    name?: string | undefined;
}

export class VoucherRequestDto implements IVoucherRequestDto {
    id?: number | undefined;
    description?: string | undefined;
    currency?: number | undefined;
    amountCur?: number | undefined;
    transDate?: Date | undefined;
    responsible?: number;
    bankTransaction?: number | undefined;
    notified?: boolean | undefined;
    completed?: boolean | undefined;
    created?: Date | undefined;
    createdBy?: number | undefined;
    modified?: Date | undefined;
    modifiedBy?: number | undefined;

    constructor(data?: IVoucherRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.description = _data["description"];
            this.currency = _data["currency"];
            this.amountCur = _data["amountCur"];
            this.transDate = _data["transDate"] ? new Date(_data["transDate"].toString()) : undefined as any;
            this.responsible = _data["responsible"];
            this.bankTransaction = _data["bankTransaction"];
            this.notified = _data["notified"];
            this.completed = _data["completed"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : undefined as any;
            this.createdBy = _data["createdBy"];
            this.modified = _data["modified"] ? new Date(_data["modified"].toString()) : undefined as any;
            this.modifiedBy = _data["modifiedBy"];
        }
    }

    static fromJS(data: any): VoucherRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new VoucherRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["description"] = this.description;
        data["currency"] = this.currency;
        data["amountCur"] = this.amountCur;
        data["transDate"] = this.transDate ? this.transDate.toISOString() : undefined as any;
        data["responsible"] = this.responsible;
        data["bankTransaction"] = this.bankTransaction;
        data["notified"] = this.notified;
        data["completed"] = this.completed;
        data["created"] = this.created ? this.created.toISOString() : undefined as any;
        data["createdBy"] = this.createdBy;
        data["modified"] = this.modified ? this.modified.toISOString() : undefined as any;
        data["modifiedBy"] = this.modifiedBy;
        return data;
    }
}

export interface IVoucherRequestDto {
    id?: number | undefined;
    description?: string | undefined;
    currency?: number | undefined;
    amountCur?: number | undefined;
    transDate?: Date | undefined;
    responsible?: number;
    bankTransaction?: number | undefined;
    notified?: boolean | undefined;
    completed?: boolean | undefined;
    created?: Date | undefined;
    createdBy?: number | undefined;
    modified?: Date | undefined;
    modifiedBy?: number | undefined;
}

export class VoucherMessageCreateCommand extends RequestExtendedInfo implements IVoucherMessageCreateCommand {
    transactionId?: string;
    channelId?: number | undefined;
    channelType?: VoucherMessageChannelTypeEnum | undefined;
    amount?: number | undefined;
    currency?: number | undefined;
    transDate?: Date | undefined;
    voucherCategory?: number | undefined;
    authReference?: string | undefined;
    description?: string | undefined;
    voucherNum?: string;
    comment?: string | undefined;
    bankTransactionId?: number | undefined;
    bankSettlementStatus?: BankSettlementStatusEnum;
    messageStatus?: VoucherMessageStatusEnum;
    voucherStatus?: VoucherApprovalStatusEnum | undefined;
    currentUserAsApprover?: boolean;
    voucherRequest?: number | undefined;
    filesDataList?: FileData[];
    salesFromDate?: Date | undefined;
    salesToDate?: Date | undefined;
    salesIsBOM?: boolean | undefined;

    constructor(data?: IVoucherMessageCreateCommand) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.transactionId = _data["transactionId"];
            this.channelId = _data["channelId"];
            this.channelType = _data["channelType"];
            this.amount = _data["amount"];
            this.currency = _data["currency"];
            this.transDate = _data["transDate"] ? new Date(_data["transDate"].toString()) : undefined as any;
            this.voucherCategory = _data["voucherCategory"];
            this.authReference = _data["authReference"];
            this.description = _data["description"];
            this.voucherNum = _data["voucherNum"];
            this.comment = _data["comment"];
            this.bankTransactionId = _data["bankTransactionId"];
            this.bankSettlementStatus = _data["bankSettlementStatus"];
            this.messageStatus = _data["messageStatus"];
            this.voucherStatus = _data["voucherStatus"];
            this.currentUserAsApprover = _data["currentUserAsApprover"];
            this.voucherRequest = _data["voucherRequest"];
            if (Array.isArray(_data["filesDataList"])) {
                this.filesDataList = [] as any;
                for (let item of _data["filesDataList"])
                    this.filesDataList!.push(FileData.fromJS(item));
            }
            this.salesFromDate = _data["salesFromDate"] ? new Date(_data["salesFromDate"].toString()) : undefined as any;
            this.salesToDate = _data["salesToDate"] ? new Date(_data["salesToDate"].toString()) : undefined as any;
            this.salesIsBOM = _data["salesIsBOM"];
        }
    }

    static override fromJS(data: any): VoucherMessageCreateCommand {
        data = typeof data === 'object' ? data : {};
        let result = new VoucherMessageCreateCommand();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["transactionId"] = this.transactionId;
        data["channelId"] = this.channelId;
        data["channelType"] = this.channelType;
        data["amount"] = this.amount;
        data["currency"] = this.currency;
        data["transDate"] = this.transDate ? this.transDate.toISOString() : undefined as any;
        data["voucherCategory"] = this.voucherCategory;
        data["authReference"] = this.authReference;
        data["description"] = this.description;
        data["voucherNum"] = this.voucherNum;
        data["comment"] = this.comment;
        data["bankTransactionId"] = this.bankTransactionId;
        data["bankSettlementStatus"] = this.bankSettlementStatus;
        data["messageStatus"] = this.messageStatus;
        data["voucherStatus"] = this.voucherStatus;
        data["currentUserAsApprover"] = this.currentUserAsApprover;
        data["voucherRequest"] = this.voucherRequest;
        if (Array.isArray(this.filesDataList)) {
            data["filesDataList"] = [];
            for (let item of this.filesDataList)
                data["filesDataList"].push(item ? item.toJSON() : undefined as any);
        }
        data["salesFromDate"] = this.salesFromDate ? this.salesFromDate.toISOString() : undefined as any;
        data["salesToDate"] = this.salesToDate ? this.salesToDate.toISOString() : undefined as any;
        data["salesIsBOM"] = this.salesIsBOM;
        super.toJSON(data);
        return data;
    }
}

export interface IVoucherMessageCreateCommand extends IRequestExtendedInfo {
    transactionId?: string;
    channelId?: number | undefined;
    channelType?: VoucherMessageChannelTypeEnum | undefined;
    amount?: number | undefined;
    currency?: number | undefined;
    transDate?: Date | undefined;
    voucherCategory?: number | undefined;
    authReference?: string | undefined;
    description?: string | undefined;
    voucherNum?: string;
    comment?: string | undefined;
    bankTransactionId?: number | undefined;
    bankSettlementStatus?: BankSettlementStatusEnum;
    messageStatus?: VoucherMessageStatusEnum;
    voucherStatus?: VoucherApprovalStatusEnum | undefined;
    currentUserAsApprover?: boolean;
    voucherRequest?: number | undefined;
    filesDataList?: FileData[];
    salesFromDate?: Date | undefined;
    salesToDate?: Date | undefined;
    salesIsBOM?: boolean | undefined;
}

export class FileData implements IFileData {
    fileName?: string;
    dataUrl?: string;

    constructor(data?: IFileData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fileName = _data["fileName"];
            this.dataUrl = _data["dataUrl"];
        }
    }

    static fromJS(data: any): FileData {
        data = typeof data === 'object' ? data : {};
        let result = new FileData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fileName"] = this.fileName;
        data["dataUrl"] = this.dataUrl;
        return data;
    }
}

export interface IFileData {
    fileName?: string;
    dataUrl?: string;
}

export class VoucherMessageAttachmentsApplyCommand implements IVoucherMessageAttachmentsApplyCommand {
    fromMsgId?: number;
    toMsgId?: number;
    fileNames?: string[];
    splitMessageByFile?: boolean;
    copyFile?: boolean;

    constructor(data?: IVoucherMessageAttachmentsApplyCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fromMsgId = _data["fromMsgId"];
            this.toMsgId = _data["toMsgId"];
            if (Array.isArray(_data["fileNames"])) {
                this.fileNames = [] as any;
                for (let item of _data["fileNames"])
                    this.fileNames!.push(item);
            }
            this.splitMessageByFile = _data["splitMessageByFile"];
            this.copyFile = _data["copyFile"];
        }
    }

    static fromJS(data: any): VoucherMessageAttachmentsApplyCommand {
        data = typeof data === 'object' ? data : {};
        let result = new VoucherMessageAttachmentsApplyCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fromMsgId"] = this.fromMsgId;
        data["toMsgId"] = this.toMsgId;
        if (Array.isArray(this.fileNames)) {
            data["fileNames"] = [];
            for (let item of this.fileNames)
                data["fileNames"].push(item);
        }
        data["splitMessageByFile"] = this.splitMessageByFile;
        data["copyFile"] = this.copyFile;
        return data;
    }
}

export interface IVoucherMessageAttachmentsApplyCommand {
    fromMsgId?: number;
    toMsgId?: number;
    fileNames?: string[];
    splitMessageByFile?: boolean;
    copyFile?: boolean;
}

export class VoucherMessageViewDetailsVm implements IVoucherMessageViewDetailsVm {
    vendorsSelected?: VendorViewDto[] | undefined;
    debtorsSelected?: DebtorDto[] | undefined;
    projectsSelected?: ProjectDto[] | undefined;
    ledgerAccountsSelected?: FinanceLedgerAccountDto[] | undefined;
    voucherMessageViewDto?: VoucherMessageViewDto | undefined;
    voucherMessageChannelDto?: VoucherMessageChannelDto | undefined;
    voucherViewDtoList?: VoucherViewDto[] | undefined;
    voucherPostingViewDtoList?: VoucherPostingViewDto[] | undefined;
    voucherMessageAttachmentDtoList?: LinkedAttachmentDto[] | undefined;
    chatDtoList?: ChatDto[] | undefined;
    attachmentsSaveUrl?: string | undefined;
    attachmentsRemoveUrl?: string | undefined;
    voucherMessageChannelType?: VoucherMessageChannelTypeEnum;
    postingTypeDefaultPostingEnum?: VoucherPostingTypeEnum;
    postingTypeDefaultOffsetPostingEnum?: VoucherPostingTypeEnum;
    chatDtoAdded?: ChatDto | undefined;
    approversNextOption?: number[] | undefined;
    amountCurOptions?: number[] | undefined;
    formFieldValues?: { [key in keyof typeof FormRecognizerFieldTypeEnum]?: any[]; } | undefined;

    constructor(data?: IVoucherMessageViewDetailsVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["vendorsSelected"])) {
                this.vendorsSelected = [] as any;
                for (let item of _data["vendorsSelected"])
                    this.vendorsSelected!.push(VendorViewDto.fromJS(item));
            }
            if (Array.isArray(_data["debtorsSelected"])) {
                this.debtorsSelected = [] as any;
                for (let item of _data["debtorsSelected"])
                    this.debtorsSelected!.push(DebtorDto.fromJS(item));
            }
            if (Array.isArray(_data["projectsSelected"])) {
                this.projectsSelected = [] as any;
                for (let item of _data["projectsSelected"])
                    this.projectsSelected!.push(ProjectDto.fromJS(item));
            }
            if (Array.isArray(_data["ledgerAccountsSelected"])) {
                this.ledgerAccountsSelected = [] as any;
                for (let item of _data["ledgerAccountsSelected"])
                    this.ledgerAccountsSelected!.push(FinanceLedgerAccountDto.fromJS(item));
            }
            this.voucherMessageViewDto = _data["voucherMessageViewDto"] ? VoucherMessageViewDto.fromJS(_data["voucherMessageViewDto"]) : undefined as any;
            this.voucherMessageChannelDto = _data["voucherMessageChannelDto"] ? VoucherMessageChannelDto.fromJS(_data["voucherMessageChannelDto"]) : undefined as any;
            if (Array.isArray(_data["voucherViewDtoList"])) {
                this.voucherViewDtoList = [] as any;
                for (let item of _data["voucherViewDtoList"])
                    this.voucherViewDtoList!.push(VoucherViewDto.fromJS(item));
            }
            if (Array.isArray(_data["voucherPostingViewDtoList"])) {
                this.voucherPostingViewDtoList = [] as any;
                for (let item of _data["voucherPostingViewDtoList"])
                    this.voucherPostingViewDtoList!.push(VoucherPostingViewDto.fromJS(item));
            }
            if (Array.isArray(_data["voucherMessageAttachmentDtoList"])) {
                this.voucherMessageAttachmentDtoList = [] as any;
                for (let item of _data["voucherMessageAttachmentDtoList"])
                    this.voucherMessageAttachmentDtoList!.push(LinkedAttachmentDto.fromJS(item));
            }
            if (Array.isArray(_data["chatDtoList"])) {
                this.chatDtoList = [] as any;
                for (let item of _data["chatDtoList"])
                    this.chatDtoList!.push(ChatDto.fromJS(item));
            }
            this.attachmentsSaveUrl = _data["attachmentsSaveUrl"];
            this.attachmentsRemoveUrl = _data["attachmentsRemoveUrl"];
            this.voucherMessageChannelType = _data["voucherMessageChannelType"];
            this.postingTypeDefaultPostingEnum = _data["postingTypeDefaultPostingEnum"];
            this.postingTypeDefaultOffsetPostingEnum = _data["postingTypeDefaultOffsetPostingEnum"];
            this.chatDtoAdded = _data["chatDtoAdded"] ? ChatDto.fromJS(_data["chatDtoAdded"]) : undefined as any;
            if (Array.isArray(_data["approversNextOption"])) {
                this.approversNextOption = [] as any;
                for (let item of _data["approversNextOption"])
                    this.approversNextOption!.push(item);
            }
            if (Array.isArray(_data["amountCurOptions"])) {
                this.amountCurOptions = [] as any;
                for (let item of _data["amountCurOptions"])
                    this.amountCurOptions!.push(item);
            }
            if (_data["formFieldValues"]) {
                this.formFieldValues = {} as any;
                for (let key in _data["formFieldValues"]) {
                    if (_data["formFieldValues"].hasOwnProperty(key))
                        (this.formFieldValues as any)![key] = _data["formFieldValues"][key] !== undefined ? _data["formFieldValues"][key] : [];
                }
            }
        }
    }

    static fromJS(data: any): VoucherMessageViewDetailsVm {
        data = typeof data === 'object' ? data : {};
        let result = new VoucherMessageViewDetailsVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.vendorsSelected)) {
            data["vendorsSelected"] = [];
            for (let item of this.vendorsSelected)
                data["vendorsSelected"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.debtorsSelected)) {
            data["debtorsSelected"] = [];
            for (let item of this.debtorsSelected)
                data["debtorsSelected"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.projectsSelected)) {
            data["projectsSelected"] = [];
            for (let item of this.projectsSelected)
                data["projectsSelected"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.ledgerAccountsSelected)) {
            data["ledgerAccountsSelected"] = [];
            for (let item of this.ledgerAccountsSelected)
                data["ledgerAccountsSelected"].push(item ? item.toJSON() : undefined as any);
        }
        data["voucherMessageViewDto"] = this.voucherMessageViewDto ? this.voucherMessageViewDto.toJSON() : undefined as any;
        data["voucherMessageChannelDto"] = this.voucherMessageChannelDto ? this.voucherMessageChannelDto.toJSON() : undefined as any;
        if (Array.isArray(this.voucherViewDtoList)) {
            data["voucherViewDtoList"] = [];
            for (let item of this.voucherViewDtoList)
                data["voucherViewDtoList"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.voucherPostingViewDtoList)) {
            data["voucherPostingViewDtoList"] = [];
            for (let item of this.voucherPostingViewDtoList)
                data["voucherPostingViewDtoList"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.voucherMessageAttachmentDtoList)) {
            data["voucherMessageAttachmentDtoList"] = [];
            for (let item of this.voucherMessageAttachmentDtoList)
                data["voucherMessageAttachmentDtoList"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.chatDtoList)) {
            data["chatDtoList"] = [];
            for (let item of this.chatDtoList)
                data["chatDtoList"].push(item ? item.toJSON() : undefined as any);
        }
        data["attachmentsSaveUrl"] = this.attachmentsSaveUrl;
        data["attachmentsRemoveUrl"] = this.attachmentsRemoveUrl;
        data["voucherMessageChannelType"] = this.voucherMessageChannelType;
        data["postingTypeDefaultPostingEnum"] = this.postingTypeDefaultPostingEnum;
        data["postingTypeDefaultOffsetPostingEnum"] = this.postingTypeDefaultOffsetPostingEnum;
        data["chatDtoAdded"] = this.chatDtoAdded ? this.chatDtoAdded.toJSON() : undefined as any;
        if (Array.isArray(this.approversNextOption)) {
            data["approversNextOption"] = [];
            for (let item of this.approversNextOption)
                data["approversNextOption"].push(item);
        }
        if (Array.isArray(this.amountCurOptions)) {
            data["amountCurOptions"] = [];
            for (let item of this.amountCurOptions)
                data["amountCurOptions"].push(item);
        }
        if (this.formFieldValues) {
            data["formFieldValues"] = {};
            for (let key in this.formFieldValues) {
                if (this.formFieldValues.hasOwnProperty(key))
                    (data["formFieldValues"] as any)[key] = (this.formFieldValues as any)[key];
            }
        }
        return data;
    }
}

export interface IVoucherMessageViewDetailsVm {
    vendorsSelected?: VendorViewDto[] | undefined;
    debtorsSelected?: DebtorDto[] | undefined;
    projectsSelected?: ProjectDto[] | undefined;
    ledgerAccountsSelected?: FinanceLedgerAccountDto[] | undefined;
    voucherMessageViewDto?: VoucherMessageViewDto | undefined;
    voucherMessageChannelDto?: VoucherMessageChannelDto | undefined;
    voucherViewDtoList?: VoucherViewDto[] | undefined;
    voucherPostingViewDtoList?: VoucherPostingViewDto[] | undefined;
    voucherMessageAttachmentDtoList?: LinkedAttachmentDto[] | undefined;
    chatDtoList?: ChatDto[] | undefined;
    attachmentsSaveUrl?: string | undefined;
    attachmentsRemoveUrl?: string | undefined;
    voucherMessageChannelType?: VoucherMessageChannelTypeEnum;
    postingTypeDefaultPostingEnum?: VoucherPostingTypeEnum;
    postingTypeDefaultOffsetPostingEnum?: VoucherPostingTypeEnum;
    chatDtoAdded?: ChatDto | undefined;
    approversNextOption?: number[] | undefined;
    amountCurOptions?: number[] | undefined;
    formFieldValues?: { [key in keyof typeof FormRecognizerFieldTypeEnum]?: any[]; } | undefined;
}

export class VoucherMessageChannelDto implements IVoucherMessageChannelDto {
    id?: number | undefined;
    name?: string | undefined;
    type?: number | undefined;
    formRecognizer?: number | undefined;
    ledgerJournalName?: string | undefined;
    voucherStatus?: number | undefined;

    constructor(data?: IVoucherMessageChannelDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.type = _data["type"];
            this.formRecognizer = _data["formRecognizer"];
            this.ledgerJournalName = _data["ledgerJournalName"];
            this.voucherStatus = _data["voucherStatus"];
        }
    }

    static fromJS(data: any): VoucherMessageChannelDto {
        data = typeof data === 'object' ? data : {};
        let result = new VoucherMessageChannelDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["type"] = this.type;
        data["formRecognizer"] = this.formRecognizer;
        data["ledgerJournalName"] = this.ledgerJournalName;
        data["voucherStatus"] = this.voucherStatus;
        return data;
    }
}

export interface IVoucherMessageChannelDto {
    id?: number | undefined;
    name?: string | undefined;
    type?: number | undefined;
    formRecognizer?: number | undefined;
    ledgerJournalName?: string | undefined;
    voucherStatus?: number | undefined;
}

export class VoucherViewDto implements IVoucherViewDto {
    id?: number;
    msgId?: number | undefined;
    voucherNum?: string | undefined;
    status?: number;
    statusName?: string | undefined;
    approver?: number | undefined;
    currency?: number | undefined;
    currencyISO?: string | undefined;
    currencyName?: string | undefined;
    amountCur?: number | undefined;
    transDate?: Date | undefined;
    documentDate?: Date | undefined;
    documentNum?: string | undefined;
    txt?: string | undefined;
    notes?: string | undefined;
    channelNum?: string | undefined;
    channelName?: string | undefined;
    channelType?: number | undefined;
    created?: Date | undefined;
    modified?: Date | undefined;
    recieved?: Date | undefined;
    authReference?: string | undefined;
    createdBy?: number | undefined;
    modifiedBy?: number | undefined;
    approverName?: string | undefined;
    approverShortName?: string | undefined;
    createdByName?: string | undefined;
    createdByShortName?: string | undefined;
    modifiedByName?: string | undefined;
    modifiedByShortName?: string | undefined;
    balancePostingType?: number | undefined;
    balanceAccountNum?: string | undefined;
    balanceAccountDescription?: string | undefined;
    balanceAccountTaxCode?: string | undefined;
    costPostingType?: number | undefined;
    costAccountNum?: string | undefined;
    costAccountDescription?: string | undefined;
    costAccountTaxCode?: string | undefined;
    projectCostType?: string | undefined;
    projectCostTypeName?: string | undefined;
    projectCostTypeDescription?: string | undefined;
    voucherCategoryId?: number | undefined;
    voucherCategoryName?: string | undefined;
    postedStatus?: number | undefined;
    postedStatusName?: string | undefined;
    validationStatus?: number | undefined;
    validationName?: string | undefined;
    salesFromDate?: Date | undefined;
    salesToDate?: Date | undefined;
    salesIsBOM?: boolean | undefined;
    chat?: ChatDto[] | undefined;

    constructor(data?: IVoucherViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.msgId = _data["msgId"];
            this.voucherNum = _data["voucherNum"];
            this.status = _data["status"];
            this.statusName = _data["statusName"];
            this.approver = _data["approver"];
            this.currency = _data["currency"];
            this.currencyISO = _data["currencyISO"];
            this.currencyName = _data["currencyName"];
            this.amountCur = _data["amountCur"];
            this.transDate = _data["transDate"] ? new Date(_data["transDate"].toString()) : undefined as any;
            this.documentDate = _data["documentDate"] ? new Date(_data["documentDate"].toString()) : undefined as any;
            this.documentNum = _data["documentNum"];
            this.txt = _data["txt"];
            this.notes = _data["notes"];
            this.channelNum = _data["channelNum"];
            this.channelName = _data["channelName"];
            this.channelType = _data["channelType"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : undefined as any;
            this.modified = _data["modified"] ? new Date(_data["modified"].toString()) : undefined as any;
            this.recieved = _data["recieved"] ? new Date(_data["recieved"].toString()) : undefined as any;
            this.authReference = _data["authReference"];
            this.createdBy = _data["createdBy"];
            this.modifiedBy = _data["modifiedBy"];
            this.approverName = _data["approverName"];
            this.approverShortName = _data["approverShortName"];
            this.createdByName = _data["createdByName"];
            this.createdByShortName = _data["createdByShortName"];
            this.modifiedByName = _data["modifiedByName"];
            this.modifiedByShortName = _data["modifiedByShortName"];
            this.balancePostingType = _data["balancePostingType"];
            this.balanceAccountNum = _data["balanceAccountNum"];
            this.balanceAccountDescription = _data["balanceAccountDescription"];
            this.balanceAccountTaxCode = _data["balanceAccountTaxCode"];
            this.costPostingType = _data["costPostingType"];
            this.costAccountNum = _data["costAccountNum"];
            this.costAccountDescription = _data["costAccountDescription"];
            this.costAccountTaxCode = _data["costAccountTaxCode"];
            this.projectCostType = _data["projectCostType"];
            this.projectCostTypeName = _data["projectCostTypeName"];
            this.projectCostTypeDescription = _data["projectCostTypeDescription"];
            this.voucherCategoryId = _data["voucherCategoryId"];
            this.voucherCategoryName = _data["voucherCategoryName"];
            this.postedStatus = _data["postedStatus"];
            this.postedStatusName = _data["postedStatusName"];
            this.validationStatus = _data["validationStatus"];
            this.validationName = _data["validationName"];
            this.salesFromDate = _data["salesFromDate"] ? new Date(_data["salesFromDate"].toString()) : undefined as any;
            this.salesToDate = _data["salesToDate"] ? new Date(_data["salesToDate"].toString()) : undefined as any;
            this.salesIsBOM = _data["salesIsBOM"];
            if (Array.isArray(_data["chat"])) {
                this.chat = [] as any;
                for (let item of _data["chat"])
                    this.chat!.push(ChatDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): VoucherViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new VoucherViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["msgId"] = this.msgId;
        data["voucherNum"] = this.voucherNum;
        data["status"] = this.status;
        data["statusName"] = this.statusName;
        data["approver"] = this.approver;
        data["currency"] = this.currency;
        data["currencyISO"] = this.currencyISO;
        data["currencyName"] = this.currencyName;
        data["amountCur"] = this.amountCur;
        data["transDate"] = this.transDate ? this.transDate.toISOString() : undefined as any;
        data["documentDate"] = this.documentDate ? this.documentDate.toISOString() : undefined as any;
        data["documentNum"] = this.documentNum;
        data["txt"] = this.txt;
        data["notes"] = this.notes;
        data["channelNum"] = this.channelNum;
        data["channelName"] = this.channelName;
        data["channelType"] = this.channelType;
        data["created"] = this.created ? this.created.toISOString() : undefined as any;
        data["modified"] = this.modified ? this.modified.toISOString() : undefined as any;
        data["recieved"] = this.recieved ? this.recieved.toISOString() : undefined as any;
        data["authReference"] = this.authReference;
        data["createdBy"] = this.createdBy;
        data["modifiedBy"] = this.modifiedBy;
        data["approverName"] = this.approverName;
        data["approverShortName"] = this.approverShortName;
        data["createdByName"] = this.createdByName;
        data["createdByShortName"] = this.createdByShortName;
        data["modifiedByName"] = this.modifiedByName;
        data["modifiedByShortName"] = this.modifiedByShortName;
        data["balancePostingType"] = this.balancePostingType;
        data["balanceAccountNum"] = this.balanceAccountNum;
        data["balanceAccountDescription"] = this.balanceAccountDescription;
        data["balanceAccountTaxCode"] = this.balanceAccountTaxCode;
        data["costPostingType"] = this.costPostingType;
        data["costAccountNum"] = this.costAccountNum;
        data["costAccountDescription"] = this.costAccountDescription;
        data["costAccountTaxCode"] = this.costAccountTaxCode;
        data["projectCostType"] = this.projectCostType;
        data["projectCostTypeName"] = this.projectCostTypeName;
        data["projectCostTypeDescription"] = this.projectCostTypeDescription;
        data["voucherCategoryId"] = this.voucherCategoryId;
        data["voucherCategoryName"] = this.voucherCategoryName;
        data["postedStatus"] = this.postedStatus;
        data["postedStatusName"] = this.postedStatusName;
        data["validationStatus"] = this.validationStatus;
        data["validationName"] = this.validationName;
        data["salesFromDate"] = this.salesFromDate ? this.salesFromDate.toISOString() : undefined as any;
        data["salesToDate"] = this.salesToDate ? this.salesToDate.toISOString() : undefined as any;
        data["salesIsBOM"] = this.salesIsBOM;
        if (Array.isArray(this.chat)) {
            data["chat"] = [];
            for (let item of this.chat)
                data["chat"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IVoucherViewDto {
    id?: number;
    msgId?: number | undefined;
    voucherNum?: string | undefined;
    status?: number;
    statusName?: string | undefined;
    approver?: number | undefined;
    currency?: number | undefined;
    currencyISO?: string | undefined;
    currencyName?: string | undefined;
    amountCur?: number | undefined;
    transDate?: Date | undefined;
    documentDate?: Date | undefined;
    documentNum?: string | undefined;
    txt?: string | undefined;
    notes?: string | undefined;
    channelNum?: string | undefined;
    channelName?: string | undefined;
    channelType?: number | undefined;
    created?: Date | undefined;
    modified?: Date | undefined;
    recieved?: Date | undefined;
    authReference?: string | undefined;
    createdBy?: number | undefined;
    modifiedBy?: number | undefined;
    approverName?: string | undefined;
    approverShortName?: string | undefined;
    createdByName?: string | undefined;
    createdByShortName?: string | undefined;
    modifiedByName?: string | undefined;
    modifiedByShortName?: string | undefined;
    balancePostingType?: number | undefined;
    balanceAccountNum?: string | undefined;
    balanceAccountDescription?: string | undefined;
    balanceAccountTaxCode?: string | undefined;
    costPostingType?: number | undefined;
    costAccountNum?: string | undefined;
    costAccountDescription?: string | undefined;
    costAccountTaxCode?: string | undefined;
    projectCostType?: string | undefined;
    projectCostTypeName?: string | undefined;
    projectCostTypeDescription?: string | undefined;
    voucherCategoryId?: number | undefined;
    voucherCategoryName?: string | undefined;
    postedStatus?: number | undefined;
    postedStatusName?: string | undefined;
    validationStatus?: number | undefined;
    validationName?: string | undefined;
    salesFromDate?: Date | undefined;
    salesToDate?: Date | undefined;
    salesIsBOM?: boolean | undefined;
    chat?: ChatDto[] | undefined;
}

export class VoucherPostingViewDto implements IVoucherPostingViewDto {
    id?: number | undefined;
    voucherId?: number;
    lineNum?: number | undefined;
    postingType?: number | undefined;
    postingTypeName?: string | undefined;
    accountNum?: string | undefined;
    accountDescription?: string | undefined;
    transDate?: Date | undefined;
    dueDate?: Date | undefined;
    amountCur?: number | undefined;
    amountCost?: number | undefined;
    txt?: string | undefined;
    dimension?: string | undefined;
    projectCostGroup?: string | undefined;
    projectCostType?: string | undefined;
    projectCostTypeName?: string | undefined;
    projectCostTypeDescription?: string | undefined;
    projectLedgerNum?: string | undefined;
    projectLedgerName?: string | undefined;
    projectLedgerDescription?: string | undefined;
    projectLedgerNumName?: string | undefined;
    paymentRef?: string | undefined;
    vendorBankAccount?: string | undefined;
    taxCode?: string | undefined;
    created?: Date | undefined;
    createdBy?: number | undefined;
    modified?: Date | undefined;
    modifiedBy?: number | undefined;
    createdByName?: string | undefined;
    createdByShortName?: string | undefined;
    modifiedByName?: string | undefined;
    modifiedByShortName?: string | undefined;
    msgId?: number | undefined;

    constructor(data?: IVoucherPostingViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.voucherId = _data["voucherId"];
            this.lineNum = _data["lineNum"];
            this.postingType = _data["postingType"];
            this.postingTypeName = _data["postingTypeName"];
            this.accountNum = _data["accountNum"];
            this.accountDescription = _data["accountDescription"];
            this.transDate = _data["transDate"] ? new Date(_data["transDate"].toString()) : undefined as any;
            this.dueDate = _data["dueDate"] ? new Date(_data["dueDate"].toString()) : undefined as any;
            this.amountCur = _data["amountCur"];
            this.amountCost = _data["amountCost"];
            this.txt = _data["txt"];
            this.dimension = _data["dimension"];
            this.projectCostGroup = _data["projectCostGroup"];
            this.projectCostType = _data["projectCostType"];
            this.projectCostTypeName = _data["projectCostTypeName"];
            this.projectCostTypeDescription = _data["projectCostTypeDescription"];
            this.projectLedgerNum = _data["projectLedgerNum"];
            this.projectLedgerName = _data["projectLedgerName"];
            this.projectLedgerDescription = _data["projectLedgerDescription"];
            this.projectLedgerNumName = _data["projectLedgerNumName"];
            this.paymentRef = _data["paymentRef"];
            this.vendorBankAccount = _data["vendorBankAccount"];
            this.taxCode = _data["taxCode"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : undefined as any;
            this.createdBy = _data["createdBy"];
            this.modified = _data["modified"] ? new Date(_data["modified"].toString()) : undefined as any;
            this.modifiedBy = _data["modifiedBy"];
            this.createdByName = _data["createdByName"];
            this.createdByShortName = _data["createdByShortName"];
            this.modifiedByName = _data["modifiedByName"];
            this.modifiedByShortName = _data["modifiedByShortName"];
            this.msgId = _data["msgId"];
        }
    }

    static fromJS(data: any): VoucherPostingViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new VoucherPostingViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["voucherId"] = this.voucherId;
        data["lineNum"] = this.lineNum;
        data["postingType"] = this.postingType;
        data["postingTypeName"] = this.postingTypeName;
        data["accountNum"] = this.accountNum;
        data["accountDescription"] = this.accountDescription;
        data["transDate"] = this.transDate ? this.transDate.toISOString() : undefined as any;
        data["dueDate"] = this.dueDate ? this.dueDate.toISOString() : undefined as any;
        data["amountCur"] = this.amountCur;
        data["amountCost"] = this.amountCost;
        data["txt"] = this.txt;
        data["dimension"] = this.dimension;
        data["projectCostGroup"] = this.projectCostGroup;
        data["projectCostType"] = this.projectCostType;
        data["projectCostTypeName"] = this.projectCostTypeName;
        data["projectCostTypeDescription"] = this.projectCostTypeDescription;
        data["projectLedgerNum"] = this.projectLedgerNum;
        data["projectLedgerName"] = this.projectLedgerName;
        data["projectLedgerDescription"] = this.projectLedgerDescription;
        data["projectLedgerNumName"] = this.projectLedgerNumName;
        data["paymentRef"] = this.paymentRef;
        data["vendorBankAccount"] = this.vendorBankAccount;
        data["taxCode"] = this.taxCode;
        data["created"] = this.created ? this.created.toISOString() : undefined as any;
        data["createdBy"] = this.createdBy;
        data["modified"] = this.modified ? this.modified.toISOString() : undefined as any;
        data["modifiedBy"] = this.modifiedBy;
        data["createdByName"] = this.createdByName;
        data["createdByShortName"] = this.createdByShortName;
        data["modifiedByName"] = this.modifiedByName;
        data["modifiedByShortName"] = this.modifiedByShortName;
        data["msgId"] = this.msgId;
        return data;
    }
}

export interface IVoucherPostingViewDto {
    id?: number | undefined;
    voucherId?: number;
    lineNum?: number | undefined;
    postingType?: number | undefined;
    postingTypeName?: string | undefined;
    accountNum?: string | undefined;
    accountDescription?: string | undefined;
    transDate?: Date | undefined;
    dueDate?: Date | undefined;
    amountCur?: number | undefined;
    amountCost?: number | undefined;
    txt?: string | undefined;
    dimension?: string | undefined;
    projectCostGroup?: string | undefined;
    projectCostType?: string | undefined;
    projectCostTypeName?: string | undefined;
    projectCostTypeDescription?: string | undefined;
    projectLedgerNum?: string | undefined;
    projectLedgerName?: string | undefined;
    projectLedgerDescription?: string | undefined;
    projectLedgerNumName?: string | undefined;
    paymentRef?: string | undefined;
    vendorBankAccount?: string | undefined;
    taxCode?: string | undefined;
    created?: Date | undefined;
    createdBy?: number | undefined;
    modified?: Date | undefined;
    modifiedBy?: number | undefined;
    createdByName?: string | undefined;
    createdByShortName?: string | undefined;
    modifiedByName?: string | undefined;
    modifiedByShortName?: string | undefined;
    msgId?: number | undefined;
}

export enum VoucherPostingTypeEnum {
    Vendor = 1,
    Project = 2,
    ProjectRoyalty = 3,
    Ledger = 4,
    Debtor = 5,
    Bank = 6,
}

export enum FormRecognizerFieldTypeEnum {
    Vendor = 1,
    TransDate = 2,
    DueDate = 3,
    DocumentNum = 4,
    InvoiceAmount = 5,
    Currency = 6,
    BankAccount = 7,
    PaymentId = 8,
    YourOrder = 9,
    YourRef = 10,
    OurOrder = 11,
    OurRef = 12,
    ProjNum = 13,
    ProjISBN = 14,
    ProjCostType = 15,
    AuthReference = 16,
    Txt = 17,
    MiscAmount = 18,
}

export enum VoucherValidationStatusEnum {
    None = 1,
    Pending = 2,
    Extracted = 3,
    Failed = 4,
    Validated = 5,
    Accepted = 6,
}

export class VoucherViewVm implements IVoucherViewVm {
    voucherViewDtoList?: VoucherViewDto[] | undefined;
    voucherApprovalStatusDtoList?: VoucherApprovalStatusDto[] | undefined;
    messageChannelNameFilter?: string | undefined;

    constructor(data?: IVoucherViewVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["voucherViewDtoList"])) {
                this.voucherViewDtoList = [] as any;
                for (let item of _data["voucherViewDtoList"])
                    this.voucherViewDtoList!.push(VoucherViewDto.fromJS(item));
            }
            if (Array.isArray(_data["voucherApprovalStatusDtoList"])) {
                this.voucherApprovalStatusDtoList = [] as any;
                for (let item of _data["voucherApprovalStatusDtoList"])
                    this.voucherApprovalStatusDtoList!.push(VoucherApprovalStatusDto.fromJS(item));
            }
            this.messageChannelNameFilter = _data["messageChannelNameFilter"];
        }
    }

    static fromJS(data: any): VoucherViewVm {
        data = typeof data === 'object' ? data : {};
        let result = new VoucherViewVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.voucherViewDtoList)) {
            data["voucherViewDtoList"] = [];
            for (let item of this.voucherViewDtoList)
                data["voucherViewDtoList"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.voucherApprovalStatusDtoList)) {
            data["voucherApprovalStatusDtoList"] = [];
            for (let item of this.voucherApprovalStatusDtoList)
                data["voucherApprovalStatusDtoList"].push(item ? item.toJSON() : undefined as any);
        }
        data["messageChannelNameFilter"] = this.messageChannelNameFilter;
        return data;
    }
}

export interface IVoucherViewVm {
    voucherViewDtoList?: VoucherViewDto[] | undefined;
    voucherApprovalStatusDtoList?: VoucherApprovalStatusDto[] | undefined;
    messageChannelNameFilter?: string | undefined;
}

export class VoucherApprovalStatusDto implements IVoucherApprovalStatusDto {
    id?: number;
    name?: string | undefined;

    constructor(data?: IVoucherApprovalStatusDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): VoucherApprovalStatusDto {
        data = typeof data === 'object' ? data : {};
        let result = new VoucherApprovalStatusDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

export interface IVoucherApprovalStatusDto {
    id?: number;
    name?: string | undefined;
}

export enum VoucherApprovalStatusAllEnum {
    All = 0,
    Pending = 1,
    OnHold = 2,
    Approved = 3,
    Accounted = 4,
    Posted = 5,
    Created = 6,
}

export class GetExpenseVoucherCreateBaseDataVm implements IGetExpenseVoucherCreateBaseDataVm {
    currencies?: CurrencyDto[] | undefined;
    voucherCategories?: VoucherCategoryDto[] | undefined;

    constructor(data?: IGetExpenseVoucherCreateBaseDataVm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["currencies"])) {
                this.currencies = [] as any;
                for (let item of _data["currencies"])
                    this.currencies!.push(CurrencyDto.fromJS(item));
            }
            if (Array.isArray(_data["voucherCategories"])) {
                this.voucherCategories = [] as any;
                for (let item of _data["voucherCategories"])
                    this.voucherCategories!.push(VoucherCategoryDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetExpenseVoucherCreateBaseDataVm {
        data = typeof data === 'object' ? data : {};
        let result = new GetExpenseVoucherCreateBaseDataVm();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.currencies)) {
            data["currencies"] = [];
            for (let item of this.currencies)
                data["currencies"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.voucherCategories)) {
            data["voucherCategories"] = [];
            for (let item of this.voucherCategories)
                data["voucherCategories"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IGetExpenseVoucherCreateBaseDataVm {
    currencies?: CurrencyDto[] | undefined;
    voucherCategories?: VoucherCategoryDto[] | undefined;
}

export class VoucherViewResponse implements IVoucherViewResponse {
    voucherViewDto?: VoucherViewDto | undefined;
    approversNextOption?: number[] | undefined;
    chatDto?: ChatDto | undefined;

    constructor(data?: IVoucherViewResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.voucherViewDto = _data["voucherViewDto"] ? VoucherViewDto.fromJS(_data["voucherViewDto"]) : undefined as any;
            if (Array.isArray(_data["approversNextOption"])) {
                this.approversNextOption = [] as any;
                for (let item of _data["approversNextOption"])
                    this.approversNextOption!.push(item);
            }
            this.chatDto = _data["chatDto"] ? ChatDto.fromJS(_data["chatDto"]) : undefined as any;
        }
    }

    static fromJS(data: any): VoucherViewResponse {
        data = typeof data === 'object' ? data : {};
        let result = new VoucherViewResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["voucherViewDto"] = this.voucherViewDto ? this.voucherViewDto.toJSON() : undefined as any;
        if (Array.isArray(this.approversNextOption)) {
            data["approversNextOption"] = [];
            for (let item of this.approversNextOption)
                data["approversNextOption"].push(item);
        }
        data["chatDto"] = this.chatDto ? this.chatDto.toJSON() : undefined as any;
        return data;
    }
}

export interface IVoucherViewResponse {
    voucherViewDto?: VoucherViewDto | undefined;
    approversNextOption?: number[] | undefined;
    chatDto?: ChatDto | undefined;
}

export class WarehouseOnhandCostJournalLineView implements IWarehouseOnhandCostJournalLineView {
    id?: number;
    journal?: number;
    productNum!: string;
    transDate?: Date;
    posted?: boolean;
    isExtraordinary?: boolean;
    isExtraordinaryCostPricePrevious?: boolean;
    qty?: number;
    costPricePrevious?: number | undefined;
    costPriceCalc?: number | undefined;
    costPriceCalcPrice?: number | undefined;
    costPriceCalcQty?: number | undefined;
    costPriceCalcQtyPeriod?: number | undefined;
    costPriceCalcAmount?: number | undefined;
    costPriceAge?: number | undefined;
    costPriceUser?: number | undefined;
    costPricePosted?: number | undefined;
    costPricePostedAdjustment?: number | undefined;
    onhandAmountPrevious?: number | undefined;
    onhandAmountPosted?: number | undefined;
    onhandAmountPostedAdjustment?: number | undefined;
    created?: Date | undefined;
    createdBy?: number | undefined;
    modified?: Date | undefined;
    modifiedBy?: number | undefined;
    productLookupId?: number | undefined;
    productLookupNum?: string | undefined;
    projectNum?: string | undefined;
    projectNumParent?: string | undefined;
    contractNum?: string | undefined;
    projectLegacyId?: number | undefined;
    projectItemNum?: string | undefined;
    name?: string | undefined;
    nameSub?: string | undefined;
    languageOriginal?: string | undefined;
    nameOriginal?: string | undefined;
    contributorAuthor?: string | undefined;
    productCreated?: Date | undefined;
    isPublished?: boolean | undefined;
    publishingDate?: Date | undefined;
    publishedDays?: number | undefined;
    responsibleShortName?: string | undefined;
    group?: string | undefined;
    type?: string | undefined;
    contractType?: string | undefined;
    contractSettlementType?: string | undefined;
    subjectBookstoreClassification?: string | undefined;
    subjectKeywords?: string | undefined;
    subjectThema?: string | undefined;
    salesPrice?: number | undefined;
    salesPriceTrade?: number | undefined;
    buyableTrade?: boolean | undefined;
    supplyApologyCode?: number | undefined;
    isDeleted?: boolean | undefined;
    deletedReason?: string | undefined;
    deleted?: Date | undefined;
    description?: string | undefined;
    salesQtyTransDate?: number | undefined;
    salesAmountTransDate?: number | undefined;
    costAmountTransDate?: number | undefined;
    salesQty3M?: number | undefined;
    salesAmount3M?: number | undefined;
    costAmount3M?: number | undefined;
    salesQty?: number | undefined;
    salesAmount?: number | undefined;
    costAmount?: number | undefined;
    costAmountBalance?: number | undefined;
    resultAmount?: number | undefined;
    salesMaxDate?: Date | undefined;
    costMaxDate?: Date | undefined;
    purchQty?: number | undefined;
    costPriceEstimate?: number | undefined;
    onhandValueEstimate?: number | undefined;
    ageDays?: number | undefined;
    ageMonths?: number | undefined;
    ageYears?: number | undefined;

    constructor(data?: IWarehouseOnhandCostJournalLineView) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.journal = _data["journal"];
            this.productNum = _data["productNum"];
            this.transDate = _data["transDate"] ? new Date(_data["transDate"].toString()) : undefined as any;
            this.posted = _data["posted"];
            this.isExtraordinary = _data["isExtraordinary"];
            this.isExtraordinaryCostPricePrevious = _data["isExtraordinaryCostPricePrevious"];
            this.qty = _data["qty"];
            this.costPricePrevious = _data["costPricePrevious"];
            this.costPriceCalc = _data["costPriceCalc"];
            this.costPriceCalcPrice = _data["costPriceCalcPrice"];
            this.costPriceCalcQty = _data["costPriceCalcQty"];
            this.costPriceCalcQtyPeriod = _data["costPriceCalcQtyPeriod"];
            this.costPriceCalcAmount = _data["costPriceCalcAmount"];
            this.costPriceAge = _data["costPriceAge"];
            this.costPriceUser = _data["costPriceUser"];
            this.costPricePosted = _data["costPricePosted"];
            this.costPricePostedAdjustment = _data["costPricePostedAdjustment"];
            this.onhandAmountPrevious = _data["onhandAmountPrevious"];
            this.onhandAmountPosted = _data["onhandAmountPosted"];
            this.onhandAmountPostedAdjustment = _data["onhandAmountPostedAdjustment"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : undefined as any;
            this.createdBy = _data["createdBy"];
            this.modified = _data["modified"] ? new Date(_data["modified"].toString()) : undefined as any;
            this.modifiedBy = _data["modifiedBy"];
            this.productLookupId = _data["productLookupId"];
            this.productLookupNum = _data["productLookupNum"];
            this.projectNum = _data["projectNum"];
            this.projectNumParent = _data["projectNumParent"];
            this.contractNum = _data["contractNum"];
            this.projectLegacyId = _data["projectLegacyId"];
            this.projectItemNum = _data["projectItemNum"];
            this.name = _data["name"];
            this.nameSub = _data["nameSub"];
            this.languageOriginal = _data["languageOriginal"];
            this.nameOriginal = _data["nameOriginal"];
            this.contributorAuthor = _data["contributorAuthor"];
            this.productCreated = _data["productCreated"] ? new Date(_data["productCreated"].toString()) : undefined as any;
            this.isPublished = _data["isPublished"];
            this.publishingDate = _data["publishingDate"] ? new Date(_data["publishingDate"].toString()) : undefined as any;
            this.publishedDays = _data["publishedDays"];
            this.responsibleShortName = _data["responsibleShortName"];
            this.group = _data["group"];
            this.type = _data["type"];
            this.contractType = _data["contractType"];
            this.contractSettlementType = _data["contractSettlementType"];
            this.subjectBookstoreClassification = _data["subjectBookstoreClassification"];
            this.subjectKeywords = _data["subjectKeywords"];
            this.subjectThema = _data["subjectThema"];
            this.salesPrice = _data["salesPrice"];
            this.salesPriceTrade = _data["salesPriceTrade"];
            this.buyableTrade = _data["buyableTrade"];
            this.supplyApologyCode = _data["supplyApologyCode"];
            this.isDeleted = _data["isDeleted"];
            this.deletedReason = _data["deletedReason"];
            this.deleted = _data["deleted"] ? new Date(_data["deleted"].toString()) : undefined as any;
            this.description = _data["description"];
            this.salesQtyTransDate = _data["salesQtyTransDate"];
            this.salesAmountTransDate = _data["salesAmountTransDate"];
            this.costAmountTransDate = _data["costAmountTransDate"];
            this.salesQty3M = _data["salesQty3M"];
            this.salesAmount3M = _data["salesAmount3M"];
            this.costAmount3M = _data["costAmount3M"];
            this.salesQty = _data["salesQty"];
            this.salesAmount = _data["salesAmount"];
            this.costAmount = _data["costAmount"];
            this.costAmountBalance = _data["costAmountBalance"];
            this.resultAmount = _data["resultAmount"];
            this.salesMaxDate = _data["salesMaxDate"] ? new Date(_data["salesMaxDate"].toString()) : undefined as any;
            this.costMaxDate = _data["costMaxDate"] ? new Date(_data["costMaxDate"].toString()) : undefined as any;
            this.purchQty = _data["purchQty"];
            this.costPriceEstimate = _data["costPriceEstimate"];
            this.onhandValueEstimate = _data["onhandValueEstimate"];
            this.ageDays = _data["ageDays"];
            this.ageMonths = _data["ageMonths"];
            this.ageYears = _data["ageYears"];
        }
    }

    static fromJS(data: any): WarehouseOnhandCostJournalLineView {
        data = typeof data === 'object' ? data : {};
        let result = new WarehouseOnhandCostJournalLineView();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["journal"] = this.journal;
        data["productNum"] = this.productNum;
        data["transDate"] = this.transDate ? this.transDate.toISOString() : undefined as any;
        data["posted"] = this.posted;
        data["isExtraordinary"] = this.isExtraordinary;
        data["isExtraordinaryCostPricePrevious"] = this.isExtraordinaryCostPricePrevious;
        data["qty"] = this.qty;
        data["costPricePrevious"] = this.costPricePrevious;
        data["costPriceCalc"] = this.costPriceCalc;
        data["costPriceCalcPrice"] = this.costPriceCalcPrice;
        data["costPriceCalcQty"] = this.costPriceCalcQty;
        data["costPriceCalcQtyPeriod"] = this.costPriceCalcQtyPeriod;
        data["costPriceCalcAmount"] = this.costPriceCalcAmount;
        data["costPriceAge"] = this.costPriceAge;
        data["costPriceUser"] = this.costPriceUser;
        data["costPricePosted"] = this.costPricePosted;
        data["costPricePostedAdjustment"] = this.costPricePostedAdjustment;
        data["onhandAmountPrevious"] = this.onhandAmountPrevious;
        data["onhandAmountPosted"] = this.onhandAmountPosted;
        data["onhandAmountPostedAdjustment"] = this.onhandAmountPostedAdjustment;
        data["created"] = this.created ? this.created.toISOString() : undefined as any;
        data["createdBy"] = this.createdBy;
        data["modified"] = this.modified ? this.modified.toISOString() : undefined as any;
        data["modifiedBy"] = this.modifiedBy;
        data["productLookupId"] = this.productLookupId;
        data["productLookupNum"] = this.productLookupNum;
        data["projectNum"] = this.projectNum;
        data["projectNumParent"] = this.projectNumParent;
        data["contractNum"] = this.contractNum;
        data["projectLegacyId"] = this.projectLegacyId;
        data["projectItemNum"] = this.projectItemNum;
        data["name"] = this.name;
        data["nameSub"] = this.nameSub;
        data["languageOriginal"] = this.languageOriginal;
        data["nameOriginal"] = this.nameOriginal;
        data["contributorAuthor"] = this.contributorAuthor;
        data["productCreated"] = this.productCreated ? this.productCreated.toISOString() : undefined as any;
        data["isPublished"] = this.isPublished;
        data["publishingDate"] = this.publishingDate ? this.publishingDate.toISOString() : undefined as any;
        data["publishedDays"] = this.publishedDays;
        data["responsibleShortName"] = this.responsibleShortName;
        data["group"] = this.group;
        data["type"] = this.type;
        data["contractType"] = this.contractType;
        data["contractSettlementType"] = this.contractSettlementType;
        data["subjectBookstoreClassification"] = this.subjectBookstoreClassification;
        data["subjectKeywords"] = this.subjectKeywords;
        data["subjectThema"] = this.subjectThema;
        data["salesPrice"] = this.salesPrice;
        data["salesPriceTrade"] = this.salesPriceTrade;
        data["buyableTrade"] = this.buyableTrade;
        data["supplyApologyCode"] = this.supplyApologyCode;
        data["isDeleted"] = this.isDeleted;
        data["deletedReason"] = this.deletedReason;
        data["deleted"] = this.deleted ? this.deleted.toISOString() : undefined as any;
        data["description"] = this.description;
        data["salesQtyTransDate"] = this.salesQtyTransDate;
        data["salesAmountTransDate"] = this.salesAmountTransDate;
        data["costAmountTransDate"] = this.costAmountTransDate;
        data["salesQty3M"] = this.salesQty3M;
        data["salesAmount3M"] = this.salesAmount3M;
        data["costAmount3M"] = this.costAmount3M;
        data["salesQty"] = this.salesQty;
        data["salesAmount"] = this.salesAmount;
        data["costAmount"] = this.costAmount;
        data["costAmountBalance"] = this.costAmountBalance;
        data["resultAmount"] = this.resultAmount;
        data["salesMaxDate"] = this.salesMaxDate ? this.salesMaxDate.toISOString() : undefined as any;
        data["costMaxDate"] = this.costMaxDate ? this.costMaxDate.toISOString() : undefined as any;
        data["purchQty"] = this.purchQty;
        data["costPriceEstimate"] = this.costPriceEstimate;
        data["onhandValueEstimate"] = this.onhandValueEstimate;
        data["ageDays"] = this.ageDays;
        data["ageMonths"] = this.ageMonths;
        data["ageYears"] = this.ageYears;
        return data;
    }
}

export interface IWarehouseOnhandCostJournalLineView {
    id?: number;
    journal?: number;
    productNum: string;
    transDate?: Date;
    posted?: boolean;
    isExtraordinary?: boolean;
    isExtraordinaryCostPricePrevious?: boolean;
    qty?: number;
    costPricePrevious?: number | undefined;
    costPriceCalc?: number | undefined;
    costPriceCalcPrice?: number | undefined;
    costPriceCalcQty?: number | undefined;
    costPriceCalcQtyPeriod?: number | undefined;
    costPriceCalcAmount?: number | undefined;
    costPriceAge?: number | undefined;
    costPriceUser?: number | undefined;
    costPricePosted?: number | undefined;
    costPricePostedAdjustment?: number | undefined;
    onhandAmountPrevious?: number | undefined;
    onhandAmountPosted?: number | undefined;
    onhandAmountPostedAdjustment?: number | undefined;
    created?: Date | undefined;
    createdBy?: number | undefined;
    modified?: Date | undefined;
    modifiedBy?: number | undefined;
    productLookupId?: number | undefined;
    productLookupNum?: string | undefined;
    projectNum?: string | undefined;
    projectNumParent?: string | undefined;
    contractNum?: string | undefined;
    projectLegacyId?: number | undefined;
    projectItemNum?: string | undefined;
    name?: string | undefined;
    nameSub?: string | undefined;
    languageOriginal?: string | undefined;
    nameOriginal?: string | undefined;
    contributorAuthor?: string | undefined;
    productCreated?: Date | undefined;
    isPublished?: boolean | undefined;
    publishingDate?: Date | undefined;
    publishedDays?: number | undefined;
    responsibleShortName?: string | undefined;
    group?: string | undefined;
    type?: string | undefined;
    contractType?: string | undefined;
    contractSettlementType?: string | undefined;
    subjectBookstoreClassification?: string | undefined;
    subjectKeywords?: string | undefined;
    subjectThema?: string | undefined;
    salesPrice?: number | undefined;
    salesPriceTrade?: number | undefined;
    buyableTrade?: boolean | undefined;
    supplyApologyCode?: number | undefined;
    isDeleted?: boolean | undefined;
    deletedReason?: string | undefined;
    deleted?: Date | undefined;
    description?: string | undefined;
    salesQtyTransDate?: number | undefined;
    salesAmountTransDate?: number | undefined;
    costAmountTransDate?: number | undefined;
    salesQty3M?: number | undefined;
    salesAmount3M?: number | undefined;
    costAmount3M?: number | undefined;
    salesQty?: number | undefined;
    salesAmount?: number | undefined;
    costAmount?: number | undefined;
    costAmountBalance?: number | undefined;
    resultAmount?: number | undefined;
    salesMaxDate?: Date | undefined;
    costMaxDate?: Date | undefined;
    purchQty?: number | undefined;
    costPriceEstimate?: number | undefined;
    onhandValueEstimate?: number | undefined;
    ageDays?: number | undefined;
    ageMonths?: number | undefined;
    ageYears?: number | undefined;
}

export class WarehouseOnhandCostJournalLineDto extends WarehouseOnhandCostJournalLineView implements IWarehouseOnhandCostJournalLineDto {

    constructor(data?: IWarehouseOnhandCostJournalLineDto) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): WarehouseOnhandCostJournalLineDto {
        data = typeof data === 'object' ? data : {};
        let result = new WarehouseOnhandCostJournalLineDto();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IWarehouseOnhandCostJournalLineDto extends IWarehouseOnhandCostJournalLineView {
}

export enum WarehouseOutboundOrderStatusEnum {
    Draft = 1,
    Released = 2,
    Ordered = 3,
    Confirmed = 4,
    Reserved = 5,
    Dispatched = 6,
    Delivered = 7,
    Cancelled = 8,
}

export interface FileResponse {
    data: Blob;
    status: number;
    fileName?: string;
    headers?: { [name: string]: any };
}

export class SwaggerException extends Error {
    override message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isSwaggerException = true;

    static isSwaggerException(obj: any): obj is SwaggerException {
        return obj.isSwaggerException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): Observable<any> {
    if (result !== null && result !== undefined)
        return _observableThrow(result);
    else
        return _observableThrow(new SwaggerException(message, status, response, headers, null));
}

function blobToText(blob: any): Observable<string> {
    return new Observable<string>((observer: any) => {
        if (!blob) {
            observer.next("");
            observer.complete();
        } else {
            let reader = new FileReader();
            reader.onload = event => {
                observer.next((event.target as any).result);
                observer.complete();
            };
            reader.readAsText(blob);
        }
    });
}